/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		74: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 110);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(32)('wks');
var uid = __webpack_require__(33);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(116)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var createDesc = __webpack_require__(31);
module.exports = __webpack_require__(8) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(111).setImmediate))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(26);
var defined = __webpack_require__(14);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(0);
var ctx = __webpack_require__(144);
var hide = __webpack_require__(7);
var has = __webpack_require__(11);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var IE8_DOM_DEFINE = __webpack_require__(146);
var toPrimitive = __webpack_require__(147);
var dP = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(152);
var enumBugKeys = __webpack_require__(34);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(32)('keys');
var uid = __webpack_require__(33);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(14);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = getMessage;
/* unused harmony export validarPermisos */
/* unused harmony export isEmpty */
/* harmony export (immutable) */ __webpack_exports__["g"] = dataValidate;
/* harmony export (immutable) */ __webpack_exports__["h"] = dataValidateList;
/* harmony export (immutable) */ __webpack_exports__["p"] = updateFields;
/* harmony export (immutable) */ __webpack_exports__["e"] = createObjectFilter;
/* harmony export (immutable) */ __webpack_exports__["d"] = createObjectFields;
/* harmony export (immutable) */ __webpack_exports__["f"] = createObjectFromData;
/* harmony export (immutable) */ __webpack_exports__["b"] = calcularEdad;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcularDias;
/* harmony export (immutable) */ __webpack_exports__["j"] = findTextFromList;
/* harmony export (immutable) */ __webpack_exports__["o"] = searchForId;
/* unused harmony export searchRangoEdad */
/* harmony export (immutable) */ __webpack_exports__["n"] = newDate;
/* harmony export (immutable) */ __webpack_exports__["i"] = dateFormat;
/* unused harmony export addDays */
/* harmony export (immutable) */ __webpack_exports__["l"] = getNameRouterForTipoSeguro;
/* harmony export (immutable) */ __webpack_exports__["m"] = isRequiere;
/* harmony export (immutable) */ __webpack_exports__["c"] = createObjectCR;
function getMessage(p_messages, p_index, p_message) {
    var error = p_messages[p_index].label;
    if (p_message) {
        error += " " + p_message;
    }
    return error;
}

function validarPermisos(menu, usuarioPermisos) {
    var permiso = true;
    for (var index = 0; index < menu.permisos.length; index++) {
        if (usuarioPermisos[menu.permisos[index]] != 1) {
            permiso = false;
        }
    }
    return permiso;
}

function isEmpty(p_value) {
    var empty = false;
    if (!p_value && (p_value === null || p_value === undefined || p_value.length == 0)) {
        empty = true;
    }
    return empty;
}

function dataValidate(p_fields, p_messages) {
    var validate = true;
    for (var index = 0; index < p_fields.length; index++) {
        if (p_fields[index].validate == 1) {
            p_fields[index].validation_error = 0;
            p_fields[index].message = '';
            if (isEmpty(p_fields[index].value)) {
                if (p_fields[index].required == 1) {
                    p_fields[index].validation_error = 1;
                    p_fields[index].message = getMessage(p_messages.data, p_messages.msg_error_1);
                    validate = false;
                }
            }
        }
    }
    return validate;
}

function dataValidateList(p_fields, p_List, p_messages) {
    var validate = true;
    for (var index = 0; index < p_List.length; index++) {
        var pos = p_List[index];
        if (p_fields[pos].validate == 1) {
            p_fields[pos].validation_error = 0;
            p_fields[pos].message = '';
            if (isEmpty(p_fields[pos].value)) {
                if (p_fields[pos].required == 1) {
                    p_fields[pos].validation_error = 1;
                    p_fields[pos].message = getMessage(p_messages.data, p_messages.msg_error_1);
                    validate = false;
                }
            }
        }
    }
    return validate;
}

function updateFields(p_data, p_fields) {
    for (var index = 0; index < p_fields.data.length; index++) {
        if (Array.isArray(p_data)) {
            p_fields.data[index].value = p_data[0][p_fields.data[index].field];
        } else {
            p_fields.data[index].value = p_data[p_fields.data[index].field];
        }
    }
}

function createObjectFilter(p_filter, p_fields) {
    var object = new Object();
    object.totalRecord = p_filter.totalRecord;
    object.currentRecord = p_filter.currentRecord;
    for (var index = 0; index < p_fields.data.length; index++) {
        var field = p_fields.data[index].field;
        if (p_fields.data[index].value) {
            object[field] = p_fields.data[index].value;
        }
    }
    return object;
}

function createObjectFields(p_fields, p_usuario) {
    var object = new Object();
    if (!p_fields.data[p_fields.usuario_creacion].value) {
        p_fields.data[p_fields.usuario_creacion].value = p_usuario;
    }
    for (var index = 0; index < p_fields.data.length; index++) {
        var field = p_fields.data[index];
        if (field.estatus == 1 || field.estatus == 3) {
            if (!isEmpty(field.value)) {
                object[field.field] = field.value;
            }
        }
    }
    return object;
}

function createObjectFromData(p_fields, p_data, isAll) {
    var object = new Object();
    for (var index = 0; index < p_fields.data.length; index++) {
        var field = p_fields.data[index];
        if (isAll || field.estatus == 1) {
            object[field.field] = p_data[0][field.field];
        }
    }
    return object;
}

function calcularEdad(p_fechaNacimiento, p_fechaLlegada) {
    var hoy = new Date(p_fechaLlegada); //new Date()
    var fechaNacimiento = new Date(p_fechaNacimiento);
    var edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    var diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
    if (diferenciaMeses < 0 || diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate()) {
        edad--;
    }
    return edad;
}

function calcularDias(p_fechaInicial, p_fechaFinal) {
    var fechaInicial = new Date(p_fechaInicial);
    var fechaFinal = new Date(p_fechaFinal);
    // Calcular diferencia en milisegundos
    var difference = fechaFinal - fechaInicial;
    // Calcular días
    var differenceDias = Math.floor(difference / (1000 * 60 * 60 * 24)) + 1;
    return differenceDias;
}

function findTextFromList(p_list, p_idValue) {
    var text = "";
    var index = 0;
    while (index < p_list.length && text == "") {
        if (p_idValue == p_list[index].code) {
            text = p_list[index].name;
        }
        index++;
    }
    return text;
}

function searchForId(list, id, idCampo) {
    var pos = -1;
    var index = 0;
    while (pos < 0 && index < list.length) {
        if (list[index][idCampo] == id) {
            pos = index;
        }
        index++;
    }
    return pos;
}

function searchRangoEdad(p_list, p_edad) {
    var pos = -1;
    var index = 0;
    while (pos < 0 && index < p_list.length) {
        if (p_list[index]['desde'] <= p_edad && p_list[index]['hasta'] >= p_edad) {
            pos = index;
        }
        index++;
    }
    return pos;
}

function newDate(p_date) {
    var date = void 0;
    if (p_date) {
        date = new Date(p_date);
    } else {
        date = addDays(new Date(), -1);
    }
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return newDate;
}

function dateFormat(p_date, p_format) {
    var date = void 0;
    var day = p_date.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    var month = p_date.getMonth() + 1;
    if (month < 10) {
        month = '0' + month;
    }
    var year = p_date.getFullYear();
    date = year + '-' + month + '-' + day;
    var map = {
        dd: day,
        mm: month,
        yyyy: year
    };
    return p_format.replace(/dd|mm|yyyy/gi, function (matched) {
        return map[matched];
    });
}

function addDays(p_date, p_days) {
    var date = p_date;
    date.setDate(date.getDate() + p_days);
    return date;
}

function getNameRouterForTipoSeguro(p_tipoSeguro) {
    var nameRouter = "";
    switch (p_tipoSeguro) {
        case 0:
            nameRouter = "";
            break;
        case 1:
            nameRouter = "cotizacionViajero";
            break;
        case 2:
            nameRouter = "cotizacionBd";
            break;
        case 3:
            nameRouter = "cotizacionSme";
            break;
        case 4:
            nameRouter = "cotizacionGrupo";
            break;
        case 5:
            nameRouter = "cotizacionSport";
            break;
        case 6:
            nameRouter = "cotizacionFunerario";
            break;
    }
    return nameRouter;
}

function isRequiere(p_requierValue, p_fields, p_list) {
    if (p_requierValue == '1') {
        p_list.push(p_fields);
    }
}

function createObjectCR(p_tipoSeguro, p_fields, p_userLogin, p_planList, p_pasajeroList, p_ltsVariable) {
    var object = new Object();
    var factor = 0;
    var idDeporte = null;
    var anoPasajeroDestino = null;
    if (p_tipoSeguro == 1) {
        anoPasajeroDestino = parseInt(p_ltsVariable.ano_pasajero_destino_viaje);
    } else if (p_tipoSeguro == 2) {
        factor = p_fields.data[this.fields.factor].value;
    } else if (p_tipoSeguro == 4) {
        factor = p_fields.data[this.fields.factor].value;
    } else if (p_tipoSeguro == 5) {
        factor = p_fields.data[this.fields.factor].value;
        idDeporte = p_fields.data[this.fields.id_deporte].value;
    }
    object = { tipo_seguro: p_tipoSeguro,
        vigencia_desde: p_fields.data[p_fields.fecha_salida].value,
        vigencia_hasta: p_fields.data[p_fields.fecha_llegada].value,
        factor: factor,
        id_agencia: p_fields.data[p_fields.id_agencia].value,
        id_deporte: idDeporte,
        fecha_cotizacion: p_fields.data[p_fields.fecha_cotizacion].value,
        nota_cotizacion: p_fields.data[p_fields.nota_cotizacion].value,
        dias_vigencia: p_fields.data[p_fields.dias_vigencia].value,
        nota_vigencia: p_fields.data[p_fields.nota_vigencia].value,
        fecha_vigencia: p_fields.data[p_fields.fecha_vigencia].value,
        fecha_salida: p_fields.data[p_fields.fecha_salida].value,
        fecha_llegada: p_fields.data[p_fields.fecha_llegada].value,
        id_pais_origen: p_fields.data[p_fields.id_pais_origen].value,
        id_origen: p_fields.data[p_fields.id_origen].value,
        id_destino: p_fields.data[p_fields.id_destino].value,
        dias_viaje: p_fields.data[p_fields.dias_viaje].value,
        mascota: p_fields.data[p_fields.mascota].value,
        pasajero_destino: p_fields.data[p_fields.pasajero_destino].value,
        ano_pasajero_destino: anoPasajeroDestino,
        ultima_salida_pais: p_fields.data[p_fields.ultima_salida_pais].value,
        estudiante: p_fields.data[p_fields.estudiante].value,
        nota_pasajero_destino: p_fields.data[p_fields.nota_pasajero_destino].value,
        titular_nombre: p_fields.data[p_fields.titular_nombre].value,
        titular_id_sexo: p_fields.data[p_fields.titular_id_sexo].value,
        titular_apellido: p_fields.data[p_fields.titular_apellido].value,
        titular_correo: p_fields.data[p_fields.titular_correo].value,
        titular_fecha_nacimiento: p_fields.data[p_fields.titular_fecha_nacimiento].value,
        titular_edad: p_fields.data[p_fields.titular_edad].value,
        titular_viaja: p_fields.data[p_fields.titular_viaja].value,
        total_pvp: p_fields.data[p_fields.total_pvp].value,
        lista_categoria: p_planList,
        lista_pasajero: p_pasajeroList,
        id_idioma: p_userLogin.id_idioma,
        id_cotizacion: 0,
        id_metodo_pago: p_fields.data[p_fields.id_metodo_pago].value,
        numero: p_fields.data[p_fields.numero].value,
        nombre: p_fields.data[p_fields.nombre].value,
        cvv: p_fields.data[p_fields.cvv].value,
        caducidad: p_fields.data[p_fields.caducidad].value,
        observacion: p_fields.data[p_fields.observacion].value,
        tipo_validacion: p_fields.data[p_fields.tipo_validacion].value,
        validado: p_fields.data[p_fields.validado].value,
        fecha_validacion: p_fields.data[p_fields.fecha_validacion].value,
        codigo_validacion: p_fields.data[p_fields.codigo_validacion].value,
        monto_validacion: p_fields.data[p_fields.monto_validacion].value,
        id_validacion: p_fields.data[p_fields.id_validacion].value,
        url_validacion: p_fields.data[p_fields.url_validacion].value };
    return object;
}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: {
        name: '',
        age: 0
    }
});

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(141);
var global = __webpack_require__(5);
var hide = __webpack_require__(7);
var Iterators = __webpack_require__(6);
var TO_STRING_TAG = __webpack_require__(1)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(29);
var $export = __webpack_require__(15);
var redefine = __webpack_require__(148);
var hide = __webpack_require__(7);
var Iterators = __webpack_require__(6);
var $iterCreate = __webpack_require__(149);
var setToStringTag = __webpack_require__(35);
var getPrototypeOf = __webpack_require__(157);
var ITERATOR = __webpack_require__(1)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(17);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(0);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(29) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(16).f;
var has = __webpack_require__(11);
var TAG = __webpack_require__(1)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(158)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(28)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(27);
var TAG = __webpack_require__(1)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_router__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_directive_tooltip_dist_vueDirectiveTooltip_css__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_directive_tooltip_dist_vueDirectiveTooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_directive_tooltip_dist_vueDirectiveTooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_dist_vue_tabs_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_dist_vue_tabs_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_dist_vue_tabs_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs_themes_vue_tabs_css__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs_themes_vue_tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_nav_tabs_themes_vue_tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form_wizard__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select_dist_vue_select_css__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_paypal_checkout__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config_store__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_js_printPdf_js__ = __webpack_require__(182);





















// register globally
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('v-select', __WEBPACK_IMPORTED_MODULE_10_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_directive_tooltip___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_nav_tabs_dist_vue_tabs_js___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_form_wizard___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('paypal-checkout', __WEBPACK_IMPORTED_MODULE_14_vue_paypal_checkout__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
//Vue.http.options.root = 'http://localhost/api';
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].http.options.root = 'https://thalofinancial.com/api/';
//Vue.http.options.root = 'https://crissercorporacion.com/api/';

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('style', {
    bind: function bind(el, binding, vnode) {
        if (binding.value.family) {
            el.style.fontFamily = binding.value.family;
        }
        if (binding.value.color) {
            el.style.color = binding.value.color;
        }
        if (binding.value.size) {
            el.style.fontSize = binding.value.size;
        }
        if (binding.modifiers['bold']) {
            el.style.fontWeight = 'bold';
        }
        if (binding.modifiers['italic']) {
            el.style.fontStyle = 'italic';
        }
    }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getVariable = function (p_errorMessage, p_messages) {
    var _this = this;

    var url = 'variable/get/all';
    this.$http.post(url).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                var objFields = new Object();
                var field = "";
                for (var i in data) {
                    objFields[data[i].variable] = data[i].valor;
                }
                objFields.data = data;
                var stringJSON = JSON.stringify(objFields);
                localStorage.setItem(_this.$store.state.LIST_VARIABLE, stringJSON);
            } else {
                _this[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
        } else {
            _this[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
    }).catch(function (error) {
        _this[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this.$http.options.root);
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getFormField = function (p_fields, p_errorMessage, p_filter, p_messages, p_store, p_updateValues) {
    var _this2 = this;

    var url = 'formularioCampo/get/formularioIdioma';
    this.$http.post(url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this2.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                var objFields = new Object();
                var field = "";
                for (var i in data) {
                    if (data[i].type == _this2.$store.state.TYPE_MENU) {
                        field = data[i].field + "_active";
                        if (data[i].value == "1") {
                            objFields[field] = true;
                        } else {
                            objFields[field] = false;
                        }
                    }
                    objFields[data[i].field] = i;
                }
                objFields.data = data;
                if (p_updateValues) {
                    for (var i in p_updateValues) {
                        objFields.data[objFields[p_updateValues[i].field]].value = p_updateValues[i].value;
                    }
                }
                if (p_store) {
                    var stringJSON = JSON.stringify(objFields);
                    localStorage.setItem(p_fields, stringJSON);
                } else {
                    _this2[p_fields] = objFields;
                }
            } else {
                _this2[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
            //alert(Object.entries(result[0]));
        } else {
            _this2[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
    }).catch(function (error) {
        alert(Object.entries(error));
        _this2[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this2.$http.options.root);
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getListField = function (p_list, p_errorMessage, p_filter, p_messages, p_store) {
    var _this3 = this;

    var url = 'formularioCampo/get/listaIdioma';
    this.$http.post(url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this3.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                if (p_store) {
                    var stringJSON = JSON.stringify(data);
                    localStorage.setItem(p_list, stringJSON);
                } else {
                    _this3[p_list] = data;
                }
            } else {
                _this3[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
            //alert(Object.entries(result[0]));
        } else {
            _this3[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
    }).catch(function (error) {
        _this3[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this3.$http.options.root);
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getUrlList = function (p_dataList, p_errorMessage, p_isDisabled, p_url, p_filter, p_messages, p_updateValues) {
    var _this4 = this;

    this[p_dataList] = [];
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this4.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                if (p_updateValues) {
                    for (var index in data) {
                        for (var i in p_updateValues) {
                            data[index][p_updateValues[i].field] = p_updateValues[i].value;
                        }
                    }
                }
                _this4[p_dataList] = data;
            } else {
                _this4[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
        } else {
            _this4[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
        _this4[p_isDisabled] = false;
    }).catch(function (error) {
        alert(Object.entries(error));
        _this4[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this4.$http.options.root);
        _this4[p_isDisabled] = false;
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getUrlListSelect = function (p_list, p_url, p_filter) {
    var _this5 = this;

    this[p_list] = [];
    this.$http.post(p_url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this5.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                _this5[p_list] = data;
            }
        }
    }).catch(function (error) {});
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getUrlData = function (p_fields, p_errorMessage, p_isDisabled, p_url, p_filter, p_messages) {
    var _this6 = this;

    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this6.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["p" /* updateFields */])(data, _this6[p_fields]);
            } else {
                _this6[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
        } else {
            _this6[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
        _this6[p_isDisabled] = false;
    }).catch(function (error) {
        _this6[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this6.$http.options.root);
        _this6[p_isDisabled] = false;
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$insertUpdate = function (p_data, p_errorMessage, p_message, p_isDisabled, p_url, p_newData, p_messages, p_tipoDato) {
    var _this7 = this;

    this[p_message] = "";
    this[p_errorMessage] = "";
    this.$http.post(p_url, p_newData).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this7.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data) {
                if (Array.isArray(data)) {
                    _this7[p_data] = data;
                } else {
                    Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["p" /* updateFields */])(data, _this7[p_data]);
                }
            } else {
                _this7[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
            _this7[p_message] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_5);
        } else {
            _this7[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
        _this7[p_isDisabled] = false;
    }).catch(function (error) {
        _this7[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this7.$http.options.root);
        _this7[p_isDisabled] = false;
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getUrlDataToPdf = function (p_errorMessage, p_isDisabled, p_url, p_filter, p_messages, p_properties, p_header) {
    var _this8 = this;

    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this8.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
            if (data && data.length > 0) {
                Object(__WEBPACK_IMPORTED_MODULE_17__assets_js_printPdf_js__["a" /* printDataToPdf */])(p_properties, p_header, data);
            } else {
                _this8[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_4);
            }
        } else {
            _this8[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
        _this8[p_isDisabled] = false;
    }).catch(function (error) {
        _this8[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_3, _this8.$http.options.root);
        _this8[p_isDisabled] = false;
    });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$getSendPdf = function (p_errorMessage, p_isDisabled, p_url, p_filter, p_messages) {
    var _this9 = this;

    this[p_errorMessage] = "";
    this.$http.post(p_url, p_filter).then(function (respuesta) {
        return respuesta.json();
    }).then(function (repuestaJson) {
        var repuestaObjeto = void 0;
        var data = [];
        repuestaObjeto = JSON.parse(repuestaJson);
        if (repuestaObjeto.code == _this9.$store.state.RESPONSE_CODE_OK) {
            data = repuestaObjeto.data;
        } else {
            _this9[p_errorMessage] = Object(__WEBPACK_IMPORTED_MODULE_16__assets_js_library_js__["k" /* getMessage */])(p_messages.data, p_messages.msg_error_5, repuestaObjeto.error);
        }
        _this9[p_isDisabled] = false;
    }).catch(function (error) {
        // alert(Object.entries(error));
        // this[p_errorMessage] = getMessage(p_messages.data, p_messages.msg_error_3, this.$http.options.root);
        // this[p_isDisabled] = false;
    });
};

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_15__config_store__["a" /* store */],
    router: __WEBPACK_IMPORTED_MODULE_3__config_router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
    }
});

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(112);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(23)))

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6785d5da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(117);
function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var normalizeComponent = __webpack_require__(38)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6785d5da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("20e85b34", content, true, {});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 116 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(119);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 119 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(121);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var LoginComp = function LoginComp(resolve) {
    __webpack_require__.e/* require.ensure */(71).then((function () {
        resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DashboardComp = function DashboardComp(resolve) {
    __webpack_require__.e/* require.ensure */(70).then((function () {
        resolve(__webpack_require__(40));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// configuracion/personalizar/
var IdiomaListComp = function IdiomaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(43).then((function () {
        resolve(__webpack_require__(41));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var IdiomaComp = function IdiomaComp(resolve) {
    __webpack_require__.e/* require.ensure */(69).then((function () {
        resolve(__webpack_require__(42));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EtiquetaListComp = function EtiquetaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(44).then((function () {
        resolve(__webpack_require__(43));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EtiquetaComp = function EtiquetaComp(resolve) {
    __webpack_require__.e/* require.ensure */(55).then((function () {
        resolve(__webpack_require__(44));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MonedaListComp = function MonedaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(27).then((function () {
        resolve(__webpack_require__(45));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MonedaComp = function MonedaComp(resolve) {
    __webpack_require__.e/* require.ensure */(57).then((function () {
        resolve(__webpack_require__(46));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var VariableListComp = function VariableListComp(resolve) {
    __webpack_require__.e/* require.ensure */(54).then((function () {
        resolve(__webpack_require__(47));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// configuracion/region/
var TerritorioListComp = function TerritorioListComp(resolve) {
    __webpack_require__.e/* require.ensure */(23).then((function () {
        resolve(__webpack_require__(48));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TerritorioComp = function TerritorioComp(resolve) {
    __webpack_require__.e/* require.ensure */(56).then((function () {
        resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PaisListComp = function PaisListComp(resolve) {
    __webpack_require__.e/* require.ensure */(24).then((function () {
        resolve(__webpack_require__(50));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PaisComp = function PaisComp(resolve) {
    __webpack_require__.e/* require.ensure */(47).then((function () {
        resolve(__webpack_require__(51));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EstadoListComp = function EstadoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(25).then((function () {
        resolve(__webpack_require__(52));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EstadoComp = function EstadoComp(resolve) {
    __webpack_require__.e/* require.ensure */(48).then((function () {
        resolve(__webpack_require__(53));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CiudadListComp = function CiudadListComp(resolve) {
    __webpack_require__.e/* require.ensure */(26).then((function () {
        resolve(__webpack_require__(54));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CiudadComp = function CiudadComp(resolve) {
    __webpack_require__.e/* require.ensure */(49).then((function () {
        resolve(__webpack_require__(55));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// configuracion/region/
var DocumentoFiscalListComp = function DocumentoFiscalListComp(resolve) {
    __webpack_require__.e/* require.ensure */(33).then((function () {
        resolve(__webpack_require__(56));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DocumentoFiscalComp = function DocumentoFiscalComp(resolve) {
    __webpack_require__.e/* require.ensure */(63).then((function () {
        resolve(__webpack_require__(57));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EstadoCivilListComp = function EstadoCivilListComp(resolve) {
    __webpack_require__.e/* require.ensure */(32).then((function () {
        resolve(__webpack_require__(58));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var EstadoCivilComp = function EstadoCivilComp(resolve) {
    __webpack_require__.e/* require.ensure */(62).then((function () {
        resolve(__webpack_require__(59));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SexoListComp = function SexoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(31).then((function () {
        resolve(__webpack_require__(60));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SexoComp = function SexoComp(resolve) {
    __webpack_require__.e/* require.ensure */(61).then((function () {
        resolve(__webpack_require__(61));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoContactoListComp = function TipoContactoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(30).then((function () {
        resolve(__webpack_require__(62));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoContactoComp = function TipoContactoComp(resolve) {
    __webpack_require__.e/* require.ensure */(60).then((function () {
        resolve(__webpack_require__(63));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoCorreoListComp = function TipoCorreoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(29).then((function () {
        resolve(__webpack_require__(64));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoCorreoComp = function TipoCorreoComp(resolve) {
    __webpack_require__.e/* require.ensure */(59).then((function () {
        resolve(__webpack_require__(65));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoTelefonoListComp = function TipoTelefonoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(28).then((function () {
        resolve(__webpack_require__(66));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoTelefonoComp = function TipoTelefonoComp(resolve) {
    __webpack_require__.e/* require.ensure */(58).then((function () {
        resolve(__webpack_require__(67));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// administracion/entidad/
var UsuarioListComp = function UsuarioListComp(resolve) {
    __webpack_require__.e/* require.ensure */(19).then((function () {
        resolve(__webpack_require__(68));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var UsuarioComp = function UsuarioComp(resolve) {
    __webpack_require__.e/* require.ensure */(12).then((function () {
        resolve(__webpack_require__(69));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CompaniaListComp = function CompaniaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(21).then((function () {
        resolve(__webpack_require__(70));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CompaniaComp = function CompaniaComp(resolve) {
    __webpack_require__.e/* require.ensure */(13).then((function () {
        resolve(__webpack_require__(71));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MetodoPagoListComp = function MetodoPagoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(20).then((function () {
        resolve(__webpack_require__(72));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MetodoPagoComp = function MetodoPagoComp(resolve) {
    __webpack_require__.e/* require.ensure */(53).then((function () {
        resolve(__webpack_require__(73));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// administracion/servicios/
var DeporteListComp = function DeporteListComp(resolve) {
    __webpack_require__.e/* require.ensure */(39).then((function () {
        resolve(__webpack_require__(74));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DeporteComp = function DeporteComp(resolve) {
    __webpack_require__.e/* require.ensure */(67).then((function () {
        resolve(__webpack_require__(75));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrigenDestinoListComp = function OrigenDestinoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(45).then((function () {
        resolve(__webpack_require__(76));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var OrigenDestinoComp = function OrigenDestinoComp(resolve) {
    __webpack_require__.e/* require.ensure */(11).then((function () {
        resolve(__webpack_require__(77));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RangoEdadListComp = function RangoEdadListComp(resolve) {
    __webpack_require__.e/* require.ensure */(35).then((function () {
        resolve(__webpack_require__(78));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RangoEdadComp = function RangoEdadComp(resolve) {
    __webpack_require__.e/* require.ensure */(65).then((function () {
        resolve(__webpack_require__(79));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RangoTiempoListComp = function RangoTiempoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(34).then((function () {
        resolve(__webpack_require__(80));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RangoTiempoComp = function RangoTiempoComp(resolve) {
    __webpack_require__.e/* require.ensure */(64).then((function () {
        resolve(__webpack_require__(81));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RamoListComp = function RamoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(36).then((function () {
        resolve(__webpack_require__(82));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var RamoComp = function RamoComp(resolve) {
    __webpack_require__.e/* require.ensure */(66).then((function () {
        resolve(__webpack_require__(83));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CategoriaListComp = function CategoriaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(22).then((function () {
        resolve(__webpack_require__(84));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CategoriaComp = function CategoriaComp(resolve) {
    __webpack_require__.e/* require.ensure */(8).then((function () {
        resolve(__webpack_require__(85));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GrupoCoberturaListComp = function GrupoCoberturaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(38).then((function () {
        resolve(__webpack_require__(86));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var GrupoCoberturaComp = function GrupoCoberturaComp(resolve) {
    __webpack_require__.e/* require.ensure */(50).then((function () {
        resolve(__webpack_require__(87));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoberturaListComp = function CoberturaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(40).then((function () {
        resolve(__webpack_require__(88));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CoberturaComp = function CoberturaComp(resolve) {
    __webpack_require__.e/* require.ensure */(51).then((function () {
        resolve(__webpack_require__(89));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AnexoComp = function AnexoComp(resolve) {
    __webpack_require__.e/* require.ensure */(14).then((function () {
        resolve(__webpack_require__(90));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var AnexoListComp = function AnexoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(41).then((function () {
        resolve(__webpack_require__(91));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProductoListComp = function ProductoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(37).then((function () {
        resolve(__webpack_require__(92));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ProductoComp = function ProductoComp(resolve) {
    __webpack_require__.e/* require.ensure */(9).then((function () {
        resolve(__webpack_require__(93));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PlanListComp = function PlanListComp(resolve) {
    __webpack_require__.e/* require.ensure */(15).then((function () {
        resolve(__webpack_require__(94));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PlanComp = function PlanComp(resolve) {
    __webpack_require__.e/* require.ensure */(10).then((function () {
        resolve(__webpack_require__(95));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TarifaListComp = function TarifaListComp(resolve) {
    __webpack_require__.e/* require.ensure */(18).then((function () {
        resolve(__webpack_require__(96));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TarifaComp = function TarifaComp(resolve) {
    __webpack_require__.e/* require.ensure */(52).then((function () {
        resolve(__webpack_require__(97));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoCambioListComp = function TipoCambioListComp(resolve) {
    __webpack_require__.e/* require.ensure */(42).then((function () {
        resolve(__webpack_require__(98));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var TipoCambioComp = function TipoCambioComp(resolve) {
    __webpack_require__.e/* require.ensure */(68).then((function () {
        resolve(__webpack_require__(99));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// moviemto/Cotizacion/
var CotizacionViajeroComp = function CotizacionViajeroComp(resolve) {
    __webpack_require__.e/* require.ensure */(2).then((function () {
        resolve(__webpack_require__(100));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CotizacionSmeComp = function CotizacionSmeComp(resolve) {
    __webpack_require__.e/* require.ensure */(6).then((function () {
        resolve(__webpack_require__(101));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CotizacionFunerarioComp = function CotizacionFunerarioComp(resolve) {
    __webpack_require__.e/* require.ensure */(7).then((function () {
        resolve(__webpack_require__(102));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CotizacionBdComp = function CotizacionBdComp(resolve) {
    __webpack_require__.e/* require.ensure */(3).then((function () {
        resolve(__webpack_require__(103));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CotizacionGrupoComp = function CotizacionGrupoComp(resolve) {
    __webpack_require__.e/* require.ensure */(5).then((function () {
        resolve(__webpack_require__(104));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var CotizacionSportComp = function CotizacionSportComp(resolve) {
    __webpack_require__.e/* require.ensure */(4).then((function () {
        resolve(__webpack_require__(105));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// moviemto/Recibo/
var CotizacionListComp = function CotizacionListComp(resolve) {
    __webpack_require__.e/* require.ensure */(17).then((function () {
        resolve(__webpack_require__(106));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ValidarMetodoPagoListComp = function ValidarMetodoPagoListComp(resolve) {
    __webpack_require__.e/* require.ensure */(16).then((function () {
        resolve(__webpack_require__(107));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ValidarMetodoPagoComp = function ValidarMetodoPagoComp(resolve) {
    __webpack_require__.e/* require.ensure */(46).then((function () {
        resolve(__webpack_require__(108));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CotizacionMComp = function CotizacionMComp(resolve) {
    __webpack_require__.e/* require.ensure */(1).then((function () {
        resolve(__webpack_require__(109));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var routes = [{ path: "/mobile", name: "cotizacionM", component: CotizacionMComp }, { path: "https://crissercorporacion.com/mobile", name: "cotizacionM", component: CotizacionMComp }, { path: "/crissercorporacion.com/mobile", name: "cotizacionM", component: CotizacionMComp }, { path: "/localhost/mobile", name: "cotizacionM", component: CotizacionMComp }, { path: "/", name: "login", component: LoginComp }, { path: "/localhost/", redirect: { name: "login" } }, { path: "/app/", redirect: { name: "login" } }, { path: "/dashboard", name: "dashboard", component: DashboardComp, children: [{ path: "/estadoCivilList", name: "estadoCivilList", component: EstadoCivilListComp }, { path: "/estadoCivil/:id", name: "estadoCivil", component: EstadoCivilComp }, { path: "/sexoList", name: "sexoList", component: SexoListComp }, { path: "/sexo/:id", name: "sexo", component: SexoComp }, { path: "/usuarioList", name: "usuarioList", component: UsuarioListComp }, { path: "/usuario/:id", name: "usuario", component: UsuarioComp }, { path: "/idiomaList", name: "idiomaList", component: IdiomaListComp }, { path: "/idioma/:id", name: "idioma", component: IdiomaComp }, { path: "/etiquetaList", name: "etiquetaList", component: EtiquetaListComp }, { path: "/etiqueta/:id", name: "etiqueta", component: EtiquetaComp }, { path: "/tipoContactoList", name: "tipoContactoList", component: TipoContactoListComp }, { path: "/tipoContacto/:id", name: "tipoContacto", component: TipoContactoComp }, { path: "/tipoTelefonoList", name: "tipoTelefonoList", component: TipoTelefonoListComp }, { path: "/tipoTelefono/:id", name: "tipoTelefono", component: TipoTelefonoComp }, { path: "/tipoCorreoList", name: "tipoCorreoList", component: TipoCorreoListComp }, { path: "/tipoCorreo/:id", name: "tipoCorreo", component: TipoCorreoComp }, { path: "/documentoFiscalList", name: "documentoFiscalList", component: DocumentoFiscalListComp }, { path: "/documentoFiscal/:id", name: "documentoFiscal", component: DocumentoFiscalComp }, { path: "/territorioList", name: "territorioList", component: TerritorioListComp }, { path: "/territorio/:id", name: "territorio", component: TerritorioComp }, { path: "/monedaList", name: "monedaList", component: MonedaListComp }, { path: "/moneda/:id", name: "moneda", component: MonedaComp }, { path: "/paisList", name: "paisList", component: PaisListComp }, { path: "/pais/:id", name: "pais", component: PaisComp }, { path: "/estadoList", name: "estadoList", component: EstadoListComp }, { path: "/estado/:id", name: "estado", component: EstadoComp }, { path: "/ciudadList", name: "ciudadList", component: CiudadListComp }, { path: "/ciudad/:id", name: "ciudad", component: CiudadComp }, { path: "/grupoCoberturaList", name: "grupoCoberturaList", component: GrupoCoberturaListComp }, { path: "/grupoCobertura/:id", name: "grupoCobertura", component: GrupoCoberturaComp }, { path: "/ramoList", name: "ramoList", component: RamoListComp }, { path: "/ramo/:id", name: "ramo", component: RamoComp }, { path: "/categoriaList", name: "categoriaList", component: CategoriaListComp }, { path: "/categoria/:id", name: "categoria", component: CategoriaComp }, { path: "/coberturaList", name: "coberturaList", component: CoberturaListComp }, { path: "/cobertura/:id", name: "cobertura", component: CoberturaComp }, { path: "/anexoList", name: "anexoList", component: AnexoListComp }, { path: "/anexo/:id", name: "anexo", component: AnexoComp }, { path: "/productoList", name: "productoList", component: ProductoListComp }, { path: "/producto/:id", name: "producto", component: ProductoComp }, { path: "/companiaList", name: "companiaList", component: CompaniaListComp }, { path: "/compania/:id", name: "compania", component: CompaniaComp }, { path: "/planList", name: "planList", component: PlanListComp }, { path: "/plan/:id", name: "plan", component: PlanComp }, { path: "/tipoCambioList", name: "tipoCambioList", component: TipoCambioListComp }, { path: "/tipoCambio/", name: "tipoCambio", component: TipoCambioComp }, { path: "/tarifaList", name: "tarifaList", component: TarifaListComp }, { path: "/tarifa/", name: "tarifa", component: TarifaComp }, { path: "/origenDestinoList", name: "origenDestinoList", component: OrigenDestinoListComp }, { path: "/origenDestino/:id", name: "origenDestino", component: OrigenDestinoComp }, { path: "/rangoEdadList", name: "rangoEdadList", component: RangoEdadListComp }, { path: "/rangoEdad/:id", name: "rangoEdad", component: RangoEdadComp }, { path: "/rangoTiempoList", name: "rangoTiempoList", component: RangoTiempoListComp }, { path: "/rangoTiempo/:id", name: "rangoTiempo", component: RangoTiempoComp }, { path: "/cotizacionList", name: "cotizacionList", component: CotizacionListComp }, { path: "/cotizacionViajero", name: "cotizacionViajero", component: CotizacionViajeroComp }, { path: "/cotizacionSme", name: "cotizacionSme", component: CotizacionSmeComp }, { path: "/cotizacionFunerario", name: "cotizacionFunerario", component: CotizacionFunerarioComp }, { path: "/cotizacionBd", name: "cotizacionBd", component: CotizacionBdComp }, { path: "/cotizacionGrupo", name: "cotizacionGrupo", component: CotizacionGrupoComp }, { path: "/cotizacionSport", name: "cotizacionSport", component: CotizacionSportComp }, { path: "/deporteList", name: "deporteList", component: DeporteListComp }, { path: "/deporte/:id", name: "deporte", component: DeporteComp }, { path: "/variableList", name: "variableList", component: VariableListComp }, { path: "/metodoPagoList", name: "metodoPagoList", component: MetodoPagoListComp }, { path: "/metodoPago", name: "metodoPago", component: MetodoPagoComp }, { path: "/validarMetodoPagoList", name: "validarMetodoPagoList", component: ValidarMetodoPagoListComp }, { path: "/validarMetodoPago", name: "validarMetodoPago", component: ValidarMetodoPagoComp }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: "history",
    routes: routes
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.4.9
  * (c) 2020 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

function decode (str) {
  try {
    return decodeURIComponent(str)
  } catch (err) {
    if (false) {
      warn(false, ("Error decoding \"" + str + "\". Leaving it intact."));
    }
  }
  return str
}

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) { return false }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

function handleRouteEntered (route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) { continue }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) { cbs[i$1](instance); }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );

    warn(
      // eslint-disable-next-line no-control-regex
      !/[^\u0000-\u007F]+/.test(path),
      "Route with path \"" + path + "\" contains unencoded characters, make sure " +
        "your path is correctly encoded before passing it to the router. Use " +
        "encodeURI to encode static segments of your path."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    })
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.4.9';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vueDirectiveTooltip"] = factory();
	else
		root["vueDirectiveTooltip"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "c267");
/******/ })
/************************************************************************/
/******/ ({

/***/ "026c":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("a828");
var gOPS = __webpack_require__("2dae");
var pIE = __webpack_require__("e60e");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "038b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("7676");

/***/ }),

/***/ "03bc":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("c5f8");
var gOPN = __webpack_require__("d9e5").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "0746":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("672a");
var toLength = __webpack_require__("64d2");
var toAbsoluteIndex = __webpack_require__("fc06");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "07fd":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "081c":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("3cc5");
var get = __webpack_require__("dfcb");
module.exports = __webpack_require__("947c").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "0a04":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("62cf");
var $forEach = __webpack_require__("f13c")(0);
var STRICT = __webpack_require__("14f6")([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "0a85":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("bc7f");

/***/ }),

/***/ "0aad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("a8ae");
var anObject = __webpack_require__("d1f8");
var speciesConstructor = __webpack_require__("2cc2");
var advanceStringIndex = __webpack_require__("ce64");
var toLength = __webpack_require__("64d2");
var callRegExpExec = __webpack_require__("dd3b");
var regexpExec = __webpack_require__("2bfe");
var fails = __webpack_require__("910c");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("e002")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "0acd":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "1331":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("3c7a");
var anObject = __webpack_require__("d1f8");
var getKeys = __webpack_require__("2369");

module.exports = __webpack_require__("66b6") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "14f6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("910c");

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),

/***/ "157a":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5b85");
var toIObject = __webpack_require__("c5f8");
var arrayIndexOf = __webpack_require__("c5be")(false);
var IE_PROTO = __webpack_require__("d0bc")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "166f":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("df98");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "16a8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("3cc5");
var dPs = __webpack_require__("56d8");
var enumBugKeys = __webpack_require__("7ffd");
var IE_PROTO = __webpack_require__("d0bc")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("8cb6")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("6bf9").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "1ae2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("adad");
var has = __webpack_require__("5b85");
var DESCRIPTORS = __webpack_require__("fa25");
var $export = __webpack_require__("1c03");
var redefine = __webpack_require__("c76b");
var META = __webpack_require__("2590").KEY;
var $fails = __webpack_require__("3f9f");
var shared = __webpack_require__("564f");
var setToStringTag = __webpack_require__("a0f7");
var uid = __webpack_require__("edac");
var wks = __webpack_require__("eb5c");
var wksExt = __webpack_require__("26c6");
var wksDefine = __webpack_require__("b978");
var enumKeys = __webpack_require__("026c");
var isArray = __webpack_require__("29b7");
var anObject = __webpack_require__("3cc5");
var isObject = __webpack_require__("bc08");
var toIObject = __webpack_require__("c5f8");
var toPrimitive = __webpack_require__("8e7e");
var createDesc = __webpack_require__("2ae9");
var _create = __webpack_require__("16a8");
var gOPNExt = __webpack_require__("03bc");
var $GOPD = __webpack_require__("e369");
var $DP = __webpack_require__("4b11");
var $keys = __webpack_require__("a828");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("d9e5").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("e60e").f = $propertyIsEnumerable;
  __webpack_require__("2dae").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("5cde")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("e0ed")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "1c03":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("adad");
var core = __webpack_require__("947c");
var ctx = __webpack_require__("499c");
var hide = __webpack_require__("e0ed");
var has = __webpack_require__("5b85");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "1c53":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("d613");
var global = __webpack_require__("adad");
var hide = __webpack_require__("e0ed");
var Iterators = __webpack_require__("de2e");
var TO_STRING_TAG = __webpack_require__("eb5c")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "1e81":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3389");
var $Object = __webpack_require__("947c").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "1f38":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("9081");
var TAG = __webpack_require__("7d30")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "21e4":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "2369":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("b691");
var enumBugKeys = __webpack_require__("7321");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "24b2":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("ad1c")('keys');
var uid = __webpack_require__("ea59");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "2590":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("edac")('meta');
var isObject = __webpack_require__("bc08");
var has = __webpack_require__("5b85");
var setDesc = __webpack_require__("4b11").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("3f9f")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "2624":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("2a8a");

/***/ }),

/***/ "26c6":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("eb5c");


/***/ }),

/***/ "28a8":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("df98");
var isArray = __webpack_require__("2de7");
var SPECIES = __webpack_require__("7d30")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "29b7":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("985c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "2a8a":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c158");
var $Object = __webpack_require__("947c").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "2ae9":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "2bfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("64bd");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "2cc2":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("d1f8");
var aFunction = __webpack_require__("f49a");
var SPECIES = __webpack_require__("7d30")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "2dae":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2de7":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("9081");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "3389":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("1c03");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("fa25"), 'Object', { defineProperty: __webpack_require__("4b11").f });


/***/ }),

/***/ "339d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c616");
var $export = __webpack_require__("62cf");
var redefine = __webpack_require__("ede6");
var hide = __webpack_require__("f650");
var Iterators = __webpack_require__("ee07");
var $iterCreate = __webpack_require__("d0b6");
var setToStringTag = __webpack_require__("bc59");
var getPrototypeOf = __webpack_require__("6aa4");
var ITERATOR = __webpack_require__("7d30")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "33ca":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("97d8");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "3c7a":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("d1f8");
var IE8_DOM_DEFINE = __webpack_require__("e258");
var toPrimitive = __webpack_require__("166f");
var dP = Object.defineProperty;

exports.f = __webpack_require__("66b6") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "3cc5":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("bc08");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "3e85":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "3f25":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("62cf");
var core = __webpack_require__("21e4");
var fails = __webpack_require__("910c");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "3f9f":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "4051":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("3e85");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4821":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("8a52");
var getKeys = __webpack_require__("2369");
var redefine = __webpack_require__("ede6");
var global = __webpack_require__("898f");
var hide = __webpack_require__("f650");
var Iterators = __webpack_require__("ee07");
var wks = __webpack_require__("7d30");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "491a":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("7d30")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("f650")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "4963":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("8c2a");
module.exports = __webpack_require__("947c").Array.isArray;


/***/ }),

/***/ "499c":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("8d84");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "4b11":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("3cc5");
var IE8_DOM_DEFINE = __webpack_require__("d210");
var toPrimitive = __webpack_require__("8e7e");
var dP = Object.defineProperty;

exports.f = __webpack_require__("fa25") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "4baa":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("985c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "4c0f":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "5532":
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__("62cf");

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),

/***/ "564f":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("947c");
var global = __webpack_require__("adad");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("5cde") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "565f":
/***/ (function(module, exports) {



/***/ }),

/***/ "56d8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("4b11");
var anObject = __webpack_require__("3cc5");
var getKeys = __webpack_require__("a828");

module.exports = __webpack_require__("fa25") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "5a82":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("d1f8");
var toObject = __webpack_require__("4051");
var toLength = __webpack_require__("64d2");
var toInteger = __webpack_require__("7c04");
var advanceStringIndex = __webpack_require__("ce64");
var regExpExec = __webpack_require__("dd3b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("e002")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "5b85":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5cde":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "6020":
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__("62cf");

$export($export.P, 'Function', { bind: __webpack_require__("da91") });


/***/ }),

/***/ "62cf":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("898f");
var core = __webpack_require__("21e4");
var hide = __webpack_require__("f650");
var redefine = __webpack_require__("ede6");
var ctx = __webpack_require__("dd29");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "64bd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("d1f8");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "64d2":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("7c04");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "66b6":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("910c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "672a":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("6815");
var defined = __webpack_require__("3e85");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "6815":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("9081");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6a0d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1ae2");
module.exports = __webpack_require__("947c").Object.getOwnPropertySymbols;


/***/ }),

/***/ "6aa4":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("07fd");
var toObject = __webpack_require__("4051");
var IE_PROTO = __webpack_require__("24b2")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "6bf9":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("adad").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "7174":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "7284":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1c53");
__webpack_require__("e001");
module.exports = __webpack_require__("081c");


/***/ }),

/***/ "7321":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "7359":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b978")('asyncIterator');


/***/ }),

/***/ "7676":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1ae2");
__webpack_require__("565f");
__webpack_require__("7359");
__webpack_require__("b592");
module.exports = __webpack_require__("947c").Symbol;


/***/ }),

/***/ "7c04":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "7c34":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "7d30":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("ad1c")('wks');
var uid = __webpack_require__("ea59");
var Symbol = __webpack_require__("898f").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "7ffd":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "8273":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("97d8");
var defined = __webpack_require__("0acd");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "8371":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("1c03");
var core = __webpack_require__("947c");
var fails = __webpack_require__("3f9f");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "8490":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("5cde");
var $export = __webpack_require__("1c03");
var redefine = __webpack_require__("c76b");
var hide = __webpack_require__("e0ed");
var Iterators = __webpack_require__("de2e");
var $iterCreate = __webpack_require__("df7a");
var setToStringTag = __webpack_require__("a0f7");
var getPrototypeOf = __webpack_require__("e55f");
var ITERATOR = __webpack_require__("eb5c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "872b":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("0acd");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "893c":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1e81");

/***/ }),

/***/ "898f":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "8a52":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("491a");
var step = __webpack_require__("af65");
var Iterators = __webpack_require__("ee07");
var toIObject = __webpack_require__("672a");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("339d")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "8a60":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ad1c")('native-function-to-string', Function.toString);


/***/ }),

/***/ "8c2a":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("1c03");

$export($export.S, 'Array', { isArray: __webpack_require__("29b7") });


/***/ }),

/***/ "8cb6":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("bc08");
var document = __webpack_require__("adad").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "8d84":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "8e7e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("bc08");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "9081":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "910c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "947c":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.4' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "97d8":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "985c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "9b5e":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("d147");
module.exports = __webpack_require__("947c").Object.keys;


/***/ }),

/***/ "9be5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("97d8");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "a0f7":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("4b11").f;
var has = __webpack_require__("5b85");
var TAG = __webpack_require__("eb5c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "a634":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "a828":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("157a");
var enumBugKeys = __webpack_require__("7ffd");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "a8ae":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("df98");
var cof = __webpack_require__("9081");
var MATCH = __webpack_require__("7d30")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "a8b1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("6a0d");

/***/ }),

/***/ "ad1c":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("21e4");
var global = __webpack_require__("898f");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("c616") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "ad89":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "adad":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "af30":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("4963");

/***/ }),

/***/ "af65":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "afd5":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("985c");
var TAG = __webpack_require__("eb5c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "b00a":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("7c04");
var defined = __webpack_require__("3e85");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "b592":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b978")('observable');


/***/ }),

/***/ "b691":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("07fd");
var toIObject = __webpack_require__("672a");
var arrayIndexOf = __webpack_require__("0746")(false);
var IE_PROTO = __webpack_require__("24b2")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "b978":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("adad");
var core = __webpack_require__("947c");
var LIBRARY = __webpack_require__("5cde");
var wksExt = __webpack_require__("26c6");
var defineProperty = __webpack_require__("4b11").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "bc08":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "bc59":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("3c7a").f;
var has = __webpack_require__("07fd");
var TAG = __webpack_require__("7d30")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "bc7f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("e001");
__webpack_require__("1c53");
module.exports = __webpack_require__("26c6").f('iterator');


/***/ }),

/***/ "c158":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("c5f8");
var $getOwnPropertyDescriptor = __webpack_require__("e369").f;

__webpack_require__("8371")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "c267":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("4c0f")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/css/index.scss
var css = __webpack_require__("e9cc");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("5a82");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.string.trim.js
var es6_string_trim = __webpack_require__("cf55");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/symbol/iterator.js
var iterator = __webpack_require__("0a85");
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/symbol.js
var symbol = __webpack_require__("038b");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js



function typeof_typeof2(obj) { if (typeof symbol_default.a === "function" && typeof iterator_default.a === "symbol") { typeof_typeof2 = function _typeof2(obj) { return typeof obj; }; } else { typeof_typeof2 = function _typeof2(obj) { return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof obj; }; } return typeof_typeof2(obj); }

function typeof_typeof(obj) {
  if (typeof symbol_default.a === "function" && typeof_typeof2(iterator_default.a) === "symbol") {
    typeof_typeof = function _typeof(obj) {
      return typeof_typeof2(obj);
    };
  } else {
    typeof_typeof = function _typeof(obj) {
      return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof_typeof2(obj);
    };
  }

  return typeof_typeof(obj);
}
// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.array.index-of.js
var es6_array_index_of = __webpack_require__("df15");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("0aad");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("8a52");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("ca85");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("4821");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.array.for-each.js
var es6_array_for_each = __webpack_require__("0a04");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.date.now.js
var es6_date_now = __webpack_require__("5532");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/array/is-array.js
var is_array = __webpack_require__("af30");
var is_array_default = /*#__PURE__*/__webpack_require__.n(is_array);

// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/arrayWithHoles.js

function _arrayWithHoles(arr) {
  if (is_array_default()(arr)) return arr;
}
// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/get-iterator.js
var get_iterator = __webpack_require__("d42b");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/iterableToArrayLimit.js

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = get_iterator_default()(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/slicedToArray.js



function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.array.map.js
var es6_array_map = __webpack_require__("d1ec");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.function.bind.js
var es6_function_bind = __webpack_require__("6020");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/core-js/modules/es6.array.is-array.js
var es6_array_is_array = __webpack_require__("ce3c");

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
var get_own_property_descriptor = __webpack_require__("2624");
var get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptor);

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js
var get_own_property_symbols = __webpack_require__("a8b1");
var get_own_property_symbols_default = /*#__PURE__*/__webpack_require__.n(get_own_property_symbols);

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/object/keys.js
var keys = __webpack_require__("fbac");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __webpack_require__("893c");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  if (key in obj) {
    define_property_default()(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread.js




function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    var ownKeys = keys_default()(source);

    if (typeof get_own_property_symbols_default.a === 'function') {
      ownKeys = ownKeys.concat(get_own_property_symbols_default()(source).filter(function (sym) {
        return get_own_property_descriptor_default()(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    define_property_default()(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var popper = __webpack_require__("f0bd");

// CONCATENATED MODULE: ./src/directives/tooltip.js












var CSS = {
  HIDDEN: 'vue-tooltip-hidden',
  VISIBLE: 'vue-tooltip-visible'
};
var BASE_CLASS = "h-tooltip  ".concat(CSS.HIDDEN);
var PLACEMENT = ['top', 'left', 'right', 'bottom', 'auto'];
var SUB_PLACEMENT = ['start', 'end'];
var EVENTS = {
  ADD: 1,
  REMOVE: 2
};
var DEFAULT_OPTIONS = {
  container: false,
  delay: 200,
  instance: null,
  // the popper.js instance
  fixIosSafari: false,
  eventsEnabled: false,
  html: false,
  modifiers: {
    arrow: {
      element: '.tooltip-arrow'
    }
  },
  placement: '',
  placementPostfix: null,
  // start | end
  removeOnDestroy: true,
  title: '',
  class: '',
  // ex: 'tooltip-custom tooltip-other-custom'
  triggers: ['hover', 'focus'],
  offset: 5
};

var includes = function includes(stack, needle) {
  return stack.indexOf(needle) > -1;
};

var tooltip_Tooltip =
/*#__PURE__*/
function () {
  function Tooltip(el) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tooltip);

    // Tooltip._defaults = DEFAULT_OPTIONS;
    this._options = _objectSpread({}, Tooltip._defaults, {
      onCreate: function onCreate(data) {
        _this.content(_this.tooltip.options.title); // this._$tt.update();

      },
      onUpdate: function onUpdate(data) {
        _this.content(_this.tooltip.options.title); // this._$tt.update();

      }
    }, Tooltip.filterOptions(options));
    this._$el = el;
    this._$tpl = this._createTooltipElement(this.options);
    this._$tt = new popper["a" /* default */](el, this._$tpl, this._options);
    this.setupPopper();
  }

  _createClass(Tooltip, [{
    key: "setupPopper",
    value: function setupPopper() {
      // this._$el.insertAdjacentElement('afterend', this._$tpl);
      this.disabled = false;
      this._visible = false;
      this._clearDelay = null;

      this._$tt.disableEventListeners();

      this._setEvents();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._cleanEvents();

      if (this._$tpl && this._$tpl.parentNode) {
        this._$tpl.parentNode.removeChild(this._$tpl);
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.toggle(true);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.toggle(false);
    }
  }, {
    key: "toggle",
    value: function toggle(visible) {
      var _this2 = this;

      var autoHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var delay = this._options.delay;

      if (this.disabled === true) {
        visible = false;
        delay = 0;
      }

      if (typeof visible !== 'boolean') {
        visible = !this._visible;
      }

      if (visible === true) {
        delay = 0;
      }

      clearTimeout(this._clearDelay);

      if (autoHide === true) {
        this._clearDelay = setTimeout(function () {
          _this2.visible = visible;

          if (_this2.visible === true && _this2.disabled !== true) {
            // add tooltip node
            // this._$el.insertAdjacentElement('afterend', this._$tpl);
            document.querySelector('body').appendChild(_this2._$tpl); // Need the timeout to be sure that the element is inserted in the DOM

            setTimeout(function () {
              // enable eventListeners
              _this2._$tt.enableEventListeners(); // only update if the tooltip is visible


              _this2._$tt.scheduleUpdate(); // switch CSS


              _this2._$tpl.classList.replace(CSS.HIDDEN, CSS.VISIBLE);
            }, 60);
          } else {
            _this2._$tpl.classList.replace(CSS.VISIBLE, CSS.HIDDEN); // remove tooltip node


            if (_this2._$tpl && _this2._$tpl.parentNode) {
              _this2._$tpl.parentNode.removeChild(_this2._$tpl);
            }

            _this2._$tt.disableEventListeners();
          }
        }, delay);
      }
    }
  }, {
    key: "_createTooltipElement",
    value: function _createTooltipElement(options) {
      // wrapper
      var $popper = document.createElement('div');
      $popper.setAttribute('id', "tooltip-".concat(randomId()));
      $popper.setAttribute('class', "".concat(BASE_CLASS, " ").concat(this._options.class)); // make arrow

      var $arrow = document.createElement('div');
      $arrow.setAttribute('class', 'tooltip-arrow');
      $arrow.setAttribute('x-arrow', '');
      $popper.appendChild($arrow); // make content container

      var $content = document.createElement('div');
      $content.setAttribute('class', 'tooltip-content');
      $popper.appendChild($content);
      return $popper;
    }
  }, {
    key: "_events",
    value: function _events() {
      var _this3 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EVENTS.ADD;
      var evtType = type === EVENTS.ADD ? 'addEventListener' : 'removeEventListener';

      if (!Array.isArray(this.options.triggers)) {
        console.error('trigger should be an array', this.options.triggers); // eslint-disable-line

        return;
      }

      var lis = function lis() {
        var _this3$_$el;

        return (_this3$_$el = _this3._$el)[evtType].apply(_this3$_$el, arguments);
      };

      if (includes(this.options.triggers, 'manual')) {
        lis('click', this._onToggle.bind(this), false);
      } else {
        // For the strange iOS/safari behaviour, we remove any 'hover' and replace it by a 'click' event
        if (this.options.fixIosSafari && Tooltip.isIosSafari() && includes(this.options.triggers, 'hover')) {
          var pos = this.options.triggers.indexOf('hover');
          var click = includes(this.options.triggers, 'click');
          this._options.triggers[pos] = click !== -1 ? 'click' : null;
        }

        this.options.triggers.map(function (evt) {
          switch (evt) {
            case 'click':
              lis('click', function (e) {
                _this3._onToggle(e);
              }, false); // document[evtType]('click', this._onDeactivate.bind(this), false);

              break;

            case 'hover':
              lis('mouseenter', _this3._onActivate.bind(_this3), false);
              lis('mouseleave', _this3._onDeactivate.bind(_this3), false);
              break;

            case 'focus':
              lis('focus', _this3._onActivate.bind(_this3), false);
              lis('blur', _this3._onDeactivate.bind(_this3), true);
              break;
          }
        });

        if (includes(this.options.triggers, 'hover') || includes(this.options.triggers, 'focus')) {
          this._$tpl[evtType]('mouseenter', this._onMouseOverTooltip.bind(this), false);

          this._$tpl[evtType]('mouseleave', this._onMouseOutTooltip.bind(this), false);
        }
      }
    }
  }, {
    key: "_setEvents",
    value: function _setEvents() {
      this._events();
    }
  }, {
    key: "_cleanEvents",
    value: function _cleanEvents() {
      this._events(EVENTS.REMOVE);
    }
  }, {
    key: "_onActivate",
    value: function _onActivate(e) {
      this.show();
    }
  }, {
    key: "_onDeactivate",
    value: function _onDeactivate(e) {
      this.hide();
    }
  }, {
    key: "_onToggle",
    value: function _onToggle(e) {
      e.stopPropagation();
      e.preventDefault();
      this.toggle();
    }
  }, {
    key: "_onMouseOverTooltip",
    value: function _onMouseOverTooltip(e) {
      this.toggle(true, false);
    }
  }, {
    key: "_onMouseOutTooltip",
    value: function _onMouseOutTooltip(e) {
      this.toggle(false);
    }
  }, {
    key: "content",
    value: function content(_content) {
      var wrapper = this.tooltip.popper.querySelector('.tooltip-content');

      if (typeof _content === 'string') {
        this.tooltip.options.title = _content;
        wrapper.textContent = _content;
      } else if (isElement(_content)) {
        if (_content !== wrapper.children[0]) {
          wrapper.innerHTML = ''; // this.tooltip.htmlContent = content.cloneNode(true);

          this.tooltip.htmlContent = _content;
          wrapper.appendChild(this.tooltip.htmlContent);
        }
      } else {
        console.error('unsupported content type', _content); // eslint-disable-line
      }
    }
  }, {
    key: "options",
    get: function get() {
      return _objectSpread({}, this._options);
    }
  }, {
    key: "tooltip",
    get: function get() {
      return this._$tt;
    }
  }, {
    key: "visible",
    get: function get() {
      return this._visible;
    },
    set: function set(val) {
      if (typeof val === 'boolean') {
        this._visible = val;
      }
    }
  }, {
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(val) {
      if (typeof val === 'boolean') {
        this._disabled = val;
      }
    }
  }, {
    key: "class",
    set: function set(val) {
      if (typeof val === 'string') {
        var classList = this._$tpl.classList.value.replace(this.options.class, val);

        this._options.class = classList;

        this._$tpl.setAttribute('class', classList);
      }
    }
  }], [{
    key: "filterOptions",
    value: function filterOptions(options) {
      var opt = _objectSpread({}, options);

      opt.modifiers = {};
      var head = null;
      var tail = null;

      if (opt.placement.indexOf('-') > -1) {
        var _opt$placement$split = opt.placement.split('-');

        var _opt$placement$split2 = _slicedToArray(_opt$placement$split, 2);

        head = _opt$placement$split2[0];
        tail = _opt$placement$split2[1];
        opt.placement = includes(PLACEMENT, head) && includes(SUB_PLACEMENT, tail) ? opt.placement : Tooltip._defaults.placement;
      } else {
        opt.placement = includes(PLACEMENT, opt.placement) ? opt.placement : Tooltip._defaults.placement;
      }

      opt.modifiers.offset = {
        fn: Tooltip._setOffset
      };
      return opt;
    }
  }, {
    key: "_setOffset",
    value: function _setOffset(data, opts) {
      var offset = data.instance.options.offset;

      if (window.isNaN(offset) || offset < 0) {
        offset = Tooltip._defaults.offset;
      }

      if (data.placement.indexOf('top') !== -1) {
        data.offsets.popper.top -= offset;
      } else if (data.placement.indexOf('right') !== -1) {
        data.offsets.popper.left += offset;
      } else if (data.placement.indexOf('bottom') !== -1) {
        data.offsets.popper.top += offset;
      } else if (data.placement.indexOf('left') !== -1) {
        data.offsets.popper.left -= offset;
      }

      return data;
    }
  }, {
    key: "isIosSafari",
    value: function isIosSafari() {
      return includes(navigator.userAgent.toLowerCase(), 'mobile') && includes(navigator.userAgent.toLowerCase(), 'safari') && (navigator.platform.toLowerCase() === 'iphone' || navigator.platform.toLowerCase() === 'ipad');
    }
  }, {
    key: "defaults",
    value: function defaults(data) {
      // if (data.placement) {
      //     data.originalPlacement = data.placement;
      // }
      Tooltip._defaults = _objectSpread({}, Tooltip._defaults, data);
    }
  }]);

  return Tooltip;
}();


tooltip_Tooltip._defaults = _objectSpread({}, DEFAULT_OPTIONS);

function randomId() {
  return "".concat(Date.now(), "-").concat(Math.round(Math.random() * 100000000));
}
/**
 * Check if the variable is an html element
 * @param {*} value
 * @return Boolean
 */


function isElement(value) {
  return value instanceof window.Element;
}
// CONCATENATED MODULE: ./src/directives/tooltip-directive.js










/**
 * @author: laurent blanes <laurent.blanes@gmail.com>
 * @tutorial: https://hekigan.github.io/vue-directive-tooltip/
 */

var tooltip_directive_BASE_CLASS = 'vue-tooltip';
var POSITIONS = ['auto', 'top', 'bottom', 'left', 'right'];
var SUB_POSITIONS = ['start', 'end'];
/**
 * usage:
 *
 * // basic usage:
 * <div v-tooltip="'my content'">
 * or
 * <div v-tooltip="{content: 'my content'}">
 *
 * // change position of tooltip
 * // options: auto (default) | bottom | top | left | right
 *
 * // change sub-position of tooltip
 * // options: start | end
 *
 * <div v-tooltip.top="{content: 'my content'}">
 *
 * // add custom class
 * <div v-tooltip="{class: 'custom-class', content: 'my content'}">
 *
 * // toggle visibility
 * <div v-tooltip="{visible: false, content: 'my content'}">
 */

/* harmony default export */ var tooltip_directive = ({
  name: 'tooltip',
  config: {},
  install: function install(Vue, installOptions) {
    Vue.directive('tooltip', {
      bind: function bind(el, binding, vnode) {
        if (installOptions) {
          tooltip_Tooltip.defaults(installOptions);
        }
      },
      inserted: function inserted(el, binding, vnode, oldVnode) {
        if (installOptions) {
          tooltip_Tooltip.defaults(installOptions);
        }

        var options = filterBindings(binding, vnode);
        el.tooltip = new tooltip_Tooltip(el, options);

        if (binding.modifiers.notrigger && binding.value.visible === true) {
          el.tooltip.show();
        }

        if (binding.value && binding.value.visible === false) {
          el.tooltip.disabled = true;
        }
      },
      componentUpdated: function componentUpdated(el, binding, vnode, oldVnode) {
        if (hasUpdated(binding.value, binding.oldValue)) {
          update(el, binding, vnode, oldVnode);
        }
      },
      unbind: function unbind(el, binding, vnode, oldVnode) {
        el.tooltip.destroy();
      }
    });
  }
});
/**
 *
 * @param {*} vnode component's properties
 * @param {*} oldvnode component's previous properties
 * @return boolean
 */

function hasUpdated(value, oldValue) {
  var updated = false;

  if (typeof value === 'string' && value !== oldValue) {
    updated = true;
  } else if (isObject(value)) {
    Object.keys(value).forEach(function (prop) {
      if (value[prop] !== oldValue[prop]) {
        updated = true;
      }
    });
  }

  return updated;
}
/**
 * Sanitize data
 * @param {*} binding
 * @param {*} vnode
 * @return {*} filtered data object
 */


function filterBindings(binding, vnode) {
  var delay = !binding.value || isNaN(binding.value.delay) ? tooltip_Tooltip._defaults.delay : binding.value.delay;

  if (binding.value.ref) {
    if (vnode.context.$refs[binding.value.ref]) {
      binding.value.html = vnode.context.$refs[binding.value.ref];
    } else {
      console.error("[Tooltip] no REF element [".concat(binding.value.ref, "]")); // eslint-disable-line
    }
  }

  return {
    class: getClass(binding),
    id: binding.value ? binding.value.id : null,
    html: binding.value ? binding.value.html : null,
    placement: getPlacement(binding),
    title: getContent(binding),
    triggers: getTriggers(binding),
    fixIosSafari: binding.modifiers.ios || false,
    offset: binding.value && binding.value.offset ? binding.value.offset : tooltip_Tooltip._defaults.offset,
    delay: delay
  };
}
/**
 * Get placement from modifiers
 * @param {*} binding
 */


function getPlacement(_ref) {
  var modifiers = _ref.modifiers,
      value = _ref.value;
  var MODS = Object.keys(modifiers);

  if (MODS.length === 0 && isObject(value) && typeof value.placement === 'string') {
    MODS = value.placement.split('.');
  }

  var head = 'bottom';
  var tail = null;

  for (var i = 0; i < MODS.length; i++) {
    var pos = MODS[i];

    if (POSITIONS.indexOf(pos) > -1) {
      head = pos;
    }

    if (SUB_POSITIONS.indexOf(pos) > -1) {
      tail = pos;
    }
  } // console.log((head && tail) ? `${head}-${tail}` : head);
  // return 'auto';


  return head && tail ? "".concat(head, "-").concat(tail) : head;
}
/**
 * Get trigger value from modifiers
 * @param {*} binding
 * @return String
 */


function getTriggers(_ref2) {
  var modifiers = _ref2.modifiers;
  var trigger = [];

  if (modifiers.notrigger) {
    return trigger;
  } else if (modifiers.manual) {
    trigger.push('manual');
  } else {
    if (modifiers.click) {
      trigger.push('click');
    }

    if (modifiers.hover) {
      trigger.push('hover');
    }

    if (modifiers.focus) {
      trigger.push('focus');
    }

    if (trigger.length === 0) {
      trigger.push('hover', 'focus');
    }
  }

  return trigger;
}
/**
 * Check if the variable is an object
 * @param {*} value
 * @return Boolean
 */


function isObject(value) {
  return typeof_typeof(value) === 'object';
}
/**
 * Check if the variable is an html element
 * @param {*} value
 * @return Boolean
 */


function tooltip_directive_isElement(value) {
  return value instanceof window.Element;
}
/**
 * Get the css class
 * @param {*} binding
 * @return HTMLElement | String
 */


function getClass(_ref3) {
  var value = _ref3.value;

  if (value === null) {
    return tooltip_directive_BASE_CLASS;
  } else if (isObject(value) && typeof value.class === 'string') {
    return "".concat(tooltip_directive_BASE_CLASS, " ").concat(value.class);
  } else if (tooltip_Tooltip._defaults.class) {
    return "".concat(tooltip_directive_BASE_CLASS, " ").concat(tooltip_Tooltip._defaults.class);
  } else {
    return tooltip_directive_BASE_CLASS;
  }
}
/**
 * Get the content
 * @param {*} binding
 * @return HTMLElement | String
 */


function getContent(_ref4, vnode) {
  var value = _ref4.value;

  if (value !== null && isObject(value)) {
    if (value.content !== undefined) {
      return "".concat(value.content);
    } else if (value.id && document.getElementById(value.id)) {
      return document.getElementById(value.id);
    } else if (value.html && document.getElementById(value.html)) {
      return document.getElementById(value.html);
    } else if (tooltip_directive_isElement(value.html)) {
      return value.html;
    } else if (value.ref && vnode) {
      return vnode.context.$refs[value.ref] || '';
    } else {
      return '';
    }
  } else {
    return "".concat(value);
  }
}
/**
 * Action on element update
 * @param {*} el Vue element
 * @param {*} binding
 */


function update(el, binding, vnode, oldVnode) {
  if (typeof binding.value === 'string') {
    el.tooltip.content(binding.value);
  } else {
    if (binding.value && binding.value.class && binding.value.class.trim() !== el.tooltip.options.class.replace(tooltip_directive_BASE_CLASS, '').trim()) {
      el.tooltip.class = "".concat(tooltip_directive_BASE_CLASS, " ").concat(binding.value.class.trim());
    }

    el.tooltip.content(getContent(binding, vnode));

    if (!binding.modifiers.notrigger && binding.value && typeof binding.value.visible === 'boolean') {
      el.tooltip.disabled = !binding.value.visible;
      return;
    } else if (binding.modifiers.notrigger) {
      el.tooltip.disabled = false;
    }

    var dir = vnode.data.directives[0];

    if (dir.oldValue.visible !== dir.value.visible) {
      if (!el.tooltip.disabled) {
        el.tooltip.toggle(dir.value.visible);
      }
    }
  }
}
// CONCATENATED MODULE: ./src/index.js


/* harmony default export */ var src = (tooltip_directive);
// CONCATENATED MODULE: /Users/l-blanes/.config/yarn/global/node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ }),

/***/ "c298":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("d1f8");
var dPs = __webpack_require__("1331");
var enumBugKeys = __webpack_require__("7321");
var IE_PROTO = __webpack_require__("24b2")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("f44d")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("cf14").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "c49f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("2bfe");
__webpack_require__("62cf")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "c5be":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("c5f8");
var toLength = __webpack_require__("33ca");
var toAbsoluteIndex = __webpack_require__("9be5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c5f8":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("4baa");
var defined = __webpack_require__("0acd");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "c616":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c76b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("e0ed");


/***/ }),

/***/ "ca85":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4051");
var $keys = __webpack_require__("2369");

__webpack_require__("3f25")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "cad2":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "ce3c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__("62cf");

$export($export.S, 'Array', { isArray: __webpack_require__("2de7") });


/***/ }),

/***/ "ce64":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("b00a")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "cf14":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("898f").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "cf55":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__("d9df")('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),

/***/ "d0b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("c298");
var descriptor = __webpack_require__("7174");
var setToStringTag = __webpack_require__("bc59");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("f650")(IteratorPrototype, __webpack_require__("7d30")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "d0bc":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("564f")('keys');
var uid = __webpack_require__("edac");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "d147":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("872b");
var $keys = __webpack_require__("a828");

__webpack_require__("8371")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "d1ec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("62cf");
var $map = __webpack_require__("f13c")(1);

$export($export.P + $export.F * !__webpack_require__("14f6")([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),

/***/ "d1f8":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("df98");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "d210":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("fa25") && !__webpack_require__("3f9f")(function () {
  return Object.defineProperty(__webpack_require__("8cb6")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "d42b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("7284");

/***/ }),

/***/ "d613":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("cad2");
var step = __webpack_require__("7c34");
var Iterators = __webpack_require__("de2e");
var toIObject = __webpack_require__("c5f8");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("8490")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "d9df":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("62cf");
var defined = __webpack_require__("3e85");
var fails = __webpack_require__("910c");
var spaces = __webpack_require__("dd46");
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),

/***/ "d9e5":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("157a");
var hiddenKeys = __webpack_require__("7ffd").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "da91":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__("f49a");
var isObject = __webpack_require__("df98");
var invoke = __webpack_require__("a634");
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),

/***/ "dd29":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("f49a");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "dd3b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("1f38");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "dd46":
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "de2e":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "df15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__("62cf");
var $indexOf = __webpack_require__("0746")(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__("14f6")($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),

/***/ "df7a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("16a8");
var descriptor = __webpack_require__("2ae9");
var setToStringTag = __webpack_require__("a0f7");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("e0ed")(IteratorPrototype, __webpack_require__("eb5c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "df98":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "dfcb":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("afd5");
var ITERATOR = __webpack_require__("eb5c")('iterator');
var Iterators = __webpack_require__("de2e");
module.exports = __webpack_require__("947c").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "e001":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("8273")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("8490")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "e002":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("c49f");
var redefine = __webpack_require__("ede6");
var hide = __webpack_require__("f650");
var fails = __webpack_require__("910c");
var defined = __webpack_require__("3e85");
var wks = __webpack_require__("7d30");
var regexpExec = __webpack_require__("2bfe");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "e0ed":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("4b11");
var createDesc = __webpack_require__("2ae9");
module.exports = __webpack_require__("fa25") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "e258":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("66b6") && !__webpack_require__("910c")(function () {
  return Object.defineProperty(__webpack_require__("f44d")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "e369":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("e60e");
var createDesc = __webpack_require__("2ae9");
var toIObject = __webpack_require__("c5f8");
var toPrimitive = __webpack_require__("8e7e");
var has = __webpack_require__("5b85");
var IE8_DOM_DEFINE = __webpack_require__("d210");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("fa25") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "e55f":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("5b85");
var toObject = __webpack_require__("872b");
var IE_PROTO = __webpack_require__("d0bc")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "e60e":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "e87c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("28a8");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "e9cc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ea59":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "eb5c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("564f")('wks');
var uid = __webpack_require__("edac");
var Symbol = __webpack_require__("adad").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "edac":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "ede6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("898f");
var hide = __webpack_require__("f650");
var has = __webpack_require__("07fd");
var SRC = __webpack_require__("ea59")('src');
var $toString = __webpack_require__("8a60");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("21e4").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "ee07":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "f0bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("ad89")))

/***/ }),

/***/ "f13c":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("dd29");
var IObject = __webpack_require__("6815");
var toObject = __webpack_require__("4051");
var toLength = __webpack_require__("64d2");
var asc = __webpack_require__("e87c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "f44d":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("df98");
var document = __webpack_require__("898f").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "f49a":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "f650":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("3c7a");
var createDesc = __webpack_require__("7174");
module.exports = __webpack_require__("66b6") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "fa25":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("3f9f")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "fbac":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("9b5e");

/***/ }),

/***/ "fc06":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("7c04");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ })

/******/ })["default"];
});
//# sourceMappingURL=vueDirectiveTooltip.umd.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(124);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4dc6267c", content, true, {});

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-tooltip{background-color:#000;box-sizing:border-box;color:#fff;max-width:320px;padding:6px 10px;border-radius:3px;z-index:100;box-shadow:2px 2px 3px rgba(0,0,0,.4)}.vue-tooltip.vue-tooltip-hidden{transform:translateX(-100000px)!important}.vue-tooltip .vue-tooltip-content{text-align:center}.vue-tooltip .tooltip-arrow{content:\"\";width:0;height:0;border-style:solid;position:absolute;margin:5px}.vue-tooltip[x-out-of-boundaries]{display:none}.vue-tooltip[x-placement^=bottom]{margin-top:5px}.vue-tooltip[x-placement^=bottom] .tooltip-arrow{border-width:0 5px 5px;border-bottom-color:#000;border-top-color:transparent!important;border-left-color:transparent!important;border-right-color:transparent!important;top:-5px;margin-top:0;margin-bottom:0}.vue-tooltip[x-placement^=top]{margin-bottom:5px}.vue-tooltip[x-placement^=top] .tooltip-arrow{border-width:5px 5px 0;border-top-color:#000;border-bottom-color:transparent!important;border-left-color:transparent!important;border-right-color:transparent!important;bottom:-5px;margin-top:0;margin-bottom:0}.vue-tooltip[x-placement^=right]{margin-left:5px}.vue-tooltip[x-placement^=right] .tooltip-arrow{border-width:5px 5px 5px 0;border-right-color:#000;border-top-color:transparent!important;border-left-color:transparent!important;border-bottom-color:transparent!important;left:-5px;margin-left:0;margin-right:0}.vue-tooltip[x-placement^=left]{margin-right:5px}.vue-tooltip[x-placement^=left] .tooltip-arrow{border-width:5px 0 5px 5px;border-left-color:#000;border-top-color:transparent!important;border-right-color:transparent!important;border-bottom-color:transparent!important;right:-5px;margin-left:0;margin-right:0}", ""]);

// exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-nav-tabs v0.5.7
 * (c) 2018-present cristij <joracristi@gmail.com>
 * Released under the MIT License.
 */
(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.vueTabs = {})));
}(this, (function (exports) { 'use strict';

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/;

var babelHelperVueJsxMergeProps = function mergeJSXProps(objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp;
    for (key in b) {
      aa = a[key];
      bb = b[key];
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa;
            a[key] = aa = {};
            aa[temp] = true;
          }
          if (typeof bb === 'string') {
            temp = bb;
            b[key] = bb = {};
            bb[temp] = true;
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey]);
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb);
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb);
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey];
          }
        }
      } else {
        a[key] = b[key];
      }
    }
    return a;
  }, {});
};

function mergeFn(a, b) {
  return function () {
    a.apply(this, arguments);
    b.apply(this, arguments);
  };
}

var VueTabs = {
    name: 'vue-tabs',
    props: {
        activeTabColor: String,
        activeTextColor: String,
        disabledColor: String,
        disabledTextColor: String,
        /**
         * Tab title position: center | bottom | top
         */
        textPosition: {
            type: String,
            default: 'center'
        },
        /**
         * Tab type: tabs | pills
         */
        type: {
            type: String,
            default: 'tabs'
        },
        direction: {
            type: String,
            default: 'horizontal'
        },
        /**
         * Centers the tabs and makes the container div full width
         */
        centered: Boolean,
        value: [String, Number, Object]
    },
    data: function data() {
        return {
            activeTabIndex: 0,
            tabs: []
        };
    },

    computed: {
        isTabShape: function isTabShape() {
            return this.type === 'tabs';
        },
        isStacked: function isStacked() {
            return this.direction === 'vertical';
        },
        classList: function classList() {
            var navType = this.isTabShape ? 'nav-tabs' : 'nav-pills';
            var centerClass = this.centered ? 'nav-justified' : '';
            var isStacked = this.isStacked ? 'nav-stacked' : '';
            return 'nav ' + navType + ' ' + centerClass + ' ' + isStacked;
        },
        stackedClass: function stackedClass() {
            return this.isStacked ? 'stacked' : '';
        },
        activeTabStyle: function activeTabStyle() {
            return {
                backgroundColor: this.activeTabColor,
                color: this.activeTextColor
            };
        }
    },
    methods: {
        navigateToTab: function navigateToTab(index, route) {
            this.changeTab(this.activeTabIndex, index, route);
        },
        activateTab: function activateTab(index) {
            this.activeTabIndex = index;
            var tab = this.tabs[index];
            tab.active = true;
            this.$emit('input', tab.title);
        },
        changeTab: function changeTab(oldIndex, newIndex, route) {
            var oldTab = this.tabs[oldIndex] || {};
            var newTab = this.tabs[newIndex];
            if (newTab.disabled) return;
            this.activeTabIndex = newIndex;
            oldTab.active = false;
            newTab.active = true;
            this.$emit('input', this.tabs[newIndex].title);
            this.$emit('tab-change', newIndex, newTab, oldTab);
            this.tryChangeRoute(route);
        },
        tryChangeRoute: function tryChangeRoute(route) {
            if (this.$router && route) {
                this.$router.push(route);
            }
        },
        addTab: function addTab(item) {
            var index = this.$slots.default.indexOf(item.$vnode);
            this.tabs.splice(index, 0, item);
        },
        removeTab: function removeTab(item) {
            var tabs = this.tabs;
            var index = tabs.indexOf(item);
            if (index > -1) {
                tabs.splice(index, 1);
            }
        },
        getTabs: function getTabs() {
            if (this.$slots.default) {
                return this.$slots.default.filter(function (comp) {
                    return comp.componentOptions;
                });
            }
            return [];
        },
        findTabAndActivate: function findTabAndActivate(tabNameOrIndex) {
            var indexToActivate = this.tabs.findIndex(function (tab, index) {
                return tab.title === tabNameOrIndex || index === tabNameOrIndex;
            });
            if (indexToActivate === this.activeTabIndex) return;
            if (indexToActivate !== -1) {
                this.changeTab(this.activeTabIndex, indexToActivate);
            } else {
                this.changeTab(this.activeTabIndex, 0);
            }
        },
        renderTabTitle: function renderTabTitle(index) {
            var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var active = tab.active,
                title = tab.title;

            var titleStyles = { color: this.activeTabColor };
            if (position === 'center') titleStyles.color = this.activeTextColor;
            var simpleTitle = h(
                'span',
                { 'class': 'title title_' + position, style: active ? titleStyles : {} },
                [position === 'center' && this.renderIcon(index), title]
            );

            if (tab.$slots.title) return tab.$slots.title;
            if (tab.$scopedSlots.title) return tab.$scopedSlots.title({
                active: active,
                title: title,
                position: position,
                icon: tab.icon,
                data: tab.tabData
            });
            return simpleTitle;
        },
        renderIcon: function renderIcon(index) {
            var h = this.$createElement;

            if (this.tabs.length === 0) return;
            var tab = this.tabs[index];
            var icon = tab.icon;

            var simpleIcon = h(
                'i',
                { 'class': icon },
                ['\xA0']
            );
            if (!tab.$slots.title && icon) return simpleIcon;
        },
        tabStyles: function tabStyles(tab) {
            if (tab.disabled) {
                return {
                    backgroundColor: this.disabledColor,
                    color: this.disabledTextColor
                };
            }
            return {};
        },
        renderTabs: function renderTabs() {
            var _this = this;

            var h = this.$createElement;

            return this.tabs.map(function (tab, index) {
                if (!tab) return;
                var route = tab.route,
                    id = tab.id,
                    title = tab.title,
                    icon = tab.icon,
                    tabId = tab.tabId;

                var active = _this.activeTabIndex === index;
                return h(
                    'li',
                    babelHelperVueJsxMergeProps([{
                        attrs: { name: 'tab',
                            id: 't-' + tabId,
                            'aria-selected': active,
                            'aria-controls': 'p-' + tabId,
                            role: 'tab' },

                        'class': ['tab', { active: active }, { disabled: tab.disabled }],
                        key: title }, {
                        on: {
                            'click': function click($event) {
                                for (var _len = arguments.length, attrs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                                    attrs[_key - 1] = arguments[_key];
                                }

                                (function () {
                                    return !tab.disabled && _this.navigateToTab(index, route);
                                }).apply(undefined, [$event].concat(attrs));
                            }
                        }
                    }]),
                    [_this.textPosition === 'top' && _this.renderTabTitle(index, _this.textPosition), h(
                        'a',
                        babelHelperVueJsxMergeProps([{
                            attrs: { href: '#',

                                role: 'tab' },

                            style: active ? _this.activeTabStyle : _this.tabStyles(tab),
                            'class': [{ 'active_tab': active }, 'tabs__link'] }, {
                            on: {
                                'click': function click($event) {
                                    for (var _len2 = arguments.length, attrs = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                                        attrs[_key2 - 1] = arguments[_key2];
                                    }

                                    (function (e) {
                                        e.preventDefault();
                                        return false;
                                    }).apply(undefined, [$event].concat(attrs));
                                }
                            }
                        }]),
                        [_this.textPosition !== 'center' && !tab.$slots.title && _this.renderIcon(index), _this.textPosition === 'center' && _this.renderTabTitle(index, _this.textPosition)]
                    ), _this.textPosition === 'bottom' && _this.renderTabTitle(index, _this.textPosition)]
                );
            });
        }
    },
    render: function render() {
        var h = arguments[0];

        var tabList = this.renderTabs();
        return h(
            'div',
            { 'class': ['vue-tabs', this.stackedClass] },
            [h(
                'div',
                { 'class': [{ 'nav-tabs-navigation': !this.isStacked }, { 'left-vertical-tabs': this.isStacked }] },
                [h(
                    'div',
                    { 'class': ['nav-tabs-wrapper', this.stackedClass] },
                    [h(
                        'ul',
                        { 'class': this.classList, attrs: { role: 'tablist' }
                        },
                        [tabList]
                    )]
                )]
            ), h(
                'div',
                { 'class': ['tab-content', { 'right-text-tabs': this.isStacked }] },
                [this.$slots.default]
            )]
        );
    },

    watch: {
        tabs: function tabs(newList) {
            if (newList.length > 0 && !this.value) {
                if (newList.length <= this.activeTabIndex) {
                    this.activateTab(this.activeTabIndex - 1);
                } else {
                    this.activateTab(this.activeTabIndex);
                }
            }
            if (newList.length > 0 && this.value) {
                this.findTabAndActivate(this.value);
            }
        },
        value: function value(newVal) {
            this.findTabAndActivate(newVal);
        }
    }
};

var VTab = {
    name: 'v-tab',
    props: {
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        tabData: {
            default: null
        },
        /***
         * Function to execute before tab switch. Return value must be boolean
         * If the return result is false, tab switch is restricted
         */
        beforeChange: {
            type: Function
        },
        id: String,
        route: {
            type: [String, Object]
        },
        disabled: Boolean,
        transitionName: String,
        transitionMode: String
    },
    computed: {
        isValidParent: function isValidParent() {
            return this.$parent.$options.name === 'vue-tabs';
        },
        hash: function hash() {
            return '#' + this.id;
        },
        tabId: function tabId() {
            return this.id ? this.id : this.title;
        }
    },
    data: function data() {
        return {
            active: false,
            validationError: null
        };
    },
    mounted: function mounted() {
        this.$parent.addTab(this);
    },
    destroyed: function destroyed() {
        if (this.$el && this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
        this.$parent.removeTab(this);
    },
    render: function render() {
        var h = arguments[0];

        return h(
            'section',
            { 'class': 'tab-container',
                attrs: { id: 'p-' + this.tabId,
                    'aria-labelledby': 't-' + this.tabId,
                    role: 'tabpanel' },
                directives: [{
                    name: 'show',
                    value: this.active
                }]
            },
            [this.$slots.default]
        );
    }
};

var VueTabsPlugin = {
  install: function install(Vue) {
    Vue.component('vue-tabs', VueTabs);
    Vue.component('v-tab', VTab);
  }
};
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueTabsPlugin);
  window.VueTabs = VueTabsPlugin;
}

exports['default'] = VueTabsPlugin;
exports.VueTabs = VueTabs;
exports.VTab = VTab;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2b289dbd", content, true, {});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-tabs.stacked{display:flex}.vue-tabs .tabs__link{text-decoration:none;color:gray}.vue-tabs .nav{margin-bottom:0;margin-top:0;padding-left:0;list-style:none}.vue-tabs .nav:after,.vue-tabs .nav:before{content:\" \";display:table}.vue-tabs .nav:after{clear:both}.vue-tabs .nav>li,.vue-tabs .nav>li>a{position:relative;display:block}.vue-tabs .nav>li>a{padding:10px 15px}.vue-tabs .nav>li>a:focus,.vue-tabs .nav>li>a:hover{text-decoration:none;background-color:#eee}.vue-tabs .nav>li span.title{display:flex;justify-content:center}.vue-tabs .nav>li.disabled>a{color:#777}.vue-tabs .nav>li.disabled>a:focus,.vue-tabs .nav>li.disabled>a:hover{color:#777;text-decoration:none;cursor:not-allowed;background-color:transparent;border-color:transparent}.vue-tabs .nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.vue-tabs .nav>li>a>img{max-width:none}.vue-tabs .nav-tabs{border-bottom:1px solid #ddd}.vue-tabs .nav-tabs>li{float:left;margin-bottom:-1px}.vue-tabs .nav-tabs>li>a{margin-right:2px;line-height:1.42857;border:1px solid transparent;border-radius:4px 4px 0 0}.vue-tabs .nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.vue-tabs .nav-tabs>li.active>a,.vue-tabs .nav-tabs>li.active>a:focus,.vue-tabs .nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.vue-tabs .nav-pills>li{float:left}.vue-tabs .nav-pills>li>a{border-radius:4px}.vue-tabs .nav-pills>li+li{margin-left:2px}.vue-tabs .nav-pills>li.active>a,.vue-tabs .nav-pills>li.active>a:focus,.vue-tabs .nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.vue-tabs .nav-stacked>li{float:none}.vue-tabs .nav-stacked>li+li{margin-top:2px;margin-left:0}.vue-tabs .nav-justified,.vue-tabs .nav-tabs.nav-justified{width:100%}.vue-tabs .nav-justified>li,.vue-tabs .nav-tabs.nav-justified>li{float:none}.vue-tabs .nav-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.vue-tabs .nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.vue-tabs .nav-justified>li,.vue-tabs .nav-tabs.nav-justified>li{display:table-cell;width:1%}.vue-tabs .nav-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{margin-bottom:0}}.vue-tabs .nav-tabs-justified,.vue-tabs .nav-tabs.nav-justified{border-bottom:0}.vue-tabs .nav-tabs-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.vue-tabs .nav-tabs-justified>.active>a,.vue-tabs .nav-tabs-justified>.active>a:focus,.vue-tabs .nav-tabs-justified>.active>a:hover,.vue-tabs .nav-tabs.nav-justified>.active>a,.vue-tabs .nav-tabs.nav-justified>.active>a:focus,.vue-tabs .nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.vue-tabs .nav-tabs-justified>li>a,.vue-tabs .nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.vue-tabs .nav-tabs-justified>.active>a,.vue-tabs .nav-tabs-justified>.active>a:focus,.vue-tabs .nav-tabs-justified>.active>a:hover,.vue-tabs .nav-tabs.nav-justified>.active>a,.vue-tabs .nav-tabs.nav-justified>.active>a:focus,.vue-tabs .nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.vue-tabs .tab-content>.tab-pane{display:none}.vue-tabs .tab-content>.active{display:block}.vue-tabs section[aria-hidden=true]{display:none}", ""]);

// exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueFormWizard=e():t.VueFormWizard=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(n){if(a[n])return a[n].exports;var i=a[n]={i:n,l:!1,exports:{}};return t[n].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var a={};return e.m=t,e.c=a,e.d=function(t,a,n){e.o(t,a)||Object.defineProperty(t,a,{configurable:!1,enumerable:!0,get:n})},e.n=function(t){var a=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(a,"a",a),a},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=7)}([function(t,e){t.exports=function(t,e,a,n,i,r){var s,o=t=t||{},c=typeof t.default;"object"!==c&&"function"!==c||(s=t,o=t.default);var u="function"==typeof o?o.options:o;e&&(u.render=e.render,u.staticRenderFns=e.staticRenderFns,u._compiled=!0),a&&(u.functional=!0),i&&(u._scopeId=i);var l;if(r?(l=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),n&&n.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},u._ssrRegister=l):n&&(l=n),l){var d=u.functional,b=d?u.render:u.beforeCreate;d?(u._injectStyles=l,u.render=function(t,e){return l.call(e),b(t,e)}):u.beforeCreate=b?[].concat(b,l):[l]}return{esModule:s,exports:o,options:u}}},function(t,e,a){"use strict";var n=a(2),i=a(4),r=a(14);e.a={name:"form-wizard",components:{WizardButton:n.a,WizardStep:i.a},props:{title:{type:String,default:"Awesome Wizard"},subtitle:{type:String,default:"Split a complicated flow in multiple steps"},nextButtonText:{type:String,default:"Next"},backButtonText:{type:String,default:"Back"},finishButtonText:{type:String,default:"Finish"},hideButtons:{type:Boolean,default:!1},validateOnBack:Boolean,color:{type:String,default:"#e74c3c"},errorColor:{type:String,default:"#8b0000"},shape:{type:String,default:"circle"},layout:{type:String,default:"horizontal"},stepsClasses:{type:[String,Array],default:""},stepSize:{type:String,default:"md",validator:function(t){return-1!==["xs","sm","md","lg"].indexOf(t)}},transition:{type:String,default:""},startIndex:{type:Number,default:0,validator:function(t){return t>=0}}},provide:function(){return{addTab:this.addTab,removeTab:this.removeTab}},data:function(){return{activeTabIndex:0,currentPercentage:0,maxStep:0,loading:!1,tabs:[]}},computed:{slotProps:function(){return{nextTab:this.nextTab,prevTab:this.prevTab,activeTabIndex:this.activeTabIndex,isLastStep:this.isLastStep,fillButtonStyle:this.fillButtonStyle}},tabCount:function(){return this.tabs.length},isLastStep:function(){return this.activeTabIndex===this.tabCount-1},isVertical:function(){return"vertical"===this.layout},displayPrevButton:function(){return 0!==this.activeTabIndex},stepPercentage:function(){return 1/(2*this.tabCount)*100},progressBarStyle:function(){return{backgroundColor:this.color,width:this.progress+"%",color:this.color}},fillButtonStyle:function(){return{backgroundColor:this.color,borderColor:this.color,color:"white"}},progress:function(){return this.activeTabIndex>0?this.stepPercentage*(2*this.activeTabIndex+1):this.stepPercentage}},methods:{emitTabChange:function(t,e){this.$emit("on-change",t,e),this.$emit("update:startIndex",e)},addTab:function(t){var e=this.$slots.default.indexOf(t.$vnode);t.tabId=""+t.title.replace(/ /g,"")+e,this.tabs.splice(e,0,t),e<this.activeTabIndex+1&&(this.maxStep=e,this.changeTab(this.activeTabIndex+1,e))},removeTab:function(t){var e=this.tabs,a=e.indexOf(t);a>-1&&(a===this.activeTabIndex&&(this.maxStep=this.activeTabIndex-1,this.changeTab(this.activeTabIndex,this.activeTabIndex-1)),a<this.activeTabIndex&&(this.maxStep=this.activeTabIndex-1,this.activeTabIndex=this.activeTabIndex-1,this.emitTabChange(this.activeTabIndex+1,this.activeTabIndex)),e.splice(a,1))},reset:function(){this.maxStep=0,this.tabs.forEach(function(t){t.checked=!1}),this.navigateToTab(0)},activateAll:function(){this.maxStep=this.tabs.length-1,this.tabs.forEach(function(t){t.checked=!0})},navigateToTab:function(t){var e=this,a=t>this.activeTabIndex;if(t<=this.maxStep){var n=function n(){a&&t-e.activeTabIndex>1?(e.changeTab(e.activeTabIndex,e.activeTabIndex+1),e.beforeTabChange(e.activeTabIndex,n)):(e.changeTab(e.activeTabIndex,t),e.afterTabChange(e.activeTabIndex))};a?this.beforeTabChange(this.activeTabIndex,n):(this.setValidationError(null),n())}return t<=this.maxStep},nextTab:function(){var t=this,e=function(){t.activeTabIndex<t.tabCount-1?(t.changeTab(t.activeTabIndex,t.activeTabIndex+1),t.afterTabChange(t.activeTabIndex)):t.$emit("on-complete")};this.beforeTabChange(this.activeTabIndex,e)},prevTab:function(){var t=this,e=function(){t.activeTabIndex>0&&(t.setValidationError(null),t.changeTab(t.activeTabIndex,t.activeTabIndex-1))};this.validateOnBack?this.beforeTabChange(this.activeTabIndex,e):e()},focusNextTab:function(){var t=Object(r.b)(this.tabs);if(-1!==t&&t<this.tabs.length-1){var e=this.tabs[t+1];e.checked&&Object(r.a)(e.tabId)}},focusPrevTab:function(){var t=Object(r.b)(this.tabs);if(-1!==t&&t>0){var e=this.tabs[t-1].tabId;Object(r.a)(e)}},setLoading:function(t){this.loading=t,this.$emit("on-loading",t)},setValidationError:function(t){this.tabs[this.activeTabIndex].validationError=t,this.$emit("on-error",t)},validateBeforeChange:function(t,e){var a=this;if(this.setValidationError(null),Object(r.c)(t))this.setLoading(!0),t.then(function(t){a.setLoading(!1);var n=!0===t;a.executeBeforeChange(n,e)}).catch(function(t){a.setLoading(!1),a.setValidationError(t)});else{var n=!0===t;this.executeBeforeChange(n,e)}},executeBeforeChange:function(t,e){this.$emit("on-validate",t,this.activeTabIndex),t?e():this.tabs[this.activeTabIndex].validationError="error"},beforeTabChange:function(t,e){if(!this.loading){var a=this.tabs[t];if(a&&void 0!==a.beforeChange){var n=a.beforeChange();this.validateBeforeChange(n,e)}else e()}},afterTabChange:function(t){if(!this.loading){var e=this.tabs[t];e&&void 0!==e.afterChange&&e.afterChange()}},changeTab:function(t,e){var a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],n=this.tabs[t],i=this.tabs[e];return n&&(n.active=!1),i&&(i.active=!0),a&&this.activeTabIndex!==e&&this.emitTabChange(t,e),this.activeTabIndex=e,this.activateTabAndCheckStep(this.activeTabIndex),!0},tryChangeRoute:function(t){this.$router&&t.route&&this.$router.push(t.route)},checkRouteChange:function(t){var e=-1,a=this.tabs.find(function(a,n){var i=a.route===t;return i&&(e=n),i});if(a&&!a.active){var n=e>this.activeTabIndex;this.navigateToTab(e,n)}},deactivateTabs:function(){this.tabs.forEach(function(t){t.active=!1})},activateTab:function(t){this.deactivateTabs();var e=this.tabs[t];e&&(e.active=!0,e.checked=!0,this.tryChangeRoute(e))},activateTabAndCheckStep:function(t){this.activateTab(t),t>this.maxStep&&(this.maxStep=t),this.activeTabIndex=t},initializeTabs:function(){this.tabs.length>0&&0===this.startIndex&&this.activateTab(this.activeTabIndex),this.startIndex<this.tabs.length?this.activateTabAndCheckStep(this.startIndex):window.console.warn("Prop startIndex set to "+this.startIndex+" is greater than the number of tabs - "+this.tabs.length+". Make sure that the starting index is less than the number of tabs registered")}},mounted:function(){this.initializeTabs()},watch:{"$route.path":function(t){this.checkRouteChange(t)}}}},function(t,e,a){"use strict";function n(t){a(10)}var i=a(3),r=a(11),s=a(0),o=n,c=s(i.a,r.a,!1,o,null,null);e.a=c.exports},function(t,e,a){"use strict";e.a={}},function(t,e,a){"use strict";function n(t){a(12)}var i=a(5),r=a(13),s=a(0),o=n,c=s(i.a,r.a,!1,o,null,null);e.a=c.exports},function(t,e,a){"use strict";e.a={name:"wizard-step",props:{tab:{type:Object,default:function(){}},transition:{type:String,default:""},index:{type:Number,default:0}},computed:{iconActiveStyle:function(){return{backgroundColor:this.tab.color}},stepCheckedStyle:function(){return{borderColor:this.tab.color}},errorStyle:function(){return{borderColor:this.tab.errorColor,backgroundColor:this.tab.errorColor}},stepTitleStyle:function(){return{color:this.tab.validationError?this.tab.errorColor:this.tab.color}},isStepSquare:function(){return"square"===this.tab.shape},isTabShape:function(){return"tab"===this.tab.shape}}}},function(t,e,a){"use strict";e.a={name:"tab-content",props:{title:{type:String,default:""},icon:{type:String,default:""},beforeChange:{type:Function},afterChange:{type:Function},route:{type:[String,Object]},additionalInfo:{type:Object,default:function(){}}},inject:["addTab","removeTab"],data:function(){return{active:!1,validationError:null,checked:!1,tabId:""}},computed:{shape:function(){return this.$parent.shape},color:function(){return this.$parent.color},errorColor:function(){return this.$parent.errorColor}},mounted:function(){this.addTab(this)},destroyed:function(){this.$el&&this.$el.parentNode&&this.$el.parentNode.removeChild(this.$el),this.removeTab(this)}}},function(t,e,a){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n=a(8),i=a(16),r=a(2),s=a(4);a.d(e,"FormWizard",function(){return n.a}),a.d(e,"TabContent",function(){return i.a}),a.d(e,"WizardButton",function(){return r.a}),a.d(e,"WizardStep",function(){return s.a});var o={install:function(t){t.component("form-wizard",n.a),t.component("tab-content",i.a),t.component("wizard-button",r.a),t.component("wizard-step",s.a)}};"undefined"!=typeof window&&window.Vue&&window.Vue.use(o),e.default=o},function(t,e,a){"use strict";function n(t){a(9)}var i=a(1),r=a(15),s=a(0),o=n,c=s(i.a,r.a,!1,o,null,null);e.a=c.exports},function(t,e){},function(t,e){},function(t,e,a){"use strict";var n=function(){var t=this,e=t.$createElement;return(t._self._c||e)("button",{staticClass:"wizard-btn",attrs:{tabindex:"-1",type:"button"}},[t._t("default")],2)},i=[],r={render:n,staticRenderFns:i};e.a=r},function(t,e){},function(t,e,a){"use strict";var n=function(){var t=this,e=t.$createElement,a=t._self._c||e;return a("li",{class:{active:t.tab.active}},[a("a",{class:{disabled:!t.tab.checked},attrs:{href:"javascript:void(0)"}},[a("div",{staticClass:"wizard-icon-circle md",class:{checked:t.tab.checked,square_shape:t.isStepSquare,tab_shape:t.isTabShape},style:[t.tab.checked?t.stepCheckedStyle:{},t.tab.validationError?t.errorStyle:{}],attrs:{role:"tab",tabindex:t.tab.checked?0:"",id:"step-"+t.tab.tabId,"aria-controls":t.tab.tabId,"aria-disabled":t.tab.active,"aria-selected":t.tab.active}},[a("transition",{attrs:{name:t.transition,mode:"out-in"}},[t.tab.active?a("div",{staticClass:"wizard-icon-container",class:{square_shape:t.isStepSquare,tab_shape:t.isTabShape},style:[t.tab.active?t.iconActiveStyle:{},t.tab.validationError?t.errorStyle:{}]},[t._t("active-step",[t.tab.icon?a("i",{staticClass:"wizard-icon",class:t.tab.icon}):a("i",{staticClass:"wizard-icon"},[t._v(t._s(t.index+1))])])],2):t._e(),t._v(" "),t.tab.active?t._e():t._t("default",[!t.tab.active&&t.tab.icon?a("i",{staticClass:"wizard-icon",class:t.tab.icon}):t._e(),t._v(" "),t.tab.active||t.tab.icon?t._e():a("i",{staticClass:"wizard-icon"},[t._v(t._s(t.index+1))])])],2)],1),t._v(" "),t._t("title",[a("span",{staticClass:"stepTitle",class:{active:t.tab.active,has_error:t.tab.validationError},style:t.tab.active?t.stepTitleStyle:{}},[t._v("\n            "+t._s(t.tab.title)+"\n      ")])])],2)])},i=[],r={render:n,staticRenderFns:i};e.a=r},function(t,e,a){"use strict";function n(){return document.activeElement.id}function i(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=n();return t.findIndex(function(t){return t.tabId===e})}function r(t){document.getElementById(t).focus()}function s(t){return t.then&&"function"==typeof t.then}e.b=i,e.a=r,e.c=s},function(t,e,a){"use strict";var n=function(){var t=this,e=t.$createElement,a=t._self._c||e;return a("div",{staticClass:"vue-form-wizard",class:[t.stepSize,{vertical:t.isVertical}],on:{keyup:[function(e){return"button"in e||!t._k(e.keyCode,"right",39,e.key)?"button"in e&&2!==e.button?null:void t.focusNextTab(e):null},function(e){return"button"in e||!t._k(e.keyCode,"left",37,e.key)?"button"in e&&0!==e.button?null:void t.focusPrevTab(e):null}]}},[a("div",{staticClass:"wizard-header"},[t._t("title",[a("h4",{staticClass:"wizard-title"},[t._v(t._s(t.title))]),t._v(" "),a("p",{staticClass:"category"},[t._v(t._s(t.subtitle))])])],2),t._v(" "),a("div",{staticClass:"wizard-navigation"},[t.isVertical?t._e():a("div",{staticClass:"wizard-progress-with-circle"},[a("div",{staticClass:"wizard-progress-bar",style:t.progressBarStyle})]),t._v(" "),a("ul",{staticClass:"wizard-nav wizard-nav-pills",class:t.stepsClasses,attrs:{role:"tablist"}},[t._l(t.tabs,function(e,n){return t._t("step",[a("wizard-step",{attrs:{tab:e,"step-size":t.stepSize,transition:t.transition,index:n},nativeOn:{click:function(e){t.navigateToTab(n)},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"enter",13,e.key))return null;t.navigateToTab(n)}}})],{tab:e,index:n,navigateToTab:t.navigateToTab,stepSize:t.stepSize,transition:t.transition})})],2),t._v(" "),a("div",{staticClass:"wizard-tab-content"},[t._t("default",null,null,t.slotProps)],2)]),t._v(" "),t.hideButtons?t._e():a("div",{staticClass:"wizard-card-footer clearfix"},[t._t("footer",[a("div",{staticClass:"wizard-footer-left"},[t.displayPrevButton?a("span",{attrs:{role:"button",tabindex:"0"},on:{click:t.prevTab,keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"enter",13,e.key))return null;t.prevTab(e)}}},[t._t("prev",[a("wizard-button",{style:t.fillButtonStyle,attrs:{disabled:t.loading}},[t._v("\n              "+t._s(t.backButtonText)+"\n            ")])],null,t.slotProps)],2):t._e(),t._v(" "),t._t("custom-buttons-left",null,null,t.slotProps)],2),t._v(" "),a("div",{staticClass:"wizard-footer-right"},[t._t("custom-buttons-right",null,null,t.slotProps),t._v(" "),t.isLastStep?a("span",{attrs:{role:"button",tabindex:"0"},on:{click:t.nextTab,keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"enter",13,e.key))return null;t.nextTab(e)}}},[t._t("finish",[a("wizard-button",{style:t.fillButtonStyle},[t._v("\n              "+t._s(t.finishButtonText)+"\n            ")])],null,t.slotProps)],2):a("span",{attrs:{role:"button",tabindex:"0"},on:{click:t.nextTab,keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"enter",13,e.key))return null;t.nextTab(e)}}},[t._t("next",[a("wizard-button",{style:t.fillButtonStyle,attrs:{disabled:t.loading}},[t._v("\n            "+t._s(t.nextButtonText)+"\n           ")])],null,t.slotProps)],2)],2)],null,t.slotProps)],2)])},i=[],r={render:n,staticRenderFns:i};e.a=r},function(t,e,a){"use strict";var n=a(6),i=a(17),r=a(0),s=r(n.a,i.a,!1,null,null,null);e.a=s.exports},function(t,e,a){"use strict";var n=function(){var t=this,e=t.$createElement;return(t._self._c||e)("div",{directives:[{name:"show",rawName:"v-show",value:t.active,expression:"active"}],staticClass:"wizard-tab-container",attrs:{role:"tabpanel",id:t.tabId,"aria-hidden":!t.active,"aria-labelledby":"step-"+t.tabId}},[t._t("default",null,{active:t.active})],2)},i=[],r={render:n,staticRenderFns:i};e.a=r}])});

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(130);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0434a17b", content, true, {});

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".vue-form-wizard .wizard-btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;-ms-touch-action:manipulation;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857;border-radius:4px}.vue-form-wizard .wizard-btn.disabled,.vue-form-wizard .wizard-btn[disabled],fieldset[disabled] .vue-form-wizard .wizard-btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);-webkit-box-shadow:none;box-shadow:none}.vue-form-wizard *{-webkit-box-sizing:border-box;box-sizing:border-box}.vue-form-wizard a{text-decoration:none}.vue-form-wizard .wizard-nav{margin-bottom:0;padding-left:0;list-style:none}.vue-form-wizard .wizard-nav>li{position:relative;display:block}.vue-form-wizard .wizard-nav>li>a{position:relative;display:block;padding:10px 15px}.vue-form-wizard .wizard-nav>li>a:focus,.vue-form-wizard .wizard-nav>li>a:hover{text-decoration:none;background-color:#eee}.vue-form-wizard .wizard-nav>li.disabled>a{color:#777}.vue-form-wizard .wizard-nav>li.disabled>a:focus,.vue-form-wizard .wizard-nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.vue-form-wizard .wizard-progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;-webkit-box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);-webkit-transition:width .6s ease;transition:width .6s ease}.vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn,.vue-form-wizard .wizard-btn{-webkit-box-sizing:border-box;box-sizing:border-box;border-width:2px;background-color:transparent;font-size:14px;font-weight:600;padding:6px 12px;min-width:140px}.vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn:focus,.vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn:hover,.vue-form-wizard .wizard-btn:focus,.vue-form-wizard .wizard-btn:hover{outline:0!important}.vue-form-wizard .wizard-nav-pills{margin-top:0;position:relative;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.vue-form-wizard .wizard-nav-pills a,.vue-form-wizard .wizard-nav-pills li{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-positive:1;flex-grow:1}.vue-form-wizard .wizard-nav-pills>li>a,.vue-form-wizard .wizard-nav-pills a{display:-webkit-box;display:-ms-flexbox;display:flex}.vue-form-wizard .wizard-nav-pills>li>a{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0;margin:0 auto;color:rgba(0,0,0,.2);position:relative;top:3px}.vue-form-wizard .wizard-nav-pills>li>a:focus,.vue-form-wizard .wizard-nav-pills>li>a:hover{background-color:transparent;color:rgba(0,0,0,.2);outline:0!important}.vue-form-wizard .wizard-nav-pills>li>a.disabled{pointer-events:none;cursor:default}.vue-form-wizard .wizard-nav-pills>li.active>a,.vue-form-wizard .wizard-nav-pills>li.active>a:focus,.vue-form-wizard .wizard-nav-pills>li.active>a:hover{background-color:transparent;-webkit-transition:font-size .2s linear;transition:font-size .2s linear}.vue-form-wizard .wizard-nav-pills>li.active>a .wizard-icon,.vue-form-wizard .wizard-nav-pills>li.active>a:focus .wizard-icon,.vue-form-wizard .wizard-nav-pills>li.active>a:hover .wizard-icon{color:#fff;font-size:24px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transition:all .2s linear;transition:all .2s linear}.vue-form-wizard{padding-bottom:20px}.vue-form-wizard .is_error{border-color:#c84513!important}.vue-form-wizard .is_error .icon-container{background:#c84513!important}.vue-form-wizard.xs .wizard-icon-circle{width:40px;height:40px;font-size:16px}.vue-form-wizard.xs .wizard-icon-circle.tab_shape{height:25px}.vue-form-wizard.xs .wizard-nav-pills>li.active>a .wizard-icon{font-size:16px}.vue-form-wizard.xs .wizard-navigation .wizard-progress-with-circle{position:relative;top:25px;height:4px}.vue-form-wizard.sm .wizard-icon-circle{width:50px;height:50px;font-size:20px}.vue-form-wizard.sm .wizard-icon-circle.tab_shape{height:30px}.vue-form-wizard.sm .wizard-nav-pills>li.active>a .wizard-icon{font-size:20px}.vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle{position:relative;top:30px;height:4px}.vue-form-wizard.md .wizard-icon-circle{width:70px;height:70px;font-size:24px}.vue-form-wizard.md .wizard-icon-circle.tab_shape{height:40px}.vue-form-wizard.md .wizard-nav-pills>li.active>a .wizard-icon{font-size:24px}.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle{position:relative;top:40px;height:4px}.vue-form-wizard.lg .wizard-icon-circle{width:90px;height:90px;font-size:28px}.vue-form-wizard.lg .wizard-icon-circle.tab_shape{height:50px}.vue-form-wizard.lg .wizard-nav-pills>li.active>a .wizard-icon{font-size:28px}.vue-form-wizard.lg .wizard-navigation .wizard-progress-with-circle{position:relative;top:50px;height:4px}.vue-form-wizard .wizard-icon-circle{font-size:18px;border:3px solid #f3f2ee;border-radius:50%;font-weight:600;width:70px;height:70px;background-color:#fff;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-line-pack:center;align-content:center}.vue-form-wizard .wizard-icon-circle.square_shape{border-radius:0}.vue-form-wizard .wizard-icon-circle.tab_shape{width:100%;min-width:100px;height:40px;border:none;background-color:#f3f2ee;border-radius:0}.vue-form-wizard .wizard-icon-circle .wizard-icon-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-flex:1;-ms-flex:1;flex:1;border-radius:40%}.vue-form-wizard .wizard-icon-circle .wizard-icon-container.square_shape,.vue-form-wizard .wizard-icon-circle .wizard-icon-container.tab_shape{border-radius:0}.vue-form-wizard .wizard-icon-circle .wizard-icon{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.vue-form-wizard .wizard-tab-content{min-height:100px;padding:30px 20px 10px}.vue-form-wizard .wizard-header{padding:15px;position:relative;border-radius:3px 3px 0 0;text-align:center}.vue-form-wizard .wizard-title{color:#252422;font-weight:300;margin:0;text-align:center}.vue-form-wizard .category{font-size:14px;font-weight:400;color:#9a9a9a;margin-bottom:0;text-align:center}.vue-form-wizard .wizard-navigation .wizard-progress-with-circle{position:relative;top:40px;height:4px}.vue-form-wizard .wizard-navigation .wizard-progress-with-circle .wizard-progress-bar{-webkit-box-shadow:none;box-shadow:none;-webkit-transition:width .3s ease;transition:width .3s ease}.vue-form-wizard .clearfix:after{content:\"\";clear:both;display:table}.vue-form-wizard .wizard-card-footer{padding:0 20px}.vue-form-wizard .wizard-card-footer .wizard-footer-left{float:left}.vue-form-wizard .wizard-card-footer .wizard-footer-right{float:right}@media screen and (max-width:350px){.vue-form-wizard .wizard-card-footer{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vue-form-wizard .wizard-card-footer .wizard-footer-left,.vue-form-wizard .wizard-card-footer .wizard-footer-right{float:none;-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.vue-form-wizard .wizard-card-footer .wizard-footer-right button{margin-top:10px}}.vue-form-wizard.vertical .wizard-card-footer{display:block}.vue-form-wizard.vertical .wizard-nav-pills{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.vue-form-wizard.vertical .wizard-navigation{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.vue-form-wizard.vertical .wizard-card-footer{padding-top:30px}", ""]);

// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueSelect=e():t.VueSelect=e()}("undefined"!=typeof self?self:this,(function(){return function(t){var e={};function n(o){if(e[o])return e[o].exports;var i=e[o]={i:o,l:!1,exports:{}};return t[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,o){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:o})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(o,i,function(e){return t[e]}.bind(null,i));return o},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=8)}([function(t,e,n){var o=n(4),i=n(5),s=n(6);t.exports=function(t){return o(t)||i(t)||s()}},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n},function(t,e,n){},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(t,e,n){"use strict";var o=n(2);n.n(o).a},function(t,e,n){"use strict";n.r(e);var o=n(0),i=n.n(o),s=n(1),r=n.n(s),a=n(3),l=n.n(a),c={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll()}},methods:{maybeAdjustScroll:function(){var t,e=(null===(t=this.$refs.dropdownMenu)||void 0===t?void 0:t.children[this.typeAheadPointer])||!1;if(e){var n=this.getDropdownViewport(),o=e.getBoundingClientRect(),i=o.top,s=o.bottom,r=o.height;if(i<n.top)return this.$refs.dropdownMenu.scrollTop=e.offsetTop;if(s>n.bottom)return this.$refs.dropdownMenu.scrollTop=e.offsetTop-(n.height-r)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},u={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var t=0;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}}},methods:{typeAheadUp:function(){for(var t=this.typeAheadPointer-1;t>=0;t--)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadDown:function(){for(var t=this.typeAheadPointer+1;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadSelect:function(){var t=this.filteredOptions[this.typeAheadPointer];t&&this.select(t)}}},p={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(t){this.mutableLoading=t}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function h(t,e,n,o,i,s,r,a){var l,c="function"==typeof t?t.options:t;if(e&&(c.render=e,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),s&&(c._scopeId="data-v-"+s),r?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},c._ssrRegister=l):i&&(l=a?function(){i.call(this,this.$root.$options.shadowRoot)}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(t,e){return l.call(e),u(t,e)}}else{var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,l):[l]}return{exports:t,options:c}}var d={Deselect:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])}),[],!1,null,null,null).exports,OpenIndicator:h({},(function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])}),[],!1,null,null,null).exports},f={inserted:function(t,e,n){var o=n.context;if(o.appendToBody){var i=o.$refs.toggle.getBoundingClientRect(),s=i.height,r=i.top,a=i.left,l=i.width,c=window.scrollX||window.pageXOffset,u=window.scrollY||window.pageYOffset;t.unbindPosition=o.calculatePosition(t,o,{width:l+"px",left:c+a+"px",top:u+r+s+"px"}),document.body.appendChild(t)}},unbind:function(t,e,n){n.context.appendToBody&&(t.unbindPosition&&"function"==typeof t.unbindPosition&&t.unbindPosition(),t.parentNode&&t.parentNode.removeChild(t))}};var y=function(t){var e={};return Object.keys(t).sort().forEach((function(n){e[n]=t[n]})),JSON.stringify(e)},b=0;var g=function(){return++b};function v(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);e&&(o=o.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),n.push.apply(n,o)}return n}function m(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?v(Object(n),!0).forEach((function(e){l()(t,e,n[e])})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):v(Object(n)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))}))}return t}var _={components:m({},d),mixins:[c,u,p],directives:{appendToBody:f},props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},selectable:{type:Function,default:function(t){return!0}},getOptionLabel:{type:Function,default:function(t){return"object"===r()(t)?t.hasOwnProperty(this.label)?t[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(t),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):t}},getOptionKey:{type:Function,default:function(t){if("object"!==r()(t))return t;try{return t.hasOwnProperty("id")?t.id:y(t)}catch(e){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",t,e)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return(e||"").toLowerCase().indexOf(n.toLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter((function(t){var o=n.getOptionLabel(t);return"number"==typeof o&&(o=o.toString()),n.filterBy(t,o,e)}))}},createOption:{type:Function,default:function(t){return"object"===r()(this.optionList[0])?l()({},this.label,t):t}},resetOnOptionsChange:{default:!1,validator:function(t){return["function","boolean"].includes(r()(t))}},clearSearchOnBlur:{type:Function,default:function(t){var e=t.clearSearchOnSelect,n=t.multiple;return e&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return[13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(t,e){return t}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(t,e,n){var o=n.width,i=n.top,s=n.left;t.style.top=i,t.style.left=s,t.style.width=o}},dropdownShouldOpen:{type:Function,default:function(t){var e=t.noDrop,n=t.open,o=t.mutableLoading;return!e&&(n&&!o)}}},data:function(){return{uid:g(),search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},watch:{options:function(t,e){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(t,e,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value)},value:function(t){this.isTrackingValues&&this.setInternalValueFromOptions(t)},multiple:function(){this.clearSelection()},open:function(t){this.$emit(t?"open":"close")}},created:function(){this.mutableLoading=this.loading,void 0!==this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value),this.$on("option:created",this.pushTag)},methods:{setInternalValueFromOptions:function(t){var e=this;Array.isArray(t)?this.$data._value=t.map((function(t){return e.findOptionFromReducedValue(t)})):this.$data._value=this.findOptionFromReducedValue(t)},select:function(t){this.$emit("option:selecting",t),this.isOptionSelected(t)||(this.taggable&&!this.optionExists(t)&&this.$emit("option:created",t),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t),this.$emit("option:selected",t)),this.onAfterSelect(t)},deselect:function(t){var e=this;this.$emit("option:deselecting",t),this.updateValue(this.selectedValue.filter((function(n){return!e.optionComparator(n,t)}))),this.$emit("option:deselected",t)},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="")},updateValue:function(t){var e=this;void 0===this.value&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map((function(t){return e.reduce(t)})):this.reduce(t)),this.$emit("input",t)},toggleDropdown:function(t){var e=t.target!==this.searchEl;e&&t.preventDefault();var n=[].concat(i()(this.$refs.deselectButtons||[]),i()([this.$refs.clearButton]||!1));void 0===this.searchEl||n.filter(Boolean).some((function(e){return e.contains(t.target)||e===t.target}))?t.preventDefault():this.open&&e?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus())},isOptionSelected:function(t){var e=this;return this.selectedValue.some((function(n){return e.optionComparator(n,t)}))},optionComparator:function(t,e){return this.getOptionKey(t)===this.getOptionKey(e)},findOptionFromReducedValue:function(t){var e=this,n=[].concat(i()(this.options),i()(this.pushedTags)).filter((function(n){return JSON.stringify(e.reduce(n))===JSON.stringify(t)}));return 1===n.length?n[0]:n.find((function(t){return e.optionComparator(t,e.$data._value)}))||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var t=null;this.multiple&&(t=i()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t)}},optionExists:function(t){var e=this;return this.optionList.some((function(n){return e.optionComparator(n,t)}))},normalizeOptionForSlot:function(t){return"object"===r()(t)?t:l()({},this.label,t)},pushTag:function(t){this.pushedTags.push(t)},onEscape:function(){this.search.length?this.search="":this.searchEl.blur()},onSearchBlur:function(){if(!this.mousedown||this.searching){var t=this.clearSearchOnSelect,e=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:t,multiple:e})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(t){var e=this,n=function(t){return t.preventDefault(),!e.isComposing&&e.typeAheadSelect()},o={8:function(t){return e.maybeDeleteValue()},9:function(t){return e.onTab()},27:function(t){return e.onEscape()},38:function(t){return t.preventDefault(),e.typeAheadUp()},40:function(t){return t.preventDefault(),e.typeAheadDown()}};this.selectOnKeyCodes.forEach((function(t){return o[t]=n}));var i=this.mapKeydown(o,this);if("function"==typeof i[t.keyCode])return i[t.keyCode](t)}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this,e={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return{search:{attributes:m({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return t.isComposing=!0},compositionend:function(){return t.isComposing=!1},keydown:this.onSearchKeyDown,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.mutableLoading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:e,listFooter:e,header:m({},e,{deselect:this.deselect}),footer:m({},e,{deselect:this.deselect})}},childComponents:function(){return m({},d,{},this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return!!this.search},dropdownOpen:function(){return this.dropdownShouldOpen(this)},searchPlaceholder:function(){if(this.isValueEmpty&&this.placeholder)return this.placeholder},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||e.unshift(n)}return e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}}},O=(n(7),h(_,(function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[t._t("header",null,null,t.scope.header),t._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+t.uid+"__combobox",role:"combobox","aria-expanded":t.dropdownOpen.toString(),"aria-owns":"vs"+t.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(e){return t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,(function(e){return t._t("selected-option-container",[n("span",{key:t.getOptionKey(e),staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button",title:"Deselect "+t.getOptionLabel(e),"aria-label":"Deselect "+t.getOptionLabel(e)},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})})),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+t.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+t.uid+"__listbox",role:"listbox",tabindex:"-1"},on:{mousedown:function(e){return e.preventDefault(),t.onMousedown(e)},mouseup:t.onMouseUp}},[t._t("list-header",null,null,t.scope.listHeader),t._v(" "),t._l(t.filteredOptions,(function(e,o){return n("li",{key:t.getOptionKey(e),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":o===t.typeAheadPointer,"vs__dropdown-option--disabled":!t.selectable(e)},attrs:{role:"option",id:"vs"+t.uid+"__option-"+o,"aria-selected":o===t.typeAheadPointer||null},on:{mouseover:function(n){t.selectable(e)&&(t.typeAheadPointer=o)},mousedown:function(n){n.preventDefault(),n.stopPropagation(),t.selectable(e)&&t.select(e)}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)})),t._v(" "),0===t.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[t._t("no-options",[t._v("Sorry, no matching options.")],null,t.scope.noOptions)],2):t._e(),t._v(" "),t._t("list-footer",null,null,t.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"}})]),t._v(" "),t._t("footer",null,null,t.scope.footer)],2)}),[],!1,null,null,null).exports),w={ajax:p,pointer:u,pointerScroll:c};n.d(e,"VueSelect",(function(){return O})),n.d(e,"mixins",(function(){return w}));e.default=O}])}));
//# sourceMappingURL=vue-select.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(133);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("575941b1", content, true, {});

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".v-select{position:relative;font-family:inherit}.v-select,.v-select *{box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{pointer-events:none;transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:0 0 4px;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:flex;flex-basis:100%;flex-grow:1;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:flex;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);transform:scale(1);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;box-sizing:border-box;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap}.vs__dropdown-option:hover{cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__dropdown-option--disabled{background:inherit;color:rgba(60,60,60,.5)}.vs__dropdown-option--disabled:hover{cursor:inherit}.vs__selected{display:flex;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em;z-index:0}.vs__deselect{display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:none;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-webkit-search-cancel-button{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:none;margin:4px 0 0;padding:0 7px;background:none;box-shadow:none;width:0;max-width:100%;flex-grow:1;z-index:1}.vs__search::-webkit-input-placeholder{color:inherit}.vs__search::-moz-placeholder{color:inherit}.vs__search:-ms-input-placeholder,.vs__search::-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable:not(.vs--disabled) .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid rgba(99,99,99,.1);border-left-color:rgba(60,60,60,.45);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}", ""]);

// exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.VueMultiselect=e():t.VueMultiselect=e()}(this,function(){return function(t){function e(i){if(n[i])return n[i].exports;var r=n[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t,n,i){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="/",e(e.s=60)}([function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e,n){var i=n(49)("wks"),r=n(30),o=n(0).Symbol,s="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=s&&o[t]||(s?o:r)("Symbol."+t))}).store=i},function(t,e,n){var i=n(5);t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var i=n(0),r=n(10),o=n(8),s=n(6),u=n(11),a=function(t,e,n){var l,c,f,p,h=t&a.F,d=t&a.G,v=t&a.S,g=t&a.P,y=t&a.B,m=d?i:v?i[e]||(i[e]={}):(i[e]||{}).prototype,b=d?r:r[e]||(r[e]={}),_=b.prototype||(b.prototype={});d&&(n=e);for(l in n)c=!h&&m&&void 0!==m[l],f=(c?m:n)[l],p=y&&c?u(f,i):g&&"function"==typeof f?u(Function.call,f):f,m&&s(m,l,f,t&a.U),b[l]!=f&&o(b,l,p),g&&_[l]!=f&&(_[l]=f)};i.core=r,a.F=1,a.G=2,a.S=4,a.P=8,a.B=16,a.W=32,a.U=64,a.R=128,t.exports=a},function(t,e,n){t.exports=!n(7)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var i=n(0),r=n(8),o=n(12),s=n(30)("src"),u=Function.toString,a=(""+u).split("toString");n(10).inspectSource=function(t){return u.call(t)},(t.exports=function(t,e,n,u){var l="function"==typeof n;l&&(o(n,"name")||r(n,"name",e)),t[e]!==n&&(l&&(o(n,s)||r(n,s,t[e]?""+t[e]:a.join(String(e)))),t===i?t[e]=n:u?t[e]?t[e]=n:r(t,e,n):(delete t[e],r(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[s]||u.call(this)})},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var i=n(13),r=n(25);t.exports=n(4)?function(t,e,n){return i.f(t,e,r(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e){var n=t.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(t,e,n){var i=n(14);t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,r){return t.call(e,n,i,r)}}return function(){return t.apply(e,arguments)}}},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var i=n(2),r=n(41),o=n(29),s=Object.defineProperty;e.f=n(4)?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),r)try{return s(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports={}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e,n){"use strict";var i=n(7);t.exports=function(t,e){return!!t&&i(function(){e?t.call(null,function(){},1):t.call(null)})}},function(t,e,n){var i=n(23),r=n(16);t.exports=function(t){return i(r(t))}},function(t,e,n){var i=n(53),r=Math.min;t.exports=function(t){return t>0?r(i(t),9007199254740991):0}},function(t,e,n){var i=n(11),r=n(23),o=n(28),s=n(19),u=n(64);t.exports=function(t,e){var n=1==t,a=2==t,l=3==t,c=4==t,f=6==t,p=5==t||f,h=e||u;return function(e,u,d){for(var v,g,y=o(e),m=r(y),b=i(u,d,3),_=s(m.length),x=0,w=n?h(e,_):a?h(e,0):void 0;_>x;x++)if((p||x in m)&&(v=m[x],g=b(v,x,y),t))if(n)w[x]=g;else if(g)switch(t){case 3:return!0;case 5:return v;case 6:return x;case 2:w.push(v)}else if(c)return!1;return f?-1:l||c?c:w}}},function(t,e,n){var i=n(5),r=n(0).document,o=i(r)&&i(r.createElement);t.exports=function(t){return o?r.createElement(t):{}}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var i=n(9);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},function(t,e){t.exports=!1},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e,n){var i=n(13).f,r=n(12),o=n(1)("toStringTag");t.exports=function(t,e,n){t&&!r(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},function(t,e,n){var i=n(49)("keys"),r=n(30);t.exports=function(t){return i[t]||(i[t]=r(t))}},function(t,e,n){var i=n(16);t.exports=function(t){return Object(i(t))}},function(t,e,n){var i=n(5);t.exports=function(t,e){if(!i(t))return t;var n,r;if(e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;if("function"==typeof(n=t.valueOf)&&!i(r=n.call(t)))return r;if(!e&&"function"==typeof(n=t.toString)&&!i(r=n.call(t)))return r;throw TypeError("Can't convert object to primitive value")}},function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},function(t,e,n){"use strict";var i=n(0),r=n(12),o=n(9),s=n(67),u=n(29),a=n(7),l=n(77).f,c=n(45).f,f=n(13).f,p=n(51).trim,h=i.Number,d=h,v=h.prototype,g="Number"==o(n(44)(v)),y="trim"in String.prototype,m=function(t){var e=u(t,!1);if("string"==typeof e&&e.length>2){e=y?e.trim():p(e,3);var n,i,r,o=e.charCodeAt(0);if(43===o||45===o){if(88===(n=e.charCodeAt(2))||120===n)return NaN}else if(48===o){switch(e.charCodeAt(1)){case 66:case 98:i=2,r=49;break;case 79:case 111:i=8,r=55;break;default:return+e}for(var s,a=e.slice(2),l=0,c=a.length;l<c;l++)if((s=a.charCodeAt(l))<48||s>r)return NaN;return parseInt(a,i)}}return+e};if(!h(" 0o1")||!h("0b1")||h("+0x1")){h=function(t){var e=arguments.length<1?0:t,n=this;return n instanceof h&&(g?a(function(){v.valueOf.call(n)}):"Number"!=o(n))?s(new d(m(e)),n,h):m(e)};for(var b,_=n(4)?l(d):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),x=0;_.length>x;x++)r(d,b=_[x])&&!r(h,b)&&f(h,b,c(d,b));h.prototype=v,v.constructor=h,n(6)(i,"Number",h)}},function(t,e,n){"use strict";function i(t){return 0!==t&&(!(!Array.isArray(t)||0!==t.length)||!t)}function r(t){return function(){return!t.apply(void 0,arguments)}}function o(t,e){return void 0===t&&(t="undefined"),null===t&&(t="null"),!1===t&&(t="false"),-1!==t.toString().toLowerCase().indexOf(e.trim())}function s(t,e,n,i){return t.filter(function(t){return o(i(t,n),e)})}function u(t){return t.filter(function(t){return!t.$isLabel})}function a(t,e){return function(n){return n.reduce(function(n,i){return i[t]&&i[t].length?(n.push({$groupLabel:i[e],$isLabel:!0}),n.concat(i[t])):n},[])}}function l(t,e,i,r,o){return function(u){return u.map(function(u){var a;if(!u[i])return console.warn("Options passed to vue-multiselect do not contain groups, despite the config."),[];var l=s(u[i],t,e,o);return l.length?(a={},n.i(d.a)(a,r,u[r]),n.i(d.a)(a,i,l),a):[]})}}var c=n(59),f=n(54),p=(n.n(f),n(95)),h=(n.n(p),n(31)),d=(n.n(h),n(58)),v=n(91),g=(n.n(v),n(98)),y=(n.n(g),n(92)),m=(n.n(y),n(88)),b=(n.n(m),n(97)),_=(n.n(b),n(89)),x=(n.n(_),n(96)),w=(n.n(x),n(93)),S=(n.n(w),n(90)),O=(n.n(S),function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return function(t){return e.reduce(function(t,e){return e(t)},t)}});e.a={data:function(){return{search:"",isOpen:!1,preferredOpenDirection:"below",optimizedHeight:this.maxHeight}},props:{internalSearch:{type:Boolean,default:!0},options:{type:Array,required:!0},multiple:{type:Boolean,default:!1},value:{type:null,default:function(){return[]}},trackBy:{type:String},label:{type:String},searchable:{type:Boolean,default:!0},clearOnSelect:{type:Boolean,default:!0},hideSelected:{type:Boolean,default:!1},placeholder:{type:String,default:"Select option"},allowEmpty:{type:Boolean,default:!0},resetAfter:{type:Boolean,default:!1},closeOnSelect:{type:Boolean,default:!0},customLabel:{type:Function,default:function(t,e){return i(t)?"":e?t[e]:t}},taggable:{type:Boolean,default:!1},tagPlaceholder:{type:String,default:"Press enter to create a tag"},tagPosition:{type:String,default:"top"},max:{type:[Number,Boolean],default:!1},id:{default:null},optionsLimit:{type:Number,default:1e3},groupValues:{type:String},groupLabel:{type:String},groupSelect:{type:Boolean,default:!1},blockKeys:{type:Array,default:function(){return[]}},preserveSearch:{type:Boolean,default:!1},preselectFirst:{type:Boolean,default:!1}},mounted:function(){!this.multiple&&this.max&&console.warn("[Vue-Multiselect warn]: Max prop should not be used when prop Multiple equals false."),this.preselectFirst&&!this.internalValue.length&&this.options.length&&this.select(this.filteredOptions[0])},computed:{internalValue:function(){return this.value||0===this.value?Array.isArray(this.value)?this.value:[this.value]:[]},filteredOptions:function(){var t=this.search||"",e=t.toLowerCase().trim(),n=this.options.concat();return n=this.internalSearch?this.groupValues?this.filterAndFlat(n,e,this.label):s(n,e,this.label,this.customLabel):this.groupValues?a(this.groupValues,this.groupLabel)(n):n,n=this.hideSelected?n.filter(r(this.isSelected)):n,this.taggable&&e.length&&!this.isExistingOption(e)&&("bottom"===this.tagPosition?n.push({isTag:!0,label:t}):n.unshift({isTag:!0,label:t})),n.slice(0,this.optionsLimit)},valueKeys:function(){var t=this;return this.trackBy?this.internalValue.map(function(e){return e[t.trackBy]}):this.internalValue},optionKeys:function(){var t=this;return(this.groupValues?this.flatAndStrip(this.options):this.options).map(function(e){return t.customLabel(e,t.label).toString().toLowerCase()})},currentOptionLabel:function(){return this.multiple?this.searchable?"":this.placeholder:this.internalValue.length?this.getOptionLabel(this.internalValue[0]):this.searchable?"":this.placeholder}},watch:{internalValue:function(){this.resetAfter&&this.internalValue.length&&(this.search="",this.$emit("input",this.multiple?[]:null))},search:function(){this.$emit("search-change",this.search,this.id)}},methods:{getValue:function(){return this.multiple?this.internalValue:0===this.internalValue.length?null:this.internalValue[0]},filterAndFlat:function(t,e,n){return O(l(e,n,this.groupValues,this.groupLabel,this.customLabel),a(this.groupValues,this.groupLabel))(t)},flatAndStrip:function(t){return O(a(this.groupValues,this.groupLabel),u)(t)},updateSearch:function(t){this.search=t},isExistingOption:function(t){return!!this.options&&this.optionKeys.indexOf(t)>-1},isSelected:function(t){var e=this.trackBy?t[this.trackBy]:t;return this.valueKeys.indexOf(e)>-1},isOptionDisabled:function(t){return!!t.$isDisabled},getOptionLabel:function(t){if(i(t))return"";if(t.isTag)return t.label;if(t.$isLabel)return t.$groupLabel;var e=this.customLabel(t,this.label);return i(e)?"":e},select:function(t,e){if(t.$isLabel&&this.groupSelect)return void this.selectGroup(t);if(!(-1!==this.blockKeys.indexOf(e)||this.disabled||t.$isDisabled||t.$isLabel)&&(!this.max||!this.multiple||this.internalValue.length!==this.max)&&("Tab"!==e||this.pointerDirty)){if(t.isTag)this.$emit("tag",t.label,this.id),this.search="",this.closeOnSelect&&!this.multiple&&this.deactivate();else{if(this.isSelected(t))return void("Tab"!==e&&this.removeElement(t));this.$emit("select",t,this.id),this.multiple?this.$emit("input",this.internalValue.concat([t]),this.id):this.$emit("input",t,this.id),this.clearOnSelect&&(this.search="")}this.closeOnSelect&&this.deactivate()}},selectGroup:function(t){var e=this,n=this.options.find(function(n){return n[e.groupLabel]===t.$groupLabel});if(n)if(this.wholeGroupSelected(n)){this.$emit("remove",n[this.groupValues],this.id);var i=this.internalValue.filter(function(t){return-1===n[e.groupValues].indexOf(t)});this.$emit("input",i,this.id)}else{var r=n[this.groupValues].filter(function(t){return!(e.isOptionDisabled(t)||e.isSelected(t))});this.$emit("select",r,this.id),this.$emit("input",this.internalValue.concat(r),this.id)}},wholeGroupSelected:function(t){var e=this;return t[this.groupValues].every(function(t){return e.isSelected(t)||e.isOptionDisabled(t)})},wholeGroupDisabled:function(t){return t[this.groupValues].every(this.isOptionDisabled)},removeElement:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(!this.disabled&&!t.$isDisabled){if(!this.allowEmpty&&this.internalValue.length<=1)return void this.deactivate();var i="object"===n.i(c.a)(t)?this.valueKeys.indexOf(t[this.trackBy]):this.valueKeys.indexOf(t);if(this.$emit("remove",t,this.id),this.multiple){var r=this.internalValue.slice(0,i).concat(this.internalValue.slice(i+1));this.$emit("input",r,this.id)}else this.$emit("input",null,this.id);this.closeOnSelect&&e&&this.deactivate()}},removeLastElement:function(){-1===this.blockKeys.indexOf("Delete")&&0===this.search.length&&Array.isArray(this.internalValue)&&this.internalValue.length&&this.removeElement(this.internalValue[this.internalValue.length-1],!1)},activate:function(){var t=this;this.isOpen||this.disabled||(this.adjustPosition(),this.groupValues&&0===this.pointer&&this.filteredOptions.length&&(this.pointer=1),this.isOpen=!0,this.searchable?(this.preserveSearch||(this.search=""),this.$nextTick(function(){return t.$refs.search.focus()})):this.$el.focus(),this.$emit("open",this.id))},deactivate:function(){this.isOpen&&(this.isOpen=!1,this.searchable?this.$refs.search.blur():this.$el.blur(),this.preserveSearch||(this.search=""),this.$emit("close",this.getValue(),this.id))},toggle:function(){this.isOpen?this.deactivate():this.activate()},adjustPosition:function(){if("undefined"!=typeof window){var t=this.$el.getBoundingClientRect().top,e=window.innerHeight-this.$el.getBoundingClientRect().bottom;e>this.maxHeight||e>t||"below"===this.openDirection||"bottom"===this.openDirection?(this.preferredOpenDirection="below",this.optimizedHeight=Math.min(e-40,this.maxHeight)):(this.preferredOpenDirection="above",this.optimizedHeight=Math.min(t-40,this.maxHeight))}}}}},function(t,e,n){"use strict";var i=n(54),r=(n.n(i),n(31));n.n(r);e.a={data:function(){return{pointer:0,pointerDirty:!1}},props:{showPointer:{type:Boolean,default:!0},optionHeight:{type:Number,default:40}},computed:{pointerPosition:function(){return this.pointer*this.optionHeight},visibleElements:function(){return this.optimizedHeight/this.optionHeight}},watch:{filteredOptions:function(){this.pointerAdjust()},isOpen:function(){this.pointerDirty=!1}},methods:{optionHighlight:function(t,e){return{"multiselect__option--highlight":t===this.pointer&&this.showPointer,"multiselect__option--selected":this.isSelected(e)}},groupHighlight:function(t,e){var n=this;if(!this.groupSelect)return["multiselect__option--group","multiselect__option--disabled"];var i=this.options.find(function(t){return t[n.groupLabel]===e.$groupLabel});return i&&!this.wholeGroupDisabled(i)?["multiselect__option--group",{"multiselect__option--highlight":t===this.pointer&&this.showPointer},{"multiselect__option--group-selected":this.wholeGroupSelected(i)}]:"multiselect__option--disabled"},addPointerElement:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"Enter",e=t.key;this.filteredOptions.length>0&&this.select(this.filteredOptions[this.pointer],e),this.pointerReset()},pointerForward:function(){this.pointer<this.filteredOptions.length-1&&(this.pointer++,this.$refs.list.scrollTop<=this.pointerPosition-(this.visibleElements-1)*this.optionHeight&&(this.$refs.list.scrollTop=this.pointerPosition-(this.visibleElements-1)*this.optionHeight),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()),this.pointerDirty=!0},pointerBackward:function(){this.pointer>0?(this.pointer--,this.$refs.list.scrollTop>=this.pointerPosition&&(this.$refs.list.scrollTop=this.pointerPosition),this.filteredOptions[this.pointer]&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerBackward()):this.filteredOptions[this.pointer]&&this.filteredOptions[0].$isLabel&&!this.groupSelect&&this.pointerForward(),this.pointerDirty=!0},pointerReset:function(){this.closeOnSelect&&(this.pointer=0,this.$refs.list&&(this.$refs.list.scrollTop=0))},pointerAdjust:function(){this.pointer>=this.filteredOptions.length-1&&(this.pointer=this.filteredOptions.length?this.filteredOptions.length-1:0),this.filteredOptions.length>0&&this.filteredOptions[this.pointer].$isLabel&&!this.groupSelect&&this.pointerForward()},pointerSet:function(t){this.pointer=t,this.pointerDirty=!0}}}},function(t,e,n){"use strict";var i=n(36),r=n(74),o=n(15),s=n(18);t.exports=n(72)(Array,"Array",function(t,e){this._t=s(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,r(1)):"keys"==e?r(0,n):"values"==e?r(0,t[n]):r(0,[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},function(t,e,n){"use strict";var i=n(31),r=(n.n(i),n(32)),o=n(33);e.a={name:"vue-multiselect",mixins:[r.a,o.a],props:{name:{type:String,default:""},selectLabel:{type:String,default:"Press enter to select"},selectGroupLabel:{type:String,default:"Press enter to select group"},selectedLabel:{type:String,default:"Selected"},deselectLabel:{type:String,default:"Press enter to remove"},deselectGroupLabel:{type:String,default:"Press enter to deselect group"},showLabels:{type:Boolean,default:!0},limit:{type:Number,default:99999},maxHeight:{type:Number,default:300},limitText:{type:Function,default:function(t){return"and ".concat(t," more")}},loading:{type:Boolean,default:!1},disabled:{type:Boolean,default:!1},openDirection:{type:String,default:""},showNoOptions:{type:Boolean,default:!0},showNoResults:{type:Boolean,default:!0},tabindex:{type:Number,default:0}},computed:{isSingleLabelVisible:function(){return(this.singleValue||0===this.singleValue)&&(!this.isOpen||!this.searchable)&&!this.visibleValues.length},isPlaceholderVisible:function(){return!(this.internalValue.length||this.searchable&&this.isOpen)},visibleValues:function(){return this.multiple?this.internalValue.slice(0,this.limit):[]},singleValue:function(){return this.internalValue[0]},deselectLabelText:function(){return this.showLabels?this.deselectLabel:""},deselectGroupLabelText:function(){return this.showLabels?this.deselectGroupLabel:""},selectLabelText:function(){return this.showLabels?this.selectLabel:""},selectGroupLabelText:function(){return this.showLabels?this.selectGroupLabel:""},selectedLabelText:function(){return this.showLabels?this.selectedLabel:""},inputStyle:function(){if(this.searchable||this.multiple&&this.value&&this.value.length)return this.isOpen?{width:"100%"}:{width:"0",position:"absolute",padding:"0"}},contentStyle:function(){return this.options.length?{display:"inline-block"}:{display:"block"}},isAbove:function(){return"above"===this.openDirection||"top"===this.openDirection||"below"!==this.openDirection&&"bottom"!==this.openDirection&&"above"===this.preferredOpenDirection},showSearchInput:function(){return this.searchable&&(!this.hasSingleSelectedSlot||!this.visibleSingleValue&&0!==this.visibleSingleValue||this.isOpen)}}}},function(t,e,n){var i=n(1)("unscopables"),r=Array.prototype;void 0==r[i]&&n(8)(r,i,{}),t.exports=function(t){r[i][t]=!0}},function(t,e,n){var i=n(18),r=n(19),o=n(85);t.exports=function(t){return function(e,n,s){var u,a=i(e),l=r(a.length),c=o(s,l);if(t&&n!=n){for(;l>c;)if((u=a[c++])!=u)return!0}else for(;l>c;c++)if((t||c in a)&&a[c]===n)return t||c||0;return!t&&-1}}},function(t,e,n){var i=n(9),r=n(1)("toStringTag"),o="Arguments"==i(function(){return arguments}()),s=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,u;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=s(e=Object(t),r))?n:o?i(e):"Object"==(u=i(e))&&"function"==typeof e.callee?"Arguments":u}},function(t,e,n){"use strict";var i=n(2);t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},function(t,e,n){var i=n(0).document;t.exports=i&&i.documentElement},function(t,e,n){t.exports=!n(4)&&!n(7)(function(){return 7!=Object.defineProperty(n(21)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var i=n(9);t.exports=Array.isArray||function(t){return"Array"==i(t)}},function(t,e,n){"use strict";function i(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=r(e),this.reject=r(n)}var r=n(14);t.exports.f=function(t){return new i(t)}},function(t,e,n){var i=n(2),r=n(76),o=n(22),s=n(27)("IE_PROTO"),u=function(){},a=function(){var t,e=n(21)("iframe"),i=o.length;for(e.style.display="none",n(40).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),a=t.F;i--;)delete a.prototype[o[i]];return a()};t.exports=Object.create||function(t,e){var n;return null!==t?(u.prototype=i(t),n=new u,u.prototype=null,n[s]=t):n=a(),void 0===e?n:r(n,e)}},function(t,e,n){var i=n(79),r=n(25),o=n(18),s=n(29),u=n(12),a=n(41),l=Object.getOwnPropertyDescriptor;e.f=n(4)?l:function(t,e){if(t=o(t),e=s(e,!0),a)try{return l(t,e)}catch(t){}if(u(t,e))return r(!i.f.call(t,e),t[e])}},function(t,e,n){var i=n(12),r=n(18),o=n(37)(!1),s=n(27)("IE_PROTO");t.exports=function(t,e){var n,u=r(t),a=0,l=[];for(n in u)n!=s&&i(u,n)&&l.push(n);for(;e.length>a;)i(u,n=e[a++])&&(~o(l,n)||l.push(n));return l}},function(t,e,n){var i=n(46),r=n(22);t.exports=Object.keys||function(t){return i(t,r)}},function(t,e,n){var i=n(2),r=n(5),o=n(43);t.exports=function(t,e){if(i(t),r(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},function(t,e,n){var i=n(10),r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n(24)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e,n){var i=n(2),r=n(14),o=n(1)("species");t.exports=function(t,e){var n,s=i(t).constructor;return void 0===s||void 0==(n=i(s)[o])?e:r(n)}},function(t,e,n){var i=n(3),r=n(16),o=n(7),s=n(84),u="["+s+"]",a="​",l=RegExp("^"+u+u+"*"),c=RegExp(u+u+"*$"),f=function(t,e,n){var r={},u=o(function(){return!!s[t]()||a[t]()!=a}),l=r[t]=u?e(p):s[t];n&&(r[n]=l),i(i.P+i.F*u,"String",r)},p=f.trim=function(t,e){return t=String(r(t)),1&e&&(t=t.replace(l,"")),2&e&&(t=t.replace(c,"")),t};t.exports=f},function(t,e,n){var i,r,o,s=n(11),u=n(68),a=n(40),l=n(21),c=n(0),f=c.process,p=c.setImmediate,h=c.clearImmediate,d=c.MessageChannel,v=c.Dispatch,g=0,y={},m=function(){var t=+this;if(y.hasOwnProperty(t)){var e=y[t];delete y[t],e()}},b=function(t){m.call(t.data)};p&&h||(p=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return y[++g]=function(){u("function"==typeof t?t:Function(t),e)},i(g),g},h=function(t){delete y[t]},"process"==n(9)(f)?i=function(t){f.nextTick(s(m,t,1))}:v&&v.now?i=function(t){v.now(s(m,t,1))}:d?(r=new d,o=r.port2,r.port1.onmessage=b,i=s(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",b,!1)):i="onreadystatechange"in l("script")?function(t){a.appendChild(l("script")).onreadystatechange=function(){a.removeChild(this),m.call(t)}}:function(t){setTimeout(s(m,t,1),0)}),t.exports={set:p,clear:h}},function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},function(t,e,n){"use strict";var i=n(3),r=n(20)(5),o=!0;"find"in[]&&Array(1).find(function(){o=!1}),i(i.P+i.F*o,"Array",{find:function(t){return r(this,t,arguments.length>1?arguments[1]:void 0)}}),n(36)("find")},function(t,e,n){"use strict";var i,r,o,s,u=n(24),a=n(0),l=n(11),c=n(38),f=n(3),p=n(5),h=n(14),d=n(61),v=n(66),g=n(50),y=n(52).set,m=n(75)(),b=n(43),_=n(80),x=n(86),w=n(48),S=a.TypeError,O=a.process,L=O&&O.versions,k=L&&L.v8||"",P=a.Promise,T="process"==c(O),V=function(){},E=r=b.f,A=!!function(){try{var t=P.resolve(1),e=(t.constructor={})[n(1)("species")]=function(t){t(V,V)};return(T||"function"==typeof PromiseRejectionEvent)&&t.then(V)instanceof e&&0!==k.indexOf("6.6")&&-1===x.indexOf("Chrome/66")}catch(t){}}(),C=function(t){var e;return!(!p(t)||"function"!=typeof(e=t.then))&&e},D=function(t,e){if(!t._n){t._n=!0;var n=t._c;m(function(){for(var i=t._v,r=1==t._s,o=0;n.length>o;)!function(e){var n,o,s,u=r?e.ok:e.fail,a=e.resolve,l=e.reject,c=e.domain;try{u?(r||(2==t._h&&$(t),t._h=1),!0===u?n=i:(c&&c.enter(),n=u(i),c&&(c.exit(),s=!0)),n===e.promise?l(S("Promise-chain cycle")):(o=C(n))?o.call(n,a,l):a(n)):l(i)}catch(t){c&&!s&&c.exit(),l(t)}}(n[o++]);t._c=[],t._n=!1,e&&!t._h&&j(t)})}},j=function(t){y.call(a,function(){var e,n,i,r=t._v,o=N(t);if(o&&(e=_(function(){T?O.emit("unhandledRejection",r,t):(n=a.onunhandledrejection)?n({promise:t,reason:r}):(i=a.console)&&i.error&&i.error("Unhandled promise rejection",r)}),t._h=T||N(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},N=function(t){return 1!==t._h&&0===(t._a||t._c).length},$=function(t){y.call(a,function(){var e;T?O.emit("rejectionHandled",t):(e=a.onrejectionhandled)&&e({promise:t,reason:t._v})})},F=function(t){var e=this;e._d||(e._d=!0,e=e._w||e,e._v=t,e._s=2,e._a||(e._a=e._c.slice()),D(e,!0))},M=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw S("Promise can't be resolved itself");(e=C(t))?m(function(){var i={_w:n,_d:!1};try{e.call(t,l(M,i,1),l(F,i,1))}catch(t){F.call(i,t)}}):(n._v=t,n._s=1,D(n,!1))}catch(t){F.call({_w:n,_d:!1},t)}}};A||(P=function(t){d(this,P,"Promise","_h"),h(t),i.call(this);try{t(l(M,this,1),l(F,this,1))}catch(t){F.call(this,t)}},i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},i.prototype=n(81)(P.prototype,{then:function(t,e){var n=E(g(this,P));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=T?O.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&D(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=l(M,t,1),this.reject=l(F,t,1)},b.f=E=function(t){return t===P||t===s?new o(t):r(t)}),f(f.G+f.W+f.F*!A,{Promise:P}),n(26)(P,"Promise"),n(83)("Promise"),s=n(10).Promise,f(f.S+f.F*!A,"Promise",{reject:function(t){var e=E(this);return(0,e.reject)(t),e.promise}}),f(f.S+f.F*(u||!A),"Promise",{resolve:function(t){return w(u&&this===s?P:this,t)}}),f(f.S+f.F*!(A&&n(73)(function(t){P.all(t).catch(V)})),"Promise",{all:function(t){var e=this,n=E(e),i=n.resolve,r=n.reject,o=_(function(){var n=[],o=0,s=1;v(t,!1,function(t){var u=o++,a=!1;n.push(void 0),s++,e.resolve(t).then(function(t){a||(a=!0,n[u]=t,--s||i(n))},r)}),--s||i(n)});return o.e&&r(o.v),n.promise},race:function(t){var e=this,n=E(e),i=n.reject,r=_(function(){v(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return r.e&&i(r.v),n.promise}})},function(t,e,n){"use strict";var i=n(3),r=n(10),o=n(0),s=n(50),u=n(48);i(i.P+i.R,"Promise",{finally:function(t){var e=s(this,r.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return u(e,t()).then(function(){return n})}:t,n?function(n){return u(e,t()).then(function(){throw n})}:t)}})},function(t,e,n){"use strict";function i(t){n(99)}var r=n(35),o=n(101),s=n(100),u=i,a=s(r.a,o.a,!1,u,null,null);e.a=a.exports},function(t,e,n){"use strict";function i(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}e.a=i},function(t,e,n){"use strict";function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function r(t){return(r="function"==typeof Symbol&&"symbol"===i(Symbol.iterator)?function(t){return i(t)}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":i(t)})(t)}e.a=r},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i=n(34),r=(n.n(i),n(55)),o=(n.n(r),n(56)),s=(n.n(o),n(57)),u=n(32),a=n(33);n.d(e,"Multiselect",function(){return s.a}),n.d(e,"multiselectMixin",function(){return u.a}),n.d(e,"pointerMixin",function(){return a.a}),e.default=s.a},function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},function(t,e,n){var i=n(14),r=n(28),o=n(23),s=n(19);t.exports=function(t,e,n,u,a){i(e);var l=r(t),c=o(l),f=s(l.length),p=a?f-1:0,h=a?-1:1;if(n<2)for(;;){if(p in c){u=c[p],p+=h;break}if(p+=h,a?p<0:f<=p)throw TypeError("Reduce of empty array with no initial value")}for(;a?p>=0:f>p;p+=h)p in c&&(u=e(u,c[p],p,l));return u}},function(t,e,n){var i=n(5),r=n(42),o=n(1)("species");t.exports=function(t){var e;return r(t)&&(e=t.constructor,"function"!=typeof e||e!==Array&&!r(e.prototype)||(e=void 0),i(e)&&null===(e=e[o])&&(e=void 0)),void 0===e?Array:e}},function(t,e,n){var i=n(63);t.exports=function(t,e){return new(i(t))(e)}},function(t,e,n){"use strict";var i=n(8),r=n(6),o=n(7),s=n(16),u=n(1);t.exports=function(t,e,n){var a=u(t),l=n(s,a,""[t]),c=l[0],f=l[1];o(function(){var e={};return e[a]=function(){return 7},7!=""[t](e)})&&(r(String.prototype,t,c),i(RegExp.prototype,a,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}))}},function(t,e,n){var i=n(11),r=n(70),o=n(69),s=n(2),u=n(19),a=n(87),l={},c={},e=t.exports=function(t,e,n,f,p){var h,d,v,g,y=p?function(){return t}:a(t),m=i(n,f,e?2:1),b=0;if("function"!=typeof y)throw TypeError(t+" is not iterable!");if(o(y)){for(h=u(t.length);h>b;b++)if((g=e?m(s(d=t[b])[0],d[1]):m(t[b]))===l||g===c)return g}else for(v=y.call(t);!(d=v.next()).done;)if((g=r(v,m,d.value,e))===l||g===c)return g};e.BREAK=l,e.RETURN=c},function(t,e,n){var i=n(5),r=n(82).set;t.exports=function(t,e,n){var o,s=e.constructor;return s!==n&&"function"==typeof s&&(o=s.prototype)!==n.prototype&&i(o)&&r&&r(t,o),t}},function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},function(t,e,n){var i=n(15),r=n(1)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[r]===t)}},function(t,e,n){var i=n(2);t.exports=function(t,e,n,r){try{return r?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},function(t,e,n){"use strict";var i=n(44),r=n(25),o=n(26),s={};n(8)(s,n(1)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(s,{next:r(1,n)}),o(t,e+" Iterator")}},function(t,e,n){"use strict";var i=n(24),r=n(3),o=n(6),s=n(8),u=n(15),a=n(71),l=n(26),c=n(78),f=n(1)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,g,y){a(n,e,d);var m,b,_,x=function(t){if(!p&&t in L)return L[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},w=e+" Iterator",S="values"==v,O=!1,L=t.prototype,k=L[f]||L["@@iterator"]||v&&L[v],P=k||x(v),T=v?S?x("entries"):P:void 0,V="Array"==e?L.entries||k:k;if(V&&(_=c(V.call(new t)))!==Object.prototype&&_.next&&(l(_,w,!0),i||"function"==typeof _[f]||s(_,f,h)),S&&k&&"values"!==k.name&&(O=!0,P=function(){return k.call(this)}),i&&!y||!p&&!O&&L[f]||s(L,f,P),u[e]=P,u[w]=h,v)if(m={values:S?P:x("values"),keys:g?P:x("keys"),entries:T},y)for(b in m)b in L||o(L,b,m[b]);else r(r.P+r.F*(p||O),e,m);return m}},function(t,e,n){var i=n(1)("iterator"),r=!1;try{var o=[7][i]();o.return=function(){r=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!r)return!1;var n=!1;try{var o=[7],s=o[i]();s.next=function(){return{done:n=!0}},o[i]=function(){return s},t(o)}catch(t){}return n}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var i=n(0),r=n(52).set,o=i.MutationObserver||i.WebKitMutationObserver,s=i.process,u=i.Promise,a="process"==n(9)(s);t.exports=function(){var t,e,n,l=function(){var i,r;for(a&&(i=s.domain)&&i.exit();t;){r=t.fn,t=t.next;try{r()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(a)n=function(){s.nextTick(l)};else if(!o||i.navigator&&i.navigator.standalone)if(u&&u.resolve){var c=u.resolve(void 0);n=function(){c.then(l)}}else n=function(){r.call(i,l)};else{var f=!0,p=document.createTextNode("");new o(l).observe(p,{characterData:!0}),n=function(){p.data=f=!f}}return function(i){var r={fn:i,next:void 0};e&&(e.next=r),t||(t=r,n()),e=r}}},function(t,e,n){var i=n(13),r=n(2),o=n(47);t.exports=n(4)?Object.defineProperties:function(t,e){r(t);for(var n,s=o(e),u=s.length,a=0;u>a;)i.f(t,n=s[a++],e[n]);return t}},function(t,e,n){var i=n(46),r=n(22).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,r)}},function(t,e,n){var i=n(12),r=n(28),o=n(27)("IE_PROTO"),s=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=r(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?s:null}},function(t,e){e.f={}.propertyIsEnumerable},function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},function(t,e,n){var i=n(6);t.exports=function(t,e,n){for(var r in e)i(t,r,e[r],n);return t}},function(t,e,n){var i=n(5),r=n(2),o=function(t,e){if(r(t),!i(e)&&null!==e)throw TypeError(e+": can't set as prototype!")};t.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(t,e,i){try{i=n(11)(Function.call,n(45).f(Object.prototype,"__proto__").set,2),i(t,[]),e=!(t instanceof Array)}catch(t){e=!0}return function(t,n){return o(t,n),e?t.__proto__=n:i(t,n),t}}({},!1):void 0),check:o}},function(t,e,n){"use strict";var i=n(0),r=n(13),o=n(4),s=n(1)("species");t.exports=function(t){var e=i[t];o&&e&&!e[s]&&r.f(e,s,{configurable:!0,get:function(){return this}})}},function(t,e){t.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"},function(t,e,n){var i=n(53),r=Math.max,o=Math.min;t.exports=function(t,e){return t=i(t),t<0?r(t+e,0):o(t,e)}},function(t,e,n){var i=n(0),r=i.navigator;t.exports=r&&r.userAgent||""},function(t,e,n){var i=n(38),r=n(1)("iterator"),o=n(15);t.exports=n(10).getIteratorMethod=function(t){if(void 0!=t)return t[r]||t["@@iterator"]||o[i(t)]}},function(t,e,n){"use strict";var i=n(3),r=n(20)(2);i(i.P+i.F*!n(17)([].filter,!0),"Array",{filter:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(37)(!1),o=[].indexOf,s=!!o&&1/[1].indexOf(1,-0)<0;i(i.P+i.F*(s||!n(17)(o)),"Array",{indexOf:function(t){return s?o.apply(this,arguments)||0:r(this,t,arguments[1])}})},function(t,e,n){var i=n(3);i(i.S,"Array",{isArray:n(42)})},function(t,e,n){"use strict";var i=n(3),r=n(20)(1);i(i.P+i.F*!n(17)([].map,!0),"Array",{map:function(t){return r(this,t,arguments[1])}})},function(t,e,n){"use strict";var i=n(3),r=n(62);i(i.P+i.F*!n(17)([].reduce,!0),"Array",{reduce:function(t){return r(this,t,arguments.length,arguments[1],!1)}})},function(t,e,n){var i=Date.prototype,r=i.toString,o=i.getTime;new Date(NaN)+""!="Invalid Date"&&n(6)(i,"toString",function(){var t=o.call(this);return t===t?r.call(this):"Invalid Date"})},function(t,e,n){n(4)&&"g"!=/./g.flags&&n(13).f(RegExp.prototype,"flags",{configurable:!0,get:n(39)})},function(t,e,n){n(65)("search",1,function(t,e,n){return[function(n){"use strict";var i=t(this),r=void 0==n?void 0:n[e];return void 0!==r?r.call(n,i):new RegExp(n)[e](String(i))},n]})},function(t,e,n){"use strict";n(94);var i=n(2),r=n(39),o=n(4),s=/./.toString,u=function(t){n(6)(RegExp.prototype,"toString",t,!0)};n(7)(function(){return"/a/b"!=s.call({source:"a",flags:"b"})})?u(function(){var t=i(this);return"/".concat(t.source,"/","flags"in t?t.flags:!o&&t instanceof RegExp?r.call(t):void 0)}):"toString"!=s.name&&u(function(){return s.call(this)})},function(t,e,n){"use strict";n(51)("trim",function(t){return function(){return t(this,3)}})},function(t,e,n){for(var i=n(34),r=n(47),o=n(6),s=n(0),u=n(8),a=n(15),l=n(1),c=l("iterator"),f=l("toStringTag"),p=a.Array,h={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},d=r(h),v=0;v<d.length;v++){var g,y=d[v],m=h[y],b=s[y],_=b&&b.prototype;if(_&&(_[c]||u(_,c,p),_[f]||u(_,f,y),a[y]=p,m))for(g in i)_[g]||o(_,g,i[g],!0)}},function(t,e){},function(t,e){t.exports=function(t,e,n,i,r,o){var s,u=t=t||{},a=typeof t.default;"object"!==a&&"function"!==a||(s=t,u=t.default);var l="function"==typeof u?u.options:u;e&&(l.render=e.render,l.staticRenderFns=e.staticRenderFns,l._compiled=!0),n&&(l.functional=!0),r&&(l._scopeId=r);var c;if(o?(c=function(t){t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,t||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},l._ssrRegister=c):i&&(c=i),c){var f=l.functional,p=f?l.render:l.beforeCreate;f?(l._injectStyles=c,l.render=function(t,e){return c.call(e),p(t,e)}):l.beforeCreate=p?[].concat(p,c):[c]}return{esModule:s,exports:u,options:l}}},function(t,e,n){"use strict";var i=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"multiselect",class:{"multiselect--active":t.isOpen,"multiselect--disabled":t.disabled,"multiselect--above":t.isAbove},attrs:{tabindex:t.searchable?-1:t.tabindex},on:{focus:function(e){t.activate()},blur:function(e){!t.searchable&&t.deactivate()},keydown:[function(e){return"button"in e||!t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerForward()):null},function(e){return"button"in e||!t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"])?e.target!==e.currentTarget?null:(e.preventDefault(),void t.pointerBackward()):null}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")||!t._k(e.keyCode,"tab",9,e.key,"Tab")?(e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()}}},[t._t("caret",[n("div",{staticClass:"multiselect__select",on:{mousedown:function(e){e.preventDefault(),e.stopPropagation(),t.toggle()}}})],{toggle:t.toggle}),t._v(" "),t._t("clear",null,{search:t.search}),t._v(" "),n("div",{ref:"tags",staticClass:"multiselect__tags"},[t._t("selection",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.visibleValues.length>0,expression:"visibleValues.length > 0"}],staticClass:"multiselect__tags-wrap"},[t._l(t.visibleValues,function(e,i){return[t._t("tag",[n("span",{key:i,staticClass:"multiselect__tag"},[n("span",{domProps:{textContent:t._s(t.getOptionLabel(e))}}),t._v(" "),n("i",{staticClass:"multiselect__tag-icon",attrs:{"aria-hidden":"true",tabindex:"1"},on:{keypress:function(n){if(!("button"in n)&&t._k(n.keyCode,"enter",13,n.key,"Enter"))return null;n.preventDefault(),t.removeElement(e)},mousedown:function(n){n.preventDefault(),t.removeElement(e)}}})])],{option:e,search:t.search,remove:t.removeElement})]})],2),t._v(" "),t.internalValue&&t.internalValue.length>t.limit?[t._t("limit",[n("strong",{staticClass:"multiselect__strong",domProps:{textContent:t._s(t.limitText(t.internalValue.length-t.limit))}})])]:t._e()],{search:t.search,remove:t.removeElement,values:t.visibleValues,isOpen:t.isOpen}),t._v(" "),n("transition",{attrs:{name:"multiselect__loading"}},[t._t("loading",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.loading,expression:"loading"}],staticClass:"multiselect__spinner"})])],2),t._v(" "),t.searchable?n("input",{ref:"search",staticClass:"multiselect__input",style:t.inputStyle,attrs:{name:t.name,id:t.id,type:"text",autocomplete:"nope",placeholder:t.placeholder,disabled:t.disabled,tabindex:t.tabindex},domProps:{value:t.search},on:{input:function(e){t.updateSearch(e.target.value)},focus:function(e){e.preventDefault(),t.activate()},blur:function(e){e.preventDefault(),t.deactivate()},keyup:function(e){if(!("button"in e)&&t._k(e.keyCode,"esc",27,e.key,"Escape"))return null;t.deactivate()},keydown:[function(e){if(!("button"in e)&&t._k(e.keyCode,"down",40,e.key,["Down","ArrowDown"]))return null;e.preventDefault(),t.pointerForward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"up",38,e.key,["Up","ArrowUp"]))return null;e.preventDefault(),t.pointerBackward()},function(e){if(!("button"in e)&&t._k(e.keyCode,"delete",[8,46],e.key,["Backspace","Delete"]))return null;e.stopPropagation(),t.removeLastElement()}],keypress:function(e){return"button"in e||!t._k(e.keyCode,"enter",13,e.key,"Enter")?(e.preventDefault(),e.stopPropagation(),e.target!==e.currentTarget?null:void t.addPointerElement(e)):null}}}):t._e(),t._v(" "),t.isSingleLabelVisible?n("span",{staticClass:"multiselect__single",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("singleLabel",[[t._v(t._s(t.currentOptionLabel))]],{option:t.singleValue})],2):t._e(),t._v(" "),t.isPlaceholderVisible?n("span",{staticClass:"multiselect__placeholder",on:{mousedown:function(e){return e.preventDefault(),t.toggle(e)}}},[t._t("placeholder",[t._v("\n          "+t._s(t.placeholder)+"\n        ")])],2):t._e()],2),t._v(" "),n("transition",{attrs:{name:"multiselect"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isOpen,expression:"isOpen"}],ref:"list",staticClass:"multiselect__content-wrapper",style:{maxHeight:t.optimizedHeight+"px"},attrs:{tabindex:"-1"},on:{focus:t.activate,mousedown:function(t){t.preventDefault()}}},[n("ul",{staticClass:"multiselect__content",style:t.contentStyle},[t._t("beforeList"),t._v(" "),t.multiple&&t.max===t.internalValue.length?n("li",[n("span",{staticClass:"multiselect__option"},[t._t("maxElements",[t._v("Maximum of "+t._s(t.max)+" options selected. First remove a selected option to select another.")])],2)]):t._e(),t._v(" "),!t.max||t.internalValue.length<t.max?t._l(t.filteredOptions,function(e,i){return n("li",{key:i,staticClass:"multiselect__element"},[e&&(e.$isLabel||e.$isDisabled)?t._e():n("span",{staticClass:"multiselect__option",class:t.optionHighlight(i,e),attrs:{"data-select":e&&e.isTag?t.tagPlaceholder:t.selectLabelText,"data-selected":t.selectedLabelText,"data-deselect":t.deselectLabelText},on:{click:function(n){n.stopPropagation(),t.select(e)},mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.pointerSet(i)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2),t._v(" "),e&&(e.$isLabel||e.$isDisabled)?n("span",{staticClass:"multiselect__option",class:t.groupHighlight(i,e),attrs:{"data-select":t.groupSelect&&t.selectGroupLabelText,"data-deselect":t.groupSelect&&t.deselectGroupLabelText},on:{mouseenter:function(e){if(e.target!==e.currentTarget)return null;t.groupSelect&&t.pointerSet(i)},mousedown:function(n){n.preventDefault(),t.selectGroup(e)}}},[t._t("option",[n("span",[t._v(t._s(t.getOptionLabel(e)))])],{option:e,search:t.search})],2):t._e()])}):t._e(),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoResults&&0===t.filteredOptions.length&&t.search&&!t.loading,expression:"showNoResults && (filteredOptions.length === 0 && search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noResult",[t._v("No elements found. Consider changing the search query.")],{search:t.search})],2)]),t._v(" "),n("li",{directives:[{name:"show",rawName:"v-show",value:t.showNoOptions&&0===t.options.length&&!t.search&&!t.loading,expression:"showNoOptions && (options.length === 0 && !search && !loading)"}]},[n("span",{staticClass:"multiselect__option"},[t._t("noOptions",[t._v("List is empty.")])],2)]),t._v(" "),t._t("afterList")],2)])])],2)},r=[],o={render:i,staticRenderFns:r};e.a=o}])});

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(136);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4af56dfc", content, true, {});

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "fieldset[disabled] .multiselect{pointer-events:none}.multiselect__spinner{position:absolute;right:1px;top:1px;width:48px;height:35px;background:#fff;display:block}.multiselect__spinner:after,.multiselect__spinner:before{position:absolute;content:\"\";top:50%;left:50%;margin:-8px 0 0 -8px;width:16px;height:16px;border-radius:100%;border:2px solid transparent;border-top-color:#41b883;box-shadow:0 0 0 1px transparent}.multiselect__spinner:before{animation:spinning 2.4s cubic-bezier(.41,.26,.2,.62);animation-iteration-count:infinite}.multiselect__spinner:after{animation:spinning 2.4s cubic-bezier(.51,.09,.21,.8);animation-iteration-count:infinite}.multiselect__loading-enter-active,.multiselect__loading-leave-active{transition:opacity .4s ease-in-out;opacity:1}.multiselect__loading-enter,.multiselect__loading-leave-active{opacity:0}.multiselect,.multiselect__input,.multiselect__single{font-family:inherit;font-size:16px;-ms-touch-action:manipulation;touch-action:manipulation}.multiselect{box-sizing:content-box;display:block;position:relative;width:100%;min-height:40px;text-align:left;color:#35495e}.multiselect *{box-sizing:border-box}.multiselect:focus{outline:none}.multiselect--disabled{background:#ededed;pointer-events:none;opacity:.6}.multiselect--active{z-index:50}.multiselect--active:not(.multiselect--above) .multiselect__current,.multiselect--active:not(.multiselect--above) .multiselect__input,.multiselect--active:not(.multiselect--above) .multiselect__tags{border-bottom-left-radius:0;border-bottom-right-radius:0}.multiselect--active .multiselect__select{transform:rotate(180deg)}.multiselect--above.multiselect--active .multiselect__current,.multiselect--above.multiselect--active .multiselect__input,.multiselect--above.multiselect--active .multiselect__tags{border-top-left-radius:0;border-top-right-radius:0}.multiselect__input,.multiselect__single{position:relative;display:inline-block;min-height:20px;line-height:20px;border:none;border-radius:5px;background:#fff;padding:0 0 0 5px;width:100%;transition:border .1s ease;box-sizing:border-box;margin-bottom:8px;vertical-align:top}.multiselect__input:-ms-input-placeholder{color:#35495e}.multiselect__input::placeholder{color:#35495e}.multiselect__tag~.multiselect__input,.multiselect__tag~.multiselect__single{width:auto}.multiselect__input:hover,.multiselect__single:hover{border-color:#cfcfcf}.multiselect__input:focus,.multiselect__single:focus{border-color:#a8a8a8;outline:none}.multiselect__single{padding-left:5px;margin-bottom:8px}.multiselect__tags-wrap{display:inline}.multiselect__tags{min-height:40px;display:block;padding:8px 40px 0 8px;border-radius:5px;border:1px solid #e8e8e8;background:#fff;font-size:14px}.multiselect__tag{position:relative;display:inline-block;padding:4px 26px 4px 10px;border-radius:5px;margin-right:10px;color:#fff;line-height:1;background:#41b883;margin-bottom:5px;white-space:nowrap;overflow:hidden;max-width:100%;text-overflow:ellipsis}.multiselect__tag-icon{cursor:pointer;margin-left:7px;position:absolute;right:0;top:0;bottom:0;font-weight:700;font-style:normal;width:22px;text-align:center;line-height:22px;transition:all .2s ease;border-radius:5px}.multiselect__tag-icon:after{content:\"\\D7\";color:#266d4d;font-size:14px}.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{background:#369a6e}.multiselect__tag-icon:focus:after,.multiselect__tag-icon:hover:after{color:#fff}.multiselect__current{min-height:40px;overflow:hidden;padding:8px 30px 0 12px;white-space:nowrap;border-radius:5px;border:1px solid #e8e8e8}.multiselect__current,.multiselect__select{line-height:16px;box-sizing:border-box;display:block;margin:0;text-decoration:none;cursor:pointer}.multiselect__select{position:absolute;width:40px;height:38px;right:1px;top:1px;padding:4px 8px;text-align:center;transition:transform .2s ease}.multiselect__select:before{position:relative;right:0;top:65%;color:#999;margin-top:4px;border-color:#999 transparent transparent;border-style:solid;border-width:5px 5px 0;content:\"\"}.multiselect__placeholder{color:#adadad;display:inline-block;margin-bottom:10px;padding-top:2px}.multiselect--active .multiselect__placeholder{display:none}.multiselect__content-wrapper{position:absolute;display:block;background:#fff;width:100%;max-height:240px;overflow:auto;border:1px solid #e8e8e8;border-top:none;border-bottom-left-radius:5px;border-bottom-right-radius:5px;z-index:50;-webkit-overflow-scrolling:touch}.multiselect__content{list-style:none;display:inline-block;padding:0;margin:0;min-width:100%;vertical-align:top}.multiselect--above .multiselect__content-wrapper{bottom:100%;border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:5px;border-top-right-radius:5px;border-bottom:none;border-top:1px solid #e8e8e8}.multiselect__content::webkit-scrollbar{display:none}.multiselect__element{display:block}.multiselect__option{display:block;padding:12px;min-height:40px;line-height:16px;text-decoration:none;text-transform:none;vertical-align:middle;position:relative;cursor:pointer;white-space:nowrap}.multiselect__option:after{top:0;right:0;position:absolute;line-height:40px;padding-right:12px;padding-left:20px;font-size:13px}.multiselect__option--highlight{background:#41b883;outline:none;color:#fff}.multiselect__option--highlight:after{content:attr(data-select);background:#41b883;color:#fff}.multiselect__option--selected{background:#f3f3f3;color:#35495e;font-weight:700}.multiselect__option--selected:after{content:attr(data-selected);color:silver}.multiselect__option--selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect--disabled .multiselect__current,.multiselect--disabled .multiselect__select{background:#ededed;color:#a6a6a6}.multiselect__option--disabled{background:#ededed!important;color:#a6a6a6!important;cursor:text;pointer-events:none}.multiselect__option--group{background:#ededed;color:#35495e}.multiselect__option--group.multiselect__option--highlight{background:#35495e;color:#fff}.multiselect__option--group.multiselect__option--highlight:after{background:#35495e}.multiselect__option--disabled.multiselect__option--highlight{background:#dedede}.multiselect__option--group-selected.multiselect__option--highlight{background:#ff6a6a;color:#fff}.multiselect__option--group-selected.multiselect__option--highlight:after{background:#ff6a6a;content:attr(data-deselect);color:#fff}.multiselect-enter-active,.multiselect-leave-active{transition:all .15s ease}.multiselect-enter,.multiselect-leave-active{opacity:0}.multiselect__strong{margin-bottom:8px;line-height:20px;display:inline-block;vertical-align:top}[dir=rtl] .multiselect{text-align:right}[dir=rtl] .multiselect__select{right:auto;left:1px}[dir=rtl] .multiselect__tags{padding:8px 8px 0 40px}[dir=rtl] .multiselect__content{text-align:right}[dir=rtl] .multiselect__option:after{right:auto;left:0}[dir=rtl] .multiselect__clear{right:auto;left:12px}[dir=rtl] .multiselect__spinner{right:auto;left:1px}@keyframes spinning{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", ""]);

// exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_paypal_checkout__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_paypal_checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_paypal_checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);





var requiredProps = [['amount'], ['currency', 'USD']];

var optionalProps = [['id'], ['invoiceNumber']];

var specificProps = [{
  name: 'env',
  type: String,
  required: false,
  default: 'production',
  validator: function validator(value) {
    return ['sandbox', 'production'].indexOf(value) !== -1;
  }
}, {
  name: 'client',
  type: Object,
  required: true
}, {
  name: 'details',
  type: Object,
  required: false,
  default: function _default() {
    return {};
  }
}, {
  name: 'commit',
  type: Boolean,
  required: false,
  default: true
}];

function defaultProps () {
  var props = {};

  // TODO: make type configurable
  // all required props are type String for now
  requiredProps.forEach(function (_ref) {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
        name = _ref2[0],
        def = _ref2[1];

    props[name] = {
      type: String,
      required: true,
      default: typeof def !== 'undefined' ? def : undefined
    };
  });

  // TODO: make type configurable
  // all optional props are type String for now
  optionalProps.forEach(function (_ref3) {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
        name = _ref4[0],
        def = _ref4[1];

    props[name] = {
      type: String,
      required: false,
      default: typeof def !== 'undefined' ? def : undefined
    };
  });

  // all specific props are declared ahead of time
  specificProps.forEach(function (prop) {
    props[prop.name] = {
      type: prop.type,
      required: prop.required
    };

    if (prop.default !== undefined) {
      props[prop.name].default = prop.default;
    }
  });

  return props;
}

function paypalProp(prop) {
  /* eslint-disable no-param-reassign */
  var define = function getDefine(object) {
    return function def(name, param, defaultParam) {
      var isDefined = typeof param !== 'undefined' && param !== null;
      var hasDefault = typeof defaultParam !== 'undefined' && defaultParam !== null;

      if (isDefined) object[name] = param;else if (hasDefault) object[name] = defaultParam;else object[name] = undefined; // TODO: throw err?
    };
  }(this);

  define('name', prop.name);
  define('propName', prop.paypalName, prop.name);
  define('injection', prop.injection, 'button');
  define('type', prop.type, Object);
  define('required', prop.required, false);
  define('validator', prop.validator, undefined);

  this.transforms = [];
}

paypalProp.prototype.getVmProp = function getVmProp() {
  return {
    type: this.type,
    required: this.required,
    validator: this.validator
  };
};

paypalProp.prototype.addChangeTransform = function addChangeTransform(callable) {
  this.transforms.push(callable);
};

paypalProp.prototype.getChange = function getChange(src) {
  var value = src[this.name];

  // change the value if necessary...
  if (value !== undefined && value !== null) {
    this.transforms.forEach(function (transform) {
      value = transform(value);
    });
  }

  return {
    name: this.propName,
    value: value
  };
};

var propTypes = {
  BUTTON: 'button',
  PAYMENT: 'payment',
  TRANSACTION: 'transaction'
};

function assignToPropertyObject(props) {
  return function assignTo(vm, type) {
    var obj = {};

    props.getTypedProps(type).forEach(function (item) {
      var _item$getChange = item.getChange(vm),
          name = _item$getChange.name,
          value = _item$getChange.value;

      if (name !== undefined && value !== undefined) {
        obj[name] = value;
      }
    });

    return obj;
  };
}

// TODO: add item validator
var itemsPayPalProp = new paypalProp({
  name: 'items',
  paypalName: 'item_list',
  type: Array,
  injection: propTypes.TRANSACTION
});

itemsPayPalProp.addChangeTransform(function (items) {
  return { items: items };
});

var shippingAddressProp = new paypalProp({
  name: 'shippingAddress',
  paypalName: 'shipping_address',
  type: Object,
  injection: propTypes.TRANSACTION
});

var props = [
// Button Props
new paypalProp({ name: 'buttonStyle', paypalName: 'style', injection: propTypes.BUTTON }), new paypalProp({ name: 'braintree', injection: propTypes.BUTTON }), new paypalProp({ name: 'locale', type: String, injection: propTypes.BUTTON }),

// Payment Props
new paypalProp({ name: 'experience', injection: propTypes.PAYMENT }),

// Transaction Props
new paypalProp({
  name: 'invoiceNumber',
  paypalName: 'invoice_number',
  type: String,
  injection: propTypes.TRANSACTION
}), new paypalProp({
  name: 'notifyUrl',
  paypalName: 'notify_url',
  type: String,
  validator: function validator(value) {
    return (/^https?:\/\//.test(value)
    );
  },
  injection: propTypes.TRANSACTION
}), itemsPayPalProp, shippingAddressProp];

function vmProps() {
  var vm = {};

  props.forEach(function (prop) {
    vm[prop.name] = prop.getVmProp();
  });

  return vm;
}

function getTypedProps(type) {
  return props.filter(function (prop) {
    return prop.injection === type;
  });
}

var additionalProps = {
  vmProps: vmProps,
  getTypedProps: getTypedProps
};

var assignTo = assignToPropertyObject(additionalProps);

var script = {
  props: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(defaultProps(), additionalProps.vmProps()),
  methods: {
    payment: function payment() {
      var vue = this;

      var transaction = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
        amount: {
          total: this.amount,
          currency: this.currency,
          details: this.details
        }
      }, assignTo(vue, propTypes.TRANSACTION));

      // TODO: clean this up
      if (transaction.shipping_address && transaction.item_list) {
        transaction.item_list.shipping_address = transaction.shipping_address;
        delete transaction.shipping_address;
      }

      var payment = {
        transactions: [transaction]
      };

      return __WEBPACK_IMPORTED_MODULE_2_paypal_checkout___default.a.rest.payment.create(this.env, this.client, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ payment: payment }, assignTo(vue, propTypes.PAYMENT)));
    },
    onAuthorize: function onAuthorize(data, actions) {
      var vue = this;
      vue.$emit('payment-authorized', data);

      if (this.commit) {
        return actions.payment.execute().then(function (response) {
          vue.$emit('payment-completed', response);
        });
      }

      return true;
    },
    onCancel: function onCancel(data) {
      var vue = this;
      vue.$emit('payment-cancelled', data);
    }
  },
  mounted: function mounted() {
    var vue = this;
    var button = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({
      // Pass in env
      env: vue.env,

      // Pass in the client ids to use to create your transaction
      // on sandbox and production environments
      client: vue.client,

      // Pass the payment details for your transaction
      // See https://developer.paypal.com/docs/api/payments/#payment_create for the expected json parameters
      payment: vue.payment,

      // Display a "Pay Now" button rather than a "Continue" button
      commit: vue.commit,

      // Pass a function to be called when the customer completes the payment
      onAuthorize: vue.onAuthorize,

      // Pass a function to be called when the customer cancels the payment
      onCancel: vue.onCancel
    }, assignTo(vue, propTypes.BUTTON));

    __WEBPACK_IMPORTED_MODULE_2_paypal_checkout___default.a.Button.render(button, vue.$el);
  }
};

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "paypal-button", attrs: { id: _vm.id } });
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

/* style */
var __vue_inject_styles__ = undefined;
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* component normalizer */
function __vue_normalize__(template, style, script$$1, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

  // For security concerns, we use only base name in production mode.
  component.__file = "/home/khoa/src/github.com/khoanguyen96/paypal/src/components/PayPalCheckout.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;

    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */

var PayPalCheckout = __vue_normalize__({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

var components = {
  'paypal-checkout': PayPalCheckout
};

__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(components).forEach(function (name) {
  // in browsers ~
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.component(name, components[name]);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (PayPalCheckout);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(139);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(160);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(140), __esModule: true };

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(25);
__webpack_require__(36);
module.exports = __webpack_require__(159);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(142);
var step = __webpack_require__(143);
var Iterators = __webpack_require__(6);
var toIObject = __webpack_require__(13);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(28)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 143 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(145);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(30)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(17);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(150);
var descriptor = __webpack_require__(31);
var setToStringTag = __webpack_require__(35);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(7)(IteratorPrototype, __webpack_require__(1)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(9);
var dPs = __webpack_require__(151);
var enumBugKeys = __webpack_require__(34);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(30)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(156).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(16);
var anObject = __webpack_require__(9);
var getKeys = __webpack_require__(18);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(11);
var toIObject = __webpack_require__(13);
var arrayIndexOf = __webpack_require__(153)(false);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(13);
var toLength = __webpack_require__(154);
var toAbsoluteIndex = __webpack_require__(155);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(19);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(19);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(11);
var toObject = __webpack_require__(21);
var IE_PROTO = __webpack_require__(20)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(19);
var defined = __webpack_require__(14);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(37);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(6);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(161), __esModule: true };

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(25);
__webpack_require__(36);
module.exports = __webpack_require__(162);


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(9);
var get = __webpack_require__(163);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(37);
var ITERATOR = __webpack_require__(1)('iterator');
var Iterators = __webpack_require__(6);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(165), __esModule: true };

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(15);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(167) });


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(8);
var getKeys = __webpack_require__(18);
var gOPS = __webpack_require__(168);
var pIE = __webpack_require__(169);
var toObject = __webpack_require__(21);
var IObject = __webpack_require__(26);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 168 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* @flow */
/* eslint import/no-commonjs: off */

// $FlowFixMe
module.exports = __webpack_require__(171);

module.exports.default = module.exports;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer) {/*! For license information please see checkout.lib.js.LICENSE.txt */
!function(root, factory) {
     true ? module.exports = factory() : "function" == typeof define && define.amd ? define("paypal", [], factory) : "object" == typeof exports ? exports.paypal = factory() : root.paypal = factory();
}("undefined" != typeof self ? self : this, (function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return {}.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 48);
    }([ function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return BUTTON_STYLE_OPTIONS;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return BUTTON_LABEL;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return BUTTON_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return BUTTON_LOGO_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return BUTTON_SIZE;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return BUTTON_TAGLINE_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return BUTTON_SHAPE;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return BUTTON_BRANDING;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return BUTTON_LAYOUT;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return BUTTON_NUMBER;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return BUTTON_LOGO;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return CHECKOUT_OVERLAY_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return FUNDING;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return FUNDING_BRAND_LABEL;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return CARD;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return FUNDING_ELIGIBILITY_REASON;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return CARD_PRIORITY;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return FPTI;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return COUNTRY;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return LANG;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return LANG_TO_DEFAULT_COUNTRY;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return ALLOWED_INSTALLMENT_COUNTRIES;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return ALLOWED_INSTALLMENT_PERIOD;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return ENV;
        }));
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return USERS;
        }));
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return SOURCE;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return LOG_LEVEL;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return PAYMENT_TYPE;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return PPTM_ID;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return ATTRIBUTE;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return PLATFORM;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return DEFAULT;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return LOCALE;
        }));
        var BUTTON_STYLE_OPTIONS = {
            LABEL: "label",
            SIZE: "size",
            SHAPE: "shape",
            COLOR: "color",
            LAYOUT: "layout",
            MAXBUTTONS: "maxbuttons",
            FUNDINGICONS: "fundingicons",
            BRANDING: "branding",
            TAGLINE: "tagline",
            HEIGHT: "height",
            INSTALLMENTPERIOD: "installmentperiod"
        };
        var BUTTON_LABEL = {
            PAYPAL: "paypal",
            CHECKOUT: "checkout",
            PAY: "pay",
            CREDIT: "credit",
            CARD: "card",
            BUYNOW: "buynow",
            INSTALLMENT: "installment",
            VENMO: "venmo",
            ITAU: "itau",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var BUTTON_COLOR = {
            GOLD: "gold",
            BLUE: "blue",
            SILVER: "silver",
            BLACK: "black",
            DARKBLUE: "darkblue",
            WHITE: "white",
            TRANSPARENT: "transparent"
        };
        var BUTTON_LOGO_COLOR = {
            BLUE: "blue",
            WHITE: "white",
            BLACK: "black",
            ANY: "any"
        };
        var BUTTON_SIZE = {
            TINY: "tiny",
            SMALL: "small",
            MEDIUM: "medium",
            LARGE: "large",
            HUGE: "huge",
            RESPONSIVE: "responsive"
        };
        var BUTTON_TAGLINE_COLOR = {
            BLACK: "black",
            BLUE: "blue"
        };
        var BUTTON_SHAPE = {
            PILL: "pill",
            RECT: "rect"
        };
        var BUTTON_BRANDING = {
            BRANDED: "branded",
            UNBRANDED: "unbranded"
        };
        var BUTTON_LAYOUT = {
            HORIZONTAL: "horizontal",
            VERTICAL: "vertical"
        };
        var BUTTON_NUMBER = {
            SINGLE: "single",
            MULTIPLE: "multiple"
        };
        var BUTTON_LOGO = {
            PP: "pp",
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var CHECKOUT_OVERLAY_COLOR = {
            BLACK: "black",
            WHITE: "white"
        };
        var FUNDING = {
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            CARD: "card",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            ZIMPLER: "zimpler",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var FUNDING_BRAND_LABEL = {
            PAYPAL: "PayPal",
            CREDIT: "PayPal Credit",
            CARD: "Debit or Credit Card"
        };
        var CARD = {
            VISA: "visa",
            MASTERCARD: "mastercard",
            AMEX: "amex",
            DISCOVER: "discover",
            SWITCH: "switch",
            MAESTRO: "maestro",
            HIPER: "hiper",
            ELO: "elo",
            JCB: "jcb",
            CUP: "cup",
            COFINOGA: "cofinoga",
            COFIDIS: "cofidis",
            CETELEM: "cetelem",
            CBNATIONALE: "cbnationale"
        };
        var FUNDING_ELIGIBILITY_REASON = {
            PRIMARY: "The funding source is the primary source",
            NOT_ENABLED: "The funding source is not currently enabled for use",
            SECONDARY_DISALLOWED: "The funding source is disallowed as a secondary button",
            OPT_OUT: "The funding source was disallowed in funding.disallowed",
            OPT_IN: "The funding source was allowed in funding.allowed",
            DISALLOWED_COUNTRY: "The funding source is not enabled for the current locale",
            DEFAULT_COUNTRY: "The funding source is enabled by default for the current locale",
            DEFAULT: "The funding source is enabled by default for all users",
            REMEMBERED: "The funding source was remembered for the current user",
            NEED_OPT_IN: "The funding source needs to be allowed in funding.allowed",
            COMMIT_NOT_SET: "The funding source is not enabled when commit is not set as true",
            INVALID_ENV: "The funding source is not supported in this environment"
        };
        var CARD_PRIORITY = [ CARD.VISA, CARD.MASTERCARD, CARD.AMEX, CARD.DISCOVER, CARD.SWITCH, CARD.MAESTRO, CARD.HIPER, CARD.ELO, CARD.JCB, CARD.CUP, CARD.COFINOGA, CARD.COFIDIS, CARD.CETELEM, CARD.CBNATIONALE ];
        var ENV = {
            LOCAL: "local",
            STAGE: "stage",
            SANDBOX: "sandbox",
            PRODUCTION: "production",
            TEST: "test",
            DEMO: "demo"
        };
        var USERS = {
            ALL: "all",
            REMEMBERED: "remembered"
        };
        var SOURCE = {
            MANUAL: "manual",
            BUTTON_FACTORY: "button_factory"
        };
        var LOG_LEVEL = {
            DEBUG: "debug",
            INFO: "info",
            WARN: "warn",
            ERROR: "error"
        };
        var PAYMENT_TYPE = {
            EC_TOKEN: "ec_token",
            BA_TOKEN: "ba_token",
            PAY_ID: "pay_id"
        };
        var PPTM_ID = "xo-pptm";
        var ATTRIBUTE = {
            BUTTON: "data-button",
            FUNDING_SOURCE: "data-funding-source",
            CARD: "data-card",
            VERSION: "data-version",
            LAYOUT: "data-layout",
            SIZE: "data-size",
            SMART_BUTTON_VERSION: "data-paypal-smart-button-version"
        };
        var PLATFORM = {
            DESKTOP: "desktop",
            MOBILE: "mobile"
        };
        var DEFAULT = "default";
        var _CONTEXT_TYPE;
        var FPTI = {
            KEY: {
                FEED: "feed_name",
                STATE: "state_name",
                TRANSITION: "transition_name",
                BUTTON_TYPE: "button_type",
                SESSION_UID: "page_session_id",
                BUTTON_SESSION_UID: "button_session_id",
                TOKEN: "token",
                CONTEXT_ID: "context_id",
                CONTEXT_TYPE: "context_type",
                REFERER: "referer_url",
                PAY_ID: "pay_id",
                SELLER_ID: "seller_id",
                DATA_SOURCE: "serverside_data_source",
                BUTTON_SOURCE: "button_source",
                ERROR_CODE: "ext_error_code",
                ERROR_DESC: "ext_error_desc",
                PAGE_LOAD_TIME: "page_load_time",
                EXPERIMENT_NAME: "pxp_exp_id",
                TREATMENT_NAME: "pxp_trtmnt_id",
                TRANSITION_TIME: "transition_time",
                FUNDING_LIST: "eligible_payment_methods",
                FUNDING_COUNT: "eligible_payment_count",
                CHOSEN_FUNDING: "selected_payment_method",
                BUTTON_LAYOUT: "button_layout",
                BUTTON_COLOR: "button_color",
                BUTTON_SIZE: "button_size",
                BUTTON_SHAPE: "button_shape",
                BUTTON_LABEL: "button_label",
                BUTTON_WIDTH: "button_width",
                VERSION: "checkoutjs_version",
                MAX_BUTTONS: "max_buttons",
                FUNDING_REMEMBERED: "funding_remembered",
                BUTTON_TAGLINE_ENABLED: "button_tagline_enabled",
                RESPONSE_DURATION: "response_duration",
                PAYMENT_FLOW: "payment_flow",
                BUTTON_VERSION: "button_version",
                PAGE_TYPE: "pp_placement",
                TIMESTAMP: "t"
            },
            BUTTON_TYPE: {
                IFRAME: "iframe",
                HTML: "html",
                CUSTOM: "custom"
            },
            DATA_SOURCE: {
                CHECKOUT: "checkout"
            },
            CONTEXT_TYPE: (_CONTEXT_TYPE = {
                BUTTON_SESSION_ID: "button_session_id"
            }, _CONTEXT_TYPE[PAYMENT_TYPE.PAY_ID] = "Pay-ID", _CONTEXT_TYPE[PAYMENT_TYPE.EC_TOKEN] = "EC-Token", 
            _CONTEXT_TYPE[PAYMENT_TYPE.BA_TOKEN] = "EC-Token", _CONTEXT_TYPE),
            FEED: {
                CHECKOUTJS: "checkoutjs"
            },
            STATE: {
                LOAD: "checkoutjs_load",
                BUTTON: "checkoutjs_button",
                CHECKOUT: "checkoutjs_checkout",
                PPTM: "checkoutjs_pptm"
            },
            TRANSITION: {
                SCRIPT_LOAD: "process_script_load",
                BUTTON_RENDER: "process_button_render",
                BUTTON_LOAD: "process_button_load",
                BUTTON_CLICK: "process_button_click",
                BUTTON_RENDER_INTRANET_MODE: "process_button_render_intranet_mode",
                BUTTON_CLICK_INTRANET_MODE: "process_button_click_intranet_mode",
                CREATE_PAYMENT: "process_create_payment",
                RECIEVE_PAYMENT: "process_recieve_payment",
                CHECKOUT_INIT: "process_checkout_init",
                CHECKOUT_APPROVE: "process_checkout_approve",
                CHECKOUT_SHIPPING_CHANGE: "process_checkout_shipping_change",
                CHECKOUT_CANCEL: "process_checkout_cancel",
                CHECKOUT_ERROR: "process_checkout_error",
                EXTERNAL_EXPERIMENT: "process_external_experiment",
                EXTERNAL_EXPERIMENT_COMPLETE: "process_external_experiment_complete",
                PPTM_LOAD: "process_pptm_load",
                PPTM_LOADED: "process_pptm_loaded"
            }
        };
        var _LANG_TO_DEFAULT_COUN;
        var COUNTRY = {
            AD: "AD",
            AE: "AE",
            AG: "AG",
            AI: "AI",
            AL: "AL",
            AM: "AM",
            AN: "AN",
            AO: "AO",
            AR: "AR",
            AT: "AT",
            AU: "AU",
            AW: "AW",
            AZ: "AZ",
            BA: "BA",
            BB: "BB",
            BE: "BE",
            BF: "BF",
            BG: "BG",
            BH: "BH",
            BI: "BI",
            BJ: "BJ",
            BM: "BM",
            BN: "BN",
            BO: "BO",
            BR: "BR",
            BS: "BS",
            BT: "BT",
            BW: "BW",
            BY: "BY",
            BZ: "BZ",
            C2: "C2",
            CA: "CA",
            CD: "CD",
            CG: "CG",
            CH: "CH",
            CI: "CI",
            CK: "CK",
            CL: "CL",
            CM: "CM",
            CN: "CN",
            CO: "CO",
            CR: "CR",
            CV: "CV",
            CY: "CY",
            CZ: "CZ",
            DE: "DE",
            DJ: "DJ",
            DK: "DK",
            DM: "DM",
            DO: "DO",
            DZ: "DZ",
            EC: "EC",
            EE: "EE",
            EG: "EG",
            ER: "ER",
            ES: "ES",
            ET: "ET",
            FI: "FI",
            FJ: "FJ",
            FK: "FK",
            FM: "FM",
            FO: "FO",
            FR: "FR",
            GA: "GA",
            GB: "GB",
            GD: "GD",
            GE: "GE",
            GF: "GF",
            GI: "GI",
            GL: "GL",
            GM: "GM",
            GN: "GN",
            GP: "GP",
            GR: "GR",
            GT: "GT",
            GW: "GW",
            GY: "GY",
            HK: "HK",
            HN: "HN",
            HR: "HR",
            HU: "HU",
            ID: "ID",
            IE: "IE",
            IL: "IL",
            IN: "IN",
            IS: "IS",
            IT: "IT",
            JM: "JM",
            JO: "JO",
            JP: "JP",
            KE: "KE",
            KG: "KG",
            KH: "KH",
            KI: "KI",
            KM: "KM",
            KN: "KN",
            KR: "KR",
            KW: "KW",
            KY: "KY",
            KZ: "KZ",
            LA: "LA",
            LC: "LC",
            LI: "LI",
            LK: "LK",
            LS: "LS",
            LT: "LT",
            LU: "LU",
            LV: "LV",
            MA: "MA",
            MC: "MC",
            MD: "MD",
            ME: "ME",
            MG: "MG",
            MH: "MH",
            MK: "MK",
            ML: "ML",
            MN: "MN",
            MQ: "MQ",
            MR: "MR",
            MS: "MS",
            MT: "MT",
            MU: "MU",
            MV: "MV",
            MW: "MW",
            MX: "MX",
            MY: "MY",
            MZ: "MZ",
            NA: "NA",
            NC: "NC",
            NE: "NE",
            NF: "NF",
            NG: "NG",
            NI: "NI",
            NL: "NL",
            NO: "NO",
            NP: "NP",
            NR: "NR",
            NU: "NU",
            NZ: "NZ",
            OM: "OM",
            PA: "PA",
            PE: "PE",
            PF: "PF",
            PG: "PG",
            PH: "PH",
            PL: "PL",
            PM: "PM",
            PN: "PN",
            PT: "PT",
            PW: "PW",
            PY: "PY",
            QA: "QA",
            RE: "RE",
            RO: "RO",
            RS: "RS",
            RU: "RU",
            RW: "RW",
            SA: "SA",
            SB: "SB",
            SC: "SC",
            SE: "SE",
            SG: "SG",
            SH: "SH",
            SI: "SI",
            SJ: "SJ",
            SK: "SK",
            SL: "SL",
            SM: "SM",
            SN: "SN",
            SO: "SO",
            SR: "SR",
            ST: "ST",
            SV: "SV",
            SZ: "SZ",
            TC: "TC",
            TD: "TD",
            TG: "TG",
            TH: "TH",
            TJ: "TJ",
            TM: "TM",
            TN: "TN",
            TO: "TO",
            TR: "TR",
            TT: "TT",
            TV: "TV",
            TW: "TW",
            TZ: "TZ",
            UA: "UA",
            UG: "UG",
            US: "US",
            UY: "UY",
            VA: "VA",
            VC: "VC",
            VE: "VE",
            VG: "VG",
            VN: "VN",
            VU: "VU",
            WF: "WF",
            WS: "WS",
            YE: "YE",
            YT: "YT",
            ZA: "ZA",
            ZM: "ZM",
            ZW: "ZW"
        };
        var LANG = {
            AR: "ar",
            CS: "cs",
            DA: "da",
            DE: "de",
            EL: "el",
            EN: "en",
            ES: "es",
            FI: "fi",
            FR: "fr",
            HE: "he",
            HU: "hu",
            ID: "id",
            IT: "it",
            JA: "ja",
            KO: "ko",
            NL: "nl",
            NO: "no",
            PL: "pl",
            PT: "pt",
            RU: "ru",
            SK: "sk",
            SV: "sv",
            TH: "th",
            TR: "tr",
            ZH: "zh"
        };
        var LANG_TO_DEFAULT_COUNTRY = ((_LANG_TO_DEFAULT_COUN = {})[LANG.AR] = COUNTRY.SA, 
        _LANG_TO_DEFAULT_COUN[LANG.CS] = COUNTRY.CZ, _LANG_TO_DEFAULT_COUN[LANG.DA] = COUNTRY.DK, 
        _LANG_TO_DEFAULT_COUN[LANG.DE] = COUNTRY.DE, _LANG_TO_DEFAULT_COUN[LANG.EL] = COUNTRY.GR, 
        _LANG_TO_DEFAULT_COUN[LANG.EN] = COUNTRY.US, _LANG_TO_DEFAULT_COUN[LANG.ES] = COUNTRY.ES, 
        _LANG_TO_DEFAULT_COUN[LANG.FI] = COUNTRY.FI, _LANG_TO_DEFAULT_COUN[LANG.FR] = COUNTRY.FR, 
        _LANG_TO_DEFAULT_COUN[LANG.HE] = COUNTRY.IL, _LANG_TO_DEFAULT_COUN[LANG.HU] = COUNTRY.HU, 
        _LANG_TO_DEFAULT_COUN[LANG.ID] = COUNTRY.ID, _LANG_TO_DEFAULT_COUN[LANG.IT] = COUNTRY.IT, 
        _LANG_TO_DEFAULT_COUN[LANG.JA] = COUNTRY.JP, _LANG_TO_DEFAULT_COUN[LANG.KO] = COUNTRY.KR, 
        _LANG_TO_DEFAULT_COUN[LANG.NL] = COUNTRY.NL, _LANG_TO_DEFAULT_COUN[LANG.NO] = COUNTRY.NO, 
        _LANG_TO_DEFAULT_COUN[LANG.PL] = COUNTRY.PL, _LANG_TO_DEFAULT_COUN[LANG.PT] = COUNTRY.PT, 
        _LANG_TO_DEFAULT_COUN[LANG.RU] = COUNTRY.RU, _LANG_TO_DEFAULT_COUN[LANG.SK] = COUNTRY.SK, 
        _LANG_TO_DEFAULT_COUN[LANG.SV] = COUNTRY.SE, _LANG_TO_DEFAULT_COUN[LANG.TH] = COUNTRY.TH, 
        _LANG_TO_DEFAULT_COUN[LANG.TR] = COUNTRY.TR, _LANG_TO_DEFAULT_COUN[LANG.ZH] = COUNTRY.CN, 
        _LANG_TO_DEFAULT_COUN);
        var ALLOWED_INSTALLMENT_COUNTRIES = [ COUNTRY.BR, COUNTRY.MX ];
        var ALLOWED_INSTALLMENT_PERIOD = {
            BR: [ 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
            MX: [ 3, 6, 9, 12 ]
        };
        var _LOCALE;
        var LOCALE = ((_LOCALE = {})[COUNTRY.AD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.AG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AL] = [ LANG.EN ], 
        _LOCALE[COUNTRY.AM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AR] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.AT] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.AU] = [ LANG.EN ], _LOCALE[COUNTRY.AW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BA] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BE] = [ LANG.EN, LANG.NL, LANG.FR ], 
        _LOCALE[COUNTRY.BF] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BG] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BH] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BI] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BN] = [ LANG.EN ], _LOCALE[COUNTRY.BO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.BR] = [ LANG.PT, LANG.EN ], _LOCALE[COUNTRY.BS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BT] = [ LANG.EN ], _LOCALE[COUNTRY.BW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BY] = [ LANG.EN ], _LOCALE[COUNTRY.BZ] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.C2] = [ LANG.ZH, LANG.EN ], _LOCALE[COUNTRY.CA] = [ LANG.EN, LANG.FR ], 
        _LOCALE[COUNTRY.CD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CH] = [ LANG.DE, LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CI] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.CK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CL] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CM] = [ LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CN] = [ LANG.ZH ], _LOCALE[COUNTRY.CO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CR] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.CV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CY] = [ LANG.EN ], _LOCALE[COUNTRY.CZ] = [ LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DE] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.DJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DK] = [ LANG.DA, LANG.EN ], _LOCALE[COUNTRY.DM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.DZ] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EC] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.EE] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EG] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ER] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ES] = [ LANG.ES, LANG.EN ], _LOCALE[COUNTRY.ET] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FI] = [ LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FM] = [ LANG.EN ], 
        _LOCALE[COUNTRY.FO] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FR] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.GA] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GB] = [ LANG.EN ], 
        _LOCALE[COUNTRY.GD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GL] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GP] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GR] = [ LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GT] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.GW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.HK] = [ LANG.EN, LANG.ZH ], _LOCALE[COUNTRY.HN] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.HR] = [ LANG.EN ], _LOCALE[COUNTRY.HU] = [ LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ID] = [ LANG.ID, LANG.EN ], _LOCALE[COUNTRY.IE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.IL] = [ LANG.HE, LANG.EN ], _LOCALE[COUNTRY.IN] = [ LANG.EN ], _LOCALE[COUNTRY.IS] = [ LANG.EN ], 
        _LOCALE[COUNTRY.IT] = [ LANG.IT, LANG.EN ], _LOCALE[COUNTRY.JM] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.JO] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.JP] = [ LANG.JA, LANG.EN ], 
        _LOCALE[COUNTRY.KE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KH] = [ LANG.EN ], _LOCALE[COUNTRY.KI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KM] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KR] = [ LANG.KO, LANG.EN ], _LOCALE[COUNTRY.KW] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LA] = [ LANG.EN ], _LOCALE[COUNTRY.LC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.LS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LT] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LU] = [ LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LV] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MC] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.MD] = [ LANG.EN ], _LOCALE[COUNTRY.ME] = [ LANG.EN ], _LOCALE[COUNTRY.MG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.ML] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MQ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MT] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MV] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MX] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.MY] = [ LANG.EN ], _LOCALE[COUNTRY.MZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NE] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NG] = [ LANG.EN ], _LOCALE[COUNTRY.NI] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.NL] = [ LANG.NL, LANG.EN ], _LOCALE[COUNTRY.NO] = [ LANG.NO, LANG.EN ], 
        _LOCALE[COUNTRY.NP] = [ LANG.EN ], _LOCALE[COUNTRY.NR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.OM] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PA] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.PE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.PF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PH] = [ LANG.EN ], 
        _LOCALE[COUNTRY.PL] = [ LANG.PL, LANG.EN ], _LOCALE[COUNTRY.PM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PT] = [ LANG.PT, LANG.EN ], 
        _LOCALE[COUNTRY.PW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PY] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.QA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.RE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.RS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RU] = [ LANG.RU, LANG.EN ], _LOCALE[COUNTRY.RW] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SC] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SE] = [ LANG.SV, LANG.EN ], 
        _LOCALE[COUNTRY.SG] = [ LANG.EN ], _LOCALE[COUNTRY.SH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SK] = [ LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SL] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ST] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SV] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.SZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TG] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TH] = [ LANG.TH, LANG.EN ], _LOCALE[COUNTRY.TJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TN] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TO] = [ LANG.EN ], _LOCALE[COUNTRY.TR] = [ LANG.TR, LANG.EN ], _LOCALE[COUNTRY.TT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TW] = [ LANG.ZH, LANG.EN ], 
        _LOCALE[COUNTRY.TZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.UA] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.US] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UY] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.VA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.VC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.VG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.VU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.WF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.WS] = [ LANG.EN ], _LOCALE[COUNTRY.YE] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.YT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ZM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZW] = [ LANG.EN ], 
        _LOCALE);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return JsxHTMLNodeContainer;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return jsxToHTML;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return jsxRender;
        }));
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
        function htmlEncode(html) {
            void 0 === html && (html = "");
            return html.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/\//g, "&#x2F;");
        }
        var JsxHTMLNode = function() {
            function JsxHTMLNode(name, props, children) {
                this.name = void 0;
                this.props = void 0;
                this.children = void 0;
                this.name = name;
                this.props = props;
                this.children = children;
            }
            var _proto = JsxHTMLNode.prototype;
            _proto.toString = function() {
                return "<" + this.name + (this.props ? " " : "") + (this.props ? this.propsToString() : "") + ">" + this.childrenToString() + "</" + this.name + ">";
            };
            _proto.propsToString = function() {
                var props = this.props;
                return props ? Object.keys(props).filter((function(key) {
                    return "innerHTML" !== key && props && !1 !== props[key];
                })).map((function(key) {
                    return props && !0 === props[key] ? "" + htmlEncode(key) : props ? htmlEncode(key) + '="' + htmlEncode(props[key]) + '"' : "";
                })).join(" ") : "";
            };
            _proto.childrenToString = function() {
                if (this.props && this.props.innerHTML) return this.props.innerHTML;
                if (!this.children) return "";
                var result = "";
                !function iterate(children) {
                    for (var _i2 = 0; _i2 < children.length; _i2++) {
                        var child = children[_i2];
                        null != child && (Array.isArray(child) ? iterate(child) : result += child instanceof JsxHTMLNode ? child.toString() : htmlEncode(child));
                    }
                }(this.children);
                return result;
            };
            return JsxHTMLNode;
        }();
        var JsxHTMLNodeContainer = function(_JsxHTMLNode) {
            Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(JsxHTMLNodeContainer, _JsxHTMLNode);
            function JsxHTMLNodeContainer(children) {
                return _JsxHTMLNode.call(this, "", {}, children) || this;
            }
            JsxHTMLNodeContainer.prototype.toString = function() {
                return this.childrenToString();
            };
            return JsxHTMLNodeContainer;
        }(JsxHTMLNode);
        function jsxToHTML(name, props) {
            for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) children[_key - 2] = arguments[_key];
            return new JsxHTMLNode(name, props, children);
        }
        function jsxRender(template, renderers) {
            var nodes = Object(_util__WEBPACK_IMPORTED_MODULE_1__.n)(template, /\{\s*([a-z]+)(?::\s*([^} ]+))?\s*\}|([^${}]+)/g, (function(match, type, value, text) {
                if (type) {
                    if (!renderers[type]) throw new Error("Can not render type: " + type);
                    return renderers[type](value);
                }
                return text && text.trim() && renderers.text ? /<br>/.test(text) ? renderers.break(text) : renderers.text(text) : text;
            }));
            return new JsxHTMLNodeContainer(nodes);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return promise_ZalgoPromise;
        }));
        function utils_isPromise(item) {
            try {
                if (!item) return !1;
                if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                var _toString = {}.toString;
                if (_toString) {
                    var name = _toString.call(item);
                    if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                }
                if ("function" == typeof item.then) return !0;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        var dispatchedErrors = [];
        var possiblyUnhandledPromiseHandlers = [];
        var activeCount = 0;
        var flushPromise;
        function flushActive() {
            if (!activeCount && flushPromise) {
                var promise = flushPromise;
                flushPromise = null;
                promise.resolve();
            }
        }
        function startActive() {
            activeCount += 1;
        }
        function endActive() {
            activeCount -= 1;
            flushActive();
        }
        var promise_ZalgoPromise = function() {
            function ZalgoPromise(handler) {
                var _this = this;
                this.resolved = void 0;
                this.rejected = void 0;
                this.errorHandled = void 0;
                this.value = void 0;
                this.error = void 0;
                this.handlers = void 0;
                this.dispatching = void 0;
                this.stack = void 0;
                this.resolved = !1;
                this.rejected = !1;
                this.errorHandled = !1;
                this.handlers = [];
                if (handler) {
                    var _result;
                    var _error;
                    var resolved = !1;
                    var rejected = !1;
                    var isAsync = !1;
                    startActive();
                    try {
                        handler((function(res) {
                            if (isAsync) _this.resolve(res); else {
                                resolved = !0;
                                _result = res;
                            }
                        }), (function(err) {
                            if (isAsync) _this.reject(err); else {
                                rejected = !0;
                                _error = err;
                            }
                        }));
                    } catch (err) {
                        endActive();
                        this.reject(err);
                        return;
                    }
                    endActive();
                    isAsync = !0;
                    resolved ? this.resolve(_result) : rejected && this.reject(_error);
                }
            }
            var _proto = ZalgoPromise.prototype;
            _proto.resolve = function(result) {
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                this.resolved = !0;
                this.value = result;
                this.dispatch();
                return this;
            };
            _proto.reject = function(error) {
                var _this2 = this;
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                if (!error) {
                    var _err = error && "function" == typeof error.toString ? error.toString() : {}.toString.call(error);
                    error = new Error("Expected reject to be called with Error, got " + _err);
                }
                this.rejected = !0;
                this.error = error;
                this.errorHandled || setTimeout((function() {
                    _this2.errorHandled || function(err, promise) {
                        if (-1 === dispatchedErrors.indexOf(err)) {
                            dispatchedErrors.push(err);
                            setTimeout((function() {
                                throw err;
                            }), 1);
                            for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) possiblyUnhandledPromiseHandlers[j](err, promise);
                        }
                    }(error, _this2);
                }), 1);
                this.dispatch();
                return this;
            };
            _proto.asyncReject = function(error) {
                this.errorHandled = !0;
                this.reject(error);
                return this;
            };
            _proto.dispatch = function() {
                var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                if (!this.dispatching && (resolved || rejected)) {
                    this.dispatching = !0;
                    startActive();
                    var chain = function(firstPromise, secondPromise) {
                        return firstPromise.then((function(res) {
                            secondPromise.resolve(res);
                        }), (function(err) {
                            secondPromise.reject(err);
                        }));
                    };
                    for (var i = 0; i < handlers.length; i++) {
                        var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                        var _result2 = void 0;
                        if (resolved) try {
                            _result2 = onSuccess ? onSuccess(this.value) : this.value;
                        } catch (err) {
                            promise.reject(err);
                            continue;
                        } else if (rejected) {
                            if (!onError) {
                                promise.reject(this.error);
                                continue;
                            }
                            try {
                                _result2 = onError(this.error);
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                        }
                        if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                            var promiseResult = _result2;
                            promiseResult.resolved ? promise.resolve(promiseResult.value) : promise.reject(promiseResult.error);
                            promiseResult.errorHandled = !0;
                        } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                    }
                    handlers.length = 0;
                    this.dispatching = !1;
                    endActive();
                }
            };
            _proto.then = function(onSuccess, onError) {
                if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                var promise = new ZalgoPromise;
                this.handlers.push({
                    promise: promise,
                    onSuccess: onSuccess,
                    onError: onError
                });
                this.errorHandled = !0;
                this.dispatch();
                return promise;
            };
            _proto.catch = function(onError) {
                return this.then(void 0, onError);
            };
            _proto.finally = function(onFinally) {
                if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                return this.then((function(result) {
                    return ZalgoPromise.try(onFinally).then((function() {
                        return result;
                    }));
                }), (function(err) {
                    return ZalgoPromise.try(onFinally).then((function() {
                        throw err;
                    }));
                }));
            };
            _proto.timeout = function(time, err) {
                var _this3 = this;
                if (this.resolved || this.rejected) return this;
                var timeout = setTimeout((function() {
                    _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                }), time);
                return this.then((function(result) {
                    clearTimeout(timeout);
                    return result;
                }));
            };
            _proto.toPromise = function() {
                if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                return Promise.resolve(this);
            };
            _proto.lazy = function() {
                this.errorHandled = !0;
                return this;
            };
            ZalgoPromise.resolve = function(value) {
                return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise((function(resolve, reject) {
                    return value.then(resolve, reject);
                })) : (new ZalgoPromise).resolve(value);
            };
            ZalgoPromise.reject = function(error) {
                return (new ZalgoPromise).reject(error);
            };
            ZalgoPromise.asyncReject = function(error) {
                return (new ZalgoPromise).asyncReject(error);
            };
            ZalgoPromise.all = function(promises) {
                var promise = new ZalgoPromise;
                var count = promises.length;
                var results = [].slice();
                if (!count) {
                    promise.resolve(results);
                    return promise;
                }
                var chain = function(i, firstPromise, secondPromise) {
                    return firstPromise.then((function(res) {
                        results[i] = res;
                        0 == (count -= 1) && promise.resolve(results);
                    }), (function(err) {
                        secondPromise.reject(err);
                    }));
                };
                for (var i = 0; i < promises.length; i++) {
                    var prom = promises[i];
                    if (prom instanceof ZalgoPromise) {
                        if (prom.resolved) {
                            results[i] = prom.value;
                            count -= 1;
                            continue;
                        }
                    } else if (!utils_isPromise(prom)) {
                        results[i] = prom;
                        count -= 1;
                        continue;
                    }
                    chain(i, ZalgoPromise.resolve(prom), promise);
                }
                0 === count && promise.resolve(results);
                return promise;
            };
            ZalgoPromise.hash = function(promises) {
                var result = {};
                var awaitPromises = [];
                var _loop = function(key) {
                    if (promises.hasOwnProperty(key)) {
                        var value = promises[key];
                        utils_isPromise(value) ? awaitPromises.push(value.then((function(res) {
                            result[key] = res;
                        }))) : result[key] = value;
                    }
                };
                for (var key in promises) _loop(key);
                return ZalgoPromise.all(awaitPromises).then((function() {
                    return result;
                }));
            };
            ZalgoPromise.map = function(items, method) {
                return ZalgoPromise.all(items.map(method));
            };
            ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                return function(handler) {
                    possiblyUnhandledPromiseHandlers.push(handler);
                    return {
                        cancel: function() {
                            possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                        }
                    };
                }(handler);
            };
            ZalgoPromise.try = function(method, context, args) {
                if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                var result;
                startActive();
                try {
                    result = method.apply(context, args || []);
                } catch (err) {
                    endActive();
                    return ZalgoPromise.reject(err);
                }
                endActive();
                return ZalgoPromise.resolve(result);
            };
            ZalgoPromise.delay = function(_delay) {
                return new ZalgoPromise((function(resolve) {
                    setTimeout(resolve, _delay);
                }));
            };
            ZalgoPromise.isPromise = function(value) {
                return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
            };
            ZalgoPromise.flush = function() {
                return function(Zalgo) {
                    var promise = flushPromise = flushPromise || new Zalgo;
                    flushActive();
                    return promise;
                }(ZalgoPromise);
            };
            return ZalgoPromise;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return isSupportedNativeBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "J", (function() {
            return util.j;
        }));
        __webpack_require__.d(__webpack_exports__, "L", (function() {
            return util.k;
        }));
        __webpack_require__.d(__webpack_exports__, "W", (function() {
            return util.s;
        }));
        __webpack_require__.d(__webpack_exports__, "I", (function() {
            return util.i;
        }));
        __webpack_require__.d(__webpack_exports__, "S", (function() {
            return util.o;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return util.c;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return util.a;
        }));
        __webpack_require__.d(__webpack_exports__, "U", (function() {
            return util.q;
        }));
        __webpack_require__.d(__webpack_exports__, "V", (function() {
            return util.r;
        }));
        __webpack_require__.d(__webpack_exports__, "N", (function() {
            return util.l;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return util.d;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return initLogger;
        }));
        __webpack_require__.d(__webpack_exports__, "T", (function() {
            return setLogLevel;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return isEligible;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return checkRecognizedBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return checkForDeprecatedIntegration;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return checkForCommonErrors;
        }));
        __webpack_require__.d(__webpack_exports__, "H", (function() {
            return loadScript;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return getElement;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return getElements;
        }));
        __webpack_require__.d(__webpack_exports__, "K", (function() {
            return onDocumentReady;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return getQueryParam;
        }));
        __webpack_require__.d(__webpack_exports__, "X", (function() {
            return urlWillRedirectPage;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return extendUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "P", (function() {
            return redirect;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return getBrowserLocale;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return isElementVisible;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return getPageRenderTime;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return getResourceLoadTime;
        }));
        __webpack_require__.d(__webpack_exports__, "R", (function() {
            return request;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return getThrottle;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return getReturnToken;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return getStorageID;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return getSessionState;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return getSessionID;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return getButtonSessionID;
        }));
        __webpack_require__.d(__webpack_exports__, "M", (function() {
            return openMetaFrame;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return getRememberedFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "Q", (function() {
            return rememberFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return isFundingRemembered;
        }));
        __webpack_require__.d(__webpack_exports__, "O", (function() {
            return precacheRememberedFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return getRenderedButtons;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return getCurrentScript;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return getScriptVersion;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return getCurrentScriptUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return getDomainSetting;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return allowIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return isPayPalDomain;
        }));
        var cross_domain_utils_src = __webpack_require__(7);
        var belter_src = __webpack_require__(11);
        function isSupportedNativeBrowser() {
            var userAgent = Object(belter_src.b)();
            return !(!Object(belter_src.p)(userAgent) || Object(belter_src.l)() || (!Object(belter_src.j)() || !Object(belter_src.m)()) && (!Object(belter_src.d)() || !Object(belter_src.e)()));
        }
        var util = __webpack_require__(14);
        var post_robot_src = __webpack_require__(15);
        var client = __webpack_require__(4);
        var config = __webpack_require__(5);
        var constants = __webpack_require__(0);
        var zalgo_promise_src = __webpack_require__(2);
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        var documentReady = new zalgo_promise_src.a((function(resolve) {
            if (isDocumentReady()) return resolve();
            var interval = setInterval((function() {
                if (isDocumentReady()) {
                    clearInterval(interval);
                    return resolve();
                }
            }), 10);
        }));
        documentReady.then((function() {
            if (document.body) return document.body;
            throw new Error("Document ready but document.body not present");
        }));
        function loadScript(src, timeout, attrs) {
            void 0 === timeout && (timeout = 0);
            void 0 === attrs && (attrs = {});
            return new zalgo_promise_src.a((function(resolve, reject) {
                var script = document.createElement("script");
                script.addEventListener("load", (function() {
                    resolve();
                }));
                script.onreadystatechange = function() {
                    "complete" !== this.readyState && "loaded" !== this.readyState || resolve();
                };
                var scriptLoadError = new Error("script_loading_error");
                script.addEventListener("error", (function() {
                    return reject(scriptLoadError);
                }));
                timeout && setTimeout((function() {
                    return reject(new Error("script_loading_timed_out"));
                }), timeout);
                for (var _i2 = 0, _Object$keys2 = Object.keys(attrs); _i2 < _Object$keys2.length; _i2++) {
                    var attr = _Object$keys2[_i2];
                    script.setAttribute(attr, attrs[attr]);
                }
                script.setAttribute("src", src);
                document.getElementsByTagName("head")[0].appendChild(script);
            }));
        }
        function getElement(item) {
            if (item) {
                if (item instanceof HTMLElement) return item;
                if ("string" == typeof item) {
                    if (document.querySelector) {
                        var result = document.querySelector(item);
                        if (result) return result;
                    }
                    return document.getElementById(item);
                }
            }
        }
        function getElements(collection) {
            if (!collection) return [];
            if (collection instanceof HTMLElement || "string" == typeof collection) {
                var element = getElement(collection);
                return element ? [ element ] : [];
            }
            if (Array.isArray(collection) || collection instanceof NodeList || collection instanceof HTMLCollection) {
                var result = [];
                for (var i = 0; i < collection.length; i++) {
                    var el = getElement(collection[i]);
                    el && result.push(el);
                }
                return result;
            }
            return [];
        }
        function onDocumentReady(method) {
            return documentReady.then(method);
        }
        var parseQuery = Object(util.i)((function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) return params;
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        }));
        function getQueryParam(name) {
            return parseQuery(window.location.search.slice(1))[name];
        }
        function urlWillRedirectPage(url) {
            return -1 === url.indexOf("#") || 0 !== url.indexOf("#") && url.split("#")[0] !== window.location.href.split("#")[0];
        }
        function extendUrl(url, params) {
            void 0 === params && (params = {});
            var hasHash = url.indexOf("#") > 0;
            var _url$split = url.split("#"), serverUrl = _url$split[0], hash = _url$split[1];
            if (hash && !serverUrl) {
                var _ref = [ "#" + hash, "" ];
                serverUrl = _ref[0];
                hash = _ref[1];
            }
            var _serverUrl$split = serverUrl.split("?"), originalUrl = _serverUrl$split[0], originalQueryString = _serverUrl$split[1];
            if (originalQueryString) {
                var originalQuery = parseQuery(originalQueryString);
                for (var _key in originalQuery) params.hasOwnProperty(_key) || (params[_key] = originalQuery[_key]);
            }
            var newQueryString = Object.keys(params).filter((function(key) {
                return key && params[key];
            })).sort().map((function(key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
            })).join("&");
            var newUrl = originalUrl;
            newQueryString && (newUrl = newUrl + "?" + newQueryString);
            hasHash && (newUrl = newUrl + "#" + (hash || ""));
            return newUrl;
        }
        function redirect(win, url) {
            void 0 === win && (win = window);
            return new zalgo_promise_src.a((function(resolve) {
                Object(client.k)("redirect", {
                    url: url
                });
                setTimeout((function() {
                    win.location = url;
                    urlWillRedirectPage(url) || resolve();
                }), 1);
            }));
        }
        function normalizeLocale(locale) {
            if (locale && locale.match(/^[a-z]{2}[-_][A-Z]{2}$/)) {
                var _locale$split = locale.split(/[-_]/), lang = _locale$split[0], country = _locale$split[1];
                if (constants.A[country] && -1 !== constants.A[country].indexOf(lang)) return {
                    country: country,
                    lang: lang
                };
            }
        }
        function normalizeLang(lang) {
            if (lang && lang.match(/^[a-z]{2}$/) && constants.z[lang]) return {
                country: constants.z[lang],
                lang: lang
            };
        }
        var getBrowserLocale = Object(util.i)((function() {
            var locales = function() {
                var nav = window.navigator;
                var locales = nav.languages ? [].slice.apply(nav.languages) : [];
                nav.language && locales.push(nav.language);
                nav.userLanguage && locales.push(nav.userLanguage);
                return locales;
            }();
            for (var _i6 = 0; _i6 < locales.length; _i6++) {
                var locale = locales[_i6];
                var loc = normalizeLocale(locale);
                if (loc) {
                    Object(client.k)("better_browser_locale_full");
                    return loc;
                }
                if (loc = normalizeLang(locale)) {
                    Object(client.k)("better_browser_locale_lang");
                    return loc;
                }
            }
            return config.a.defaultLocale;
        }));
        function isElementVisible(el) {
            return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }
        var enablePerformance = Object(util.i)((function() {
            return Boolean(window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0);
        }));
        function getPageRenderTime() {
            return documentReady.then((function() {
                if (enablePerformance()) {
                    var timing = window.performance.timing;
                    return timing.connectEnd && timing.domInteractive ? timing.domInteractive - timing.connectEnd : void 0;
                }
            }));
        }
        function getResourceLoadTime(url) {
            if (enablePerformance() && window.performance && "function" == typeof window.performance.getEntries) {
                var entries = window.performance.getEntries();
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry && entry.name === url && entry.duration && entry.duration >= 0 && entry.duration <= 6e4) return Math.floor(entry.duration);
                }
            }
        }
        function allowIframe() {
            if (!Object(belter_src.p)()) return !0;
            var parentWindow = Object(cross_domain_utils_src.n)(window);
            if (parentWindow && Object(cross_domain_utils_src.v)(parentWindow)) return !0;
            var parentComponentWindow = window.xchild && window.xchild.getParentComponentWindow();
            return !(!parentComponentWindow || !Object(cross_domain_utils_src.v)(parentComponentWindow));
        }
        function isPayPalDomain() {
            return Boolean((window.location.protocol + "//" + window.location.host).match(config.a.paypal_domain_regex)) || "mock://www.paypal.com" === window.mockDomain;
        }
        var accessedStorage;
        function getStorageState(handler) {
            var localStorageEnabled = Object(util.f)();
            var storage;
            accessedStorage && (storage = accessedStorage);
            if (!storage && localStorageEnabled) {
                var rawStorage = window.localStorage.getItem("__paypal_storage__");
                rawStorage && (storage = JSON.parse(rawStorage));
            }
            storage || (storage = window.__paypal_storage__);
            storage || (storage = {
                id: Object(util.s)()
            });
            storage.id || (storage.id = Object(util.s)());
            accessedStorage = storage;
            var result = handler(storage);
            localStorageEnabled ? window.localStorage.setItem("__paypal_storage__", JSON.stringify(storage)) : window.__paypal_storage__ = storage;
            accessedStorage = null;
            return result;
        }
        function getStorageID() {
            return getStorageState((function(storage) {
                return storage.id;
            }));
        }
        function getSession(handler) {
            return getStorageState((function(storage) {
                var session = storage.__paypal_session__;
                var now = Date.now();
                session && now - session.created > config.a.session_uid_lifetime && (session = null);
                session || (session = {
                    guid: Object(util.s)(),
                    created: now
                });
                storage.__paypal_session__ = session;
                return handler(session);
            }));
        }
        function getSessionState(handler) {
            return getSession((function(session) {
                session.state = session.state || {};
                return handler(session.state);
            }));
        }
        function getSessionID() {
            var xprops = window.xprops;
            if (xprops && xprops.sessionID) return xprops.sessionID;
            var querySessionID = getQueryParam("sessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : getSession((function(session) {
                return session.guid;
            }));
        }
        function getButtonSessionID() {
            if (window.xprops && window.xprops.buttonSessionID) return window.xprops.buttonSessionID;
            var querySessionID = getQueryParam("buttonSessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : void 0;
        }
        var PAGE_TYPES = {
            HOME: "home",
            PRODUCT: "product",
            CART: "cart",
            CHECKOUT: "checkout",
            PRODUCT_LISTING: "product-listing",
            SEARCH_RESULTS: "search-results",
            PRODUCT_DETAILS: "product-details",
            MINI_CART: "mini-cart"
        };
        var getCurrentScript = Object(util.i)((function() {
            var localSDKUrl = config.a.localSDKUrl;
            var scripts = [].slice.call(document.getElementsByTagName("script"));
            for (var _i2 = 0; _i2 < scripts.length; _i2++) {
                var script = scripts[_i2];
                if (script.src && (script.src.replace(/^https?:/, "").split("?")[0] === config.a.scriptUrl || script.hasAttribute("data-paypal-checkout"))) return script;
                if (script.src && -1 !== script.src.indexOf("paypal.checkout.v4.js")) return script;
                if (config.a.env === constants.t.LOCAL && localSDKUrl && script.src === localSDKUrl) return script;
            }
            document.currentScript && Object(client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            });
        }));
        function getScriptVersion() {
            return "4.0.338";
        }
        function getCurrentScriptUrl() {
            var script = getCurrentScript();
            if (script && "string" == typeof script.src) {
                var scriptUrl = script.src;
                0 === scriptUrl.indexOf("http://www.paypalobjects.com") && (scriptUrl = scriptUrl.replace("http://", "https://"));
                0 === scriptUrl.indexOf("//www.paypalobjects.com") && (scriptUrl = "https:" + scriptUrl);
                return scriptUrl;
            }
            return "https://www.paypalobjects.com/api/checkout.4.0.338.js";
        }
        function getDomainSetting(name, def) {
            var hostname = window.xchild ? window.xchild.getParentDomain() : Object(cross_domain_utils_src.h)();
            if (config.a.domain_settings) for (var _i4 = 0, _Object$keys2 = Object.keys(config.a.domain_settings); _i4 < _Object$keys2.length; _i4++) {
                var domain = _Object$keys2[_i4];
                if (Object(util.b)(hostname, domain)) return config.a.domain_settings[domain][name];
            }
            return def;
        }
        function getRefererDomain() {
            return window.xchild && window.xchild.getParentDomain ? window.xchild.getParentDomain() : window.location.host;
        }
        var setupProxyLogTransport = Object(util.k)((function() {
            Object(client.o)(function(name, win, originalMethod) {
                if (win && Object(cross_domain_utils_src.h)() === config.a.paypalDomain && !Object(cross_domain_utils_src.v)(win)) {
                    win && Object(post_robot_src.send)(win, "proxy_log", {
                        originalMethod: originalMethod
                    }).catch(util.j);
                    return originalMethod;
                }
                var methods = [];
                Object(post_robot_src.on)("proxy_log", {
                    domain: config.a.paypal_domain_regex
                }, (function(_ref) {
                    methods.push(_ref.data.originalMethod);
                }));
                return function() {
                    var _arguments = arguments, _this = this;
                    return (methods = methods.filter((function(method) {
                        return !Object(cross_domain_utils_src.z)(method.source);
                    }))).length ? methods[methods.length - 1].apply(this, arguments).catch((function() {
                        return originalMethod.apply(_this, _arguments);
                    })) : originalMethod.apply(this, arguments);
                };
            }(0, Object(cross_domain_utils_src.n)(window), Object(client.i)()));
        }));
        function initLogger() {
            setupProxyLogTransport();
            Object(client.c)((function() {
                return {
                    referer: getRefererDomain(),
                    host: window.location.host,
                    path: window.location.pathname,
                    env: config.a.env,
                    country: config.a.locale.country,
                    lang: config.a.locale.lang,
                    uid: getSessionID(),
                    ver: "4.0.338"
                };
            }));
            Object(client.a)((function() {
                return {
                    "x-app-name": "checkoutjs"
                };
            }));
            Object(client.b)((function() {
                return {
                    state: config.a.state
                };
            }));
            Object(client.d)((function(payload) {
                var _ref;
                void 0 === payload && (payload = {});
                var sessionID = getSessionID();
                var paymentToken = function() {
                    if (window.root && window.root.token) return window.root.token;
                    if (isPayPalDomain()) {
                        var queryToken = getQueryParam("token");
                        if (queryToken) return queryToken;
                    }
                }();
                var buttonSessionID = payload[constants.u.KEY.BUTTON_SESSION_UID] || getButtonSessionID();
                var contextType;
                var contextID;
                if (paymentToken) {
                    contextType = constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN];
                    contextID = paymentToken;
                } else if (buttonSessionID) {
                    contextType = constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID;
                    contextID = buttonSessionID;
                } else {
                    contextType = payload[constants.u.KEY.CONTEXT_TYPE];
                    contextID = payload[constants.u.KEY.CONTEXT_ID];
                }
                return (_ref = {})[constants.u.KEY.FEED] = constants.u.FEED.CHECKOUTJS, _ref[constants.u.KEY.DATA_SOURCE] = constants.u.DATA_SOURCE.CHECKOUT, 
                _ref[constants.u.KEY.CONTEXT_TYPE] = contextType, _ref[constants.u.KEY.CONTEXT_ID] = contextID, 
                _ref[constants.u.KEY.SELLER_ID] = config.a.merchantID, _ref[constants.u.KEY.SESSION_UID] = sessionID, 
                _ref[constants.u.KEY.BUTTON_SESSION_UID] = buttonSessionID, _ref[constants.u.KEY.VERSION] = config.a.version, 
                _ref[constants.u.KEY.TOKEN] = paymentToken, _ref[constants.u.KEY.PAGE_TYPE] = function() {
                    var script = getCurrentScript();
                    if (script && script.hasAttribute("data-page-type")) {
                        var pageType = script.getAttribute("data-page-type").toLowerCase();
                        if (-1 === Object(belter_src.r)(PAGE_TYPES).indexOf(pageType) && pageType.length) throw new Error("Invalid page type, '" + pageType + "'");
                        return pageType;
                    }
                    return "";
                }(), _ref[constants.u.KEY.REFERER] = getRefererDomain(), _ref[constants.u.KEY.TIMESTAMP] = Date.now().toString(), 
                _ref;
            }));
            window.location.protocol !== cross_domain_utils_src.a.FILE && Object(client.l)({
                uri: config.a.loggerUrl,
                heartbeat: !1,
                logPerformance: !1,
                prefix: "ppxo",
                logLevel: "warn"
            });
        }
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            config.a.logLevel = logLevel;
            client.e.logLevel = logLevel;
            post_robot_src.CONFIG.LOG_LEVEL = logLevel;
            window.LOG_LEVEL = logLevel;
        }
        var bowserCache = {};
        function getBowser() {
            var userAgent = Object(belter_src.b)();
            if (bowserCache[userAgent]) return bowserCache[userAgent];
            delete __webpack_require__.c[42];
            var bowser = __webpack_require__(42);
            bowserCache[userAgent] = bowser;
            return bowser;
        }
        function getBrowser() {
            var bowser = getBowser();
            for (var _i2 = 0, _Object$keys2 = Object.keys(config.a.SUPPORTED_BROWSERS); _i2 < _Object$keys2.length; _i2++) {
                var browser = _Object$keys2[_i2];
                if (bowser[browser]) return {
                    browser: browser,
                    version: bowser.version
                };
            }
            return {};
        }
        var eligibilityResults = {};
        function isEligible() {
            if (Object(belter_src.i)()) return !1;
            var userAgent = window.navigator.userAgent;
            if (userAgent && eligibilityResults.hasOwnProperty(userAgent)) return eligibilityResults[userAgent];
            var result = function() {
                if (Object(belter_src.i)()) return !1;
                var bowser = getBowser();
                var _getBrowser = getBrowser(), browser = _getBrowser.browser, version = _getBrowser.version;
                return !browser || !version || -1 !== bowser.compareVersions([ version, config.a.SUPPORTED_BROWSERS[browser] ]);
            }();
            eligibilityResults[userAgent] = result;
            return result;
        }
        var checkRecognizedBrowser = Object(util.k)((function(state) {
            if (!getBrowser().browser) {
                var _getBowser = getBowser(), name = _getBowser.name, version = _getBowser.version, mobile = _getBowser.mobile, android = _getBowser.android, ios = _getBowser.ios;
                Object(client.k)("unrecognized_browser_" + state, {
                    name: name,
                    version: version,
                    mobile: mobile,
                    android: android,
                    ios: ios
                });
                Object(client.h)();
            }
        }));
        function logWarn(err) {
            if (window.console) {
                if (window.console.warn) return window.console.warn(err);
                if (window.console.log) return window.console.log(err);
            }
        }
        function checkForDeprecatedIntegration() {
            var scripts = [].slice.call(document.getElementsByTagName("script"));
            for (var _i2 = 0; _i2 < scripts.length; _i2++) {
                var _script$attributes$ty;
                if ("application/x-component" === (null == (_script$attributes$ty = scripts[_i2].attributes.type) ? void 0 : _script$attributes$ty.value)) {
                    Object(client.q)("deprecated_integration_application_xcomponent");
                    console.error("\n                This integration pattern using '<script type=\"application/x-component\">' is no longer supported.\n                Please visit https://developer.paypal.com/demo/checkout-v4/\n                for an example of the new recommended integration pattern.\n            ");
                }
            }
        }
        function checkForCommonErrors() {
            if ("[]" !== JSON.stringify([])) {
                logWarn([].toJSON ? "Custom Array.prototype.toJSON is causing incorrect json serialization of arrays. This is likely to cause issues. Probable cause is Prototype.js" : "JSON.stringify is doing incorrect serialization of arrays. This is likely to cause issues.");
                Object(client.q)("json_stringify_array_broken");
            }
            if ("{}" !== JSON.stringify({})) {
                logWarn("JSON.stringify is doing incorrect serialization of objects. This is likely to cause issues.");
                Object(client.q)("json_stringify_object_broken");
            }
            Object(belter_src.i)() && Object(client.q)("ie_intranet_mode");
            Object(belter_src.g)() && !Object(belter_src.h)() && Object(client.q)("ie_meta_compatibility_header_missing", {
                message: 'Drop tag: <meta http-equiv="X-UA-Compatible" content="IE=edge">'
            });
            3 !== function(bar, baz, zomg) {}.bind({
                a: 1
            }).length && Object(client.q)("function_bind_arrity_overwritten");
            window.opener && window.parent !== window && Object(client.q)("window_has_opener_and_parent");
            window.name && 0 === window.name.indexOf("__prerender") && Object(client.q)("prerender_running_checkoutjs");
            var context = {};
            (function() {
                return this;
            }).bind(context)() !== context && Object(client.q)("function_bind_broken");
            window.Window && window.constructor && window.Window !== window.constructor && Object(client.q)("window_constructor_does_not_match_window");
            Object.assign && JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) != JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) && Object(client.q)("object_assign_broken");
        }
        var esm_extends = __webpack_require__(13);
        var headerBuilders = [];
        var corrids = [];
        Object(client.c)((function() {
            return {
                prev_corr_ids: corrids.join(",")
            };
        }));
        function request(_ref) {
            var url = _ref.url, _ref$method = _ref.method, method = void 0 === _ref$method ? "get" : _ref$method, _ref$headers = _ref.headers, headers = void 0 === _ref$headers ? {} : _ref$headers, json = _ref.json, data = _ref.data, body = _ref.body, _ref$win = _ref.win, win = void 0 === _ref$win ? window : _ref$win, _ref$timeout = _ref.timeout, timeout = void 0 === _ref$timeout ? 0 : _ref$timeout;
            return "/demo/checkout/api/braintree/client-token/" === url ? zalgo_promise_src.a.resolve("eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJjMDFhZmRkM2Y1OTJmNWVhNTNlMzE5MWQwYmIyMWVjYjM5NzNlZGM1MzkwNDZiMjJmNTA2ODEyNzIzZmRlMTJifGNsaWVudF9pZD1jbGllbnRfaWQkc2FuZGJveCQ0ZHByYmZjNnBoNTk1Y2NqXHUwMDI2Y3JlYXRlZF9hdD0yMDE3LTA0LTI2VDIzOjI2OjU5Ljg3OTA3ODYwNiswMDAwXHUwMDI2bWVyY2hhbnRfaWQ9M3cydHR2d2QyNDY1NDhoZCIsImNvbmZpZ1VybCI6Imh0dHBzOi8vYXBpLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb206NDQzL21lcmNoYW50cy8zdzJ0dHZ3ZDI0NjU0OGhkL2NsaWVudF9hcGkvdjEvY29uZmlndXJhdGlvbiIsImNoYWxsZW5nZXMiOltdLCJlbnZpcm9ubWVudCI6InNhbmRib3giLCJjbGllbnRBcGlVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvM3cydHR2d2QyNDY1NDhoZC9jbGllbnRfYXBpIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9jbGllbnQtYW5hbHl0aWNzLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20vM3cydHR2d2QyNDY1NDhoZCJ9LCJ0aHJlZURTZWN1cmVFbmFibGVkIjpmYWxzZSwicGF5cGFsRW5hYmxlZCI6dHJ1ZSwicGF5cGFsIjp7ImRpc3BsYXlOYW1lIjoiYmFyY28uMDMtZmFjaWxpdGF0b3JAZ21haWwuY29tIiwiY2xpZW50SWQiOiJBV3VZdnFnMGtaN2Y5S0V4TVpqZU53T3RjQV8yZVhnOWpMZy1QSnBGX0pnYk44M0YyVml5aEdnV2JCNDg4RGU3MFpucGRBZEI2TUNqekNqSyIsInByaXZhY3lVcmwiOiJodHRwczovL2V4YW1wbGUuY29tIiwidXNlckFncmVlbWVudFVybCI6Imh0dHBzOi8vZXhhbXBsZS5jb20iLCJiYXNlVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhc3NldHNVcmwiOiJodHRwczovL2NoZWNrb3V0LnBheXBhbC5jb20iLCJkaXJlY3RCYXNlVXJsIjpudWxsLCJhbGxvd0h0dHAiOnRydWUsImVudmlyb25tZW50Tm9OZXR3b3JrIjpmYWxzZSwiZW52aXJvbm1lbnQiOiJvZmZsaW5lIiwidW52ZXR0ZWRNZXJjaGFudCI6ZmFsc2UsImJyYWludHJlZUNsaWVudElkIjoibWFzdGVyY2xpZW50MyIsImJpbGxpbmdBZ3JlZW1lbnRzRW5hYmxlZCI6dHJ1ZSwibWVyY2hhbnRBY2NvdW50SWQiOiJVU0QiLCJjdXJyZW5jeUlzb0NvZGUiOiJVU0QifSwiY29pbmJhc2VFbmFibGVkIjpmYWxzZSwibWVyY2hhbnRJZCI6IjN3MnR0dndkMjQ2NTQ4aGQiLCJ2ZW5tbyI6Im9mZiJ9") : new zalgo_promise_src.a((function(resolve, reject) {
                if (json && data || json && body || data && json) throw new Error("Only options.json or options.data or options.body should be passed");
                var normalizedHeaders = {};
                for (var _i4 = 0, _Object$keys2 = Object.keys(headers); _i4 < _Object$keys2.length; _i4++) {
                    var _key2 = _Object$keys2[_i4];
                    normalizedHeaders[_key2.toLowerCase()] = headers[_key2];
                }
                json ? normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/json" : (data || body) && (normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/x-www-form-urlencoded; charset=utf-8");
                normalizedHeaders.accept = normalizedHeaders.accept || "application/json";
                for (var _i6 = 0; _i6 < headerBuilders.length; _i6++) {
                    var builtHeaders = (0, headerBuilders[_i6])();
                    for (var _i8 = 0, _Object$keys4 = Object.keys(builtHeaders); _i8 < _Object$keys4.length; _i8++) {
                        var _key3 = _Object$keys4[_i8];
                        normalizedHeaders[_key3.toLowerCase()] = builtHeaders[_key3];
                    }
                }
                var xhr = new win.XMLHttpRequest;
                xhr.addEventListener("load", (function() {
                    var responseHeaders = function(rawHeaders) {
                        void 0 === rawHeaders && (rawHeaders = "");
                        var result = {};
                        for (var _i2 = 0, _rawHeaders$trim$spli2 = rawHeaders.trim().split("\n"); _i2 < _rawHeaders$trim$spli2.length; _i2++) {
                            var _line$split = _rawHeaders$trim$spli2[_i2].split(":"), _key = _line$split[0], values = _line$split.slice(1);
                            result[_key.toLowerCase()] = values.join(":").trim();
                        }
                        return result;
                    }(this.getAllResponseHeaders());
                    var corrID = responseHeaders["paypal-debug-id"] || "unknown";
                    responseHeaders["paypal-debug-id"] && corrids.push(responseHeaders["paypal-debug-id"]);
                    if (!this.status) return reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: no response status code. Correlation id: " + corrID));
                    var contentType = responseHeaders["content-type"];
                    var isJSON = contentType && (0 === contentType.indexOf("application/json") || 0 === contentType.indexOf("text/json"));
                    var res = this.responseText;
                    try {
                        res = JSON.parse(this.responseText);
                    } catch (err) {
                        if (isJSON) return reject(new Error("Invalid json: " + this.responseText + ". Correlation id: " + corrID));
                    }
                    if (this.status >= 400) {
                        var message = "Request to " + method.toLowerCase() + " " + url + " failed with " + this.status + " error. Correlation id: " + corrID;
                        if (res) {
                            "object" == typeof res && null !== res && (res = JSON.stringify(res, null, 4));
                            message = message + "\n\n" + res + "\n";
                        }
                        return reject(new Error(message));
                    }
                    return resolve(res);
                }), !1);
                xhr.addEventListener("error", (function(evt) {
                    var corrID = this.getResponseHeader("paypal-debug-id");
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: " + evt.toString() + ". Correlation id: " + corrID));
                }), !1);
                xhr.open(method, url, !0);
                for (var _key4 in normalizedHeaders) normalizedHeaders.hasOwnProperty(_key4) && xhr.setRequestHeader(_key4, normalizedHeaders[_key4]);
                json ? body = JSON.stringify(json) : data && (body = Object.keys(data).map((function(key) {
                    return encodeURIComponent(key) + "=" + (data ? encodeURIComponent(data[key]) : "");
                })).join("&"));
                xhr.timeout = timeout;
                xhr.ontimeout = function() {
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " has timed out"));
                };
                xhr.send(body);
            }));
        }
        request.get = function(url, options) {
            void 0 === options && (options = {});
            return request(Object(esm_extends.a)({
                method: "get",
                url: url
            }, options));
        };
        request.post = function(url, data, options) {
            void 0 === options && (options = {});
            return request(Object(esm_extends.a)({
                method: "post",
                url: url,
                data: data
            }, options));
        };
        request.addHeaderBuilder = function(method) {
            headerBuilders.push(method);
        };
        function getThrottle(name, sample, sticky) {
            void 0 === sticky && (sticky = !0);
            var uid = getStorageID();
            var percentile = sticky ? function(name) {
                return getStorageState((function(storage) {
                    storage.throttlePercentiles = storage.throttlePercentiles || {};
                    storage.throttlePercentiles[name] = storage.throttlePercentiles[name] || Math.floor(100 * Math.random());
                    return storage.throttlePercentiles[name];
                }));
            }(name) : Math.floor(100 * Math.random());
            var group;
            var treatment = name + "_" + (group = percentile < sample ? "test" : sample >= 50 || sample <= percentile && percentile < 2 * sample ? "control" : "throttle");
            var started = !1;
            var forced = !1;
            try {
                window.localStorage && window.localStorage.getItem(name) && (forced = !0);
            } catch (err) {}
            return {
                isEnabled: function() {
                    return "test" === group || forced;
                },
                isDisabled: function() {
                    return "test" !== group && !forced;
                },
                getTreatment: function() {
                    return treatment;
                },
                log: function(checkpointName, payload) {
                    var _extends2;
                    void 0 === payload && (payload = {});
                    if (!started) return this;
                    var checkpoint = name + "_" + treatment + "_" + checkpointName;
                    Object(client.k)(checkpoint, Object(esm_extends.a)({}, payload, {
                        expuid: uid
                    }));
                    Object(client.p)(Object(esm_extends.a)(((_extends2 = {})[constants.u.KEY.EXPERIMENT_NAME] = name, 
                    _extends2[constants.u.KEY.TREATMENT_NAME] = treatment, _extends2), payload));
                    Object(client.h)();
                    return this;
                },
                logStart: function(payload) {
                    void 0 === payload && (payload = {});
                    started = !0;
                    return this.log("start", payload);
                },
                logComplete: function(payload) {
                    void 0 === payload && (payload = {});
                    return started ? this.log("complete", payload) : this;
                }
            };
        }
        function getReturnToken() {
            var token = Object(util.g)(window.location.href, /token=((EC-)?[A-Z0-9]+)/);
            var payer = Object(util.g)(window.location.href, /PayerID=([A-Z0-9]+)/);
            if (token && payer) return token;
        }
        var openMetaFrame = Object(util.i)((function(env) {
            void 0 === env && (env = config.a.env);
            return zalgo_promise_src.a.try((function() {
                if (Object(belter_src.i)()) return {
                    iframeEligible: !1,
                    iframeEligibleReason: "ie_intranet",
                    rememberedFunding: []
                };
                var metaFrameUrl = config.a.metaFrameUrls[env];
                var metaFrameDomain = config.a.paypalDomains[env];
                return zalgo_promise_src.a.try((function() {
                    if (!post_robot_src.bridge) throw new Error("Opening meta window without bridge support is not currently supported");
                    var metaListener = Object(post_robot_src.once)("meta", {
                        domain: metaFrameDomain
                    });
                    return post_robot_src.bridge.openBridge(extendUrl(metaFrameUrl, {
                        version: "4.0.338"
                    }), metaFrameDomain).then((function() {
                        return metaListener;
                    })).then((function(_ref) {
                        return _ref.data;
                    }));
                }));
            }));
        }));
        var button_props = __webpack_require__(26);
        function getRememberedFunding(handler) {
            void 0 === handler && (handler = util.e);
            return getStorageState((function(storage) {
                storage.rememberedFunding = storage.rememberedFunding || [];
                return handler(storage.rememberedFunding);
            }));
        }
        function hasRememberedFunding(source) {
            return !!getRememberedFunding((function(rememberedFunding) {
                return -1 !== rememberedFunding.indexOf(source);
            })) || !!getSessionState((function(session) {
                return session.recentlyCheckedRemembered;
            }));
        }
        function getRememberedFundingPromises() {
            return function(handler) {
                window.__paypal_global__ = window.__paypal_global__ || {};
                return function(global) {
                    global.rememberFundingPromises = global.rememberFundingPromises || {};
                    return global.rememberFundingPromises;
                }(window.__paypal_global__);
            }();
        }
        function getRememberedFundingPromise(source) {
            var promises = getRememberedFundingPromises();
            var promise = promises[source] = promises[source] || new zalgo_promise_src.a;
            hasRememberedFunding(source) && promise.resolve(function(source) {
                if (getRememberedFunding((function(rememberedFunding) {
                    return -1 !== rememberedFunding.indexOf(source);
                }))) return !0;
                if (getSessionState((function(session) {
                    return session.recentlyCheckedRemembered;
                }))) return !1;
                throw new Error("Can not find remembered funding result");
            }(source));
            return promise;
        }
        function rememberFunding(sources) {
            getRememberedFunding((function(rememberedFunding) {
                for (var _i4 = 0; _i4 < sources.length; _i4++) {
                    var source = sources[_i4];
                    source !== constants.v.VENMO && -1 === rememberedFunding.indexOf(source) && rememberedFunding.push(source);
                }
                !function() {
                    var promises = getRememberedFundingPromises();
                    var rememberedFunding = getRememberedFunding((function(sources) {
                        return sources;
                    }));
                    for (var _i2 = 0, _Object$keys2 = Object.keys(promises); _i2 < _Object$keys2.length; _i2++) {
                        var source = _Object$keys2[_i2];
                        promises[source].resolve(-1 !== rememberedFunding.indexOf(source));
                    }
                }();
            }));
            getSessionState((function(session) {
                session.recentlyCheckedRemembered = !0;
            }));
        }
        function loadMeta() {
            return openMetaFrame().then((function(_ref) {
                rememberFunding(_ref.rememberedFunding || []);
            }));
        }
        function isFundingRemembered(source) {
            void 0 === source && (source = constants.v.PAYPAL);
            return hasRememberedFunding(source) ? getRememberedFundingPromise(source) : loadMeta().then((function() {
                return getRememberedFundingPromise(source);
            }));
        }
        function precacheRememberedFunding() {
            return getSessionState((function(session) {
                return session.recentlyCheckedRemembered;
            })) ? zalgo_promise_src.a.resolve() : loadMeta();
        }
        function getRenderedButtons(props) {
            return Object(button_props.a)(props).sources.toString();
        }
        __webpack_require__(1);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getTransport;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return setTransport;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return immediateFlush;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return _flush;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return prefix;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return debug;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return info;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return warn;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return error;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return _track;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return init;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return addPayloadBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return addMetaBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return addTrackingBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addHeaderBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return config;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return logLevels;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "buffer", (function() {
            return buffer;
        }));
        __webpack_require__.d(interface_namespaceObject, "tracking", (function() {
            return tracking;
        }));
        __webpack_require__.d(interface_namespaceObject, "getTransport", (function() {
            return getTransport;
        }));
        __webpack_require__.d(interface_namespaceObject, "setTransport", (function() {
            return setTransport;
        }));
        __webpack_require__.d(interface_namespaceObject, "print", (function() {
            return print;
        }));
        __webpack_require__.d(interface_namespaceObject, "immediateFlush", (function() {
            return immediateFlush;
        }));
        __webpack_require__.d(interface_namespaceObject, "flush", (function() {
            return _flush;
        }));
        __webpack_require__.d(interface_namespaceObject, "log", (function() {
            return log;
        }));
        __webpack_require__.d(interface_namespaceObject, "prefix", (function() {
            return prefix;
        }));
        __webpack_require__.d(interface_namespaceObject, "debug", (function() {
            return debug;
        }));
        __webpack_require__.d(interface_namespaceObject, "info", (function() {
            return info;
        }));
        __webpack_require__.d(interface_namespaceObject, "warn", (function() {
            return warn;
        }));
        __webpack_require__.d(interface_namespaceObject, "error", (function() {
            return error;
        }));
        __webpack_require__.d(interface_namespaceObject, "track", (function() {
            return _track;
        }));
        __webpack_require__.d(interface_namespaceObject, "init", (function() {
            return init;
        }));
        __webpack_require__.d(interface_namespaceObject, "startTransition", (function() {
            return startTransition;
        }));
        __webpack_require__.d(interface_namespaceObject, "endTransition", (function() {
            return endTransition;
        }));
        __webpack_require__.d(interface_namespaceObject, "transition", (function() {
            return transition;
        }));
        __webpack_require__.d(interface_namespaceObject, "payloadBuilders", (function() {
            return payloadBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "metaBuilders", (function() {
            return metaBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "trackingBuilders", (function() {
            return trackingBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "headerBuilders", (function() {
            return headerBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "addPayloadBuilder", (function() {
            return addPayloadBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addMetaBuilder", (function() {
            return addMetaBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addTrackingBuilder", (function() {
            return addTrackingBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addHeaderBuilder", (function() {
            return addHeaderBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "config", (function() {
            return config;
        }));
        __webpack_require__.d(interface_namespaceObject, "logLevels", (function() {
            return logLevels;
        }));
        var src = __webpack_require__(2);
        function extend(dest, src, over) {
            void 0 === over && (over = !0);
            dest = dest || {};
            src = src || {};
            for (var i in src) src.hasOwnProperty(i) && (!over && dest.hasOwnProperty(i) || (dest[i] = src[i]));
            return dest;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        var payloadBuilders = [];
        var metaBuilders = [];
        var trackingBuilders = [];
        var headerBuilders = [];
        function addPayloadBuilder(builder) {
            payloadBuilders.push(builder);
        }
        function addMetaBuilder(builder) {
            metaBuilders.push(builder);
        }
        function addTrackingBuilder(builder) {
            trackingBuilders.push(builder);
        }
        function addHeaderBuilder(builder) {
            headerBuilders.push(builder);
        }
        var config = {
            uri: "",
            prefix: "",
            initial_state_name: "init",
            flushInterval: 6e5,
            debounceInterval: 10,
            sizeLimit: 300,
            silent: !1,
            heartbeat: !0,
            heartbeatConsoleLog: !0,
            heartbeatInterval: 5e3,
            heartbeatTooBusy: !1,
            heartbeatTooBusyThreshold: 1e4,
            logLevel: "warn",
            autoLog: [ "warn", "error" ],
            logUnload: !0,
            logPerformance: !0
        };
        var logLevels = [ "error", "warn", "info", "debug" ];
        var buffer = [];
        var tracking = [];
        var logger_transport = function(headers, data, options) {
            return function(method, url, headers, data, _temp) {
                void 0 === headers && (headers = {});
                void 0 === data && (data = {});
                var _ref$fireAndForget = (void 0 === _temp ? {} : _temp).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
                return new src.a((function(resolve) {
                    var XRequest = window.XMLHttpRequest || window.ActiveXObject;
                    if (window.XDomainRequest && !function(url) {
                        var match = url.match(/https?:\/\/[^/]+/);
                        return !match || match[0] === window.location.protocol + "//" + window.location.host;
                    }(url)) {
                        if (!function(url) {
                            return window.location.protocol === url.split("/")[0];
                        }(url)) return resolve();
                        XRequest = window.XDomainRequest;
                    }
                    var req = new XRequest("MSXML2.XMLHTTP.3.0");
                    req.open("post".toUpperCase(), url, !0);
                    if ("function" == typeof req.setRequestHeader) {
                        req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                        req.setRequestHeader("Content-type", "application/json");
                        for (var headerName in headers) headers.hasOwnProperty(headerName) && req.setRequestHeader(headerName, headers[headerName]);
                    }
                    fireAndForget ? resolve() : req.onreadystatechange = function() {
                        req.readyState > 3 && resolve();
                    };
                    req.send(JSON.stringify(data).replace(/&/g, "%26"));
                }));
            }(0, config.uri, headers, data, options);
        };
        function getTransport() {
            return logger_transport;
        }
        function setTransport(newTransport) {
            logger_transport = newTransport;
        }
        var loaded = !1;
        setTimeout((function() {
            loaded = !0;
        }), 1);
        function print(level, event, payload) {
            if ("undefined" != typeof window && window.console && window.console.log) {
                if (!loaded) return setTimeout((function() {
                    return print(level, event, payload);
                }), 1);
                var logLevel = config.logLevel;
                window.LOG_LEVEL && (logLevel = window.LOG_LEVEL);
                if (!(logLevels.indexOf(level) > logLevels.indexOf(logLevel))) {
                    payload = payload || {};
                    var args = [ event ];
                    Boolean(window.document.documentMode) && (payload = JSON.stringify(payload));
                    args.push(payload);
                    (payload.error || payload.warning) && args.push("\n\n", payload.error || payload.warning);
                    try {
                        window.console[level] && window.console[level].apply ? window.console[level].apply(window.console, args) : window.console.log && window.console.log.apply && window.console.log.apply(window.console, args);
                    } catch (err) {}
                }
            }
        }
        function immediateFlush(_temp) {
            var _ref$fireAndForget = (void 0 === _temp ? {} : _temp).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
            if ("undefined" != typeof window && config.uri && (buffer.length || tracking.length)) {
                var meta = {};
                for (var _i2 = 0; _i2 < metaBuilders.length; _i2++) {
                    var builder = metaBuilders[_i2];
                    try {
                        extend(meta, builder(meta), !1);
                    } catch (err) {
                        console.error("Error in custom meta builder:", err.stack || err.toString());
                    }
                }
                var headers = {};
                for (var _i4 = 0; _i4 < headerBuilders.length; _i4++) {
                    var _builder = headerBuilders[_i4];
                    try {
                        extend(headers, _builder(headers), !1);
                    } catch (err) {
                        console.error("Error in custom header builder:", err.stack || err.toString());
                    }
                }
                var req = logger_transport(headers, {
                    events: buffer,
                    meta: meta,
                    tracking: tracking
                }, {
                    fireAndForget: fireAndForget
                });
                buffer = [];
                tracking = [];
                return req;
            }
        }
        var _flush = (method = immediateFlush, interval = config.debounceInterval, debounce = {}, 
        function() {
            var args = arguments;
            if (debounce.timeout) {
                clearTimeout(debounce.timeout);
                delete debounce.timeout;
            }
            debounce.timeout = setTimeout((function() {
                var resolver = debounce.resolver;
                var rejector = debounce.rejector;
                delete debounce.promise;
                delete debounce.resolver;
                delete debounce.rejector;
                delete debounce.timeout;
                return src.a.resolve().then((function() {
                    return method.apply(null, args);
                })).then(resolver, rejector);
            }), interval);
            debounce.promise = debounce.promise || new src.a((function(resolver, rejector) {
                debounce.resolver = resolver;
                debounce.rejector = rejector;
            }));
            return debounce.promise;
        });
        var method, interval, debounce;
        function enqueue(level, event, payload) {
            buffer.push({
                level: level,
                event: event,
                payload: payload
            });
            config.autoLog.indexOf(level) > -1 && _flush();
        }
        function log(level, event, payload) {
            if ("undefined" != typeof window) {
                config.prefix && (event = config.prefix + "_" + event);
                "string" == typeof (payload = payload || {}) ? payload = {
                    message: payload
                } : payload instanceof Error && (payload = {
                    error: payload.stack || payload.toString()
                });
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                payload.timestamp = Date.now();
                for (var _i6 = 0; _i6 < payloadBuilders.length; _i6++) {
                    var builder = payloadBuilders[_i6];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom payload builder:", err.stack || err.toString());
                    }
                }
                config.silent || print(level, event, payload);
                buffer.length === config.sizeLimit ? enqueue("info", "logger_max_buffer_length") : buffer.length < config.sizeLimit && enqueue(level, event, payload);
            }
        }
        function prefix(name) {
            return {
                debug: function(event, payload) {
                    return log("debug", name + "_" + event, payload);
                },
                info: function(event, payload) {
                    return log("info", name + "_" + event, payload);
                },
                warn: function(event, payload) {
                    return log("warn", name + "_" + event, payload);
                },
                error: function(event, payload) {
                    return log("error", name + "_" + event, payload);
                },
                track: function(payload) {
                    return _track(payload);
                },
                flush: function() {
                    return _flush();
                }
            };
        }
        function debug(event, payload) {
            return log("debug", event, payload);
        }
        function info(event, payload) {
            return log("info", event, payload);
        }
        function warn(event, payload) {
            return log("warn", event, payload);
        }
        function error(event, payload) {
            return log("error", event, payload);
        }
        function _track(payload) {
            if ("undefined" != typeof window && payload) {
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                for (var _i8 = 0; _i8 < trackingBuilders.length; _i8++) {
                    var builder = trackingBuilders[_i8];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom tracking builder:", err.stack || err.toString());
                    }
                }
                print("debug", "tracking", payload);
                tracking.push(payload);
            }
        }
        var enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0;
        function now() {
            return enablePerformance ? performance.now() : Date.now();
        }
        function timer(startTime) {
            return {
                startTime: startTime = void 0 !== startTime ? startTime : now(),
                elapsed: function() {
                    return parseInt(now() - startTime, 10);
                },
                reset: function() {
                    startTime = now();
                }
            };
        }
        function reqStartElapsed() {
            if (enablePerformance) {
                var timing = window.performance.timing;
                return parseInt(timing.connectEnd - timing.navigationStart, 10);
            }
        }
        var clientTimer = timer();
        var reqTimer = timer(reqStartElapsed());
        var initiated = !1;
        function init(conf) {
            extend(config, conf || {});
            if (!initiated) {
                initiated = !0;
                config.logPerformance && function() {
                    if (!enablePerformance) return info("no_performance_data");
                    addPayloadBuilder((function() {
                        var payload = {};
                        payload.client_elapsed = clientTimer.elapsed();
                        enablePerformance && (payload.req_elapsed = reqTimer.elapsed());
                        return payload;
                    }));
                    new src.a((function(resolve) {
                        "undefined" != typeof document && "complete" === document.readyState && resolve();
                        window.addEventListener("load", resolve);
                    })).then((function() {
                        var timing = {};
                        [ "connectEnd", "connectStart", "domComplete", "domContentLoadedEventEnd", "domContentLoadedEventStart", "domInteractive", "domLoading", "domainLookupEnd", "domainLookupStart", "fetchStart", "loadEventEnd", "loadEventStart", "navigationStart", "redirectEnd", "redirectStart", "requestStart", "responseEnd", "responseStart", "secureConnectionStart", "unloadEventEnd", "unloadEventStart" ].forEach((function(key) {
                            timing[key] = parseInt(window.performance.timing[key], 10) || 0;
                        }));
                        var offset = timing.connectEnd - timing.navigationStart;
                        timing.connectEnd && Object.keys(timing).forEach((function(name) {
                            var time = timing[name];
                            time && info("timing_" + name, {
                                client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                                req_elapsed: parseInt(time - timing.connectEnd, 10)
                            });
                        }));
                        info("timing", timing);
                        info("memory", window.performance.memory);
                        info("navigation", window.performance.navigation);
                        window.performance.getEntries && window.performance.getEntries().forEach((function(resource) {
                            [ "link", "script", "img", "css" ].indexOf(resource.initiatorType) > -1 && info(resource.initiatorType, resource);
                        }));
                    }));
                }();
                config.heartbeat && (heartBeatTimer = timer(), heartbeatCount = 0, time = config.heartbeatInterval, 
                function loop() {
                    setTimeout((function() {
                        !function() {
                            if (!(config.heartbeatMaxThreshold && heartbeatCount > config.heartbeatMaxThreshold)) {
                                heartbeatCount += 1;
                                var elapsed = heartBeatTimer.elapsed();
                                var lag = elapsed - config.heartbeatInterval;
                                var heartbeatPayload = {
                                    count: heartbeatCount,
                                    elapsed: elapsed
                                };
                                if (config.heartbeatTooBusy) {
                                    heartbeatPayload.lag = lag;
                                    lag >= config.heartbeatTooBusyThreshold && info("toobusy", heartbeatPayload);
                                }
                                info("heartbeat", heartbeatPayload);
                            }
                        }();
                        loop();
                    }), time);
                }());
                if (config.logUnload) {
                    window.addEventListener("beforeunload", (function() {
                        info("window_beforeunload");
                        immediateFlush({
                            fireAndForget: !0
                        });
                    }));
                    window.addEventListener("unload", (function() {
                        info("window_unload");
                        immediateFlush({
                            fireAndForget: !0
                        });
                    }));
                }
                config.flushInterval && setInterval(_flush, config.flushInterval);
                if (window.beaverLogQueue) {
                    window.beaverLogQueue.forEach((function(payload) {
                        log(payload.level, payload.event, payload);
                    }));
                    delete window.beaverLogQueue;
                }
            }
            var heartBeatTimer, heartbeatCount, time;
        }
        var windowID = uniqueID();
        var pageID = uniqueID();
        var currentState = config.initial_state_name;
        var startTime;
        function startTransition() {
            startTime = now();
        }
        function endTransition(toState) {
            startTime = startTime || reqStartElapsed();
            var currentTime = now();
            var elapsedTime;
            void 0 !== startTime && (elapsedTime = parseInt(currentTime - startTime, 0));
            var transitionName = "transition_" + currentState + "_to_" + toState;
            info(transitionName, {
                duration: elapsedTime
            });
            _track({
                transition: transitionName,
                transition_time: elapsedTime
            });
            immediateFlush();
            startTime = currentTime;
            currentState = toState;
            pageID = uniqueID();
        }
        function transition(toState) {
            startTransition();
            endTransition(toState);
        }
        addPayloadBuilder((function() {
            return {
                windowID: windowID,
                pageID: pageID
            };
        }));
        addMetaBuilder((function() {
            return {
                state: "ui_" + currentState
            };
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return config;
        }));
        var constants = __webpack_require__(0);
        var _altpayUris, _guestUris, _billingUris, _buttonUris, _inlinedCardFieldUris, _postBridgeUris, _legacyCheckoutUris, _buttonJSUrls;
        var config = {
            locales: constants.A,
            scriptUrl: "//www.paypalobjects.com/api/checkout.lib.js",
            paypal_domain_regex: /^(https?|mock):\/\/[a-zA-Z0-9_.-]+\.paypal\.com(:\d+)?$/,
            version: "4.0.338",
            cors: !0,
            env: "undefined" == typeof window || void 0 === window.location ? constants.t.PRODUCTION : -1 !== window.location.host.indexOf("localhost.paypal.com") ? constants.t.LOCAL : -1 !== window.location.host.indexOf("qa.paypal.com") ? constants.t.STAGE : -1 !== window.location.host.indexOf("sandbox.paypal.com") ? constants.t.SANDBOX : "production",
            state: "checkoutjs",
            locale: {
                country: constants.r.US,
                lang: constants.y.EN
            },
            stage: "msmaster",
            stageDomain: "qa.paypal.com",
            get stageUrl() {
                return "www." + config.stage + "." + config.stageDomain;
            },
            get apiStageUrl() {
                return "www." + config.apiStage + "." + config.stageDomain;
            },
            get localSDKUrl() {
                var scripts = [].slice.call(document.getElementsByTagName("script"));
                for (var _i2 = 0; _i2 < scripts.length; _i2++) {
                    var script = scripts[_i2];
                    if (config.env === constants.t.LOCAL && script.src.match(/checkout(\.min)?\.js$/)) return script.src;
                }
            },
            get localSDKDomain() {
                var localSDKUrl = config.localSDKUrl;
                if (localSDKUrl) return new URL(localSDKUrl).origin;
            },
            get localhostUrl() {
                return config.localSDKDomain || "http://localhost.paypal.com:" + config.ports.default;
            },
            set localhostUrl(val) {
                delete this.localhostUrl;
                this.localhostUrl = val;
            },
            merchantID: "",
            authCode: "",
            logLevel: "warn",
            throttles: {
                v4_mobile_device: 0
            },
            domain_settings: {
                "walmart.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ulta.com": {
                    disable_venmo: !0
                },
                "barnesandnoble.com": {
                    disable_venmo: !0
                },
                "bn.com": {
                    disable_venmo: !0
                },
                "agoratix.com": {
                    disable_venmo: !0
                },
                "tractorsupply.com": {
                    disable_venmo: !0
                },
                "etsy.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ticketmaster.com": {
                    disable_venmo: !0
                },
                "livenation.com": {
                    disable_venmo: !0
                },
                "frontgatetickets.com": {
                    disable_venmo: !0
                },
                "williams-sonoma.com": {
                    disable_venmo: !0
                },
                "westelm.com": {
                    disable_venmo: !0
                },
                "markandgraham.com": {
                    disable_venmo: !0
                },
                "potterybarn.com": {
                    disable_venmo: !0
                },
                "potterybarnkids.com": {
                    disable_venmo: !0
                },
                "pbteen.com": {
                    disable_venmo: !0
                },
                "beallsflorida.com": {
                    disable_venmo: !0
                },
                "therealreal.com": {
                    disable_venmo: !0
                },
                "liveaquaria.com": {
                    disable_venmo: !0
                },
                "drsfostersmith.com": {
                    disable_venmo: !0
                },
                "boxed.com": {
                    disable_venmo: !0
                },
                "bevisible.com": {
                    disable_venmo: !0
                },
                "moeller.org": {
                    disable_venmo: !0
                },
                "searshometownstores.com": {
                    disable_venmo: !0
                },
                "searshardwarestores.com": {
                    disable_venmo: !0
                },
                "searshomeapplianceshowroom.com": {
                    disable_venmo: !0
                },
                "barkshop.com": {
                    disable_venmo: !0
                },
                "vividseats.com": {
                    disable_venmo: !0
                },
                "getcargo.today": {
                    disable_venmo: !0
                },
                "smartdestinations.com": {
                    disable_venmo: !0
                },
                "philadelphiapass.com": {
                    disable_venmo: !0
                },
                "thesydneypass.com": {
                    disable_venmo: !0
                },
                "3secondlash.com": {
                    disable_venmo: !0
                },
                "newyorkpass.com": {
                    disable_venmo: !0
                },
                "dndbeyond.com": {
                    disable_venmo: !0
                },
                "app.zapbuy.it": {
                    disable_venmo: !0
                },
                "gamersaloon.com": {
                    disable_venmo: !0
                },
                "1800contacts.com": {
                    disable_venmo: !0
                },
                "shopchatters.ca": {
                    disable_venmo: !0
                },
                "shopguyswin.ca": {
                    disable_venmo: !0
                },
                "jjill.com": {
                    disable_venmo: !0
                },
                "qvc.com": {
                    disable_venmo: !0
                },
                "stelladot.com": {
                    disable_venmo: !0
                },
                "keepcollective.com": {
                    disable_venmo: !0
                },
                "everskin.com": {
                    disable_venmo: !0
                },
                "zulily.com": {
                    disable_venmo: !0
                },
                "freshly.com": {
                    disable_venmo: !0
                },
                "buypeticare.com": {
                    disable_venmo: !0
                },
                "getownzone.com": {
                    disable_venmo: !0
                },
                "uncommongoods.com": {
                    disable_venmo: !0
                },
                "onegold.com": {
                    disable_venmo: !0
                },
                "universitytees.com": {
                    disable_venmo: !0
                },
                "revolve.com": {
                    disable_venmo: !0
                },
                "functionofbeauty.com": {
                    disable_venmo: !0
                },
                "givebutter.com": {
                    disable_venmo: !0
                },
                "hausmart.com": {
                    disable_venmo: !0
                },
                "derbyjackpot.com": {
                    disable_venmo: !0
                },
                "ancestry.com": {
                    disable_venmo: !0
                },
                "boats.net": {
                    disable_venmo: !0
                },
                "partzilla.com": {
                    disable_venmo: !0
                },
                "firedog.com": {
                    disable_venmo: !0
                },
                "chick-fil-a.com": {
                    disable_venmo: !0
                },
                "roku.com": {
                    disable_venmo: !0
                },
                "barkbox.com": {
                    disable_venmo: !0
                },
                "neimanmarcus.com": {
                    disable_venmo: !0
                },
                "lastcall.com": {
                    disable_venmo: !0
                },
                "horchow.com": {
                    disable_venmo: !0
                },
                "bergdorfgoodman.com": {
                    disable_venmo: !0
                },
                "fwrd.com": {
                    disable_venmo: !0
                },
                "plunderdesign.com": {
                    disable_venmo: !0
                },
                "stitchfix.com": {
                    disable_venmo: !0
                },
                "revzilla.com": {
                    disable_venmo: !0
                },
                "cyclegear.com": {
                    disable_venmo: !0
                },
                "chegg.com": {
                    disable_venmo: !0
                },
                "youniqueproducts.com": {
                    disable_venmo: !0
                },
                "archives.com": {
                    disable_venmo: !0
                },
                "hautelook.com": {
                    disable_venmo: !0
                },
                "nordstromrack.com": {
                    disable_venmo: !0
                },
                "motherhoodcanada.ca": {
                    disable_venmo: !0
                },
                "atomtickets.com": {
                    disable_venmo: !0
                },
                "trademore.com": {
                    disable_venmo: !0
                },
                "lasheaseoffer.com": {
                    disable_venmo: !0
                },
                "rookie.paypalsixthman.com": {
                    disable_venmo: !0
                },
                "1800Contacts.com": {
                    disable_venmo: !0
                },
                "hulu.com": {
                    disable_venmo: !0
                },
                "grubhub.com": {
                    disable_venmo: !0
                },
                "eat24.com": {
                    disable_venmo: !0
                },
                "seamless.com": {
                    disable_venmo: !0
                },
                "freshfeetscrubber.com": {
                    disable_venmo: !0
                },
                "opensky.com": {
                    disable_venmo: !0
                },
                "dotandbo.com": {
                    disable_venmo: !0
                },
                "storenvy.com": {
                    disable_venmo: !0
                },
                "gemafina.com": {
                    disable_venmo: !0
                },
                "pickperfect.com": {
                    disable_venmo: !0
                },
                "55mulberry.com": {
                    disable_venmo: !0
                },
                "hollar.com": {
                    disable_venmo: !0
                },
                "bjs.com": {
                    disable_venmo: !0
                },
                "playsugarhouse.com": {
                    disable_venmo: !0
                },
                "lakeshorelearning.com": {
                    disable_venmo: !0
                },
                "llmhq.com": {
                    disable_venmo: !0
                },
                "gainful.com": {
                    disable_venmo: !0
                },
                "modaoperandi.com": {
                    disable_venmo: !0
                },
                "play.jackpocket.com": {
                    disable_venmo: !0
                },
                "crepeerase.com": {
                    disable_venmo: !0
                },
                "specificbeauty.com": {
                    disable_venmo: !0
                },
                "meaningfulbeauty.com": {
                    disable_venmo: !0
                },
                "smileactives.com ": {
                    disable_venmo: !0
                },
                "mally.com": {
                    disable_venmo: !0
                },
                "westmorebeauty.com": {
                    disable_venmo: !0
                },
                "subd.com": {
                    disable_venmo: !0
                },
                "seacalmskin.com": {
                    disable_venmo: !0
                },
                "whittier.edu": {
                    disable_venmo: !0
                },
                "curology.com": {
                    disable_venmo: !0
                },
                "monoprice.com": {
                    disable_venmo: !0
                },
                "dominos.com": {
                    disable_venmo: !0
                },
                "audiobooks.com": {
                    disable_venmo: !0
                },
                "1aauto.com": {
                    disable_venmo: !0
                },
                "greatwolf.com": {
                    disable_venmo: !0
                },
                "cvs.com": {
                    disable_venmo: !0
                },
                "gilt.com": {
                    disable_venmo: !0
                },
                "ruelala.com": {
                    disable_venmo: !0
                },
                "shopdisney.com": {
                    disable_venmo: !0
                },
                "disneycruise.disney.go.com": {
                    disable_venmo: !0
                },
                "disneyland.disney.go.com": {
                    disable_venmo: !0
                },
                "disneyworld.disney.go.com": {
                    disable_venmo: !0
                },
                "disneyaulani.com": {
                    disable_venmo: !0
                },
                "6abc.com": {
                    disable_venmo: !0
                },
                "abc30.com": {
                    disable_venmo: !0
                },
                "abc7.com": {
                    disable_venmo: !0
                },
                "abc7chicago.com": {
                    disable_venmo: !0
                },
                "abcnewsvideosource.com": {
                    disable_venmo: !0
                },
                "aetndigital.com": {
                    disable_venmo: !0
                },
                "araca.com.au": {
                    disable_venmo: !0
                },
                "disney.com": {
                    disable_venmo: !0
                },
                "espncustomercare.com": {
                    disable_venmo: !0
                },
                "makerstudios.com": {
                    disable_venmo: !0
                },
                "abc.org": {
                    disable_venmo: !0
                },
                "dclnews.com": {
                    disable_venmo: !0
                },
                "disneyanimation.com": {
                    disable_venmo: !0
                },
                "espncricinfo.com": {
                    disable_venmo: !0
                },
                "fort-pierce.net": {
                    disable_venmo: !0
                },
                "nationalgeographic.com": {
                    disable_venmo: !0
                },
                "nhl.tv": {
                    disable_venmo: !0
                },
                "pixar.com": {
                    disable_venmo: !0
                },
                "xgames.com": {
                    disable_venmo: !0
                },
                "espnwsummit.com": {
                    disable_venmo: !0
                },
                "plus.espn.com": {
                    disable_venmo: !0
                },
                "disneyplus.com": {
                    disable_venmo: !0
                }
            },
            creditTestDomains: [ "bluesuncorp.co.uk", "nationsphotolab.com", "plexusworldwide.com", "nshss.org", "bissell.com", "mobstub.com", "vuoriclothing.com", "tape4backup.com", "avivamiento.com", "rhododendron.org", "whiterabbitjapan.com", "atsracing.net", "thehilltopgallery.com", "weedtraqr.com", "worldpantry.com", "ciraconnect.com", "mymalls.com", "prowinch.com", "zodiacpoolsystems.com", "everlywell.com", "candlewarmers.com", "chop.edu", "incruises.com", "flikn.com", "didforsale.com", "mcc.org", "sygu.net", "merchbar.com", "eduinconline.com", "us.livebetterwith.com", "bakemeawish.com", "judolaunch.com", "eventcartel.com", "tapatalk.com", "telescope.com", "covenant.edu", "aquatruwater.com", "spingo.com", "usu.edu", "getcelerity.com", "brandless.com", "saberigniter.com", "euromodeltrains.com", "gofasttrader.com", "megamodzplanet.com", "draftanalyzer.com", "lovewithoutboundaries.com", "filterpop.com", "seekverify.com", "photoandgo.com", "sightseeingpass.com", "bigoanddukes.com", "thethirstyduck.com", "thebrushguys.com", "907delivery.com", "mauisails.com", "drive.net", "channelmax.net", "modernrebelco.com", "enchanteddiamonds.com", "ibabbleon.com", "fullgenomes.com", "conn-comp.com", "wingware.com", "paradigmgoods.com", "theneptunegroup.com", "kidzartworks.com", "unirealm.com", "ncfarmsinc.com", "oneofakindantiques.com", "servers4less.com", "stumpthespread.com", "marketwagon.com", "monsterhouseplans.com", "canterburychoral.org", "teacupnordic.org", "thethirstyduck.com", "medialoot.com", "theartistunion.com", "yourglamourzone.com", "breckstables.com", "mackephotography.com", "dsaj.org", "massluminosity.com", "tespa.org", "versatilearts.net", "yecup.org", "divinebusinessmanagement.com", "captivatebeautyservices.com", "class4me.com", "wcsonlineuniversity.com", "pvplive.com", "kyneteks.com", "rare-paper.com", "bpg.bpgsim.biz", "geodegallery.com", "way.com", "kringle.com", "talentedmrsalas.ph", "litcharts.com", "purpletreephotography.com", "apache.org", "neopackage.com", "globaldance.tv", "integral.studio", "airdoctorpro.com", "ivoryandiron.com", "yuengling.com", "averysbranchfarms.com", "amberreinink.com", "skinnymechocolate.com", "bmbl.net", "ncwatercolor.net", "astrograph.com", "localadventures.mx", "ripcurl.com", "worldfootbrakechallenge.com", "shespeakssales.com", "obrienguitars.com", "jadenikkolephoto.com", "americavoice.com", "cassiexie.com", "aamastateconvention.org", "rellesflorist.com", "passionnobby.com", "bodybyheidi.com", "roqos.com", "prijector.com", "maryswanson.net", "tsghobbies.com", "erinlaytonphotography.com", "darter.org", "fountainpenhospital.com", "myzestfullife.com", "pcog.org", "alisabethdesigns.com", "katiemathisphoto.com", "strictlybellaphotography.com", "maptools.com", "sites.google.com", "gallerr.com", "southfloridatrikke.com", "caviar.tv", "mintingmasters.com", "prospectorsguild.com", "inktale.com", "prettygirlgoods.com", "laceycahill.com", "daniellenowak.com", "t212.org", "scmsinc.com", "babypaloozanc.com", "tetrisonline.com", "grdd.net", "cdspg.info", "airshipapparel.com", "waft.com", "extendpets.com", "supplyhub.com", "hlbsusa.com", "jaderollerbeauty.com", "theparentingjunkie.com", "schagringas.com", "yourscribemate.com", "sportscollectibles.com", "thedivinenoise.com", "hometeamsonline.com", "trademarkpress.com", "destinationenglish.us", "jacquesflowers.com", "aliszhatchphotography.com", "rusticfoundry.com", "ahhhmassage.net", "frezzor.com", "mandelininc.com", "kayleejackson.com", "monkinstitute.org", "eddiebsbbq.com", "morningstarmediaservices.com", "kinevative.com", "orivet.com", "digitalprinthouse.net", "dynamicgenius.com", "allpartsusa.com", "flowersbydavid.net", "nwvoices.org", "leaptrade.com", "tulsaschoolpics.com", "alioth.io", "windowflair.com", "vitcom.net", "simplybeautifulfashions.com", "christinabenton.com", "fromthedaughter.com", "hometowngraphics.net", "fibanalysis.com", "creativejobscentral.com", "sandbox.gg", "jt-digitalmedia.com", "kodable.com", "birthingstone.com", "taranicholephoto.com", "hillyfieldsflorist.com", "charitynoelphoto.com", "auxdelicesfoods.com", "terilynnphotography.com", "folieadeuxevents.com", "karensfloral.com", "montgomerydiveclub.com", "rainbowplastics.com", "confettionthedancefloor.com", "vomozmedia.com", "neatmod.com", "getnaturafled.com", "callingpost.com", "iamfamily.org", "pedigreeonline.com", "typeboost.io", "in-n-outpetdoor.com", "nerdstockgc.com", "keiadmin.com", "createdbykaui.com", "aikophoto.com", "lonestar.ink", "stlfurs.com", "treasurelistings.com", "thecubicle.us", "redclaypaper.com", "blushhousemedia.com", "documentsanddesigns.com", "whitneyleighphotography.shootproof.com", "amaryllisday.com", "hermanproav.com", "felicemedia.com", "withloveplacenta.com", "store.brgadgets.co", "klowephoto.com", "spenceraustinconsulting.com", "sno-eagles.org", "dsatallahassee.org", "bakupages.com", "neswc.com", "josiebrooksphotography.com", "brisksale.com", "legalwhoosh.com", "jasmineeaster.com", "swatstudios.com", "facebook.com", "shakershell.com", "alexiswinslow.com", "mixeddimensions.com", "sweetpproductions.com", "lbeaphotography.com", "otlseatfillers.com", "jdtickets.com", "catholicar.com", "masque.com", "smalltownstudio.net", "goherbalife.com", "itzyourz.com", "magazinespeedloader.com", "dreammachines.io", "dallasdieteticalliance.org", "http:", "medair.org", "unbridledambition.com", "sarasprints.com", "wiperecord.com", "showmyrabbit.com", "cctrendsshop.com", "rachelalessandra.com", "otherworld-apothecary.com", "melissaannphoto.com", "girlceo.co", "seasidemexico.com", "telosid.com", "instin.com", "marinecorpsmustang.org", "lancityconnect.com", "hps1.org", "karenware.com", "livecurriculum.com", "spellingstars.com", "vektorfootball.com", "zaltv.com", "nebraskamayflower.org", "ethiopianspices.com", "immitranslate.com", "rafaelmagic.com.com", "bahc1.org", "newenamel.com", "bhchp.org", "buybulkamerica.com", "sourcepoint.com", "squarestripsports.com", "wix.com", "wilderootsphotography.com", "goodsalt.com", "systemongrid.com", "designmil.org", "freshtrendhq.com", "valisimofashions.com", "buyneatly.com", "getbeauty.us", "intellimidia.com" ],
            customCountry: !1,
            SUPPORTED_BROWSERS: {
                msie: "11",
                firefox: "43",
                chrome: "41",
                safari: "8",
                opera: "23",
                msedge: "14",
                samsungBrowser: "2.1",
                silk: "59.3",
                ucbrowser: "10.0.0.488",
                vivaldi: "1.91"
            },
            session_uid_lifetime: 3e5,
            _apiStage: "",
            get apiStage() {
                return config._apiStage || config.stage;
            },
            set apiStage(value) {
                config._apiStage = value;
            },
            ports: {
                default: 8e3,
                button: 8e3,
                checkout: 8e3,
                guest: 8001,
                altpay: 3e3
            },
            get paypalUrls() {
                var _ref;
                return (_ref = {})[constants.t.LOCAL] = config.localhostUrl, _ref[constants.t.STAGE] = "https://" + config.stageUrl, 
                _ref[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref;
            },
            get paypalDomains() {
                var _ref2;
                return (_ref2 = {})[constants.t.LOCAL] = config.localhostUrl, _ref2[constants.t.STAGE] = "https://" + config.stageUrl, 
                _ref2[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref2[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref2[constants.t.TEST] = "mock://www.paypal.com", _ref2[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref2;
            },
            get wwwApiUrls() {
                var _ref3;
                return (_ref3 = {})[constants.t.LOCAL] = config.localSDKDomain || "https://" + config.stageUrl, 
                _ref3[constants.t.STAGE] = "https://" + config.stageUrl, _ref3[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", 
                _ref3[constants.t.PRODUCTION] = "https://www.paypal.com", _ref3[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref3;
            },
            get corsApiUrls() {
                var _ref4;
                return (_ref4 = {})[constants.t.LOCAL] = "https://" + config.stageUrl, _ref4[constants.t.STAGE] = "https://" + config.apiStageUrl + ":12326", 
                _ref4[constants.t.SANDBOX] = "https://cors.api.sandbox.paypal.com", _ref4[constants.t.PRODUCTION] = "https://cors.api.paypal.com", 
                _ref4[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref4;
            },
            get apiUrls() {
                var _ref5;
                var domain = window.location.protocol + "//" + window.location.host;
                var corsApiUrls = config.corsApiUrls;
                var wwwApiUrls = config.wwwApiUrls;
                return (_ref5 = {})[constants.t.LOCAL] = domain === wwwApiUrls.local ? wwwApiUrls.local : corsApiUrls.local, 
                _ref5[constants.t.STAGE] = domain === wwwApiUrls.stage ? wwwApiUrls.stage : corsApiUrls.stage, 
                _ref5[constants.t.SANDBOX] = domain === wwwApiUrls.sandbox ? wwwApiUrls.sandbox : corsApiUrls.sandbox, 
                _ref5[constants.t.PRODUCTION] = domain === wwwApiUrls.production ? wwwApiUrls.production : corsApiUrls.production, 
                _ref5[constants.t.TEST] = domain === wwwApiUrls.test ? wwwApiUrls.test : corsApiUrls.test, 
                _ref5;
            },
            get checkoutUri() {
                return null;
            },
            set checkoutUri(val) {
                delete this.checkoutUri;
                this.checkoutUri = val;
            },
            get checkoutUris() {
                var _ref7;
                if (config.checkoutUri) {
                    var _ref6;
                    return (_ref6 = {})[constants.t.LOCAL] = config.checkoutUri, _ref6[constants.t.STAGE] = config.checkoutUri, 
                    _ref6[constants.t.SANDBOX] = config.checkoutUri, _ref6[constants.t.PRODUCTION] = config.checkoutUri, 
                    _ref6[constants.t.TEST] = config.checkoutUri, _ref6[constants.t.DEMO] = config.checkoutUri, 
                    _ref6;
                }
                return (_ref7 = {})[constants.t.LOCAL] = "/webapps/hermes", _ref7[constants.t.STAGE] = "/webapps/hermes", 
                _ref7[constants.t.SANDBOX] = "/checkoutnow", _ref7[constants.t.PRODUCTION] = "/checkoutnow", 
                _ref7[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
                _ref7[constants.t.DEMO] = "/demo/dev/checkout.htm", _ref7;
            },
            altpayUris: (_altpayUris = {}, _altpayUris[constants.t.LOCAL] = "/latinumcheckout", 
            _altpayUris[constants.t.STAGE] = "/latinumcheckout", _altpayUris[constants.t.SANDBOX] = "/latinumcheckout", 
            _altpayUris[constants.t.PRODUCTION] = "/latinumcheckout", _altpayUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
            _altpayUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _altpayUris),
            guestUris: (_guestUris = {}, _guestUris[constants.t.LOCAL] = "/webapps/xoonboarding", 
            _guestUris[constants.t.STAGE] = "/webapps/xoonboarding", _guestUris[constants.t.SANDBOX] = "/webapps/xoonboarding", 
            _guestUris[constants.t.PRODUCTION] = "/webapps/xoonboarding", _guestUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?guesturl=true", 
            _guestUris[constants.t.DEMO] = "/demo/dev/guest.htm", _guestUris),
            billingUris: (_billingUris = {}, _billingUris[constants.t.LOCAL] = "/webapps/hermes/agreements", 
            _billingUris[constants.t.STAGE] = "/webapps/hermes/agreements", _billingUris[constants.t.SANDBOX] = "/agreements/approve", 
            _billingUris[constants.t.PRODUCTION] = "/agreements/approve", _billingUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?billingurl=true", 
            _billingUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _billingUris),
            buttonUris: (_buttonUris = {}, _buttonUris[constants.t.LOCAL] = "/smart/button", 
            _buttonUris[constants.t.STAGE] = "/smart/button", _buttonUris[constants.t.SANDBOX] = "/smart/button", 
            _buttonUris[constants.t.PRODUCTION] = "/smart/button", _buttonUris[constants.t.TEST] = "/base/test/windows/button/index.htm", 
            _buttonUris[constants.t.DEMO] = "/demo/dev/button.htm", _buttonUris),
            inlinedCardFieldUris: (_inlinedCardFieldUris = {}, _inlinedCardFieldUris[constants.t.LOCAL] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.STAGE] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.SANDBOX] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.PRODUCTION] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.TEST] = "/base/test/windows/card-fields/index.htm", 
            _inlinedCardFieldUris[constants.t.DEMO] = "/demo/dev/card.htm", _inlinedCardFieldUris),
            postBridgeUris: (_postBridgeUris = {}, _postBridgeUris[constants.t.LOCAL] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.STAGE] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.SANDBOX] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.PRODUCTION] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.TEST] = "/base/test/windows/component-meta/index.htm", 
            _postBridgeUris[constants.t.DEMO] = "/demo/dev/bridge.htm", _postBridgeUris),
            legacyCheckoutUris: (_legacyCheckoutUris = {}, _legacyCheckoutUris[constants.t.LOCAL] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.STAGE] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.SANDBOX] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.PRODUCTION] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.TEST] = "#fallback", _legacyCheckoutUris),
            buttonJSUrls: (_buttonJSUrls = {}, _buttonJSUrls[constants.t.LOCAL] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.STAGE] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.SANDBOX] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.PRODUCTION] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.TEST] = "/base/test/lib/button.js", _buttonJSUrls[constants.t.DEMO] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls),
            get buttonJSUrl() {
                return config.buttonJSUrls[config.env];
            },
            loginUri: "/signin/",
            hermesLoggerUri: "/webapps/hermes/api/logger",
            loggerUri: "/xoplatform/logger/api/logger",
            loggerThrottlePercentage: 1,
            pptmUri: "/tagmanager/pptm.js",
            get postBridgeUri() {
                return config.postBridgeUris[config.env] + "?xcomponent=1";
            },
            paymentStandardUri: "/webapps/xorouter?cmd=_s-xclick",
            authApiUri: "/v1/oauth2/token",
            paymentApiUri: "/v1/payments/payment",
            orderApiUri: "/v2/checkout/orders",
            billingApiUri: "/v1/billing-agreements/agreement-tokens",
            experienceApiUri: "/v1/payment-experience/web-profiles",
            trackingApiUri: "/v1/risk/transaction-contexts",
            get checkoutUrls() {
                var _ref8;
                var paypalUrls = config.paypalUrls;
                return (_ref8 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.checkoutUris.local.replace(":" + config.ports.default, ":" + config.ports.checkout), 
                _ref8[constants.t.STAGE] = "" + paypalUrls.stage + config.checkoutUris.stage, _ref8[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.checkoutUris.sandbox, 
                _ref8[constants.t.PRODUCTION] = "" + paypalUrls.production + config.checkoutUris.production, 
                _ref8[constants.t.TEST] = "" + paypalUrls.test + config.checkoutUris.test, _ref8[constants.t.DEMO] = "" + paypalUrls.test + config.checkoutUris.demo, 
                _ref8;
            },
            get guestUrls() {
                var _ref9;
                var paypalUrls = config.paypalUrls;
                return (_ref9 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.guest) + config.guestUris.local, 
                _ref9[constants.t.STAGE] = "" + paypalUrls.stage + config.guestUris.stage, _ref9[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.guestUris.sandbox, 
                _ref9[constants.t.PRODUCTION] = "" + paypalUrls.production + config.guestUris.production, 
                _ref9[constants.t.TEST] = "" + paypalUrls.test + config.guestUris.test, _ref9[constants.t.DEMO] = "" + paypalUrls.test + config.guestUris.demo, 
                _ref9;
            },
            get altpayUrls() {
                var _ref10;
                var paypalUrls = config.paypalUrls;
                return (_ref10 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.altpay) + config.altpayUris.local, 
                _ref10[constants.t.STAGE] = "" + paypalUrls.stage + config.altpayUris.stage, _ref10[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.altpayUris.sandbox, 
                _ref10[constants.t.PRODUCTION] = "" + paypalUrls.production + config.altpayUris.production, 
                _ref10[constants.t.TEST] = "" + paypalUrls.test + config.altpayUris.test, _ref10[constants.t.DEMO] = "" + paypalUrls.test + config.altpayUris.demo, 
                _ref10;
            },
            get billingUrls() {
                var _ref11;
                var paypalUrls = config.paypalUrls;
                return (_ref11 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.checkout) + config.billingUris.local, 
                _ref11[constants.t.STAGE] = "" + paypalUrls.stage + config.billingUris.stage, _ref11[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.billingUris.sandbox, 
                _ref11[constants.t.PRODUCTION] = "" + paypalUrls.production + config.billingUris.production, 
                _ref11[constants.t.TEST] = "" + paypalUrls.test + config.billingUris.test, _ref11[constants.t.DEMO] = "" + paypalUrls.test + config.billingUris.demo, 
                _ref11;
            },
            get buttonUrls() {
                var _ref12;
                var paypalUrls = config.paypalUrls;
                return (_ref12 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.buttonUris.local, 
                _ref12[constants.t.STAGE] = "" + paypalUrls.stage + config.buttonUris.stage, _ref12[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.buttonUris.sandbox, 
                _ref12[constants.t.PRODUCTION] = "" + paypalUrls.production + config.buttonUris.production, 
                _ref12[constants.t.TEST] = "" + paypalUrls.test + config.buttonUris.test, _ref12[constants.t.DEMO] = "" + paypalUrls.demo + config.buttonUris.demo, 
                _ref12;
            },
            get inlinedCardFieldUrls() {
                var _ref13;
                var paypalUrls = config.paypalUrls;
                return (_ref13 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.inlinedCardFieldUris.local, 
                _ref13[constants.t.STAGE] = "" + paypalUrls.stage + config.inlinedCardFieldUris.stage, 
                _ref13[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.inlinedCardFieldUris.sandbox, 
                _ref13[constants.t.PRODUCTION] = "" + paypalUrls.production + config.inlinedCardFieldUris.production, 
                _ref13[constants.t.TEST] = "" + paypalUrls.test + config.inlinedCardFieldUris.test, 
                _ref13[constants.t.DEMO] = "" + paypalUrls.demo + config.inlinedCardFieldUris.demo, 
                _ref13;
            },
            get loginUrls() {
                var _ref14;
                var paypalUrls = config.paypalUrls;
                return (_ref14 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.loginUri, 
                _ref14[constants.t.STAGE] = "" + paypalUrls.stage + config.loginUri, _ref14[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.loginUri, 
                _ref14[constants.t.PRODUCTION] = "" + paypalUrls.production + config.loginUri, _ref14[constants.t.TEST] = "" + paypalUrls.test + config.loginUri, 
                _ref14;
            },
            get paymentsStandardUrls() {
                var _ref15;
                var paypalUrls = config.paypalUrls;
                return (_ref15 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.paymentStandardUri, 
                _ref15[constants.t.STAGE] = "" + paypalUrls.stage + config.paymentStandardUri, _ref15[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.paymentStandardUri, 
                _ref15[constants.t.PRODUCTION] = "" + paypalUrls.production + config.paymentStandardUri, 
                _ref15[constants.t.TEST] = "" + paypalUrls.test + config.paymentStandardUri, _ref15;
            },
            get metaFrameUrls() {
                var _ref16;
                var paypalUrls = config.paypalUrls;
                return (_ref16 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.postBridgeUri + "&env=local", 
                _ref16[constants.t.STAGE] = "" + paypalUrls.stage + config.postBridgeUri + "&env=stage&stage=" + config.stage, 
                _ref16[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.postBridgeUri + "&env=sandbox", 
                _ref16[constants.t.PRODUCTION] = "" + paypalUrls.production + config.postBridgeUri + "&env=production", 
                _ref16[constants.t.TEST] = "" + paypalUrls.test + config.postBridgeUri + "&env=test", 
                _ref16[constants.t.DEMO] = "" + paypalUrls.demo + config.postBridgeUri + "&env=demo", 
                _ref16;
            },
            get legacyCheckoutUrls() {
                var _ref17;
                var paypalUrls = config.paypalUrls;
                return (_ref17 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.legacyCheckoutUris.local, 
                _ref17[constants.t.STAGE] = "" + paypalUrls.stage + config.legacyCheckoutUris.stage, 
                _ref17[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.legacyCheckoutUris.sandbox, 
                _ref17[constants.t.PRODUCTION] = "" + paypalUrls.production + config.legacyCheckoutUris.production, 
                _ref17[constants.t.TEST] = "" + paypalUrls.test + config.legacyCheckoutUris.test, 
                _ref17;
            },
            get authApiUrls() {
                var _ref18;
                var apiUrls = config.apiUrls;
                var authApiUri = config.authApiUri;
                return (_ref18 = {})[constants.t.LOCAL] = "" + apiUrls.local + authApiUri, _ref18[constants.t.STAGE] = "" + apiUrls.stage + authApiUri, 
                _ref18[constants.t.SANDBOX] = "" + apiUrls.sandbox + authApiUri, _ref18[constants.t.PRODUCTION] = "" + apiUrls.production + authApiUri, 
                _ref18[constants.t.TEST] = "" + apiUrls.test + authApiUri, _ref18;
            },
            get paymentApiUrls() {
                var _ref19;
                var apiUrls = config.apiUrls;
                var paymentApiUri = config.paymentApiUri;
                return (_ref19 = {})[constants.t.LOCAL] = "" + apiUrls.local + paymentApiUri, _ref19[constants.t.STAGE] = "" + apiUrls.stage + paymentApiUri, 
                _ref19[constants.t.SANDBOX] = "" + apiUrls.sandbox + paymentApiUri, _ref19[constants.t.PRODUCTION] = "" + apiUrls.production + paymentApiUri, 
                _ref19[constants.t.TEST] = "" + apiUrls.test + paymentApiUri, _ref19;
            },
            get orderApiUrls() {
                var _ref20;
                var apiUrls = config.apiUrls;
                var orderApiUri = config.orderApiUri;
                return (_ref20 = {})[constants.t.LOCAL] = "" + apiUrls.local + orderApiUri, _ref20[constants.t.STAGE] = "" + apiUrls.stage + orderApiUri, 
                _ref20[constants.t.SANDBOX] = "" + apiUrls.sandbox + orderApiUri, _ref20[constants.t.PRODUCTION] = "" + apiUrls.production + orderApiUri, 
                _ref20[constants.t.TEST] = "" + apiUrls.test + orderApiUri, _ref20;
            },
            get billingApiUrls() {
                var _ref21;
                var apiUrls = config.apiUrls;
                var billingApiUri = config.billingApiUri;
                return (_ref21 = {})[constants.t.LOCAL] = "" + apiUrls.local + billingApiUri, _ref21[constants.t.STAGE] = "" + apiUrls.stage + billingApiUri, 
                _ref21[constants.t.SANDBOX] = "" + apiUrls.sandbox + billingApiUri, _ref21[constants.t.PRODUCTION] = "" + apiUrls.production + billingApiUri, 
                _ref21[constants.t.TEST] = "" + apiUrls.test + billingApiUri, _ref21;
            },
            get experienceApiUrls() {
                var _ref22;
                var apiUrls = config.apiUrls;
                var experienceApiUri = config.experienceApiUri;
                return (_ref22 = {})[constants.t.LOCAL] = "" + apiUrls.local + experienceApiUri, 
                _ref22[constants.t.STAGE] = "" + apiUrls.stage + experienceApiUri, _ref22[constants.t.SANDBOX] = "" + apiUrls.sandbox + experienceApiUri, 
                _ref22[constants.t.PRODUCTION] = "" + apiUrls.production + experienceApiUri, _ref22[constants.t.TEST] = "" + apiUrls.test + experienceApiUri, 
                _ref22;
            },
            get trackingApiUrls() {
                var _ref23;
                var apiUrls = config.apiUrls;
                var trackingApiUri = config.trackingApiUri;
                return (_ref23 = {})[constants.t.LOCAL] = "" + apiUrls.local + trackingApiUri, _ref23[constants.t.STAGE] = "" + apiUrls.stage + trackingApiUri, 
                _ref23[constants.t.SANDBOX] = "" + apiUrls.sandbox + trackingApiUri, _ref23[constants.t.PRODUCTION] = "" + apiUrls.production + trackingApiUri, 
                _ref23[constants.t.TEST] = "" + apiUrls.test + trackingApiUri, _ref23;
            },
            _paypalUrl: "",
            get paypalUrl() {
                return this._paypalUrl || config.paypalUrls[config.env];
            },
            set paypalUrl(value) {
                this._paypalUrl = value;
            },
            get paypalDomain() {
                return config.paypalDomains[config.env];
            },
            get corsApiUrl() {
                return config.corsApiUrls[config.env];
            },
            get wwwApiUrl() {
                return config.wwwApiUrls[config.env];
            },
            get apiUrl() {
                var domain = window.location.protocol + "//" + window.location.host;
                var wwwApiUrl = config.wwwApiUrl;
                return domain === wwwApiUrl ? wwwApiUrl : config.corsApiUrl;
            },
            get checkoutUrl() {
                return "" + config.paypalUrl + config.checkoutUris[config.env];
            },
            get billingUrl() {
                return "" + config.paypalUrl + config.billingUris[config.env];
            },
            get buttonUrl() {
                return "" + config.paypalUrl + config.buttonUris[config.env];
            },
            get legacyCheckoutUrl() {
                return config.legacyCheckoutUrls[config.env];
            },
            get postBridgeUrl() {
                return "" + config.paypalUrl + config.postBridgeUri;
            },
            get postBridgeDomain() {
                return "" + config.paypalDomain;
            },
            get loggerUrl() {
                var isTestExperiment = Math.random() < config.loggerThrottlePercentage;
                return "" + config.paypalUrl + (isTestExperiment ? config.loggerUri : config.hermesLoggerUri);
            },
            get pptmUrl() {
                return "" + config.paypalUrls[config.env] + config.pptmUri;
            },
            get authApiUrl() {
                return "" + config.apiUrl + config.authApiUri;
            },
            get paymentApiUrl() {
                return "" + config.apiUrl + config.paymentApiUri;
            },
            get orderApiUrl() {
                return "" + config.apiUrl + config.orderApiUri;
            },
            get billingApiUrl() {
                return "" + config.apiUrl + config.billingApiUri;
            },
            get experienceApiUrl() {
                return "" + config.apiUrl + config.experienceApiUri;
            },
            defaultLocale: {
                country: constants.r.US,
                lang: constants.y.EN
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return appendChild;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return getElement;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return elementReady;
        }));
        __webpack_require__.d(__webpack_exports__, "I", (function() {
            return popup;
        }));
        __webpack_require__.d(__webpack_exports__, "Y", (function() {
            return writeToWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "X", (function() {
            return writeElementToWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return awaitFrameLoad;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return awaitFrameWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return iframe;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return addEventListener;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return extendUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "Q", (function() {
            return showElement;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return hideElement;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return destroyElement;
        }));
        __webpack_require__.d(__webpack_exports__, "P", (function() {
            return showAndAnimate;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return animateAndHide;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addClass;
        }));
        __webpack_require__.d(__webpack_exports__, "L", (function() {
            return removeClass;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return getCurrentScriptDir;
        }));
        __webpack_require__.d(__webpack_exports__, "W", (function() {
            return watchElementForClose;
        }));
        __webpack_require__.d(__webpack_exports__, "J", (function() {
            return prefetchPage;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return jsxDom;
        }));
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "H", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return memoize;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return debounce;
        }));
        __webpack_require__.d(__webpack_exports__, "N", (function() {
            return serializeFunctions;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return deserializeFunctions;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return denodeify;
        }));
        __webpack_require__.d(__webpack_exports__, "K", (function() {
            return promisify;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return dasherizeToCamel;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return extend;
        }));
        __webpack_require__.d(__webpack_exports__, "U", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return get;
        }));
        __webpack_require__.d(__webpack_exports__, "M", (function() {
            return replaceObject;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return copyProp;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return dotify;
        }));
        __webpack_require__.d(__webpack_exports__, "R", (function() {
            return stringify;
        }));
        __webpack_require__.d(__webpack_exports__, "S", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return eventEmitter;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return isPerc;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return isPx;
        }));
        __webpack_require__.d(__webpack_exports__, "T", (function() {
            return toCSS;
        }));
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return normalizeDimension;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return memoized;
        }));
        __webpack_require__.d(__webpack_exports__, "O", (function() {
            return setLogLevel;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return info;
        }));
        __webpack_require__.d(__webpack_exports__, "V", (function() {
            return warn;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return logger_error;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return globalFor;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return global;
        }));
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(7);
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_safe_weakmap_src = __webpack_require__(17);
        var error = __webpack_require__(25);
        function urlEncode(str) {
            return str.replace(/\?/g, "%3F").replace(/&/g, "%26").replace(/#/g, "%23").replace(/\+/g, "%2B");
        }
        function dasherizeToCamel(string) {
            return string.replace(/-([a-z])/g, (function(g) {
                return g[1].toUpperCase();
            }));
        }
        function extend(obj, source) {
            if (!source) return obj;
            for (var key in source) source.hasOwnProperty(key) && (obj[key] = source[key]);
            return obj;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        function get(item, path, def) {
            if (!path) return def;
            var pathParts = path.split(".");
            for (var i = 0; i < pathParts.length; i++) {
                if ("object" != typeof item || null === item) return def;
                item = item[pathParts[i]];
            }
            return void 0 === item ? def : item;
        }
        function replaceObject(item, replacers, fullKey) {
            void 0 === fullKey && (fullKey = "");
            if (Array.isArray(item)) {
                var length = item.length;
                var result = [];
                var _loop = function(i) {
                    Object.defineProperty(result, i, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var itemKey = fullKey ? fullKey + "." + i : "" + i;
                            var child = item[i];
                            var replacer = replacers[typeof child];
                            if (replacer) {
                                var replaced = replacer(child, i, itemKey);
                                if (void 0 !== replaced) {
                                    result[i] = replaced;
                                    return result[i];
                                }
                            }
                            if ("object" == typeof child && null !== child) {
                                result[i] = replaceObject(child, replacers, itemKey);
                                return result[i];
                            }
                            result[i] = child;
                            return result[i];
                        },
                        set: function(value) {
                            delete result[i];
                            result[i] = value;
                        }
                    });
                };
                for (var i = 0; i < length; i++) _loop(i);
                return result;
            }
            if ("object" == typeof item && null !== item) {
                var _result = {};
                var _loop2 = function(key) {
                    if (!item.hasOwnProperty(key)) return "continue";
                    Object.defineProperty(_result, key, {
                        configurable: !0,
                        enumerable: !0,
                        get: function() {
                            var itemKey = fullKey ? fullKey + "." + key : "" + key;
                            var child = item[key];
                            var replacer = replacers[typeof child];
                            if (replacer) {
                                var replaced = replacer(child, key, itemKey);
                                if (void 0 !== replaced) {
                                    _result[key] = replaced;
                                    return _result[key];
                                }
                            }
                            if ("object" == typeof child && null !== child) {
                                _result[key] = replaceObject(child, replacers, itemKey);
                                return _result[key];
                            }
                            _result[key] = child;
                            return _result[key];
                        },
                        set: function(value) {
                            delete _result[key];
                            _result[key] = value;
                        }
                    });
                };
                for (var key in item) _loop2(key);
                return _result;
            }
            throw new Error("Pass an object or array");
        }
        function copyProp(source, target, name, def) {
            if (source.hasOwnProperty(name)) {
                var descriptor = Object.getOwnPropertyDescriptor(source, name);
                Object.defineProperty(target, name, descriptor);
            } else target[name] = def;
        }
        function dotify(obj, prefix, newobj) {
            void 0 === prefix && (prefix = "");
            void 0 === newobj && (newobj = {});
            prefix = prefix ? prefix + "." : prefix;
            for (var key in obj) null != obj[key] && "function" != typeof obj[key] && (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every((function(val) {
                return "object" != typeof val;
            })) ? newobj["" + prefix + key] = obj[key].join(",") : obj[key] && "object" == typeof obj[key] ? newobj = dotify(obj[key], "" + prefix + key, newobj) : newobj["" + prefix + key] = obj[key].toString());
            return newobj;
        }
        var objectIDs = new cross_domain_safe_weakmap_src.a;
        function getObjectID(obj) {
            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
            var uid = objectIDs.get(obj);
            if (!uid) {
                uid = typeof obj + ":" + uniqueID();
                objectIDs.set(obj, uid);
            }
            return uid;
        }
        function stringify(item) {
            return "string" == typeof item ? item : item && "function" == typeof item.toString ? item.toString() : {}.toString.call(item);
        }
        function stringifyError(err) {
            if (err) {
                var stack = err.stack, message = err.message;
                if ("string" == typeof stack) return stack;
                if ("string" == typeof message) return message;
            }
            return stringify(err);
        }
        function eventEmitter() {
            var triggered = {};
            var handlers = {};
            return {
                on: function(eventName, handler) {
                    var handlerList = handlers[eventName] = handlers[eventName] || [];
                    handlerList.push(handler);
                    var cancelled = !1;
                    return {
                        cancel: function() {
                            if (!cancelled) {
                                cancelled = !0;
                                handlerList.splice(handlerList.indexOf(handler), 1);
                            }
                        }
                    };
                },
                once: function(eventName, handler) {
                    var listener = this.on(eventName, (function() {
                        listener.cancel();
                        handler();
                    }));
                    return listener;
                },
                trigger: function(eventName) {
                    var handlerList = handlers[eventName];
                    if (handlerList) for (var _i3 = 0; _i3 < handlerList.length; _i3++) (0, handlerList[_i3])();
                },
                triggerOnce: function(eventName) {
                    if (!triggered[eventName]) {
                        triggered[eventName] = !0;
                        this.trigger(eventName);
                    }
                }
            };
        }
        function noop() {}
        function once(method) {
            var called = !1;
            var result;
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                if (called) return result;
                called = !0;
                return result = method.apply(this, arguments);
            };
        }
        function memoize(method) {
            var results = {};
            return function() {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                var cacheKey;
                try {
                    cacheKey = JSON.stringify([].slice.call(arguments), (function(key, val) {
                        return "function" == typeof val ? "zoid:memoize[" + getObjectID(val) + "]" : val;
                    }));
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                results.hasOwnProperty(cacheKey) || (results[cacheKey] = method.apply(this, arguments));
                return results[cacheKey];
            };
        }
        function debounce(method, time) {
            void 0 === time && (time = 100);
            var timeout;
            return function() {
                var _arguments = arguments, _this = this;
                clearTimeout(timeout);
                timeout = setTimeout((function() {
                    return method.apply(_this, _arguments);
                }), time);
            };
        }
        function serializeFunctions(obj) {
            return replaceObject(obj, {
                function: function() {
                    return {
                        __type__: "__function__"
                    };
                }
            });
        }
        function deserializeFunctions(obj, handler) {
            return replaceObject(obj, {
                object: function(value, key, fullKey) {
                    if (value && "__function__" === value.__type__) return function() {
                        return handler({
                            key: key,
                            fullKey: fullKey,
                            self: this,
                            args: arguments
                        });
                    };
                }
            });
        }
        function appendChild(container, child) {
            container.appendChild(child);
        }
        function getElementSafe(id) {
            if (function(element) {
                return element instanceof window.Element || null !== element && "object" == typeof element && 1 === element.nodeType && "object" == typeof element.style && "object" == typeof element.ownerDocument;
            }(id)) return id;
            if ("string" == typeof id) {
                var element = document.getElementById(id);
                if (element) return element;
                document.querySelector && (element = document.querySelector(id));
                if (element) return element;
            }
        }
        function getElement(id) {
            var element = getElementSafe(id);
            if (element) return element;
            throw new Error("Can not find element: " + stringify(id));
        }
        new zalgo_promise_src.a((function(resolve) {
            if ("complete" === window.document.readyState) return resolve(window.document);
            var interval = setInterval((function() {
                if ("complete" === window.document.readyState) {
                    clearInterval(interval);
                    return resolve(window.document);
                }
            }), 10);
        }));
        function isDocumentReady() {
            return "complete" === window.document.readyState;
        }
        function elementReady(id) {
            return new zalgo_promise_src.a((function(resolve, reject) {
                var name = stringify(id);
                var el = getElementSafe(id);
                if (el) return resolve(el);
                if (isDocumentReady()) return reject(new Error("Document is ready and element " + name + " does not exist"));
                var interval = setInterval((function() {
                    if (el = getElementSafe(id)) {
                        clearInterval(interval);
                        return resolve(el);
                    }
                    if (isDocumentReady()) {
                        clearInterval(interval);
                        return reject(new Error("Document is ready and element " + name + " does not exist"));
                    }
                }), 10);
            }));
        }
        function popup(url, options) {
            var params = Object.keys(options).map((function(key) {
                if (options[key]) return key + "=" + stringify(options[key]);
            })).filter(Boolean).join(",");
            var win;
            try {
                win = window.open(url, options.name, params, !0);
            } catch (err) {
                throw new error.b("Can not open popup window - " + (err.stack || err.message));
            }
            if (Object(src.z)(win)) {
                var err;
                throw new error.b("Can not open popup window - blocked");
            }
            return win;
        }
        function writeToWindow(win, html) {
            try {
                win.document.open();
                win.document.write(html);
                win.document.close();
            } catch (err) {
                try {
                    win.location = "javascript: document.open(); document.write(" + JSON.stringify(html) + "); document.close();";
                } catch (err2) {}
            }
        }
        function writeElementToWindow(win, el) {
            var tag = el.tagName.toLowerCase();
            if ("html" !== tag) throw new Error("Expected element to be html, got " + tag);
            var documentElement = win.document.documentElement;
            for (;documentElement.children && documentElement.children.length; ) documentElement.removeChild(documentElement.children[0]);
            for (;el.children.length; ) documentElement.appendChild(el.children[0]);
        }
        function setStyle(el, styleText, doc) {
            void 0 === doc && (doc = window.document);
            el.styleSheet ? el.styleSheet.cssText = styleText : el.appendChild(doc.createTextNode(styleText));
        }
        var awaitFrameLoadPromises = new cross_domain_safe_weakmap_src.a;
        function awaitFrameLoad(frame) {
            if (awaitFrameLoadPromises.has(frame)) {
                var _promise = awaitFrameLoadPromises.get(frame);
                if (_promise) return _promise;
            }
            var promise = new zalgo_promise_src.a((function(resolve, reject) {
                frame.addEventListener("load", (function() {
                    Object(src.A)(frame);
                    resolve(frame);
                }));
                frame.addEventListener("error", (function(err) {
                    frame.contentWindow ? resolve(frame) : reject(err);
                }));
            }));
            awaitFrameLoadPromises.set(frame, promise);
            return promise;
        }
        function awaitFrameWindow(frame) {
            return frame.contentWindow ? zalgo_promise_src.a.resolve(frame.contentWindow) : awaitFrameLoad(frame).then((function(loadedFrame) {
                if (!loadedFrame.contentWindow) throw new Error("Could not find window in iframe");
                return loadedFrame.contentWindow;
            }));
        }
        function iframe(options, container) {
            void 0 === options && (options = {});
            var el = getElement(container);
            var attributes = options.attributes || {};
            var style = options.style || {};
            var frame = function(tag, options, container) {
                void 0 === tag && (tag = "div");
                void 0 === options && (options = {});
                tag = tag.toLowerCase();
                var element = document.createElement(tag);
                options.style && extend(element.style, options.style);
                options.class && (element.className = options.class.join(" "));
                if (options.attributes) for (var _i2 = 0, _Object$keys2 = Object.keys(options.attributes); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    element.setAttribute(key, options.attributes[key]);
                }
                options.styleSheet && setStyle(element, options.styleSheet);
                if (options.html) {
                    if ("iframe" === tag) throw new Error("Iframe html can not be written unless container provided and iframe in DOM");
                    element.innerHTML = options.html;
                }
                return element;
            }("iframe", {
                attributes: Object(esm_extends.a)({
                    frameBorder: "0",
                    allowTransparency: "true"
                }, attributes),
                style: Object(esm_extends.a)({
                    backgroundColor: "transparent"
                }, style),
                html: options.html,
                class: options.class
            });
            awaitFrameLoad(frame);
            el.appendChild(frame);
            (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) && frame.setAttribute("src", options.url || "about:blank");
            return frame;
        }
        function addEventListener(obj, event, handler) {
            obj.addEventListener(event, handler);
            return {
                cancel: function() {
                    obj.removeEventListener(event, handler);
                }
            };
        }
        var parseQuery = memoize((function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) throw new Error("Can not parse query string params: " + queryString);
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        }));
        function extendQuery(originalQuery, props) {
            void 0 === props && (props = {});
            return props && Object.keys(props).length ? function(obj) {
                void 0 === obj && (obj = {});
                return Object.keys(obj).filter((function(key) {
                    return "string" == typeof obj[key];
                })).map((function(key) {
                    return urlEncode(key) + "=" + urlEncode(obj[key]);
                })).join("&");
            }(Object(esm_extends.a)({}, parseQuery(originalQuery), props)) : originalQuery;
        }
        function extendUrl(url, options) {
            void 0 === options && (options = {});
            var query = options.query || {};
            var hash = options.hash || {};
            var originalUrl;
            var originalHash;
            var _url$split = url.split("#");
            originalHash = _url$split[1];
            var _originalUrl$split = (originalUrl = _url$split[0]).split("?");
            originalUrl = _originalUrl$split[0];
            var queryString = extendQuery(_originalUrl$split[1], query);
            var hashString = extendQuery(originalHash, hash);
            queryString && (originalUrl = originalUrl + "?" + queryString);
            hashString && (originalUrl = originalUrl + "#" + hashString);
            return originalUrl;
        }
        function bindEvents(element, eventNames, handler) {
            handler = once(handler);
            for (var _i8 = 0; _i8 < eventNames.length; _i8++) element.addEventListener(eventNames[_i8], handler);
            return {
                cancel: once((function() {
                    for (var _i10 = 0; _i10 < eventNames.length; _i10++) element.removeEventListener(eventNames[_i10], handler);
                }))
            };
        }
        var VENDOR_PREFIXES = [ "webkit", "moz", "ms", "o" ];
        function setVendorCSS(element, name, value) {
            element.style[name] = value;
            var capitalizedName = (string = name).charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            var string;
            for (var _i12 = 0; _i12 < VENDOR_PREFIXES.length; _i12++) element.style["" + VENDOR_PREFIXES[_i12] + capitalizedName] = value;
        }
        var CSSRule = window.CSSRule;
        var KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE;
        var ANIMATION_START_EVENTS = [ "animationstart", "webkitAnimationStart", "oAnimationStart", "MSAnimationStart" ];
        var ANIMATION_END_EVENTS = [ "animationend", "webkitAnimationEnd", "oAnimationEnd", "MSAnimationEnd" ];
        function animate(element, name, clean, timeout) {
            void 0 === timeout && (timeout = 1e3);
            return new zalgo_promise_src.a((function(resolve, reject) {
                var el = getElement(element);
                if (!el || !function(element, name) {
                    var stylesheets = element.ownerDocument.styleSheets;
                    try {
                        for (var i = 0; i < stylesheets.length; i++) {
                            var cssRules = stylesheets[i].cssRules;
                            if (cssRules) for (var j = 0; j < cssRules.length; j++) {
                                var cssRule = cssRules[j];
                                if (cssRule && cssRule.type === KEYFRAMES_RULE && cssRule.name === name) return !0;
                            }
                        }
                    } catch (err) {
                        return !1;
                    }
                    return !1;
                }(el, name)) return resolve();
                var hasStarted = !1;
                var startTimeout;
                var endTimeout;
                var startEvent;
                var endEvent;
                function cleanUp() {
                    setVendorCSS(el, "animationName", "");
                    clearTimeout(startTimeout);
                    clearTimeout(endTimeout);
                    startEvent.cancel();
                    endEvent.cancel();
                }
                startEvent = bindEvents(el, ANIMATION_START_EVENTS, (function(event) {
                    if (event.target === el && event.animationName === name) {
                        clearTimeout(startTimeout);
                        event.stopPropagation();
                        startEvent.cancel();
                        hasStarted = !0;
                        endTimeout = setTimeout((function() {
                            cleanUp();
                            resolve();
                        }), timeout);
                    }
                }));
                endEvent = bindEvents(el, ANIMATION_END_EVENTS, (function(event) {
                    if (event.target === el && event.animationName === name) {
                        cleanUp();
                        return "string" == typeof event.animationName && event.animationName !== name ? reject("Expected animation name to be " + name + ", found " + event.animationName) : resolve();
                    }
                }));
                setVendorCSS(el, "animationName", name);
                startTimeout = setTimeout((function() {
                    if (!hasStarted) {
                        cleanUp();
                        return resolve();
                    }
                }), 200);
                clean && clean(cleanUp);
            }));
        }
        function showElement(element) {
            element.style.setProperty("display", "");
        }
        function hideElement(element) {
            element.style.setProperty("display", "none", "important");
        }
        function destroyElement(element) {
            element.parentNode && element.parentNode.removeChild(element);
        }
        function showAndAnimate(element, name, clean) {
            var animation = animate(element, name, clean);
            showElement(element);
            return animation;
        }
        function animateAndHide(element, name, clean) {
            return animate(element, name, clean).then((function() {
                hideElement(element);
            }));
        }
        function addClass(element, name) {
            element.classList ? element.classList.add(name) : -1 === element.className.split(/\s+/).indexOf(name) && (element.className += " " + name);
        }
        function removeClass(element, name) {
            element.classList ? element.classList.remove(name) : -1 !== element.className.split(/\s+/).indexOf(name) && (element.className = element.className.replace(name, ""));
        }
        function getCurrentScriptDir() {
            console.warn("Do not use zoid.getCurrentScriptDir() in production -- browser support is limited");
            return document.currentScript ? document.currentScript.src.split("/").slice(0, -1).join("/") : ".";
        }
        function isElementClosed(el) {
            return !el || !el.parentNode;
        }
        function watchElementForClose(element, handler) {
            handler = once(handler);
            var interval;
            isElementClosed(element) ? handler() : interval = function(method, time) {
                var timeout;
                timeout = setTimeout((function runInterval() {
                    timeout = setTimeout(runInterval, 50);
                    method.call();
                }), 50);
                return {
                    cancel: function() {
                        clearTimeout(timeout);
                    }
                };
            }((function() {
                if (isElementClosed(element)) {
                    interval.cancel();
                    handler();
                }
            }));
            return {
                cancel: function() {
                    interval && interval.cancel();
                }
            };
        }
        function prefetchPage(url) {
            return function(url) {
                return function(contentType, url) {
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        var req = new window.XMLHttpRequest;
                        req.open("GET", url);
                        req.setRequestHeader("Accept", "text/html");
                        req.send(null);
                        req.onload = function() {
                            resolve(req.responseText);
                        };
                        req.onerror = function() {
                            return reject(new Error("prefetch failed"));
                        };
                    }));
                }(0, url);
            }(url);
        }
        var JSX_EVENTS = {
            onClick: "click"
        };
        function fixScripts(el, doc) {
            void 0 === doc && (doc = window.document);
            for (var _i14 = 0, _querySelectorAll2 = function(el, selector) {
                return [].slice.call(el.querySelectorAll("script"));
            }(el); _i14 < _querySelectorAll2.length; _i14++) {
                var script = _querySelectorAll2[_i14];
                var newScript = doc.createElement("script");
                newScript.text = script.textContent;
                script.parentNode.replaceChild(newScript, script);
            }
        }
        function jsxDom(name, props, content) {
            name = name.toLowerCase();
            var doc = this && this.createElement ? this : window.document;
            var el = doc.createElement(name);
            for (var prop in props) if (prop in JSX_EVENTS) el.addEventListener(JSX_EVENTS[prop], props[prop]); else if ("innerHTML" === prop) {
                el.innerHTML = props[prop];
                fixScripts(el, doc);
            } else el.setAttribute(prop, props[prop]);
            if ("style" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                setStyle(el, content, doc);
            } else if ("iframe" === name) {
                if (arguments.length > 3) throw new Error("Expected only single child node for iframe");
                el.addEventListener("load", (function() {
                    var win = el.contentWindow;
                    if (!win) throw new Error("Expected frame to have contentWindow");
                    "string" == typeof content ? writeToWindow(win, content) : writeElementToWindow(win, content);
                }));
            } else if ("script" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                el.text = content;
            } else for (var i = 2; i < arguments.length; i++) if ("string" == typeof arguments[i]) {
                var textNode = doc.createTextNode(arguments[i]);
                appendChild(el, textNode);
            } else appendChild(el, arguments[i]);
            return el;
        }
        function denodeify(method) {
            return function() {
                var self = this;
                var args = [].slice.call(arguments);
                return args.length >= method.length ? zalgo_promise_src.a.resolve(method.apply(self, args)) : new zalgo_promise_src.a((function(resolve, reject) {
                    args.push((function(err, result) {
                        if (err && !(err instanceof Error)) throw new Error("Passed non-Error object in callback: [ " + err + " ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).");
                        return err ? reject(err) : resolve(result);
                    }));
                    method.apply(self, args);
                }));
            };
        }
        function promisify(method) {
            return function() {
                var _arguments = arguments, _this = this;
                return zalgo_promise_src.a.try((function() {
                    return method.apply(_this, _arguments);
                }));
            };
        }
        function isPerc(str) {
            return "string" == typeof str && /^[0-9]+%$/.test(str);
        }
        function isPx(str) {
            return "string" == typeof str && /^[0-9]+px$/.test(str);
        }
        function toNum(val) {
            if ("number" == typeof val) return val;
            var match = val.match(/^([0-9]+)(px|%)$/);
            if (!match) throw new Error("Could not match css value from " + val);
            return parseInt(match[1], 10);
        }
        function toPx(val) {
            return toNum(val) + "px";
        }
        function toCSS(val) {
            return "number" == typeof val ? toPx(val) : isPerc(val) ? val : toPx(val);
        }
        function normalizeDimension(dim, max) {
            if ("number" == typeof dim) return dim;
            if (isPerc(dim)) return parseInt(max * toNum(dim) / 100, 10);
            if (isPx(dim)) return toNum(dim);
            throw new Error("Can not normalize dimension: " + dim);
        }
        function memoized(target, name, descriptor) {
            var method = descriptor.value;
            descriptor.value = function() {
                this.__memoized__ = this.__memoized__ || {};
                this.__memoized__.hasOwnProperty(name) || (this.__memoized__[name] = method.apply(this, arguments));
                return this.__memoized__[name];
            };
            descriptor.value.displayName = name + ":memoized";
        }
        var post_robot_src = __webpack_require__(15);
        var client = __webpack_require__(4);
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            client.e.logLevel = logLevel;
            post_robot_src.CONFIG.LOG_LEVEL = logLevel;
            window.LOG_LEVEL = logLevel;
        }
        function info(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.k)("xc_" + name + "_" + event, payload);
        }
        function warn(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.q)("xc_" + name + "_" + event, payload);
        }
        function logger_error(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.g)("xc_" + name + "_" + event, payload);
        }
        var constants = __webpack_require__(8);
        function globalFor(win) {
            if (Object(src.v)(win)) {
                win[constants.__ZOID__] || (win[constants.__ZOID__] = {});
                return win[constants.__ZOID__];
            }
        }
        var global = function() {
            var global = globalFor(window);
            if (!global) throw new Error("Could not get local global");
            return global;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return getParent;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return getOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getActualDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return getDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return isActuallySameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return isSameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return assertSameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return getFrames;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return getTop;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getAllFramesInWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return isTop;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return isWindowClosed;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return linkFrameWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return getUserAgent;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return getFrameByName;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return findFrameByName;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return isOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return getAncestor;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return isAncestor;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return isPopup;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return isIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return getDistanceFromTop;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return getNthParentFromTop;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return isSameTopWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return matchDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return stringifyDomainPattern;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getDomainFromUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return onCloseWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return isWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return PROTOCOL;
        }));
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var PROTOCOL = {
            MOCK: "mock:",
            FILE: "file:",
            ABOUT: "about:"
        };
        var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
        function getActualProtocol(win) {
            void 0 === win && (win = window);
            return win.location.protocol;
        }
        function getProtocol(win) {
            void 0 === win && (win = window);
            if (win.mockDomain) {
                var protocol = win.mockDomain.split("//")[0];
                if (protocol) return protocol;
            }
            return getActualProtocol(win);
        }
        function isAboutProtocol(win) {
            void 0 === win && (win = window);
            return getProtocol(win) === PROTOCOL.ABOUT;
        }
        function getParent(win) {
            void 0 === win && (win = window);
            if (win) try {
                if (win.parent && win.parent !== win) return win.parent;
            } catch (err) {}
        }
        function getOpener(win) {
            void 0 === win && (win = window);
            if (win && !getParent(win)) try {
                return win.opener;
            } catch (err) {}
        }
        function canReadFromWindow(win) {
            try {
                return !0;
            } catch (err) {}
            return !1;
        }
        function getActualDomain(win) {
            void 0 === win && (win = window);
            var location = win.location;
            if (!location) throw new Error("Can not read window location");
            var protocol = getActualProtocol(win);
            if (!protocol) throw new Error("Can not read window protocol");
            if (protocol === PROTOCOL.FILE) return PROTOCOL.FILE + "//";
            if (protocol === PROTOCOL.ABOUT) {
                var parent = getParent(win);
                return parent && canReadFromWindow() ? getActualDomain(parent) : PROTOCOL.ABOUT + "//";
            }
            var host = location.host;
            if (!host) throw new Error("Can not read window host");
            return protocol + "//" + host;
        }
        function getDomain(win) {
            void 0 === win && (win = window);
            var domain = getActualDomain(win);
            return domain && win.mockDomain && 0 === win.mockDomain.indexOf(PROTOCOL.MOCK) ? win.mockDomain : domain;
        }
        function isActuallySameDomain(win) {
            try {
                if (win === window) return !0;
            } catch (err) {}
            try {
                var desc = Object.getOwnPropertyDescriptor(win, "location");
                if (desc && !1 === desc.enumerable) return !1;
            } catch (err) {}
            try {
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
            } catch (err) {}
            try {
                if (function(win) {
                    void 0 === win && (win = window);
                    return getProtocol(win) === PROTOCOL.MOCK;
                }(win) && canReadFromWindow()) return !0;
            } catch (err) {}
            try {
                if (getActualDomain(win) === getActualDomain(window)) return !0;
            } catch (err) {}
            return !1;
        }
        function isSameDomain(win) {
            if (!isActuallySameDomain(win)) return !1;
            try {
                if (win === window) return !0;
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                if (getDomain(window) === getDomain(win)) return !0;
            } catch (err) {}
            return !1;
        }
        function assertSameDomain(win) {
            if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
            return win;
        }
        function isAncestorParent(parent, child) {
            if (!parent || !child) return !1;
            var childParent = getParent(child);
            return childParent ? childParent === parent : -1 !== function(win) {
                var result = [];
                try {
                    for (;win.parent !== win; ) {
                        result.push(win.parent);
                        win = win.parent;
                    }
                } catch (err) {}
                return result;
            }(child).indexOf(parent);
        }
        function getFrames(win) {
            var result = [];
            var frames;
            try {
                frames = win.frames;
            } catch (err) {
                frames = win;
            }
            var len;
            try {
                len = frames.length;
            } catch (err) {}
            if (0 === len) return result;
            if (len) {
                for (var i = 0; i < len; i++) {
                    var frame = void 0;
                    try {
                        frame = frames[i];
                    } catch (err) {
                        continue;
                    }
                    result.push(frame);
                }
                return result;
            }
            for (var _i = 0; _i < 100; _i++) {
                var _frame = void 0;
                try {
                    _frame = frames[_i];
                } catch (err) {
                    return result;
                }
                if (!_frame) return result;
                result.push(_frame);
            }
            return result;
        }
        function getAllChildFrames(win) {
            var result = [];
            for (var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++) {
                var frame = _getFrames2[_i3];
                result.push(frame);
                for (var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++) result.push(_getAllChildFrames2[_i5]);
            }
            return result;
        }
        function getTop(win) {
            void 0 === win && (win = window);
            try {
                if (win.top) return win.top;
            } catch (err) {}
            if (getParent(win) === win) return win;
            try {
                if (isAncestorParent(window, win) && window.top) return window.top;
            } catch (err) {}
            try {
                if (isAncestorParent(win, window) && window.top) return window.top;
            } catch (err) {}
            for (var _i7 = 0, _getAllChildFrames4 = getAllChildFrames(win); _i7 < _getAllChildFrames4.length; _i7++) {
                var frame = _getAllChildFrames4[_i7];
                try {
                    if (frame.top) return frame.top;
                } catch (err) {}
                if (getParent(frame) === frame) return frame;
            }
        }
        function getAllFramesInWindow(win) {
            var top = getTop(win);
            if (!top) throw new Error("Can not determine top window");
            var result = [].concat(getAllChildFrames(top), [ top ]);
            -1 === result.indexOf(win) && (result = [].concat(result, [ win ], getAllChildFrames(win)));
            return result;
        }
        function isTop(win) {
            return win === getTop(win);
        }
        var iframeWindows = [];
        var iframeFrames = [];
        function isWindowClosed(win, allowMock) {
            void 0 === allowMock && (allowMock = !0);
            try {
                if (win === window) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if (!win) return !0;
            } catch (err) {
                return !0;
            }
            try {
                if (win.closed) return !0;
            } catch (err) {
                return !err || err.message !== IE_WIN_ACCESS_ERROR;
            }
            if (allowMock && isSameDomain(win)) try {
                if (win.mockclosed) return !0;
            } catch (err) {}
            try {
                if (!win.parent || !win.top) return !0;
            } catch (err) {}
            var iframeIndex = function(collection, item) {
                for (var i = 0; i < collection.length; i++) try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }(iframeWindows, win);
            if (-1 !== iframeIndex) {
                var frame = iframeFrames[iframeIndex];
                if (frame && function(frame) {
                    if (!frame.contentWindow) return !0;
                    if (!frame.parentNode) return !0;
                    var doc = frame.ownerDocument;
                    if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                        var parent = frame;
                        for (;parent.parentNode && parent.parentNode !== parent; ) parent = parent.parentNode;
                        if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                    }
                    return !1;
                }(frame)) return !0;
            }
            return !1;
        }
        function linkFrameWindow(frame) {
            !function() {
                for (var i = 0; i < iframeWindows.length; i++) {
                    var closed = !1;
                    try {
                        closed = iframeWindows[i].closed;
                    } catch (err) {}
                    if (closed) {
                        iframeFrames.splice(i, 1);
                        iframeWindows.splice(i, 1);
                    }
                }
            }();
            if (frame && frame.contentWindow) try {
                iframeWindows.push(frame.contentWindow);
                iframeFrames.push(frame);
            } catch (err) {}
        }
        function getUserAgent(win) {
            return (win = win || window).navigator.mockUserAgent || win.navigator.userAgent;
        }
        function getFrameByName(win, name) {
            var winFrames = getFrames(win);
            for (var _i9 = 0; _i9 < winFrames.length; _i9++) {
                var childFrame = winFrames[_i9];
                try {
                    if (isSameDomain(childFrame) && childFrame.name === name && -1 !== winFrames.indexOf(childFrame)) return childFrame;
                } catch (err) {}
            }
            try {
                if (-1 !== winFrames.indexOf(win.frames[name])) return win.frames[name];
            } catch (err) {}
            try {
                if (-1 !== winFrames.indexOf(win[name])) return win[name];
            } catch (err) {}
        }
        function findFrameByName(win, name) {
            return getFrameByName(win, name) || function findChildFrameByName(win, name) {
                var frame = getFrameByName(win, name);
                if (frame) return frame;
                for (var _i11 = 0, _getFrames4 = getFrames(win); _i11 < _getFrames4.length; _i11++) {
                    var namedFrame = findChildFrameByName(_getFrames4[_i11], name);
                    if (namedFrame) return namedFrame;
                }
            }(getTop(win) || win, name);
        }
        function isOpener(parent, child) {
            return parent === getOpener(child);
        }
        function getAncestor(win) {
            void 0 === win && (win = window);
            return getOpener(win = win || window) || getParent(win) || void 0;
        }
        function isAncestor(parent, child) {
            var actualParent = getAncestor(child);
            if (actualParent) return actualParent === parent;
            if (child === parent) return !1;
            if (getTop(child) === child) return !1;
            for (var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++) if (_getFrames8[_i15] === child) return !0;
            return !1;
        }
        function isPopup(win) {
            void 0 === win && (win = window);
            return Boolean(getOpener(win));
        }
        function isIframe(win) {
            void 0 === win && (win = window);
            return Boolean(getParent(win));
        }
        function anyMatch(collection1, collection2) {
            for (var _i17 = 0; _i17 < collection1.length; _i17++) {
                var item1 = collection1[_i17];
                for (var _i19 = 0; _i19 < collection2.length; _i19++) if (item1 === collection2[_i19]) return !0;
            }
            return !1;
        }
        function getDistanceFromTop(win) {
            void 0 === win && (win = window);
            var distance = 0;
            var parent = win;
            for (;parent; ) (parent = getParent(parent)) && (distance += 1);
            return distance;
        }
        function getNthParentFromTop(win, n) {
            void 0 === n && (n = 1);
            return function(win, n) {
                void 0 === n && (n = 1);
                var parent = win;
                for (var i = 0; i < n; i++) {
                    if (!parent) return;
                    parent = getParent(parent);
                }
                return parent;
            }(win, getDistanceFromTop(win) - n);
        }
        function isSameTopWindow(win1, win2) {
            var top1 = getTop(win1) || win1;
            var top2 = getTop(win2) || win2;
            try {
                if (top1 && top2) return top1 === top2;
            } catch (err) {}
            var allFrames1 = getAllFramesInWindow(win1);
            var allFrames2 = getAllFramesInWindow(win2);
            if (anyMatch(allFrames1, allFrames2)) return !0;
            var opener1 = getOpener(top1);
            var opener2 = getOpener(top2);
            return opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2) || opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1), 
            !1;
        }
        function matchDomain(pattern, origin) {
            if ("string" == typeof pattern) {
                if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                if (isRegex(origin)) return !1;
                if (Array.isArray(origin)) return !1;
            }
            return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some((function(subpattern) {
                return matchDomain(subpattern, origin);
            })));
        }
        function stringifyDomainPattern(pattern) {
            return Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() + ")" : pattern.toString();
        }
        function getDomainFromUrl(url) {
            return url.match(/^(https?|mock|file):\/\//) ? url.split("/").slice(0, 3).join("/") : getDomain();
        }
        function onCloseWindow(win, callback, delay, maxtime) {
            void 0 === delay && (delay = 1e3);
            void 0 === maxtime && (maxtime = 1 / 0);
            var timeout;
            !function check() {
                if (isWindowClosed(win)) {
                    timeout && clearTimeout(timeout);
                    return callback();
                }
                if (maxtime <= 0) clearTimeout(timeout); else {
                    maxtime -= delay;
                    timeout = setTimeout(check, delay);
                }
            }();
            return {
                cancel: function() {
                    timeout && clearTimeout(timeout);
                }
            };
        }
        function isWindow(obj) {
            try {
                if (obj === window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if ("[object Window]" === {}.toString.call(obj)) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (window.Window && obj instanceof window.Window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.self === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.parent === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.top === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
            } catch (err) {}
            return !1;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "ZOID", (function() {
            return ZOID;
        }));
        __webpack_require__.d(__webpack_exports__, "__ZOID__", (function() {
            return __ZOID__;
        }));
        __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", (function() {
            return POST_MESSAGE;
        }));
        __webpack_require__.d(__webpack_exports__, "PROP_TYPES", (function() {
            return PROP_TYPES;
        }));
        __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", (function() {
            return INITIAL_PROPS;
        }));
        __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", (function() {
            return WINDOW_REFERENCES;
        }));
        __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", (function() {
            return PROP_TYPES_LIST;
        }));
        __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", (function() {
            return CONTEXT_TYPES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", (function() {
            return CLASS_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "EVENTS", (function() {
            return EVENTS;
        }));
        __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", (function() {
            return ATTRIBUTES;
        }));
        __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", (function() {
            return ANIMATION_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", (function() {
            return EVENT_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", (function() {
            return CLOSE_REASONS;
        }));
        __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", (function() {
            return CONTEXT_TYPES_LIST;
        }));
        __webpack_require__.d(__webpack_exports__, "DELEGATE", (function() {
            return DELEGATE;
        }));
        __webpack_require__.d(__webpack_exports__, "WILDCARD", (function() {
            return WILDCARD;
        }));
        __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", (function() {
            return DEFAULT_DIMENSIONS;
        }));
        var ZOID = "zoid";
        var __ZOID__ = "__" + ZOID + "__";
        var POST_MESSAGE = {
            INIT: ZOID + "_init",
            PROPS: ZOID + "_props",
            PROP_CALLBACK: ZOID + "_prop_callback",
            CLOSE: ZOID + "_close",
            CHECK_CLOSE: ZOID + "_check_close",
            REDIRECT: ZOID + "_redirect",
            RESIZE: ZOID + "_resize",
            DELEGATE: ZOID + "_delegate",
            ALLOW_DELEGATE: ZOID + "_allow_delegate",
            ERROR: ZOID + "_error",
            HIDE: ZOID + "_hide",
            SHOW: ZOID + "_show"
        };
        var PROP_TYPES = {
            STRING: "string",
            OBJECT: "object",
            FUNCTION: "function",
            BOOLEAN: "boolean",
            NUMBER: "number"
        };
        var INITIAL_PROPS = {
            RAW: "raw",
            UID: "uid"
        };
        var WINDOW_REFERENCES = {
            OPENER: "opener",
            TOP: "top",
            PARENT: "parent",
            GLOBAL: "global"
        };
        var PROP_TYPES_LIST = Object.keys(PROP_TYPES).map((function(key) {
            return PROP_TYPES[key];
        }));
        var CONTEXT_TYPES = {
            IFRAME: "iframe",
            POPUP: "popup"
        };
        var CLASS_NAMES = {
            ZOID: "" + ZOID,
            OUTLET: ZOID + "-outlet",
            COMPONENT_FRAME: ZOID + "-component-frame",
            PRERENDER_FRAME: ZOID + "-prerender-frame",
            VISIBLE: ZOID + "-visible",
            INVISIBLE: ZOID + "-invisible"
        };
        var EVENTS = {
            CLOSE: ZOID + "-close"
        };
        var ATTRIBUTES = {
            IFRAME_PLACEHOLDER: "data-zoid-" + ZOID + "-placeholder"
        };
        var ANIMATION_NAMES = {
            SHOW_CONTAINER: ZOID + "-show-container",
            SHOW_COMPONENT: ZOID + "-show-component",
            HIDE_CONTAINER: ZOID + "-hide-container",
            HIDE_COMPONENT: ZOID + "-hide-component"
        };
        var EVENT_NAMES = {
            CLICK: "click"
        };
        var CLOSE_REASONS = {
            PARENT_CALL: "parent_call",
            CHILD_CALL: "child_call",
            CLOSE_DETECTED: "close_detected",
            USER_CLOSED: "user_closed",
            PARENT_CLOSE_DETECTED: "parent_close_detected"
        };
        var CONTEXT_TYPES_LIST = Object.keys(CONTEXT_TYPES).map((function(key) {
            return CONTEXT_TYPES[key];
        }));
        var DELEGATE = {
            CALL_ORIGINAL: "call_original",
            CALL_DELEGATE: "call_delegate"
        };
        var WILDCARD = "*";
        var DEFAULT_DIMENSIONS = {
            WIDTH: 300,
            HEIGHT: 150
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return global;
        }));
        var _conf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
        var global = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] || {};
        global.registerSelf = function() {};
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return CONSTANTS;
        }));
        var CONSTANTS = {
            POST_MESSAGE_TYPE: {
                REQUEST: "postrobot_message_request",
                RESPONSE: "postrobot_message_response",
                ACK: "postrobot_message_ack"
            },
            POST_MESSAGE_ACK: {
                SUCCESS: "success",
                ERROR: "error"
            },
            POST_MESSAGE_NAMES: {
                METHOD: "postrobot_method",
                HELLO: "postrobot_ready",
                OPEN_TUNNEL: "postrobot_open_tunnel"
            },
            WINDOW_TYPES: {
                FULLPAGE: "fullpage",
                POPUP: "popup",
                IFRAME: "iframe"
            },
            WINDOW_PROPS: {
                POSTROBOT: "__postRobot__"
            },
            SERIALIZATION_TYPES: {
                METHOD: "postrobot_method",
                ERROR: "postrobot_error",
                PROMISE: "postrobot_promise",
                ZALGO_PROMISE: "postrobot_zalgo_promise",
                REGEX: "regex"
            },
            SEND_STRATEGIES: {
                POST_MESSAGE: "postrobot_post_message",
                BRIDGE: "postrobot_bridge",
                GLOBAL: "postrobot_global"
            },
            MOCK_PROTOCOL: "mock:",
            FILE_PROTOCOL: "file:",
            BRIDGE_NAME_PREFIX: "__postrobot_bridge__",
            POSTROBOT_PROXY: "__postrobot_proxy__",
            WILDCARD: "*"
        };
        var POST_MESSAGE_NAMES = {
            METHOD: "postrobot_method",
            HELLO: "postrobot_hello",
            OPEN_TUNNEL: "postrobot_open_tunnel"
        };
        Object.keys(POST_MESSAGE_NAMES).map((function(key) {
            return POST_MESSAGE_NAMES[key];
        }));
        var _ALLOWED_POST_MESSAGE;
        var CONFIG = {
            ALLOW_POSTMESSAGE_POPUP: !("__ALLOW_POSTMESSAGE_POPUP__" in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
            BRIDGE_TIMEOUT: 5e3,
            CHILD_WINDOW_TIMEOUT: 5e3,
            ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 1e4 : 2e3,
            RES_TIMEOUT: -1,
            ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.POST_MESSAGE] = !0, 
            _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.BRIDGE] = !0, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.GLOBAL] = !0, 
            _ALLOWED_POST_MESSAGE),
            ALLOW_SAME_ORIGIN: !1
        };
        0 === window.location.href.indexOf(CONSTANTS.FILE_PROTOCOL) && (CONFIG.ALLOW_POSTMESSAGE_POPUP = !0);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return getUserAgent;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return isDevice;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return isAndroid;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return isIos;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return isSFVC;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return device_isIE;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return isIECompHeader;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return isIEIntranet;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return supportsPopups;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return isChrome;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return isSafari;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return isLocalStorageEnabled;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return base64encode;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return values;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return identity;
        }));
        var iPhoneScreenHeightMatrix = {
            926: {
                device: "iPhone 12 Pro Max",
                textSizeHeights: [ 752, 748, 744, 738 ],
                zoomHeight: {
                    1.15: [ 752, 747, 744, 738 ],
                    1.25: [ 753, 748, 744, 738 ],
                    1.5: [ 752, 749, 744, 738 ],
                    1.75: [ 753, 747, 744, 739 ],
                    2: [ 752, 748, 744 ],
                    2.5: [ 753, 748 ],
                    3: [ 753, 744 ]
                },
                maybeSafari: {
                    2: [ 738 ],
                    2.5: [ 745, 738 ],
                    3: [ 747, 738 ]
                }
            },
            896: {
                device: "iPhone XS Max, iPhone 11 Pro Max, iPhone XR, iPhone 11",
                textSizeHeights: [ 721, 717, 713, 707 ],
                zoomHeight: {
                    1.15: [ 721, 716, 713, 707 ],
                    1.25: [ 721, 718, 713, 708 ],
                    1.5: [ 722, 717, 713 ],
                    1.75: [ 721, 718, 712, 707 ],
                    2: [ 722, 718, 714, 708 ],
                    2.5: [ 720, 718, 713, 708 ],
                    3: [ 720, 717, 708 ]
                },
                maybeSafari: {
                    1.5: [ 707 ],
                    3: [ 714 ]
                }
            },
            844: {
                device: "iPhone 12, iPhone 12 Pro",
                textSizeHeights: [ 670, 666, 662, 656 ],
                zoomHeight: {
                    1.15: [ 670, 666, 662 ],
                    1.25: [ 670, 666, 663, 656 ],
                    1.5: [ 671, 666, 662 ],
                    1.75: [ 670, 667, 662, 656 ],
                    2: [ 670, 666, 662 ],
                    2.5: [ 670, 663 ],
                    3: [ 669, 666, 663, 657 ]
                },
                maybeSafari: {
                    1.15: [ 656 ],
                    1.5: [ 656 ],
                    2: [ 656 ],
                    2.5: [ 665, 655 ],
                    3: [ 663 ]
                }
            },
            812: {
                device: "iPhone X, iPhone XS, iPhone 11 Pro, iPhone 12 Mini",
                textSizeHeights: [ 641, 637, 633, 627 ],
                zoomHeight: {
                    1.15: [ 641, 637, 633, 627 ],
                    1.25: [ 641, 638, 633, 628 ],
                    1.5: [ 641, 638, 633, 627 ],
                    1.75: [ 641, 637, 634 ],
                    2: [ 642, 638, 634, 628 ],
                    2.5: [ 640, 638, 633, 628 ],
                    3: [ 642, 633 ]
                },
                maybeSafari: {
                    1.75: [ 627 ],
                    3: [ 636, 627 ]
                }
            },
            736: {
                device: "iPhone 6 Plus, iPhone 6S Plus, iPhone 7 Plus, iPhone 8 Plus",
                textSizeHeights: [ 628, 624, 620, 614 ],
                zoomHeight: {
                    1.15: [ 628, 624, 620, 614 ],
                    1.25: [ 628, 624, 620, 614 ],
                    1.5: [ 629, 624, 620 ],
                    1.75: [ 628, 625, 620, 614 ],
                    2: [ 628, 624, 620 ],
                    2.5: [ 628, 625, 620, 615 ],
                    3: [ 627, 624, 615 ]
                },
                maybeSafari: {
                    1.5: [ 614 ],
                    2: [ 614 ],
                    3: [ 621 ]
                }
            },
            667: {
                device: "iPhone 6, iPhone 6S, iPhone 7, iPhone 8,  iPhone SE2",
                textSizeHeights: [ 559, 555, 551, 545 ],
                zoomHeight: {
                    1.15: [ 559, 555, 551, 545 ],
                    1.25: [ 559, 555, 551, 545 ],
                    1.5: [ 560, 555, 551 ],
                    1.75: [ 558, 555, 551 ],
                    2: [ 560, 556, 552, 546 ],
                    2.5: [ 560, 555, 550 ],
                    3: [ 558, 555, 546 ]
                },
                maybeSafari: {
                    1.5: [ 545 ],
                    1.75: [ 544 ],
                    2.5: [ 545 ],
                    3: [ 552 ]
                }
            }
        };
        function getUserAgent() {
            return window.navigator.mockUserAgent || window.navigator.userAgent;
        }
        function isDevice(userAgent) {
            void 0 === userAgent && (userAgent = getUserAgent());
            return !!userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i);
        }
        function isOperaMini(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Opera Mini/i.test(ua);
        }
        function isAndroid(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Android/.test(ua);
        }
        function isIos(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /iPhone|iPod|iPad/.test(ua);
        }
        function isSFVC(ua) {
            void 0 === ua && (ua = getUserAgent());
            if (isIos(ua)) {
                var device = iPhoneScreenHeightMatrix[window.outerHeight];
                if (!device) return !1;
                var height = window.innerHeight;
                var scale = Math.round(window.screen.width / window.innerWidth * 100) / 100;
                var computedHeight = Math.round(height * scale);
                return scale > 1 && device.zoomHeight[scale] ? -1 !== device.zoomHeight[scale].indexOf(computedHeight) : -1 !== device.textSizeHeights.indexOf(computedHeight);
            }
            return !1;
        }
        function device_isIE() {
            return !!window.document.documentMode || Boolean(window.navigator && window.navigator.userAgent && /Edge|MSIE|rv:11/i.test(window.navigator.userAgent));
        }
        function isIECompHeader() {
            var mHttp = window.document.querySelector('meta[http-equiv="X-UA-Compatible"]');
            var mContent = window.document.querySelector('meta[content="IE=edge"]');
            return !(!mHttp || !mContent);
        }
        function isIEIntranet() {
            if (window.document.documentMode) try {
                var status = window.status;
                window.status = "testIntranetMode";
                if ("testIntranetMode" === window.status) {
                    window.status = status;
                    return !0;
                }
                return !1;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        function supportsPopups(ua) {
            void 0 === ua && (ua = getUserAgent());
            return !(function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return !!isIos(ua) && (!!function(ua) {
                    void 0 === ua && (ua = getUserAgent());
                    return /\bGSA\b/.test(ua);
                }(ua) || /.+AppleWebKit(?!.*Safari)|.*WKWebView/.test(ua));
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return !!isAndroid(ua) && /Version\/[\d.]+/.test(ua) && !isOperaMini(ua);
            }(ua) || isOperaMini(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /FxiOS/i.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /EdgiOS/i.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /FBAN/.test(ua) || /FBAV/.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /QQBrowser/.test(ua);
            }(ua) || "undefined" != typeof process && process.versions && process.versions.electron || (userAgent = getUserAgent(), 
            /Macintosh.*AppleWebKit(?!.*Safari)/i.test(userAgent)) || !0 === window.navigator.standalone || window.matchMedia("(display-mode: standalone)").matches);
            var userAgent;
        }
        function isChrome(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Chrome|Chromium|CriOS/.test(ua);
        }
        function isSafari(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Safari/.test(ua) && !isChrome(ua);
        }
        __webpack_require__(21);
        __webpack_require__(13);
        var zalgo_promise_src = __webpack_require__(2);
        __webpack_require__(7);
        var cross_domain_safe_weakmap_src = __webpack_require__(17);
        __webpack_require__(24);
        __webpack_require__(30);
        function getFunctionName(fn) {
            return fn.name || fn.__name__ || fn.displayName || "anonymous";
        }
        function setFunctionName(fn, name) {
            try {
                delete fn.name;
                fn.name = name;
            } catch (err) {}
            fn.__name__ = fn.displayName = name;
            return fn;
        }
        function base64encode(str) {
            if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (function(m, p1) {
                return String.fromCharCode(parseInt(p1, 16));
            }))).replace(/[=]/g, "");
            if ("undefined" != typeof Buffer) return Buffer.from(str, "utf8").toString("base64").replace(/[=]/g, "");
            throw new Error("Can not find window.btoa or Buffer");
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "uid_" + "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            })) + "_" + base64encode((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }
        var objectIDs;
        function serializeArgs(args) {
            try {
                return JSON.stringify([].slice.call(args), (function(subkey, val) {
                    return "function" == typeof val ? "memoize[" + function(obj) {
                        objectIDs = objectIDs || new cross_domain_safe_weakmap_src.a;
                        if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                        var uid = objectIDs.get(obj);
                        if (!uid) {
                            uid = typeof obj + ":" + uniqueID();
                            objectIDs.set(obj, uid);
                        }
                        return uid;
                    }(val) + "]" : val;
                }));
            } catch (err) {
                throw new Error("Arguments not serializable -- can not be used to memoize");
            }
        }
        function getEmptyObject() {
            return {};
        }
        var memoizeGlobalIndex = 0;
        var memoizeGlobalIndexValidFrom = 0;
        function memoize(method, options) {
            void 0 === options && (options = {});
            var _options$thisNamespac = options.thisNamespace, thisNamespace = void 0 !== _options$thisNamespac && _options$thisNamespac, cacheTime = options.time;
            var simpleCache;
            var thisCache;
            var memoizeIndex = memoizeGlobalIndex;
            memoizeGlobalIndex += 1;
            var memoizedFunction = function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                if (memoizeIndex < memoizeGlobalIndexValidFrom) {
                    simpleCache = null;
                    thisCache = null;
                    memoizeIndex = memoizeGlobalIndex;
                    memoizeGlobalIndex += 1;
                }
                var cache;
                cache = thisNamespace ? (thisCache = thisCache || new cross_domain_safe_weakmap_src.a).getOrSet(this, getEmptyObject) : simpleCache = simpleCache || {};
                var cacheKey = serializeArgs(args);
                var cacheResult = cache[cacheKey];
                if (cacheResult && cacheTime && Date.now() - cacheResult.time < cacheTime) {
                    delete cache[cacheKey];
                    cacheResult = null;
                }
                if (cacheResult) return cacheResult.value;
                var time = Date.now();
                var value = method.apply(this, arguments);
                cache[cacheKey] = {
                    time: time,
                    value: value
                };
                return value;
            };
            memoizedFunction.reset = function() {
                simpleCache = null;
                thisCache = null;
            };
            return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
        }
        memoize.clear = function() {
            memoizeGlobalIndexValidFrom = memoizeGlobalIndex;
        };
        function noop() {}
        function once(method) {
            var called = !1;
            return setFunctionName((function() {
                if (!called) {
                    called = !0;
                    return method.apply(this, arguments);
                }
            }), getFunctionName(method) + "::once");
        }
        function values(obj) {
            if (Object.values) return Object.values(obj);
            var result = [];
            for (var key in obj) obj.hasOwnProperty(key) && result.push(obj[key]);
            return result;
        }
        memoize(values);
        function identity(item) {
            return item;
        }
        Error;
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        function isDocumentInteractive() {
            return Boolean(document.body) && "interactive" === document.readyState;
        }
        memoize((function() {
            return new zalgo_promise_src.a((function(resolve) {
                if (isDocumentReady() || isDocumentInteractive()) return resolve();
                var interval = setInterval((function() {
                    if (isDocumentReady() || isDocumentInteractive()) {
                        clearInterval(interval);
                        return resolve();
                    }
                }), 10);
            }));
        }));
        function isLocalStorageEnabled() {
            return function(method, logic, args) {
                void 0 === args && (args = []);
                var cache = method.__inline_memoize_cache__ = method.__inline_memoize_cache__ || {};
                var key = serializeArgs(args);
                return cache.hasOwnProperty(key) ? cache[key] : cache[key] = function() {
                    try {
                        if ("undefined" == typeof window) return !1;
                        if (window.localStorage) {
                            var value = Math.random().toString();
                            window.localStorage.setItem("__test__localStorage__", value);
                            var result = window.localStorage.getItem("__test__localStorage__");
                            window.localStorage.removeItem("__test__localStorage__");
                            if (value === result) return !0;
                        }
                    } catch (err) {}
                    return !1;
                }.apply(void 0, args);
            }(isLocalStorageEnabled);
        }
        var currentScript = "undefined" != typeof document ? document.currentScript : null;
        var getCurrentScript = memoize((function() {
            if (currentScript) return currentScript;
            if (currentScript = function() {
                try {
                    var stack = function() {
                        try {
                            throw new Error("_");
                        } catch (err) {
                            return err.stack || "";
                        }
                    }();
                    var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                    var scriptLocation = stackDetails && stackDetails[1];
                    if (!scriptLocation) return;
                    for (var _i22 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i22 < _Array$prototype$slic2.length; _i22++) {
                        var script = _Array$prototype$slic2[_i22];
                        if (script.src && script.src === scriptLocation) return script;
                    }
                } catch (err) {}
            }()) return currentScript;
            throw new Error("Can not determine current script");
        }));
        var currentUID = uniqueID();
        memoize((function() {
            var script;
            try {
                script = getCurrentScript();
            } catch (err) {
                return currentUID;
            }
            var uid = script.getAttribute("data-uid");
            if (uid && "string" == typeof uid) return uid;
            if ((uid = script.getAttribute("data-uid-auto")) && "string" == typeof uid) return uid;
            if (script.src) {
                var hashedString = function(str) {
                    var hash = "";
                    for (var i = 0; i < str.length; i++) {
                        var total = str[i].charCodeAt(0) * i;
                        str[i + 1] && (total += str[i + 1].charCodeAt(0) * (i - 1));
                        hash += String.fromCharCode(97 + Math.abs(total) % 26);
                    }
                    return hash;
                }(JSON.stringify({
                    src: script.src,
                    dataset: script.dataset
                }));
                uid = "uid_" + hashedString.slice(hashedString.length - 30);
            } else uid = uniqueID();
            script.setAttribute("data-uid-auto", uid);
            return uid;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return BUTTON_CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return BUTTON_RELATIVE_STYLE;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return BUTTON_STYLE;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return labelToFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return fundingToDefaultLabel;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getButtonConfig;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _logoColors, _tagLineColors, _secondaryColors, _logoColors2, _secondaryColors2, _logoColors3, _secondaryColors3, _logoColors4, _secondaryColors4, _logoColors5, _secondaryColors5, _logoColors6, _secondaryColors6, _logoColors7, _secondaryColors7, _logoColors8, _secondaryColors8, _logoColors9, _secondaryColors9, _logoColors10, _secondaryColors10, _logoColors11, _secondaryColors11, _logoColors12, _secondaryColors12, _logoColors13, _secondaryColors13, _logoColors14, _secondaryColors14, _logoColors15, _secondaryColors15, _logoColors16, _secondaryColors16, _logoColors17, _secondaryColors17, _logoColors18, _secondaryColors18, _BUTTON_CONFIG, _FUNDING_TO_DEFAULT_L, _LABEL_TO_FUNDING, _BUTTON_STYLE;
        var BUTTON_CONFIG = ((_BUTTON_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            sizes: [ _constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL, _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM, _constants__WEBPACK_IMPORTED_MODULE_0__.l.LARGE, _constants__WEBPACK_IMPORTED_MODULE_0__.l.RESPONSIVE ],
            shapes: [ _constants__WEBPACK_IMPORTED_MODULE_0__.k.PILL, _constants__WEBPACK_IMPORTED_MODULE_0__.k.RECT ],
            layouts: [ _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL, _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ],
            logoColors: (_logoColors = {}, _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors),
            tagLineColors: (_tagLineColors = {}, _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLACK, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors),
            secondaryColors: (_secondaryColors = {}, _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors),
            tag: "{ content: safer_tag }",
            dualTag: "{ content: dual_tag|safer_tag }",
            defaultLocale: {
                country: "US",
                lang: "en"
            },
            defaultLabel: _constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT,
            defaultVerticalLabel: _constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL,
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD,
            defaultSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL,
            defaultVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM,
            defaultShape: _constants__WEBPACK_IMPORTED_MODULE_0__.k.PILL,
            defaultLayout: _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL,
            defaultBranding: !0,
            defaultVerticalBranding: !0,
            defaultFundingIcons: !1,
            defaultTagline: !0,
            defaultDual: "",
            minimumSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.TINY,
            minimumVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM,
            maximumSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE,
            maximumVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE,
            minHorizontalButtons: 1,
            minVerticalButtons: 1,
            maxHorizontalButtons: 2,
            maxVerticalButtons: 6,
            allowUnbranded: !1,
            allowFundingIcons: !0,
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.PAYPAL
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT] = {
            label: "{ content: checkout }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAY] = {
            label: "{ content: pay }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BUYNOW] = {
            label: "{ content: buynow }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            defaultBranding: void 0,
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowUnbranded: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.INSTALLMENT] = {
            label: function(style) {
                return "{ content: " + (style.installmentperiod ? "installment_period" : "installment") + " }";
            },
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowSecondaryVertical: !1,
            allowSecondaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT] = {
            label: function(_ref) {
                return _ref.locale.country === _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ? "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }" : "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }";
            },
            logoLabel: function(_ref2) {
                return _ref2.locale.country === _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ? "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }" : "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }";
            },
            tag: "{ content: later_tag }",
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors2 = {}, _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors2),
            secondaryColors: (_secondaryColors2 = {}, _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors2),
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE,
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1,
            allowFundingIcons: !1,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.CREDIT
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.VENMO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.VENMO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors3 = {}, _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors3),
            secondaryColors: (_secondaryColors3 = {}, _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors3),
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ITAU + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ITAU + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK ],
            logoColors: (_logoColors4 = {}, _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4),
            secondaryColors: (_secondaryColors4 = {}, _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.IDEAL + " } Online betalen",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.IDEAL + " } Online betalen",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors5 = {}, _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors5),
            secondaryColors: (_secondaryColors5 = {}, _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors5),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ELV] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ELV + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ELV + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors6 = {}, _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors6),
            secondaryColors: (_secondaryColors6 = {}, _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors6),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BANCONTACT + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BANCONTACT + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors7 = {}, _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors7),
            secondaryColors: (_secondaryColors7 = {}, _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors7),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.GIROPAY + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.GIROPAY + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors8 = {}, _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors8),
            secondaryColors: (_secondaryColors8 = {}, _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors8),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.SOFORT + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.SOFORT + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors9 = {}, _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors9),
            secondaryColors: (_secondaryColors9 = {}, _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors9),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.EPS + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.EPS + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors10 = {}, _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors10),
            secondaryColors: (_secondaryColors10 = {}, _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors10),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MYBANK + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MYBANK + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors11 = {}, _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors11),
            secondaryColors: (_secondaryColors11 = {}, _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors11),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.P24] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.P24 + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.P24 + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors12 = {}, _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors12),
            secondaryColors: (_secondaryColors12 = {}, _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors12),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BLIK + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BLIK + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors13 = {}, _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors13),
            secondaryColors: (_secondaryColors13 = {}, _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors13),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MAXIMA + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MAXIMA + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors14 = {}, _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors14),
            secondaryColors: (_secondaryColors14 = {}, _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors14),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BOLETO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BOLETO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors15 = {}, _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors15),
            secondaryColors: (_secondaryColors15 = {}, _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors15),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.OXXO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.OXXO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors16 = {}, _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors16),
            secondaryColors: (_secondaryColors16 = {}, _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors16),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MERCADOPAGO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MERCADOPAGO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors17 = {}, _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors17),
            secondaryColors: (_secondaryColors17 = {}, _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors17),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD] = {
            label: "{ cards }",
            logoLabel: "{ cards }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT ],
            logoColors: (_logoColors18 = {}, _logoColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors18),
            secondaryColors: (_secondaryColors18 = {}, _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.CARD
        }, _BUTTON_CONFIG);
        var FUNDING_TO_DEFAULT_LABEL = ((_FUNDING_TO_DEFAULT_L = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.ELV, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.P24] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.P24, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO, 
        _FUNDING_TO_DEFAULT_L);
        var LABEL_TO_FUNDING = ((_LABEL_TO_FUNDING = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BUYNOW] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.INSTALLMENT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.P24] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO, 
        _LABEL_TO_FUNDING);
        var BUTTON_RELATIVE_STYLE = {
            FUNDINGICONS: 100,
            TAGLINE: 50,
            VERTICAL_MARGIN: 30
        };
        var BUTTON_STYLE = ((_BUTTON_STYLE = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.l.TINY] = {
            defaultWidth: 75,
            defaultHeight: 25,
            minWidth: 75,
            maxWidth: 150,
            minHeight: 25,
            maxHeight: 30,
            buttonTextMargin: .5,
            allowFunding: !0,
            allowTagline: !1,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL] = {
            defaultWidth: 150,
            defaultHeight: 25,
            minWidth: 150,
            maxWidth: 200,
            minHeight: 25,
            maxHeight: 55,
            buttonTextMargin: .5,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM] = {
            defaultWidth: 250,
            defaultHeight: 35,
            minWidth: 200,
            maxWidth: 300,
            minHeight: 35,
            maxHeight: 55,
            buttonTextMargin: 1,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.LARGE] = {
            defaultWidth: 350,
            defaultHeight: 45,
            minWidth: 300,
            maxWidth: 500,
            minHeight: 30,
            maxHeight: 55,
            buttonTextMargin: 1,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE] = {
            defaultWidth: 500,
            defaultHeight: 55,
            minWidth: 500,
            maxWidth: 750,
            minHeight: 40,
            maxHeight: 55,
            buttonTextMargin: 1.25,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE);
        function labelToFunding(label) {
            return label ? LABEL_TO_FUNDING[label] : _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL;
        }
        function fundingToDefaultLabel(funding) {
            return FUNDING_TO_DEFAULT_LABEL[funding];
        }
        function getButtonConfig(label, key, def) {
            return function(conf, category, key, def) {
                var categoryConfig = conf[category];
                if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
                if (conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s] && conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s].hasOwnProperty(key)) return conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s][key];
                if (arguments.length >= 4) return def;
                throw new Error("No value found for " + category + ":" + key);
            }(BUTTON_CONFIG, label, key, def);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _extends;
        }));
        function _extends() {
            return (_extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) ({}).hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }).apply(this, arguments);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return memoize;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return match;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return safeJSON;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return eventEmitter;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return awaitKey;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return stringifyErrorMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return domainMatches;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return patchMethod;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return extend;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return sortBy;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return identity;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return values;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return perc;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return max;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return regexMap;
        }));
        var zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
        var belter_src__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.n;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.o;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.q;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.k;
        }));
        var moduleGlobal = {};
        function getGlobal() {
            return "undefined" != typeof window || "undefined" != typeof window ? window : moduleGlobal;
        }
        function memoize(method, options) {
            void 0 === options && (options = {});
            var cache = {};
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                var key;
                try {
                    key = JSON.stringify([].slice.call(arguments));
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                var time = options.time;
                cache[key] && time && Date.now() - cache[key].time < time && delete cache[key];
                var glob = getGlobal();
                glob.__CACHE_START_TIME__ && cache[key] && cache[key].time < glob.__CACHE_START_TIME__ && delete cache[key];
                if (cache[key]) return cache[key].value;
                cache[key] = {
                    time: Date.now(),
                    value: method.apply(this, arguments)
                };
                return cache[key].value;
            };
        }
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        function safeJSON(item) {
            return JSON.stringify(item, (function(key, val) {
                if ("function" == typeof val) return "<" + typeof val + ">";
                try {
                    JSON.stringify(val);
                } catch (err) {
                    return "<" + typeof val + ">";
                }
                return val;
            }));
        }
        function eventEmitter() {
            var listeners = [];
            return {
                listen: function(method) {
                    listeners.push(method);
                    return {
                        cancel: function() {
                            listeners.splice(listeners.indexOf(method), 1);
                        }
                    };
                },
                once: function(method) {
                    var listener = this.listen((function() {
                        method.apply(null, arguments);
                        listener.cancel();
                    }));
                },
                trigger: function() {
                    for (var _i2 = 0; _i2 < listeners.length; _i2++) {
                        var listener = listeners[_i2];
                        listener.apply(void 0, arguments);
                    }
                }
            };
        }
        function awaitKey(obj, key) {
            return new zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__.a((function(resolve) {
                var value = obj[key];
                if (value) return resolve(value);
                delete obj[key];
                Object.defineProperty(obj, key, {
                    configurable: !0,
                    set: function(item) {
                        (value = item) && resolve(value);
                    },
                    get: function() {
                        return value;
                    }
                });
            }));
        }
        function stringifyError(err, level) {
            void 0 === level && (level = 1);
            if (level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack;
                    var message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        function stringifyErrorMessage(err) {
            var defaultMessage = "<unknown error: " + {}.toString.call(err) + ">";
            return err ? err instanceof Error ? err.message || defaultMessage : "string" == typeof err.message && err.message || defaultMessage : defaultMessage;
        }
        function domainMatches(hostname, domain) {
            var index = (hostname = hostname.split("://")[1]).indexOf(domain);
            return -1 !== index && hostname.slice(index) === domain;
        }
        function patchMethod(obj, name, handler) {
            var original = obj[name];
            obj[name] = function() {
                var _arguments = arguments, _this = this;
                return handler({
                    context: this,
                    args: [].slice.call(arguments),
                    original: original,
                    callOriginal: function() {
                        return original.apply(_this, _arguments);
                    }
                });
            };
        }
        function extend(obj, source) {
            if (!source) return obj;
            if (Object.assign) return Object.assign(obj, source);
            for (var _key2 in source) source.hasOwnProperty(_key2) && (obj[_key2] = source[_key2]);
            return obj;
        }
        function sortBy(arr, order) {
            return arr.sort((function(a, b) {
                return order.indexOf(a) - order.indexOf(b);
            }));
        }
        function identity(item) {
            return item;
        }
        function values(obj) {
            var result = [];
            for (var _key6 in obj) obj.hasOwnProperty(_key6) && result.push(obj[_key6]);
            return result;
        }
        function perc(pixels, percentage) {
            return Math.round(pixels * percentage / 100);
        }
        function max() {
            return Math.max.apply(Math, arguments);
        }
        function regexMap(str, regex, handler) {
            var results = [];
            str.replace(regex, (function() {
                results.push(handler.apply(null, arguments));
            }));
            return results;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "request", (function() {
            return request;
        }));
        __webpack_require__.d(__webpack_exports__, "send", (function() {
            return _send;
        }));
        __webpack_require__.d(__webpack_exports__, "sendToParent", (function() {
            return sendToParent;
        }));
        __webpack_require__.d(__webpack_exports__, "client", (function() {
            return client;
        }));
        __webpack_require__.d(__webpack_exports__, "listen", (function() {
            return listen;
        }));
        __webpack_require__.d(__webpack_exports__, "on", (function() {
            return _on;
        }));
        __webpack_require__.d(__webpack_exports__, "once", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "listener", (function() {
            return server_listener;
        }));
        __webpack_require__.d(__webpack_exports__, "CONFIG", (function() {
            return conf.a;
        }));
        __webpack_require__.d(__webpack_exports__, "CONSTANTS", (function() {
            return conf.b;
        }));
        __webpack_require__.d(__webpack_exports__, "disable", (function() {
            return disable;
        }));
        __webpack_require__.d(__webpack_exports__, "parent", (function() {
            return public_parent;
        }));
        __webpack_require__.d(__webpack_exports__, "cleanUpWindow", (function() {
            return cleanUpWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(__webpack_exports__, "bridge", (function() {
            return bridge;
        }));
        __webpack_require__.d(__webpack_exports__, "init", (function() {
            return init;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "request", (function() {
            return request;
        }));
        __webpack_require__.d(interface_namespaceObject, "send", (function() {
            return _send;
        }));
        __webpack_require__.d(interface_namespaceObject, "sendToParent", (function() {
            return sendToParent;
        }));
        __webpack_require__.d(interface_namespaceObject, "client", (function() {
            return client;
        }));
        __webpack_require__.d(interface_namespaceObject, "listen", (function() {
            return listen;
        }));
        __webpack_require__.d(interface_namespaceObject, "on", (function() {
            return _on;
        }));
        __webpack_require__.d(interface_namespaceObject, "once", (function() {
            return once;
        }));
        __webpack_require__.d(interface_namespaceObject, "listener", (function() {
            return server_listener;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONFIG", (function() {
            return conf.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONSTANTS", (function() {
            return conf.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "disable", (function() {
            return disable;
        }));
        __webpack_require__.d(interface_namespaceObject, "parent", (function() {
            return public_parent;
        }));
        __webpack_require__.d(interface_namespaceObject, "cleanUpWindow", (function() {
            return cleanUpWindow;
        }));
        __webpack_require__.d(interface_namespaceObject, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "bridge", (function() {
            return bridge;
        }));
        __webpack_require__.d(interface_namespaceObject, "init", (function() {
            return init;
        }));
        var lib = __webpack_require__(16);
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        var global = __webpack_require__(9);
        var esm_extends = __webpack_require__(13);
        var zalgo_promise_src = __webpack_require__(2);
        var SEND_MESSAGE_STRATEGIES = {};
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.POST_MESSAGE] = function(win, serializedMessage, domain) {
            try {
                __webpack_require__(43).emulateIERestrictions(window, win);
            } catch (err) {
                return;
            }
            (Array.isArray(domain) ? domain : "string" == typeof domain ? [ domain ] : [ conf.b.WILDCARD ]).map((function(dom) {
                if (0 === dom.indexOf(conf.b.MOCK_PROTOCOL)) {
                    if (window.location.protocol === conf.b.FILE_PROTOCOL) return conf.b.WILDCARD;
                    if (!Object(src.q)(win)) throw new Error("Attempting to send messsage to mock domain " + dom + ", but window is actually cross-domain");
                    return Object(src.d)(win);
                }
                return 0 === dom.indexOf(conf.b.FILE_PROTOCOL) ? conf.b.WILDCARD : dom;
            })).forEach((function(dom) {
                return win.postMessage(serializedMessage, dom);
            }));
        };
        var _require = __webpack_require__(23), sendBridgeMessage = _require.sendBridgeMessage, needsBridgeForBrowser = _require.needsBridgeForBrowser, isBridge = _require.isBridge;
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.BRIDGE] = function(win, serializedMessage, domain) {
            if (needsBridgeForBrowser() || isBridge()) {
                if (Object(src.v)(win)) throw new Error("Post message through bridge disabled between same domain windows");
                if (!1 !== Object(src.w)(window, win)) throw new Error("Can only use bridge to communicate between two different windows, not between frames");
                return sendBridgeMessage(win, serializedMessage, domain);
            }
        };
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.GLOBAL] = function(win, serializedMessage) {
            if (Object(lib.i)()) {
                if (!Object(src.v)(win)) throw new Error("Post message through global disabled between different domain windows");
                if (!1 !== Object(src.w)(window, win)) throw new Error("Can only use global to communicate between two different windows, not between frames");
                var foreignGlobal = win[conf.b.WINDOW_PROPS.POSTROBOT];
                if (!foreignGlobal) throw new Error("Can not find postRobot global on foreign window");
                return foreignGlobal.receiveMessage({
                    source: window,
                    origin: Object(src.h)(),
                    data: serializedMessage
                });
            }
        };
        function sendMessage(win, message, domain) {
            return zalgo_promise_src.a.try((function() {
                var _jsonStringify;
                message = function(win, message, options) {
                    void 0 === options && (options = {});
                    var id = Object(lib.q)();
                    var type = Object(lib.c)();
                    var sourceDomain = Object(src.h)(window);
                    return Object(esm_extends.a)({}, message, options, {
                        sourceDomain: sourceDomain,
                        id: message.id || id,
                        windowType: type
                    });
                }(0, message, {
                    data: Object(lib.o)(win, domain, message.data),
                    domain: domain
                });
                if (win === window && !conf.a.ALLOW_SAME_ORIGIN) throw new Error("Attemping to send message to self");
                if (Object(src.z)(win)) throw new Error("Window is closed");
                var messages = [];
                var serializedMessage = Object(lib.g)(((_jsonStringify = {})[conf.b.WINDOW_PROPS.POSTROBOT] = message, 
                _jsonStringify), null, 2);
                return zalgo_promise_src.a.map(Object.keys(SEND_MESSAGE_STRATEGIES), (function(strategyName) {
                    return zalgo_promise_src.a.try((function() {
                        if (!conf.a.ALLOWED_POST_MESSAGE_METHODS[strategyName]) throw new Error("Strategy disallowed: " + strategyName);
                        return SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                    })).then((function() {
                        messages.push(strategyName + ": success");
                        return !0;
                    }), (function(err) {
                        messages.push(strategyName + ": " + Object(lib.p)(err) + "\n");
                        return !1;
                    }));
                })).then((function(results) {
                    var success = results.some(Boolean);
                    var status = message.type + " " + message.name + " " + (success ? "success" : "error") + ":\n  - " + messages.join("\n  - ") + "\n";
                    if (!success) throw new Error(status);
                }));
            }));
        }
        var cross_domain_safe_weakmap_src = __webpack_require__(17);
        global.a.responseListeners = global.a.responseListeners || {};
        global.a.requestListeners = global.a.requestListeners || {};
        global.a.WINDOW_WILDCARD = global.a.WINDOW_WILDCARD || new function() {};
        global.a.erroredResponseListeners = global.a.erroredResponseListeners || {};
        function getResponseListener(hash) {
            return global.a.responseListeners[hash];
        }
        function deleteResponseListener(hash) {
            delete global.a.responseListeners[hash];
        }
        function isResponseListenerErrored(hash) {
            return Boolean(global.a.erroredResponseListeners[hash]);
        }
        function getRequestListener(_ref) {
            var name = _ref.name, win = _ref.win, domain = _ref.domain;
            win === conf.b.WILDCARD && (win = null);
            domain === conf.b.WILDCARD && (domain = null);
            if (!name) throw new Error("Name required to get request listener");
            var nameListeners = global.a.requestListeners[name];
            if (nameListeners) for (var _i2 = 0, _ref3 = [ win, global.a.WINDOW_WILDCARD ]; _i2 < _ref3.length; _i2++) {
                var winQualifier = _ref3[_i2];
                var winListeners = winQualifier && nameListeners.get(winQualifier);
                if (winListeners) {
                    if (domain && "string" == typeof domain) {
                        if (winListeners[domain]) return winListeners[domain];
                        if (winListeners.__domain_regex__) for (var _i4 = 0, _winListeners$__DOMAI2 = winListeners.__domain_regex__; _i4 < _winListeners$__DOMAI2.length; _i4++) {
                            var _winListeners$__DOMAI3 = _winListeners$__DOMAI2[_i4], regex = _winListeners$__DOMAI3.regex, listener = _winListeners$__DOMAI3.listener;
                            if (Object(src.B)(regex, domain)) return listener;
                        }
                    }
                    if (winListeners[conf.b.WILDCARD]) return winListeners[conf.b.WILDCARD];
                }
            }
        }
        var _RECEIVE_MESSAGE_TYPE;
        var RECEIVE_MESSAGE_TYPES = ((_RECEIVE_MESSAGE_TYPE = {})[conf.b.POST_MESSAGE_TYPE.ACK] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                options.ack = !0;
            }
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.REQUEST] = function(source, origin, message) {
            var options = getRequestListener({
                name: message.name,
                win: source,
                domain: origin
            });
            function respond(data) {
                return message.fireAndForget || Object(src.z)(source) ? zalgo_promise_src.a.resolve() : sendMessage(source, Object(esm_extends.a)({
                    target: message.originalSource,
                    hash: message.hash,
                    name: message.name
                }, data), origin);
            }
            return zalgo_promise_src.a.all([ respond({
                type: conf.b.POST_MESSAGE_TYPE.ACK
            }), zalgo_promise_src.a.try((function() {
                if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                return options.handler({
                    source: source,
                    origin: origin,
                    data: message.data
                });
            })).then((function(data) {
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.SUCCESS,
                    data: data
                });
            }), (function(err) {
                var error = Object(lib.p)(err).replace(/^Error: /, "");
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.ERROR,
                    error: error,
                    code: err.code
                });
            })) ]).then(lib.j).catch((function(err) {
                if (options && options.handleError) return options.handleError(err);
                throw err;
            }));
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.RESPONSE] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + Object(src.D)(options.domain));
                deleteResponseListener(message.hash);
                if (message.ack === conf.b.POST_MESSAGE_ACK.ERROR) {
                    var err = new Error(message.error);
                    message.code && (err.code = message.code);
                    return options.respond(err, null);
                }
                if (message.ack === conf.b.POST_MESSAGE_ACK.SUCCESS) return options.respond(null, {
                    source: source,
                    origin: origin,
                    data: message.data || message.response
                });
            }
        }, _RECEIVE_MESSAGE_TYPE);
        global.a.receivedMessages = global.a.receivedMessages || [];
        function receiveMessage(event) {
            if (window && !window.closed) {
                try {
                    if (!event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var message = function(message) {
                    var parsedMessage;
                    try {
                        parsedMessage = Object(lib.f)(message);
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage && (parsedMessage = parsedMessage[conf.b.WINDOW_PROPS.POSTROBOT]) && "object" == typeof parsedMessage && null !== parsedMessage && parsedMessage.type && "string" == typeof parsedMessage.type && RECEIVE_MESSAGE_TYPES[parsedMessage.type]) return parsedMessage;
                }(event.data);
                if (message) {
                    if (!message.sourceDomain || "string" != typeof message.sourceDomain) throw new Error("Expected message to have sourceDomain");
                    0 !== message.sourceDomain.indexOf(conf.b.MOCK_PROTOCOL) && 0 !== message.sourceDomain.indexOf(conf.b.FILE_PROTOCOL) || (origin = message.sourceDomain);
                    if (-1 === global.a.receivedMessages.indexOf(message.id)) {
                        global.a.receivedMessages.push(message.id);
                        if (!Object(src.z)(source) || message.fireAndForget) {
                            message.data && (message.data = Object(lib.b)(source, origin, message.data));
                            RECEIVE_MESSAGE_TYPES[message.type](source, origin, message);
                        }
                    }
                }
            }
        }
        function messageListener(event) {
            try {
                Object(lib.j)(event.source);
            } catch (err) {
                return;
            }
            var messageEvent = {
                source: event.source || event.sourceElement,
                origin: event.origin || event.originalEvent && event.originalEvent.origin,
                data: event.data
            };
            try {
                __webpack_require__(43).emulateIERestrictions(messageEvent.source, window);
            } catch (err) {
                return;
            }
            receiveMessage(messageEvent);
        }
        global.a.receiveMessage = receiveMessage;
        global.a.requestPromises = global.a.requestPromises || new cross_domain_safe_weakmap_src.a;
        function request(options) {
            return zalgo_promise_src.a.try((function() {
                if (!options.name) throw new Error("Expected options.name");
                var name = options.name;
                var targetWindow;
                var domain;
                if ("string" == typeof options.window) {
                    var el = document.getElementById(options.window);
                    if (!el) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be a valid element id");
                    if ("iframe" !== el.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (!el.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    targetWindow = el.contentWindow;
                } else if (options.window instanceof HTMLIFrameElement) {
                    if ("iframe" !== options.window.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (options.window && !options.window.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    options.window && options.window.contentWindow && (targetWindow = options.window.contentWindow);
                } else targetWindow = options.window;
                if (!targetWindow) throw new Error("Expected options.window to be a window object, iframe, or iframe element id.");
                var win = targetWindow;
                domain = options.domain || conf.b.WILDCARD;
                var hash = options.name + "_" + Object(lib.q)();
                if (Object(src.z)(win)) throw new Error("Target window is closed");
                var hasResult = !1;
                var requestPromises = global.a.requestPromises.get(win);
                requestPromises || global.a.requestPromises.set(win, requestPromises = []);
                var requestPromise = zalgo_promise_src.a.try((function() {
                    if (Object(src.r)(window, win)) return Object(lib.k)(win, options.timeout || conf.a.CHILD_WINDOW_TIMEOUT);
                })).then((function(_temp) {
                    var origin = (void 0 === _temp ? {} : _temp).origin;
                    if (Object(lib.e)(domain) && !origin) return Object(lib.n)(win);
                })).then((function(_temp2) {
                    var origin = (void 0 === _temp2 ? {} : _temp2).origin;
                    if (Object(lib.e)(domain)) {
                        if (!Object(src.B)(domain, origin)) throw new Error("Remote window domain " + origin + " does not match regex: " + domain.toString());
                        domain = origin;
                    }
                    if ("string" != typeof domain && !Array.isArray(domain)) throw new TypeError("Expected domain to be a string or array");
                    var actualDomain = domain;
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        var responseListener;
                        options.fireAndForget || function(hash, listener) {
                            global.a.responseListeners[hash] = listener;
                        }(hash, responseListener = {
                            name: name,
                            window: win,
                            domain: actualDomain,
                            respond: function(err, result) {
                                if (!err) {
                                    hasResult = !0;
                                    requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                                }
                                err ? reject(err) : resolve(result);
                            }
                        });
                        sendMessage(win, {
                            type: conf.b.POST_MESSAGE_TYPE.REQUEST,
                            hash: hash,
                            name: name,
                            data: options.data,
                            fireAndForget: options.fireAndForget
                        }, actualDomain).catch(reject);
                        if (options.fireAndForget) return resolve();
                        var ackTimeout = conf.a.ACK_TIMEOUT;
                        var resTimeout = options.timeout || conf.a.RES_TIMEOUT;
                        var cycleTime = 100;
                        setTimeout((function cycle() {
                            if (!hasResult) {
                                if (Object(src.z)(win)) return reject(responseListener.ack ? new Error("Window closed for " + name + " before response") : new Error("Window closed for " + name + " before ack"));
                                ackTimeout = Math.max(ackTimeout - cycleTime, 0);
                                -1 !== resTimeout && (resTimeout = Math.max(resTimeout - cycleTime, 0));
                                if (responseListener.ack) {
                                    if (-1 === resTimeout) return;
                                    cycleTime = Math.min(resTimeout, 2e3);
                                } else {
                                    if (0 === ackTimeout) return reject(new Error("No ack for postMessage " + name + " in " + Object(src.h)() + " in " + conf.a.ACK_TIMEOUT + "ms"));
                                    if (0 === resTimeout) return reject(new Error("No response for postMessage " + name + " in " + Object(src.h)() + " in " + (options.timeout || conf.a.RES_TIMEOUT) + "ms"));
                                }
                                setTimeout(cycle, cycleTime);
                            }
                        }), cycleTime);
                    }));
                }));
                requestPromise.catch((function() {
                    !function(hash) {
                        global.a.erroredResponseListeners[hash] = !0;
                    }(hash);
                    deleteResponseListener(hash);
                }));
                requestPromises.push(requestPromise);
                return requestPromise;
            }));
        }
        function _send(window, name, data, options) {
            (options = options || {}).window = window;
            options.name = name;
            options.data = data;
            return request(options);
        }
        function sendToParent(name, data, options) {
            var win = Object(src.f)();
            return win ? _send(win, name, data, options) : new zalgo_promise_src.a((function(resolve, reject) {
                return reject(new Error("Window does not have a parent"));
            }));
        }
        function client(options) {
            void 0 === options && (options = {});
            if (!options.window) throw new Error("Expected options.window");
            var win = options.window;
            return {
                send: function(name, data) {
                    return _send(win, name, data, options);
                }
            };
        }
        global.a.send = _send;
        function listen(options) {
            if (!options.name) throw new Error("Expected options.name");
            if (!options.handler) throw new Error("Expected options.handler");
            var name = options.name;
            var win = options.window;
            var domain = options.domain;
            var listenerOptions = {
                handler: options.handler,
                handleError: options.errorHandler || function(err) {
                    throw err;
                },
                window: win,
                domain: domain || conf.b.WILDCARD,
                name: name
            };
            var requestListener = function addRequestListener(_ref4, listener) {
                var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                if (Array.isArray(win)) {
                    var listenersCollection = [];
                    for (var _i6 = 0, _win2 = win; _i6 < _win2.length; _i6++) listenersCollection.push(addRequestListener({
                        name: name,
                        domain: domain,
                        win: _win2[_i6]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i8 = 0; _i8 < listenersCollection.length; _i8++) listenersCollection[_i8].cancel();
                        }
                    };
                }
                if (Array.isArray(domain)) {
                    var _listenersCollection = [];
                    for (var _i10 = 0, _domain2 = domain; _i10 < _domain2.length; _i10++) _listenersCollection.push(addRequestListener({
                        name: name,
                        win: win,
                        domain: _domain2[_i10]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i12 = 0; _i12 < _listenersCollection.length; _i12++) _listenersCollection[_i12].cancel();
                        }
                    };
                }
                var existingListener = getRequestListener({
                    name: name,
                    win: win,
                    domain: domain
                });
                win && win !== conf.b.WILDCARD || (win = global.a.WINDOW_WILDCARD);
                domain = domain || conf.b.WILDCARD;
                if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                var requestListeners = global.a.requestListeners;
                var nameListeners = requestListeners[name];
                if (!nameListeners) {
                    nameListeners = new cross_domain_safe_weakmap_src.a;
                    requestListeners[name] = nameListeners;
                }
                var winListeners = nameListeners.get(win);
                winListeners || nameListeners.set(win, winListeners = {});
                var strDomain = domain.toString();
                var regexListeners = winListeners.__domain_regex__;
                var regexListener;
                if (Object(lib.e)(domain)) {
                    regexListeners || (winListeners.__domain_regex__ = regexListeners = []);
                    regexListeners.push(regexListener = {
                        regex: domain,
                        listener: listener
                    });
                } else winListeners[strDomain] = listener;
                return {
                    cancel: function() {
                        if (winListeners) {
                            delete winListeners[strDomain];
                            win && 0 === Object.keys(winListeners).length && nameListeners.delete(win);
                            regexListener && regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                        }
                    }
                };
            }({
                name: name,
                win: win,
                domain: domain
            }, listenerOptions);
            if (options.once) {
                var _handler = listenerOptions.handler;
                listenerOptions.handler = Object(lib.l)((function() {
                    requestListener.cancel();
                    return _handler.apply(this, arguments);
                }));
            }
            if (listenerOptions.window && options.errorOnClose) var interval = Object(lib.m)((function() {
                if (win && "object" == typeof win && Object(src.z)(win)) {
                    interval.cancel();
                    listenerOptions.handleError(new Error("Post message target window is closed"));
                }
            }), 50);
            return {
                cancel: function() {
                    requestListener.cancel();
                }
            };
        }
        function _on(name, options, handler) {
            if ("function" == typeof options) {
                handler = options;
                options = {};
            }
            (options = options || {}).name = name;
            options.handler = handler || options.handler;
            return listen(options);
        }
        function once(name, options, handler) {
            void 0 === options && (options = {});
            if ("function" == typeof options) {
                handler = options;
                options = {};
            }
            options = options || {};
            handler = handler || options.handler;
            var errorHandler = options.errorHandler;
            var promise = new zalgo_promise_src.a((function(resolve, reject) {
                (options = options || {}).name = name;
                options.once = !0;
                options.handler = function(event) {
                    resolve(event);
                    if (handler) return handler(event);
                };
                options.errorHandler = function(err) {
                    reject(err);
                    if (errorHandler) return errorHandler(err);
                };
            }));
            var onceListener = listen(options);
            promise.cancel = onceListener.cancel;
            return promise;
        }
        function server_listener(options) {
            void 0 === options && (options = {});
            return {
                on: function(name, handler) {
                    return _on(name, options, handler);
                }
            };
        }
        global.a.on = _on;
        function disable() {
            delete window[conf.b.WINDOW_PROPS.POSTROBOT];
            window.removeEventListener("message", messageListener);
        }
        var public_parent = Object(src.f)();
        function cleanUpWindow(win) {
            var requestPromises = global.a.requestPromises.get(win);
            if (requestPromises) for (var _i2 = 0; _i2 < requestPromises.length; _i2++) requestPromises[_i2].reject(new Error("No response from window - cleaned up"));
            global.a.popupWindowsByWin && global.a.popupWindowsByWin.delete(win);
            global.a.remoteWindows && global.a.remoteWindows.delete(win);
            global.a.requestPromises.delete(win);
            global.a.methods.delete(win);
            global.a.readyPromises.delete(win);
        }
        var bridge = __webpack_require__(45);
        function init() {
            if (!global.a.initialized) {
                Object(lib.a)(window, "message", messageListener);
                __webpack_require__(23).openTunnelToOpener();
                Object(lib.d)();
                Object(lib.h)({
                    on: _on,
                    send: _send
                });
            }
            global.a.initialized = !0;
        }
        init();
        __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addEventListener;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return safeInterval;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return isRegex;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return util_weakMapMemoize;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getWindowType;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return jsonStringify;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return jsonParse;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return needsGlobalMessagingForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return listenForMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return serializeMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return deserializeMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return sayHello;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return initOnReady;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return onChildWindowReady;
        }));
        var src = __webpack_require__(17);
        var cross_domain_utils_src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        function stringifyError(err, level) {
            void 0 === level && (level = 1);
            if (level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack;
                    var message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        var once = function(method) {
            if (!method) return method;
            var called = !1;
            return function() {
                if (!called) {
                    called = !0;
                    return method.apply(this, arguments);
                }
            };
        };
        function noop() {}
        function addEventListener(obj, event, handler) {
            obj.addEventListener ? obj.addEventListener(event, handler) : obj.attachEvent("on" + event, handler);
            return {
                cancel: function() {
                    obj.removeEventListener ? obj.removeEventListener(event, handler) : obj.detachEvent("on" + event, handler);
                }
            };
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        function replaceObject(item, callback, depth) {
            void 0 === depth && (depth = 1);
            if (depth >= 100) throw new Error("Self-referential object passed, or object contained too many layers");
            var newobj;
            if ("object" != typeof item || null === item || Array.isArray(item)) {
                if (!Array.isArray(item)) throw new TypeError("Invalid type: " + typeof item);
                newobj = [];
            } else newobj = {};
            !function(item, callback) {
                Array.isArray(item) ? function(item, callback) {
                    for (var i = 0; i < item.length; i++) callback(item[i], i);
                }(item, callback) : "object" == typeof item && null !== item && function(item, callback) {
                    for (var _key in item) item.hasOwnProperty(_key) && callback(item[_key], _key);
                }(item, callback);
            }(item, (function(childItem, key) {
                var result = callback(childItem, key);
                newobj[key] = void 0 !== result ? result : "object" == typeof childItem && null !== childItem ? replaceObject(childItem, callback, depth + 1) : childItem;
            }));
            return newobj;
        }
        function safeInterval(method, time) {
            var timeout;
            timeout = setTimeout((function runInterval() {
                timeout = setTimeout(runInterval, time);
                method.call();
            }), time);
            return {
                cancel: function() {
                    clearTimeout(timeout);
                }
            };
        }
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var util_weakMapMemoize = function(method) {
            var weakmap = new src.a;
            return function(arg) {
                var result = weakmap.get(arg);
                if (void 0 !== result) return result;
                void 0 !== (result = method.call(this, arg)) && weakmap.set(arg, result);
                return result;
            };
        };
        function getWindowType() {
            return Object(cross_domain_utils_src.u)() ? conf.b.WINDOW_TYPES.POPUP : Object(cross_domain_utils_src.s)() ? conf.b.WINDOW_TYPES.IFRAME : conf.b.WINDOW_TYPES.FULLPAGE;
        }
        function jsonStringify(obj, replacer, indent) {
            var objectToJSON;
            var arrayToJSON;
            try {
                if ("{}" !== JSON.stringify({})) {
                    objectToJSON = {}.toJSON;
                    delete Object.prototype.toJSON;
                }
                if ("{}" !== JSON.stringify({})) throw new Error("Can not correctly serialize JSON objects");
                if ("[]" !== JSON.stringify([])) {
                    arrayToJSON = [].toJSON;
                    delete Array.prototype.toJSON;
                }
                if ("[]" !== JSON.stringify([])) throw new Error("Can not correctly serialize JSON objects");
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            var result = JSON.stringify.call(this, obj, replacer, indent);
            try {
                objectToJSON && (Object.prototype.toJSON = objectToJSON);
                arrayToJSON && (Array.prototype.toJSON = arrayToJSON);
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            return result;
        }
        function jsonParse(item) {
            return JSON.parse(item);
        }
        function needsGlobalMessagingForBrowser() {
            return !!Object(cross_domain_utils_src.p)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        var zalgo_promise_src = __webpack_require__(2);
        var global = __webpack_require__(9);
        global.a.methods = global.a.methods || new src.a;
        var listenForMethods = once((function() {
            global.a.on(conf.b.POST_MESSAGE_NAMES.METHOD, {
                origin: conf.b.WILDCARD
            }, (function(_ref) {
                var source = _ref.source, origin = _ref.origin, data = _ref.data;
                var methods = global.a.methods.get(source);
                if (!methods) throw new Error("Could not find any methods this window has privileges to call");
                var meth = methods[data.id];
                if (!meth) throw new Error("Could not find method with id: " + data.id);
                if (!Object(cross_domain_utils_src.B)(meth.domain, origin)) throw new Error("Method domain " + meth.domain + " does not match origin " + origin);
                return zalgo_promise_src.a.try((function() {
                    return meth.method.apply({
                        source: source,
                        origin: origin,
                        data: data
                    }, data.args);
                })).then((function(result) {
                    return {
                        result: result,
                        id: data.id,
                        name: data.name
                    };
                }));
            }));
        }));
        function isSerialized(item, type) {
            return "object" == typeof item && null !== item && item.__type__ === type;
        }
        function serializeMethod(destination, domain, method, name) {
            var id = uniqueID();
            var methods = global.a.methods.get(destination);
            methods || global.a.methods.set(destination, methods = {});
            methods[id] = {
                domain: domain,
                method: method
            };
            return {
                __type__: conf.b.SERIALIZATION_TYPES.METHOD,
                __id__: id,
                __name__: name
            };
        }
        function serializeMethods(destination, domain, obj) {
            return replaceObject({
                obj: obj
            }, (function(item, key) {
                return "function" == typeof item ? serializeMethod(destination, domain, item, key.toString()) : item instanceof Error ? {
                    __type__: conf.b.SERIALIZATION_TYPES.ERROR,
                    __message__: stringifyError(err = item),
                    __code__: err.code
                } : window.Promise && item instanceof window.Promise ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.PROMISE,
                        __then__: serializeMethod(destination, domain, (function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }), name + ".then")
                    };
                }(destination, domain, item, key.toString()) : zalgo_promise_src.a.isPromise(item) ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
                        __then__: serializeMethod(destination, domain, (function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }), name + ".then")
                    };
                }(destination, domain, item, key.toString()) : isRegex(item) ? {
                    __type__: conf.b.SERIALIZATION_TYPES.REGEX,
                    __source__: item.source
                } : void 0;
                var err;
            })).obj;
        }
        function deserializeMethod(source, origin, obj) {
            function wrapper() {
                var args = [].slice.call(arguments);
                return global.a.send(source, conf.b.POST_MESSAGE_NAMES.METHOD, {
                    id: obj.__id__,
                    name: obj.__name__,
                    args: args
                }, {
                    domain: origin,
                    timeout: -1
                }).then((function(_ref2) {
                    return _ref2.data.result;
                }), (function(err) {
                    throw err;
                }));
            }
            wrapper.__name__ = obj.__name__;
            wrapper.__xdomain__ = !0;
            wrapper.source = source;
            wrapper.origin = origin;
            return wrapper;
        }
        function deserializeZalgoPromise(source, origin, prom) {
            return new zalgo_promise_src.a((function(resolve, reject) {
                return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
            }));
        }
        function deserializeMethods(source, origin, obj) {
            return replaceObject({
                obj: obj
            }, (function(item) {
                if ("object" == typeof item && null !== item) return isSerialized(item, conf.b.SERIALIZATION_TYPES.METHOD) ? deserializeMethod(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ERROR) ? function(source, origin, obj) {
                    var err = new Error(obj.__message__);
                    obj.__code__ && (err.code = obj.__code__);
                    return err;
                }(0, 0, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.PROMISE) ? function(source, origin, prom) {
                    return window.Promise ? new window.Promise((function(resolve, reject) {
                        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
                    })) : deserializeZalgoPromise(source, origin, prom);
                }(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? deserializeZalgoPromise(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.REGEX) ? function(source, origin, item) {
                    return new RegExp(item.__source__);
                }(0, 0, item) : void 0;
            })).obj;
        }
        global.a.readyPromises = global.a.readyPromises || new src.a;
        function sayHello(win) {
            return global.a.send(win, conf.b.POST_MESSAGE_NAMES.HELLO, {}, {
                domain: conf.b.WILDCARD,
                timeout: -1
            }).then((function(_ref2) {
                return {
                    origin: _ref2.origin
                };
            }));
        }
        function initOnReady() {
            handler = function(_ref3) {
                var source = _ref3.source, origin = _ref3.origin;
                var promise = global.a.readyPromises.get(source) || new zalgo_promise_src.a;
                promise.resolve({
                    origin: origin
                });
                global.a.readyPromises.set(source, promise);
            }, global.a.on(conf.b.POST_MESSAGE_NAMES.HELLO, {
                domain: conf.b.WILDCARD
            }, (function(_ref) {
                return handler({
                    source: _ref.source,
                    origin: _ref.origin
                });
            }));
            var handler;
            var parent = Object(cross_domain_utils_src.f)();
            parent && sayHello(parent).catch(noop);
        }
        function onChildWindowReady(win, timeout, name) {
            void 0 === timeout && (timeout = 5e3);
            void 0 === name && (name = "Window");
            var promise = global.a.readyPromises.get(win);
            if (promise) return promise;
            promise = new zalgo_promise_src.a;
            global.a.readyPromises.set(win, promise);
            -1 !== timeout && setTimeout((function() {
                return promise.reject(new Error(name + " did not load after " + timeout + "ms"));
            }), timeout);
            return promise;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return weakmap_CrossDomainSafeWeakMap;
        }));
        var src = __webpack_require__(7);
        function safeIndexOf(collection, item) {
            for (var i = 0; i < collection.length; i++) try {
                if (collection[i] === item) return i;
            } catch (err) {}
            return -1;
        }
        var weakmap_CrossDomainSafeWeakMap = function() {
            function CrossDomainSafeWeakMap() {
                this.name = void 0;
                this.weakmap = void 0;
                this.keys = void 0;
                this.values = void 0;
                this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                if (function() {
                    if ("undefined" == typeof WeakMap) return !1;
                    if (void 0 === Object.freeze) return !1;
                    try {
                        var testWeakMap = new WeakMap;
                        var testKey = {};
                        Object.freeze(testKey);
                        testWeakMap.set(testKey, "__testvalue__");
                        return "__testvalue__" === testWeakMap.get(testKey);
                    } catch (err) {
                        return !1;
                    }
                }()) try {
                    this.weakmap = new WeakMap;
                } catch (err) {}
                this.keys = [];
                this.values = [];
            }
            var _proto = CrossDomainSafeWeakMap.prototype;
            _proto._cleanupClosedWindows = function() {
                var weakmap = this.weakmap;
                var keys = this.keys;
                for (var i = 0; i < keys.length; i++) {
                    var value = keys[i];
                    if (Object(src.y)(value) && Object(src.z)(value)) {
                        if (weakmap) try {
                            weakmap.delete(value);
                        } catch (err) {}
                        keys.splice(i, 1);
                        this.values.splice(i, 1);
                        i -= 1;
                    }
                }
            };
            _proto.isSafeToReadWrite = function(key) {
                return !Object(src.y)(key);
            };
            _proto.set = function(key, value) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.set(key, value);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var name = this.name;
                    var entry = key[name];
                    entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                        value: [ key, value ],
                        writable: !0
                    });
                    return;
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var values = this.values;
                var index = safeIndexOf(keys, key);
                if (-1 === index) {
                    keys.push(key);
                    values.push(value);
                } else values[index] = value;
            };
            _proto.get = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return weakmap.get(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return entry && entry[0] === key ? entry[1] : void 0;
                } catch (err) {}
                this._cleanupClosedWindows();
                var index = safeIndexOf(this.keys, key);
                if (-1 !== index) return this.values[index];
            };
            _proto.delete = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.delete(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var index = safeIndexOf(keys, key);
                if (-1 !== index) {
                    keys.splice(index, 1);
                    this.values.splice(index, 1);
                }
            };
            _proto.has = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return !0;
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return !(!entry || entry[0] !== key);
                } catch (err) {}
                this._cleanupClosedWindows();
                return -1 !== safeIndexOf(this.keys, key);
            };
            _proto.getOrSet = function(key, getter) {
                if (this.has(key)) return this.get(key);
                var value = getter();
                this.set(key, value);
                return value;
            };
            return CrossDomainSafeWeakMap;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return Checkout;
        }));
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(2);
        var beaver_logger_client = __webpack_require__(4);
        var zoid_src = __webpack_require__(22);
        var belter_src = __webpack_require__(11);
        var lib = __webpack_require__(3);
        var config = __webpack_require__(5);
        var constants = __webpack_require__(0);
        var post_robot_src = __webpack_require__(15);
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        var onAuthorize;
        Object(lib.F)() && Object(post_robot_src.on)("onLegacyPaymentAuthorize", {
            window: window.parent
        }, (function(_ref) {
            onAuthorize = _ref.data.method;
        }));
        function onLegacyPaymentAuthorize(method) {
            onAuthorize = method;
            return src.a.try((function() {
                if (post_robot_src.bridge && !Object(lib.F)()) return post_robot_src.bridge.openBridge(Object(lib.h)(config.a.postBridgeUrl, {
                    version: Object(lib.w)()
                }), config.a.postBridgeDomain).then((function(postBridge) {
                    return Object(post_robot_src.send)(postBridge, "onLegacyPaymentAuthorize", {
                        method: method
                    }, {
                        domain: config.a.paypalDomain
                    }).then(lib.J);
                }));
            }));
        }
        window.onLegacyPaymentAuthorize = onLegacyPaymentAuthorize;
        window.watchForLegacyFallback = function(win) {
            var interval = setInterval((function() {
                try {
                    if (-1 === win.document.body.innerHTML.indexOf("merchantpaymentweb") && -1 === win.document.body.innerHTML.indexOf("wapapp") || win.ppxoWatching || win.closed) return;
                    win.ppxoWatching = !0;
                    var XMLHttpRequestsend = win.XMLHttpRequest.prototype.send;
                    win.XMLHttpRequest.prototype.send = function() {
                        if (this._patched) return XMLHttpRequestsend.apply(this, arguments);
                        this._patched = !0;
                        var self = this;
                        var onload = this.onload;
                        function listener() {
                            if (self.readyState === self.DONE && 200 === self.status && self.responseText) try {
                                var response = JSON.parse(self.responseText.replace("while (1);", ""));
                                if ("redirect" === response.type && response.url && onAuthorize) {
                                    var url = response.url;
                                    clearInterval(interval);
                                    win.close();
                                    onAuthorize({
                                        returnUrl: url,
                                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
                                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
                                    });
                                    onAuthorize = null;
                                    win.PAYPAL && win.PAYPAL.Checkout && win.PAYPAL.Checkout.XhrResponse && win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES && Object.defineProperty(win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES, "Redirect", {
                                        value: Math.random().toString()
                                    });
                                    win.mob && win.mob.Xhr && win.mob.Xhr.prototype._xhrOnReady && (win.mob.Xhr.prototype._xhrOnReady = lib.J);
                                }
                            } catch (err) {
                                return;
                            }
                            if (onload) return onload.apply(this, arguments);
                        }
                        if (this.onload !== listener) try {
                            delete this.onload;
                            this.addEventListener("load", listener);
                            Object.defineProperty(this, "onload", {
                                get: function() {
                                    return listener;
                                },
                                set: function(handler) {
                                    onload = handler;
                                }
                            });
                        } catch (err) {}
                        return XMLHttpRequestsend.apply(this, arguments);
                    };
                } catch (err) {}
            }), 100);
        };
        window.onLegacyFallback = window.watchForLegacyFallback;
        var integrations = __webpack_require__(28);
        var template = __webpack_require__(31);
        var Checkout = Object(zoid_src.c)({
            tag: "paypal-checkout",
            name: "ppcheckout",
            scrolling: !0,
            buildUrl: function(props) {
                var env = props.env || config.a.env;
                if (!props.payment) throw new Error("Can not build url without payment prop");
                return props.payment().then((function(token) {
                    if (!token) throw new Error("Expected payment id or token to be passed, got " + token);
                    return Object(integrations.c)(env, props.fundingSource, token);
                }));
            },
            get unsafeRenderTo() {
                return config.a.env === constants.t.LOCAL;
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            get bridgeUrl() {
                return config.a.metaFrameUrls;
            },
            get bridgeDomain() {
                return config.a.paypalDomains;
            },
            contexts: {
                iframe: !Object(belter_src.p)(),
                popup: !0
            },
            get version() {
                return Object(lib.w)();
            },
            validate: function() {
                Object(lib.D)() || Object(beaver_logger_client.q)("checkout_render_ineligible");
            },
            prerenderTemplate: template.a,
            containerTemplate: template.b,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.x)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.k)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.xprops && window.xprops.meta || {};
                    }
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                stageUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stageUrl;
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    },
                    queryParam: "code"
                },
                localhostUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        if ((props.env || config.a.env) === constants.t.LOCAL) return config.a.localhostUrl;
                    }
                },
                checkoutUri: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.checkoutUri;
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.j)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    sendToChild: !1,
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                    }
                },
                payment: {
                    type: "function",
                    required: !1,
                    memoize: !0,
                    promisify: !0,
                    queryParam: function(payment) {
                        return payment().then((function(token) {
                            return Object(integrations.b)(token);
                        }));
                    },
                    queryValue: function(payment) {
                        return payment();
                    },
                    childDecorate: function(payment) {
                        var token = Object(lib.r)("token");
                        return token ? Object(lib.I)((function() {
                            return src.a.resolve(token);
                        })) : payment;
                    },
                    validate: function(payment, props) {
                        if (!payment && !props.url) throw new Error("Expected either props.payment or props.url to be passed");
                    },
                    alias: "billingAgreement"
                },
                style: {
                    type: "object",
                    required: !1,
                    allowDelegate: !0,
                    def: function() {
                        return {};
                    },
                    validate: function(style) {
                        if (style.overlayColor && style.overlayColor !== constants.q.BLACK && style.overlayColor !== constants.q.WHITE) throw new Error("Invalid background color: " + style.overlayColor);
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1
                },
                experience: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                fundingSource: {
                    type: "string",
                    required: !1,
                    queryParam: !0
                },
                fundingOffered: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map((function(el) {
                            return el.getAttribute(constants.c.FUNDING_SOURCE);
                        }));
                    },
                    queryValue: function(val) {
                        return val.join(",");
                    }
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _this = this;
                            void 0 === actions && (actions = {});
                            data && !data.intent && Object(beaver_logger_client.q)("checkout_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            var close = function() {
                                return src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return _this.closeComponent();
                                }));
                            };
                            var redirect = function(win, url) {
                                return src.a.all([ Object(lib.P)(win || window.top, url || data.returnUrl), close() ]);
                            };
                            return src.a.try((function() {
                                try {
                                    var isButton = -1 !== window.location.href.indexOf("/smart/button");
                                    var isGuest = -1 !== _this.window.location.href.indexOf("/webapps/xoonboarding");
                                    if (isButton && isGuest) return Object(lib.R)({
                                        win: _this.window,
                                        method: "get",
                                        url: "/webapps/xoonboarding/api/auth"
                                    }).then((function(result) {
                                        result && result.data && result.data.access_token && (window.$Api && window.$Api.addHeader && window.$Api.addHeader("x-paypal-internal-euat", result.data.access_token));
                                    })).catch((function() {}));
                                } catch (err) {}
                            })).then((function() {
                                return original.call(_this, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            })).catch((function(err) {
                                return _this.error(err);
                            })).finally((function() {
                                return _this.close();
                            }));
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0,
                    childDecorate: function(original) {
                        if (original) return function(data) {
                            "string" == typeof data && (data = {
                                accessToken: data
                            });
                            return original(data);
                        };
                    }
                },
                accessToken: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _this2 = this;
                            void 0 === actions && (actions = {});
                            var close = function() {
                                return src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return _this2.closeComponent();
                                }));
                            };
                            var redirect = function(win, url) {
                                return src.a.all([ Object(lib.P)(win || window.top, url || data.cancelUrl), close() ]);
                            };
                            return src.a.try((function() {
                                return original.call(_this2, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            })).finally((function() {
                                _this2.close();
                            }));
                        };
                    }
                },
                init: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track;
                            Object(beaver_logger_client.k)("checkout_init");
                            Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_INIT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN], 
                            _track[constants.u.KEY.TOKEN] = data.paymentToken, _track[constants.u.KEY.SELLER_ID] = data.merchantID, 
                            _track[constants.u.KEY.CONTEXT_ID] = data.paymentToken, _track));
                            Object(beaver_logger_client.h)();
                            this.paymentToken = data.paymentToken;
                            this.cancelUrl = data.cancelUrl;
                            return original.apply(this, arguments);
                        };
                    }
                },
                onClose: {
                    type: "function",
                    required: !1,
                    once: !0,
                    promisify: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(reason) {
                            var onClose = original.apply(this, arguments);
                            var CLOSE_REASONS = zoid_src.a.CLOSE_REASONS;
                            var shouldCancel = this.props.onCancel && -1 !== [ CLOSE_REASONS.CLOSE_DETECTED, CLOSE_REASONS.USER_CLOSED ].indexOf(reason);
                            if (shouldCancel) {
                                Object(beaver_logger_client.k)("close_trigger_cancel");
                                return this.props.onCancel({
                                    paymentToken: this.paymentToken,
                                    cancelUrl: this.cancelUrl
                                }).then((function() {
                                    return onClose;
                                }));
                            }
                            return onClose;
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    noop: !0,
                    once: !0
                },
                fallback: {
                    type: "function",
                    required: !1,
                    once: !0,
                    def: function() {
                        return function(url) {
                            Object(beaver_logger_client.q)("fallback", {
                                url: url
                            });
                            if (Object(lib.n)("allow_full_page_fallback")) {
                                window.top.location = url;
                                return this.close();
                            }
                            return onLegacyPaymentAuthorize(this.props.onAuthorize);
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.__test__ || {
                            action: "checkout"
                        };
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.m)()
                        }));
                    }
                }
            },
            get dimensions() {
                return Object(belter_src.f)() ? {
                    width: "100%",
                    height: "590px"
                } : {
                    width: "500px",
                    height: "590px"
                };
            }
        });
        if (Checkout.isChild() && Checkout.xchild && Checkout.xprops) {
            Checkout.xprops && Checkout.xprops.logLevel && Object(lib.T)(Checkout.xprops.logLevel);
            Checkout.xchild.onProps((function(xprops) {
                Object(lib.N)(xprops, "onAuthorize", (function(_ref) {
                    var callOriginal = _ref.callOriginal, data = _ref.args[0];
                    if (data && !data.intent) {
                        Object(beaver_logger_client.q)("hermes_authorize_no_intent", {
                            paymentID: data.paymentID,
                            token: data.paymentToken
                        });
                        try {
                            var intent = window.injector.get("$CheckoutCartModel").instance(data.paymentToken).payment_action;
                            Object(beaver_logger_client.q)("hermes_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken,
                                intent: intent
                            });
                        } catch (err) {}
                        Object(beaver_logger_client.j)();
                    }
                    return callOriginal();
                }));
            }));
        }
        Object(lib.N)(Checkout, "init", (function(_ref2) {
            var _ref2$args = _ref2.args;
            return _ref2.original.call(_ref2.context, _ref2$args[0], _ref2$args[1], "body");
        }));
        Object(lib.N)(Checkout, "render", (function(_ref3) {
            return _ref3.original.call(_ref3.context, _ref3.args[0], "body");
        }));
        Object(lib.N)(Checkout, "renderTo", (function(_ref4) {
            var _ref4$args = _ref4.args, win = _ref4$args[0], props = _ref4$args[1], original = _ref4.original, context = _ref4.context;
            var payment = props.payment();
            props.payment = function() {
                return payment;
            };
            return original.call(context, win, props, "body").catch((function(err) {
                if (err instanceof zoid_src.b && Object(lib.F)()) {
                    Checkout.contexts.iframe = !0;
                    return original.call(context, win, props, "body");
                }
                throw err;
            }));
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return fundingLogos;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return cardLogos;
        }));
        var constants = __webpack_require__(0);
        var jsx = __webpack_require__(1);
        var _P24_LOGO_COLORS;
        var P24_LOGO_COLORS = ((_P24_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _P24_LOGO_COLORS[constants.i.ANY] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS);
        var _SOFORT_LOGO_COLORS;
        var SOFORT_LOGO_COLORS = ((_SOFORT_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#2C2E2F",
            secondary: "#ffffff"
        }, _SOFORT_LOGO_COLORS[constants.i.ANY] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS);
        var _IDEAL_LOGO_COLORS;
        var IDEAL_LOGO_COLORS = ((_IDEAL_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#2C2E2F"
        }, _IDEAL_LOGO_COLORS[constants.i.ANY] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS);
        var _GIROPAY_LOGO_COLORS;
        var GIROPAY_LOGO_COLORS = ((_GIROPAY_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#000000",
            tertiary: "#2C2E2F"
        }, _GIROPAY_LOGO_COLORS[constants.i.ANY] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS);
        var _EPS_LOGO_COLORS;
        var EPS_LOGO_COLORS = ((_EPS_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _EPS_LOGO_COLORS[constants.i.ANY] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS);
        var _MYBANK_LOGO_COLORS;
        var MYBANK_LOGO_COLORS = ((_MYBANK_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _MYBANK_LOGO_COLORS[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS);
        var _BANCONTACT_LOGO_COLO;
        var BANCONTACT_LOGO_COLORS = ((_BANCONTACT_LOGO_COLO = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _BANCONTACT_LOGO_COLO[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE"
        }, _BANCONTACT_LOGO_COLO[constants.i.BLACK] = {
            primary: "#005498",
            secondary: "#FFD800"
        }, _BANCONTACT_LOGO_COLO);
        var _BLIK_LOGO_COLORS;
        var BLIK_LOGO_COLORS = ((_BLIK_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#FFFFFF",
            secondary: "#FFFFFF",
            tertiary: "#000000",
            quaternary: "#000000",
            quinary: "#000000",
            senary: "#000000"
        }, _BLIK_LOGO_COLORS[constants.i.ANY] = {
            primary: "#4D4D4F",
            secondary: "#000000",
            tertiary: "#FF0000",
            quaternary: "#E83E49",
            quinary: "#FF00FF",
            senary: "#FFFFFF"
        }, _BLIK_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#4D4D4F",
            secondary: "#000000",
            tertiary: "#FF0000",
            quaternary: "#E83E49",
            quinary: "#FF00FF",
            senary: "#FFFFFF"
        }, _BLIK_LOGO_COLORS);
        var _MAXIMA_LOGO_COLORS;
        var MAXIMA_LOGO_COLORS = ((_MAXIMA_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS[constants.i.ANY] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS);
        var _BOLETO_LOGO_COLORS;
        var BOLETO_LOGO_COLORS = ((_BOLETO_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS[constants.i.ANY] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS);
        var _OXXO_LOGO_COLORS;
        var OXXO_LOGO_COLORS = ((_OXXO_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS[constants.i.ANY] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS);
        var _MERCADOPAGO_LOGO_COL;
        var MERCADOPAGO_LOGO_COLORS = ((_MERCADOPAGO_LOGO_COL = {})[constants.i.WHITE] = {
            primary: "#FFFFFF",
            secondary: "#000000",
            tertiary: "#FFFFFF",
            quaternary: "#000000"
        }, _MERCADOPAGO_LOGO_COL[constants.i.ANY] = {
            primary: "#2D3277",
            secondary: "#FFFFFF",
            tertiary: "#009EE3",
            quaternary: "#009EE3"
        }, _MERCADOPAGO_LOGO_COL[constants.i.BLACK] = {
            primary: "#2D3277",
            secondary: "#FFFFFF",
            tertiary: "#009EE3",
            quaternary: "#009EE3"
        }, _MERCADOPAGO_LOGO_COL);
        var _PAYPAL_LOGO_COLORS;
        var PAYPAL_LOGO_COLORS = ((_PAYPAL_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _PAYPAL_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _PAYPAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _PAYPAL_LOGO_COLORS);
        var _CREDIT_LOGO_COLORS;
        var CREDIT_LOGO_COLORS = ((_CREDIT_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _CREDIT_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _CREDIT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _CREDIT_LOGO_COLORS);
        var _BUTTON_LOGO$PP, _BUTTON_LOGO$VENMO, _BUTTON_LOGO$ITAU, _BUTTON_LOGO$ELV, _fundingLogos;
        var fundingLogos = ((_fundingLogos = {})[constants.h.PP] = ((_BUTTON_LOGO$PP = {})[constants.i.WHITE] = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446"></path>\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"></path>\n    <path fill="#ffffff" d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z"></path>\n    <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n        <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"></path>\n        <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"></path>\n        <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"></path>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$PP[constants.i.BLUE] = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#009cde" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 6.675 28.9 C 6.581 29.3 6.862 29.6 7.236 29.6 L 11.356 29.6 C 11.825 29.6 12.292 29.3 12.386 28.8 L 12.386 28.5 L 13.228 23.3 L 13.228 23.1 C 13.322 22.6 13.79 22.2 14.258 22.2 L 14.821 22.2 C 18.845 22.2 21.935 20.5 22.871 15.5 C 23.339 13.4 23.153 11.7 22.029 10.5 C 21.748 10.1 21.279 9.8 20.905 9.5 L 20.905 9.5"></path>\n    <path fill="#012169" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 8.173 18.7 C 8.267 18.1 8.735 17.7 9.296 17.7 L 11.636 17.7 C 16.224 17.7 19.782 15.7 20.905 10.1 C 20.812 9.8 20.905 9.7 20.905 9.5"></path>\n    <path fill="#003087" d="M 9.485 9.5 C 9.577 9.2 9.765 8.9 10.046 8.7 C 10.232 8.7 10.326 8.6 10.513 8.6 L 16.692 8.6 C 17.442 8.6 18.189 8.7 18.753 8.8 C 18.939 8.8 19.127 8.8 19.314 8.9 C 19.501 9 19.688 9 19.782 9.1 C 19.875 9.1 19.968 9.1 20.063 9.1 C 20.343 9.2 20.624 9.4 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.6 C 18.658 3.2 16.506 2.6 13.79 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 9.485 9.5 Z"></path>\n</svg>\n', 
        _BUTTON_LOGO$PP[constants.i.BLACK] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="24" height="32" viewBox="0 0 24 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446" style="fill: rgb(99, 99, 99);"/>\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"/>\n  <path d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z" style="fill: rgb(51, 48, 48);"/>\n  <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n    <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"/>\n    <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"/>\n    <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$PP), _fundingLogos[constants.h.PAYPAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!PAYPAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " paypal logo available");
            var _PAYPAL_LOGO_COLORS$l = PAYPAL_LOGO_COLORS[logoColor], primary = _PAYPAL_LOGO_COLORS$l.primary, secondary = _PAYPAL_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "100",
                height: "32",
                viewBox: "0 0 100 32",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.c)("path", {
                fill: primary,
                d: "M 12 4.917 L 4.2 4.917 C 3.7 4.917 3.2 5.317 3.1 5.817 L 0 25.817 C -0.1 26.217 0.2 26.517 0.6 26.517 L 4.3 26.517 C 4.8 26.517 5.3 26.117 5.4 25.617 L 6.2 20.217 C 6.3 19.717 6.7 19.317 7.3 19.317 L 9.8 19.317 C 14.9 19.317 17.9 16.817 18.7 11.917 C 19 9.817 18.7 8.117 17.7 6.917 C 16.6 5.617 14.6 4.917 12 4.917 Z M 12.9 12.217 C 12.5 15.017 10.3 15.017 8.3 15.017 L 7.1 15.017 L 7.9 9.817 C 7.9 9.517 8.2 9.317 8.5 9.317 L 9 9.317 C 10.4 9.317 11.7 9.317 12.4 10.117 C 12.9 10.517 13.1 11.217 12.9 12.217 Z"
            }), Object(jsx.c)("path", {
                fill: primary,
                d: "M 35.2 12.117 L 31.5 12.117 C 31.2 12.117 30.9 12.317 30.9 12.617 L 30.7 13.617 L 30.4 13.217 C 29.6 12.017 27.8 11.617 26 11.617 C 21.9 11.617 18.4 14.717 17.7 19.117 C 17.3 21.317 17.8 23.417 19.1 24.817 C 20.2 26.117 21.9 26.717 23.8 26.717 C 27.1 26.717 29 24.617 29 24.617 L 28.8 25.617 C 28.7 26.017 29 26.417 29.4 26.417 L 32.8 26.417 C 33.3 26.417 33.8 26.017 33.9 25.517 L 35.9 12.717 C 36 12.517 35.6 12.117 35.2 12.117 Z M 30.1 19.317 C 29.7 21.417 28.1 22.917 25.9 22.917 C 24.8 22.917 24 22.617 23.4 21.917 C 22.8 21.217 22.6 20.317 22.8 19.317 C 23.1 17.217 24.9 15.717 27 15.717 C 28.1 15.717 28.9 16.117 29.5 16.717 C 30 17.417 30.2 18.317 30.1 19.317 Z"
            }), Object(jsx.c)("path", {
                fill: primary,
                d: "M 55.1 12.117 L 51.4 12.117 C 51 12.117 50.7 12.317 50.5 12.617 L 45.3 20.217 L 43.1 12.917 C 43 12.417 42.5 12.117 42.1 12.117 L 38.4 12.117 C 38 12.117 37.6 12.517 37.8 13.017 L 41.9 25.117 L 38 30.517 C 37.7 30.917 38 31.517 38.5 31.517 L 42.2 31.517 C 42.6 31.517 42.9 31.317 43.1 31.017 L 55.6 13.017 C 55.9 12.717 55.6 12.117 55.1 12.117 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 67.5 4.917 L 59.7 4.917 C 59.2 4.917 58.7 5.317 58.6 5.817 L 55.5 25.717 C 55.4 26.117 55.7 26.417 56.1 26.417 L 60.1 26.417 C 60.5 26.417 60.8 26.117 60.8 25.817 L 61.7 20.117 C 61.8 19.617 62.2 19.217 62.8 19.217 L 65.3 19.217 C 70.4 19.217 73.4 16.717 74.2 11.817 C 74.5 9.717 74.2 8.017 73.2 6.817 C 72 5.617 70.1 4.917 67.5 4.917 Z M 68.4 12.217 C 68 15.017 65.8 15.017 63.8 15.017 L 62.6 15.017 L 63.4 9.817 C 63.4 9.517 63.7 9.317 64 9.317 L 64.5 9.317 C 65.9 9.317 67.2 9.317 67.9 10.117 C 68.4 10.517 68.5 11.217 68.4 12.217 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 90.7 12.117 L 87 12.117 C 86.7 12.117 86.4 12.317 86.4 12.617 L 86.2 13.617 L 85.9 13.217 C 85.1 12.017 83.3 11.617 81.5 11.617 C 77.4 11.617 73.9 14.717 73.2 19.117 C 72.8 21.317 73.3 23.417 74.6 24.817 C 75.7 26.117 77.4 26.717 79.3 26.717 C 82.6 26.717 84.5 24.617 84.5 24.617 L 84.3 25.617 C 84.2 26.017 84.5 26.417 84.9 26.417 L 88.3 26.417 C 88.8 26.417 89.3 26.017 89.4 25.517 L 91.4 12.717 C 91.4 12.517 91.1 12.117 90.7 12.117 Z M 85.5 19.317 C 85.1 21.417 83.5 22.917 81.3 22.917 C 80.2 22.917 79.4 22.617 78.8 21.917 C 78.2 21.217 78 20.317 78.2 19.317 C 78.5 17.217 80.3 15.717 82.4 15.717 C 83.5 15.717 84.3 16.117 84.9 16.717 C 85.5 17.417 85.7 18.317 85.5 19.317 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 95.1 5.417 L 91.9 25.717 C 91.8 26.117 92.1 26.417 92.5 26.417 L 95.7 26.417 C 96.2 26.417 96.7 26.017 96.8 25.517 L 100 5.617 C 100.1 5.217 99.8 4.917 99.4 4.917 L 95.8 4.917 C 95.4 4.917 95.2 5.117 95.1 5.417 Z"
            }));
        }, _fundingLogos[constants.h.CREDIT] = function(_ref) {
            var logoColor = _ref.logoColor, locale = _ref.locale;
            if (!CREDIT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " credit logo available");
            var primary = CREDIT_LOGO_COLORS[logoColor].primary;
            switch ((locale || {}).country) {
              case constants.r.DE:
                return Object(jsx.c)("svg", {
                    width: "135",
                    height: "32",
                    viewBox: "0 0 135 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.c)("g", {
                    transform: "matrix(1.3333333,0,0,-1.3333333,10,40)",
                    fill: primary
                }, Object(jsx.c)("g", {
                    transform: "matrix(0.17016911,0,0,0.17819595,39.327112,22.053803)"
                }, Object(jsx.c)("path", {
                    d: "m 0,0 -1.35,-8.619 c -0.146,-0.929 -0.946,-1.613 -1.886,-1.613 h -40.935 c -0.922,0 -1.445,1.057 -0.884,1.79 l 29.853,39.007 h -19.237 c -0.683,0 -1.205,0.611 -1.099,1.286 l 1.35,8.619 c 0.145,0.929 0.945,1.613 1.885,1.613 H 7.112 c 0.922,0 1.444,-1.055 0.886,-1.788 L -21.724,1.286 H -1.1 C -0.416,1.286 0.106,0.675 0,0 m 203.3312,42.0833 c 0.684,0 1.206,-0.611 1.1,-1.287 l -4.446,-28.132 c -1.041,-6.73 -2.359,-13.391 -8.395,-18.456 -5.065,-4.302 -12.143,-5.828 -18.248,-5.828 -6.106,0 -12.767,1.526 -16.444,5.828 -4.371,5.065 -3.608,11.726 -2.567,18.456 l 4.394,27.808 c 0.146,0.928 0.946,1.611 1.885,1.611 h 10.668 c 0.683,0 1.205,-0.61 1.1,-1.285 l -4.101,-26.261 c -1.11,-6.799 -1.804,-14.223 6.938,-14.223 8.743,0 10.408,7.424 11.518,14.223 l 4.05,25.932 c 0.145,0.929 0.945,1.614 1.885,1.614 z m -361.2517,-52.3157 h -10.665 c -0.685,0 -1.207,0.611 -1.1,1.287 l 6.249,39.511 h -9.939 c -0.684,0 -1.206,0.61 -1.1,1.285 l 1.35,8.619 c 0.146,0.929 0.946,1.614 1.886,1.614 h 33.145 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -9.608 l -6.198,-39.188 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 m -98.5277,28.8638 h 1.318 c 4.441,0 9.549,0.837 10.477,6.522 0.929,5.688 -2.034,6.505 -6.779,6.522 h -1.927 c -0.58,0 -1.075,-0.422 -1.166,-0.995 z m 23.345,-28.864 h -13.977 c -0.594,0 -1.136,0.341 -1.393,0.878 l -9.224,19.244 h -0.139 l -2.985,-18.819 c -0.119,-0.75 -0.766,-1.303 -1.526,-1.303 h -10.977 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.848,49.725 c 0.119,0.751 0.766,1.304 1.526,1.304 h 19.009 c 10.339,0 17.416,-4.926 15.681,-16.097 -1.179,-7.216 -6.175,-13.461 -13.807,-14.779 l 12.015,-19.748 c 0.451,-0.742 -0.083,-1.692 -0.951,-1.692 m 445.918,52.3159 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 m -304.5422,0 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 M 131.156,1.2855 h 15.004 c 0.684,0 1.206,-0.61 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.928 -0.945,-1.613 -1.885,-1.613 h -26.969 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.927 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.612 1.099,-1.287 z m -33.5321,20.607 2.937,18.58 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.1,-1.287 l -7.8,-49.418 c -0.146,-0.927 -0.946,-1.611 -1.885,-1.611 h -10.664 c -0.685,0 -1.207,0.612 -1.1,1.288 l 3.196,20.152 h -19.636 l -3.145,-19.83 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 h -10.666 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.099,-1.287 l -2.988,-18.904 z m 221.8207,-2.9142 c 0.699,0 1.224,-0.638 1.094,-1.325 -1.342,-7.069 -3.07,-13.21 -8.427,-19.351 -6.245,-7.147 -14.432,-10.269 -23.175,-10.269 -16.444,0 -26.088,11.171 -23.521,27.615 2.706,16.999 15.958,28.17 32.819,28.17 10.373,0 17.776,-4.519 20.966,-13.617 0.198,-0.566 -0.087,-1.189 -0.644,-1.409 l -11.599,-4.569 c -0.598,-0.236 -1.275,0.081 -1.466,0.694 -1.354,4.349 -4.637,7.175 -9.686,7.175 -8.95,0 -14.987,-8.535 -16.236,-16.514 -1.318,-8.118 2.29,-16.374 11.24,-16.374 5.898,0 10.894,3.053 12.351,9.089 h -9.793 c -0.686,0 -1.209,0.614 -1.099,1.292 l 1.373,8.458 c 0.088,0.539 0.553,0.935 1.099,0.935 z m -438.1464,9.9777 -1.132,-7.133 h 14.032 c 0.684,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -12.076 c -0.937,0 -1.735,-0.68 -1.884,-1.605 l -1.198,-7.415 h 14.865 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -26.831 c -0.684,0 -1.206,0.611 -1.099,1.286 l 7.799,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 h 26.834 c 0.683,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.146,-0.929 -0.946,-1.614 -1.886,-1.614 h -12.904 c -0.939,0 -1.738,-0.682 -1.885,-1.609 M 34.135,25.9168 H 33.996 L 25.739,9.2648 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 H 2.701 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 L 55.21,-8.8812 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 H 41.905 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m -216.5493,27.06 h -0.139 l -8.257,-16.652 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 h -11.907 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 l 10.961,-50.089 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 h -12.217 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m 517.9793,-39.4791 -6.146,-39.098 c -0.119,-0.757 0.467,-1.442 1.233,-1.442 h 6.181 c 1.024,0 1.896,0.745 2.055,1.756 l 6.06,38.396 c 0.119,0.757 -0.466,1.442 -1.233,1.442 h -6.917 c -0.614,0 -1.138,-0.447 -1.233,-1.054 m -77.0618,-12.7966 h -7.207 c -0.689,0 -1.334,-0.342 -1.721,-0.912 l -9.942,-14.642 -4.213,14.07 c -0.263,0.88 -1.073,1.484 -1.993,1.484 h -7.084 c -0.856,0 -1.457,-0.842 -1.182,-1.651 l 7.936,-23.294 -7.464,-10.531 c -0.586,-0.827 0.005,-1.97 1.018,-1.97 h 7.2 c 0.683,0 1.322,0.334 1.71,0.895 l 23.968,34.591 c 0.574,0.828 -0.019,1.96 -1.026,1.96 m 58.6183,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.53,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.234,-1.054 l -0.315,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.922,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -116.7913,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.531,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.233,-1.054 l -0.316,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.921,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -43.0269,-0.172 c -0.818,-5.375 -4.924,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.618,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.149 c 1.024,0 1.896,0.745 2.055,1.756 l 1.634,10.358 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.904,3.825 -10.913,3.825 m 108.5272,-14.023 c -0.818,-5.375 -4.923,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.619,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.683 c 0.717,0 1.327,0.521 1.438,1.229 l 1.717,10.885 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.903,3.825 -10.913,3.825 m -161.6161,-40.475 -4.55,18.557 h 3.561 l 3.442,-14.442 7.914,14.442 h 3.798 l -15.748,-27.656 h -3.758 z M 82.525,-65.6994 c -0.989,1.121 -2.328,1.681 -4.016,1.681 -1.319,0 -2.546,-0.356 -3.679,-1.068 -1.135,-0.712 -2.045,-1.701 -2.731,-2.967 -0.686,-1.267 -1.028,-2.691 -1.028,-4.274 0,-1.767 0.5,-3.205 1.503,-4.313 1.002,-1.107 2.242,-1.661 3.719,-1.661 1.346,0 2.612,0.369 3.799,1.108 1.187,0.738 2.136,1.746 2.848,3.026 0.713,1.28 1.069,2.672 1.069,4.175 0,1.74 -0.495,3.171 -1.484,4.293 m -8.527,12.206 -1.661,-10.604 c 0.791,0.976 1.806,1.761 3.047,2.354 1.239,0.594 2.65,0.891 4.233,0.891 1.529,0 2.908,-0.376 4.135,-1.128 1.226,-0.752 2.182,-1.787 2.868,-3.106 0.686,-1.319 1.029,-2.809 1.029,-4.472 0,-2.162 -0.515,-4.153 -1.543,-5.974 -1.029,-1.819 -2.388,-3.264 -4.075,-4.332 -1.689,-1.068 -3.469,-1.602 -5.342,-1.602 -1.635,0 -2.981,0.329 -4.036,0.988 -1.055,0.659 -1.912,1.623 -2.571,2.889 l -0.515,-3.205 h -3.403 l 4.313,27.301 z M 39.4576,-76.5416 c 0.976,-1.121 2.308,-1.681 3.996,-1.681 1.319,0 2.552,0.356 3.699,1.069 1.148,0.712 2.064,1.701 2.751,2.967 0.685,1.266 1.028,2.691 1.028,4.273 0,1.767 -0.501,3.198 -1.503,4.293 -1.003,1.095 -2.256,1.642 -3.759,1.642 -1.32,0 -2.572,-0.37 -3.759,-1.108 -1.187,-0.738 -2.136,-1.741 -2.849,-3.007 -0.712,-1.266 -1.068,-2.651 -1.068,-4.155 0,-1.741 0.488,-3.171 1.464,-4.293 m 9.892,-4.253 0.474,2.968 c -0.844,-1.108 -1.899,-1.986 -3.165,-2.631 -1.266,-0.647 -2.704,-0.969 -4.313,-0.969 -1.53,0 -2.902,0.369 -4.115,1.107 -1.214,0.738 -2.163,1.767 -2.848,3.086 -0.687,1.319 -1.029,2.823 -1.029,4.51 0,2.111 0.507,4.083 1.523,5.916 1.016,1.833 2.347,3.29 3.996,4.372 1.648,1.081 3.357,1.622 5.124,1.622 3.297,0 5.553,-1.279 6.766,-3.837 l 1.781,11.157 h 3.521 l -4.313,-27.301 z m -28.8284,15.3321 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.395,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.688,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.306,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.205,1.484 l -0.476,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.845,1.806 2.124,3.323 3.839,4.55 1.714,1.226 3.824,1.84 6.33,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -18.0138,-1.4448 c -1.556,0 -2.875,-0.561 -3.956,-1.681 -1.082,-1.122 -1.794,-2.751 -2.137,-4.888 l -1.543,-9.772 h -3.522 l 3.047,19.308 h 3.403 l -0.515,-3.283 c 1.583,2.268 3.483,3.402 5.698,3.402 0.554,0 1.068,-0.039 1.543,-0.119 l -0.475,-3.086 c -0.474,0.079 -0.989,0.119 -1.543,0.119 m -24.5657,-1.0092 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.396,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.689,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.305,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.204,1.484 l -0.475,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.844,1.806 2.124,3.323 3.838,4.55 1.715,1.226 3.824,1.84 6.331,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -24.4869,-17.7856 h -3.561 l -2.057,14.837 -6.766,-14.837 h -3.522 l -2.77,19.308 h 3.522 l 1.741,-15.193 6.805,15.193 h 3.324 l 2.017,-15.154 6.529,15.154 h 3.6 z M -59.063,-65.225 c -1.201,-0.778 -2.124,-1.807 -2.77,-3.086 -0.647,-1.28 -0.969,-2.619 -0.969,-4.017 0,-1.741 0.494,-3.171 1.484,-4.292 0.988,-1.122 2.261,-1.682 3.817,-1.682 1.53,0 2.889,0.402 4.076,1.207 1.187,0.805 2.11,1.852 2.769,3.146 0.659,1.292 0.99,2.637 0.99,4.035 0,1.715 -0.495,3.12 -1.484,4.215 -0.989,1.093 -2.262,1.641 -3.818,1.641 -1.53,0 -2.896,-0.389 -4.095,-1.167 M -50.28,-62 c 1.332,-0.766 2.368,-1.827 3.106,-3.185 0.738,-1.359 1.108,-2.896 1.108,-4.61 0,-1.952 -0.482,-3.825 -1.444,-5.618 -0.963,-1.794 -2.321,-3.251 -4.075,-4.372 -1.755,-1.122 -3.766,-1.682 -6.034,-1.682 -1.688,0 -3.199,0.383 -4.531,1.148 -1.331,0.764 -2.374,1.833 -3.125,3.205 -0.752,1.37 -1.128,2.914 -1.128,4.628 0,1.979 0.481,3.859 1.444,5.639 0.963,1.781 2.321,3.224 4.076,4.332 1.753,1.108 3.764,1.663 6.033,1.663 1.715,0 3.238,-0.383 4.57,-1.148 m -20.7559,4.1545 c -0.897,0.87 -2.255,1.305 -4.075,1.305 h -4.471 l -1.82,-11.513 h 4.668 c 2.401,0 4.175,0.639 5.322,1.919 1.148,1.279 1.721,2.894 1.721,4.847 0,1.424 -0.448,2.571 -1.345,3.442 m 3.027,2.373 c 1.464,-1.318 2.196,-3.112 2.196,-5.38 0,-3.113 -0.944,-5.599 -2.829,-7.459 -1.887,-1.859 -4.715,-2.789 -8.487,-2.789 h -4.748 l -1.543,-9.694 h -3.759 l 4.313,27.301 h 8.309 c 2.901,0 5.084,-0.66 6.548,-1.979"
                }))));

              default:
                return Object(jsx.c)("svg", {
                    width: "100",
                    height: "32",
                    viewBox: "0 0 95 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 52.732 6.347 C 52.83 5.963 53.122 5.675 53.512 5.675 L 60.626 5.675 C 66.571 5.675 70.664 10.187 69.69 15.851 C 68.813 21.515 63.16 25.931 57.313 25.931 L 50.004 25.931 C 49.711 25.931 49.516 25.739 49.614 25.451 L 52.732 6.347 Z M 55.753 21.515 L 57.02 21.515 C 60.236 21.515 63.355 19.787 64.037 15.851 C 64.622 12.203 62.478 10.187 58.97 10.187 L 57.995 10.187 C 57.8 10.187 57.605 10.283 57.605 10.475 L 55.753 21.515 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 43.571 10.763 L 43.084 13.547 L 48.737 13.547 C 49.029 13.547 49.224 13.739 49.224 14.027 L 48.639 17.387 C 48.542 17.771 48.249 17.963 47.859 17.963 L 42.987 17.963 C 42.597 17.963 42.304 18.251 42.207 18.635 L 41.72 21.515 L 47.762 21.515 C 48.054 21.515 48.249 21.707 48.152 21.995 L 47.665 25.355 C 47.567 25.643 47.275 25.931 46.885 25.931 L 36.067 25.931 C 35.775 25.931 35.58 25.643 35.58 25.451 L 38.699 6.347 C 38.796 5.963 39.186 5.675 39.478 5.675 L 50.393 5.675 C 50.588 5.675 50.881 5.963 50.783 6.155 L 50.296 9.515 C 50.198 9.899 49.906 10.091 49.516 10.091 L 44.254 10.091 C 43.864 10.187 43.571 10.379 43.571 10.763 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 74.563 25.931 L 70.274 25.931 C 69.982 25.931 69.787 25.739 69.787 25.451 L 73.003 6.347 C 73.003 5.963 73.393 5.675 73.685 5.675 L 78.071 5.675 C 78.266 5.675 78.558 5.963 78.461 6.251 L 75.342 25.355 C 75.245 25.643 74.952 25.931 74.563 25.931 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 34.118 25.931 L 28.466 25.931 C 28.173 25.931 27.978 25.835 27.881 25.643 L 24.178 18.155 L 24.08 18.155 L 22.911 25.451 C 22.813 25.739 22.618 25.931 22.326 25.931 L 17.843 25.931 C 17.551 25.931 17.356 25.739 17.453 25.451 L 20.572 6.251 C 20.669 5.963 20.864 5.675 21.156 5.675 L 28.855 5.675 C 33.046 5.675 35.97 7.595 35.288 11.915 C 34.8 14.699 32.754 17.195 29.635 17.675 L 34.508 25.355 C 34.703 25.547 34.411 25.931 34.118 25.931 Z M 24.665 14.795 L 25.152 14.795 C 27.004 14.795 29.05 14.411 29.44 12.203 C 29.83 10.091 28.661 9.707 26.711 9.707 L 25.932 9.707 C 25.639 9.707 25.445 9.899 25.445 10.091 L 24.665 14.795 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 86.16 25.931 L 81.872 25.931 C 81.579 25.931 81.384 25.739 81.482 25.451 L 83.918 10.187 L 79.923 10.187 C 79.63 10.187 79.435 9.899 79.533 9.611 L 80.02 6.347 C 80.118 5.963 80.41 5.675 80.8 5.675 L 94.249 5.675 C 94.444 5.675 94.736 5.963 94.639 6.251 L 94.054 9.515 C 94.054 9.899 93.761 10.187 93.372 10.187 L 89.473 10.187 L 86.939 25.355 C 86.939 25.643 86.647 25.931 86.16 25.931 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 17.648 11.435 C 17.648 11.819 17.161 12.011 16.868 11.723 C 15.894 10.763 14.529 10.283 13.068 10.283 C 9.657 10.283 7.025 12.779 6.441 15.851 C 5.953 19.019 7.902 21.323 11.313 21.323 C 12.678 21.323 14.237 20.843 15.407 19.979 C 15.796 19.787 16.284 20.075 16.186 20.459 L 15.407 25.067 C 15.309 25.355 15.114 25.547 14.822 25.643 C 13.165 26.123 11.898 26.507 10.339 26.507 C 1.178 26.507 -0.284 19.019 0.203 15.851 C 1.47 6.923 9.072 4.907 13.652 5.195 C 15.114 5.195 16.479 5.387 17.745 5.867 C 18.233 6.059 18.428 6.443 18.33 6.923 L 17.648 11.435 Z"
                }));
            }
        }, _fundingLogos[constants.h.VENMO] = ((_BUTTON_LOGO$VENMO = {})[constants.i.WHITE] = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="White" fill="#FFFFFF">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$VENMO[constants.i.BLUE] = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Blue" fill="#3D93CE">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$VENMO), _fundingLogos[constants.h.ITAU] = ((_BUTTON_LOGO$ITAU = {})[constants.i.WHITE] = '<?xml version="1.0" encoding="UTF-8"?>\n\x3c!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 181 33" preserveAspectRatio="xMinYMin meet">\n   <path fill="#FF7900" d="M136.5,5.6L153,1.8c2.2-0.5,4.4,0.8,5,2.9l4,15.2c0.5,2.1-0.8,4.2-3,4.7l-16.5,3.8c-2.2,0.5-4.4-0.8-5-2.9  l-4-15.2C132.8,8.3,134.2,6.1,136.5,5.6z" />\n   <path fill="#004995" d="M144.5,6.1h10.1c1.5,0,2.7,1.2,2.7,2.5v9.7c0,1.3-1.2,2.5-2.7,2.5h-10.1c-1.5,0-2.7-1.2-2.7-2.5V8.6  C141.9,7.2,143.1,6.1,144.5,6.1z" />\n   <path fill="#FFFFFF" d="M108.2,19.9c-0.1-1-0.5-1.9-1.1-2.8c-1.1-1.3-2.8-2-4.6-1.9c-1.6,0.1-3.9,0.3-5.3,1.3L98,19  c0,0,1.3-1.1,3.9-1.1c1.1,0,2.1,0.6,2.3,1.3v0.2c-1.4,0-5.7,0.3-7.4,2.8c-2,3,1.1,5.8,3.1,5.8c1.6,0,3.2,0.1,4.6-1.3l0.2,1.1h3.4  v-7.3c0-0.1,0-0.2,0-0.2L108.2,19.9L108.2,19.9z M100.4,24.1c0.2-1.8,2.7-1.9,3.9-1.9v2.1C103,26,100.2,25.8,100.4,24.1z" />\n   <path fill="#FFFFFF" d="M95.2,16.1c0,0-7.6-2-10,3c-1.3,2.8-0.7,5.7,0.8,7.3c0.7,0.7,1.6,1.2,2.6,1.5c2,0.6,5.4,0.4,6.5-0.2l-0.4-2.8  c0,0-3.4,1.1-5.2-0.6c-2.2-2.2-0.2-5.7,2.1-5.7c2.3,0,3.1,0.4,3.1,0.4L95.2,16.1z" />\n   <rect fill="#FFFFFF" x="42.3" y="11.7" width="3.9" height="16.3" />\n   <path fill="#FFFFFF" d="M55.7,18.7v-3h-2.1v-4.1h-3.9v4.1h-2v3h2v6.2c0,1.7,1.3,3,3,3l0,0h3.1v-3h-1.1c-0.7,0-1.1-0.5-1.1-1.1l0,0v-5.2  L55.7,18.7L55.7,18.7z" />\n   <path fill="#FFFFFF" d="M69,19.9c-0.1-1-0.5-1.9-1.1-2.8c-1.2-1.3-2.8-2-4.6-1.9c-1.6,0.1-3.9,0.3-5.3,1.3l0.8,2.5c0,0,1.3-1.1,3.9-1.1  c1.1,0,2.1,0.6,2.3,1.3v0.2c-1.4,0-5.8,0.3-7.4,2.8c-2,3,1.1,5.8,3.1,5.8c1.6,0,3.2,0.1,4.6-1.3l0.2,1.1H69V19.9L69,19.9z   M61.1,24.1c0.2-1.8,2.7-1.9,3.9-1.9v2.1C63.8,26,60.9,25.8,61.1,24.1L61.1,24.1z" />\n   <path fill="#FFFFFF" d="M79.1,15.7v7.2c0,0.3-0.1,0.5-0.2,0.7c-0.5,0.7-1.1,1.3-2,1.3c-0.9,0.1-1.8-0.5-2.1-1.3  c-0.1-0.2-0.1-0.4-0.1-0.6v-7.3h-3.9V24c0,2.1,1.8,4.1,3.9,4.1c3.9,0.2,4.6-1.8,4.6-1.8v-0.1l0.4,1.5H83V15.6L79.1,15.7z" />\n   <rect fill="#FFF100" x="143.1" y="13.5" width="1.2" height="5" />\n   <path fill="#FFF100" d="M147.3,15.7v-0.9h-0.7v-1.3h-1.2v1.3h-0.6v0.9h0.6v1.9c0,0.5,0.4,0.9,1,0.9h1v-0.9H147c-0.2,0-0.4-0.2-0.4-0.3  l0,0v-1.6C146.6,15.7,147.3,15.7,147.3,15.7z" />\n   <path fill="#FFF100" d="M151.6,16c0-0.3-0.2-0.6-0.4-0.8c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.7,0.4l0.3,0.8c0.4-0.3,0.8-0.3,1.2-0.3  c0.3,0,0.6,0.2,0.7,0.3v0.1c-0.4,0-1.9,0.1-2.3,0.8c-0.4,0.6-0.2,1.3,0.4,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.5,0.1,1.1-0.1,1.5-0.3  l0.1,0.3h1.1L151.6,16L151.6,16z M149.1,17.3c0.1-0.6,0.9-0.6,1.2-0.6v0.7C149.9,17.9,149,17.8,149.1,17.3L149.1,17.3z" />\n   <path fill="#FFF100" d="M154.8,14.8V17c-0.1,0.3-0.4,0.4-0.7,0.5c-0.4,0-0.6-0.2-0.7-0.5v-2.3h-1.2v2.5c0,0.7,0.5,1.2,1.2,1.3  c1.2,0.1,1.5-0.5,1.5-0.5l0,0l0.2,0.4h1.1v-3.8L154.8,14.8L154.8,14.8z" />\n   <path fill="#FFFFFF" d="M113.5,17.9l-0.2-2.1H110V28h3.9v-6.8c0.4-0.8,1.2-2.1,3.4-2.1v-3.6C115.9,15.4,114.4,16.3,113.5,17.9z" />\n   <path fill="#FFFFFF" d="M128.1,10.4v6.4c-0.7-0.6-1.7-1.4-3.7-1.4c-3.6,0-6.1,3.2-6.1,6.8c-0.1,3.2,2.6,5.9,5.9,6  c1.5-0.1,3-0.6,4.2-1.4L129,28h3.1V10.5L128.1,10.4L128.1,10.4z M125.4,25.1c-2.3,0-2.8-1.9-2.8-3.4s0.7-3.2,2.8-3.2  c1.3,0,2.1,0.9,2.7,1.8v3C127.5,24.1,126.6,25.1,125.4,25.1z" />\n   <polygon fill="#FFF100" points="154.6,14.4 153.5,14.4 154.4,13.5 155.7,13.5 " />\n   <line fill="none" x1="35.6" y1="8.3" x2="35.6" y2="28.2" />\n   <rect fill="#D8D8D8" x="22.4" y="32.2" width="0.1" height="0.1" />\n   <path fill="#FFFFFF" opacity="0.7" enable-background="new    " d="M25.3,12.9c0.2-1.6,0-2.6-0.9-3.7s-2.6-1.5-4.6-1.5h-6.1c-0.4,0-0.8,0.3-0.9,0.8l-2.5,16.8  c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l-0.3,1.7c-0.1,0.2,0.2,0.5,0.4,0.5H18c0.4,0,0.6-0.3,0.7-0.7l0.1-0.2l0.6-3.9l0.1-0.2  c0.1-0.5,0.4-0.7,0.7-0.7h0.5c3.1,0,5.4-1.4,6.1-5.1c0.3-1.6,0.1-2.9-0.6-3.8C25.9,13.4,25.6,13.1,25.3,12.9L25.3,12.9" />\n   <path fill="#FFFFFF" opacity="0.7" enable-background="new    " d="M25.3,12.9c0.2-1.6,0-2.6-0.9-3.7s-2.6-1.5-4.6-1.5h-6.1c-0.4,0-0.8,0.3-0.9,0.8l-2.5,16.8  c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l0.9-6.3l-0.1,0.2c0.1-0.5,0.4-0.8,0.9-0.8h1.8c3.5,0,6.2-1.5,7-5.8C25.2,13.2,25.2,13,25.3,12.9" />\n   <path fill="#FFFFFF" d="M16.6,12.9c0-0.2,0.1-0.5,0.4-0.6c0.1,0,0.2-0.1,0.3-0.1h4.8c0.6,0,1.1,0.1,1.6,0.1c0.1,0,0.2,0,0.4,0.1  c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2c0.2-1.6,0-2.6-0.9-3.6c-0.9-1.1-2.6-1.6-4.6-1.6h-6.1  c-0.4,0-0.8,0.4-0.9,0.8l-2.5,16.8c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l0.9-6.3L16.6,12.9z" />\n   <g transform="matrix(0.379173, 0, 0, 0.397443, 9.686229, 4.778377)" opacity="0.2">\n      <path fill="#231F20" d="M41.1,20.5c0.9,0.5,1.7,1.1,2.3,1.8c1,1.1,1.6,2.5,1.9,4.1c0.3-3.2-0.2-5.8-1.9-7.8c-0.6-0.7-1.3-1.2-2.1-1.7   C41.3,18,41.3,19.2,41.1,20.5z" />\n      <path fill="#231F20" d="M2.2,49L8.5,9.4c0.1-1.1,1.1-1.9,2.2-1.9h16c5.5,0,9.8,1.2,12.2,3.9c1.2,1.4,1.9,3,2.2,4.8   c0.4-3.6-0.2-6.1-2.2-8.4c-2.4-2.8-6.7-4-12.2-4h-16c-1.1,0-2.1,0.8-2.3,1.9L1.8,47.9C1.8,48.3,1.9,48.7,2.2,49z" />\n      <path fill="#231F20" d="M12.5,53.2l-0.1,0.6c-0.1,0.4,0.1,0.8,0.4,1.1l0.3-1.7C13.1,53.2,12.5,53.2,12.5,53.2z" />\n   </g>\n   <rect fill="#FFFFFF" x="35.5" y="6.7" width="1.1" height="21.5" />\n</svg>', 
        _BUTTON_LOGO$ITAU), _fundingLogos[constants.h.IDEAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!IDEAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " ideal logo available");
            var _IDEAL_LOGO_COLORS$lo = IDEAL_LOGO_COLORS[logoColor], primary = _IDEAL_LOGO_COLORS$lo.primary, secondary = _IDEAL_LOGO_COLORS$lo.secondary, tertiary = _IDEAL_LOGO_COLORS$lo.tertiary;
            return Object(jsx.c)("svg", {
                width: "38",
                height: "32",
                viewBox: "0 0 38 32",
                preserveAspectRatio: "xMinYMin meet",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("polygon", {
                fill: primary,
                points: "4.47 27.632 10.452 27.632 10.452 17.982 4.47 17.982"
            }), Object(jsx.c)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 0.31993, 0.181113)"
            }, Object(jsx.c)("path", {
                d: "M11.1102604,13.937999 C11.1102604,15.8893766 9.51859887,17.4723289 7.55546104,17.4723289 C5.59238806,17.4723289 4.00066169,15.8893766 4.00066169,13.937999 C4.00066169,11.9865569 5.59238806,10.4043136 7.55546104,10.4043136 C9.51859887,10.4043136 11.1102604,11.9865569 11.1102604,13.937999",
                fill: primary
            }), Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "39.1898554 33.9678282 0 33.9678282 0 0.001572704 39.1898554 0.001572704",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("g", null), Object(jsx.c)("path", {
                d: "M22.1049929,2.25750057 C26.4717361,2.25750057 30.1110886,3.433548 32.6296578,5.65853743 C35.476843,8.17370364 36.9204068,11.9843525 36.9204068,16.9847134 C36.9204068,26.8945533 32.0742264,31.7119261 22.1049929,31.7119261 L2.26942909,31.7119261 L2.26942909,2.25750057 L22.1049929,2.25750057 Z M22.531325,0.001572704 L-1.9452416e-05,0.001572704 L-1.9452416e-05,33.967854 L22.531325,33.967854 L22.531325,33.9614085 C27.4529808,33.8947619 31.3518934,32.6793969 34.1187402,30.3394196 C37.4837488,27.4935988 39.1898554,23.0003706 39.1898554,16.9847134 C39.1898554,14.1090499 38.7410881,11.5297509 37.8560681,9.31836144 C37.0093692,7.2028812 35.758125,5.40419768 34.13722,3.97219912 C31.2823834,1.45020067 27.2749912,0.0865245021 22.531325,0.00904949351 L22.531325,0.001572704 Z",
                fill: primary
            })), Object(jsx.c)("path", {
                d: "M21.4851352,29.4975138 L13.5194356,29.4975138 L13.5194356,5.00387361 L21.4851352,5.00387361 L21.1636516,5.00387361 C27.8067813,5.00387361 34.8779291,7.60998594 34.8779291,17.282889 C34.8779291,27.5088167 27.8067813,29.4975138 21.1636516,29.4975138 L21.4851352,29.4975138 Z",
                fill: tertiary
            })), Object(jsx.c)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 11.685725, 10.562208)",
                fill: secondary
            }, Object(jsx.c)("path", {
                d: "M1.41115607,1.17495169 L1.41115607,5.07048794 L2.30681015,5.07048794 C2.64178075,5.07048794 2.88357428,5.05173151 3.03219074,5.0142831 C3.2267149,4.96613516 3.38810511,4.88459948 3.51649106,4.76961161 C3.64474732,4.65455929 3.749531,4.46538363 3.83058274,4.20189125 C3.91163447,3.93846333 3.95216034,3.57944852 3.95216034,3.12471792 C3.95216034,2.67005177 3.91163447,2.3210275 3.83058274,2.07764511 C3.749531,1.83426272 3.63605858,1.64437805 3.49016546,1.5079911 C3.34420749,1.37160414 3.15915018,1.27930447 2.93492866,1.23109207 C2.76737852,1.19370812 2.43915142,1.17495169 1.95018252,1.17495169 L1.41115607,1.17495169 Z M0.215675421,0.175897919 L2.40271056,0.175897919 C2.89589415,0.175897919 3.27190935,0.213410777 3.53069132,0.288436492 C3.878306,0.390275522 4.17612249,0.571265392 4.42407595,0.831212737 C4.67202941,1.09116008 4.86065301,1.40950373 4.99001157,1.78598587 C5.11937014,2.16253246 5.18408185,2.62686687 5.18408185,3.1789891 C5.18408185,3.66407805 5.12345515,4.08213371 5.00220176,4.433285 C4.85397434,4.86210466 4.6423969,5.20919527 4.36753426,5.47449239 C4.15997698,5.67552779 3.87966767,5.832347 3.52660632,5.94488558 C3.26244251,6.02796818 2.90938115,6.06954171 2.46742226,6.06954171 L0.215675421,6.06954171 L0.215675421,0.175897919 Z"
            }), Object(jsx.c)("path", {
                d: "M2.40271056,0.337035624 C2.87825729,0.337035624 3.24247136,0.372743739 3.48523751,0.443128689 C3.80302515,0.536201827 4.07944398,0.704171771 4.30645367,0.942075479 C4.53702965,1.18384649 4.7154083,1.48530291 4.83666169,1.83813003 C4.95966581,2.19611355 5.02197838,2.64723467 5.02197838,3.1789891 C5.02197838,3.64390361 4.96375081,4.04829479 4.84885188,4.38094747 C4.70970226,4.78359837 4.50973142,5.11264156 4.25458057,5.35892443 C4.06589213,5.54165459 3.80438682,5.68712971 3.47713234,5.79148248 C3.23060538,5.86895749 2.89070683,5.908404 2.46742226,5.908404 L0.377778888,5.908404 L0.377778888,0.337035624 L2.40271056,0.337035624 Z M0.0535719538,0.0147602138 L0.0535719538,6.23067941 L2.46742226,6.23067941 C2.92390562,6.23067941 3.2967436,6.18614095 3.57549672,6.09848204 C3.95157676,5.97866004 4.25594223,5.80759625 4.48061764,5.58993144 C4.77246872,5.30819828 4.9996081,4.93661473 5.15548679,4.48562252 C5.28205718,4.11919538 5.34618531,3.67954727 5.34618531,3.1789891 C5.34618531,2.61178438 5.27797217,2.12559969 5.1434263,1.73390616 C5.00706486,1.33699177 4.80456521,0.995959927 4.54169823,0.720349996 C4.27494076,0.440679396 3.9502151,0.243317935 3.57646934,0.133873205 C3.29992083,0.0536910833 2.91612466,0.0147602138 2.40271056,0.0147602138 L0.0535719538,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M1.9501501,1.33608939 C2.54124418,1.33608939 2.79263424,1.36451409 2.899428,1.38836247 C3.09466542,1.43032272 3.25566658,1.50998921 3.37905974,1.6253638 C3.50439814,1.74254314 3.60457808,1.91180219 3.6766817,2.12824235 C3.75189771,2.35415741 3.79002445,2.68945275 3.79002445,3.12471792 C3.79002445,3.56127219 3.75150867,3.90784717 3.67551456,4.15477459 C3.60360546,4.38861762 3.51354078,4.55523401 3.40791416,4.64991853 C3.30014777,4.74647224 3.16054427,4.81647046 2.99299412,4.85797953 C2.85754047,4.89207627 2.62683481,4.90935023 2.30677773,4.90935023 L1.57329196,4.90935023 L1.57329196,1.33608939 L1.9501501,1.33608939 Z M1.24902018,1.01381398 L1.24902018,5.23162564 L2.30677773,5.23162564 C2.65860709,5.23162564 2.90889484,5.21158011 3.07203577,5.17052222 C3.29100514,5.1163155 3.47729444,5.02163098 3.62500312,4.88924025 C3.77699133,4.7529822 3.89493781,4.54356764 3.98558607,4.24900792 C4.07214932,3.96766148 4.11423138,3.59988078 4.11423138,3.12471792 C4.11423138,2.64833041 4.07176027,2.2893156 3.98441893,2.02698342 C3.89519718,1.75904364 3.76622766,1.54492386 3.60120633,1.39061839 C3.43423976,1.23450819 3.22162485,1.12789948 2.96919733,1.0736283 C2.78932733,1.03347278 2.45558871,1.01381398 1.9501501,1.01381398 L1.24902018,1.01381398 Z"
            }), Object(jsx.c)("polygon", {
                points: "6.53678989 6.06950948 6.53678989 0.175865691 10.9257088 0.175865691 10.9257088 1.17491946 7.73227054 1.17491946 7.73227054 2.48013487 10.702849 2.48013487 10.702849 3.47918864 7.73227054 3.47918864 7.73227054 5.07045571 11.0391813 5.07045571 11.0391813 6.06950948"
            }), Object(jsx.c)("path", {
                d: "M10.7636378,0.337035624 L10.7636378,1.01381398 L7.57019949,1.01381398 L7.57019949,2.64130481 L10.5407779,2.64130481 L10.5407779,3.31808317 L7.57019949,3.31808317 L7.57019949,5.23162564 L10.8771102,5.23162564 L10.8771102,5.908404 L6.69892578,5.908404 L6.69892578,0.337035624 L10.7636378,0.337035624 Z M6.37471884,0.0147602138 L6.37471884,6.23067941 L11.2013172,6.23067941 L11.2013172,4.90935023 L7.89440643,4.90935023 L7.89440643,3.64035858 L10.8649849,3.64035858 L10.8649849,2.3190294 L7.89440643,2.3190294 L7.89440643,1.33608939 L11.0878447,1.33608939 L11.0878447,0.0147602138 L6.37471884,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M15.5303032,3.73301276 L14.7130424,1.54959685 L13.9121864,3.73301276 L15.5303032,3.73301276 Z M17.7341971,6.06950948 L16.431793,6.06950948 L15.9144884,4.73206653 L13.5458326,4.73206653 L13.055113,6.06950948 L11.7849999,6.06950948 L14.0890089,0.175865691 L15.363207,0.175865691 L17.7341971,6.06950948 Z"
            }), Object(jsx.c)("path", {
                d: "M15.2534629,0.337035624 C15.3291976,0.525244463 17.332991,5.50626875 17.4947703,5.908404 L16.5431581,5.908404 C16.4751395,5.73244163 16.0257887,4.57096105 16.0257887,4.57096105 L13.4323926,4.57096105 C13.4323926,4.57096105 13.0075518,5.72876769 12.9417378,5.908404 L12.0218979,5.908404 C12.1781008,5.50884695 14.1252876,0.527951577 14.1999201,0.337035624 L15.2534629,0.337035624 Z M13.9780328,0.0147602138 L11.5481019,6.23067941 L13.168553,6.23067941 C13.168553,6.23067941 13.5933289,5.07280832 13.6592077,4.89323646 L15.8031882,4.89323646 C15.871142,5.06913438 16.3204928,6.23067941 16.3204928,6.23067941 L17.9736239,6.23067941 L15.472951,0.0147602138 L13.9780328,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M14.7145337,2.01579402 C14.8921991,2.49044124 15.1926093,3.29290701 15.2970039,3.57186861 L14.1437998,3.57186861 C14.2457305,3.2940672 14.5401752,2.49134361 14.7145337,2.01579402 L14.7145337,2.01579402 Z M13.680573,3.89414402 L15.7636025,3.89414402 L14.7114862,1.0833868 L13.680573,3.89414402 Z"
            }), Object(jsx.c)("polygon", {
                points: "18.7343171 6.06950948 18.7343171 0.224207003 19.9297978 0.224207003 19.9297978 5.07045571 22.9084814 5.07045571 22.9084814 6.06950948"
            }), Object(jsx.c)("path", {
                d: "M19.7677267,0.385376935 L19.7677267,5.23162564 L22.7464104,5.23162564 L22.7464104,5.908404 L18.8963882,5.908404 L18.8963882,0.385376935 L19.7677267,0.385376935 Z M18.5722461,0.0631015253 L18.5722461,6.23067941 L23.0706173,6.23067941 L23.0706173,4.90935023 L20.0919337,4.90935023 L20.0919337,0.0631015253 L18.5722461,0.0631015253 Z"
            })));
        }, _fundingLogos[constants.h.ELV] = ((_BUTTON_LOGO$ELV = {})[constants.i.ANY] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#005DA0" d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z"/>\n  <path fill="#005DA0" d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z"/>\n  <path fill="#005DA0" d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z"/>\n  <path fill="#005DA0" d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z"/>\n  <path fill="#005DA0" d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z"/>\n  <path fill="#005DA0" d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z"/>\n  <path fill="#005DA0" d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z"/>\n  <path fill="#005DA0" d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z"/>\n  <path fill="#005DA0" d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z"/>\n  <path fill="#005DA0" d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z"/>\n  <path fill="#005DA0" d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z"/>\n  <path fill="#005DA0" d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z"/>\n  <path fill="#005DA0" d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z"/>\n  <path fill="#005DA0" d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z"/>\n  <path fill="#005DA0" d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z"/>\n  <path fill="#AEB1BC" d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path fill="#005DA0" d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z"/>\n    <path fill="#005DA0" d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z"/>\n    <polygon fill="#005DA0" points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$ELV[constants.i.WHITE] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z" style="fill: rgb(255, 255, 255);"/>\n    <polygon points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$ELV), _fundingLogos[constants.h.BANCONTACT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BANCONTACT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " bancontact logo available");
            var _BANCONTACT_LOGO_COLO2 = BANCONTACT_LOGO_COLORS[logoColor], primary = _BANCONTACT_LOGO_COLO2.primary, secondary = _BANCONTACT_LOGO_COLO2.secondary;
            return Object(jsx.c)("svg", {
                version: "1.1",
                id: "Layer_1",
                x: "0px",
                y: "0px",
                width: "226px",
                height: "32px",
                viewBox: "36.09922790527344 36.68461608886719 226 32",
                style: "enable-background:new 0 0 476.9 123.4;",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                transform: "matrix(0.557769, 0, 0, 0.557769, 15.684875, 18.15871)"
            }, Object(jsx.c)("g", null, Object(jsx.c)("path", {
                fill: primary,
                d: "M147.6,50.2h-5.8h-26.9h-5.8l-3.9,4.4L92.5,68.9l0,0l-3.9,4.4h-6H56.2h-5.8l3.9-4.5l1.8-2.1l3.9-4.5h-5.8h-7.6 h-4.2c-3.2,0-5.8,2.7-5.8,6l0,0v11.5v1.1c0,3.3,2.6,6,5.8,6H44h61.1h4.4c3.2,0,7.6-2,9.7-4.4l10.2-11.6L147.6,50.2z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M155.3,36.8c3.2,0,5.8,2.7,5.8,6v12.6c0,3.3-2.6,6-5.8,6h-3.2h-8.5h-5.8l3.9-4.4l0,0l1.9-2.2l3.9-4.4h-38.6 L88.3,73.6H50l27.5-31.1l1-1.2c2.2-2.4,6.5-4.4,9.7-4.4h1.4h65.7V36.8z"
            })), Object(jsx.c)("path", {
                fill: primary,
                d: "M 440.7 85.6 L 440.7 81.8 C 440.7 81.3 440.4 81 439.7 81 L 437.3 81 C 436.6 81 436.1 80.9 436 80.6 C 435.8 80.3 435.8 79.7 435.8 78.7 L 435.8 64.7 L 439.7 64.7 C 440 64.7 440.2 64.6 440.4 64.4 C 440.6 64.2 440.7 64 440.7 63.7 L 440.7 59.8 C 440.7 59.5 440.6 59.3 440.4 59.1 C 440.2 58.9 440 58.8 439.7 58.8 L 435.8 58.8 L 435.8 53.8 C 435.8 53.5 435.7 53.3 435.6 53.2 C 435.4 53.1 435.2 53 435 53 L 434.9 53 L 429.1 54 C 428.8 54.1 428.6 54.2 428.4 54.3 C 428.2 54.5 428.1 54.7 428.1 54.9 L 428.1 58.8 L 424.2 58.8 C 423.9 58.8 423.7 58.9 423.5 59.1 C 423.3 59.3 423.2 59.5 423.2 59.8 L 423.2 63 C 423.2 63.3 423.3 63.5 423.5 63.6 C 423.7 63.8 423.9 63.9 424.2 64 L 428.1 64.6 L 428.1 78.6 C 428.1 80.3 428.3 81.7 428.6 82.8 C 429 83.9 429.5 84.7 430.1 85.3 C 430.8 85.9 431.6 86.3 432.6 86.5 C 433.6 86.7 434.8 86.8 436.1 86.8 C 436.8 86.8 437.4 86.8 438 86.7 C 438.5 86.6 439.2 86.5 439.9 86.4 C 440.4 86.4 440.7 86.1 440.7 85.6 M 419.9 85.1 L 419.9 80.8 C 419.9 80.5 419.8 80.3 419.6 80.2 C 419.4 80.1 419.2 80 418.9 80 L 418.8 80 C 417.9 80.1 417 80.2 416.2 80.2 C 415.4 80.3 414.3 80.3 412.9 80.3 C 412.4 80.3 411.8 80.2 411.4 80 C 410.9 79.8 410.5 79.5 410.1 79.1 C 409.7 78.7 409.5 78.1 409.3 77.4 C 409.1 76.7 409 75.8 409 74.7 L 409 70.7 C 409 69.6 409.1 68.7 409.3 68 C 409.5 67.3 409.8 66.7 410.1 66.3 C 410.5 65.9 410.9 65.6 411.4 65.4 C 411.9 65.2 412.4 65.1 412.9 65.1 C 414.3 65.1 415.4 65.1 416.2 65.2 C 417 65.3 417.9 65.3 418.8 65.4 L 418.9 65.4 C 419.2 65.4 419.4 65.3 419.6 65.2 C 419.8 65.1 419.9 64.9 419.9 64.6 L 419.9 60.3 C 419.9 59.9 419.8 59.7 419.7 59.6 C 419.5 59.5 419.3 59.3 418.9 59.2 C 418.2 59 417.3 58.9 416.3 58.7 C 415.2 58.5 414 58.5 412.5 58.5 C 409.1 58.5 406.4 59.5 404.3 61.6 C 402.3 63.7 401.2 66.7 401.2 70.7 L 401.2 74.7 C 401.2 78.6 402.2 81.7 404.3 83.8 C 406.3 85.9 409.1 86.9 412.5 86.9 C 413.9 86.9 415.2 86.8 416.3 86.7 C 417.4 86.5 418.3 86.4 418.9 86.2 C 419.3 86.1 419.5 86 419.7 85.8 C 419.8 85.7 419.9 85.4 419.9 85.1 M 388.6 80 C 388 80.3 387.4 80.5 386.7 80.7 C 386 80.9 385.3 81 384.6 81 C 383.6 81 382.8 80.9 382.3 80.6 C 381.8 80.3 381.6 79.7 381.6 78.6 L 381.6 78.2 C 381.6 77.6 381.7 77.1 381.8 76.7 C 381.9 76.3 382.2 75.9 382.5 75.6 C 382.8 75.3 383.3 75.1 383.8 74.9 C 384.3 74.8 385 74.7 385.9 74.7 L 388.6 74.7 L 388.6 80 L 388.6 80 Z M 396.2 68.3 C 396.2 66.5 395.9 65 395.4 63.8 C 394.9 62.6 394.1 61.6 393.2 60.8 C 392.2 60 391.1 59.4 389.7 59.1 C 388.3 58.7 386.7 58.5 385 58.5 C 383.4 58.5 381.8 58.6 380.3 58.8 C 378.8 59 377.6 59.2 376.7 59.5 C 376.1 59.7 375.8 60 375.8 60.6 L 375.8 64.5 C 375.8 64.8 375.9 65 376 65.2 C 376.2 65.3 376.4 65.4 376.6 65.4 L 376.8 65.4 C 377.2 65.4 377.7 65.3 378.2 65.3 C 378.8 65.3 379.4 65.2 380.2 65.2 C 380.9 65.2 381.7 65.1 382.5 65.1 C 383.3 65.1 384.1 65.1 384.8 65.1 C 385.9 65.1 386.8 65.3 387.4 65.7 C 388 66.1 388.4 67 388.4 68.4 L 388.4 70.1 L 385.8 70.1 C 381.7 70.1 378.6 70.7 376.8 72 C 375 73.3 374 75.4 374 78.2 L 374 78.6 C 374 80.2 374.2 81.5 374.7 82.5 C 375.2 83.6 375.8 84.4 376.6 85.1 C 377.4 85.7 378.2 86.2 379.2 86.5 C 380.2 86.8 381.2 86.9 382.3 86.9 C 383.7 86.9 385 86.7 386 86.3 C 387 85.9 388 85.4 389 84.7 L 389 85.5 C 389 85.8 389.1 86 389.3 86.2 C 389.5 86.4 389.7 86.5 390 86.5 L 395.4 86.5 C 395.7 86.5 395.9 86.4 396.1 86.2 C 396.3 86 396.4 85.8 396.4 85.5 L 396.4 68.3 L 396.2 68.3 Z M 370.5 85.6 L 370.5 81.8 C 370.5 81.3 370.2 81 369.5 81 L 367.1 81 C 366.4 81 365.9 80.9 365.8 80.6 C 365.6 80.3 365.6 79.7 365.6 78.7 L 365.6 64.7 L 369.5 64.7 C 369.8 64.7 370 64.6 370.2 64.4 C 370.4 64.2 370.5 64 370.5 63.7 L 370.5 59.8 C 370.5 59.5 370.4 59.3 370.2 59.1 C 370 58.9 369.8 58.8 369.5 58.8 L 365.6 58.8 L 365.6 53.8 C 365.6 53.5 365.5 53.3 365.4 53.2 C 365.2 53.1 365 53 364.8 53 L 364.7 53 L 358.9 54 C 358.6 54.1 358.4 54.2 358.2 54.3 C 358 54.5 357.9 54.7 357.9 54.9 L 357.9 58.8 L 354 58.8 C 353.7 58.8 353.5 58.9 353.3 59.1 C 353.1 59.3 353 59.5 353 59.8 L 353 63 C 353 63.3 353.1 63.5 353.3 63.6 C 353.5 63.8 353.7 63.9 354 64 L 357.9 64.6 L 357.9 78.6 C 357.9 80.3 358.1 81.7 358.4 82.8 C 358.8 83.9 359.3 84.7 359.9 85.3 C 360.6 85.9 361.4 86.3 362.4 86.5 C 363.4 86.7 364.6 86.8 365.9 86.8 C 366.6 86.8 367.2 86.8 367.8 86.7 C 368.3 86.6 369 86.5 369.7 86.4 C 370.2 86.4 370.5 86.1 370.5 85.6 M 349.5 85.5 L 349.5 69.5 C 349.5 68 349.4 66.6 349.1 65.2 C 348.9 63.9 348.4 62.7 347.8 61.7 C 347.2 60.7 346.3 59.9 345.2 59.4 C 344.1 58.8 342.7 58.5 340.9 58.5 C 339.4 58.5 338 58.7 336.8 59.1 C 335.6 59.5 334.4 60.1 333 61.1 L 333 59.8 C 333 59.5 332.9 59.3 332.7 59.1 C 332.5 58.9 332.3 58.8 332 58.8 L 326.6 58.8 C 326.3 58.8 326.1 58.9 325.9 59.1 C 325.7 59.3 325.6 59.5 325.6 59.8 L 325.6 85.4 C 325.6 85.7 325.7 85.9 325.9 86.1 C 326.1 86.3 326.3 86.4 326.6 86.4 L 332.4 86.4 C 332.7 86.4 332.9 86.3 333.1 86.1 C 333.3 85.9 333.4 85.7 333.4 85.4 L 333.4 66.5 C 334.2 66.1 335 65.7 335.8 65.4 C 336.5 65.1 337.3 65 338 65 C 338.7 65 339.3 65.1 339.8 65.2 C 340.3 65.3 340.6 65.6 340.9 65.9 C 341.2 66.3 341.3 66.7 341.4 67.3 C 341.5 67.9 341.5 68.6 341.5 69.4 L 341.5 85.4 C 341.5 85.7 341.6 85.9 341.8 86.1 C 342 86.3 342.2 86.4 342.5 86.4 L 348.3 86.4 C 348.6 86.4 348.8 86.3 349 86.1 C 349.4 85.9 349.5 85.7 349.5 85.5 M 313.1 74.4 C 313.1 78.3 311.7 80.3 308.8 80.3 C 307.4 80.3 306.3 79.8 305.6 78.8 C 304.9 77.8 304.5 76.3 304.5 74.4 L 304.5 71 C 304.5 69 304.9 67.6 305.6 66.6 C 306.3 65.6 307.4 65.1 308.8 65.1 C 311.6 65.1 313.1 67.1 313.1 71 L 313.1 74.4 Z M 320.9 71 C 320.9 69.1 320.6 67.3 320.1 65.8 C 319.6 64.3 318.8 63 317.8 61.9 C 316.8 60.8 315.5 60 314 59.4 C 312.5 58.8 310.8 58.5 308.8 58.5 C 306.8 58.5 305.1 58.8 303.6 59.4 C 302.1 60 300.8 60.8 299.8 61.9 C 298.8 63 298 64.3 297.5 65.8 C 297 67.3 296.7 69.1 296.7 71 L 296.7 74.4 C 296.7 76.3 297 78.1 297.5 79.6 C 298 81.1 298.8 82.4 299.8 83.5 C 300.8 84.6 302.1 85.4 303.6 86 C 305.1 86.6 306.8 86.9 308.8 86.9 C 310.8 86.9 312.5 86.6 314 86 C 315.5 85.4 316.8 84.6 317.8 83.5 C 318.8 82.4 319.6 81.1 320.1 79.6 C 320.6 78.1 320.9 76.3 320.9 74.4 L 320.9 71 Z M 294.1 85.1 L 294.1 80.8 C 294.1 80.5 294 80.3 293.8 80.2 C 293.6 80.1 293.4 80 293.1 80 L 293 80 C 292.1 80.1 291.2 80.2 290.4 80.2 C 289.6 80.2 288.5 80.3 287.1 80.3 C 286.6 80.3 286 80.2 285.6 80 C 285.1 79.8 284.7 79.5 284.3 79.1 C 283.9 78.7 283.7 78.1 283.5 77.4 C 283.3 76.7 283.2 75.8 283.2 74.7 L 283.2 70.7 C 283.2 69.6 283.3 68.7 283.5 68 C 283.7 67.3 284 66.7 284.3 66.3 C 284.7 65.9 285.1 65.6 285.6 65.4 C 286.1 65.2 286.6 65.1 287.1 65.1 C 288.5 65.1 289.6 65.1 290.4 65.2 C 291.2 65.3 292.1 65.3 293 65.4 L 293.1 65.4 C 293.4 65.4 293.6 65.3 293.8 65.2 C 294 65.1 294.1 64.9 294.1 64.6 L 294.1 60.3 C 294.1 59.9 294 59.7 293.9 59.6 C 293.7 59.5 293.5 59.3 293.1 59.2 C 292.4 59 291.6 58.9 290.5 58.7 C 289.4 58.5 288.2 58.5 286.7 58.5 C 283.3 58.5 280.6 59.5 278.5 61.6 C 276.5 63.7 275.4 66.7 275.4 70.7 L 275.4 74.7 C 275.4 78.6 276.4 81.7 278.5 83.8 C 280.5 85.9 283.3 86.9 286.7 86.9 C 288.1 86.9 289.4 86.8 290.5 86.7 C 291.6 86.5 292.4 86.4 293.1 86.2 C 293.5 86.1 293.7 86 293.9 85.8 C 294 85.7 294.1 85.4 294.1 85.1 M 270.4 85.5 L 270.4 69.5 C 270.4 68 270.3 66.6 270 65.2 C 269.7 63.8 269.3 62.7 268.7 61.7 C 268.1 60.7 267.2 59.9 266.1 59.4 C 265 58.8 263.6 58.5 261.8 58.5 C 260.3 58.5 258.9 58.7 257.7 59.1 C 256.5 59.5 255.3 60.1 253.9 61.1 L 253.9 59.8 C 253.9 59.5 253.8 59.3 253.6 59.1 C 253.4 58.9 253.2 58.8 252.9 58.8 L 247.5 58.8 C 247.2 58.8 247 58.9 246.8 59.1 C 246.6 59.3 246.5 59.5 246.5 59.8 L 246.5 85.4 C 246.5 85.7 246.6 85.9 246.8 86.1 C 247 86.3 247.2 86.4 247.5 86.4 L 253.3 86.4 C 253.6 86.4 253.8 86.3 254 86.1 C 254.2 85.9 254.3 85.7 254.3 85.4 L 254.3 66.5 C 255.1 66.1 255.9 65.7 256.7 65.4 C 257.4 65.1 258.2 65 258.9 65 C 259.6 65 260.2 65.1 260.7 65.2 C 261.2 65.3 261.5 65.6 261.8 65.9 C 262.1 66.3 262.2 66.7 262.3 67.3 C 262.4 67.9 262.4 68.6 262.4 69.4 L 262.4 85.4 C 262.4 85.7 262.5 85.9 262.7 86.1 C 262.9 86.3 263.1 86.4 263.4 86.4 L 269.2 86.4 C 269.5 86.4 269.7 86.3 269.9 86.1 C 270.3 85.9 270.4 85.7 270.4 85.5 M 233.3 80 C 232.7 80.3 232.1 80.5 231.4 80.7 C 230.7 80.9 230 81 229.3 81 C 228.3 81 227.5 80.9 227 80.6 C 226.5 80.3 226.3 79.7 226.3 78.6 L 226.3 78.2 C 226.3 77.6 226.4 77.1 226.5 76.7 C 226.6 76.3 226.9 75.9 227.2 75.6 C 227.5 75.3 228 75.1 228.5 74.9 C 229 74.8 229.7 74.7 230.6 74.7 L 233.3 74.7 L 233.3 80 L 233.3 80 Z M 241 68.3 C 241 66.5 240.7 65 240.2 63.8 C 239.7 62.6 238.9 61.6 238 60.8 C 237 60 235.9 59.4 234.5 59.1 C 233.1 58.7 231.5 58.5 229.8 58.5 C 228.2 58.5 226.6 58.6 225.1 58.8 C 223.6 59 222.4 59.2 221.5 59.5 C 220.9 59.7 220.6 60 220.6 60.6 L 220.6 64.5 C 220.6 64.8 220.7 65 220.8 65.2 C 221 65.3 221.2 65.4 221.4 65.4 L 221.6 65.4 C 222 65.4 222.5 65.3 223 65.3 C 223.6 65.3 224.2 65.2 225 65.2 C 225.7 65.2 226.5 65.1 227.3 65.1 C 228.1 65.1 228.9 65.1 229.6 65.1 C 230.7 65.1 231.6 65.3 232.2 65.7 C 232.8 66.1 233.2 67 233.2 68.4 L 233.2 70.1 L 230.6 70.1 C 226.5 70.1 223.4 70.7 221.6 72 C 219.8 73.3 218.8 75.4 218.8 78.2 L 218.8 78.6 C 218.8 80.2 219 81.5 219.5 82.5 C 220 83.6 220.6 84.4 221.4 85.1 C 222.2 85.7 223 86.2 224 86.5 C 225 86.8 226 86.9 227.1 86.9 C 228.5 86.9 229.8 86.7 230.8 86.3 C 231.8 85.9 232.8 85.4 233.8 84.7 L 233.8 85.5 C 233.8 85.8 233.9 86 234.1 86.2 C 234.3 86.4 234.5 86.5 234.8 86.5 L 240.2 86.5 C 240.5 86.5 240.7 86.4 240.9 86.2 C 241.1 86 241.2 85.8 241.2 85.5 L 241.2 68.3 L 241 68.3 Z M 206.6 75.9 C 206.6 77.2 206.1 78.3 205.2 79 C 204.3 79.7 202.5 80.1 200.1 80.1 L 199.3 80.1 C 198.9 80.1 198.5 80.1 198.1 80.1 C 197.7 80.1 197.3 80.1 196.9 80.1 L 196.1 80.1 L 196.1 71.1 L 201.5 71.1 C 203.4 71.1 204.8 71.5 205.5 72.4 C 206.2 73.3 206.6 74.3 206.6 75.4 L 206.6 75.9 Z M 206.4 61.6 C 206.4 62.1 206.3 62.6 206.2 63.1 C 206 63.6 205.8 64 205.4 64.3 C 205 64.6 204.5 64.9 203.9 65.1 C 203.3 65.3 202.5 65.4 201.5 65.4 L 196.1 65.4 L 196.1 57.1 C 196.3 57.1 196.5 57.1 196.8 57.1 C 197.1 57.1 197.5 57.1 197.9 57.1 L 199 57.1 L 199.8 57.1 C 202.3 57.1 204 57.4 205 58 C 206 58.6 206.5 59.6 206.5 60.9 L 206.5 61.6 L 206.4 61.6 Z M 214.6 75.4 C 214.6 73.7 214.2 72.3 213.4 71.1 C 212.6 69.9 211.6 68.9 210.3 68.3 C 211.6 67.7 212.6 66.7 213.3 65.5 C 214 64.2 214.4 62.8 214.4 61.3 L 214.4 60.4 C 214.4 58.5 214 56.9 213.3 55.6 C 212.6 54.3 211.5 53.3 210.2 52.5 C 208.9 51.7 207.3 51.2 205.4 50.8 C 203.5 50.5 201.5 50.3 199.2 50.3 C 198.4 50.3 197.6 50.3 196.8 50.3 C 196 50.3 195.2 50.4 194.4 50.4 C 193.6 50.4 192.9 50.5 192.2 50.6 C 191.5 50.7 191 50.7 190.6 50.8 C 189.7 51 189 51.3 188.6 51.7 C 188.2 52.1 188 52.9 188 54 L 188 83.3 C 188 84.4 188.2 85.1 188.6 85.6 C 189 86 189.7 86.3 190.6 86.5 C 191.1 86.6 191.7 86.7 192.3 86.7 C 193 86.8 193.7 86.8 194.5 86.9 C 195.3 86.9 196.1 87 196.9 87 C 197.7 87 198.6 87 199.4 87 C 201.5 87 203.5 86.8 205.3 86.5 C 207.1 86.2 208.7 85.6 210.1 84.8 C 211.5 84 212.5 82.9 213.4 81.5 C 214.2 80.1 214.6 78.3 214.6 76.2 L 214.6 75.4 L 214.6 75.4 Z"
            })));
        }, _fundingLogos[constants.h.GIROPAY] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!GIROPAY_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " giropay logo available");
            var _GIROPAY_LOGO_COLORS$ = GIROPAY_LOGO_COLORS[logoColor], primary = _GIROPAY_LOGO_COLORS$.primary, secondary = _GIROPAY_LOGO_COLORS$.secondary, tertiary = _GIROPAY_LOGO_COLORS$.tertiary;
            return Object(jsx.c)("svg", {
                width: "75px",
                height: "32px",
                viewBox: "0 0 75 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.614571, 0, 0, 1.614571, -161.457123, -256.816772)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(0.000000, 0.144715)"
            }, Object(jsx.c)("mask", {
                fill: primary
            }, Object(jsx.c)("polygon", {
                points: "0 0.017902439 46.0918699 0.017902439 46.0918699 19.8373984 0 19.8373984",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M0,3.5735122 C0,1.60977236 1.5998374,0.017902439 3.57349593,0.017902439 L42.5182114,0.017902439 C44.4918699,0.017902439 46.0918699,1.60977236 46.0918699,3.5735122 L46.0918699,16.2818049 C46.0918699,18.2455447 44.4918699,19.8374146 42.5182114,19.8374146 L3.57349593,19.8374146 C1.5998374,19.8374146 0,18.2455447 0,16.2818049 L0,3.5735122 Z",
                fill: secondary
            })), Object(jsx.c)("path", {
                d: "M1.46738211,3.84021138 L1.46738211,16.3065528 C1.46738211,17.5338699 2.46738211,18.5288293 3.70087805,18.5288293 L24.1036423,18.5288293 L24.1036423,1.61793496 L3.70087805,1.61793496 C2.46738211,1.61793496 1.46738211,2.61289431 1.46738211,3.84021138",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M5.67102439,10.0205528 C5.67102439,9.34152846 6.00582114,8.77730081 6.64663415,8.77730081 C7.42126829,8.77730081 7.74630894,9.39892683 7.74630894,9.95356098 C7.74630894,10.7187642 7.25866667,11.235187 6.64663415,11.235187 C6.13004878,11.235187 5.67102439,10.795187 5.67102439,10.0205528 Z M9.41053659,7.57226016 L7.8515122,7.57226016 L7.8515122,8.47112195 L7.8324878,8.47112195 C7.46907317,7.85908943 6.87606504,7.45746341 6.13964228,7.45746341 C4.59021138,7.45746341 3.8921626,8.56689431 3.8921626,10.0491707 C3.8921626,11.5221789 4.74321951,12.5550244 6.11102439,12.5550244 C6.79964228,12.5550244 7.37346341,12.2872195 7.78468293,11.7038049 L7.80370732,11.7038049 L7.80370732,11.9716098 C7.80370732,12.9472195 7.26826016,13.4158374 6.27362602,13.4158374 C5.55622764,13.4158374 5.11622764,13.2628293 4.59021138,13.0046179 L4.50419512,14.3626667 C4.90582114,14.5060813 5.58500813,14.6782764 6.40744715,14.6782764 C8.41590244,14.6782764 9.41053659,14.0182764 9.41053659,11.9716098 L9.41053659,7.57226016 Z",
                fill: tertiary
            }), Object(jsx.c)("mask", {
                fill: primary
            }, Object(jsx.c)("polygon", {
                points: "0 19.9821138 46.0918699 19.9821138 46.0918699 0.162601626 0 0.162601626",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M10.5985366,6.75918699 L12.32,6.75918699 L12.32,5.49674797 L10.5985366,5.49674797 L10.5985366,6.75918699 Z M10.598374,12.5549593 L12.3198374,12.5549593 L12.3198374,7.57219512 L10.598374,7.57219512 L10.598374,12.5549593 Z",
                id: "Fill-8",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M17.1133333,7.51479675 C16.9411382,7.48617886 16.7307317,7.45739837 16.5299187,7.45739837 C15.7839024,7.45739837 15.3534959,7.85918699 15.0570732,8.4904065 L15.0380488,8.4904065 L15.0380488,7.57219512 L13.4694309,7.57219512 L13.4694309,12.5549593 L15.1910569,12.5549593 L15.1910569,10.4508943 C15.1910569,9.47544715 15.6404878,8.89203252 16.4439024,8.89203252 C16.6447154,8.89203252 16.835935,8.89203252 17.0273171,8.94943089 L17.1133333,7.51479675 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M20.0773496,11.4647154 C19.2835285,11.4647154 18.9583252,10.804878 18.9583252,10.0682927 C18.9583252,9.32243902 19.2835285,8.66243902 20.0773496,8.66243902 C20.8711707,8.66243902 21.196374,9.32243902 21.196374,10.0682927 C21.196374,10.804878 20.8711707,11.4647154 20.0773496,11.4647154 M20.0773496,12.6697561 C21.7223902,12.6697561 22.9752358,11.7133333 22.9752358,10.0682927 C22.9752358,8.41382114 21.7223902,7.45739837 20.0773496,7.45739837 C18.4323089,7.45739837 17.1794634,8.41382114 17.1794634,10.0682927 C17.1794634,11.7133333 18.4323089,12.6697561 20.0773496,12.6697561",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M29.3757073,10.0110244 C29.3757073,10.8048455 28.9836748,11.3500488 28.3332683,11.3500488 C27.7594472,11.3500488 27.2812358,10.8048455 27.2812358,10.0780163 C27.2812358,9.332 27.7020488,8.77720325 28.3332683,8.77720325 C29.0026992,8.77720325 29.3757073,9.35102439 29.3757073,10.0110244 Z M25.5597724,14.5633821 L27.2812358,14.5633821 L27.2812358,11.856878 L27.3002602,11.856878 C27.6254634,12.4498862 28.2758699,12.6697236 28.8783089,12.6697236 C30.360748,12.6697236 31.1545691,11.4456585 31.1545691,9.97265041 C31.1545691,8.76777236 30.399122,7.45736585 29.0218862,7.45736585 C28.2376585,7.45736585 27.5106667,7.77297561 27.166439,8.47118699 L27.147252,8.47118699 L27.147252,7.5721626 L25.5597724,7.5721626 L25.5597724,14.5633821 Z",
                id: "Fill-12",
                fill: primary,
                mask: "url(#mask-4)"
            }), Object(jsx.c)("path", {
                d: "M33.505252,10.9769919 C33.505252,10.4987805 33.9642764,10.3169919 34.5476911,10.3169919 C34.8059024,10.3169919 35.0546829,10.3361789 35.2745203,10.3457724 C35.2745203,10.929187 34.8633008,11.5221951 34.2128943,11.5221951 C33.8112683,11.5221951 33.505252,11.3212195 33.505252,10.9769919 Z M36.9769593,12.5550407 C36.900374,12.1628455 36.8813496,11.770813 36.8813496,11.3786179 L36.8813496,9.52317073 C36.8813496,8.00252033 35.7815122,7.45747967 34.5094797,7.45747967 C33.7730569,7.45747967 33.1322439,7.56268293 32.5202114,7.81130081 L32.5488293,8.97813008 C33.0270407,8.7103252 33.5816748,8.60512195 34.1364715,8.60512195 C34.7580976,8.60512195 35.2650894,8.78674797 35.2745203,9.46577236 C35.0546829,9.42756098 34.7485041,9.39894309 34.4711057,9.39894309 C33.5530569,9.39894309 31.8984228,9.58056911 31.8984228,11.1013821 C31.8984228,12.1820325 32.7784228,12.6698374 33.7634634,12.6698374 C34.4711057,12.6698374 34.9493171,12.392439 35.3415122,11.770813 L35.3606992,11.770813 C35.3606992,12.0290244 35.3893171,12.2872358 35.3989106,12.5550407 L36.9769593,12.5550407 Z",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.750748,14.5634634 C38.1045691,14.6398862 38.4583902,14.6782602 38.8218049,14.6782602 C40.3998537,14.6782602 40.7728618,13.463626 41.2606667,12.2107805 L43.0873333,7.5722439 L41.3658699,7.5722439 L40.3426179,10.8239512 L40.3234309,10.8239512 L39.2522114,7.5722439 L37.3967642,7.5722439 L39.414813,12.6698049 C39.2904228,13.1098049 38.9653821,13.3584228 38.5445691,13.3584228 C38.3053821,13.3584228 38.0949756,13.3296423 37.8655447,13.2532195 L37.750748,14.5634634 Z",
                fill: primary
            }))));
        }, _fundingLogos[constants.h.SOFORT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!SOFORT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " sofort logo available");
            var _SOFORT_LOGO_COLORS$l = SOFORT_LOGO_COLORS[logoColor], primary = _SOFORT_LOGO_COLORS$l.primary, secondary = _SOFORT_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "138px",
                height: "32px",
                viewBox: "0 0 138 44",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                transform: "translate(-24.000000, -436.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(24.000000, 436.000000)"
            }, Object(jsx.c)("g", {
                "stroke-width": "1"
            }, Object(jsx.c)("g", {
                mask: "url(#mask-2)",
                "fill-rule": "evenodd",
                fill: primary
            }, Object(jsx.c)("rect", {
                x: "0",
                y: "0",
                width: "138",
                height: "44"
            })), Object(jsx.c)("g", {
                transform: "translate(16.000000, 5.000000)",
                "fill-rule": "nonzero",
                fill: secondary
            }, Object(jsx.c)("path", {
                d: "M8.55107133,24.0386247 C9.22879411,24.6861671 9.24327745,25.7425763 8.58354713,26.4073957 L8.45110904,26.5423627 C7.79086355,27.1983175 6.69897696,27.2144066 6.01224032,26.5722566 L2.17289107,22.8768054 C1.11590922,21.8458618 0.96410333,20.5754632 1.63678914,19.9042365 L1.77159366,19.7668966 C2.32598975,19.2126062 3.22970309,19.1541252 3.86016464,19.6360673 C4.15990129,19.8651943 4.59424066,19.8150784 4.83028878,19.5241303 C5.0663369,19.2331822 5.01470714,18.8115781 4.7149705,18.5824512 C3.5284497,17.675442 1.82767241,17.7855026 0.775688111,18.8373698 L0.64137931,18.9742146 C-0.604692328,20.2175294 -0.354282964,22.3130983 1.19683948,23.8259789 L5.04656839,27.5313427 C6.28726435,28.6915831 8.24857838,28.6626828 9.44549924,27.4733999 L9.58132339,27.3350447 C10.7636633,26.1435999 10.7376475,24.2460125 9.52028002,23.0828568 C9.24837962,22.8230647 8.81099605,22.8264175 8.54335646,23.0903455 C8.27571687,23.3542735 8.27917094,23.7788325 8.55107133,24.0386247 Z"
            }), Object(jsx.c)("path", {
                d: "M6.25316137,4.00463901 L7.82450265,16.5582851 C7.87051944,16.9259191 8.21485204,17.1877352 8.59359104,17.1430676 C8.97233003,17.0984001 9.24205468,16.7641637 9.19603789,16.3965297 L7.61982167,3.8039371 L7.60423898,3.7221812 C7.33535457,2.67817937 8.00377183,1.50751858 8.89431251,1.32322405 C9.39350944,1.21977105 9.9143927,1.3151232 10.3403167,1.58785163 C10.7662406,1.86058007 11.0615522,2.28785533 11.1600097,2.7738347 L13.8959914,14.1304918 C13.9828807,14.4910975 14.3544774,14.7150537 14.7259757,14.6307121 C15.097474,14.5463704 15.3281952,14.1856693 15.2413059,13.8250637 L12.5104951,2.49173037 C12.3457557,1.67638792 11.8361294,0.939028727 11.1011021,0.468374716 C10.3660749,-0.00227929421 9.46717414,-0.16683078 8.60603358,0.0116310396 C6.93120471,0.358231477 5.83076908,2.26447015 6.25316137,4.00463901 Z"
            }), Object(jsx.c)("path", {
                d: "M20.6946385,18.7562157 L23.8016655,3.70806757 C24.1627527,2.08823591 23.171098,0.461930237 21.5243733,-0.0131380565 C19.6806639,-0.465927398 17.8331452,0.588982967 17.3518411,2.34622562 L13.9119445,13.7963592 C13.8051409,14.1518899 14.01548,14.5241472 14.3817501,14.6278193 C14.7480201,14.7314913 15.1315221,14.5273196 15.2383257,14.1717889 L18.6826501,2.70623335 C18.9740354,1.64312835 20.0755418,1.01418179 21.1583367,1.27975309 C22.0849843,1.54768368 22.6596154,2.49007404 22.4491321,3.43451398 L19.3399561,18.4926732 C19.2649826,18.8557898 19.5074605,19.20915 19.8815457,19.2819253 C20.2556309,19.3547006 20.6196649,19.1193324 20.6946385,18.7562157 Z"
            }), Object(jsx.c)("path", {
                d: "M12.8691892,33.2538889 C7.94394615,33.2538889 3.83027027,29.7443025 3.83027027,24.757037 C3.83027027,24.3866994 3.52098374,24.0864815 3.13945946,24.0864815 C2.75793518,24.0864815 2.44864865,24.3866994 2.44864865,24.757037 C2.44864865,30.5262551 7.21772847,34.595 12.8691892,34.595 C13.2507135,34.595 13.56,34.2947821 13.56,33.9244444 C13.56,33.5541068 13.2507135,33.2538889 12.8691892,33.2538889 Z"
            }), Object(jsx.c)("path", {
                d: "M10.432735,21.523985 C10.32527,21.8997898 10.0848456,22.2268322 9.75367873,22.4476857 L9.6059963,22.5431752 C8.81135162,23.0620226 7.73737824,22.860771 7.20041193,22.0943828 L4.18000129,17.7280455 C3.35596459,16.5133712 3.46371228,15.2353866 4.25688098,14.7069262 L4.40481451,14.6112693 C5.42222949,14.0388226 6.28666557,14.4731364 7.17531296,15.7298428 L9.70102318,19.3822431 C9.91366027,19.6897297 10.3428334,19.7716746 10.6596081,19.5652723 C10.9763829,19.3588699 11.0608031,18.9422806 10.848166,18.634794 L8.31843628,14.9766458 C7.06906995,13.2097547 5.52101546,12.4319743 3.67452351,13.4735669 L3.48275305,13.5961381 C1.99799965,14.5853027 1.82065576,16.6887608 3.02954142,18.4706511 L6.05567438,22.8452879 C7.02249844,24.2252138 8.95163568,24.5867144 10.3747579,23.6575027 L10.5280578,23.5583063 C11.1349164,23.1536749 11.5696876,22.5622681 11.7640218,21.8826817 C11.8660652,21.5258361 11.650769,21.1562586 11.2831443,21.0572072 C10.9155196,20.9581559 10.5347784,21.1671394 10.432735,21.523985 Z"
            }), Object(jsx.c)("path", {
                d: "M15.0071132,23.7451482 C13.5716937,24.5235597 12.6792061,25.9892512 12.5683793,28.2063913 C12.5498892,28.5762937 12.8438232,28.8907086 13.2248991,28.9086565 C13.6059751,28.9266044 13.9298874,28.6412889 13.9483774,28.2713865 C14.048744,26.2635083 14.8525076,25.179561 16.152515,24.704555 C16.8482268,24.4503509 17.6046979,24.3996276 18.2711038,24.4684707 C18.3606758,24.477724 18.4201821,24.4863334 18.4442402,24.4906858 C19.3337661,24.6516105 19.6045203,23.3685934 18.7214531,23.1770635 L13.4090206,22.0248413 C10.9225036,21.3638621 10.5472361,20.4704561 11.0076227,18.9808309 C11.2064187,18.3317669 11.6147718,17.9986147 12.2306776,17.865687 C12.6373189,17.7779238 13.0941226,17.7888366 13.5282841,17.8626882 C13.6538003,17.8840387 13.7420731,17.9043308 13.7811352,17.9152244 L21.8451208,19.7433694 C21.8985237,19.7533496 21.9361525,19.763479 22.0020154,19.7924494 C22.1354002,19.8511201 22.2742678,19.9453829 22.4097247,20.0858789 C22.9502905,20.6465543 23.2485509,21.7041959 23.09758,23.4414127 C22.571614,29.5314735 19.6483005,33.3130406 12.7195863,33.2539148 C12.3380768,33.2506592 12.0260833,33.5482264 12.0227294,33.9185497 C12.0193755,34.288873 12.3259312,34.5917185 12.7074407,34.5949741 C20.4944029,34.6614237 23.8949457,30.262518 24.474342,23.5537955 C24.6558214,21.4655214 24.2521788,20.0341915 23.4184922,19.1694909 C22.9588119,18.69271 22.4737204,18.4793376 22.1015974,18.4267977 L14.1289333,16.6177417 C14.0788208,16.6028791 13.9434651,16.5717637 13.7667652,16.5417067 C13.169132,16.4400483 12.5401983,16.4250234 11.9308051,16.5565455 C10.8493625,16.7899475 10.0333579,17.4556796 9.68377867,18.5970598 C9.0191343,20.7475737 9.72889785,22.4373206 13.0761134,23.3260543 L15.0071132,23.7451482 Z"
            }))), Object(jsx.c)("path", {
                d: "M60.72,30.286 C63.712,30.286 66,28.284 66,25.336 C66,22.608 64.064,21.42 61.688,20.716 C60.17,20.276 59.224,19.946 59.224,18.868 C59.224,17.966 59.884,17.262 60.918,17.262 C61.798,17.262 62.458,17.768 62.92,18.538 L65.406,16.976 C64.636,15.26 62.898,14.38 61.006,14.38 C58.014,14.38 56.122,16.536 56.122,19.022 C56.122,21.002 57.31,22.542 60.258,23.4 C61.864,23.862 62.876,24.17 62.876,25.446 C62.876,26.634 62.018,27.382 60.764,27.382 C59.422,27.382 58.41,26.524 57.794,25.732 L55.726,27.822 C56.826,29.318 58.63,30.286 60.72,30.286 Z M73.546,30.286 C70.378,30.286 67.804,27.756 67.804,24.676 C67.804,21.596 70.378,19.066 73.546,19.066 C76.714,19.066 79.288,21.596 79.288,24.676 C79.288,27.756 76.714,30.286 73.546,30.286 Z M73.546,27.47 C75.086,27.47 76.296,26.26 76.296,24.676 C76.296,23.092 75.086,21.882 73.546,21.882 C72.006,21.882 70.796,23.092 70.796,24.676 C70.796,26.26 72.006,27.47 73.546,27.47 Z M87.428,17.416 L87.428,14.6 L86.988,14.6 C83.336,14.6 81.554,17.02 81.554,19.88 L81.554,30 L84.546,30 L84.546,25.556 C84.546,24.082 85.69,23.026 87.34,22.982 L87.34,20.122 C86.152,20.122 85.206,20.474 84.546,21.178 L84.546,20.034 C84.546,18.186 85.756,17.35 87.428,17.416 Z M95.018,30.286 C91.85,30.286 89.276,27.756 89.276,24.676 C89.276,21.596 91.85,19.066 95.018,19.066 C98.186,19.066 100.76,21.596 100.76,24.676 C100.76,27.756 98.186,30.286 95.018,30.286 Z M95.018,27.47 C96.558,27.47 97.768,26.26 97.768,24.676 C97.768,23.092 96.558,21.882 95.018,21.882 C93.478,21.882 92.268,23.092 92.268,24.676 C92.268,26.26 93.478,27.47 95.018,27.47 Z M106.018,20.562 L106.018,19.352 L103.114,19.352 L103.114,30 L106.106,30 L106.106,25.138 C106.106,23.378 107.14,22.388 108.944,22.388 L108.944,19.176 C107.58,19.132 106.612,19.594 106.018,20.562 Z M114.378,24.566 L114.378,21.97 C115.038,22.674 115.984,23.026 117.172,23.026 L117.172,20.166 C115.544,20.122 114.378,19.044 114.378,17.592 L114.378,15.92 L111.386,15.92 L111.386,24.72 C111.386,27.58 113.168,30 116.82,30 L117.26,30 L117.26,27.184 C115.588,27.25 114.378,26.414 114.378,24.566 Z M121.572,30.176 C122.672,30.176 123.574,29.274 123.574,28.174 C123.574,27.074 122.672,26.172 121.572,26.172 C120.472,26.172 119.57,27.074 119.57,28.174 C119.57,29.274 120.472,30.176 121.572,30.176 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.EPS] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!EPS_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " eps logo available");
            var _EPS_LOGO_COLORS$logo = EPS_LOGO_COLORS[logoColor], primary = _EPS_LOGO_COLORS$logo.primary, secondary = _EPS_LOGO_COLORS$logo.secondary, tertiary = _EPS_LOGO_COLORS$logo.tertiary;
            return Object(jsx.c)("svg", {
                width: "52px",
                height: "32px",
                viewBox: "0 0 52 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333759, 0, 0, 1.333759, 0.000008, -0.000005)"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M30.5812744,12.0000152 L27.4748661,12.0000152 C27.129394,12.0000152 26.8482796,11.7245987 26.8482796,11.3798207 C26.8482796,11.0350427 27.129394,10.7315163 27.4748661,10.7315163 L32.2041612,10.7315163 L32.2041612,8.39747822 L27.4748661,8.39747822 C25.824238,8.39747822 24.4812484,9.74381226 24.4812484,11.3911357 C24.4812484,13.0384592 25.824238,14.3847932 27.4748661,14.3847932 L30.5390793,14.3847932 C30.8846021,14.3847932 31.1657165,14.6590934 31.1657165,15.0038715 C31.1657165,15.3486495 30.8846021,15.6025522 30.5390793,15.6025522 L23.9683147,15.6025522 C23.4104473,16.6680913 22.8679974,17.5814106 21.7668179,18.0380702 L30.5812744,18.0380702 C32.2041612,18.0146791 33.5316827,16.6405903 33.5316827,15.0078292 C33.5316827,13.3751696 32.2041612,12.0234063 30.5812744,12.0000152",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M18.6731848,15.6025522 L16.2795788,15.6025522 L16.2795788,13.1992034 C16.2795788,11.8562182 17.3483005,10.7635839 18.6731848,10.7635839 C19.9980691,10.7635839 21.0759195,11.8562182 21.0759195,13.1992034 C21.0759195,14.5422393 19.9980691,15.6025522 18.6731848,15.6025522 M18.6731848,8.39747822 C16.0403551,8.39747822 13.8959637,10.5557023 13.8959637,13.2076262 L13.8959637,13.3091061 L13.8959637,23.2135459 L16.2795788,23.2135459 L16.2795788,18.0380702 L18.6682147,18.0380702 C21.3010951,18.0380702 23.4379299,15.8511273 23.4379299,13.1992034 C23.4379299,10.5472795 21.3060651,8.39747822 18.6731848,8.39747822",
                fill: primary
            }), Object(jsx.c)("g", {
                transform: "translate(0.000000, 6.842233)"
            }, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "0 0.0330469345 12.6787834 0.0330469345 12.6787834 12.7180364 0 12.7180364",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M6.34967672,11.1958376 C4.09589259,11.1958376 2.20112146,9.58905539 1.68833992,7.48994334 C1.68833992,7.48994334 1.54020078,6.7959222 1.54020078,6.3389074 C1.54020078,5.8818926 1.68042835,5.18071712 1.68042835,5.18071712 C2.19686138,3.08678055 4.08935033,1.52754165 6.33943225,1.52754165 C8.98580286,1.52754165 11.1573269,3.67982918 11.1573269,6.32744017 L11.1573269,7.49182072 L4.12642315,7.49182072 C4.54162861,8.30366004 5.38137113,8.76031966 6.34967672,8.76031966 L12.6701111,8.76031966 L12.6787834,1.89423932 C12.6787834,0.870560677 11.8417287,0.0330469345 10.8185493,0.0330469345 L1.86031521,0.0330469345 C0.837135761,0.0330469345 -2.02860858e-05,0.845190698 -2.02860858e-05,1.86886934 L-2.02860858e-05,10.831474 C-2.02860858e-05,11.8551526 0.837135761,12.7180364 1.86031521,12.7180364 L10.8185493,12.7180364 C11.7367482,12.7180364 12.5027001,12.0584169 12.6506871,11.1958376 L6.34967672,11.1958376 Z",
                fill: tertiary
            })), Object(jsx.c)("path", {
                d: "M6.33943732,10.6481099 C5.37483394,10.6481099 4.53595358,11.238926 4.11907451,12.0000254 L8.55990156,12.0000254 C8.1430225,11.238926 7.30419285,10.6481099 6.33943732,10.6481099",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M10.396619,3.96072558 C10.396619,1.77327526 8.57959428,1.52219873e-05 6.33823537,1.52219873e-05 C4.134,1.52219873e-05 2.34126788,1.71527949 2.28238752,3.85259873 C2.28142393,3.86163044 2.28218466,3.87040846 2.28218466,3.87969387 L2.28218466,5.0699518 C2.28218466,5.21232812 2.39806892,5.35308076 2.54392588,5.35308076 L4.03703251,5.35308076 C4.18288947,5.35308076 4.31079324,5.21232812 4.31079324,5.0699518 L4.31079324,3.96072558 C4.31079324,2.86839577 5.22011704,1.97968541 6.33940182,1.97968541 C7.45868661,1.97968541 8.3680104,2.86839577 8.3680104,3.96072558 L8.3680104,5.0699518 C8.3680104,5.21232812 8.486329,5.35308076 8.63218596,5.35308076 L10.1253433,5.35308076 C10.2712003,5.35308076 10.396619,5.21232812 10.396619,5.0699518 L10.396619,3.96072558 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M20.7598572,20.7474063 C20.7598572,20.8523366 20.8407987,20.9002858 20.9277753,20.9002858 C21.0206856,20.9002858 21.1436192,20.8253429 21.1436192,20.687381 C21.1436192,20.5884888 21.0716036,20.5345015 20.9907129,20.5345015 C20.8827909,20.5345015 20.7598572,20.6034063 20.7598572,20.7474063 Z M20.0403098,20.7504 C20.0403098,20.8523366 20.1183098,20.9002858 20.2022434,20.9002858 C20.3071732,20.9002858 20.4211303,20.8253429 20.4211303,20.6843873 C20.4211303,20.5854444 20.3550991,20.5345015 20.2681732,20.5345015 C20.160302,20.5345015 20.0403098,20.6034063 20.0403098,20.7504 Z M21.3474437,21.133233 L21.1315997,22.3559645 C21.0236778,22.9739772 20.6189196,23.2570047 20.0702824,23.2570047 C19.6056296,23.2570047 19.2458559,22.9539856 19.3508364,22.3569793 L19.5666296,21.133233 L19.8994736,21.133233 L19.6835282,22.3559645 C19.6175984,22.7370723 19.7885087,22.9540364 20.1122746,22.9540364 C20.4450679,22.9540364 20.7298845,22.7559983 20.7988065,22.3569793 L21.0146505,21.133233 L21.3474437,21.133233 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M21.9179189,22.5590867 C21.9059501,22.8050233 22.0647901,22.9639915 22.2956458,22.9639915 C22.5864468,22.9639915 22.8682205,22.7389598 22.8862244,22.3971247 C22.898244,22.1481438 22.736361,22.0011501 22.511439,22.0011501 C22.2236302,22.0011501 21.9358213,22.2321691 21.9179189,22.5590867 Z M22.1517667,21.1331924 L22.0018525,21.9781142 C22.1307199,21.8042283 22.388556,21.7122368 22.5684429,21.7122368 C22.9401854,21.7122368 23.1980216,21.9302156 23.1980216,22.3350698 C23.1980216,22.9079746 22.7992479,23.2524989 22.2896614,23.2524989 C22.0917706,23.2524989 21.9238525,23.178926 21.8219657,22.9930148 L21.7650125,23.2135307 L21.4741607,23.2135307 L21.8429111,21.1331924 L22.1517667,21.1331924 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M24.7516112,22.3509666 C24.7755995,22.0972668 24.6256853,21.994011 24.3768257,21.994011 C24.1520559,21.994011 23.9451886,22.0972668 23.8551691,22.3509666 L24.7516112,22.3509666 Z M23.804251,22.6046664 C23.7922315,22.8076262 23.9511222,22.9733429 24.2209779,22.9733429 C24.3708921,22.9733429 24.5686814,22.9146875 24.6766034,22.812751 L24.8445215,23.006882 C24.6616931,23.1747298 24.3918375,23.2582985 24.1640247,23.2582985 C23.7383212,23.2582985 23.4894616,23.0032288 23.4894616,22.6132922 C23.4894616,22.0943746 23.8971612,21.7076854 24.4188179,21.7076854 C24.895541,21.7076854 25.1653459,21.9957869 25.0034629,22.6046664 L23.804251,22.6046664 Z",
                id: "Fill-16",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M25.8283814,21.7420871 L25.8133697,21.9376896 C25.9573502,21.7485311 26.131202,21.7099687 26.290042,21.7099687 C26.4339718,21.7099687 26.5628391,21.7610638 26.6318118,21.8360068 L26.4459913,22.1059941 C26.3800108,22.0461717 26.314081,22.0161844 26.2001239,22.0161844 C25.9872215,22.0161844 25.7774633,22.1438968 25.729436,22.4168778 L25.5885999,23.2135459 L25.2797442,23.2135459 L25.5405726,21.7420871 L25.8283814,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.c)("polygon", {
                fill: tertiary,
                points: "28.1192941 21.7420871 28.275142 22.9057573 28.8387909 21.7420871 29.1835529 21.7420871 28.4100952 23.2135459 28.0473293 23.2135459 27.900458 22.2428397 27.6635672 22.7250723 27.4057818 23.2135459 27.0460081 23.2135459 26.7851797 21.7420871 27.1329847 21.7420871 27.285891 22.9057573 27.8524307 21.7420871"
            }), Object(jsx.c)("path", {
                d: "M30.5274503,22.3509666 C30.5513879,22.0972668 30.4015244,21.994011 30.1526649,21.994011 C29.9278951,21.994011 29.7210277,22.0972668 29.6310082,22.3509666 L30.5274503,22.3509666 Z M29.5800901,22.6046664 C29.5680706,22.8076262 29.7269614,22.9733429 29.996817,22.9733429 C30.1467312,22.9733429 30.3445205,22.9146875 30.4524425,22.812751 L30.6203606,23.006882 C30.4375322,23.1747298 30.1676766,23.2582985 29.9398638,23.2582985 C29.5141603,23.2582985 29.2653008,23.0032288 29.2653008,22.6132922 C29.2653008,22.0943746 29.6730004,21.7076854 30.1946571,21.7076854 C30.6713801,21.7076854 30.941185,21.9957869 30.7793021,22.6046664 L29.5800901,22.6046664 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M31.3524449,21.3412364 C31.3524449,21.4461666 31.4304449,21.5003569 31.5144293,21.5003569 C31.63432,21.5003569 31.7452342,21.4222173 31.7452342,21.2753759 C31.7452342,21.1762808 31.6702264,21.119249 31.5892849,21.119249 C31.4783707,21.119249 31.3524449,21.1913505 31.3524449,21.3412364 Z M31.625242,21.742082 L31.3645151,23.2135408 L31.0556594,23.2135408 L31.3164878,21.742082 L31.625242,21.742082 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M32.9955925,22.1060753 C32.8996393,21.9981006 32.7767563,21.9681133 32.629885,21.9681133 C32.4259085,21.9681133 32.2820801,22.0371704 32.2820801,22.1661006 C32.2820801,22.2740753 32.398928,22.3191831 32.5728811,22.3341006 C32.8426861,22.3580499 33.1874481,22.4481133 33.1154832,22.8290182 C33.0645651,23.1049421 32.7887251,23.266904 32.4049631,23.266904 C32.1651815,23.266904 31.9342752,23.2129167 31.7784273,22.9939738 L31.9792596,22.7750309 C32.0901737,22.9279104 32.2850723,22.9909801 32.4589241,22.9939738 C32.6057953,22.9939738 32.7797485,22.9399865 32.806729,22.8020245 C32.8337095,22.6700499 32.7167602,22.619107 32.5009163,22.5979992 C32.2490645,22.5739992 31.9733259,22.481145 31.9733259,22.202126 C31.9733259,21.833145 32.3719475,21.7042148 32.6718265,21.7042148 C32.8996393,21.7042148 33.0675573,21.7551577 33.2055027,21.9022021 L32.9955925,22.1060753 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M33.9703034,21.7420871 L33.8294672,22.534493 C33.7844828,22.7865184 33.8984399,22.9606579 34.1562254,22.9606579 C34.3990498,22.9606579 34.6059172,22.7593725 34.6478079,22.5134359 L34.7827104,21.7420871 L35.0915153,21.7420871 L34.8307884,23.2135459 L34.5519562,23.2135459 L34.5729016,23.0003366 C34.3990498,23.1652922 34.2280888,23.2430765 34.0213229,23.2430765 C33.658557,23.2430765 33.442713,22.982882 33.5206116,22.5361167 L33.6615492,21.7420871 L33.9703034,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M36.4472345,23.2135459 L36.588172,22.4259603 C36.633055,22.1709412 36.5462813,22.0020279 36.2644061,22.0020279 C36.0185895,22.0020279 35.8116207,22.199863 35.7697299,22.4428059 L35.6348274,23.2135459 L35.3260225,23.2135459 L35.5869016,21.7420871 L35.8686246,21.7420871 L35.8476792,21.957123 C36.0185895,21.7981548 36.1953827,21.7197615 36.3872384,21.7197615 C36.7470121,21.7197615 36.9809614,21.9701632 36.9000199,22.4231696 L36.7590823,23.2135459 L36.4472345,23.2135459 Z",
                fill: tertiary
            }), Object(jsx.c)("g", {
                transform: "translate(37.174252, 21.709040)"
            }, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "0.0103575649 0.00128879493 1.81575683 0.00128879493 1.81575683 2.2832981 0.0103575649 2.2832981",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M0.406639662,0.85909852 C0.406639662,1.11092093 0.571514824,1.26400338 0.808507022,1.26400338 C1.44691014,1.26400338 1.61787113,0.2832 0.979214434,0.2832 C0.676444603,0.2832 0.406639662,0.508028753 0.406639662,0.85909852 Z M0.319663069,1.70747061 C0.298717685,1.91043044 0.45456554,1.9925277 0.715495319,1.9925277 C0.943358778,1.9925277 1.18922614,1.86522114 1.24617932,1.54134799 L1.291113,1.288663 C1.15621053,1.4776186 0.910343173,1.55220634 0.72756554,1.55220634 C0.349686476,1.55220634 0.085916645,1.32717463 0.085916645,0.91912389 C0.085916645,0.337339535 0.517553836,0.00128879493 1.00619493,0.00128879493 C1.21316372,0.00128879493 1.39903498,0.099572093 1.46501547,0.267572093 L1.51598427,0.0330520085 L1.8157619,0.0330520085 L1.55787503,1.54824863 C1.46202328,2.1092296 1.04524564,2.28331839 0.664526528,2.28331839 C0.208748895,2.28331839 -0.0429507152,2.06265032 0.0198854356,1.70747061 L0.319663069,1.70747061 Z",
                fill: tertiary
            }))))));
        }, _fundingLogos[constants.h.MYBANK] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MYBANK_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " mybank logo available");
            var _MYBANK_LOGO_COLORS$l = MYBANK_LOGO_COLORS[logoColor], primary = _MYBANK_LOGO_COLORS$l.primary, secondary = _MYBANK_LOGO_COLORS$l.secondary, tertiary = _MYBANK_LOGO_COLORS$l.tertiary;
            return Object(jsx.c)("svg", {
                width: "58px",
                height: "32px",
                viewBox: "0 0 58 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333867, 0, 0, 1.333867, -0.00001, -0.00321)"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M29.010016,14.6206556 C29.010016,14.6206556 27.947442,14.8389924 27.9585564,14.0777038 C27.9698571,13.3164773 29.8942008,13.3619719 30.0914038,13.4236258 C30.0914038,13.4236258 30.1519432,14.2874637 29.010016,14.6206556 M29.3297879,9.81836571 C27.677716,9.80301439 26.9053582,10.753926 26.9053582,10.753926 C26.4037199,11.2864986 26.7253546,12.0076376 27.2173686,12.0597202 C27.924406,12.1345501 27.9170171,11.5413802 29.0022546,11.2784811 C29.9542434,11.0477763 29.9954723,11.9305703 29.9954723,11.9305703 C25.9352386,11.8295126 26.1290887,15.239929 27.5113104,15.9642377 C28.8367183,16.658714 30.0756326,15.7825701 30.0756326,15.7825701 C30.0756326,15.7825701 30.1222013,16.2545455 30.777951,16.2545455 C31.5283904,16.2545455 31.5272727,15.5049412 31.5272727,15.5049412 L31.5242302,12.1853897 C31.4748674,9.75671183 29.3297879,9.81836571 29.3297879,9.81836571",
                id: "Fill-1",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M42.4169651,14.9132636 L40.766254,12.4266353 L41.9794586,11.2784792 C41.9794586,11.2784792 42.5394372,10.7597112 42.0797024,10.2455911 C41.5701862,9.67606803 40.9629029,10.2382165 40.9629029,10.2382165 L39.4383789,11.6556411 L39.4383789,8.81056644 C39.4383789,8.40291433 39.1083605,8.07272727 38.7011934,8.07272727 C38.2936547,8.07272727 37.9636364,8.40291433 37.9636364,8.81056644 L37.9636364,15.5050966 C37.9636364,15.9126248 38.2936547,16.2429358 38.7011934,16.2429358 C39.1083605,16.2429358 39.4383789,15.9126248 39.4383789,15.5050966 L39.4383789,13.7227806 L39.7172538,13.4440304 L41.2106953,15.7865117 C41.2106953,15.7865117 41.697426,16.5998328 42.4143027,16.0821803 C42.9532914,15.6931198 42.4169651,14.9132636 42.4169651,14.9132636",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.0887651,12.0920353 C37.0887651,9.6760941 35.0962232,9.33568291 33.7411943,10.1020724 C33.7401529,10.1029393 33.7389278,10.1056016 33.7382539,10.1063446 C33.6363205,9.81249385 33.362313,9.6 33.0365425,9.6 C32.6248269,9.6 32.2909091,9.93768691 32.2909091,10.3541303 L32.2909091,15.3913243 C32.2909091,15.8078915 32.6248269,16.1454545 33.0365425,16.1454545 C33.4485644,16.1454545 33.7826048,15.8078915 33.7826048,15.3913243 L33.7723134,11.9929705 C33.7723134,11.9929705 33.9532086,11.7752139 34.2436332,11.5669922 C34.9412403,11.0671487 35.6063806,11.2374162 35.6063806,12.0917257 L35.6234716,15.4035835 C35.6234716,15.8135877 35.9518762,16.1454545 36.3573435,16.1454545 C36.7625045,16.1454545 37.0909091,15.8135877 37.0909091,15.4035835 L37.0887651,12.0920353 Z",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M15.5613016,16.2862697 C15.7330634,15.9971851 15.762994,15.7935853 15.762994,15.7935853 L14.0695172,11.3349218 C14.0695172,11.3349218 13.7622674,10.4721348 14.4393994,10.2166114 C15.1567468,9.94557914 15.4157136,10.6357839 15.4696009,10.7805123 C15.5234881,10.9252407 16.5395249,13.6504516 16.5395249,13.6504516 L17.5177483,10.7867779 C17.5177483,10.7867779 17.7979621,9.89638514 18.5815138,10.2138818 C19.2290232,10.4764773 18.8964002,11.3498103 18.8964002,11.3498103 C18.8964002,11.3498103 17.8952671,14.3335844 17.0561037,16.4983684 C16.5548597,17.7916804 16.1267792,17.9191009 15.6376676,18.0403799 C14.9830758,18.2027884 13.7454545,18.1223286 13.7454545,17.30247 C13.7454545,16.655814 14.4027561,16.615491 14.6992284,16.6251065 C14.7151175,16.6254167 15.3279543,16.6788911 15.5613016,16.2862697",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M11.5669215,8.85710249 L10.0137262,13.1590392 L8.3203761,8.88327934 C8.3203761,8.88327934 8.06948196,8.07272727 7.36345596,8.07272727 C6.54545455,8.07272727 6.57202708,8.72317872 6.55361169,8.88327934 C6.53525811,9.04350403 6.55361169,15.569481 6.55361169,15.569481 C6.55361169,15.569481 6.54545455,16.2545455 7.29591229,16.2545455 C8.06280792,16.2545455 8.02603896,15.56334 8.03209502,15.56334 C8.03821288,15.56334 8.03209502,12.1182301 8.03209502,12.1182301 L9.27754342,15.56334 C9.27754342,15.56334 9.46151186,16.2407127 10.0381976,16.2283686 C10.6148833,16.2161486 10.7804982,15.56334 10.7804982,15.56334 L11.823501,12.1244331 L11.823501,15.56334 C11.823501,15.56334 11.823501,16.2545455 12.5780991,16.2545455 C13.3081022,16.2545455 13.3081022,15.56334 13.3081022,15.56334 L13.3090909,8.88948239 C13.3090909,8.88948239 13.3090909,8.07272727 12.5166733,8.07663519 C11.8595284,8.07973672 11.609932,8.71207526 11.5669215,8.85710249 C11.5619778,8.8740368 11.5596913,8.88327934 11.5596913,8.88327934",
                fill: secondary
            }), Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                fill: tertiary
            }, Object(jsx.c)("polygon", {
                points: "3.086436e-05 0.00960615385 42.6159033 0.00960615385 42.6159033 24 3.086436e-05 24",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("g", null), Object(jsx.c)("path", {
                d: "M42.6159341,18.6971754 L29.5208652,18.6971754 L19.9057529,18.6956369 L19.9124196,18.7062215 C18.0119775,20.9263446 15.1892466,22.3382831 12.0318843,22.3382831 C6.30740974,22.3382831 1.66682976,17.7116369 1.66682976,12.0048677 C1.66682976,6.29803692 6.30740974,1.67182154 12.0318843,1.67182154 C15.2027652,1.67182154 18.0390147,3.09182154 19.9398272,5.32819077 L22.0210727,5.32819077 C19.8613082,2.12277538 16.1963507,0.00960615385 12.0318843,0.00960615385 C5.38703452,0.00960615385 3.086436e-05,5.38012923 3.086436e-05,12.0048677 C3.086436e-05,18.6296062 5.38703452,24.0000062 12.0318843,24.0000062 C15.5178286,24.0000062 18.6504994,22.5164985 20.846622,20.1542215 L41.6296327,20.1336062 L42.6159341,18.6971754 Z",
                fill: secondary
            })), Object(jsx.c)("path", {
                d: "M23.5642714,14.6942333 L21.476941,14.6942333 L21.476941,12.703212 L23.5642714,12.703212 C24.0691167,12.729228 24.5593003,12.986305 24.5593003,13.698846 C24.5593003,14.4306215 24.1135333,14.6942333 23.5642714,14.6942333 Z M21.476941,9.5856756 L23.4225205,9.5856756 C23.8122278,9.59572442 24.2213404,9.80372869 24.2213404,10.3852036 C24.2213404,10.9910915 23.8636056,11.1846082 23.4225205,11.1846082 L21.476941,11.1846082 L21.476941,9.5856756 Z M25.2086687,11.7878453 C25.2484033,11.7332241 25.7477042,11.3284357 25.7082776,10.252103 C25.6287468,8.0729285 23.7375637,8.09777311 23.3189641,8.08507338 C22.644646,8.06479081 22.2387368,8.0729285 21.0010496,8.08507338 C19.9559983,8.09543044 19.9636372,9.0459372 19.9636372,9.0459372 L19.9636364,16.1454545 L23.4862807,16.1454545 C25.3714882,16.1454545 26.0727273,15.1069128 26.0727273,13.6549518 C26.0727273,12.1940516 25.2086687,11.7878453 25.2086687,11.7878453 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.P24] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!P24_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " p24 logo available");
            var _P24_LOGO_COLORS$logo = P24_LOGO_COLORS[logoColor], primary = _P24_LOGO_COLORS$logo.primary, secondary = _P24_LOGO_COLORS$logo.secondary;
            return Object(jsx.c)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                viewBox: "0 0 100 32",
                height: "32",
                width: "100",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.c)("g", {
                transform: "matrix(1.2953205,0,0,1.4482638,-127.73674,-229.48747)"
            }, Object(jsx.c)("g", {
                transform: "translate(99,159)"
            }, Object(jsx.c)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 34.123047 14.666016 L 32.416016 14.667969 L 30.496094 27.771484 L 32.208984 27.773438 L 34.123047 14.666016 z M 2.4082031 14.669922 L 0.5 27.771484 L 2.2753906 27.773438 L 2.9785156 22.916016 L 6.421875 22.933594 C 6.421875 22.933594 7.7610468 22.994689 8.7128906 22.419922 C 9.6646511 21.844634 9.9179688 20.537109 9.9179688 20.537109 C 9.9179688 20.537109 10.021944 20.051453 10.107422 19.458984 C 10.201364 18.808401 10.297704 18.027313 10.347656 17.611328 C 10.369589 17.428799 10.382812 17.316406 10.382812 17.316406 C 10.382812 17.316406 10.406035 17.181738 10.408203 16.972656 C 10.411247 16.680039 10.373345 16.24144 10.173828 15.824219 C 10.107822 15.686199 10.023752 15.551336 9.9179688 15.423828 C 9.7749921 15.251532 9.573657 15.118146 9.3457031 15.015625 C 9.1093266 14.909344 8.8444066 14.836083 8.5878906 14.785156 C 8.2611582 14.720236 7.9481918 14.691729 7.7226562 14.679688 C 7.5151753 14.668598 7.3808594 14.669922 7.3808594 14.669922 L 4.5292969 14.669922 L 2.4082031 14.669922 z M 3.9023438 16.636719 L 6.5097656 16.644531 C 6.5097656 16.644531 6.6871684 16.640189 6.9335938 16.644531 C 7.2136679 16.6496 7.5842469 16.667097 7.8886719 16.712891 C 8.149399 16.752066 8.3620627 16.811675 8.4277344 16.90625 C 8.5143382 17.03109 8.5484972 17.190294 8.5605469 17.335938 C 8.5776425 17.542977 8.5477921 17.723762 8.546875 17.736328 C 8.5451652 17.758038 8.3882592 18.81021 8.1777344 20.056641 C 8.0971356 20.533644 7.7783765 20.790093 7.4101562 20.878906 C 6.8022654 21.025453 6.1484375 21 6.1484375 21 L 3.2695312 20.990234 L 3.9023438 16.636719 z M 27.246094 18.195312 C 26.565902 18.205016 26.253806 18.2403 26 18.302734 C 26 18.302734 24.790129 18.501565 24.103516 19.472656 C 23.416902 20.4437 23.212891 22.568359 23.212891 22.568359 C 23.212891 22.568359 22.804576 24.916796 22.923828 25.699219 C 23.042829 26.481642 23.256401 27.206424 24.033203 27.546875 C 24.810173 27.88723 25.46875 27.873047 25.46875 27.873047 C 25.46875 27.873047 26.853325 27.996517 27.896484 27.714844 C 28.939685 27.433792 29.490234 26.595703 29.490234 26.595703 C 29.490234 26.595703 29.735609 26.235379 29.912109 25.804688 C 30.088777 25.374043 30.140682 25.073949 30.148438 25.037109 L 30.257812 24.53125 L 28.484375 24.533203 C 28.484375 24.533203 28.385914 25.868868 27.429688 25.992188 C 26.473716 26.115218 25.960314 26.068498 25.775391 26.060547 C 25.593178 26.052871 24.567122 26.102566 24.650391 25.125 C 24.650808 25.111821 24.651179 25.091912 24.652344 25.064453 C 24.69996 23.94948 24.808594 23.660156 24.808594 23.660156 L 30.375 23.642578 L 30.613281 22.072266 C 30.883598 20.286624 30.683916 18.929319 29.257812 18.398438 C 28.779056 18.220288 27.947801 18.185366 27.246094 18.195312 z M 37.748047 18.197266 C 37.067855 18.206824 36.755758 18.242238 36.501953 18.304688 C 36.501953 18.304688 35.292082 18.503803 34.605469 19.474609 C 33.918854 20.445938 33.714844 22.570313 33.714844 22.570312 C 33.714844 22.570312 33.306572 24.918749 33.425781 25.701172 C 33.545028 26.483643 33.758145 27.207998 34.535156 27.548828 C 35.311959 27.889232 35.970703 27.875 35.970703 27.875 C 35.970703 27.875 37.355488 27.998135 38.398438 27.716797 C 39.441597 27.435412 39.992187 26.597656 39.992188 26.597656 C 39.992188 26.597656 40.237604 26.237189 40.414062 25.806641 C 40.590771 25.376138 40.642384 25.077855 40.650391 25.041016 L 40.759766 24.533203 L 38.986328 24.535156 C 38.986328 24.535156 38.887867 25.871106 37.931641 25.994141 C 36.975669 26.117315 36.462059 26.072303 36.277344 26.064453 C 36.095172 26.056777 35.06916 26.104467 35.152344 25.126953 C 35.152802 25.113774 35.153175 25.093967 35.154297 25.066406 C 35.201874 23.951433 35.310547 23.662109 35.310547 23.662109 L 40.876953 23.644531 L 41.115234 22.076172 C 41.385759 20.290531 41.185607 18.931462 39.759766 18.400391 C 39.280716 18.222193 38.449796 18.187223 37.748047 18.197266 z M 46.277344 18.304688 L 43.757812 24.96875 L 43.179688 18.316406 L 41.541016 18.318359 L 42.371094 27.773438 L 44.355469 27.765625 L 46.90625 21.148438 L 47.486328 27.765625 L 49.505859 27.765625 L 53.117188 18.316406 L 51.417969 18.318359 L 48.898438 24.996094 L 48.300781 18.3125 L 46.277344 18.304688 z M 11.253906 18.310547 L 9.7929688 27.720703 L 11.617188 27.720703 L 12.427734 22.507812 C 12.596271 21.449811 13.285209 20.144531 14.638672 20.144531 L 15.582031 20.140625 L 15.865234 18.310547 L 14.873047 18.310547 C 14.184891 18.310547 13.533952 18.621542 12.978516 18.96875 L 13.076172 18.310547 L 11.253906 18.310547 z M 23.574219 18.310547 L 17.048828 18.320312 L 16.789062 20.167969 L 20.960938 20.167969 L 15.732422 25.884766 L 15.451172 27.771484 L 22.191406 27.769531 L 22.457031 25.939453 L 17.880859 25.951172 L 23.335938 20.005859 L 23.574219 18.310547 z M 59.283203 18.3125 L 56.183594 25.228516 L 55.087891 18.320312 L 53.347656 18.316406 L 54.962891 27.882812 L 54.755859 28.283203 C 54.755859 28.283203 54.42297 29.081956 54.011719 29.267578 C 53.600426 29.452827 52.910156 29.304688 52.910156 29.304688 L 52.650391 31.068359 L 53.066406 31.152344 C 53.459811 31.231491 53.623329 31.198848 54.033203 31.152344 C 54.443329 31.10608 54.748768 30.903232 55.25 30.449219 C 55.751441 29.99568 56.560547 28.207031 56.560547 28.207031 L 61.027344 18.330078 L 59.283203 18.3125 z M 37.816406 20.023438 C 38.153219 20.022293 38.536406 20.045829 38.880859 20.126953 C 39.109271 20.180351 39.326106 20.327316 39.382812 20.544922 C 39.516491 21.058003 39.375 21.841797 39.375 21.841797 L 35.558594 21.835938 L 35.710938 21.144531 C 35.710938 21.144531 35.842858 20.605552 36.107422 20.375 C 36.372026 20.144305 36.710486 20.103629 37.029297 20.068359 C 37.188702 20.050872 37.479594 20.024582 37.816406 20.023438 z M 27.330078 20.027344 C 27.666911 20.026207 28.050203 20.04988 28.394531 20.130859 C 28.623194 20.184445 28.839945 20.329507 28.896484 20.546875 C 29.030121 21.059954 28.886719 21.84375 28.886719 21.84375 L 25.072266 21.839844 L 25.224609 21.148438 C 25.224609 21.148438 25.35653 20.607886 25.621094 20.376953 C 25.885906 20.146258 26.224367 20.107486 26.542969 20.072266 C 26.702373 20.054561 26.993245 20.028481 27.330078 20.027344 z ",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "m 18.656138,16.774358 c -0.0046,0.0239 -0.0083,0.04735 -0.01154,0.07058 -0.0065,0.118231 0.01306,-0.07708 0.01154,-0.07058",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "m 26.763669,16.775893 c -0.0046,0.02391 -0.0083,0.04743 -0.01154,0.07066 -0.0065,0.118089 0.01306,-0.07731 0.01154,-0.07066",
                fill: primary
            }), Object(jsx.c)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 51.226562 0.78710938 C 50.728893 0.78574323 50.439453 0.79296875 50.439453 0.79296875 L 48.318359 5.6542969 C 48.318359 5.6542969 49.531198 5.9719517 51.199219 6.5273438 C 54.144731 7.5791572 56.515625 9.2929688 56.515625 9.2929688 L 66.666016 3.234375 C 66.745656 3.1868271 63.084253 2.0998969 59.082031 1.3945312 C 56.08052 0.86568549 52.71957 0.7912078 51.226562 0.78710938 z M 47.589844 0.90820312 C 47.589844 0.90820313 43.781742 1.1966088 40.910156 1.8066406 C 38.038322 2.4166724 34.904297 3.3691406 34.904297 3.3691406 L 35.34375 6.2011719 C 35.34375 6.2011719 37.385444 5.5830734 39.835938 5.25 C 42.979007 4.7627651 46.330078 5.2851562 46.330078 5.2851562 L 47.589844 0.90820312 z M 32.949219 4.0429688 C 32.949219 4.0429687 31.321834 4.6211203 28.267578 6.0117188 C 25.213321 7.4021267 22.914062 8.8925781 22.914062 8.8925781 L 25.453125 10.84375 C 25.453125 10.84375 27.099522 9.6851386 28.839844 8.8378906 C 30.525001 7.9290065 33.464844 6.8066406 33.464844 6.8066406 L 32.949219 4.0429688 z M 71.046875 5.0175781 L 58.333984 10.615234 L 60.566406 12.546875 L 78.900391 12.546875 C 78.900391 12.546875 78.861436 11.867776 78.373047 10.908203 C 78.067288 10.306786 77.515959 9.6724399 76.935547 9.0117188 C 76.724772 8.771647 75.878829 8.0196942 75.248047 7.5527344 C 73.629269 6.3552786 72.725403 5.8908131 71.046875 5.0175781 z M 20.621094 10.361328 C 20.621094 10.361328 18.007768 12.208509 16.898438 13.080078 C 15.819753 13.883157 13.6875 15.744141 13.6875 15.744141 L 19.160156 15.744141 C 19.160156 15.744141 20.387652 14.611026 21.257812 13.884766 C 22.127974 13.158363 23.712891 12.011719 23.712891 12.011719 L 20.621094 10.361328 z M 66.779297 14.519531 C 65.231195 14.543948 64.467235 14.626145 63.683594 14.955078 C 62.899953 15.283726 62.446574 15.882838 62.158203 16.728516 C 61.840059 17.527168 61.65625 19.259766 61.65625 19.259766 L 63.453125 19.261719 L 63.560547 18.464844 C 63.560547 18.464844 63.753461 17.029388 64.181641 16.751953 C 64.31878 16.663088 64.538495 16.579747 64.792969 16.529297 C 65.262594 16.436347 65.860733 16.425312 66.345703 16.445312 C 67.093861 16.476103 67.374266 16.483376 68.134766 16.582031 C 68.895557 16.68089 68.701172 17.517578 68.701172 17.517578 L 68.552734 18.767578 C 68.552734 18.767578 68.488006 19.327955 68.3125 19.677734 C 68.157306 19.987057 67.733373 20.195678 67.488281 20.287109 C 66.896194 20.507571 64.871094 21.095703 64.871094 21.095703 L 63.275391 21.619141 C 63.275391 21.619141 62.297563 21.944394 61.748047 22.636719 C 61.19878 23.329281 60.983257 24.116118 60.908203 24.527344 C 60.833113 24.938283 60.412109 27.769531 60.412109 27.769531 L 69.009766 27.773438 L 69.296875 25.810547 L 62.496094 25.820312 L 62.619141 25.021484 C 62.619141 25.021484 62.697988 24.196554 62.990234 23.927734 C 63.082461 23.842591 63.127078 23.730658 63.669922 23.509766 C 63.993778 23.377829 65.103516 23.039062 65.103516 23.039062 L 67.669922 22.240234 C 67.669922 22.240234 69.069743 21.828553 69.621094 20.957031 C 70.172403 20.085747 70.384766 18.416016 70.384766 18.416016 C 70.384766 18.416016 70.533003 16.793571 70.419922 16.285156 C 70.307099 15.776804 69.886071 15.166455 69.375 14.90625 C 68.863719 14.646045 68.327565 14.495353 66.779297 14.519531 z ",
                fill: secondary
            }), Object(jsx.c)("g", {
                transform: "translate(53.596306,9.56338)"
            }, Object(jsx.c)("path", {
                d: "M 4.7408782,5.7106164 1.839113,5.7061141 5.3711256,1.8647573 Z M 6.112171,5.7095319 7.0417209,0.01876197 5.3948175,0.01774319 0.26289873,5.6444944 0.02981113,7.0693723 4.5178982,7.0688465 4.1894639,9.0682502 l 1.376733,0.00181 0.3251187,-2.001047 1.2714396,0.00269 0.2297076,-1.3639812 z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.BLIK] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BLIK_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " blik logo available");
            var _BLIK_LOGO_COLORS$log = BLIK_LOGO_COLORS[logoColor], primary = _BLIK_LOGO_COLORS$log.primary, secondary = _BLIK_LOGO_COLORS$log.secondary, tertiary = _BLIK_LOGO_COLORS$log.tertiary, quaternary = _BLIK_LOGO_COLORS$log.quaternary, quinary = _BLIK_LOGO_COLORS$log.quinary, senary = _BLIK_LOGO_COLORS$log.senary;
            return Object(jsx.c)("svg", {
                width: "58px",
                height: "30px",
                viewBox: "0 0 58 30",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("defs", null, Object(jsx.c)("path", {
                d: "M4.81760131,0 C2.15699346,0 0,2.12049689 0,4.73608696 L0,4.73608696 L0,25.263913 C0,27.8795031 2.15699346,30 4.81760131,30 L4.81760131,30 L53.1823987,30 C55.8430065,30 58,27.8795031 58,25.263913 L58,25.263913 L58,4.73608696 C58,2.12049689 55.8430065,0 53.1823987,0 L53.1823987,0 L4.81760131,0 Z",
                id: "path-1"
            }), Object(jsx.c)("linearGradient", {
                x1: "50%",
                y1: "100%",
                x2: "50%",
                y2: "0%",
                id: "linearGradient-3"
            }, Object(jsx.c)("stop", {
                "stop-color": primary,
                offset: "0%"
            }), Object(jsx.c)("stop", {
                "stop-color": secondary,
                offset: "100%"
            })), Object(jsx.c)("radialGradient", {
                cx: "20.3705659%",
                cy: "18.0870534%",
                fx: "20.3705659%",
                fy: "18.0870534%",
                r: "117.639519%",
                gradientTransform: "translate(0.203706,0.180871),scale(0.983106,1.000000),rotate(54.479781),translate(-0.203706,-0.180871)",
                id: "radialGradient-4"
            }, Object(jsx.c)("stop", {
                "stop-color": tertiary,
                offset: "0%"
            }), Object(jsx.c)("stop", {
                "stop-color": quaternary,
                offset: "55.9042441%"
            }), Object(jsx.c)("stop", {
                "stop-color": quinary,
                offset: "100%"
            })), Object(jsx.c)("path", {
                d: "M3.67238562,6.95664596 C5.60913072,6.95664596 7.17892157,5.41322981 7.17892157,3.50925466 C7.17892157,1.60546584 5.60913072,0.0620496894 3.67238562,0.0620496894 C1.73564052,0.0620496894 0.165849673,1.60546584 0.165849673,3.50925466 C0.165849673,5.41322981 1.73564052,6.95664596 3.67238562,6.95664596 Z",
                id: "path-5"
            })), Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                id: "mask-2",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-1"
            })), Object(jsx.c)("g", {
                id: "Clip-2"
            }), Object(jsx.c)("path", {
                d: "M4.81760131,0 C2.15699346,0 0,2.12049689 0,4.73608696 L0,4.73608696 L0,25.263913 C0,27.8795031 2.15699346,30 4.81760131,30 L4.81760131,30 L53.1823987,30 C55.8430065,30 58,27.8795031 58,25.263913 L58,25.263913 L58,4.73608696 C58,2.12049689 55.8430065,0 53.1823987,0 L53.1823987,0 L4.81760131,0 Z",
                fill: "url(#linearGradient-3)",
                mask: "url(#mask-2)"
            })), Object(jsx.c)("g", {
                transform: "translate(6.254902, 4.472050)",
                fill: senary
            }, Object(jsx.c)("polygon", {
                points: "17.627451 21.6769565 21.5604575 21.6769565 21.5604575 0.0154658385 17.627451 0.0154658385"
            }), Object(jsx.c)("polygon", {
                points: "24.9248366 21.6769565 28.8578431 21.6769565 28.8578431 7.32913043 24.9248366 7.32913043"
            }), Object(jsx.c)("polygon", {
                points: "46.4852941 21.6770124 40.5751699 14.0838447 46.0114379 7.32918634 41.3676471 7.32918634 36.1552288 13.8822298 36.1552288 0.0155217391 32.2222222 0.0155217391 32.2222222 21.6770124 36.1552288 21.6770124 36.1552288 14.3106149 41.3676471 21.6770124"
            }), Object(jsx.c)("path", {
                d: "M7.60539216,17.9735963 C5.65575817,17.9735963 4.0751634,16.4197453 4.0751634,14.5030994 C4.0751634,12.5864534 5.65575817,11.0326025 7.60539216,11.0326025 C9.55502614,11.0326025 11.1356209,12.5864534 11.1356209,14.5030994 C11.1356209,16.4197453 9.55502614,17.9735963 7.60539216,17.9735963 M7.60539216,7.16614286 C6.3282549,7.16614286 5.12636601,7.4821677 4.0751634,8.03800621 L4.0751634,0.0155217391 L0.142156863,0.0155217391 L0.142156863,14.5030994 C0.142156863,18.5551491 3.48360131,21.8400559 7.60539216,21.8400559 C11.727183,21.8400559 15.0686275,18.5551491 15.0686275,14.5030994 C15.0686275,10.4510497 11.727183,7.16614286 7.60539216,7.16614286"
            })), Object(jsx.c)("g", {
                transform: "translate(14.026144, 3.354037)"
            }, Object(jsx.c)("mask", {
                id: "mask-6",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-5"
            })), Object(jsx.c)("use", {
                fill: "url(#radialGradient-4)",
                href: "#path-5"
            }), Object(jsx.c)("path", {
                d: "M3.67238562,6.95664596 C5.60913072,6.95664596 7.17892157,5.41322981 7.17892157,3.50925466 C7.17892157,1.60546584 5.60913072,0.0620496894 3.67238562,0.0620496894 C1.73564052,0.0620496894 0.165849673,1.60546584 0.165849673,3.50925466 C0.165849673,5.41322981 1.73564052,6.95664596 3.67238562,6.95664596 Z",
                mask: "url(#mask-6)"
            }))))));
        }, _fundingLogos[constants.h.MAXIMA] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MAXIMA_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " maxima logo available");
            var _MAXIMA_LOGO_COLORS$l = MAXIMA_LOGO_COLORS[logoColor], primary = _MAXIMA_LOGO_COLORS$l.primary, secondary = _MAXIMA_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "93px",
                height: "20px",
                viewBox: "0 0 93 20",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("defs", null, Object(jsx.c)("polygon", {
                id: "path-1",
                points: "0.126046849 0.210564103 13.9960414 0.210564103 13.9960414 19.7435897 0.126046849 19.7435897"
            })), Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-101.000000, -153.000000)"
            }, Object(jsx.c)("g", {
                id: "logo-maxima",
                transform: "translate(101.000000, 153.000000)"
            }, Object(jsx.c)("path", {
                d: "M24.7684479,3.31769231 L31.0927027,3.31769231 C31.6107,4.85923077 32.1393986,6.37589744 32.679563,7.86205128 C33.3708205,9.79794872 33.9293301,11.3192308 34.3477027,12.4258974 C34.4990507,12.8233333 34.6516726,13.2235897 34.8042945,13.6202564 L34.6631384,16.9894872 L30.5446397,16.9894872 C30.4111274,16.4687179 30.2518808,15.9366667 30.0765822,15.3917949 C29.8329986,14.6961538 29.656426,14.1761538 29.5481384,13.8374359 L24.6869137,13.8374359 L23.3049082,16.9894872 L17.5085877,16.9894872 C18.7168233,14.9294872 19.9696479,12.6705128 21.2706288,10.2146154 C22.4380973,8.01717949 23.6025082,5.72051282 24.7684479,3.31769231 Z M26.1713466,10.3571795 L28.6736836,10.3571795 L27.6769274,7.00128205 L26.1713466,10.3571795 Z",
                id: "Fill-1",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M81.6723452,3.31769231 L87.9971096,3.31769231 C88.5140877,4.85923077 89.0417671,6.37589744 89.5832055,7.86205128 C90.2754822,9.79794872 90.8309342,11.3192308 91.2516,12.4258974 C91.8325315,13.9528205 92.4188137,15.4738462 93,16.9894872 L87.4470082,16.9894872 C87.3114575,16.4687179 87.1555233,15.9366667 86.9781863,15.3917949 C86.7371507,14.6961538 86.5605781,14.1761538 86.4505068,13.8374359 L81.5915753,13.8374359 L80.2067671,16.9894872 L74.4119753,16.9894872 C75.618937,14.9294872 76.872526,12.6705128 78.174526,10.2146154 C79.3419945,8.01717949 80.5038575,5.72051282 81.6723452,3.31769231 Z M83.076263,10.3571795 L85.5747781,10.3571795 L84.5803151,7.00128205 L83.076263,10.3571795 Z",
                id: "Fill-3",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M58.2832529,3.31807692 L64.9953049,3.31807692 C65.0651186,3.78217949 65.2523926,4.97474359 65.5637515,6.89858974 C65.8231323,8.46730769 65.9920611,9.69115385 66.0746145,10.5621795 C66.3449515,9.41653846 66.7452337,7.9024359 67.2734227,6.01935897 C67.7088666,4.47730769 67.9565268,3.57576923 68.0248118,3.31807692 L74.8996775,3.31807692 C74.8996775,4.79141026 74.8619679,6.30371795 74.7875679,7.85192308 C74.7154611,9.39782051 74.6372392,11.0239744 74.5656419,12.7219231 C74.4904775,14.4196154 74.4530227,15.8429487 74.4530227,16.9888462 L69.9372995,16.9888462 C69.9372995,16.0196154 69.9696584,14.9288462 70.0379433,13.7142308 C70.202031,10.7967949 70.2830556,8.96705128 70.2830556,8.22884615 L67.8235241,16.9888462 L63.3681871,16.9888462 L61.9469433,8.22884615 C61.7958501,9.62141026 61.6679433,11.1034615 61.5588912,12.670641 C61.4498392,14.2398718 61.3950584,15.6798718 61.3950584,16.9888462 L57.1058474,16.9888462 C57.2806364,15.4737179 57.4635789,13.9188462 57.65442,12.3237179 C57.8439871,10.7267949 57.9960995,9.18371795 58.1097378,7.69730769 C58.2251597,6.21192308 58.2832529,4.75064103 58.2832529,3.31807692",
                id: "Fill-5",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M50.0900038,3.31807692 L55.5584038,3.31807692 C55.1650011,7.91525641 54.9698285,12.4742308 54.9698285,16.9888462 L50.1251655,16.9888462 L49.461171,16.3744872 C49.4754395,15.2557692 49.525634,14.0047436 49.6109901,12.6201282 C49.7131627,10.9747436 49.8178833,9.27397436 49.9259162,7.51397436 C50.0342038,5.75346154 50.0900038,4.355 50.0900038,3.31807692",
                id: "Fill-7",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M1.17743096,3.31807692 L7.8899926,3.31807692 C7.95878712,3.78217949 8.14631589,4.97474359 8.45869397,6.89858974 C8.71552685,8.46730769 8.88522,9.69115385 8.96726384,10.5621795 C9.23963918,9.41653846 9.6386474,7.9024359 10.1676008,6.01935897 C10.6030447,4.47730769 10.8507049,3.57576923 10.9194995,3.31807692 L17.7938556,3.31807692 C17.7938556,4.79141026 17.7556364,6.30371795 17.6812364,7.85192308 C17.6091296,9.39782051 17.5314173,11.0239744 17.4580364,12.7219231 C17.3836364,14.4196154 17.3464364,15.8429487 17.3464364,16.9888462 L12.8304584,16.9888462 C12.8304584,16.0196154 12.8630721,14.9288462 12.932631,13.7142308 C13.0949351,10.7967949 13.1764693,8.96705128 13.1764693,8.22884615 L10.716683,16.9888462 L6.26185562,16.9888462 L4.83882822,8.22884615 C4.68900904,9.62141026 4.56110219,11.1034615 4.45230493,12.670641 C4.3422337,14.2398718 4.29025562,15.6798718 4.29025562,16.9888462 L2.54794521e-05,16.9888462 C0.174050137,15.4737179 0.356992603,13.9188462 0.54732411,12.3237179 C0.737655616,10.7267949 0.890277534,9.18371795 1.00569945,7.69730769 C1.12010219,6.21192308 1.17743096,4.75064103 1.17743096,3.31807692",
                id: "Fill-9",
                fill: primary
            }), Object(jsx.c)("g", {
                id: "Group-13",
                transform: "translate(35.161644, 0.045846)"
            }, Object(jsx.c)("mask", {
                id: "mask-2",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-1"
            })), Object(jsx.c)("g", {
                id: "Clip-12"
            }), Object(jsx.c)("path", {
                d: "M13.9960414,17.0754359 L13.5193208,17.5531282 C13.4044085,17.5285128 13.3037647,17.5190256 13.2135674,17.5190256 C13.0303701,17.5190256 12.8729071,17.6226154 12.7373564,17.828 C12.6698359,17.9638974 12.7513701,18.1431282 12.9760989,18.3746667 C13.065277,18.4656923 13.3167592,18.6572308 13.7239208,18.9572308 L13.7239208,19.0251795 C13.7239208,19.092359 13.7585729,19.3331282 13.825329,19.743641 C12.4433236,19.743641 11.2075701,19.4695385 10.1203619,18.9218462 C9.4420989,18.5805641 8.38674,17.8482564 6.95887151,16.7321026 C6.32596192,16.1867179 5.79955644,15.6851795 5.37940027,15.228 C4.95669616,14.7695385 4.52303589,14.2005641 4.07001123,13.5174872 L0.126046849,16.8015897 L0.228983836,14.338 L2.8113263,11.1905641 C2.33664411,10.6656923 1.91495918,10.0977436 1.55493452,9.48005128 C1.30345233,8.95466667 1.09961671,8.44979487 0.942663288,7.95825641 C0.784945479,7.46569231 0.670287945,6.96235897 0.602512603,6.4354359 C0.716660548,6.21005128 0.772460548,6.04748718 0.772460548,5.958 L0.670287945,5.51312821 L4.34085781,1.74953846 L7.26564411,6.57261538 L12.8387647,0.414666667 C12.9541866,0.27825641 13.0446386,0.210564103 13.11114,0.210564103 C13.2688578,0.210564103 13.3501373,0.518769231 13.3501373,1.13364103 C13.3501373,1.63441026 13.3167592,2.15928205 13.2484742,2.70697436 C13.1801893,3.25517949 13.1330523,3.63158974 13.11114,3.83748718 C12.907814,4.88312821 12.1250852,5.96723077 10.7655016,7.08671795 C9.8607263,7.83953846 9.20259205,8.49005128 8.79517562,9.03594872 C8.92970712,9.35133333 9.04461945,9.60441026 9.13379753,9.78902564 C9.67727425,10.9254359 10.1422742,11.8277436 10.5277784,12.4910769 C11.0931674,13.4482564 11.6287455,14.2572308 12.1250852,14.9192821 C12.6221893,15.578 13.2484742,16.2956923 13.9960414,17.0754359",
                id: "Fill-11",
                fill: secondary,
                mask: "url(#mask-2)"
            }))))));
        }, _fundingLogos[constants.h.BOLETO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BOLETO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " boleto logo available");
            var _BOLETO_LOGO_COLORS$l = BOLETO_LOGO_COLORS[logoColor], primary = _BOLETO_LOGO_COLORS$l.primary, secondary = _BOLETO_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "50px",
                height: "23px",
                viewBox: "0 0 50 23",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                id: "Group-38-Copy-2",
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("polygon", {
                id: "Fill-1",
                fill: primary,
                points: "3.77543103 22.2594828 6.12112069 22.2594828 6.12112069 0.294827586 3.77543103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-3",
                fill: primary,
                points: "6.86077586 22.2594828 7.58793103 22.2594828 7.58793103 0.294827586 6.86077586 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-4",
                fill: primary,
                points: "8.22112069 22.2594828 9.52241379 22.2594828 9.52241379 0.294827586 8.22112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-5",
                fill: primary,
                points: "10.7771552 22.2594828 11.5043103 22.2594828 11.5043103 0.294827586 10.7771552 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-6",
                fill: primary,
                points: "11.8202586 22.2594828 12.3806034 22.2594828 12.3806034 0.294827586 11.8202586 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-7",
                fill: primary,
                points: "1.99181034 22.2594828 2.71896552 22.2594828 2.71896552 0.294827586 1.99181034 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-8",
                fill: primary,
                points: "0.388793103 22.2594828 1.69008621 22.2594828 1.69008621 0.294827586 0.388793103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-9",
                fill: primary,
                points: "16.2655172 22.2594828 18.6112069 22.2594828 18.6112069 0.294827586 16.2655172 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-10",
                fill: primary,
                points: "19.350431 22.2594828 20.0775862 22.2594828 20.0775862 0.294827586 19.350431 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-11",
                fill: primary,
                points: "20.7112069 22.2594828 22.0125 22.2594828 22.0125 0.294827586 20.7112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-12",
                fill: primary,
                points: "23.2668103 22.2594828 23.9939655 22.2594828 23.9939655 0.294827586 23.2668103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-13",
                fill: primary,
                points: "24.3099138 22.2594828 24.8702586 22.2594828 24.8702586 0.294827586 24.3099138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-14",
                fill: primary,
                points: "14.4814655 22.2594828 15.2086207 22.2594828 15.2086207 0.294827586 14.4814655 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-15",
                fill: primary,
                points: "12.8784483 22.2594828 14.1797414 22.2594828 14.1797414 0.294827586 12.8784483 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-16",
                fill: primary,
                points: "25.7918103 22.2594828 27.0931034 22.2594828 27.0931034 0.294827586 25.7918103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-17",
                fill: primary,
                points: "28.3474138 22.2594828 29.074569 22.2594828 29.074569 0.294827586 28.3474138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-18",
                fill: primary,
                points: "29.3909483 22.2594828 29.9512931 22.2594828 29.9512931 0.294827586 29.3909483 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-19",
                fill: primary,
                points: "32.0521552 22.2594828 32.7793103 22.2594828 32.7793103 0.294827586 32.0521552 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-20",
                fill: primary,
                points: "30.4491379 22.2594828 31.750431 22.2594828 31.750431 0.294827586 30.4491379 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-21",
                fill: primary,
                points: "33.7456897 22.2594828 34.4728448 22.2594828 34.4728448 0.294827586 33.7456897 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-22",
                fill: primary,
                points: "34.7887931 22.2594828 35.3491379 22.2594828 35.3491379 0.294827586 34.7887931 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-23",
                fill: primary,
                points: "37.450431 22.2594828 38.1775862 22.2594828 38.1775862 0.294827586 37.450431 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-24",
                fill: primary,
                points: "35.8474138 22.2594828 37.1487069 22.2594828 37.1487069 0.294827586 35.8474138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-25",
                fill: primary,
                points: "38.8112069 22.2594828 41.1568966 22.2594828 41.1568966 0.294827586 38.8112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-26",
                fill: primary,
                points: "41.8961207 22.2594828 42.6232759 22.2594828 42.6232759 0.294827586 41.8961207 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-27",
                fill: primary,
                points: "43.2564655 22.2594828 44.5577586 22.2594828 44.5577586 0.294827586 43.2564655 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-28",
                fill: primary,
                points: "45.8125 22.2594828 46.5396552 22.2594828 46.5396552 0.294827586 45.8125 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-29",
                fill: primary,
                points: "46.8556034 22.2594828 47.4159483 22.2594828 47.4159483 0.294827586 46.8556034 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-30",
                fill: primary,
                points: "48.3375 22.2594828 49.6387931 22.2594828 49.6387931 0.294827586 48.3375 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-31",
                fill: secondary,
                points: "3.04224138 22.3090517 48.0056034 22.3090517 48.0056034 9.9987069 3.04224138 9.9987069"
            }), Object(jsx.c)("path", {
                d: "M3.89008621,21.837069 L3.89008621,10.6991379 L8.06939655,10.6991379 C8.91982759,10.6991379 9.6012931,10.8107759 10.1172414,11.0362069 C10.6306034,11.2616379 11.0327586,11.6090517 11.3228448,12.0784483 C11.6159483,12.5452586 11.7612069,13.0349138 11.7612069,13.5482759 C11.7612069,14.0228448 11.6314655,14.4715517 11.375,14.8913793 C11.1181034,15.3116379 10.7293103,15.6512931 10.2081897,15.9103448 C10.8823276,16.1073276 11.4008621,16.4443966 11.7612069,16.9215517 C12.1241379,17.3956897 12.3056034,17.9586207 12.3056034,18.6068966 C12.3056034,19.1301724 12.1939655,19.6150862 11.9737069,20.0637931 C11.7534483,20.512069 11.4810345,20.8568966 11.1568966,21.1008621 C10.8327586,21.3418103 10.4258621,21.5258621 9.93836207,21.650431 C9.44827586,21.775 8.84956897,21.837069 8.13922414,21.837069 L3.89008621,21.837069 Z M5.36767241,15.3814655 L7.7762931,15.3814655 C8.42974138,15.3814655 8.8987069,15.3375 9.18146552,15.2517241 C9.55732759,15.1400862 9.84008621,14.9538793 10.0293103,14.6943966 C10.2185345,14.4353448 10.3146552,14.1112069 10.3146552,13.7193966 C10.3146552,13.3487069 10.2262931,13.0219828 10.0474138,12.7422414 C9.87112069,12.4594828 9.61724138,12.2650862 9.28793103,12.1612069 C8.95862069,12.0577586 8.39310345,12.0056034 7.59482759,12.0056034 L5.36767241,12.0056034 L5.36767241,15.3814655 Z M5.36767241,20.5301724 L8.14181034,20.5301724 C8.61896552,20.5301724 8.95344828,20.512069 9.14784483,20.4758621 C9.48491379,20.4163793 9.77025862,20.3150862 9.99827586,20.1724138 C10.2262931,20.0301724 10.412931,19.8228448 10.5607759,19.550431 C10.7086207,19.2780172 10.7810345,18.9646552 10.7810345,18.6094828 C10.7810345,18.1918103 10.675,17.8314655 10.4594828,17.5228448 C10.2469828,17.2142241 9.9512931,16.9991379 9.57284483,16.874569 C9.19698276,16.750431 8.65258621,16.687931 7.94482759,16.687931 L5.36767241,16.687931 L5.36767241,20.5301724 Z",
                id: "Fill-32",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M13.6435345,17.800431 C13.6435345,16.3094828 14.0581897,15.2051724 14.8905172,14.487069 C15.5827586,13.8905172 16.4306034,13.5926724 17.4288793,13.5926724 C18.5357759,13.5926724 19.4431034,13.9556034 20.1482759,14.6814655 C20.8508621,15.4047414 21.2034483,16.4081897 21.2034483,17.6862069 C21.2034483,18.7232759 21.0478448,19.5375 20.737069,20.1310345 C20.4258621,20.725 19.9719828,21.1862069 19.3758621,21.5155172 C18.7818966,21.8448276 18.1314655,22.0081897 17.4288793,22.0081897 C16.2982759,22.0081897 15.3857759,21.6478448 14.6883621,20.924569 C13.9909483,20.2012931 13.6435345,19.1590517 13.6435345,17.800431 Z M15.0435345,17.8030172 C15.0435345,18.8349138 15.2689655,19.6073276 15.7202586,20.1181034 C16.1737069,20.6314655 16.7418103,20.8883621 17.4288793,20.8883621 C18.1077586,20.8883621 18.6732759,20.6314655 19.1267241,20.1155172 C19.5780172,19.599569 19.8034483,18.8142241 19.8034483,17.7590517 C19.8034483,16.7633621 19.575431,16.0090517 19.1215517,15.4982759 C18.6681034,14.9849138 18.1030172,14.7280172 17.4288793,14.7280172 C16.7418103,14.7280172 16.1737069,14.9823276 15.7202586,15.4926724 C15.2689655,16.0034483 15.0435345,16.7737069 15.0435345,17.8030172 Z",
                id: "Fill-33",
                fill: primary
            }), Object(jsx.c)("polygon", {
                id: "Fill-34",
                fill: primary,
                points: "22.7771552 21.837069 24.1461207 21.837069 24.1461207 10.6991379 22.7771552 10.6991379"
            }), Object(jsx.c)("path", {
                d: "M31.7711207,19.2237069 L33.1866379,19.4103448 C32.9663793,20.2323276 32.5543103,20.8724138 31.9525862,21.3262931 C31.3512931,21.7801724 30.5836207,22.0081897 29.6478448,22.0081897 C28.4706897,22.0081897 27.5375,21.6452586 26.8478448,20.9193966 C26.1581897,20.1961207 25.8133621,19.1771552 25.8133621,17.8676724 C25.8133621,16.5146552 26.1607759,15.4616379 26.8581897,14.7150862 C27.5556034,13.9659483 28.4603448,13.5926724 29.5724138,13.5926724 C30.6487069,13.5926724 31.5275862,13.9581897 32.2094828,14.6918103 C32.8909483,15.425431 33.2331897,16.4573276 33.2331897,17.7875 C33.2331897,17.8676724 33.2306034,17.9896552 33.225431,18.150431 L27.2133621,18.150431 C27.2650862,19.0344828 27.5142241,19.7137931 27.9650862,20.1831897 C28.4137931,20.6521552 28.9762931,20.8883621 29.6478448,20.8883621 C30.1482759,20.8883621 30.5758621,20.7560345 30.9284483,20.4913793 C31.2836207,20.2271552 31.5637931,19.8043103 31.7711207,19.2237069 Z M27.2909483,17.0301724 L31.7866379,17.0301724 C31.7271552,16.3512931 31.5534483,15.8431034 31.2706897,15.5034483 C30.837931,14.9771552 30.2724138,14.7125 29.5801724,14.7125 C28.9530172,14.7125 28.4267241,14.9224138 27.9987069,15.3426724 C27.5737069,15.7625 27.337931,16.325 27.2909483,17.0301724 Z",
                id: "Fill-35",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.887069,20.6159483 L38.0737069,21.8241379 C37.6900862,21.9047414 37.3452586,21.9461207 37.0443966,21.9461207 C36.549569,21.9461207 36.1655172,21.8681034 35.8909483,21.7099138 C35.6185345,21.5517241 35.4267241,21.3469828 35.3155172,21.0905172 C35.2038793,20.8336207 35.149569,20.2943966 35.149569,19.4724138 L35.149569,14.8215517 L34.1383621,14.8215517 L34.1383621,13.7637931 L35.149569,13.7637931 L35.149569,11.7672414 L36.5181034,10.9456897 L36.5181034,13.7637931 L37.887069,13.7637931 L37.887069,14.8215517 L36.5181034,14.8215517 L36.5181034,19.550431 C36.5181034,19.9418103 36.5413793,20.1935345 36.5909483,20.3047414 C36.6375,20.4163793 36.7155172,20.5043103 36.8241379,20.5719828 C36.9331897,20.6366379 37.0887931,20.6702586 37.2909483,20.6702586 C37.4413793,20.6702586 37.6409483,20.6521552 37.887069,20.6159483",
                id: "Fill-36",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M38.724569,17.800431 C38.724569,16.3094828 39.1396552,15.2051724 39.9715517,14.487069 C40.6637931,13.8905172 41.5116379,13.5926724 42.5099138,13.5926724 C43.6168103,13.5926724 44.524569,13.9556034 45.2297414,14.6814655 C45.9323276,15.4047414 46.2849138,16.4081897 46.2849138,17.6862069 C46.2849138,18.7232759 46.1293103,19.5375 45.8181034,20.1310345 C45.5068966,20.725 45.0534483,21.1862069 44.4568966,21.5155172 C43.8633621,21.8448276 43.2125,22.0081897 42.5099138,22.0081897 C41.3797414,22.0081897 40.4668103,21.6478448 39.7693966,20.924569 C39.0719828,20.2012931 38.724569,19.1590517 38.724569,17.800431 Z M40.124569,17.8030172 C40.124569,18.8349138 40.350431,19.6073276 40.8012931,20.1181034 C41.2551724,20.6314655 41.8228448,20.8883621 42.5099138,20.8883621 C43.1892241,20.8883621 43.7543103,20.6314655 44.2081897,20.1155172 C44.6590517,19.599569 44.8849138,18.8142241 44.8849138,17.7590517 C44.8849138,16.7633621 44.6564655,16.0090517 44.2030172,15.4982759 C43.7491379,14.9849138 43.1840517,14.7280172 42.5099138,14.7280172 C41.8228448,14.7280172 41.2551724,14.9823276 40.8012931,15.4926724 C40.350431,16.0034483 40.124569,16.7737069 40.124569,17.8030172 Z",
                id: "Fill-37",
                fill: primary
            })))));
        }, _fundingLogos[constants.h.OXXO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!OXXO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " oxxo logo available");
            var _OXXO_LOGO_COLORS$log = OXXO_LOGO_COLORS[logoColor], primary = _OXXO_LOGO_COLORS$log.primary, secondary = _OXXO_LOGO_COLORS$log.secondary;
            return Object(jsx.c)("svg", {
                width: "42px",
                height: "20px",
                viewBox: "0 0 42 20",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                id: "logo-OXXO",
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M0.142456528,1.48437917 C0.142456528,0.77043992 0.728159303,0.186243119 1.44446761,0.186243119 L40.6503931,0.186243119 C41.3667014,0.186243119 41.9524042,0.77043992 41.9524042,1.48437917 L41.9524042,18.1011373 C41.9524042,18.8150765 41.3667014,19.3990362 40.6503931,19.3990362 L1.44446761,19.3990362 C0.728159303,19.3990362 0.142456528,18.8150765 0.142456528,18.1011373 L0.142456528,1.48437917 Z",
                id: "Fill-2",
                fill: secondary
            }), Object(jsx.c)("polygon", {
                id: "Fill-4",
                fill: "#FEFEFE",
                points: "0.142480318 17.5124813 41.952428 17.5124813 41.952428 2.07265562 0.142480318 2.07265562"
            }), Object(jsx.c)("path", {
                d: "M35.5752619,6.08262231 C33.662331,6.08262231 32.1029152,7.63763417 32.1029152,9.54463469 C32.1029152,11.4511608 33.662331,13.0064099 35.5752619,13.0064099 C37.4877171,13.0064099 39.0471329,11.4511608 39.0471329,9.54463469 C39.0471329,7.63763417 37.4877171,6.08262231 35.5752619,6.08262231",
                id: "Fill-6",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M6.95585459,6.08262231 C5.04268574,6.08262231 3.48326994,7.63763417 3.48326994,9.54463469 C3.48326994,11.4511608 5.04268574,13.0064099 6.95585459,13.0064099 C8.86807185,13.0064099 10.4277255,11.4511608 10.4277255,9.54463469 C10.4277255,7.63763417 8.86807185,6.08262231 6.95585459,6.08262231",
                id: "Fill-7",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M35.5752619,15.0141446 C32.5537303,15.0141446 30.0893537,12.5573397 30.0893537,9.54480072 C30.0893537,6.53155015 32.5537303,4.07521964 35.5752619,4.07521964 C38.5970315,4.07521964 41.0609322,6.53155015 41.0609322,9.54480072 C41.0609322,12.5573397 38.5970315,15.0141446 35.5752619,15.0141446 Z M12.4411918,9.54480072 C12.4411918,12.5573397 9.97729109,15.0141446 6.95575943,15.0141446 C3.93351408,15.0141446 1.46985124,12.5573397 1.46985124,9.54480072 C1.46985124,6.53155015 3.93351408,4.07521964 6.95575943,4.07521964 C9.97729109,4.07521964 12.4411918,6.53155015 12.4411918,9.54480072 Z M35.3028697,3.03585692 C32.0884035,2.9620911 30.5772808,5.01709763 28.384107,7.55170056 L26.3151155,9.94232969 L29.591435,13.8526295 C30.3719756,15.0542296 28.8822636,16.2465793 27.9580332,15.1472077 L24.9288888,11.5447794 L21.9772989,14.9562705 C21.0373673,16.0421223 19.5645461,14.8288999 20.3617394,13.6386849 L23.5659761,9.92382894 L21.4667717,7.42693908 L22.8173138,5.75949957 L24.9522028,8.31639828 L26.7923372,6.18217058 C27.6953948,5.13569219 28.6162946,3.74884741 29.8098246,3.03585692 L0.142385159,3.03585692 L0.142385159,16.549707 L7.07875226,16.549707 C10.2934564,16.549707 11.7529554,14.6332189 13.8866549,12.0492806 L15.8999784,9.61097649 L12.5334959,5.77752594 C11.726073,4.59418943 13.1874752,3.36815887 14.1371606,4.44594623 L17.2483795,7.9779294 L20.1209875,4.49931378 C21.0354641,3.39164059 22.5356435,4.57118208 21.7662842,5.77942346 L18.6486421,9.56757088 L20.8051797,12.0153626 L19.4463112,13.6197098 L17.2997653,11.2058361 L15.5095892,13.3813347 C14.6310351,14.4484486 13.7415376,15.8094397 12.5646605,16.549707 L41.9523328,16.549707 L41.9523328,3.03585692 L35.3028697,3.03585692 Z",
                id: "Fill-8",
                fill: primary
            })))));
        }, _fundingLogos[constants.h.MERCADOPAGO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MERCADOPAGO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " mercadopago logo available");
            var _MERCADOPAGO_LOGO_COL2 = MERCADOPAGO_LOGO_COLORS[logoColor], primary = _MERCADOPAGO_LOGO_COL2.primary, secondary = _MERCADOPAGO_LOGO_COL2.secondary, tertiary = _MERCADOPAGO_LOGO_COL2.tertiary, quaternary = _MERCADOPAGO_LOGO_COL2.quaternary;
            return Object(jsx.c)("svg", {
                width: "98px",
                height: "26px",
                viewBox: "0 0 98 26",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("title", null, "MercadoPago"), Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "MERCADO-PAGO-SPEC",
                transform: "translate(-1451.000000, -108.000000)"
            }, Object(jsx.c)("g", {
                id: "BTN_OXXO_SILVER",
                transform: "translate(1340.000000, 97.000000)"
            }, Object(jsx.c)("g", {
                id: "LOGO_MERCADOPAGO_2_26",
                transform: "translate(111.000000, 11.000000)"
            }, Object(jsx.c)("path", {
                d: "M35.6856062,11.9270732 C35.6856062,5.49784553 27.6975208,0.257102279 17.8434328,0.257102279 C7.98985878,0.257102279 0.00203049886,5.49784553 0.00203049886,11.9270732 C0.00203049886,12.0931114 -2.57025172e-05,12.5521584 -2.57025172e-05,12.6102461 C-2.57025172e-05,19.430666 6.98180606,24.954908 17.8411196,24.954908 C28.7677737,24.954908 35.6856062,19.4322082 35.6856062,12.6115312 L35.6856062,11.9270732 Z",
                id: "background_border",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M35.0023818,11.9212901 C35.0023818,17.9824577 27.3216986,22.8960079 17.8467227,22.8960079 C8.37200381,22.8960079 0.691577629,17.9824577 0.691577629,11.9212901 C0.691577629,5.85960846 8.37200381,0.946058252 17.8467227,0.946058252 C27.3216986,0.946058252 35.0023818,5.85960846 35.0023818,11.9212901",
                id: "background",
                fill: quaternary
            }), Object(jsx.c)("path", {
                d: "M12.1504795,8.4587241 C12.1414836,8.47594479 11.9703048,8.65303513 12.0810827,8.79542708 C12.3519872,9.14112593 13.1880901,9.33954936 14.0337029,9.14986479 C14.5372152,9.03677371 15.1826054,8.52349444 15.8076906,8.02743586 C16.485209,7.48922515 17.1573298,6.95024337 17.833049,6.73588438 C18.548607,6.50816007 19.0068829,6.60582964 19.3096586,6.6973306 C19.6419921,6.79654232 20.0326704,7.01527074 20.6559564,7.48279952 C21.8297904,8.36542396 26.5498006,12.4852804 27.3653415,13.1977542 C28.0222978,12.9008901 30.9413327,11.6442941 34.9082592,10.7698944 C34.5635885,8.65509133 33.2771775,6.72020584 31.3260994,5.13590268 C28.6070301,6.27812254 25.2839517,6.87390689 22.0343824,5.28677646 C22.0179328,5.2800938 20.2591096,4.4478463 18.5244467,4.4887133 C15.9462272,4.54834314 14.8291958,5.66434643 13.647137,6.84563412 L12.1504795,8.4587241 Z",
                id: "righthand",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M27.1736521,13.645672 C27.1183917,13.5965802 21.6237076,8.78866731 20.3786777,7.85283866 C19.6584931,7.31257175 19.2577909,7.17480626 18.8370407,7.121088 C18.6180552,7.09281523 18.3155366,7.13342521 18.1040049,7.1915129 C17.5249272,7.34906933 16.7679881,7.85540892 16.0953532,8.3882221 C15.399329,8.94262539 14.7431438,9.46464351 14.1345082,9.60112388 C13.3562359,9.77538695 12.4062709,9.56976681 11.9726694,9.27650109 C11.7971212,9.15852654 11.6734921,9.02204617 11.6141193,8.88325258 C11.4539926,8.5118512 11.7493146,8.21498713 11.7978923,8.16538127 L13.3140838,6.52530365 C13.4904031,6.34924141 13.6680075,6.17343619 13.8494672,5.9999442 C13.3603483,6.06368644 12.907984,6.18860068 12.4676999,6.31120168 C11.9181801,6.46567381 11.3899934,6.61269221 10.855381,6.61243519 C10.6322832,6.61243519 9.43634504,6.41632498 9.20939182,6.35463894 C7.83739145,5.97912516 6.6329715,5.61337834 4.83405232,4.77342008 C2.67838221,6.37828525 1.23698504,8.38462374 0.820604265,10.5947832 C1.1303196,10.6765172 1.62920546,10.8250777 1.838938,10.8715993 C6.71701873,11.9562455 8.23629452,13.0735339 8.51208253,13.3069128 C8.81048875,12.9748363 9.24074889,12.7645897 9.72138596,12.7645897 C10.2611388,12.7653608 10.7474304,13.0365223 11.0430094,13.4557304 C11.3223958,13.2349458 11.7076765,13.0465463 12.2057913,13.0468033 C12.4319734,13.0468033 12.6666374,13.0886984 12.9033576,13.1691473 C13.4539055,13.3580608 13.7379183,13.7245787 13.8851937,14.0561412 C14.0699948,13.972608 14.296691,13.911179 14.5639972,13.9119501 C14.8266769,13.9119501 15.0998947,13.9720939 15.3754257,14.0908396 C16.2747568,14.4768914 16.4148355,15.3602869 16.3331015,16.0264961 C16.3971007,16.0187854 16.4616141,16.0159581 16.5271555,16.0159581 C17.5935529,16.0167292 18.4610129,16.8834181 18.4604988,17.9503296 C18.4604988,18.2803499 18.3759375,18.5908363 18.2291762,18.86354 C18.5193576,19.026751 19.259076,19.3955821 19.9083216,19.313334 C20.4272554,19.2480496 20.6243937,19.0704453 20.6948186,18.9709765 C20.7428823,18.9020938 20.7942874,18.8221589 20.7467377,18.7645853 L19.3703679,17.2355426 C19.3703679,17.2355426 19.1436717,17.0211836 19.2184661,16.9386785 C19.2963447,16.8536031 19.4361664,16.9754331 19.5351211,17.0581952 C20.2357717,17.6434415 21.0911515,18.5260659 21.0911515,18.5260659 C21.1055449,18.5355759 21.1620904,18.6476388 21.4784884,18.7044414 C21.750678,18.7530192 22.2323432,18.7247464 22.5662189,18.4505005 C22.6505232,18.3813608 22.7345704,18.2950003 22.8049953,18.2058126 C22.7993407,18.210182 22.7949713,18.2160936 22.7895738,18.2181498 C23.1414412,17.7678417 22.750763,17.3121361 22.750763,17.3121361 L21.1438416,15.5075623 C21.1438416,15.5075623 20.9140611,15.2952595 20.9919397,15.2096702 C21.0621076,15.1356469 21.2098971,15.2474529 21.3103939,15.3312431 C21.8193038,15.7566197 22.5382032,16.4780894 23.2272877,17.1530375 C23.3617118,17.2512211 23.9672631,17.6259638 24.7691817,17.0993192 C25.2554733,16.7800939 25.3533999,16.3881306 25.3395205,16.0922946 C25.3055932,15.7005882 25.0002473,15.4217159 25.0002473,15.4217159 L22.8049953,13.2148978 C22.8049953,13.2148978 22.5734156,13.0169884 22.6551496,12.9167486 C22.7222332,12.8324443 22.8728499,12.9540172 22.9712906,13.0365223 C23.6709131,13.6215116 25.5636465,15.3569456 25.5636465,15.3569456 C25.5906341,15.3759654 26.2447632,15.841695 27.0528503,15.3271307 C27.3417466,15.1423296 27.5265477,14.8637143 27.5424833,14.5403766 C27.569985,13.9790336 27.1736521,13.645672 27.1736521,13.645672",
                id: "lefthand",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M16.5269242,16.4433139 C16.1866228,16.4392015 15.8144504,16.6414803 15.7656156,16.6119224 C15.738885,16.5941876 15.7864346,16.4574503 15.8183058,16.3785435 C15.850948,16.3001508 16.2991999,14.9515398 15.2065858,14.4832399 C14.370483,14.1239187 13.8595169,14.5282193 13.6837117,14.7107072 C13.6377042,14.7582568 13.6171422,14.7546585 13.6117447,14.6934865 C13.595038,14.4508547 13.4863164,13.7936414 12.7645897,13.5736278 C11.7334047,13.2577439 11.0702798,13.9776714 10.9019283,14.2375238 C10.8266199,13.6497073 10.3297902,13.1932306 9.72115464,13.1929727 C9.05957184,13.1922025 8.52316031,13.7281 8.52238914,14.3891687 C8.52213221,15.0502374 9.05828672,15.5863919 9.71961249,15.5863919 C10.041151,15.587163 10.3323605,15.4586504 10.5472335,15.2522592 C10.5541732,15.2586849 10.5567435,15.269994 10.5534021,15.2926122 C10.5030252,15.5887052 10.4102391,16.6646125 11.5370375,17.1025834 C11.9888877,17.2781316 12.3731404,17.1475628 12.6915945,16.924208 C12.7864368,16.8571244 12.8021154,16.8856542 12.788493,16.9745849 C12.7478831,17.251401 12.7992881,17.843844 13.6299934,18.180804 C14.2617613,18.4375722 14.63599,18.1746354 14.880935,17.9481962 C14.9876004,17.8510407 15.0166442,17.8667193 15.0222988,18.017079 C15.0523707,18.8177124 15.7175519,19.4535927 16.525125,19.4543644 C17.3573725,19.4551348 18.0318065,18.7822429 18.0320642,17.9502524 C18.0328346,17.1180049 17.3589146,16.4523097 16.5269242,16.4433139",
                id: "fingers",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M16.5269242,19.3471586 C15.7725553,19.3463875 15.1595502,18.7603701 15.1317915,18.0134549 C15.1297353,17.9494557 15.1233097,17.779048 14.9793756,17.779048 C14.9200028,17.779048 14.8685977,17.8147745 14.8092249,17.8682357 C14.6437007,18.0219368 14.432426,18.1782081 14.1237388,18.1782081 C13.9839171,18.1782081 13.8322723,18.1455659 13.6721456,18.0800245 C12.8756246,17.7574579 12.8645725,17.2105083 12.8969577,16.9904948 C12.9056965,16.931893 12.9087808,16.870721 12.8684279,16.8234284 L12.8193361,16.7794771 L12.7697302,16.7794771 C12.7293772,16.7794771 12.6874821,16.7959267 12.6311936,16.8357656 C12.4006421,16.9974344 12.1798574,17.0760841 11.9552174,17.0760841 C11.8313313,17.0760841 11.7046179,17.0511527 11.5776475,17.0023179 C10.5289848,16.5941619 10.6117469,15.604358 10.6631519,15.3064658 C10.6706056,15.2463219 10.6556982,15.1992863 10.6174014,15.1681863 L10.5433782,15.1072713 L10.4739814,15.1735838 C10.2693893,15.3704651 10.0023402,15.4784157 9.72115464,15.4784157 C9.12074384,15.4776446 8.63188196,14.9898108 8.6323956,14.389143 C8.63291006,13.7882181 9.12202896,13.3006414 9.72269679,13.3014116 C10.2655339,13.3014116 10.7276652,13.7093114 10.796805,14.2516345 L10.8343307,14.5441292 L10.9949714,14.2966139 C11.0129631,14.2675701 11.4529902,13.6021319 12.2618485,13.602903 C12.4158065,13.602903 12.5746481,13.6278344 12.7345177,13.6771833 C13.3796509,13.8740645 13.4888866,14.4587968 13.5055933,14.7024567 C13.5171594,14.8443346 13.6181703,14.8512743 13.6379612,14.8512743 C13.6937357,14.8512743 13.7346027,14.8158048 13.7636465,14.7854758 C13.8854765,14.6585054 14.1504694,14.4472307 14.565308,14.4472307 C14.7549926,14.4477447 14.9572714,14.4927241 15.1657188,14.5824259 C16.1904782,15.022196 15.7257767,16.3245425 15.7201221,16.3381649 C15.6322195,16.554066 15.6286212,16.6494224 15.7113833,16.7044257 L15.7517362,16.7237026 L15.7818082,16.7237026 C15.8278157,16.7237026 15.8853893,16.7036547 15.9802316,16.6715265 C16.1197963,16.6232058 16.3302999,16.5507247 16.5271812,16.5512387 L16.5276952,16.5512387 C17.2992848,16.5594635 17.9266832,17.1876331 17.9264263,17.9502267 C17.9256551,18.7207882 17.2979997,19.3471586 16.5269242,19.3471586 M27.3862377,13.0700898 C25.6937269,11.5929662 21.7818038,8.19226611 20.722346,7.39703022 C20.1173088,6.94158162 19.7042693,6.70126308 19.3418638,6.59331251 C19.1791669,6.54396368 18.9537558,6.48818922 18.6635744,6.48793219 C18.3944691,6.48793219 18.1050587,6.53650995 17.8027971,6.63263736 C17.1180821,6.84930958 16.4359372,7.39137567 15.7761536,7.91570702 L15.7422263,7.94269466 C15.1276791,8.43104249 14.4925699,8.936611 14.0119329,9.04404752 C13.8019433,9.09134016 13.5862992,9.11550052 13.3711691,9.11550052 C12.8327014,9.11472945 12.34898,8.95948624 12.1677772,8.72842061 C12.1379623,8.69012386 12.1569822,8.6281808 12.2271501,8.53899306 L12.236403,8.5271699 L13.7253498,6.92256176 C14.891473,5.75643855 15.9930829,4.65534272 18.5286362,4.596998 C18.5702743,4.59571288 18.6131975,4.5949418 18.6550926,4.5949418 C20.2334842,4.5959699 21.8113617,5.3025321 21.988195,5.38452313 C23.4681459,6.10624981 24.9953895,6.47302473 26.5311149,6.47430986 C28.1313536,6.47482391 29.7824833,6.07874812 31.5184313,5.27939984 C31.3246344,5.11618885 31.1228696,4.95760432 30.9151933,4.80184707 C29.3902629,5.46291581 27.9372996,5.79704853 26.5352273,5.79653448 C25.1035971,5.79524935 23.672995,5.4516067 22.284031,4.77383132 C22.2107788,4.7388759 20.4686622,3.91742345 18.6558637,3.91665238 C18.608571,3.91665238 18.5602503,3.91742345 18.5129577,3.91819453 C16.3829901,3.96805741 15.1831966,4.72422546 14.3766516,5.38709338 C13.5919537,5.40611324 12.9149494,5.59528377 12.3127394,5.76337823 C11.7752998,5.91270986 11.3111123,6.04225054 10.858234,6.04199352 C10.6718907,6.04199352 10.3362159,6.02502986 10.3061439,6.02400176 C9.78541093,6.00832322 7.16272608,5.36498922 5.07645276,4.57489384 C4.86337889,4.72576762 4.65852983,4.88152487 4.4590783,5.0401094 C6.63839473,5.9335289 9.2908945,6.62492661 10.1280255,6.67890189 C10.3608903,6.69406638 10.6091766,6.72053997 10.8572059,6.72105402 C11.4110951,6.72105402 11.9636993,6.56555379 12.4985686,6.41596514 C12.8144526,6.32729146 13.1629787,6.23090702 13.5297536,6.16048212 C13.431827,6.25660954 13.3341575,6.35402208 13.2362309,6.45220569 L11.7233807,8.08868496 C11.6043781,8.20897274 11.3458107,8.52974016 11.5162184,8.92478784 C11.5840731,9.08414345 11.7215815,9.23655938 11.9140934,9.36635709 C12.2744427,9.60898885 12.9200899,9.77322794 13.5197296,9.77374199 C13.7469399,9.77399901 13.96207,9.75112377 14.1602364,9.70665842 C14.7943175,9.56426647 15.4594986,9.03453759 16.1642616,8.47422272 C16.7256046,8.02828405 17.5234107,7.46180057 18.1341026,7.29524826 C18.3047673,7.24898373 18.5142428,7.21993988 18.6828513,7.21993988 C18.7332282,7.22045393 18.7807779,7.22199608 18.8247292,7.22842171 C19.2285157,7.27956972 19.6184229,7.41682116 20.3149611,7.93961036 C21.5566497,8.87235471 27.0521049,13.6797535 27.1058232,13.7273032 C27.1096786,13.7301305 27.4600039,14.0323921 27.4355865,14.5348763 C27.4227352,14.8150337 27.266978,15.0640911 26.9965875,15.236555 C26.7621805,15.3853726 26.5200628,15.461195 26.2753749,15.461195 C25.9080859,15.4604239 25.6551731,15.2884741 25.6387235,15.2766509 C25.6184185,15.2602013 23.7357091,13.5337632 23.0432833,12.9539144 C22.9327625,12.8626705 22.825583,12.7801654 22.7171184,12.7801654 C22.6590307,12.7796514 22.6078827,12.8045828 22.5731843,12.8480201 C22.4642056,12.9821872 22.5862926,13.1682734 22.7302267,13.2908744 L24.929334,15.5012909 C24.9324183,15.5036041 25.2035799,15.757802 25.2331378,16.0968182 C25.2503585,16.4633361 25.0753243,16.7699672 24.7111197,17.0084865 C24.4515242,17.1794083 24.1888445,17.2662828 23.9315623,17.2662828 C23.5938312,17.2662828 23.356597,17.1125817 23.3041639,17.0760841 L22.988794,16.7650837 C22.4120295,16.1978291 21.8167592,15.6112977 21.3811015,15.2476071 C21.2749502,15.1591904 21.161088,15.0777134 21.0531374,15.0777134 C20.9996762,15.0777134 20.9516125,15.0975044 20.9146009,15.1363152 C20.864995,15.1915756 20.8302966,15.2910443 20.9541827,15.4555404 C21.0053307,15.5233951 21.0652176,15.5794266 21.0652176,15.5794266 L22.6700828,17.3819441 C22.6834481,17.3981367 23.0008742,17.7754496 22.7063233,18.1512204 L22.6495208,18.2231875 C22.6017141,18.2761347 22.549795,18.3247124 22.5004462,18.3671216 C22.2267144,18.5917616 21.8609675,18.6156649 21.7160053,18.6156649 C21.6388978,18.6156649 21.5641035,18.6089823 21.4993331,18.5971591 C21.3407486,18.5688863 21.2343402,18.524678 21.1829351,18.463763 L21.1636583,18.4434581 C21.0757556,18.3529852 20.2668974,17.5271633 19.5973469,16.9683906 C19.5094442,16.8943673 19.3994375,16.8013242 19.2853183,16.8013242 C19.2292868,16.8013242 19.1791669,16.8234284 19.1406131,16.8660946 C19.0079881,17.0110568 19.2069256,17.227986 19.2912299,17.3074068 L20.6601459,18.8169156 C20.6586038,18.8302809 20.6413831,18.861381 20.6082269,18.9091877 C20.559135,18.9770423 20.3930968,19.1430806 19.8965242,19.2052807 C19.8371513,19.2132484 19.7757223,19.2163327 19.7148074,19.2163327 C19.2028132,19.2163327 18.6566347,18.9677894 18.3751922,18.8184578 C18.5031907,18.5480673 18.5697602,18.2499181 18.5697602,17.9509978 C18.5702743,16.8244565 17.6555217,15.9079047 16.5289804,15.9071337 C16.50482,15.9071337 16.4791175,15.9079047 16.4552141,15.9086758 C16.4919687,15.3943684 16.4192306,14.420243 15.4194027,13.9915251 C15.1317915,13.8671249 14.8446944,13.8036397 14.5658221,13.8036397 C14.3476077,13.8036397 14.1376182,13.8409083 13.9402228,13.9167307 C13.7330605,13.5142293 13.3891609,13.2209636 12.9403949,13.0680336 C12.6926226,12.9821872 12.4458785,12.9387499 12.2073591,12.9387499 C11.7914924,12.9387499 11.4082679,13.061351 11.0664244,13.3044968 C10.7387173,12.8971119 10.2442009,12.6560223 9.72295381,12.6560223 C9.26724818,12.6560223 8.82876324,12.8385101 8.5036264,13.1603056 C8.07773569,12.8349118 6.38753816,11.7610606 1.86389514,10.733988 C1.64490969,10.6846392 1.14216846,10.540191 0.833995277,10.4502322 C0.783104293,10.6951772 0.744036467,10.9426925 0.71833395,11.1922639 C0.71833395,11.1922639 1.55263766,11.3922295 1.71687674,11.4289841 C6.3379323,12.4555426 7.86491885,13.5227111 8.12297212,13.7244759 C8.03558356,13.9342084 7.99009011,14.1609046 7.98957605,14.389143 C7.989062,15.3437345 8.76553505,16.1212356 9.72115464,16.1220067 C9.82807711,16.1220067 9.9342285,16.1127538 10.0385807,16.0934769 C10.1822578,16.7959267 10.6420758,17.3284829 11.3447826,17.6019576 C11.5501458,17.6808644 11.7578221,17.7214743 11.9616431,17.7214743 C12.093754,17.7217314 12.226379,17.7050247 12.3559197,17.6718685 C12.4854604,18.0016318 12.777698,18.412358 13.4302849,18.677608 C13.6592943,18.769623 13.8880467,18.8176867 14.1106305,18.8176867 C14.2923473,18.8176867 14.4699517,18.7858156 14.6393313,18.7236155 C14.9521309,19.4854381 15.6967329,19.9902375 16.5264101,19.9902375 C17.076444,19.9910066 17.6043737,19.7668807 17.9893974,19.3705478 C18.3194177,19.5538068 19.0151848,19.8853693 19.7181487,19.8863974 C19.8093926,19.8863974 19.894725,19.8797147 19.9800573,19.8696907 C20.6781377,19.7812741 21.0032745,19.5083133 21.1526062,19.2960105 C21.1795938,19.2589989 21.2037542,19.2196741 21.2243162,19.1788071 C21.3893264,19.2260997 21.5705291,19.2649105 21.7782054,19.2654245 C22.1596308,19.2654245 22.5256346,19.1353698 22.8954939,18.8657504 C23.2589275,18.6035847 23.5172377,18.2275569 23.5545064,17.9070465 C23.5552775,17.9029341 23.5560485,17.8980506 23.5565626,17.8934242 C23.6789066,17.9186126 23.8045919,17.9317209 23.9302772,17.9317209 C24.3227546,17.9317209 24.7090635,17.809377 25.0781516,17.5675163 C25.7898543,17.1007586 25.9137404,16.4913519 25.9019173,16.0921918 C26.0263175,16.1181513 26.1535449,16.1315166 26.2800013,16.1315166 C26.6488324,16.1315166 27.0104669,16.0207388 27.3556517,15.8007252 C27.7969639,15.5187686 28.0624709,15.0869663 28.1025668,14.5844821 C28.1303255,14.2428957 28.0455072,13.8982249 27.8653326,13.6018749 C29.0581864,13.0880816 31.7839383,12.0936512 34.9939257,11.3703824 C34.9743918,11.121325 34.9386653,10.8756089 34.8941999,10.6309209 C31.0102926,11.4927263 28.1120767,12.7470092 27.3862377,13.0700898",
                id: "handoutline",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M82.5260533,20.2673344 C82.2142818,20.68243 81.766544,20.8898493 81.1830968,20.8898493 C80.5993927,20.8898493 80.1495986,20.68243 79.8357709,20.2673344 C79.5196299,19.8535238 79.3628446,19.2636511 79.3628446,18.4995152 C79.3628446,17.7356364 79.5196299,17.1470488 79.8357709,16.7352945 C80.1495986,16.321998 80.5993927,16.1168919 81.1830968,16.1168919 C81.766544,16.1168919 82.2142818,16.321998 82.5260533,16.7352945 C82.839367,17.1470488 82.9948673,17.7356364 82.9948673,18.4995152 C82.9948673,19.2636511 82.839367,19.8535238 82.5260533,20.2673344 M84.1229507,15.6398532 C83.4778176,14.8322801 82.4998368,14.4295216 81.1882373,14.4295216 C79.8789511,14.4295216 78.9007133,14.8322801 78.2566082,15.6398532 C77.6119891,16.4461411 77.2901936,17.3989335 77.2901936,18.4995152 C77.2901936,19.6188599 77.6119891,20.5749935 78.2566082,21.3715145 C78.9007133,22.1646942 79.8789511,22.5630832 81.1882373,22.5630832 C82.4998368,22.5630832 83.4778176,22.1646942 84.1229507,21.3715145 C84.7665418,20.5749935 85.0873092,19.6188599 85.0873092,18.4995152 C85.0873092,17.3989335 84.7665418,16.4461411 84.1229507,15.6398532",
                id: "pago_o",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M71.2460667,18.5582712 C71.2460667,19.8971153 71.6331467,20.639147 72.4067924,20.7859084 C73.178896,20.9290714 73.750006,20.7496678 74.117552,20.2458985 C74.291815,20.0338527 74.4167293,19.6979208 74.4940938,19.2427292 C74.5709444,18.7870236 74.5768559,18.3354304 74.5090013,17.8892347 C74.4424318,17.4417538 74.281791,17.0438789 74.0301634,16.6945817 C73.7795639,16.3460555 73.4117608,16.1705074 72.9282965,16.1705074 C72.2705691,16.1705074 71.8269436,16.4141672 71.5943359,16.8973745 C71.360957,17.3836662 71.2460667,17.9365273 71.2460667,18.5582712 M74.5526956,21.905253 L74.5526956,21.4122787 C74.2049405,21.956658 73.7350985,22.293875 73.1457398,22.4308695 C72.555353,22.5658077 71.9708777,22.5174869 71.392057,22.2841081 C70.8114372,22.0522714 70.3128083,21.619955 69.8966846,20.9899863 C69.482103,20.3571904 69.2741696,19.5275131 69.2741696,18.4988984 C69.2741696,17.2970487 69.5497006,16.3206101 70.0999915,15.5736949 C70.6515675,14.8267798 71.5367622,14.4859644 72.7545475,14.4525511 C73.954855,14.420937 74.6526784,14.6926126 75.3358513,15.2100043 C76.0827664,15.7770018 76.5246005,16.646775 76.5246005,18.0043819 L76.5246005,22.1108731 C76.527677,23.4175891 75.6165228,25.8392803 72.7545475,25.6339171 C70.9815878,25.5054046 69.9976955,24.7780233 69.4484327,23.1299779 L71.565292,23.1299779 C71.7200212,23.4008825 71.9564843,23.6095869 72.2772517,23.754035 C72.5944208,23.9015675 72.9151882,23.9393502 73.2321002,23.8712385 C73.5508115,23.8033839 73.8415069,23.6134423 74.1039296,23.304241 C74.3635251,22.9934976 74.5131137,22.5269969 74.5526956,21.905253",
                id: "pago_g",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M66.540784,19.3679776 C66.5281898,20.0380422 66.335935,20.4981173 65.9678749,20.7515441 C65.6000719,21.0039428 65.1973135,21.1303992 64.7606277,21.1303992 C64.4840686,21.1303992 64.2501757,21.0540627 64.0579209,20.9024179 C63.865152,20.750516 63.7687676,20.5027437 63.7687676,20.1609002 C63.7687676,19.7779327 63.926324,19.494434 64.2416939,19.3114321 C64.4293223,19.2042526 64.7346682,19.1122375 65.161844,19.0392424 L65.6175496,18.9544241 C65.8455309,18.9112439 66.0241634,18.8657504 66.1531901,18.8161445 C66.2858151,18.7680808 66.4132996,18.7043386 66.540784,18.6236327 L66.540784,19.3679776 Z M67.5562905,15.0065175 C66.9026755,14.6762401 66.1552463,14.5089167 65.314774,14.5089167 C64.0206522,14.5089167 63.1089839,14.8461337 62.5774559,15.5192827 C62.2440942,15.9503139 62.0559518,16.5003478 62.0127716,17.1701554 L63.9453439,17.1701554 C63.9926365,16.8745764 64.0869647,16.6406835 64.2301277,16.4679626 C64.4293223,16.2340697 64.7683406,16.1168662 65.2461482,16.1168662 C65.6753803,16.1168662 65.9982039,16.175725 66.2189885,16.2960127 C66.4390021,16.4155294 66.5497799,16.6316876 66.5497799,16.9455154 C66.5497799,17.2030546 66.4063599,17.3924821 66.1179776,17.5145691 C65.9578509,17.584737 65.6918299,17.6430817 65.3178583,17.6901173 L64.6331432,17.7736505 C63.8556421,17.8720911 63.2647412,18.0368442 62.8655811,18.2661107 C62.1333164,18.6873749 61.7683406,19.3679776 61.7683406,20.3086897 C61.7683406,21.0337577 61.9942658,21.5951007 62.4499714,21.9904054 C62.9028498,22.3857101 63.4801283,22.5525195 64.1769235,22.5846476 C68.5442952,22.7797297 68.4954605,20.2822161 68.5352994,19.7630253 L68.5352994,16.8887128 C68.5352994,15.9667635 68.2093915,15.3398791 67.5562905,15.0065175 L67.5562905,15.0065175 Z",
                id: "pago_a",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M59.2065451,18.5572688 C59.2065451,17.7998156 59.0590126,17.2176536 58.7626626,16.8089836 C58.4675977,16.4026268 58.0445343,16.1967496 57.4932153,16.1967496 C56.9622013,16.1967496 56.5483907,16.4026268 56.2517837,16.8089836 C55.9772808,17.1785858 55.8400294,17.762804 55.8400294,18.5572688 C55.8400294,19.2977583 55.9873048,19.8488203 56.2828837,20.2184225 C56.5774346,20.6270925 57.0012691,20.8306564 57.5523311,20.8306564 C58.0635541,20.8306564 58.4675977,20.6270925 58.7626626,20.2184225 C59.0590126,19.8105235 59.2065451,19.2586905 59.2065451,18.5572688 L59.2065451,18.5572688 Z M55.8400294,23.9923231 C55.8400294,24.2642557 55.7413317,24.4976346 55.5434223,24.6914315 C55.3475691,24.8859996 55.111106,24.9831551 54.8350609,24.9831551 L53.8321487,24.9831551 L53.8321487,18.0031225 C53.8321487,16.6457726 54.2893965,15.7955333 55.0424803,15.2210821 C55.539824,14.8411989 56.2813416,14.4787934 57.6703056,14.4787934 C58.6081905,14.4787934 59.706459,14.842741 60.2999301,15.5660098 C60.9656253,16.3794945 61.2432125,17.2860223 61.2432125,18.4698802 C61.2432125,19.6946052 60.9478906,20.6826099 60.3577608,21.4421193 C59.767374,22.1810667 59.0086357,22.5488697 58.0836021,22.5488697 C57.5916559,22.5488697 57.1588255,22.4612241 56.7848539,22.2877321 C56.3898062,22.0929071 56.0764925,21.7921876 55.8400294,21.3837746 L55.8400294,23.9923231 Z",
                id: "pago_p",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M94.8863424,9.12010127 C94.5735428,9.5349399 94.1268331,9.74235921 93.5423578,9.74235921 C92.9591677,9.74235921 92.5098877,9.5349399 92.1950319,9.12010127 C91.879919,8.7057767 91.7226196,8.1156469 91.7226196,7.35099702 C91.7226196,6.58737523 91.879919,5.99878759 92.1950319,5.58651921 C92.5098877,5.17399381 92.9591677,4.96785962 93.5423578,4.96785962 C94.1268331,4.96785962 94.5735428,5.17399381 94.8863424,5.58651921 C95.198628,5.99878759 95.3551564,6.58737523 95.3551564,7.35099702 C95.3551564,8.1156469 95.198628,8.7057767 94.8863424,9.12010127 M96.4822117,4.49133496 C95.8381067,3.68427592 94.8606399,3.28100342 93.5485264,3.28100342 C92.2382121,3.28100342 91.2604883,3.68427592 90.6168973,4.49133496 C89.9722782,5.29787995 89.6499686,6.25118631 89.6499686,7.35099702 C89.6499686,8.47059866 89.9722782,9.42724635 90.6168973,10.2237674 C91.2604883,11.0174611 92.2382121,11.4158501 93.5485264,11.4158501 C94.8606399,11.4158501 95.8381067,11.0174611 96.4822117,10.2237674 C97.1268309,9.42724635 97.4481123,8.47059866 97.4481123,7.35099702 C97.4481123,6.25118631 97.1268309,5.29787995 96.4822117,4.49133496",
                id: "mercado_o",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M86.6429797,9.1366794 C86.349714,9.55717258 85.9191969,9.76690512 85.3552836,9.76690512 C84.7895712,9.76690512 84.368821,9.55511638 84.0917479,9.13308104 C83.8146747,8.71027464 83.6761382,8.09469935 83.6761382,7.39045038 C83.6761382,6.73683537 83.8115904,6.18962878 84.0848082,5.74857358 C84.3572549,5.30803244 84.7849448,5.08673377 85.368906,5.08673377 C85.7518735,5.08673377 86.0872913,5.20830667 86.3774727,5.45068141 C86.8488569,5.85241175 87.084292,6.57259628 87.084292,7.50534063 C87.084292,8.172835 86.9372736,8.71644324 86.6429797,9.1366794 L86.6429797,9.1366794 Z M89.0525907,0.930636741 C89.0525907,0.930636741 87.0290315,0.714478572 87.0290315,2.33990576 L87.0274894,4.49172049 C86.8036205,4.13214228 86.5124109,3.85095674 86.1530898,3.64842091 C85.7945396,3.44562805 85.3840704,3.34333203 84.9206541,3.34333203 C83.9172278,3.34333203 83.1173655,3.71730365 82.5169547,4.46344773 C81.9165439,5.21087692 81.6178806,6.28729834 81.6178806,7.58913084 C81.6178806,8.71849944 81.9221984,9.64481816 82.531091,10.3657738 C83.1399837,11.0859583 84.3343796,11.4020993 85.3951225,11.4020993 C89.0937147,11.4020993 89.0510486,8.23040864 89.0510486,8.23040864 L89.0525907,0.930636741 Z",
                id: "mercado_d",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M79.0090237,8.17810402 C78.9954014,8.84739757 78.8036606,9.30850072 78.4353435,9.56141349 C78.0667694,9.81432626 77.664268,9.94103967 77.2278393,9.94103967 C76.9512802,9.94103967 76.7173873,9.86444617 76.5246184,9.71254429 C76.3323636,9.56038539 76.2364932,9.31312718 76.2364932,8.9712837 C76.2364932,8.58780214 76.3935356,8.30481743 76.7083914,8.12181551 C76.8960198,8.01463601 77.2018797,7.92236397 77.6290556,7.8491118 L78.0852752,7.76455052 C78.3122285,7.72137029 78.490861,7.67536278 78.6214297,7.62601395 C78.7535407,7.57795024 78.8810252,7.51446503 79.0090237,7.43375912 L79.0090237,8.17810402 Z M80.0235021,3.81664388 C79.3704011,3.48533843 78.6229719,3.31827207 77.7817285,3.31827207 C76.4888919,3.31827207 75.5764525,3.65600315 75.0451815,4.32915207 C74.7107918,4.76069734 74.5236774,5.31047418 74.4799832,5.97976773 L76.4117843,5.97976773 C76.459334,5.6844458 76.5541763,5.4505529 76.6968253,5.27757496 C76.8960198,5.04368205 77.2345219,4.9267356 77.7133598,4.9267356 C78.1415638,4.9267356 78.4649014,4.98533734 78.6862001,5.10613917 C78.9062136,5.22514182 79.0169915,5.44181404 79.0169915,5.7548707 C79.0169915,6.01292397 78.8740855,6.20183747 78.5854462,6.32418146 C78.4248055,6.39460635 78.1585274,6.45295107 77.7850698,6.49972965 L77.1003548,6.5840339 C76.3223396,6.68196049 75.7319528,6.8464566 75.3317646,7.07623711 C74.600528,7.49775839 74.2350382,8.17810402 74.2350382,9.1193302 C74.2350382,9.84414118 74.4614773,10.4054842 74.9166689,10.8010459 C75.3700613,11.1966076 75.9473399,11.3626459 76.6441351,11.3950311 C81.0125349,11.5898561 80.9634431,9.0928566 81.003539,8.57340873 L81.003539,5.69883921 C81.003539,4.77740397 80.676089,4.14923445 80.0235021,3.81664388 L80.0235021,3.81664388 Z",
                id: "mercado_a",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M70.0623373,5.03054806 C70.5617372,5.03054806 70.9282551,5.18476317 71.1652323,5.49293635 C71.3279293,5.7211747 71.4291972,5.9784569 71.4690361,6.26349781 L73.6234211,6.26349781 C73.5054465,5.17628134 73.1250493,4.417286 72.4830004,3.98728289 C71.8383813,3.55907896 71.0130734,3.34343484 70.0039926,3.34343484 C68.8173074,3.34343484 67.8850771,3.70815356 67.2119282,4.43579182 C66.536723,5.16445818 66.199506,6.18253488 66.199506,7.49156408 C66.199506,8.65074761 66.5045949,9.59557214 67.1150297,10.3237244 C67.7259785,11.0513627 68.6787708,11.4158244 69.9728926,11.4158244 C71.2690705,11.4158244 72.2475653,10.9793957 72.9065779,10.1062812 C73.3203884,9.56550019 73.5522251,8.99104893 73.6010599,8.38395548 L71.4533575,8.38395548 C71.4096633,8.78517177 71.284235,9.11262184 71.0763016,9.36450651 C70.8691393,9.6156201 70.5200991,9.74233351 70.0260968,9.74233351 C69.3303296,9.74233351 68.8571463,9.42542147 68.6055186,8.7895412 C68.4680102,8.450525 68.3980993,8.00150202 68.3980993,7.4427293 C68.3980993,6.85645488 68.4680102,6.38661287 68.6055186,6.03166111 C68.8671703,5.36493781 69.3529478,5.03054806 70.0623373,5.03054806",
                id: "mercado_c",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M65.6216363,3.34333203 C61.1954058,3.34333203 61.4570575,7.26270887 61.4570575,7.26270887 L61.4570575,11.2437718 L63.4659662,11.2437718 L63.4659662,7.50971006 C63.4659662,6.89799015 63.5433308,6.44485477 63.6965178,6.15030393 C63.9720488,5.6282858 64.5102595,5.36612013 65.3139772,5.36612013 C65.3741211,5.36612013 65.4540559,5.36946146 65.5519825,5.37383088 C65.6496521,5.37871436 65.7606869,5.38745322 65.8886855,5.40236068 L65.8886855,3.35849651 C65.7992407,3.35232791 65.7416671,3.34975766 65.7164786,3.34744443 C65.6910331,3.34538823 65.659162,3.34333203 65.6216363,3.34333203",
                id: "mercado_r",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M55.542934,5.42361666 C55.8256617,5.13343524 56.2222515,4.98795899 56.7342456,4.98795899 C57.2051158,4.98795899 57.5991353,5.12443936 57.9178466,5.39919927 C58.2352726,5.6731881 58.412877,6.07568952 58.4486035,6.6043903 L55.01192,6.6043903 C55.08363,6.10756064 55.2612344,5.71456915 55.542934,5.42361666 L55.542934,5.42361666 Z M58.2432404,9.16384696 C58.1589362,9.28413474 58.0679493,9.38720183 57.9682235,9.46739368 C57.6844677,9.70128659 57.2989299,9.77222554 56.8450235,9.77222554 C56.4157915,9.77222554 56.0801166,9.70719817 55.7757988,9.51545739 C55.2748567,9.20754124 54.9926431,8.68603716 54.9625711,7.92087323 L60.5207405,7.92087323 C60.5281942,7.26211771 60.5071181,6.7575773 60.4539139,6.40648092 C60.3616419,5.80889739 60.158335,5.28199579 59.8465634,4.82886041 C59.4998365,4.31481007 59.0590383,3.93852522 58.5272532,3.69923478 C57.9957252,3.46225757 57.3978846,3.34274087 56.7342456,3.34274087 C55.614644,3.34274087 54.70606,3.69563643 54.0054094,4.40039945 C53.3045017,5.10670462 52.9526343,6.11912677 52.9526343,7.44100723 C52.9526343,8.85207542 53.3412563,9.87040915 54.1182434,10.4960084 C54.8939454,11.1218647 55.7909633,11.4354354 56.8059557,11.4354354 C58.0358211,11.4354354 58.9932399,11.0642911 59.6764128,10.3220024 C60.0449869,9.93132412 60.2757955,9.54475826 60.373208,9.16384696 L58.2432404,9.16384696 Z",
                id: "mercado_e",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M52.146372,11.2430778 L50.3114693,11.2430778 L50.3114693,6.6227933 C50.3114693,6.20075797 50.1719112,5.19681765 48.9615731,5.19681765 C48.1550281,5.19681765 47.5710669,5.77872264 47.5710669,6.6227933 L47.5710669,11.2430778 L45.7343651,11.2430778 L45.7343651,6.6227933 C45.7343651,6.20075797 45.6089368,5.19681765 44.3993763,5.19681765 C43.5784379,5.19681765 43.0078421,5.77872264 43.0078421,6.6227933 L43.0078421,11.2430778 L41.1719112,11.2430778 L41.1719112,6.6667446 C41.1719112,4.75910378 42.4375032,3.31667852 44.3993763,3.31667852 C45.3732447,3.31667852 46.1653963,3.72586259 46.6807318,4.38101975 C47.2227978,3.72586259 48.0293428,3.31667852 48.9615731,3.31667852 C50.9645703,3.31667852 52.146372,4.70075907 52.146372,6.6667446 L52.146372,11.2430778 Z",
                id: "mercado_m",
                fill: primary
            }))))));
        }, _fundingLogos);
        var _cardLogos;
        var cardLogos = ((_cardLogos = {})[constants.o.VISA] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(33, 86, 154);"/>\n  <path d="M19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.AMEX] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(20, 119, 190);"/>\n  <path d="M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.MASTERCARD] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(62, 57, 57);"/>\n  <path style="fill: rgb(255, 95, 0);" d="M 22.205 3.901 L 15.688 3.901 L 15.688 15.589 L 22.205 15.589"/>\n  <path d="M 16.1 9.747 C 16.1 7.371 17.218 5.265 18.935 3.901 C 17.67 2.912 16.078 2.312 14.342 2.312 C 10.223 2.312 6.892 5.636 6.892 9.746 C 6.892 13.853 10.223 17.178 14.342 17.178 C 16.078 17.178 17.67 16.58 18.935 15.588 C 17.216 14.246 16.099 12.119 16.099 9.745 Z" style="fill: rgb(235, 0, 27);"/>\n  <path d="M 30.996 9.747 C 30.996 13.854 27.663 17.179 23.547 17.179 C 21.81 17.179 20.216 16.581 18.954 15.589 C 20.691 14.227 21.788 12.12 21.788 9.746 C 21.788 7.37 20.671 5.264 18.954 3.9 C 20.216 2.911 21.81 2.311 23.547 2.311 C 27.663 2.311 30.996 5.657 30.996 9.745 Z" style="fill: rgb(247, 158, 27);"/>\n  <path d="M 7.167 22.481 L 7.167 20.43 C 7.167 19.641 6.685 19.127 5.857 19.127 C 5.443 19.127 4.993 19.262 4.683 19.71 C 4.44 19.332 4.096 19.127 3.579 19.127 C 3.233 19.127 2.888 19.23 2.612 19.607 L 2.612 19.197 L 1.886 19.197 L 1.886 22.481 L 2.612 22.481 L 2.612 20.668 C 2.612 20.086 2.921 19.812 3.406 19.812 C 3.888 19.812 4.131 20.121 4.131 20.669 L 4.131 22.481 L 4.856 22.481 L 4.856 20.668 C 4.856 20.086 5.204 19.812 5.651 19.812 C 6.137 19.812 6.377 20.121 6.377 20.669 L 6.377 22.481 L 7.171 22.481 Z M 17.909 19.197 L 16.734 19.197 L 16.734 18.204 L 16.007 18.204 L 16.007 19.197 L 15.352 19.197 L 15.352 19.845 L 16.007 19.845 L 16.007 21.351 C 16.007 22.106 16.319 22.551 17.146 22.551 C 17.459 22.551 17.804 22.449 18.044 22.309 L 17.839 21.695 C 17.632 21.831 17.389 21.867 17.216 21.867 C 16.872 21.867 16.734 21.66 16.734 21.319 L 16.734 19.847 L 17.909 19.847 L 17.909 19.198 Z M 24.053 19.127 C 23.639 19.127 23.364 19.332 23.191 19.607 L 23.191 19.197 L 22.465 19.197 L 22.465 22.481 L 23.191 22.481 L 23.191 20.633 C 23.191 20.086 23.434 19.777 23.882 19.777 C 24.018 19.777 24.192 19.812 24.33 19.847 L 24.538 19.162 C 24.401 19.127 24.192 19.127 24.052 19.127 Z M 14.765 19.469 C 14.42 19.229 13.937 19.127 13.418 19.127 C 12.588 19.127 12.036 19.538 12.036 20.188 C 12.036 20.736 12.453 21.044 13.175 21.146 L 13.524 21.181 C 13.903 21.249 14.108 21.351 14.108 21.523 C 14.108 21.765 13.832 21.934 13.35 21.934 C 12.864 21.934 12.484 21.764 12.244 21.592 L 11.898 22.139 C 12.278 22.411 12.794 22.549 13.313 22.549 C 14.28 22.549 14.831 22.105 14.831 21.488 C 14.831 20.908 14.383 20.599 13.692 20.496 L 13.348 20.462 C 13.037 20.428 12.795 20.36 12.795 20.155 C 12.795 19.914 13.038 19.777 13.418 19.777 C 13.83 19.777 14.245 19.949 14.453 20.052 L 14.764 19.469 Z M 34.033 19.127 C 33.618 19.127 33.342 19.332 33.171 19.607 L 33.171 19.197 L 32.445 19.197 L 32.445 22.481 L 33.171 22.481 L 33.171 20.633 C 33.171 20.086 33.414 19.777 33.862 19.777 C 33.998 19.777 34.17 19.812 34.307 19.847 L 34.515 19.162 C 34.38 19.127 34.172 19.127 34.033 19.127 Z M 24.779 20.838 C 24.779 21.834 25.47 22.551 26.54 22.551 C 27.025 22.551 27.369 22.449 27.715 22.173 L 27.369 21.593 C 27.092 21.798 26.816 21.901 26.504 21.901 C 25.919 21.901 25.505 21.49 25.505 20.84 C 25.505 20.226 25.919 19.813 26.507 19.78 C 26.816 19.78 27.092 19.883 27.369 20.089 L 27.715 19.507 C 27.369 19.233 27.024 19.13 26.54 19.13 C 25.47 19.13 24.779 19.85 24.779 20.841 Z M 31.478 20.838 L 31.478 19.198 L 30.75 19.198 L 30.75 19.608 C 30.51 19.3 30.165 19.128 29.717 19.128 C 28.784 19.128 28.058 19.848 28.058 20.84 C 28.058 21.835 28.784 22.552 29.716 22.552 C 30.197 22.552 30.543 22.382 30.748 22.074 L 30.748 22.484 L 31.477 22.484 L 31.477 20.84 Z M 28.818 20.838 C 28.818 20.259 29.196 19.779 29.819 19.779 C 30.406 19.779 30.821 20.224 30.821 20.84 C 30.821 21.424 30.406 21.902 29.819 21.902 C 29.196 21.869 28.818 21.424 28.818 20.841 Z M 20.148 19.128 C 19.183 19.128 18.494 19.813 18.494 20.84 C 18.494 21.869 19.183 22.552 20.185 22.552 C 20.671 22.552 21.154 22.417 21.533 22.108 L 21.188 21.595 C 20.914 21.799 20.565 21.937 20.222 21.937 C 19.772 21.937 19.323 21.732 19.219 21.149 L 21.671 21.149 L 21.671 20.878 C 21.705 19.815 21.083 19.13 20.15 19.13 Z M 20.148 19.748 C 20.6 19.748 20.911 20.019 20.98 20.532 L 19.253 20.532 C 19.321 20.087 19.633 19.748 20.148 19.748 Z M 38.141 20.84 L 38.141 17.898 L 37.412 17.898 L 37.412 19.61 C 37.173 19.302 36.828 19.13 36.38 19.13 C 35.446 19.13 34.721 19.85 34.721 20.841 C 34.721 21.837 35.446 22.554 36.379 22.554 C 36.861 22.554 37.206 22.383 37.41 22.076 L 37.41 22.486 L 38.14 22.486 L 38.14 20.841 Z M 35.481 20.84 C 35.481 20.261 35.861 19.78 36.484 19.78 C 37.069 19.78 37.486 20.226 37.486 20.841 C 37.486 21.426 37.069 21.904 36.484 21.904 C 35.861 21.87 35.481 21.426 35.481 20.843 Z M 11.237 20.84 L 11.237 19.2 L 10.515 19.2 L 10.515 19.61 C 10.272 19.302 9.928 19.13 9.478 19.13 C 8.545 19.13 7.82 19.85 7.82 20.841 C 7.82 21.837 8.545 22.554 9.477 22.554 C 9.96 22.554 10.304 22.383 10.512 22.076 L 10.512 22.486 L 11.236 22.486 L 11.236 20.841 Z M 8.546 20.84 C 8.546 20.261 8.926 19.78 9.548 19.78 C 10.134 19.78 10.55 20.226 10.55 20.841 C 10.55 21.426 10.134 21.904 9.548 21.904 C 8.926 21.87 8.546 21.426 8.546 20.843 Z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.MAESTRO] = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 23.999999" width="40" height="24" preserveAspectRatio="xMinYMin meet" version="1.1">\n    <path d="M 0,1.927 C 0,0.86299997 0.892,0 1.992,0 H 38.008 C 39.108,0 40,0.86299997 40,1.927 V 22.073 C 40,23.137 39.108,24 38.008,24 H 1.992 C 0.892,24 0,23.137 0,22.073 Z" style="fill:#3e3939" />\n    <path d="m 23.74623,18.221667 v 0.929759 h -0.621716 v 0.609196 h 0.621716 v 1.394324 c 0,0.71165 0.275786,1.135118 1.064369,1.135118 a 1.564348,1.564348 0 0 0 0.833339,-0.237293 l -0.192215,-0.571003 a 1.2309624,1.2309624 0 0 1 -0.589785,0.17343 c -0.333383,0 -0.442649,-0.192213 -0.442649,-0.512774 v -1.388065 h 1.086908 V 19.151426 H 24.419289 V 18.221667 Z M 10.802242,19.066278 A 1.1860835,1.1860835 0 0 0 9.8436827,19.612862 1.1251765,1.1251765 0 0 0 8.830654,19.068153 1.0129794,1.0129794 0 0 0 7.9328276,19.523328 V 19.145165 H 7.2660325 v 3.061001 H 7.939089 v -1.704869 a 0.71485573,0.71485573 0 0 1 0.7500683,-0.814556 c 0.4423764,0 0.6667964,0.288356 0.6667964,0.807671 v 1.702363 h 0.6736813 v -1.695478 a 0.72126699,0.72126699 0 0 1 0.750068,-0.814556 c 0.4552,0 0.673058,0.288356 0.673058,0.807671 v 1.702363 l 0.669926,0.0094 v -1.923369 a 1.1379991,1.1379991 0 0 0 -1.202112,-1.214633 1.1860835,1.1860835 0 0 0 -0.118329,-0.002 z m 10.549158,0.002 c -0.782176,0 -1.282253,0.372027 -1.282253,0.981097 0,0.50008 0.372102,0.80792 1.058106,0.904089 l 0.320567,0.04445 c 0.365439,0.05128 0.538444,0.147461 0.538444,0.320563 0,0.237218 -0.243528,0.371902 -0.69873,0.371902 a 1.6316662,1.6316662 0 0 1 -1.019289,-0.320606 l -0.320562,0.519663 a 2.2086798,2.2086798 0 0 0 1.323576,0.396946 c 0.881546,0 1.394948,-0.461335 1.394948,-0.999881 0,-0.538545 -0.403858,-0.820441 -1.07063,-0.916612 l -0.320563,-0.04509 c -0.288506,-0.03848 -0.519662,-0.07675 -0.519662,-0.301152 0,-0.224394 0.218082,-0.359382 0.583526,-0.359382 a 1.9714631,1.9714631 0 0 1 0.961688,0.262961 l 0.298023,-0.538445 A 2.2888207,2.2888207 0 0 0 21.3514,19.06818 Z m 6.45947,0 0.0132,0.01254 a 0.90398792,0.90398792 0 0 0 -0.80829,0.448915 v -0.371917 h -0.659908 v 3.061628 h 0.666794 v -1.714927 c 0,-0.506487 0.205162,-0.788884 0.641127,-0.788884 a 1.0835034,1.0835034 0 0 1 0.416355,0.07701 l 0.205363,-0.641127 a 1.4200945,1.4200945 0 0 0 -0.474583,-0.08326 z m 2.301544,0 a 1.7246296,1.7246296 0 0 0 -0.656779,0.13148 1.5835818,1.5835818 0 0 0 -0.519661,0.339973 1.564348,1.564348 0 0 0 -0.343103,0.509644 1.7021902,1.7021902 0 0 0 0,1.282252 1.564348,1.564348 0 0 0 0.343103,0.509647 1.5835818,1.5835818 0 0 0 0.519661,0.339972 1.8143872,1.8143872 0 0 0 1.314183,0 1.6028157,1.6028157 0 0 0 0.522793,-0.339972 1.5483199,1.5483199 0 0 0 0.345606,-0.509647 1.6989845,1.6989845 0 0 0 0,-1.282252 1.5515252,1.5515252 0 0 0 -0.345606,-0.509644 1.6028157,1.6028157 0 0 0 -0.532186,-0.343105 1.7246296,1.7246296 0 0 0 -0.641125,-0.122092 z m -15.816534,0.0025 a 1.1604384,1.1604384 0 0 0 -0.05759,6.27e-4 1.602816,1.602816 0 0 0 0,3.205632 1.1604384,1.1604384 0 0 0 0.961689,-0.448915 v 0.371903 h 0.666796 l 0.0062,-1.522675 v -1.528937 h -0.673017 v 0.371902 a 1.1604384,1.1604384 0 0 0 -0.904087,-0.449539 z m 3.747834,0.0039 a 1.6029727,1.6029727 0 0 0 0.04446,3.205629 1.859266,1.859266 0 0 0 1.253452,-0.429506 l -0.320573,-0.493394 a 1.458562,1.458562 0 0 1 -0.89094,0.320563 0.84949219,0.84949219 0 0 1 -0.917235,-0.750067 h 2.273368 c 0.0096,-0.07692 0.0094,-0.160682 0.0094,-0.250439 0,-0.961691 -0.596025,-1.602816 -1.451926,-1.602816 z m -0.05135,0.589784 a 0.78858528,0.78858528 0 0 1 0.03819,0 0.75973457,0.75973457 0 0 1 0.775738,0.743808 h -1.589666 a 0.78858528,0.78858528 0 0 1 0.775738,-0.743808 z m 12.120042,0.03256 a 0.99374563,0.99374563 0 0 1 0.385051,0.08952 0.91681058,0.91681058 0 0 1 0.320563,0.201604 0.92963292,0.92963292 0 0 1 0.201606,0.320564 1.1123539,1.1123539 0 0 1 0,0.795147 0.92642727,0.92642727 0 0 1 -0.201606,0.320562 0.91681058,0.91681058 0 0 1 -0.320563,0.202231 1.0418302,1.0418302 0 0 1 -0.760083,0 0.89757672,0.89757672 0 0 1 -0.304286,-0.202231 0.9360443,0.9360443 0 0 1 -0.202231,-0.320562 1.1123539,1.1123539 0 0 1 0,-0.795147 0.93924994,0.93924994 0 0 1 0.202231,-0.320564 0.90078228,0.90078228 0 0 1 0.304286,-0.201604 0.99374563,0.99374563 0 0 1 0.381918,-0.07073 z M 14.309018,19.80595 a 0.92642727,0.92642727 0 1 1 0.01565,1.852627 0.91681058,0.91681058 0 0 1 -0.936018,-0.981097 h 0.0069 a 0.92642727,0.92642727 0 0 1 0.913439,-0.871499 z m 18.111818,1.952179 -0.01629,0.0031 a 0.3205631,0.3205631 0 0 0 -0.10581,0.0194 0.3205631,0.3205631 0 0 0 -0.09955,0.06386 0.3205631,0.3205631 0 0 0 -0.067,0.09641 0.30132932,0.30132932 0 0 0 0,0.236665 0.3205631,0.3205631 0 0 0 0.288631,0.185952 0.30132932,0.30132932 0 0 0 0.12147,-0.02567 0.3205631,0.3205631 0 0 0 0.09956,-0.06384 0.3205631,0.3205631 0 0 0 0.06763,-0.09642 0.2981237,0.2981237 0 0 0 0,-0.236664 0.3205631,0.3205631 0 0 0 -0.06763,-0.09641 0.3205631,0.3205631 0 0 0 -0.09956,-0.06387 0.3205631,0.3205631 0 0 0 -0.12147,-0.02255 z m 0,0.067 a 0.23080544,0.23080544 0 0 1 0.09266,0.01941 0.2372167,0.2372167 0 0 1 0.07387,0.384424 0.24042232,0.24042232 0 0 1 -0.07387,0.05135 0.2275998,0.2275998 0 0 1 -0.09266,0.01941 v -0.01321 a 0.2372167,0.2372167 0 0 1 -0.170301,-0.07014 0.2372167,0.2372167 0 0 1 0,-0.320564 0.23401105,0.23401105 0 0 1 0.07701,-0.05134 0.24042232,0.24042232 0 0 1 0.09329,-0.0194 z m 0.01878,0.09329 -0.134612,0.0031 v 0.281748 h 0.06134 v -0.105802 h 0.0288 l 0.08639,0.105811 h 0.07388 l -0.09329,-0.105811 a 0.11219709,0.11219709 0 0 0 0.06761,-0.02879 0.07693513,0.07693513 0 0 0 0.02255,-0.05761 0.08014078,0.08014078 0 0 0 -0.0288,-0.067 0.12822525,0.12822525 0 0 0 -0.08391,-0.02567 z m -0.07014,0.05448 0.07014,0.01878 a 0.06731826,0.06731826 0 0 1 0.03881,0 0.03205633,0.03205633 0 0 1 0,0.02943 0.03205633,0.03205633 0 0 1 0,0.0288 0.06731826,0.06731826 0 0 1 -0.03881,0 h -0.07014 z" style="fill:#ffffff;stroke-width:0.77356213" />\n    <g transform="matrix(0.21220782,0,0,0.21220782,2.1400282,0.14227739)">\n        <rect x="68.410004" y="15.14" width="31.5" height="56.610001" style="fill:#7673c0" />\n        <path d="m 382.25,296.22 a 35.94,35.94 0 0 1 13.75,-28.3 36,36 0 1 0 0,56.61 35.94,35.94 0 0 1 -13.75,-28.31 z" transform="translate(-311.84,-252.78)" id="path8" style="fill:#eb001b" />\n        <path d="m 450.81,318.53 v -1.16 h 0.47 v -0.24 h -1.19 v 0.24 h 0.47 v 1.16 z m 2.31,0 v -1.4 h -0.36 l -0.42,1 -0.42,-1 h -0.36 v 1.4 h 0.26 v -1.05 l 0.39,0.91 h 0.27 l 0.39,-0.91 v 1.06 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n        <path d="m 454.25,296.22 a 36,36 0 0 1 -58.25,28.3 36,36 0 0 0 0,-56.61 36,36 0 0 1 58.25,28.3 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n    </g>\n</svg>\n', 
        _cardLogos[constants.o.DISCOVER] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(17, 49, 82);"/>\n  <path d="M 5.498 13.349 C 5.16 13.654 4.722 13.787 4.028 13.787 L 3.738 13.787 L 3.738 10.141 L 4.028 10.141 C 4.722 10.141 5.143 10.265 5.498 10.587 C 5.868 10.917 6.093 11.431 6.093 11.959 C 6.093 12.489 5.869 13.019 5.498 13.349 Z M 4.243 9.206 L 2.666 9.206 L 2.666 14.721 L 4.236 14.721 C 5.069 14.721 5.671 14.524 6.199 14.084 C 6.829 13.564 7.199 12.779 7.199 11.968 C 7.199 10.34 5.985 9.206 4.243 9.206 Z M 7.696 14.721 L 8.77 14.721 L 8.77 9.207 L 7.696 9.207 M 11.393 11.323 C 10.748 11.083 10.559 10.926 10.559 10.628 C 10.559 10.281 10.897 10.018 11.359 10.018 C 11.681 10.018 11.946 10.15 12.226 10.464 L 12.788 9.727 C 12.326 9.322 11.773 9.115 11.17 9.115 C 10.195 9.115 9.452 9.793 9.452 10.695 C 9.452 11.455 9.798 11.845 10.807 12.208 C 11.227 12.356 11.442 12.455 11.55 12.522 C 11.765 12.662 11.872 12.862 11.872 13.092 C 11.872 13.54 11.518 13.872 11.038 13.872 C 10.528 13.872 10.114 13.614 9.868 13.136 L 9.173 13.806 C 9.668 14.532 10.263 14.856 11.08 14.856 C 12.196 14.856 12.98 14.111 12.98 13.044 C 12.98 12.168 12.617 11.771 11.395 11.324 Z M 13.316 11.968 C 13.316 13.588 14.586 14.845 16.223 14.845 C 16.685 14.845 17.081 14.755 17.57 14.525 L 17.57 13.258 C 17.14 13.688 16.76 13.862 16.273 13.862 C 15.191 13.862 14.423 13.077 14.423 11.962 C 14.423 10.902 15.215 10.067 16.223 10.067 C 16.735 10.067 17.123 10.25 17.57 10.687 L 17.57 9.421 C 17.098 9.181 16.71 9.081 16.248 9.081 C 14.621 9.081 13.316 10.364 13.316 11.968 Z M 26.088 12.911 L 24.62 9.206 L 23.446 9.206 L 25.783 14.862 L 26.361 14.862 L 28.741 9.207 L 27.576 9.207 M 29.226 14.721 L 32.272 14.721 L 32.272 13.787 L 30.299 13.787 L 30.299 12.299 L 32.199 12.299 L 32.199 11.365 L 30.299 11.365 L 30.299 10.141 L 32.272 10.141 L 32.272 9.206 L 29.226 9.206 M 34.373 11.745 L 34.059 11.745 L 34.059 10.075 L 34.389 10.075 C 35.059 10.075 35.423 10.355 35.423 10.893 C 35.423 11.447 35.059 11.745 34.373 11.745 Z M 36.528 10.835 C 36.528 9.802 35.818 9.207 34.578 9.207 L 32.986 9.207 L 32.986 14.721 L 34.059 14.721 L 34.059 12.506 L 34.199 12.506 L 35.686 14.721 L 37.006 14.721 L 35.273 12.398 C 36.083 12.233 36.528 11.678 36.528 10.835 Z" style="fill: rgb(255, 255, 255);"/>\n  <g id="MarkingBase_1_" transform="matrix(0.089776, 0, 0, 0.089776, 2.192296, 5.72498)">\n    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="224.3917" y1="44.1731" x2="201.33" y2="80.2807" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F89F21"/>\n      <stop offset="0.2502" style="stop-color:#F79A23"/>\n      <stop offset="0.5331" style="stop-color:#F78E22"/>\n      <stop offset="0.6196" style="stop-color:#F68721"/>\n      <stop offset="0.7232" style="stop-color:#F48220"/>\n      <stop offset="1" style="stop-color:#F27623"/>\n    </linearGradient>\n    <circle fill="url(#SVGID_1_)" cx="207.343" cy="70.866" r="33.307"/>\n    <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="220.7487" y1="44.664" x2="187.0436" y2="110.5426" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F68721;stop-opacity:0"/>\n      <stop offset="0.3587" style="stop-color:#E27027;stop-opacity:0.2704"/>\n      <stop offset="0.703" style="stop-color:#D4612C;stop-opacity:0.5299"/>\n      <stop offset="0.9816" style="stop-color:#D15D2D;stop-opacity:0.74"/>\n    </linearGradient>\n    <circle opacity="0.65" fill="url(#SVGID_2_)" cx="207.343" cy="70.866" r="33.307"/>\n  </g>\n  <g id="Orange_1_" enable-background="new    " transform="matrix(0.469224, 0, 0, 0.469224, 13.785085, 6.199149)">\n    <g id="Orange">\n      <g>\n        <path d="M13,38c20.1,0,40,0,40,0c1.7,0,3-1.3,3-3V18C56,18,51.2,31.8,13,38z" style="fill: rgb(255, 129, 38);"/>\n      </g>\n    </g>\n  </g>\n</svg>', 
        _cardLogos[constants.o.HIPER] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(243, 97, 24);"/>\n  <path id="path16" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 3.206 6.45 L 3.206 16.929 L 5.586 16.929 L 5.586 12.545 L 9.489 12.545 L 9.489 16.929 L 11.853 16.929 L 11.853 6.45 L 9.489 6.45 L 9.489 10.477 L 5.586 10.477 L 5.586 6.45 L 3.206 6.45"/>\n  <path id="path18" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 32.319 13.882 C 32.351 13.71 32.397 13.353 32.397 12.949 C 32.397 11.068 31.464 9.155 29.008 9.155 C 26.364 9.155 25.167 11.285 25.167 13.213 C 25.167 15.592 26.644 17.085 29.225 17.085 C 30.251 17.085 31.2 16.929 31.977 16.618 L 31.666 15.017 C 31.029 15.219 30.376 15.328 29.567 15.328 C 28.463 15.328 27.499 14.861 27.422 13.882 Z M 27.406 12.265 C 27.468 11.628 27.873 10.725 28.868 10.725 C 29.956 10.725 30.205 11.689 30.205 12.265 L 27.406 12.265"/>\n  <path id="path20" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 33.155 16.929 L 35.519 16.929 L 35.519 13.073 C 35.519 12.887 35.533 12.7 35.565 12.545 C 35.72 11.814 36.31 11.348 37.182 11.348 C 37.446 11.348 37.648 11.378 37.819 11.41 L 37.819 9.186 C 37.648 9.155 37.539 9.155 37.321 9.155 C 36.591 9.155 35.658 9.621 35.269 10.725 L 35.207 10.725 L 35.129 9.326 L 33.092 9.326 C 33.123 9.979 33.155 10.709 33.155 11.829 L 33.155 16.929"/>\n  <path id="path22" style="fill: rgb(254, 234, 1); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 14.256 6.028 C 14.927 6.028 15.472 6.572 15.472 7.243 C 15.472 7.914 14.927 8.458 14.256 8.458 C 13.585 8.458 13.041 7.914 13.041 7.243 C 13.041 6.572 13.585 6.028 14.256 6.028"/>\n  <path id="path24" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 19.247 15.159 L 20.433 15.159 C 21.624 15.159 22.163 14.395 22.163 13.6 C 22.163 12.805 22.106 11.006 20.633 11.006 C 18.943 11.006 19.218 13.238 19.224 14.408 C 19.226 14.658 19.24 14.908 19.247 15.159 Z M 13.041 9.315 L 15.472 9.315 L 15.472 13.6 C 15.472 14.395 15.912 15.157 16.887 15.159 C 16.894 13.229 16.886 11.243 16.822 9.315 L 18.852 9.315 C 18.896 9.687 18.936 10.059 18.973 10.432 C 19.932 8.514 22.954 8.937 23.971 10.555 C 25.022 12.228 25.379 17.017 20.433 17.017 L 19.282 17.017 C 19.293 17.988 19.295 18.963 19.295 19.936 L 16.865 19.936 C 16.865 19.001 16.871 18.022 16.878 17.016 C 14.252 17.007 13.041 15.339 13.041 13.6 L 13.041 9.315"/>\n</svg>', 
        _cardLogos[constants.o.ELO] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(21, 21, 21);"/>\n  <path class="st0" d="M 9.229 8.55 C 9.592 8.431 9.977 8.365 10.382 8.365 C 12.14 8.365 13.602 9.613 13.939 11.268 L 16.427 10.762 C 15.855 7.946 13.365 5.824 10.379 5.824 C 9.693 5.824 9.037 5.935 8.42 6.142 L 9.229 8.55 Z" style="fill: rgb(255, 205, 5);"/>\n  <path class="st1" d="M 6.292 16.616 L 7.973 14.716 C 7.221 14.052 6.749 13.08 6.749 11.999 C 6.749 10.917 7.221 9.945 7.973 9.279 L 6.292 7.38 C 5.015 8.51 4.209 10.16 4.209 11.999 C 4.209 13.836 5.019 15.488 6.292 16.616" style="fill: rgb(0, 164, 224);"/>\n  <path class="st2" d="M 13.939 12.723 C 13.602 14.379 12.136 15.626 10.382 15.626 C 9.977 15.626 9.592 15.562 9.229 15.442 L 8.422 17.849 C 9.039 18.055 9.698 18.167 10.382 18.167 C 13.365 18.167 15.855 16.05 16.427 13.235 L 13.939 12.723 Z" style="fill: rgb(239, 66, 35);"/>\n  <path d="M 18.603 14.794 C 18.521 14.663 18.412 14.453 18.343 14.296 C 17.948 13.381 17.932 12.434 18.264 11.526 C 18.631 10.527 19.33 9.765 20.233 9.378 C 21.366 8.889 22.626 8.986 23.713 9.632 C 24.406 10.028 24.897 10.641 25.269 11.506 C 25.319 11.615 25.358 11.737 25.398 11.835 L 18.603 14.794 Z M 20.87 10.845 C 20.066 11.194 19.65 11.949 19.734 12.834 L 23.151 11.363 C 22.565 10.675 21.802 10.444 20.87 10.845 Z M 23.578 14.044 C 23.578 14.044 23.578 14.044 23.578 14.044 L 23.508 13.998 C 23.302 14.331 22.985 14.595 22.584 14.768 C 21.82 15.1 21.113 15.014 20.602 14.569 L 20.559 14.643 C 20.559 14.643 20.559 14.643 20.559 14.643 L 19.688 15.936 C 19.905 16.088 20.134 16.213 20.376 16.315 C 21.333 16.712 22.311 16.693 23.279 16.273 C 23.978 15.971 24.527 15.509 24.9 14.924 L 23.578 14.044 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 27.77 7.466 L 27.77 14.673 L 28.891 15.13 L 28.254 16.614 L 27.018 16.1 C 26.742 15.979 26.552 15.797 26.409 15.588 C 26.272 15.377 26.171 15.085 26.171 14.698 L 26.171 7.466 L 27.77 7.466 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.037801, 0, 0, 0.037801, 1.0913, 0.089785)">\n    <path d="M782.7,337.2c0-16.2,7.2-30.8,18.5-40.7l-30.4-33.9c-20.6,18.2-33.6,44.9-33.6,74.6c0,29.7,12.9,56.4,33.6,74.7l30.4-34&#10;&#9;&#9;C789.8,367.9,782.6,353.4,782.7,337.2z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.7,391.4c-6,0-11.8-1-17.1-2.8L805,431.7c9.9,3.3,20.6,5.1,31.6,5.2c48.2,0,88.4-34.1,97.7-79.6l-44.7-9.1&#10;&#9;&#9;C884.6,372.9,862.8,391.4,836.7,391.4z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.8,237.6c-11,0-21.7,1.8-31.6,5.1l14.4,43.2c5.4-1.8,11.2-2.8,17.1-2.8c26.2,0,48,18.6,53,43.3l44.7-9.1&#10;&#9;&#9;C925.2,272,885,237.7,836.8,237.6z" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>', 
        _cardLogos[constants.o.JCB] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <pattern id="pattern-0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" viewBox="0 0 100 100">\n      <path d="M 0 0 L 50 0 L 50 100 L 0 100 Z" style="fill: black;"/>\n    </pattern>\n  </defs>\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(255, 255, 255); stroke: rgb(233, 234, 231);"/>\n  <g transform="matrix(0.100306, 0, 0, 0.100306, 4.733743, 10.105099)" id="g6321">\n    <g transform="matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)" id="g6323">\n      <path style="fill:#ffffff" id="path6325" d="m 174,108.3 c 0,14 -11.4,25.4 -25.4,25.4 l -138.2,0 0,-100.6 c 0,-14 11.4,-25.4 25.4,-25.4 l 138.2,0 0,100.6 z" class="st0"/>\n      <g id="g6327">\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="81.398598" x2="157.3299" y1="81.398598" x1="117.3856" gradientUnits="userSpaceOnUse" id="SVGID_1_">\n          <stop id="stop6330" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6332" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6334" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6336" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_1_)" id="path6338" d="m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z" class="st1"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="157.3318" y1="75.171402" x1="117.3844" gradientUnits="userSpaceOnUse" id="SVGID_2_">\n          <stop id="stop6341" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6343" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6345" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6347" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_2_)" id="path6349" d="m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z" class="st2"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="68.399101" x2="157.33051" y1="68.399101" x1="117.3846" gradientUnits="userSpaceOnUse" id="SVGID_3_">\n          <stop id="stop6352" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6354" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6356" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6358" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_3_)" id="path6360" d="m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z" class="st3"/>\n      </g>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="68.522102" y1="75.171402" x1="27.9594" gradientUnits="userSpaceOnUse" id="SVGID_4_">\n        <stop id="stop6363" style="stop-color:#1F286F" offset="0"/>\n        <stop id="stop6365" style="stop-color:#004E94" offset="0.4751"/>\n        <stop id="stop6367" style="stop-color:#0066B1" offset="0.8261"/>\n        <stop id="stop6369" style="stop-color:#006FBC" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_4_)" id="path6371" d="m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z" class="st4"/>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="111.8553" y1="75.171402" x1="72.459503" gradientUnits="userSpaceOnUse" id="SVGID_5_">\n        <stop id="stop6374" style="stop-color:#6C2C2F" offset="0"/>\n        <stop id="stop6376" style="stop-color:#882730" offset="0.1735"/>\n        <stop id="stop6378" style="stop-color:#BE1833" offset="0.5731"/>\n        <stop id="stop6380" style="stop-color:#DC0436" offset="0.8585"/>\n        <stop id="stop6382" style="stop-color:#E60039" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_5_)" id="path6384" d="m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z" class="st5"/>\n    </g>\n    <g id="g6386"/>\n  </g>\n</svg>', 
        _cardLogos[constants.o.CUP] = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="40px" height="24px" viewBox="0 0 40 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch --\x3e\n    <title>unionpay</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id="unionpay" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g>\n            <path d="M38,24 L2,24 C0.9,24 0,23.1 0,22 L0,2 C0,0.9 0.9,0 2,0 L38,0 C39.1,0 40,0.9 40,2 L40,22 C40,23.1 39.1,24 38,24" id="Fill-1" fill="#FFFFFF"></path>\n            <path d="M38,0 L2,0 C0.9,0 0,0.9 0,2 L0,22 C0,23.1 0.9,24 2,24 L38,24 C39.1,24 40,23.1 40,22 L40,2 C40,0.9 39.1,0 38,0 M38,1 C38.551,1 39,1.449 39,2 L39,22 C39,22.551 38.551,23 38,23 L2,23 C1.449,23 1,22.551 1,22 L1,2 C1,1.449 1.449,1 2,1 L38,1" id="Fill-3" fill="#C8C8C8"></path>\n            <path d="M11.6294,3.3945 L18.4974,3.3945 C19.4564,3.3945 20.0524,4.1755 19.8284,5.1375 L16.6294,18.8655 C16.4054,19.8245 15.4474,20.6055 14.4904,20.6055 L7.6204,20.6055 C6.6624,20.6055 6.0664,19.8245 6.2894,18.8655 L9.4894,5.1375 C9.7124,4.1755 10.6694,3.3945 11.6294,3.3945" id="Fill-5" fill="#D80029"></path>\n            <path d="M17.9287,3.3945 L24.7967,3.3945 C25.7537,3.3945 26.3547,4.1755 26.1257,5.1375 L22.9297,18.8655 C22.7037,19.8245 21.7437,20.6055 20.7837,20.6055 L13.9177,20.6055 C12.9587,20.6055 12.3627,19.8245 12.5877,18.8655 L15.7837,5.1375 C16.0077,4.1755 16.9697,3.3945 17.9287,3.3945" id="Fill-7" fill="#0E2E62"></path>\n            <path d="M25.5161,3.3945 L32.3771,3.3945 C33.3361,3.3945 33.9351,4.1755 33.7091,5.1375 L30.5121,18.8655 C30.2891,19.8245 29.3291,20.6055 28.3711,20.6055 L21.5001,20.6055 C20.5421,20.6055 19.9431,19.8245 20.1691,18.8655 L23.3661,5.1375 C23.5901,4.1755 24.5511,3.3945 25.5161,3.3945" id="Fill-9" fill="#0C606C"></path>\n            <path d="M24.4546,16.3071 L25.1006,16.3071 L25.2466,15.6821 L24.5976,15.6821 L24.4546,16.3071 Z M24.8526,14.5921 L24.6816,15.3221 C24.6816,15.3221 24.9176,15.1981 25.0506,15.1611 C25.1796,15.1271 25.3786,15.1051 25.3786,15.1051 L25.5006,14.5921 L24.8526,14.5921 Z M25.1026,13.5291 L24.9406,14.2371 C24.9406,14.2371 25.1706,14.1281 25.3006,14.0941 C25.4316,14.0581 25.6296,14.0401 25.6296,14.0401 L25.7516,13.5291 L25.1026,13.5291 Z M26.5356,13.5291 L25.8886,16.2961 L26.1126,16.2961 L25.9756,16.8721 L25.7516,16.8721 L25.7106,17.0491 L24.9126,17.0491 L24.9556,16.8721 L23.3366,16.8721 L23.4636,16.3421 L23.6286,16.3401 L24.2886,13.5291 L24.4186,12.9631 L25.2336,12.9631 L25.1686,13.2481 C25.1686,13.2481 25.3736,13.0911 25.5716,13.0391 C25.7756,12.9841 26.9526,12.9641 26.9526,12.9641 L26.8176,13.5291 L26.5356,13.5291 Z" id="Fill-11" fill="#FFFFFF"></path>\n            <path d="M26.9966,12.9678 L27.8616,12.9678 L27.8726,13.2878 C27.8666,13.3418 27.9146,13.3668 28.0136,13.3688 L28.1616,13.3688 L28.0306,13.9018 L27.5596,13.9018 C27.1566,13.9318 27.0016,13.7578 27.0136,13.5618 L26.9966,12.9678" id="Fill-13" fill="#FFFFFF"></path>\n            <path d="M27.1436,15.4956 L26.3166,15.4956 L26.4276,15.0226 L27.3706,15.0226 L27.4736,14.5886 L26.5416,14.5886 L26.6686,14.0536 L29.2616,14.0536 L29.1336,14.5886 L28.2656,14.5886 L28.1616,15.0226 L29.0326,15.0226 L28.9216,15.4956 L27.9786,15.4956 L27.8216,15.6976 L28.2056,15.6976 L28.3396,16.2966 C28.3516,16.3536 28.3596,16.3926 28.3786,16.4196 C28.3956,16.4386 28.5126,16.4486 28.5806,16.4486 L28.6976,16.4486 L28.5596,17.0356 L28.2656,17.0356 C28.2206,17.0356 28.1526,17.0346 28.0576,17.0246 C27.9706,17.0176 27.9036,16.9636 27.8406,16.9376 C27.7836,16.9106 27.6996,16.8476 27.6706,16.7326 L27.5386,16.1376 L27.1546,16.7246 C27.0266,16.9106 26.8526,17.0496 26.5396,17.0496 L25.9386,17.0496 L26.0596,16.5326 L26.2906,16.5326 C26.3556,16.5326 26.4156,16.5056 26.4546,16.4836 C26.4986,16.4646 26.5356,16.4426 26.5796,16.3806 L27.1436,15.4956" id="Fill-15" fill="#FFFFFF"></path>\n            <path d="M18.0044,14.1973 L20.1934,14.1973 L20.0684,14.7183 L19.1874,14.7183 L19.0834,15.1663 L19.9734,15.1663 L19.8434,15.7033 L18.9514,15.7033 L18.7794,16.4263 C18.7584,16.5053 18.9974,16.5203 19.0834,16.5203 L19.5254,16.4583 L19.3824,17.0503 L18.3764,17.0503 C18.2934,17.0503 18.2344,17.0433 18.1454,17.0223 C18.0594,17.0003 18.0184,16.9613 17.9734,16.9053 C17.9374,16.8493 17.8764,16.7963 17.9074,16.6723 L18.1364,15.7123 L17.6394,15.7123 L17.7704,15.1663 L18.2714,15.1663 L18.3764,14.7183 L17.8784,14.7183 L18.0044,14.1973" id="Fill-17" fill="#FFFFFF"></path>\n            <path d="M19.4194,13.2588 L20.3174,13.2588 L20.1894,13.8018 L18.9614,13.8018 L18.8354,13.9198 C18.7844,13.9738 18.7614,13.9518 18.6914,13.9888 C18.6234,14.0278 18.4814,14.0938 18.2914,14.0938 L17.9004,14.0938 L18.0264,13.5718 L18.1414,13.5718 C18.2444,13.5718 18.3104,13.5588 18.3434,13.5378 C18.3804,13.5158 18.4214,13.4598 18.4644,13.3688 L18.6664,12.9618 L19.5584,12.9618 L19.4194,13.2588" id="Fill-19" fill="#FFFFFF"></path>\n            <path d="M21.1973,14.1572 C21.1973,14.1572 21.4273,13.9322 21.8443,13.8582 C21.9383,13.8422 22.5393,13.8462 22.5393,13.8462 L22.6063,13.5452 L21.3453,13.5452 L21.1973,14.1572 Z M22.3963,14.3842 L21.1463,14.3842 L21.0853,14.6352 L22.1703,14.6352 C22.2953,14.6232 22.3233,14.6392 22.3313,14.6342 L22.3963,14.3842 Z M20.6843,12.9632 L21.4543,12.9632 L21.3633,13.3512 C21.3633,13.3512 21.5903,13.1552 21.7603,13.0912 C21.9223,13.0252 22.3023,12.9702 22.3023,12.9702 L23.5393,12.9632 L23.2033,14.3672 C23.1463,14.6112 23.0763,14.7642 23.0263,14.8342 C22.9833,14.9052 22.9343,14.9662 22.8283,15.0262 C22.7283,15.0832 22.6333,15.1142 22.5453,15.1222 C22.4663,15.1322 22.3403,15.1322 22.1653,15.1332 L20.9773,15.1332 L20.7093,16.2452 C20.6813,16.3562 20.6723,16.4072 20.6943,16.4382 C20.7123,16.4622 20.7553,16.4932 20.8113,16.4932 L21.3323,16.4422 L21.1933,17.0552 L20.6003,17.0552 C20.4153,17.0552 20.2773,17.0502 20.1853,17.0422 C20.0933,17.0352 19.9953,17.0422 19.9293,16.9922 C19.8733,16.9412 19.7873,16.8822 19.7843,16.8172 C19.7873,16.7572 19.8063,16.6562 19.8333,16.5212 L20.6843,12.9632 Z" id="Fill-21" fill="#FFFFFF"></path>\n            <path d="M23.0562,15.2319 L23.0082,15.5689 C22.9802,15.6729 22.9602,15.7539 22.8882,15.8259 C22.8062,15.8939 22.7132,15.9679 22.4822,15.9679 L22.0622,15.9839 L22.0792,16.3649 C22.0832,16.4769 22.1092,16.4639 22.1282,16.4819 C22.1512,16.5019 22.1652,16.5079 22.1862,16.5139 L22.3222,16.5079 L22.7222,16.4829 L22.5922,17.0439 L22.1282,17.0439 C21.8022,17.0439 21.5562,17.0339 21.4752,16.9709 C21.3932,16.9189 21.3802,16.8579 21.3752,16.7559 L21.3112,15.2649 L22.0562,15.2649 L22.0642,15.5689 L22.2422,15.5689 C22.3052,15.5689 22.3442,15.5649 22.3702,15.5479 C22.3892,15.5289 22.4032,15.5069 22.4162,15.4709 L22.4692,15.2319 L23.0562,15.2319" id="Fill-23" fill="#FFFFFF"></path>\n            <path d="M12.4448,7.7773 C12.4168,7.9033 11.9418,10.0983 11.9398,10.1003 C11.8368,10.5433 11.7588,10.8603 11.5118,11.0673 C11.3628,11.1853 11.1948,11.2413 11.0048,11.2413 C10.6918,11.2413 10.5078,11.0883 10.4738,10.7923 L10.4658,10.6903 C10.4658,10.6903 10.5628,10.0983 10.5628,10.0963 C10.5628,10.0963 11.0648,8.0893 11.1558,7.8233 C11.1578,7.8083 11.1608,7.7983 11.1638,7.7903 C10.1898,7.8023 10.0168,7.7953 10.0048,7.7773 C9.9988,7.7983 9.9738,7.9253 9.9738,7.9253 L9.4628,10.1823 L9.4148,10.3743 L9.3348,10.9983 C9.3348,11.1853 9.3698,11.3383 9.4428,11.4663 C9.6748,11.8713 10.3408,11.9313 10.7158,11.9313 C11.1998,11.9313 11.6508,11.8263 11.9588,11.6443 C12.4908,11.3253 12.6318,10.8333 12.7528,10.3993 L12.8108,10.1743 C12.8108,10.1743 13.3288,8.0923 13.4158,7.8233 C13.4178,7.8083 13.4218,7.7983 13.4238,7.7903 C12.7188,7.8013 12.5118,7.7953 12.4448,7.7773" id="Fill-25" fill="#FFFFFF"></path>\n            <path d="M15.2935,11.9106 C14.9485,11.9056 14.8275,11.9056 14.4245,11.9246 L14.4055,11.8966 C14.4425,11.7416 14.4815,11.5876 14.5165,11.4346 L14.5645,11.2266 C14.6395,10.8986 14.7155,10.5206 14.7195,10.4026 C14.7285,10.3336 14.7505,10.1606 14.5525,10.1606 C14.4695,10.1606 14.3815,10.1996 14.2925,10.2416 C14.2475,10.4136 14.1445,10.9026 14.0985,11.1246 C14.0005,11.5956 13.9905,11.6496 13.9475,11.8796 L13.9185,11.9106 C13.5605,11.9056 13.4395,11.9056 13.0315,11.9246 L13.0135,11.8926 C13.0795,11.6086 13.1485,11.3326 13.2115,11.0526 C13.3855,10.2976 13.4265,10.0106 13.4725,9.6276 L13.5045,9.6006 C13.9065,9.5466 14.0015,9.5326 14.4355,9.4436 L14.4695,9.4836 L14.4035,9.7266 C14.4785,9.6846 14.5505,9.6406 14.6255,9.6006 C14.8275,9.5026 15.0535,9.4706 15.1805,9.4706 C15.3675,9.4706 15.5725,9.5256 15.6605,9.7426 C15.7475,9.9376 15.6885,10.1786 15.5805,10.6526 L15.5275,10.8916 C15.4135,11.4216 15.3975,11.5196 15.3345,11.8796 L15.2935,11.9106" id="Fill-27" fill="#FFFFFF"></path>\n            <path d="M16.6963,11.9106 C16.4873,11.9056 16.3543,11.9056 16.2243,11.9106 C16.0943,11.9106 15.9663,11.9146 15.7733,11.9246 L15.7623,11.9056 L15.7513,11.8926 C15.8033,11.6936 15.8313,11.6216 15.8583,11.5526 C15.8843,11.4806 15.9093,11.4106 15.9553,11.2066 C16.0143,10.9436 16.0533,10.7546 16.0783,10.5966 C16.1083,10.4366 16.1223,10.3066 16.1423,10.1526 L16.1613,10.1396 L16.1743,10.1236 C16.3833,10.0986 16.5133,10.0776 16.6503,10.0546 C16.7823,10.0356 16.9213,10.0106 17.1363,9.9716 L17.1423,9.9866 L17.1523,10.0046 C17.1083,10.1696 17.0713,10.3336 17.0303,10.4996 C16.9913,10.6646 16.9533,10.8296 16.9173,10.9926 C16.8353,11.3386 16.8083,11.4716 16.7883,11.5626 C16.7723,11.6526 16.7673,11.6976 16.7363,11.8796 L16.7173,11.8966 L16.6963,11.9106" id="Fill-29" fill="#FFFFFF"></path>\n            <path d="M18.8965,10.6846 C18.8765,10.7706 18.7985,11.1066 18.6915,11.2486 C18.6185,11.3496 18.5295,11.4126 18.4375,11.4126 C18.4085,11.4126 18.2365,11.4126 18.2325,11.1616 C18.2325,11.0356 18.2545,10.9076 18.2875,10.7676 C18.3775,10.3706 18.4865,10.0316 18.7585,10.0316 C18.9745,10.0316 18.9875,10.2766 18.8965,10.6846 M19.7975,10.7226 C19.9195,10.1886 19.8285,9.9396 19.7085,9.7916 C19.5255,9.5596 19.2115,9.4836 18.8795,9.4836 C18.6825,9.4836 18.2135,9.5056 17.8445,9.8486 C17.5825,10.0906 17.4525,10.4256 17.3825,10.7426 C17.3075,11.0676 17.2205,11.6586 17.7575,11.8716 C17.9245,11.9426 18.1635,11.9656 18.3155,11.9656 C18.7125,11.9656 19.1165,11.8536 19.4175,11.5286 C19.6555,11.2726 19.7605,10.8806 19.7975,10.7226" id="Fill-31" fill="#FFFFFF"></path>\n            <path d="M28.7817,9.5107 C28.3477,9.5897 28.2337,9.6107 27.8217,9.6667 L27.7857,9.6907 C27.7837,9.7247 27.7777,9.7567 27.7717,9.7927 C27.7097,9.6877 27.6207,9.5947 27.4737,9.5377 C27.2867,9.4687 26.8547,9.5587 26.4857,9.9007 C26.2207,10.1417 26.0987,10.4697 26.0217,10.7907 C25.9497,11.1087 25.8627,11.6977 26.3987,11.9057 C26.5687,11.9777 26.7237,11.9987 26.8767,11.9907 C27.0457,11.9847 27.1937,11.8967 27.3367,11.7747 C27.3217,11.8257 27.3107,11.8767 27.2967,11.9287 L27.3217,11.9577 C27.7077,11.9427 27.8277,11.9427 28.2447,11.9477 L28.2827,11.9147 C28.3417,11.5587 28.4027,11.2087 28.5587,10.5227 C28.6347,10.1967 28.7127,9.8717 28.7937,9.5467 L28.7817,9.5107 M27.4107,11.2907 C27.3417,11.3917 27.1717,11.4537 27.0787,11.4537 C27.0507,11.4537 26.8807,11.4537 26.8767,11.2057 C26.8747,11.0787 26.8977,10.9507 26.9297,10.8127 C27.0187,10.4157 27.1277,10.0797 27.4047,10.0797 C27.5797,10.0797 27.6667,10.2537 27.6427,10.5387 C27.6267,10.6017 27.6187,10.6597 27.6017,10.7337 C27.5717,10.8587 27.5367,10.9807 27.5067,11.1027 C27.4797,11.1767 27.4487,11.2457 27.4107,11.2907" id="Fill-33" fill="#FFFFFF"></path>\n            <path d="M22.1577,11.9106 C21.8087,11.9056 21.6947,11.9056 21.2867,11.9246 L21.2717,11.8966 C21.3087,11.7416 21.3477,11.5876 21.3827,11.4346 L21.4317,11.2266 C21.5037,10.8986 21.5797,10.5206 21.5897,10.4026 C21.5927,10.3336 21.6147,10.1606 21.4167,10.1606 C21.3367,10.1606 21.2457,10.1996 21.1567,10.2416 C21.1117,10.4136 21.0117,10.9026 20.9637,11.1246 C20.8677,11.5956 20.8597,11.6496 20.8157,11.8796 L20.7837,11.9106 C20.4287,11.9056 20.3077,11.9056 19.8967,11.9246 L19.8777,11.8926 C19.9477,11.6086 20.0137,11.3326 20.0777,11.0526 C20.2507,10.2976 20.2907,10.0106 20.3407,9.6276 L20.3727,9.6006 C20.7727,9.5466 20.8677,9.5326 21.3027,9.4436 L21.3367,9.4836 L21.2717,9.7266 C21.3407,9.6846 21.4147,9.6406 21.4887,9.6006 C21.6927,9.5026 21.9187,9.4706 22.0427,9.4706 C22.2317,9.4706 22.4397,9.5256 22.5257,9.7426 C22.6087,9.9376 22.5547,10.1786 22.4457,10.6526 L22.3907,10.8916 C22.2787,11.4216 22.2607,11.5196 22.1987,11.8796 L22.1577,11.9106" id="Fill-35" fill="#FFFFFF"></path>\n            <path d="M25.1504,7.7729 L24.8644,7.7789 C24.1174,7.7889 23.8204,7.7859 23.6934,7.7679 C23.6834,7.8229 23.6634,7.9199 23.6634,7.9199 L23.3994,9.1629 C23.3994,9.1629 22.7584,11.7979 22.7284,11.9239 C23.3774,11.9119 23.6474,11.9119 23.7574,11.9259 C23.7834,11.8019 23.9354,11.0669 23.9374,11.0629 C23.9374,11.0629 24.0654,10.5229 24.0744,10.5089 C24.0744,10.5089 24.1104,10.4499 24.1544,10.4269 L24.2154,10.4269 C24.7754,10.4269 25.4114,10.4269 25.9104,10.0589 C26.2474,9.8139 26.4764,9.4389 26.5834,8.9909 C26.6084,8.8799 26.6294,8.7489 26.6294,8.6159 C26.6294,8.4449 26.5944,8.2749 26.4944,8.1349 C26.2434,7.7809 25.7364,7.7789 25.1504,7.7729 M25.5254,9.0659 C25.4634,9.3409 25.2884,9.5699 25.0564,9.6849 C24.8664,9.7799 24.6384,9.7869 24.3974,9.7869 L24.2404,9.7869 L24.2554,9.7249 C24.2554,9.7249 24.5394,8.4899 24.5394,8.4919 L24.5454,8.4289 L24.5514,8.3809 L24.6664,8.3889 C24.6664,8.3889 25.2534,8.4409 25.2664,8.4449 C25.4964,8.5349 25.5934,8.7639 25.5254,9.0659" id="Fill-37" fill="#FFFFFF"></path>\n            <path d="M17.0757,9.7915 C17.3027,9.6335 17.3337,9.4145 17.1407,9.2965 C16.9457,9.1865 16.6047,9.2195 16.3747,9.3795 C16.1427,9.5355 16.1177,9.7565 16.3117,9.8725 C16.5047,9.9865 16.8457,9.9485 17.0757,9.7915" id="Fill-39" fill="#FFFFFF"></path>\n            <path d="M31.6587,9.5098 L31.6217,9.4688 C31.1967,9.5568 31.1197,9.5698 30.7267,9.6218 L30.6967,9.6478 C30.6967,9.6548 30.6967,9.6628 30.6957,9.6688 L30.6927,9.6628 C30.3997,10.3378 30.4117,10.1908 30.1737,10.7218 C30.1707,10.6958 30.1707,10.6768 30.1707,10.6558 L30.1107,9.5098 L30.0747,9.4688 C29.6287,9.5568 29.6167,9.5698 29.2057,9.6218 L29.1727,9.6478 C29.1687,9.6668 29.1667,9.6788 29.1637,9.6958 L29.1687,9.7008 C29.2187,9.9658 29.2067,9.9058 29.2597,10.3208 C29.2817,10.5228 29.3147,10.7308 29.3377,10.9338 C29.3807,11.2698 29.4037,11.4368 29.4507,11.9478 C29.1727,12.4128 29.1077,12.5858 28.8417,12.9888 L28.6527,13.2908 C28.6307,13.3238 28.6117,13.3418 28.5827,13.3548 C28.5547,13.3668 28.5127,13.3738 28.4587,13.3738 L28.3167,13.3738 L28.1927,13.9118 L28.7297,13.9018 C29.0437,13.9018 29.2417,13.7458 29.3477,13.5498 L29.6807,12.9768 L31.6587,9.5098" id="Fill-41" fill="#FFFFFF"></path>\n        </g>\n    </g>\n</svg>', 
        _cardLogos);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return FUNDING_PRIORITY;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return FUNDING_ORDER;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return FUNDING_CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getFundingConfig;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getCardConfig;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _FUNDING_CONFIG, _CARD_CONFIG;
        var FUNDING_PRIORITY = [ _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD, _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO ];
        var FUNDING_ORDER = [ _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD ];
        var FUNDING_CONFIG = ((_FUNDING_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            enabled: !0,
            allowOptIn: !0,
            allowOptOut: !0,
            allowRemember: !0,
            allowHorizontal: !0,
            allowVertical: !0,
            requireCommitAsTrue: !1
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL] = {
            default: !0,
            allowOptIn: !1,
            allowOptOut: !1,
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD] = {
            default: "undefined" == typeof __paypal_checkout__ || __paypal_checkout__.serverConfig.paypalMerchantConfiguration.creditCard.isPayPalBranded,
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO] = {
            allowOptOut: !0,
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU] = {
            allowOptOut: !0,
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US, _constants__WEBPACK_IMPORTED_MODULE_0__.r.GB, _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            defaultVerticalCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US ],
            platforms: [ _constants__WEBPACK_IMPORTED_MODULE_0__.D.MOBILE ],
            allowHorizontal: !0,
            allowVertical: !0,
            allowRemember: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            defaultVerticalCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BE ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE, _constants__WEBPACK_IMPORTED_MODULE_0__.r.AT, _constants__WEBPACK_IMPORTED_MODULE_0__.r.BE, _constants__WEBPACK_IMPORTED_MODULE_0__.r.ES, _constants__WEBPACK_IMPORTED_MODULE_0__.r.IT, _constants__WEBPACK_IMPORTED_MODULE_0__.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.AT ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.IT ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.P24] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.PL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.PL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.LT ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.MX ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.MX, _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ZIMPLER] = {
            allowedCountries: [],
            allowHorizontal: !1,
            allowVertical: !1,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG);
        var CARD_CONFIG = ((_CARD_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.GB] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.DISCOVER, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MAESTRO ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.US] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.DISCOVER ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.BR] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.HIPER, _constants__WEBPACK_IMPORTED_MODULE_0__.o.ELO ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.JP] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.JCB ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.CN] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.CUP ]
        }, _CARD_CONFIG);
        function getConfig(conf, category, key, def) {
            var categoryConfig = conf[category];
            if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
            if (conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s] && conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s].hasOwnProperty(key)) return conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s][key];
            if (arguments.length >= 4) return def;
            throw new Error("No value found for " + category + ":" + key);
        }
        function getFundingConfig(source, key, def) {
            return getConfig(FUNDING_CONFIG, source, key, def);
        }
        function getCardConfig(source, key, def) {
            return getConfig(CARD_CONFIG, source, key, def);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _inheritsLoose;
        }));
        var _babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            Object(_babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__.a)(subClass, superClass);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return create;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return interface_destroyAll;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return src_error.b;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return CONSTANTS;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "create", (function() {
            return create;
        }));
        __webpack_require__.d(interface_namespaceObject, "getByTag", (function() {
            return getByTag;
        }));
        __webpack_require__.d(interface_namespaceObject, "getCurrentScriptDir", (function() {
            return lib.t;
        }));
        __webpack_require__.d(interface_namespaceObject, "destroyAll", (function() {
            return interface_destroyAll;
        }));
        __webpack_require__.d(interface_namespaceObject, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(interface_namespaceObject, "PopupOpenError", (function() {
            return src_error.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "IntegrationError", (function() {
            return src_error.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "RenderError", (function() {
            return src_error.c;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONSTANTS", (function() {
            return CONSTANTS;
        }));
        var src = __webpack_require__(15);
        var assertThisInitialized = __webpack_require__(24);
        var inheritsLoose = __webpack_require__(21);
        function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
            var desc = {};
            Object.keys(descriptor).forEach((function(key) {
                desc[key] = descriptor[key];
            }));
            desc.enumerable = !!desc.enumerable;
            desc.configurable = !!desc.configurable;
            ("value" in desc || desc.initializer) && (desc.writable = !0);
            desc = decorators.slice().reverse().reduce((function(desc, decorator) {
                return decorator(target, property, desc) || desc;
            }), desc);
            if (context && void 0 !== desc.initializer) {
                desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                desc.initializer = void 0;
            }
            if (void 0 === desc.initializer) {
                Object.defineProperty(target, property, desc);
                desc = null;
            }
            return desc;
        }
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_utils_src = __webpack_require__(7);
        var lib = __webpack_require__(6);
        var base_BaseComponent = function() {
            function BaseComponent() {
                this.clean = void 0;
                this.event = void 0;
                this.component = void 0;
                this.clean = (obj = this, tasks = [], cleaned = !1, {
                    set: function(name, item) {
                        if (cleaned) return item;
                        obj[name] = item;
                        this.register((function() {
                            delete obj[name];
                        }));
                        return item;
                    },
                    register: function(name, method) {
                        if ("function" == typeof name) {
                            method = name;
                            name = "<anonymous-cleanup-handler>";
                        }
                        if ("function" != typeof method) throw new TypeError("Expected to be passed function to clean.register");
                        cleaned ? method() : tasks.push({
                            complete: !1,
                            name: name,
                            run: function() {
                                if (!this.complete) {
                                    this.complete = !0;
                                    method && method();
                                }
                            }
                        });
                    },
                    hasTasks: function() {
                        return Boolean(tasks.filter((function(item) {
                            return !item.complete;
                        })).length);
                    },
                    all: function() {
                        var results = [];
                        cleaned = !0;
                        for (;tasks.length; ) results.push(tasks.pop().run());
                        return zalgo_promise_src.a.all(results).then((function() {}));
                    },
                    run: function(name) {
                        var results = [];
                        for (var _i2 = 0; _i2 < tasks.length; _i2++) {
                            var item = tasks[_i2];
                            item.name === name && results.push(item.run());
                        }
                        return zalgo_promise_src.a.all(results).then(lib.F);
                    }
                });
                var obj, tasks, cleaned;
                this.event = Object(lib.p)();
            }
            var _proto = BaseComponent.prototype;
            _proto.addProp = function(options, name, def) {
                Object(lib.g)(options, this, name, def);
            };
            _proto.on = function(eventName, handler) {
                return this.event.on(eventName, handler);
            };
            _proto.listeners = function() {
                throw new Error("Expected listeners to be implemented");
            };
            _proto.error = function(err) {
                throw new Error("Expected error to be implemented - got " + Object(lib.S)(err));
            };
            _proto.listen = function(win, domain) {
                var _this = this;
                if (!win) throw this.component.createError("window to listen to not set");
                if (!domain) throw new Error("Must pass domain to listen to");
                if (this.listeners) {
                    var listeners = this.listeners();
                    var _loop = function() {
                        var listenerName = _Object$keys2[_i4];
                        var name = listenerName.replace(/^zoid_/, "");
                        var errorHandler = function(err) {
                            _this.error(err);
                        };
                        var listener = Object(src.on)(listenerName, {
                            window: win,
                            domain: domain,
                            errorHandler: errorHandler
                        }, (function(_ref) {
                            var source = _ref.source, data = _ref.data;
                            _this.component.log("listener_" + name);
                            return listeners[listenerName].call(_this, source, data);
                        }));
                        var errorListener = Object(src.on)(listenerName, {
                            window: win,
                            errorHandler: errorHandler
                        }, (function(_ref2) {
                            var origin = _ref2.origin;
                            _this.component.logError("unexpected_listener_" + name, {
                                origin: origin,
                                domain: domain.toString()
                            });
                            _this.error(new Error("Unexpected " + name + " message from domain " + origin + " -- expected message from " + domain.toString()));
                        }));
                        _this.clean.register((function() {
                            listener.cancel();
                            errorListener.cancel();
                        }));
                    };
                    for (var _i4 = 0, _Object$keys2 = Object.keys(listeners); _i4 < _Object$keys2.length; _i4++) _loop();
                }
            };
            return BaseComponent;
        }();
        var esm_extends = __webpack_require__(13);
        var client = __webpack_require__(4);
        __webpack_require__(17);
        Object.create(Error.prototype);
        function onResize(el, handler, _temp) {
            var _ref2 = void 0 === _temp ? {} : _temp, _ref2$width = _ref2.width, width = void 0 === _ref2$width || _ref2$width, _ref2$height = _ref2.height, height = void 0 === _ref2$height || _ref2$height, _ref2$interval = _ref2.interval, interval = void 0 === _ref2$interval ? 100 : _ref2$interval, _ref2$win = _ref2.win, win = void 0 === _ref2$win ? window : _ref2$win;
            var currentWidth = el.offsetWidth;
            var currentHeight = el.offsetHeight;
            handler({
                width: currentWidth,
                height: currentHeight
            });
            var check = function() {
                var newWidth = el.offsetWidth;
                var newHeight = el.offsetHeight;
                (width && newWidth !== currentWidth || height && newHeight !== currentHeight) && handler({
                    width: newWidth,
                    height: newHeight
                });
                currentWidth = newWidth;
                currentHeight = newHeight;
            };
            var observer;
            var timeout;
            if (void 0 !== win.ResizeObserver) (observer = new win.ResizeObserver(check)).observe(el); else if (void 0 !== win.MutationObserver) {
                (observer = new win.MutationObserver(check)).observe(el, {
                    attributes: !0,
                    childList: !0,
                    subtree: !0,
                    characterData: !1
                });
                win.addEventListener("resize", check);
            } else !function loop() {
                check();
                timeout = setTimeout(loop, interval);
            }();
            return {
                cancel: function() {
                    observer.disconnect();
                    window.removeEventListener("resize", check);
                    clearTimeout(timeout);
                }
            };
        }
        function isShadowElement(element) {
            for (;element.parentNode; ) element = element.parentNode;
            return "[object ShadowRoot]" === element.toString();
        }
        var base32 = __webpack_require__(34);
        var base32_default = __webpack_require__.n(base32);
        var constants = __webpack_require__(8);
        function normalize(str) {
            return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, "").replace(/[^a-z0-9A-Z]+/g, "_");
        }
        var isZoidComponentWindow = Object(lib.D)((function() {
            return !!window.name && "xcomponent" === window.name.split("__")[0];
        }));
        var getComponentMeta = Object(lib.D)((function() {
            if (!window.name) throw new Error("Can not get component meta without window name");
            var _window$name$split2 = window.name.split("__"), zoidcomp = _window$name$split2[0], name = _window$name$split2[1], version = _window$name$split2[2], encodedOptions = _window$name$split2[3];
            if ("xcomponent" !== zoidcomp) throw new Error("Window not rendered by zoid - got " + zoidcomp);
            var componentMeta;
            try {
                componentMeta = JSON.parse(base32_default.a.decode(encodedOptions.toUpperCase()));
            } catch (err) {
                throw new Error("Can not decode component-meta: " + encodedOptions + " " + Object(lib.S)(err));
            }
            componentMeta.name = name;
            componentMeta.version = version.replace(/_/g, ".");
            return componentMeta;
        }));
        function window_getParentDomain() {
            return getComponentMeta().domain;
        }
        function getWindowByRef(_ref) {
            var ref = _ref.ref, uid = _ref.uid, distance = _ref.distance;
            var result;
            ref === constants.WINDOW_REFERENCES.OPENER ? result = Object(cross_domain_utils_src.m)(window) : ref === constants.WINDOW_REFERENCES.TOP ? result = Object(cross_domain_utils_src.o)(window) : ref === constants.WINDOW_REFERENCES.PARENT && (result = distance ? Object(cross_domain_utils_src.l)(window, distance) : Object(cross_domain_utils_src.n)(window));
            if (ref === constants.WINDOW_REFERENCES.GLOBAL) {
                var ancestor = Object(cross_domain_utils_src.f)(window);
                if (ancestor) for (var _i2 = 0, _getAllFramesInWindow2 = Object(cross_domain_utils_src.e)(ancestor); _i2 < _getAllFramesInWindow2.length; _i2++) {
                    var frame = _getAllFramesInWindow2[_i2];
                    var global = Object(lib.w)(frame);
                    if (global && global.windows && global.windows[uid]) {
                        result = global.windows[uid];
                        break;
                    }
                }
            }
            if (!result) throw new Error("Unable to find window by ref");
            return result;
        }
        var window_getParentComponentWindow = Object(lib.D)((function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.componentParent);
        }));
        var window_getParentRenderWindow = Object(lib.D)((function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.renderParent);
        }));
        var src_error = __webpack_require__(25);
        function normalizeChildProp(component, props, key, value) {
            var prop = component.getProp(key);
            return prop ? "function" == typeof prop.childDecorate ? prop.childDecorate(value) : value : component.looseProps ? value : void 0;
        }
        var child_ChildComponent = function(_BaseComponent) {
            Object(inheritsLoose.a)(ChildComponent, _BaseComponent);
            function ChildComponent(component) {
                var _this;
                (_this = _BaseComponent.call(this) || this).component = void 0;
                _this.props = void 0;
                _this.context = void 0;
                _this.onPropHandlers = void 0;
                _this.onInit = void 0;
                _this.watchingForResize = void 0;
                _this.autoResize = void 0;
                _this.component = component;
                if (!_this.hasValidParentDomain()) {
                    _this.error(new src_error.c("Can not be rendered by domain: " + _this.getParentDomain()));
                    return Object(assertThisInitialized.a)(_this);
                }
                _this.component.log("construct_child");
                _this.onPropHandlers = [];
                var _loop = function() {
                    var item = _ref2[_i2];
                    var _loop2 = function() {
                        var _ref4$_i = _ref4[_i4], name = _ref4$_i[0], getter = _ref4$_i[1];
                        Object.defineProperty(item, name, {
                            configurable: !0,
                            get: function() {
                                _this.props || _this.setProps(_this.getInitialProps(), window_getParentDomain());
                                delete item[name];
                                item[name] = getter();
                                return item[name];
                            }
                        });
                    };
                    for (var _i4 = 0, _ref4 = [ [ "xchild", function() {
                        return Object(assertThisInitialized.a)(_this);
                    } ], [ "xprops", function() {
                        return _this.props;
                    } ] ]; _i4 < _ref4.length; _i4++) _loop2();
                };
                for (var _i2 = 0, _ref2 = [ _this.component, window ]; _i2 < _ref2.length; _i2++) _loop();
                _this.component.log("init_child");
                _this.setWindows();
                _this.onInit = _this.sendToParent(constants.POST_MESSAGE.INIT, {
                    exports: _this.exports()
                }).then((function(_ref5) {
                    var origin = _ref5.origin, data = _ref5.data;
                    _this.context = data.context;
                    _this.setProps(data.props, origin);
                    _this.watchForResize();
                    return Object(assertThisInitialized.a)(_this);
                })).catch((function(err) {
                    _this.error(err);
                    throw err;
                }));
                return _this;
            }
            var _proto = ChildComponent.prototype;
            _proto.hasValidParentDomain = function() {
                return Object(cross_domain_utils_src.B)(this.component.allowedParentDomains, this.getParentDomain());
            };
            _proto.init = function() {
                return this.onInit;
            };
            _proto.getParentDomain = function() {
                return window_getParentDomain();
            };
            _proto.onProps = function(handler) {
                this.onPropHandlers.push(handler);
            };
            _proto.getParentComponentWindow = function() {
                return window_getParentComponentWindow();
            };
            _proto.getParentRenderWindow = function() {
                return window_getParentRenderWindow();
            };
            _proto.getInitialProps = function() {
                var _this2 = this;
                var componentMeta = getComponentMeta();
                var props = componentMeta.props;
                if (props.type === constants.INITIAL_PROPS.RAW) props = props.value; else {
                    if (props.type !== constants.INITIAL_PROPS.UID) throw new Error("Unrecognized props type: " + props.type);
                    var parentComponentWindow = window_getParentComponentWindow();
                    if (!Object(cross_domain_utils_src.v)(parentComponentWindow)) {
                        if ("file:" === window.location.protocol) throw new Error("Can not get props from file:// domain");
                        throw new Error("Parent component window is on a different domain - expected " + Object(cross_domain_utils_src.h)() + " - can not retrieve props");
                    }
                    var global = Object(lib.w)(parentComponentWindow);
                    if (!global) throw new Error("Can not find global for parent component - can not retrieve props");
                    props = JSON.parse(global.props[componentMeta.uid]);
                }
                if (!props) throw new Error("Initial props not found");
                return Object(lib.k)(props, (function(_ref6) {
                    var fullKey = _ref6.fullKey, self = _ref6.self, args = _ref6.args;
                    return _this2.onInit.then((function() {
                        var func = Object(lib.s)(_this2.props, fullKey);
                        if ("function" != typeof func) throw new TypeError("Expected " + fullKey + " to be function, got " + typeof func);
                        return func.apply(self, args);
                    }));
                }));
            };
            _proto.setProps = function(props, origin, required) {
                void 0 === required && (required = !0);
                this.props = this.props || {};
                var normalizedProps = function(component, props, origin, required) {
                    void 0 === required && (required = !0);
                    var result = {};
                    for (var _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        var prop = component.getProp(key);
                        var value = props[key];
                        if (!prop || !prop.sameDomain || origin === Object(cross_domain_utils_src.h)(window)) {
                            result[key] = normalizeChildProp(component, 0, key, value);
                            prop && prop.alias && !result[prop.alias] && (result[prop.alias] = value);
                        }
                    }
                    if (required) for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        props.hasOwnProperty(_key) || (result[_key] = normalizeChildProp(component, 0, _key, props[_key]));
                    }
                    return result;
                }(this.component, props, origin, required);
                Object(lib.q)(this.props, normalizedProps);
                this.props.logLevel && Object(lib.O)(this.props.logLevel);
                for (var _i6 = 0, _this$onPropHandlers2 = this.onPropHandlers; _i6 < _this$onPropHandlers2.length; _i6++) _this$onPropHandlers2[_i6].call(this, this.props);
            };
            _proto.sendToParent = function(name, data, options) {
                void 0 === data && (data = {});
                void 0 === options && (options = {});
                var parentWindow = window_getParentComponentWindow();
                if (!parentWindow) throw new Error("Can not find parent component window to message");
                this.component.log("send_to_parent_" + name);
                return Object(src.send)(parentWindow, name, data, Object(esm_extends.a)({
                    domain: window_getParentDomain()
                }, options));
            };
            _proto.setWindows = function() {
                if (window.__activeZoidComponent__) throw this.component.createError("Can not attach multiple components to the same window");
                window.__activeZoidComponent__ = this;
                if (!window_getParentComponentWindow()) throw this.component.createError("Can not find parent window");
                var componentMeta = getComponentMeta();
                if (componentMeta.tag !== this.component.tag) throw this.component.createError("Parent is " + componentMeta.tag + " - can not attach " + this.component.tag);
                this.watchForClose();
            };
            _proto.watchForClose = function() {
                var _this3 = this;
                window.addEventListener("unload", (function() {
                    return _this3.checkClose();
                }));
            };
            _proto.enableAutoResize = function(_temp) {
                var _ref7 = void 0 === _temp ? {} : _temp, _ref7$width = _ref7.width, _ref7$height = _ref7.height;
                this.autoResize = {
                    width: void 0 === _ref7$width || _ref7$width,
                    height: void 0 === _ref7$height || _ref7$height
                };
                this.watchForResize();
            };
            _proto.getAutoResize = function() {
                var width = !1;
                var height = !1;
                var autoResize = this.autoResize || this.component.autoResize;
                if ("object" == typeof autoResize) {
                    width = Boolean(autoResize.width);
                    height = Boolean(autoResize.height);
                } else if (autoResize) {
                    width = !0;
                    height = !0;
                }
                return {
                    width: width,
                    height: height,
                    element: autoResize.element ? Object(lib.u)(autoResize.element) : document.body
                };
            };
            _proto.watchForResize = function() {
                var _this4 = this;
                var _this$getAutoResize = this.getAutoResize(), width = _this$getAutoResize.width, height = _this$getAutoResize.height, element = _this$getAutoResize.element;
                if ((width || height) && this.context !== constants.CONTEXT_TYPES.POPUP && !this.watchingForResize) {
                    this.watchingForResize = !0;
                    onResize(element, (function(_ref8) {
                        _this4.resize(width ? _ref8.width : void 0, height ? _ref8.height : void 0);
                    }), {
                        width: width,
                        height: height
                    });
                }
            };
            _proto.exports = function() {
                var self = this;
                return {
                    updateProps: function(props) {
                        var _this5 = this;
                        return zalgo_promise_src.a.try((function() {
                            return self.setProps(props, _this5.origin, !1);
                        }));
                    },
                    close: function() {
                        return zalgo_promise_src.a.try((function() {
                            return self.destroy();
                        }));
                    }
                };
            };
            _proto.resize = function(width, height) {
                var _this6 = this;
                return zalgo_promise_src.a.resolve().then((function() {
                    _this6.component.log("resize", {
                        width: Object(lib.R)(width),
                        height: Object(lib.R)(height)
                    });
                    if (_this6.context !== constants.CONTEXT_TYPES.POPUP) return _this6.sendToParent(constants.POST_MESSAGE.RESIZE, {
                        width: width,
                        height: height
                    }).then(lib.F);
                }));
            };
            _proto.hide = function() {
                return this.sendToParent(constants.POST_MESSAGE.HIDE).then(lib.F);
            };
            _proto.show = function() {
                return this.sendToParent(constants.POST_MESSAGE.SHOW).then(lib.F);
            };
            _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            };
            _proto.close = function(reason) {
                void 0 === reason && (reason = constants.CLOSE_REASONS.CHILD_CALL);
                this.component.log("close_child");
                this.sendToParent(constants.POST_MESSAGE.CLOSE, {
                    reason: reason
                });
            };
            _proto.checkClose = function() {
                this.sendToParent(constants.POST_MESSAGE.CHECK_CLOSE, {}, {
                    fireAndForget: !0
                });
            };
            _proto.destroy = function() {
                return Object(client.h)().then((function() {
                    window.close();
                }));
            };
            _proto.focus = function() {
                this.component.log("focus");
                window.focus();
            };
            _proto.error = function(err) {
                var stringifiedError = Object(lib.S)(err);
                this.component.logError("error", {
                    error: stringifiedError
                });
                return this.sendToParent(constants.POST_MESSAGE.ERROR, {
                    error: stringifiedError
                }).then(lib.F);
            };
            return ChildComponent;
        }(base_BaseComponent);
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1;
                descriptor.configurable = !0;
                "value" in descriptor && (descriptor.writable = !0);
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            protoProps && _defineProperties(Constructor.prototype, protoProps);
            staticProps && _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var RENDER_DRIVERS = {};
        RENDER_DRIVERS[constants.CONTEXT_TYPES.IFRAME] = {
            focusable: !1,
            renderedIntoContainerTemplate: !0,
            allowResize: !0,
            openOnClick: !1,
            needsBridge: !1,
            open: function(url) {
                var _this = this;
                var attributes = this.component.attributes.iframe || {};
                this.iframe = Object(lib.y)({
                    url: url,
                    attributes: Object(esm_extends.a)({
                        name: this.childWindowName,
                        title: this.component.name,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.COMPONENT_FRAME, constants.CLASS_NAMES.INVISIBLE ]
                }, this.element);
                return Object(lib.f)(this.iframe).then((function(frameWindow) {
                    _this.window = frameWindow;
                    var detectClose = function() {
                        return zalgo_promise_src.a.try((function() {
                            return _this.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                        })).finally((function() {
                            return _this.destroy();
                        }));
                    };
                    var iframeWatcher = Object(lib.W)(_this.iframe, detectClose);
                    var elementWatcher = Object(lib.W)(_this.element, detectClose);
                    _this.clean.register("destroyWindow", (function() {
                        iframeWatcher.cancel();
                        elementWatcher.cancel();
                        Object(src.cleanUpWindow)(_this.window);
                        delete _this.window;
                        if (_this.iframe) {
                            Object(lib.l)(_this.iframe);
                            delete _this.iframe;
                        }
                    }));
                }));
            },
            openPrerender: function() {
                var _this2 = this;
                var attributes = this.component.attributes.iframe || {};
                this.prerenderIframe = Object(lib.y)({
                    attributes: Object(esm_extends.a)({
                        name: "__prerender__" + this.childWindowName,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.PRERENDER_FRAME, constants.CLASS_NAMES.VISIBLE ]
                }, this.element);
                return Object(lib.f)(this.prerenderIframe).then((function(prerenderFrameWindow) {
                    _this2.prerenderWindow = prerenderFrameWindow;
                    _this2.clean.register("destroyPrerender", (function() {
                        if (_this2.prerenderIframe) {
                            Object(lib.l)(_this2.prerenderIframe);
                            delete _this2.prerenderIframe;
                        }
                    }));
                }));
            },
            switchPrerender: function() {
                var _this3 = this;
                Object(lib.a)(this.prerenderIframe, constants.CLASS_NAMES.INVISIBLE);
                Object(lib.L)(this.prerenderIframe, constants.CLASS_NAMES.VISIBLE);
                Object(lib.a)(this.iframe, constants.CLASS_NAMES.VISIBLE);
                Object(lib.L)(this.iframe, constants.CLASS_NAMES.INVISIBLE);
                setTimeout((function() {
                    _this3.prerenderIframe && Object(lib.l)(_this3.prerenderIframe);
                }), 1e3);
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyComponent: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                createPrerenderTemplate: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                resize: constants.DELEGATE.CALL_DELEGATE,
                loadUrl: constants.DELEGATE.CALL_DELEGATE,
                hijackSubmit: constants.DELEGATE.CALL_DELEGATE,
                openPrerender: constants.DELEGATE.CALL_DELEGATE,
                switchPrerender: constants.DELEGATE.CALL_DELEGATE,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL,
                open: function(original, override) {
                    return function() {
                        var _this4 = this;
                        return override.apply(this, arguments).then((function() {
                            _this4.clean.set("window", Object(cross_domain_utils_src.c)(window_getParentComponentWindow(), _this4.childWindowName));
                            if (!_this4.window) throw new Error("Unable to find parent component iframe window");
                        }));
                    };
                }
            },
            resize: function(width, height) {
                if (width) {
                    this.container.style.width = Object(lib.T)(width);
                    this.element.style.width = Object(lib.T)(width);
                }
                if (height) {
                    this.container.style.height = Object(lib.T)(height);
                    this.element.style.height = Object(lib.T)(height);
                }
            },
            show: function() {
                Object(lib.Q)(this.element);
            },
            hide: function() {
                Object(lib.x)(this.element);
            },
            loadUrl: function(url) {
                this.iframe.setAttribute("src", url);
            }
        };
        RENDER_DRIVERS[constants.CONTEXT_TYPES.POPUP] = {
            focusable: !0,
            renderedIntoContainerTemplate: !1,
            allowResize: !1,
            openOnClick: !0,
            needsBridge: !0,
            open: function(url) {
                var _this5 = this;
                void 0 === url && (url = "");
                return zalgo_promise_src.a.try((function() {
                    var _ref = _this5.component.dimensions || {}, _ref$width = _ref.width, width = void 0 === _ref$width ? constants.DEFAULT_DIMENSIONS.WIDTH : _ref$width, _ref$height = _ref.height, height = void 0 === _ref$height ? constants.DEFAULT_DIMENSIONS.HEIGHT : _ref$height;
                    var _getPosition = function(_ref2) {
                        var width = _ref2.width, height = _ref2.height;
                        var x = 0;
                        var y = 0;
                        width && (window.outerWidth ? x = Math.round((window.outerWidth - width) / 2) + window.screenX : window.screen.width && (x = Math.round((window.screen.width - width) / 2)));
                        height && (window.outerHeight ? y = Math.round((window.outerHeight - height) / 2) + window.screenY : window.screen.height && (y = Math.round((window.screen.height - height) / 2)));
                        return {
                            x: x,
                            y: y
                        };
                    }({
                        width: width = Object(lib.G)(width, window.outerWidth),
                        height: height = Object(lib.G)(height, window.outerWidth)
                    }), x = _getPosition.x, y = _getPosition.y;
                    var attributes = _this5.component.attributes.popup || {};
                    _this5.window = Object(lib.I)(url || "", Object(esm_extends.a)({
                        name: _this5.childWindowName,
                        width: width,
                        height: height,
                        top: y,
                        left: x,
                        status: 1,
                        toolbar: 0,
                        menubar: 0,
                        resizable: 1,
                        scrollbars: 1
                    }, attributes));
                    _this5.prerenderWindow = _this5.window;
                    _this5.clean.register("destroyWindow", (function() {
                        if (_this5.window) {
                            _this5.window.close();
                            Object(src.cleanUpWindow)(_this5.window);
                            delete _this5.window;
                            delete _this5.prerenderWindow;
                        }
                    }));
                    _this5.resize(width, height);
                }));
            },
            openPrerender: function() {
                return zalgo_promise_src.a.try(lib.F);
            },
            resize: function() {},
            hide: function() {
                throw new Error("Can not hide popup");
            },
            show: function() {
                throw new Error("Can not show popup");
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                open: constants.DELEGATE.CALL_ORIGINAL,
                loadUrl: constants.DELEGATE.CALL_ORIGINAL,
                createPrerenderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                destroyComponent: constants.DELEGATE.CALL_ORIGINAL,
                resize: constants.DELEGATE.CALL_ORIGINAL,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL
            },
            loadUrl: function(url) {
                if (Object(cross_domain_utils_src.v)(this.window)) try {
                    if (this.window.location && this.window.location.replace) {
                        this.window.location.replace(url);
                        return;
                    }
                } catch (err) {}
                this.window.location = url;
            }
        };
        function validateProp(prop, key, value, props, required) {
            void 0 === required && (required = !0);
            if (null != value && "" !== value) {
                if (!value || "function" != typeof value.then || !prop.promise) {
                    if ("function" === prop.type) {
                        if ("function" != typeof value) throw new TypeError("Prop is not of type function: " + key);
                    } else if ("string" === prop.type) {
                        if ("string" != typeof value) throw new TypeError("Prop is not of type string: " + key);
                    } else if ("object" === prop.type) {
                        if (!1 !== prop.sendToChild) try {
                            JSON.stringify(value);
                        } catch (err) {
                            throw new Error("Unable to serialize prop: " + key);
                        }
                    } else if ("number" === prop.type && isNaN(parseInt(value, 10))) throw new TypeError("Prop is not a number: " + key);
                    "function" == typeof prop.validate && value && prop.validate(value, props);
                }
            } else if (required && !1 !== prop.required && !prop.hasOwnProperty("def")) throw new Error("Prop is required: " + key);
        }
        function normalizeProp(component, instance, props, key, value) {
            var prop = component.getProp(key);
            var resultValue;
            !(resultValue = prop.value ? prop.value : !prop.def || props.hasOwnProperty(key) && function(value) {
                return null != value && "" !== value;
            }(value) ? value : prop.def.call(component, props)) && prop.alias && props[prop.alias] && (resultValue = props[prop.alias]);
            var decorated = !1;
            if (prop.decorate && null != resultValue) {
                resultValue = prop.decorate.call(instance, resultValue, props);
                decorated = !0;
            }
            var type = prop.type;
            if ("boolean" === type) resultValue = Boolean(resultValue); else if ("function" === type) {
                if (!resultValue && prop.noop) {
                    resultValue = lib.F;
                    !decorated && prop.decorate && (resultValue = prop.decorate.call(instance, lib.F, props));
                }
                if (resultValue && "function" == typeof resultValue) {
                    resultValue = resultValue.bind(instance);
                    prop.denodeify && (resultValue = Object(lib.j)(resultValue));
                    prop.promisify && (resultValue = Object(lib.K)(resultValue));
                    var original = resultValue;
                    resultValue = function() {
                        component.log("call_prop_" + key);
                        return original.apply(this, arguments);
                    };
                    prop.once && (resultValue = Object(lib.H)(resultValue));
                    prop.memoize && (resultValue = Object(lib.D)(resultValue));
                }
            } else "string" === type || "object" === type || "number" === type && void 0 !== resultValue && (resultValue = parseInt(resultValue, 10));
            return resultValue;
        }
        function props_getQueryParam(prop, key, value) {
            return zalgo_promise_src.a.try((function() {
                return "function" == typeof prop.queryParam ? prop.queryParam(value) : "string" == typeof prop.queryParam ? prop.queryParam : key;
            }));
        }
        function getQueryValue(prop, key, value) {
            return zalgo_promise_src.a.try((function() {
                return "function" == typeof prop.queryValue ? prop.queryValue(value) : value;
            }));
        }
        var _class, _class2;
        lib.v.props = lib.v.props || {};
        lib.v.windows = lib.v.windows || {};
        var parent_ParentComponent = (_applyDecoratedDescriptor((_class = ((_class2 = function(_BaseComponent) {
            Object(inheritsLoose.a)(ParentComponent, _BaseComponent);
            function ParentComponent(component, context, _ref) {
                var _this;
                var props = _ref.props;
                (_this = _BaseComponent.call(this) || this).html = void 0;
                _this.context = void 0;
                _this.props = void 0;
                _this.childWindowName = void 0;
                _this.onInit = void 0;
                _this.window = void 0;
                _this.handledErrors = void 0;
                _this.container = void 0;
                _this.element = void 0;
                _this.outlet = void 0;
                _this.iframe = void 0;
                _this.prerenderIframe = void 0;
                _this.prerenderWindow = void 0;
                _this.childExports = void 0;
                _this.timeout = void 0;
                _this.component = component;
                _this.validateParentDomain();
                _this.context = context;
                try {
                    _this.setProps(props);
                } catch (err) {
                    props.onError && props.onError(err);
                    throw err;
                }
                _this.props.logLevel && Object(lib.O)(_this.props.logLevel);
                _this.childWindowName = _this.buildChildWindowName({
                    renderTo: window
                });
                _this.registerActiveComponent();
                _this.component.log("construct_parent");
                _this.watchForUnload();
                _this.onInit = new zalgo_promise_src.a;
                _this.onInit.catch((function(err) {
                    return _this.error(err);
                }));
                return _this;
            }
            var _proto = ParentComponent.prototype;
            _proto.render = function(element, loadUrl) {
                var _this2 = this;
                void 0 === loadUrl && (loadUrl = !0);
                return this.tryInit((function() {
                    _this2.component.log("render_" + _this2.context, {
                        context: _this2.context,
                        element: element,
                        loadUrl: Object(lib.R)(loadUrl)
                    });
                    var tasks = {};
                    tasks.onRender = _this2.props.onRender();
                    tasks.getDomain = _this2.getDomain();
                    tasks.elementReady = zalgo_promise_src.a.try((function() {
                        if (element) return _this2.elementReady(element);
                    }));
                    tasks.openContainer = tasks.elementReady.then((function() {
                        return _this2.openContainer(element);
                    }));
                    tasks.showContainer = tasks.openContainer.then((function() {
                        return _this2.showContainer();
                    }));
                    tasks.openPrerender = tasks.openContainer.then((function() {
                        return _this2.openPrerender();
                    }));
                    tasks.switchPrerender = zalgo_promise_src.a.all([ tasks.openPrerender, _this2.onInit ]).then((function() {
                        return _this2.switchPrerender();
                    }));
                    tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then((function() {
                        return _this2.open();
                    }));
                    tasks.listen = zalgo_promise_src.a.hash({
                        domain: tasks.getDomain,
                        open: tasks.open
                    }).then((function(_ref2) {
                        _this2.listen(_this2.window, _ref2.domain);
                    }));
                    tasks.watchForClose = tasks.open.then((function() {
                        return _this2.watchForClose();
                    }));
                    tasks.linkDomain = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then((function(_ref3) {
                        var domain = _ref3[0];
                        if (src.bridge && "string" == typeof domain) return src.bridge.linkUrl(_this2.window, domain);
                    }));
                    if (!_this2.html) {
                        tasks.createPrerenderTemplate = tasks.openPrerender.then((function() {
                            return _this2.createPrerenderTemplate();
                        }));
                        tasks.showComponent = tasks.createPrerenderTemplate.then((function() {
                            return _this2.showComponent();
                        }));
                    }
                    tasks.openBridge = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then((function(_ref4) {
                        var domain = _ref4[0];
                        return _this2.openBridge("string" == typeof domain ? domain : null);
                    }));
                    if (_this2.html) tasks.loadHTML = tasks.open.then((function() {
                        return _this2.loadHTML();
                    })); else if (loadUrl) {
                        tasks.buildUrl = _this2.buildUrl();
                        tasks.loadUrl = zalgo_promise_src.a.all([ tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate ]).then((function(_ref5) {
                            return _this2.loadUrl(_ref5[0]);
                        }));
                        tasks.runTimeout = tasks.loadUrl.then((function() {
                            return _this2.runTimeout();
                        }));
                    }
                    return zalgo_promise_src.a.hash(tasks);
                })).then((function() {
                    return _this2.props.onEnter();
                })).then((function() {
                    return _this2;
                }));
            };
            _proto.getOutlet = function() {
                var outlet = document.createElement("div");
                Object(lib.a)(outlet, constants.CLASS_NAMES.OUTLET);
                return outlet;
            };
            _proto.validateParentDomain = function() {
                var domain = Object(cross_domain_utils_src.h)();
                if (!Object(cross_domain_utils_src.B)(this.component.allowedParentDomains, domain)) throw new src_error.c("Can not be rendered by domain: " + domain);
            };
            _proto.renderTo = function(win, element) {
                var _this3 = this;
                return this.tryInit((function() {
                    if (win === window) return _this3.render(element);
                    if (!Object(cross_domain_utils_src.w)(window, win)) throw new Error("Can only renderTo an adjacent frame");
                    if (element && "string" != typeof element) throw new Error("Element passed to renderTo must be a string selector, got " + typeof element + " " + element);
                    _this3.checkAllowRenderTo(win);
                    _this3.component.log("render_" + _this3.context + "_to_win", {
                        element: Object(lib.R)(element),
                        context: _this3.context
                    });
                    _this3.childWindowName = _this3.buildChildWindowName({
                        renderTo: win
                    });
                    _this3.delegate(win);
                    return _this3.render(element);
                }));
            };
            _proto.prefetch = function() {
                var _this4 = this;
                return zalgo_promise_src.a.try((function() {
                    _this4.html = _this4.buildUrl().then((function(url) {
                        return Object(lib.J)(url).then((function(html) {
                            return '\n                        <base href="' + url.split("/").slice(0, 3).join("/") + '">\n\n                        ' + html + "\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, '', '/" + url.split("/").slice(3).join("/") + "');\n                            }\n                        <\/script>\n                    ";
                        }));
                    }));
                }));
            };
            _proto.loadHTML = function() {
                var _this5 = this;
                return zalgo_promise_src.a.try((function() {
                    if (!_this5.html) throw new Error("Html not prefetched");
                    return _this5.html.then((function(html) {
                        return Object(lib.Y)(_this5.window, html);
                    }));
                }));
            };
            _proto.checkAllowRenderTo = function(win) {
                if (!win) throw this.component.createError("Must pass window to renderTo");
                if (!Object(cross_domain_utils_src.v)(win)) {
                    var origin = Object(cross_domain_utils_src.h)();
                    var domain = this.component.getDomain(null, this.props.env);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.B)(domain, origin)) throw new Error("Can not render remotely to " + domain.toString() + " - can only render to " + origin);
                }
            };
            _proto.registerActiveComponent = function() {
                var _this6 = this;
                ParentComponent.activeComponents.push(this);
                this.clean.register((function() {
                    ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
                }));
            };
            _proto.getComponentParentRef = function() {
                if (this.component.getDomain(null, this.props.env) === Object(cross_domain_utils_src.h)(window)) {
                    var uid = Object(lib.U)();
                    lib.v.windows = lib.v.windows || {};
                    lib.v.windows[uid] = window;
                    this.clean.register((function() {
                        delete lib.v.windows[uid];
                    }));
                    return {
                        ref: constants.WINDOW_REFERENCES.GLOBAL,
                        uid: uid
                    };
                }
                return this.context === constants.CONTEXT_TYPES.POPUP ? {
                    ref: constants.WINDOW_REFERENCES.OPENER
                } : Object(cross_domain_utils_src.x)(window) ? {
                    ref: constants.WINDOW_REFERENCES.TOP
                } : {
                    ref: constants.WINDOW_REFERENCES.PARENT,
                    distance: Object(cross_domain_utils_src.g)(window)
                };
            };
            _proto.getRenderParentRef = function(renderToWindow) {
                void 0 === renderToWindow && (renderToWindow = window);
                if (renderToWindow === window) return this.getComponentParentRef();
                var uid = Object(lib.U)();
                lib.v.windows[uid] = renderToWindow;
                this.clean.register((function() {
                    delete lib.v.windows[uid];
                }));
                return {
                    ref: constants.WINDOW_REFERENCES.GLOBAL,
                    uid: uid
                };
            };
            _proto.buildChildWindowName = function(_temp) {
                var _ref6$renderTo = (void 0 === _temp ? {} : _temp).renderTo, renderTo = void 0 === _ref6$renderTo ? window : _ref6$renderTo;
                var childDomain = this.component.getDomain(null, this.props.env);
                var sameDomain = Object(cross_domain_utils_src.v)(renderTo);
                var uid = Object(lib.U)();
                var tag = this.component.tag;
                var sProps = Object(lib.N)(this.getPropsForChild());
                var componentParent = this.getComponentParentRef();
                var renderParent = this.getRenderParentRef(renderTo);
                var props = sameDomain || this.component.unsafeRenderTo ? {
                    type: constants.INITIAL_PROPS.RAW,
                    value: sProps
                } : {
                    type: constants.INITIAL_PROPS.UID,
                    uid: uid
                };
                if (props.type === constants.INITIAL_PROPS.UID) {
                    lib.v.props[uid] = JSON.stringify(sProps);
                    this.clean.register((function() {
                        delete lib.v.props[uid];
                    }));
                }
                return function(name, version, options) {
                    void 0 === options && (options = {});
                    options.id = Object(lib.U)();
                    options.domain = Object(cross_domain_utils_src.h)(window);
                    var encodedName = normalize(name);
                    var encodedVersion = normalize(version);
                    var encodedOptions = (str = JSON.stringify(options), base32_default.a.encode(str).replace(/\=/g, "").toLowerCase());
                    var str;
                    if (!encodedName) throw new Error("Invalid name: " + name + " - must contain alphanumeric characters");
                    if (!encodedVersion) throw new Error("Invalid version: " + version + " - must contain alphanumeric characters");
                    return [ "xcomponent", encodedName, encodedVersion, encodedOptions, "" ].join("__");
                }(this.component.name, this.component.version, {
                    uid: uid,
                    tag: tag,
                    componentParent: componentParent,
                    renderParent: renderParent,
                    props: props,
                    childDomain: childDomain
                });
            };
            _proto.sendToParent = function(name, data) {
                if (!window_getParentComponentWindow()) throw new Error("Can not find parent component window to message");
                this.component.log("send_to_parent_" + name);
                return Object(src.send)(window_getParentComponentWindow(), name, data, {
                    domain: window_getParentDomain()
                });
            };
            _proto.setProps = function(props, required) {
                void 0 === required && (required = !0);
                !function(component, props, required) {
                    void 0 === required && (required = !0);
                    if ((props = props || {}).env && "object" == typeof component.url && !component.url[props.env]) throw new Error("Invalid env: " + props.env);
                    for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                        var key = _component$getPropNam2[_i2];
                        var prop = component.getProp(key);
                        if (prop.alias && props.hasOwnProperty(prop.alias)) {
                            var value = props[prop.alias];
                            delete props[prop.alias];
                            props[key] || (props[key] = value);
                        }
                    }
                    for (var _i4 = 0, _Object$keys2 = Object.keys(props); _i4 < _Object$keys2.length; _i4++) {
                        var _key = _Object$keys2[_i4];
                        var _prop = component.getProp(_key);
                        _prop && validateProp(_prop, _key, props[_key], props, required);
                    }
                    for (var _i6 = 0, _component$getPropNam4 = component.getPropNames(); _i6 < _component$getPropNam4.length; _i6++) {
                        var _key2 = _component$getPropNam4[_i6];
                        var _prop2 = component.getProp(_key2);
                        var _value2 = props[_key2];
                        _prop2 && !props.hasOwnProperty(_key2) && validateProp(_prop2, _key2, _value2, props, required);
                    }
                }(this.component, props, required);
                this.component.validate && this.component.validate(this.component, props);
                this.props = this.props || {};
                Object(lib.q)(this.props, function(component, instance, props) {
                    var result = {};
                    props = props || {};
                    for (var _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        result[key] = -1 !== component.getPropNames().indexOf(key) ? normalizeProp(component, instance, props, key, props[key]) : props[key];
                    }
                    for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        if (!(props.hasOwnProperty(_key) || instance.props && instance.props.hasOwnProperty(_key))) {
                            var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);
                            void 0 !== normalizedProp && (result[_key] = normalizedProp);
                        }
                    }
                    return result;
                }(this.component, this, props));
            };
            _proto.buildUrl = function() {
                var _this7 = this;
                return zalgo_promise_src.a.all([ this.props.url, (propsDef = Object(esm_extends.a)({}, this.component.props, this.component.builtinProps), 
                props = this.props, params = {}, zalgo_promise_src.a.all(Object.keys(props).map((function(key) {
                    var prop = propsDef[key];
                    if (prop) return zalgo_promise_src.a.resolve().then((function() {
                        var value = props[key];
                        if (value && prop.queryParam) return value;
                    })).then((function(value) {
                        if (value) return zalgo_promise_src.a.all([ props_getQueryParam(prop, key, value), getQueryValue(prop, 0, value) ]).then((function(_ref) {
                            var queryParam = _ref[0], queryValue = _ref[1];
                            var result;
                            if ("boolean" == typeof queryValue) result = "1"; else if ("string" == typeof queryValue) result = queryValue.toString(); else {
                                if ("function" == typeof queryValue) return;
                                if ("object" == typeof queryValue && null !== queryValue) {
                                    if ("json" !== prop.serialization) {
                                        result = Object(lib.m)(queryValue, key);
                                        for (var _i6 = 0, _Object$keys4 = Object.keys(result); _i6 < _Object$keys4.length; _i6++) {
                                            var dotkey = _Object$keys4[_i6];
                                            params[dotkey] = result[dotkey];
                                        }
                                        return;
                                    }
                                    result = JSON.stringify(queryValue);
                                } else "number" == typeof queryValue && (result = queryValue.toString());
                            }
                            params[queryParam] = result;
                        }));
                    }));
                }))).then((function() {
                    Object.keys(params).forEach((function(key) {
                        params[key] = escape(params[key]);
                    }));
                    return params;
                }))) ]).then((function(_ref7) {
                    var url = _ref7[0], query = _ref7[1];
                    return url && !_this7.component.getValidDomain(url) ? url : zalgo_promise_src.a.try((function() {
                        return url || _this7.component.getUrl(_this7.props.env, _this7.props);
                    })).then((function(finalUrl) {
                        query.xcomponent = "1";
                        return Object(lib.r)(finalUrl, {
                            query: query
                        });
                    }));
                }));
                var propsDef, props, params;
            };
            _proto.getDomain = function() {
                var _this8 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this8.props.url;
                })).then((function(url) {
                    return _this8.component.getDomain(url, _this8.props.env) || (_this8.component.buildUrl ? zalgo_promise_src.a.try((function() {
                        return _this8.component.buildUrl(_this8.props);
                    })).then((function(builtUrl) {
                        return _this8.component.getDomain(builtUrl, _this8.props.env);
                    })) : void 0);
                })).then((function(domain) {
                    if (!domain) throw new Error("Could not determine domain");
                    return domain;
                }));
            };
            _proto.getPropsForChild = function() {
                var result = {};
                for (var _i2 = 0, _Object$keys2 = Object.keys(this.props); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    var prop = this.component.getProp(key);
                    prop && !1 === prop.sendToChild || (result[key] = this.props[key]);
                }
                return result;
            };
            _proto.updateProps = function(props) {
                var _this9 = this;
                this.setProps(props, !1);
                return this.onInit.then((function() {
                    if (_this9.childExports) return _this9.childExports.updateProps(_this9.getPropsForChild());
                    throw new Error("Child exports were not available");
                }));
            };
            _proto.openBridge = function(domain) {
                var _this10 = this;
                return zalgo_promise_src.a.try((function() {
                    if (src.bridge && _this10.driver.needsBridge) {
                        var needsBridgeParams = {
                            win: _this10.window
                        };
                        domain && (needsBridgeParams.domain = domain);
                        var needsBridge = src.bridge.needsBridge(needsBridgeParams);
                        var bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);
                        if (bridgeUrl) {
                            bridgeUrl = Object(lib.r)(bridgeUrl, {
                                query: {
                                    version: _this10.component.version
                                }
                            });
                            var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);
                            if (!bridgeDomain) throw new Error("Can not determine domain for bridge");
                            return needsBridge ? src.bridge.openBridge(bridgeUrl, bridgeDomain).then((function(result) {
                                if (result) return result;
                            })) : void 0;
                        }
                        if (needsBridge && domain && !src.bridge.hasBridge(domain, domain)) throw new Error("Bridge url needed to render " + _this10.context);
                    }
                }));
            };
            _proto.open = function() {
                var _this11 = this;
                return zalgo_promise_src.a.try((function() {
                    _this11.component.log("open_" + _this11.context, {
                        windowName: _this11.childWindowName
                    });
                    var win = _this11.props.win;
                    if (!win) return _this11.driver.open.call(_this11);
                    _this11.clean.set("window", win);
                    window.addEventListener("beforeunload", (function() {
                        return win.close();
                    }));
                    window.addEventListener("unload", (function() {
                        return win.close();
                    }));
                    Object(cross_domain_utils_src.b)(_this11.window).name = _this11.childWindowName;
                }));
            };
            _proto.openPrerender = function() {
                var _this12 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this12.component.prerenderTemplate) return _this12.driver.openPrerender.call(_this12);
                }));
            };
            _proto.switchPrerender = function() {
                var _this13 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this13.prerenderWindow && _this13.driver.switchPrerender) return _this13.driver.switchPrerender.call(_this13);
                }));
            };
            _proto.elementReady = function(element) {
                return Object(lib.n)(element).then(lib.F);
            };
            _proto.delegate = function(win) {
                var _this14 = this;
                this.component.log("delegate_" + this.context);
                var props = {
                    uid: this.props.uid,
                    dimensions: this.props.dimensions,
                    onClose: this.props.onClose,
                    onDisplay: this.props.onDisplay
                };
                for (var _i4 = 0, _this$component$getPr2 = this.component.getPropNames(); _i4 < _this$component$getPr2.length; _i4++) {
                    var propName = _this$component$getPr2[_i4];
                    this.component.getProp(propName).allowDelegate && (props[propName] = this.props[propName]);
                }
                var delegate = Object(src.send)(win, constants.POST_MESSAGE.DELEGATE + "_" + this.component.name, {
                    context: this.context,
                    env: this.props.env,
                    options: {
                        context: this.context,
                        childWindowName: this.childWindowName,
                        isWindowClosed: function() {
                            return Object(cross_domain_utils_src.z)(_this14.window);
                        },
                        props: props,
                        overrides: {
                            focus: function() {
                                return _this14.focus();
                            },
                            userClose: function() {
                                return _this14.userClose();
                            },
                            getDomain: function() {
                                return _this14.getDomain();
                            },
                            error: function(err) {
                                return _this14.error(err);
                            },
                            on: function(eventName, handler) {
                                return _this14.on(eventName, handler);
                            }
                        }
                    }
                }).then((function(_ref8) {
                    var data = _ref8.data;
                    _this14.clean.register(data.destroy);
                    return data;
                })).catch((function(err) {
                    throw new Error("Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n" + Object(lib.S)(err));
                }));
                var overrides = this.driver.delegateOverrides;
                var _loop = function() {
                    var key = _Object$keys4[_i6];
                    var val = overrides[key];
                    if (val === constants.DELEGATE.CALL_ORIGINAL) return "continue";
                    var original = _this14[key];
                    _this14[key] = function() {
                        var _arguments = arguments, _this15 = this;
                        return delegate.then((function(data) {
                            var override = data.overrides[key];
                            if (val === constants.DELEGATE.CALL_DELEGATE) return override.apply(_this15, _arguments);
                            if ("function" == typeof val) return val(original, override).apply(_this15, _arguments);
                            throw new Error("Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method");
                        }));
                    };
                };
                for (var _i6 = 0, _Object$keys4 = Object.keys(overrides); _i6 < _Object$keys4.length; _i6++) _loop();
            };
            _proto.watchForClose = function() {
                var _this16 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.window, (function() {
                    _this16.component.log("detect_close_child");
                    return zalgo_promise_src.a.try((function() {
                        return _this16.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                    })).finally((function() {
                        return _this16.destroy();
                    }));
                }), 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            };
            _proto.watchForUnload = function() {
                var _this17 = this;
                var onunload = Object(lib.H)((function() {
                    _this17.component.log("navigate_away");
                    Object(client.h)();
                    _this17.destroyComponent();
                }));
                var unloadWindowListener = Object(lib.b)(window, "unload", onunload);
                this.clean.register("destroyUnloadWindowListener", unloadWindowListener.cancel);
            };
            _proto.loadUrl = function(url) {
                var _this18 = this;
                return zalgo_promise_src.a.try((function() {
                    _this18.component.log("load_url");
                    if (window.location.href.split("#")[0] === url.split("#")[0]) {
                        var _query;
                        url = Object(lib.r)(url, {
                            query: (_query = {}, _query[Object(lib.U)()] = "1", _query)
                        });
                    }
                    return _this18.driver.loadUrl.call(_this18, url);
                }));
            };
            _proto.hijack = function(targetElement) {
                targetElement.target = this.childWindowName;
            };
            _proto.runTimeout = function() {
                var _this19 = this;
                var timeout = this.props.timeout;
                if (timeout) {
                    var id = this.timeout = setTimeout((function() {
                        _this19.component.log("timed_out", {
                            timeout: timeout.toString()
                        });
                        var error = _this19.component.createError("Loading component timed out after " + timeout + " milliseconds");
                        _this19.onInit.reject(error);
                        _this19.props.onTimeout(error);
                    }), timeout);
                    this.clean.register((function() {
                        clearTimeout(id);
                        delete _this19.timeout;
                    }));
                }
            };
            _proto.listeners = function() {
                var _ref9;
                return (_ref9 = {})[constants.POST_MESSAGE.INIT] = function(source, data) {
                    this.childExports = data.exports;
                    this.onInit.resolve(this);
                    this.timeout && clearTimeout(this.timeout);
                    return {
                        props: this.getPropsForChild(),
                        context: this.context
                    };
                }, _ref9[constants.POST_MESSAGE.CLOSE] = function(source, data) {
                    this.close(data.reason);
                }, _ref9[constants.POST_MESSAGE.CHECK_CLOSE] = function() {
                    this.checkClose();
                }, _ref9[constants.POST_MESSAGE.RESIZE] = function(source, data) {
                    var _this20 = this;
                    return zalgo_promise_src.a.try((function() {
                        if (_this20.driver.allowResize) return _this20.resize(data.width, data.height);
                    }));
                }, _ref9[constants.POST_MESSAGE.HIDE] = function() {
                    this.hide();
                }, _ref9[constants.POST_MESSAGE.SHOW] = function() {
                    this.show();
                }, _ref9[constants.POST_MESSAGE.ERROR] = function(source, data) {
                    this.error(new Error(data.error));
                }, _ref9;
            };
            _proto.resize = function(width, height) {
                var _this21 = this;
                return zalgo_promise_src.a.try((function() {
                    _this21.component.log("resize", {
                        height: Object(lib.R)(height),
                        width: Object(lib.R)(width)
                    });
                    _this21.driver.resize.call(_this21, width, height);
                    _this21.props.onResize && _this21.props.onResize();
                }));
            };
            _proto.hide = function() {
                this.container && Object(lib.x)(this.container);
                return this.driver.hide.call(this);
            };
            _proto.show = function() {
                this.container && Object(lib.Q)(this.container);
                return this.driver.show.call(this);
            };
            _proto.checkClose = function() {
                var _this22 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.window, (function() {
                    _this22.userClose();
                }), 50, 500);
                this.clean.register(closeWindowListener.cancel);
            };
            _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            };
            _proto.close = function(reason) {
                var _this23 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                return zalgo_promise_src.a.try((function() {
                    _this23.component.log("close", {
                        reason: reason
                    });
                    _this23.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this23.props.onClose(reason);
                })).then((function() {
                    return zalgo_promise_src.a.all([ _this23.closeComponent(), _this23.closeContainer() ]);
                })).then((function() {
                    return _this23.destroy();
                }));
            };
            _proto.closeContainer = function(reason) {
                var _this24 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                return zalgo_promise_src.a.try((function() {
                    _this24.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this24.props.onClose(reason);
                })).then((function() {
                    return zalgo_promise_src.a.all([ _this24.closeComponent(reason), _this24.hideContainer() ]);
                })).then((function() {
                    return _this24.destroyContainer();
                }));
            };
            _proto.destroyContainer = function() {
                var _this25 = this;
                return zalgo_promise_src.a.try((function() {
                    _this25.clean.run("destroyContainerEvents");
                    _this25.clean.run("destroyContainerTemplate");
                }));
            };
            _proto.closeComponent = function(reason) {
                var _this26 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                var win = this.window;
                return zalgo_promise_src.a.try((function() {
                    return _this26.cancelContainerEvents();
                })).then((function() {
                    _this26.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this26.props.onClose(reason);
                })).then((function() {
                    return _this26.hideComponent();
                })).then((function() {
                    return _this26.destroyComponent();
                })).then((function() {
                    _this26.childExports && _this26.context === constants.CONTEXT_TYPES.POPUP && !Object(cross_domain_utils_src.z)(win) && _this26.childExports.close().catch(lib.F);
                }));
            };
            _proto.destroyComponent = function() {
                this.clean.run("destroyUnloadWindowListener");
                this.clean.run("destroyCloseWindowListener");
                this.clean.run("destroyContainerEvents");
                this.clean.run("destroyWindow");
            };
            _proto.showContainer = function() {
                var _this27 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this27.props.onDisplay) return _this27.props.onDisplay();
                })).then((function() {
                    if (_this27.container) return Object(lib.P)(_this27.container, constants.ANIMATION_NAMES.SHOW_CONTAINER, _this27.clean.register);
                }));
            };
            _proto.showComponent = function() {
                var _this28 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this28.props.onDisplay) return _this28.props.onDisplay();
                })).then((function() {
                    if (_this28.element) return Object(lib.P)(_this28.element, constants.ANIMATION_NAMES.SHOW_COMPONENT, _this28.clean.register);
                }));
            };
            _proto.hideContainer = function() {
                var _this29 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this29.container ? Object(lib.c)(_this29.container, constants.ANIMATION_NAMES.HIDE_CONTAINER, _this29.clean.register) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.hideComponent = function() {
                var _this30 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this30.element ? Object(lib.c)(_this30.element, constants.ANIMATION_NAMES.HIDE_COMPONENT, _this30.clean.register) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.focus = function() {
                if (!this.window || Object(cross_domain_utils_src.z)(this.window)) throw new Error("No window to focus");
                this.component.log("focus");
                this.window.focus();
            };
            _proto.createPrerenderTemplate = function() {
                var _this31 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this31.component.prerenderTemplate ? zalgo_promise_src.a.try((function() {
                        return _this31.prerenderIframe ? Object(lib.e)(_this31.prerenderIframe).then((function() {
                            return _this31.prerenderWindow;
                        })) : _this31.prerenderWindow;
                    })).then((function(win) {
                        var doc;
                        try {
                            doc = win.document;
                        } catch (err) {
                            return;
                        }
                        var el;
                        try {
                            el = _this31.renderTemplate(_this31.component.prerenderTemplate, {
                                jsxDom: lib.C.bind(doc),
                                document: doc
                            });
                        } catch (err) {
                            _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            });
                            console.error(err.stack ? err.stack : err);
                            return;
                        }
                        try {
                            Object(lib.X)(win, el);
                        } catch (err) {
                            _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            });
                            console.error(err.stack ? err.stack : err);
                        }
                        var _ref10 = "object" == typeof _this31.component.autoResize && null !== _this31.component.autoResize ? _this31.component.autoResize : {}, _ref10$width = _ref10.width, width = void 0 !== _ref10$width && _ref10$width, _ref10$height = _ref10.height, height = void 0 !== _ref10$height && _ref10$height, _ref10$element = _ref10.element, element = void 0 === _ref10$element ? "body" : _ref10$element;
                        (element = function(id, doc) {
                            void 0 === doc && (doc = document);
                            return (element = id) instanceof window.Element || null !== element && "object" == typeof element && 1 === element.nodeType && "object" == typeof element.style && "object" == typeof element.ownerDocument ? id : "string" == typeof id ? doc.querySelector(id) : void 0;
                            var element;
                        }(element, doc)) && (width || height) && onResize(element, (function(_ref11) {
                            _this31.resize(width ? _ref11.width : void 0, height ? _ref11.height : void 0);
                        }), {
                            width: width,
                            height: height,
                            win: win
                        });
                    })) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.renderTemplate = function(renderer, options) {
                var _this32 = this;
                void 0 === options && (options = {});
                var _ref12 = this.component.dimensions || {}, _ref12$width = _ref12.width, width = void 0 === _ref12$width ? constants.DEFAULT_DIMENSIONS.WIDTH + "px" : _ref12$width, _ref12$height = _ref12.height, height = void 0 === _ref12$height ? constants.DEFAULT_DIMENSIONS.HEIGHT + "px" : _ref12$height;
                return renderer.call(this, Object(esm_extends.a)({
                    id: constants.CLASS_NAMES.ZOID + "-" + this.component.tag + "-" + this.props.uid,
                    props: renderer.__xdomain__ ? null : this.props,
                    tag: this.component.tag,
                    context: this.context,
                    outlet: this.getOutlet(),
                    CLASS: constants.CLASS_NAMES,
                    ANIMATION: constants.ANIMATION_NAMES,
                    CONTEXT: constants.CONTEXT_TYPES,
                    EVENT: constants.EVENTS,
                    actions: {
                        close: function() {
                            return _this32.userClose();
                        },
                        focus: function() {
                            return _this32.focus();
                        }
                    },
                    on: function(eventName, handler) {
                        return _this32.on(eventName, handler);
                    },
                    jsxDom: lib.C,
                    document: document,
                    dimensions: {
                        width: width,
                        height: height
                    }
                }, options));
            };
            _proto.openContainer = function(element) {
                var _this33 = this;
                return zalgo_promise_src.a.try((function() {
                    var el;
                    if (!(el = element ? Object(lib.u)(element) : document.body)) throw new Error("Could not find element to open container into");
                    isShadowElement(el) && (el = function(element) {
                        var shadowHost = function(element) {
                            var shadowRoot = function(element) {
                                for (;element.parentNode; ) element = element.parentNode;
                                if (isShadowElement(element)) return element;
                            }(element);
                            if (shadowRoot.host) return shadowRoot.host;
                        }(element);
                        if (!shadowHost) throw new Error("Element is not in shadow dom");
                        if (isShadowElement(shadowHost)) throw new Error("Host element is also in shadow dom");
                        var slotName = "shadow-slot-" + (chars = "0123456789abcdef", "xxxxxxxxxx".replace(/./g, (function() {
                            return chars.charAt(Math.floor(Math.random() * chars.length));
                        })) + "_" + function(str) {
                            if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (function(m, p1) {
                                return String.fromCharCode(parseInt(p1, 16));
                            })));
                            if ("undefined" != typeof Buffer) return Buffer.from(str, "utf8").toString("base64");
                            throw new Error("Can not find window.btoa or Buffer");
                        }((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase());
                        var chars;
                        var slot = document.createElement("slot");
                        slot.setAttribute("name", slotName);
                        element.appendChild(slot);
                        var slotProvider = document.createElement("div");
                        slotProvider.setAttribute("slot", slotName);
                        shadowHost.appendChild(slotProvider);
                        return slotProvider;
                    }(el));
                    if (_this33.component.containerTemplate) {
                        var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                            container: el
                        });
                        _this33.container = container;
                        Object(lib.x)(_this33.container);
                        Object(lib.d)(el, _this33.container);
                        if (_this33.driver.renderedIntoContainerTemplate) {
                            _this33.element = _this33.getOutlet();
                            Object(lib.x)(_this33.element);
                            if (!_this33.element) throw new Error("Could not find element to render component into");
                            Object(lib.x)(_this33.element);
                        }
                        _this33.clean.register("destroyContainerTemplate", (function() {
                            _this33.container && _this33.container.parentNode && _this33.container.parentNode.removeChild(_this33.container);
                            delete _this33.container;
                        }));
                    } else if (_this33.driver.renderedIntoContainerTemplate) throw new Error("containerTemplate needed to render " + _this33.context);
                }));
            };
            _proto.cancelContainerEvents = function() {
                this.clean.run("destroyContainerEvents");
            };
            _proto.destroy = function() {
                var _this34 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this34.clean.hasTasks()) {
                        _this34.component.log("destroy");
                        Object(client.h)();
                        return _this34.clean.all();
                    }
                })).then((function() {
                    if (_this34.props && _this34.props.onDestroy) return _this34.props.onDestroy();
                }));
            };
            _proto.tryInit = function(method) {
                var _this35 = this;
                return zalgo_promise_src.a.try(method).catch((function(err) {
                    _this35.onInit.reject(err);
                })).then((function() {
                    return _this35.onInit;
                }));
            };
            _proto.error = function(err) {
                var _this36 = this;
                return zalgo_promise_src.a.try((function() {
                    _this36.handledErrors = _this36.handledErrors || [];
                    if (-1 === _this36.handledErrors.indexOf(err)) {
                        _this36.handledErrors.push(err);
                        _this36.onInit.reject(err);
                        return _this36.destroy();
                    }
                })).then((function() {
                    if (_this36.props.onError) return _this36.props.onError(err);
                })).catch((function(errErr) {
                    throw new Error("An error was encountered while handling error:\n\n " + Object(lib.S)(err) + "\n\n" + Object(lib.S)(errErr));
                })).then((function() {
                    if (!_this36.props.onError) throw err;
                }));
            };
            ParentComponent.destroyAll = function() {
                var results = [];
                for (;ParentComponent.activeComponents.length; ) results.push(ParentComponent.activeComponents[0].destroy());
                return zalgo_promise_src.a.all(results).then(lib.F);
            };
            _createClass(ParentComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]);
            return ParentComponent;
        }(base_BaseComponent)).activeComponents = [], _class2)).prototype, "getOutlet", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "getOutlet"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "prefetch", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "prefetch"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "loadHTML", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "loadHTML"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "buildUrl", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "buildUrl"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "open", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "switchPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "switchPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "close", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "destroyContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "destroyContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "createPrerenderTemplate", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "createPrerenderTemplate"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openContainer"), _class.prototype), 
        _class);
        var delegate_DelegateComponent = function(_BaseComponent) {
            Object(inheritsLoose.a)(DelegateComponent, _BaseComponent);
            function DelegateComponent(component, source, options) {
                var _this;
                (_this = _BaseComponent.call(this) || this).source = void 0;
                _this.context = void 0;
                _this.props = void 0;
                _this.focus = void 0;
                _this.userClose = void 0;
                _this.getDomain = void 0;
                _this.error = void 0;
                _this.on = void 0;
                _this.childWindowName = void 0;
                _this.isWindowClosed = void 0;
                _this.component = component;
                _this.clean.set("source", source);
                _this.context = options.context;
                _this.props = {
                    uid: options.props.uid,
                    dimensions: options.props.dimensions,
                    onClose: options.props.onClose,
                    onDisplay: options.props.onDisplay
                };
                for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                    var propName = _component$getPropNam2[_i2];
                    _this.component.getProp(propName).allowDelegate && (_this.props[propName] = options.props[propName]);
                }
                _this.focus = function() {
                    return zalgo_promise_src.a.all([ _this.isWindowClosed().then((function(closed) {
                        closed || window.open("", _this.childWindowName);
                    })), options.overrides.focus.call(Object(assertThisInitialized.a)(_this)) ]).then(lib.F);
                };
                _this.clean.register("destroyFocusOverride", (function() {
                    _this.focus = lib.F;
                }));
                _this.userClose = options.overrides.userClose;
                _this.getDomain = options.overrides.getDomain;
                _this.error = options.overrides.error;
                _this.on = options.overrides.on;
                for (var _i4 = 0, _Object$keys2 = Object.keys(RENDER_DRIVERS[options.context].delegateOverrides); _i4 < _Object$keys2.length; _i4++) {
                    var key = _Object$keys2[_i4];
                    _this[key] = parent_ParentComponent.prototype[key];
                }
                _this.childWindowName = options.childWindowName;
                _this.isWindowClosed = options.isWindowClosed;
                parent_ParentComponent.prototype.registerActiveComponent.call(Object(assertThisInitialized.a)(_this));
                _this.watchForClose();
                return _this;
            }
            var _proto = DelegateComponent.prototype;
            _proto.watchForClose = function() {
                var _this2 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.source, (function() {
                    return _this2.destroy();
                }), 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            };
            _proto.getOverrides = function(context) {
                var overrides = {};
                var self = this;
                var _loop = function() {
                    var key = _Object$keys4[_i6];
                    overrides[key] = function() {
                        return parent_ParentComponent.prototype[key].apply(self, arguments);
                    };
                };
                for (var _i6 = 0, _Object$keys4 = Object.keys(RENDER_DRIVERS[context].delegateOverrides); _i6 < _Object$keys4.length; _i6++) _loop();
                return overrides;
            };
            _proto.destroy = function() {
                return this.clean.all();
            };
            _createClass(DelegateComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]);
            return DelegateComponent;
        }(base_BaseComponent);
        var drivers = __webpack_require__(29);
        function defaultContainerTemplate(_ref) {
            var id = _ref.id, CLASS = _ref.CLASS, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _ref$dimensions = _ref.dimensions;
            return jsxDom("div", {
                id: id,
                class: CLASS.ZOID + " " + CLASS.ZOID + "-tag-" + _ref.tag + " " + CLASS.ZOID + "-context-" + _ref.context
            }, jsxDom("style", null, "\n                    #" + id + ", #" + id + " > ." + CLASS.OUTLET + " {\n                        width: " + _ref$dimensions.width + ";\n                        height: " + _ref$dimensions.height + ";\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                    }\n                "), outlet);
        }
        function defaultPrerenderTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("style", null, "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    ")), jsxDom("body", null, jsxDom("div", {
                class: "spinner"
            }, jsxDom("div", {
                id: "loader",
                class: "loader"
            }))));
        }
        var component_class, component_class2;
        var component_drivers = {
            angular: drivers.angular,
            angular2: drivers.angular2,
            glimmer: drivers.glimmer,
            react: drivers.react,
            vue: drivers.vue,
            script: drivers.script
        };
        var component_Component = (_applyDecoratedDescriptor((component_class = ((component_class2 = function(_BaseComponent) {
            Object(inheritsLoose.a)(Component, _BaseComponent);
            function Component(options) {
                var _this;
                (_this = _BaseComponent.call(this) || this).name = void 0;
                _this.looseProps = void 0;
                _this.tag = void 0;
                _this.url = void 0;
                _this.domain = void 0;
                _this.bridgeUrl = void 0;
                _this.bridgeDomain = void 0;
                _this.props = void 0;
                _this.builtinProps = void 0;
                _this.dimensions = void 0;
                _this.scrolling = void 0;
                _this.autoResize = void 0;
                _this.listenForResize = void 0;
                _this.defaultLogLevel = void 0;
                _this.allowedParentDomains = void 0;
                _this.version = void 0;
                _this.defaultEnv = void 0;
                _this.buildUrl = void 0;
                _this.contexts = void 0;
                _this.defaultContext = void 0;
                _this.containerTemplate = void 0;
                _this.prerenderTemplate = void 0;
                _this.validate = void 0;
                _this.unsafeRenderTo = void 0;
                _this.driverCache = void 0;
                _this.xchild = void 0;
                _this.xprops = void 0;
                !function(options) {
                    if (!options) throw new Error("Expected options to be passed");
                    if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) throw new Error("Invalid options.tag: " + options.tag);
                    !function(options) {
                        if (options.props && "object" != typeof options.props) throw new Error("Expected options.props to be an object");
                        if (options.props) for (var _i2 = 0, _Object$keys2 = Object.keys(options.props); _i2 < _Object$keys2.length; _i2++) {
                            var key = _Object$keys2[_i2];
                            var prop = options.props[key];
                            if (!prop || "object" != typeof prop) throw new Error("Expected options.props." + key + " to be an object");
                            if (!prop.type) throw new Error("Expected prop.type");
                            if (-1 === constants.PROP_TYPES_LIST.indexOf(prop.type)) throw new Error("Expected prop.type to be one of " + constants.PROP_TYPES_LIST.join(", "));
                            if (prop.required && prop.def) throw new Error("Required prop can not have a default value");
                        }
                    }(options);
                    if (options.dimensions) {
                        if (options.dimensions && !Object(lib.B)(options.dimensions.width) && !Object(lib.A)(options.dimensions.width)) throw new Error("Expected options.dimensions.width to be a px or % string value");
                        if (options.dimensions && !Object(lib.B)(options.dimensions.height) && !Object(lib.A)(options.dimensions.height)) throw new Error("Expected options.dimensions.height to be a px or % string value");
                    }
                    if (options.contexts) {
                        var anyEnabled = !1;
                        for (var _i4 = 0, _Object$keys4 = Object.keys(options.contexts); _i4 < _Object$keys4.length; _i4++) {
                            var context = _Object$keys4[_i4];
                            if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(context)) throw new Error("Unsupported context type: " + context);
                            (options.contexts && options.contexts[context] || options.contexts && void 0 === options.contexts[context]) && (anyEnabled = !0);
                        }
                        if (!anyEnabled) throw new Error("No context type is enabled");
                    }
                    if (options.defaultContext) {
                        if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(options.defaultContext)) throw new Error("Unsupported context type: " + (options.defaultContext || "unknown"));
                        if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) throw new Error("Disallowed default context type: " + (options.defaultContext || "unknown"));
                    }
                    if (options.url && options.buildUrl) throw new Error("Can not pass both options.url and options.buildUrl");
                    if (options.defaultEnv) {
                        if ("string" != typeof options.defaultEnv) throw new TypeError("Expected options.defaultEnv to be a string");
                        if (!options.buildUrl && "object" != typeof options.url) throw new Error("Expected options.url to be an object mapping env->url");
                        if (options.url && "object" == typeof options.url && !options.url[options.defaultEnv]) throw new Error("No url found for default env: " + options.defaultEnv);
                    }
                    if (options.url && "object" == typeof options.url) {
                        if (!options.defaultEnv) throw new Error("Must pass options.defaultEnv with env->url mapping");
                        for (var _i6 = 0, _Object$keys6 = Object.keys(options.url); _i6 < _Object$keys6.length; _i6++) {
                            var env = _Object$keys6[_i6];
                            if (!options.url[env]) throw new Error("No url specified for env: " + env);
                        }
                    }
                    if (options.prerenderTemplate && "function" != typeof options.prerenderTemplate) throw new Error("Expected options.prerenderTemplate to be a function");
                    if (options.containerTemplate && "function" != typeof options.containerTemplate) throw new Error("Expected options.containerTemplate to be a function");
                }(options);
                _this.addProp(options, "tag");
                _this.addProp(options, "defaultLogLevel", "info");
                _this.addProp(options, "allowedParentDomains", constants.WILDCARD);
                Object(lib.O)(_this.defaultLogLevel);
                if (Component.components[_this.tag]) throw new Error("Can not register multiple components with the same tag");
                _this.addProp(options, "name", _this.tag.replace(/-/g, "_"));
                _this.builtinProps = {
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultEnv;
                        }
                    },
                    uid: {
                        type: "string",
                        def: function() {
                            return Object(lib.U)();
                        },
                        queryParam: !0
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultLogLevel;
                        }
                    },
                    url: {
                        type: "string",
                        required: !1,
                        promise: !0,
                        sendToChild: !1
                    },
                    win: {
                        type: "object",
                        required: !1,
                        sendToChild: !1
                    },
                    dimensions: {
                        type: "object",
                        required: !1
                    },
                    version: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.version;
                        }
                    },
                    timeout: {
                        type: "number",
                        required: !1,
                        sendToChild: !1
                    },
                    onDisplay: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        memoize: !0,
                        sendToChild: !1
                    },
                    onEnter: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onRender: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onClose: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onDestroy: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onResize: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        sendToChild: !1
                    },
                    onTimeout: {
                        type: "function",
                        required: !1,
                        memoize: !0,
                        promisify: !0,
                        sendToChild: !1,
                        def: function() {
                            return function(err) {
                                if (this.props.onError) return this.props.onError(err);
                                throw err;
                            };
                        }
                    },
                    onError: {
                        type: "function",
                        required: !1,
                        promisify: !0,
                        sendToChild: !0,
                        once: !0,
                        def: function() {
                            return function(err) {
                                setTimeout((function() {
                                    throw err;
                                }));
                            };
                        }
                    }
                };
                _this.props = options.props || {};
                options.props || (_this.looseProps = !0);
                _this.addProp(options, "dimensions");
                _this.addProp(options, "scrolling");
                _this.addProp(options, "listenForResize");
                _this.addProp(options, "version", "latest");
                _this.addProp(options, "defaultEnv");
                _this.addProp(options, "buildUrl");
                _this.addProp(options, "url");
                _this.addProp(options, "domain");
                _this.addProp(options, "bridgeUrl");
                _this.addProp(options, "bridgeDomain");
                _this.addProp(options, "attributes", {});
                _this.addProp(options, "contexts", {
                    iframe: !0,
                    popup: !1
                });
                _this.addProp(options, "defaultContext");
                _this.addProp(options, "autoResize", !1);
                _this.addProp(options, "containerTemplate", defaultContainerTemplate);
                _this.addProp(options, "prerenderTemplate", defaultPrerenderTemplate);
                _this.addProp(options, "validate");
                _this.addProp(options, "unsafeRenderTo", !1);
                Component.components[_this.tag] = Object(assertThisInitialized.a)(_this);
                _this.registerDrivers();
                _this.registerChild();
                _this.listenDelegate();
                return _this;
            }
            var _proto = Component.prototype;
            _proto.getPropNames = function() {
                var props = Object.keys(this.props);
                for (var _i2 = 0, _Object$keys2 = Object.keys(this.builtinProps); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    -1 === props.indexOf(key) && props.push(key);
                }
                return props;
            };
            _proto.getProp = function(name) {
                return this.props[name] || this.builtinProps[name];
            };
            _proto.registerDrivers = function() {
                this.driverCache = {};
                for (var _i4 = 0, _Object$keys4 = Object.keys(component_drivers); _i4 < _Object$keys4.length; _i4++) {
                    var driverName = _Object$keys4[_i4];
                    if (0 !== driverName.indexOf("_")) {
                        var glob = component_drivers[driverName].global();
                        glob && this.driver(driverName, glob);
                    }
                }
            };
            _proto.driver = function(name, dep) {
                if (!component_drivers[name]) throw new Error("Could not find driver for framework: " + name);
                this.driverCache[name] || (this.driverCache[name] = component_drivers[name].register(this, dep));
                return this.driverCache[name];
            };
            _proto.registerChild = function() {
                var _this2 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this2.isChild()) return new child_ChildComponent(_this2);
                }));
            };
            _proto.listenDelegate = function() {
                var _this3 = this;
                Object(src.on)(constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name, (function() {
                    return !0;
                }));
                Object(src.on)(constants.POST_MESSAGE.DELEGATE + "_" + this.name, (function(_ref) {
                    var source = _ref.source, origin = _ref.origin, data = _ref.data;
                    var domain = _this3.getDomain(null, data.env || _this3.defaultEnv);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.B)(domain, origin)) throw new Error("Can not render from " + origin + " - expected " + domain.toString());
                    var delegate = _this3.delegate(source, data.options);
                    return {
                        overrides: delegate.getOverrides(data.context),
                        destroy: function() {
                            return delegate.destroy();
                        }
                    };
                }));
            };
            _proto.canRenderTo = function(win) {
                return Object(src.send)(win, constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name).then((function(_ref2) {
                    return _ref2.data;
                })).catch((function() {
                    return !1;
                }));
            };
            _proto.getValidDomain = function(url) {
                if (url) {
                    var domain = Object(cross_domain_utils_src.i)(url);
                    if ("string" == typeof this.domain && domain === this.domain) return domain;
                    var domains = this.domain;
                    if (domains && "object" == typeof domains && !(domains instanceof RegExp)) for (var _i6 = 0, _Object$keys6 = Object.keys(domains); _i6 < _Object$keys6.length; _i6++) {
                        var env = _Object$keys6[_i6];
                        if ("test" !== env && domain === domains[env]) return domain;
                    }
                }
            };
            _proto.getDomain = function(url, env) {
                var domain = this.getForEnv(this.domain, env);
                if (domain) return domain;
                if (domain = this.getValidDomain(url)) return domain;
                var envUrl = this.getForEnv(this.url, env);
                return envUrl ? Object(cross_domain_utils_src.i)(envUrl) : url ? Object(cross_domain_utils_src.i)(url) : void 0;
            };
            _proto.getBridgeUrl = function(env) {
                return this.getForEnv(this.bridgeUrl, env);
            };
            _proto.getForEnv = function(item, env) {
                if (item) {
                    if ("string" == typeof item || item instanceof RegExp) return item;
                    env || (env = this.defaultEnv);
                    if (env) return env && "object" == typeof item && item[env] ? item[env] : void 0;
                }
            };
            _proto.getBridgeDomain = function(env) {
                var bridgeDomain = this.getForEnv(this.bridgeDomain, env);
                if (bridgeDomain) return bridgeDomain;
                var bridgeUrl = this.getBridgeUrl(env);
                return bridgeUrl ? Object(cross_domain_utils_src.i)(bridgeUrl) : void 0;
            };
            _proto.getUrl = function(env, props) {
                var url = this.getForEnv(this.url, env);
                if (url) return url;
                if (this.buildUrl) return this.buildUrl(props);
                throw new Error("Unable to get url");
            };
            _proto.isZoidComponent = function() {
                return isZoidComponentWindow();
            };
            _proto.isChild = function() {
                if (!isZoidComponentWindow()) return !1;
                var _getComponentMeta = getComponentMeta(), tag = _getComponentMeta.tag, childDomain = _getComponentMeta.childDomain;
                return (!childDomain || childDomain === Object(cross_domain_utils_src.h)()) && tag === this.tag;
            };
            _proto.createError = function(message, tag) {
                return new Error("[" + (tag || this.tag) + "] " + message);
            };
            _proto.init = function(props, context, element) {
                return new parent_ParentComponent(this, this.getRenderContext(context, element), {
                    props: props
                });
            };
            _proto.delegate = function(source, options) {
                return new delegate_DelegateComponent(this, source, options);
            };
            _proto.validateRenderContext = function(context, element) {
                if (context && !this.contexts[context]) throw new Error("[" + this.tag + "] Can not render to " + context);
                if (!element && context === constants.CONTEXT_TYPES.IFRAME) throw new Error("[" + this.tag + "] Context type " + constants.CONTEXT_TYPES.IFRAME + " requires an element selector");
            };
            _proto.getDefaultContext = function() {
                if (this.defaultContext) return this.defaultContext;
                if (this.contexts[constants.CONTEXT_TYPES.IFRAME]) return constants.CONTEXT_TYPES.IFRAME;
                if (this.contexts[constants.CONTEXT_TYPES.POPUP]) return constants.CONTEXT_TYPES.POPUP;
                throw new Error("Can not determine default context");
            };
            _proto.getRenderContext = function(context, element) {
                context = context || this.getDefaultContext();
                this.validateRenderContext(context, element);
                return context;
            };
            _proto.render = function(props, element) {
                var _this4 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this4, _this4.getRenderContext(null, element), {
                        props: props
                    }).render(element);
                }));
            };
            _proto.renderIframe = function(props, element) {
                var _this5 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this5, _this5.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).render(element);
                }));
            };
            _proto.renderPopup = function(props) {
                var _this6 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this6, _this6.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).render();
                }));
            };
            _proto.renderTo = function(win, props, element) {
                var _this7 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this7, _this7.getRenderContext(null, element), {
                        props: props
                    }).renderTo(win, element);
                }));
            };
            _proto.renderIframeTo = function(win, props, element) {
                var _this8 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this8, _this8.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).renderTo(win, element);
                }));
            };
            _proto.renderPopupTo = function(win, props) {
                var _this9 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this9, _this9.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).renderTo(win);
                }));
            };
            _proto.prerender = function(props, element) {
                var instance = new parent_ParentComponent(this, this.getRenderContext(null, element), {
                    props: props
                });
                instance.prefetch();
                return {
                    render: function(innerProps, innerElement) {
                        innerProps && instance.updateProps(innerProps);
                        return instance.render(innerElement);
                    },
                    renderTo: function(win, innerProps, innerElement) {
                        innerProps && instance.updateProps(innerProps);
                        return instance.renderTo(win, innerElement);
                    },
                    get html() {
                        return instance.html;
                    },
                    set html(value) {
                        instance.html = value;
                    }
                };
            };
            _proto.log = function(event, payload) {
                void 0 === payload && (payload = {});
                Object(lib.z)(this.name, event, payload);
            };
            _proto.logWarning = function(event, payload) {
                Object(lib.V)(this.name, event, payload);
            };
            _proto.logError = function(event, payload) {
                Object(lib.o)(this.name, event, payload);
            };
            Component.getByTag = function(tag) {
                return Component.components[tag];
            };
            return Component;
        }(base_BaseComponent)).components = {}, component_class2)).prototype, "getPropNames", [ lib.D ], Object.getOwnPropertyDescriptor(component_class.prototype, "getPropNames"), component_class.prototype), 
        component_class);
        function create(options) {
            return new component_Component(options);
        }
        function getByTag(tag) {
            return component_Component.getByTag(tag);
        }
        function interface_destroyAll() {
            return parent_ParentComponent.destroyAll();
        }
        var postRobot = src;
        var CONSTANTS = constants;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", (function() {
            return openTunnelToOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", (function() {
            return needsBridgeForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", (function() {
            return needsBridgeForWin;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", (function() {
            return needsBridgeForDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridge", (function() {
            return needsBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "getBridgeName", (function() {
            return getBridgeName;
        }));
        __webpack_require__.d(__webpack_exports__, "isBridge", (function() {
            return isBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "documentBodyReady", (function() {
            return documentBodyReady;
        }));
        __webpack_require__.d(__webpack_exports__, "registerRemoteWindow", (function() {
            return registerRemoteWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "findRemoteWindow", (function() {
            return findRemoteWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "registerRemoteSendMessage", (function() {
            return registerRemoteSendMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "rejectRemoteSendMessage", (function() {
            return rejectRemoteSendMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "sendBridgeMessage", (function() {
            return sendBridgeMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "hasBridge", (function() {
            return hasBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "openBridge", (function() {
            return openBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "linkUrl", (function() {
            return linkUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyBridges", (function() {
            return destroyBridges;
        }));
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        var lib = __webpack_require__(16);
        var global = __webpack_require__(9);
        global.a.tunnelWindows = global.a.tunnelWindows || {};
        global.a.tunnelWindowId = 0;
        function deleteTunnelWindow(id) {
            try {
                global.a.tunnelWindows[id] && delete global.a.tunnelWindows[id].source;
            } catch (err) {}
            delete global.a.tunnelWindows[id];
        }
        function getTunnelWindow(id) {
            return global.a.tunnelWindows[id];
        }
        global.a.openTunnelToParent = function(_ref2) {
            var name = _ref2.name, source = _ref2.source, canary = _ref2.canary, sendMessage = _ref2.sendMessage;
            var parentWindow = Object(src.n)(window);
            if (!parentWindow) throw new Error("No parent window found to open tunnel to");
            var id = function(_ref) {
                var name = _ref.name, source = _ref.source, canary = _ref.canary, sendMessage = _ref.sendMessage;
                !function() {
                    var tunnelWindows = global.a.tunnelWindows;
                    for (var _i2 = 0, _Object$keys2 = Object.keys(tunnelWindows); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        var tunnelWindow = tunnelWindows[key];
                        try {
                            Object(lib.j)(tunnelWindow.source);
                        } catch (err) {
                            deleteTunnelWindow(key);
                            continue;
                        }
                        Object(src.z)(tunnelWindow.source) && deleteTunnelWindow(key);
                    }
                }();
                global.a.tunnelWindowId += 1;
                global.a.tunnelWindows[global.a.tunnelWindowId] = {
                    name: name,
                    source: source,
                    canary: canary,
                    sendMessage: sendMessage
                };
                return global.a.tunnelWindowId;
            }({
                name: name,
                source: source,
                canary: canary,
                sendMessage: sendMessage
            });
            return global.a.send(parentWindow, conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                name: name,
                sendMessage: function() {
                    var tunnelWindow = getTunnelWindow(id);
                    try {
                        Object(lib.j)(tunnelWindow && tunnelWindow.source);
                    } catch (err) {
                        deleteTunnelWindow(id);
                        return;
                    }
                    if (tunnelWindow && tunnelWindow.source && !Object(src.z)(tunnelWindow.source)) {
                        try {
                            tunnelWindow.canary();
                        } catch (err) {
                            return;
                        }
                        tunnelWindow.sendMessage.apply(this, arguments);
                    }
                }
            }, {
                domain: conf.b.WILDCARD
            });
        };
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_safe_weakmap_src = __webpack_require__(17);
        function needsBridgeForBrowser() {
            return !!Object(src.p)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        function needsBridgeForWin(win) {
            return !Object(src.w)(window, win);
        }
        function needsBridgeForDomain(domain, win) {
            if (domain) {
                if (Object(src.h)() !== Object(src.i)(domain)) return !0;
            } else if (win && !Object(src.v)(win)) return !0;
            return !1;
        }
        function needsBridge(_ref) {
            var win = _ref.win, domain = _ref.domain;
            return !(!needsBridgeForBrowser() || domain && !needsBridgeForDomain(domain, win) || win && !needsBridgeForWin(win));
        }
        function getBridgeName(domain) {
            var sanitizedDomain = (domain = domain || Object(src.i)(domain)).replace(/[^a-zA-Z0-9]+/g, "_");
            return conf.b.BRIDGE_NAME_PREFIX + "_" + sanitizedDomain;
        }
        function isBridge() {
            return Boolean(window.name && window.name === getBridgeName(Object(src.h)()));
        }
        var documentBodyReady = new zalgo_promise_src.a((function(resolve) {
            if (window.document && window.document.body) return resolve(window.document.body);
            var interval = setInterval((function() {
                if (window.document && window.document.body) {
                    clearInterval(interval);
                    return resolve(window.document.body);
                }
            }), 10);
        }));
        global.a.remoteWindows = global.a.remoteWindows || new cross_domain_safe_weakmap_src.a;
        function registerRemoteWindow(win) {
            global.a.remoteWindows.set(win, {
                sendMessagePromise: new zalgo_promise_src.a
            });
        }
        function findRemoteWindow(win) {
            return global.a.remoteWindows.get(win);
        }
        function registerRemoteSendMessage(win, domain, sendMessage) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to register sendMessage to");
            var sendMessageWrapper = function(remoteWin, message, remoteDomain) {
                if (remoteWin !== win) throw new Error("Remote window does not match window");
                if (!Object(src.B)(remoteDomain, domain)) throw new Error("Remote domain " + remoteDomain + " does not match domain " + domain);
                sendMessage(message);
            };
            remoteWindow.sendMessagePromise.resolve(sendMessageWrapper);
            remoteWindow.sendMessagePromise = zalgo_promise_src.a.resolve(sendMessageWrapper);
        }
        function rejectRemoteSendMessage(win, err) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found on which to reject sendMessage");
            remoteWindow.sendMessagePromise.asyncReject(err);
        }
        function sendBridgeMessage(win, message, domain) {
            var messagingChild = Object(src.t)(window, win);
            var messagingParent = Object(src.t)(win, window);
            if (!messagingChild && !messagingParent) throw new Error("Can only send messages to and from parent and popup windows");
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to send message to");
            return remoteWindow.sendMessagePromise.then((function(sendMessage) {
                return sendMessage(win, message, domain);
            }));
        }
        var awaitRemoteBridgeForWindow = Object(lib.r)((function(win) {
            return zalgo_promise_src.a.try((function() {
                for (var _i2 = 0, _getFrames2 = Object(src.k)(win); _i2 < _getFrames2.length; _i2++) {
                    var frame = _getFrames2[_i2];
                    try {
                        if (frame && frame !== window && Object(src.v)(frame) && frame[conf.b.WINDOW_PROPS.POSTROBOT]) return frame;
                    } catch (err) {
                        continue;
                    }
                }
                try {
                    var _frame = Object(src.j)(win, getBridgeName(Object(src.h)()));
                    if (!_frame) return;
                    return Object(src.v)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT] ? _frame : new zalgo_promise_src.a((function(resolve) {
                        var interval;
                        var timeout;
                        interval = setInterval((function() {
                            if (_frame && Object(src.v)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT]) {
                                clearInterval(interval);
                                clearTimeout(timeout);
                                return resolve(_frame);
                            }
                        }), 100);
                        timeout = setTimeout((function() {
                            clearInterval(interval);
                            return resolve();
                        }), 2e3);
                    }));
                } catch (err) {}
            }));
        }));
        function openTunnelToOpener() {
            return zalgo_promise_src.a.try((function() {
                var opener = Object(src.m)(window);
                if (opener && needsBridge({
                    win: opener
                })) {
                    registerRemoteWindow(opener);
                    return awaitRemoteBridgeForWindow(opener).then((function(bridge) {
                        return bridge ? window.name ? bridge[conf.b.WINDOW_PROPS.POSTROBOT].openTunnelToParent({
                            name: window.name,
                            source: window,
                            canary: function() {},
                            sendMessage: function(message) {
                                try {
                                    Object(lib.j)(window);
                                } catch (err) {
                                    return;
                                }
                                if (window && !window.closed) try {
                                    global.a.receiveMessage({
                                        data: message,
                                        origin: this.origin,
                                        source: this.source
                                    });
                                } catch (err) {
                                    zalgo_promise_src.a.reject(err);
                                }
                            }
                        }).then((function(_ref) {
                            var source = _ref.source, origin = _ref.origin, data = _ref.data;
                            if (source !== opener) throw new Error("Source does not match opener");
                            registerRemoteSendMessage(source, origin, data.sendMessage);
                        })).catch((function(err) {
                            rejectRemoteSendMessage(opener, err);
                            throw err;
                        })) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: window does not have a name")) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: no bridge found in opener"));
                    }));
                }
            }));
        }
        global.a.bridges = global.a.bridges || {};
        global.a.bridgeFrames = global.a.bridgeFrames || {};
        global.a.popupWindowsByWin = global.a.popupWindowsByWin || new cross_domain_safe_weakmap_src.a;
        global.a.popupWindowsByName = global.a.popupWindowsByName || {};
        function hasBridge(url, domain) {
            domain = domain || Object(src.i)(url);
            return Boolean(global.a.bridges[domain]);
        }
        function openBridge(url, domain) {
            domain = domain || Object(src.i)(url);
            if (global.a.bridges[domain]) return global.a.bridges[domain];
            global.a.bridges[domain] = zalgo_promise_src.a.try((function() {
                if (Object(src.h)() === domain) throw new Error("Can not open bridge on the same domain as current domain: " + domain);
                var name = getBridgeName(domain);
                if (Object(src.j)(window, name)) throw new Error("Frame with name " + name + " already exists on page");
                var iframe = function(name, url) {
                    var iframe = document.createElement("iframe");
                    iframe.setAttribute("name", name);
                    iframe.setAttribute("id", name);
                    iframe.setAttribute("style", "display: none; margin: 0; padding: 0; border: 0px none; overflow: hidden;");
                    iframe.setAttribute("frameborder", "0");
                    iframe.setAttribute("border", "0");
                    iframe.setAttribute("scrolling", "no");
                    iframe.setAttribute("allowTransparency", "true");
                    iframe.setAttribute("tabindex", "-1");
                    iframe.setAttribute("hidden", "true");
                    iframe.setAttribute("title", "");
                    iframe.setAttribute("role", "presentation");
                    iframe.src = url;
                    return iframe;
                }(name, url);
                global.a.bridgeFrames[domain] = iframe;
                return documentBodyReady.then((function(body) {
                    body.appendChild(iframe);
                    var bridge = iframe.contentWindow;
                    !function(source, domain) {
                        global.a.on(conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                            window: source,
                            domain: domain
                        }, (function(_ref) {
                            var origin = _ref.origin, data = _ref.data;
                            if (origin !== domain) throw new Error("Domain " + domain + " does not match origin " + origin);
                            if (!data.name) throw new Error("Register window expected to be passed window name");
                            if (!data.sendMessage) throw new Error("Register window expected to be passed sendMessage method");
                            if (!global.a.popupWindowsByName[data.name]) throw new Error("Window with name " + data.name + " does not exist, or was not opened by this window");
                            if (!global.a.popupWindowsByName[data.name].domain) throw new Error("We do not have a registered domain for window " + data.name);
                            if (global.a.popupWindowsByName[data.name].domain !== origin) throw new Error("Message origin " + origin + " does not matched registered window origin " + global.a.popupWindowsByName[data.name].domain);
                            registerRemoteSendMessage(global.a.popupWindowsByName[data.name].win, domain, data.sendMessage);
                            return {
                                sendMessage: function(message) {
                                    if (window && !window.closed) {
                                        var winDetails = global.a.popupWindowsByName[data.name];
                                        if (winDetails) try {
                                            global.a.receiveMessage({
                                                data: message,
                                                origin: winDetails.domain,
                                                source: winDetails.win
                                            });
                                        } catch (err) {
                                            zalgo_promise_src.a.reject(err);
                                        }
                                    }
                                }
                            };
                        }));
                    }(bridge, domain);
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        iframe.onload = resolve;
                        iframe.onerror = reject;
                    })).then((function() {
                        return Object(lib.k)(bridge, conf.a.BRIDGE_TIMEOUT, "Bridge " + url);
                    })).then((function() {
                        return bridge;
                    }));
                }));
            }));
            return global.a.bridges[domain];
        }
        var windowOpen = window.open;
        window.open = function(url, name, options, last) {
            var domain = url;
            if (url && 0 === url.indexOf(conf.b.MOCK_PROTOCOL)) {
                var _url$split = url.split("|");
                domain = _url$split[0];
                url = _url$split[1];
            }
            domain && (domain = Object(src.i)(domain));
            var win = windowOpen.call(this, url, name, options, last);
            if (!win) return win;
            url && registerRemoteWindow(win);
            for (var _i2 = 0, _Object$keys2 = Object.keys(global.a.popupWindowsByName); _i2 < _Object$keys2.length; _i2++) {
                var winName = _Object$keys2[_i2];
                Object(src.z)(global.a.popupWindowsByName[winName].win) && delete global.a.popupWindowsByName[winName];
            }
            if (name && win) {
                var winOptions = global.a.popupWindowsByWin.get(win) || global.a.popupWindowsByName[name] || {};
                winOptions.name = winOptions.name || name;
                winOptions.win = winOptions.win || win;
                winOptions.domain = winOptions.domain || domain;
                global.a.popupWindowsByWin.set(win, winOptions);
                global.a.popupWindowsByName[name] = winOptions;
            }
            return win;
        };
        function linkUrl(win, url) {
            var winOptions = global.a.popupWindowsByWin.get(win);
            if (winOptions) {
                winOptions.domain = Object(src.i)(url);
                registerRemoteWindow(win);
            }
        }
        function destroyBridges() {
            for (var _i4 = 0, _Object$keys4 = Object.keys(global.a.bridgeFrames); _i4 < _Object$keys4.length; _i4++) {
                var frame = global.a.bridgeFrames[_Object$keys4[_i4]];
                frame.parentNode && frame.parentNode.removeChild(frame);
            }
            global.a.bridgeFrames = {};
            global.a.bridges = {};
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _assertThisInitialized;
        }));
        function _assertThisInitialized(self) {
            if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return PopupOpenError;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return IntegrationError;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return RenderError;
        }));
        function PopupOpenError(message) {
            this.message = message;
        }
        PopupOpenError.prototype = Object.create(Error.prototype);
        function IntegrationError(message) {
            this.message = message;
        }
        IntegrationError.prototype = Object.create(Error.prototype);
        function RenderError(message) {
            this.message = message;
        }
        RenderError.prototype = Object.create(Error.prototype);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return normalizeProps;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _funding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
        var _lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
        var _funding_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
        var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
        var normalizeProps = Object(_lib_util__WEBPACK_IMPORTED_MODULE_2__.i)((function(props, defs) {
            void 0 === defs && (defs = {});
            var env = props.env, locale = props.locale, _props$style = props.style, style = void 0 === _props$style ? {} : _props$style, funding = props.funding, commit = props.commit, checkoutCustomization = props.checkoutCustomization;
            locale = locale ? function(locale) {
                var _locale$split = locale.split("_");
                return {
                    country: _locale$split[1],
                    lang: _locale$split[0]
                };
            }(locale) : defs.locale || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)("DEFAULT", "defaultLocale");
            (funding = funding || {}).allowed = funding.allowed || [];
            funding.disallowed = funding.disallowed || [];
            funding.remembered = funding.remembered || [];
            var label = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.LABEL] || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)("DEFAULT", style.layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
            var layout = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.LAYOUT] || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultLayout");
            var _style$BUTTON_STYLE_O = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.SIZE], size = void 0 === _style$BUTTON_STYLE_O ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalSize" : "defaultSize") : _style$BUTTON_STYLE_O, _style$BUTTON_STYLE_O2 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.COLOR], color = void 0 === _style$BUTTON_STYLE_O2 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultColor") : _style$BUTTON_STYLE_O2, _style$BUTTON_STYLE_O3 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.SHAPE], shape = void 0 === _style$BUTTON_STYLE_O3 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultShape") : _style$BUTTON_STYLE_O3, _style$BUTTON_STYLE_O4 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.BRANDING], branding = void 0 === _style$BUTTON_STYLE_O4 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalBranding" : "defaultBranding") : _style$BUTTON_STYLE_O4, _style$BUTTON_STYLE_O5 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.FUNDINGICONS], fundingicons = void 0 === _style$BUTTON_STYLE_O5 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultFundingIcons") : _style$BUTTON_STYLE_O5, _style$BUTTON_STYLE_O6 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.TAGLINE], tagline = void 0 === _style$BUTTON_STYLE_O6 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultTagline") : _style$BUTTON_STYLE_O6, max = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.MAXBUTTONS], height = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.HEIGHT], installmentperiod = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.INSTALLMENTPERIOD];
            max = function(_ref) {
                var label = _ref.label, layout = _ref.layout, max = _ref.max;
                if (!(layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "allowPrimaryHorizontal") : Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "allowPrimaryVertical"))) return 1;
                var configMax = layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "maxHorizontalButtons") : Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "maxVerticalButtons");
                return max ? Math.min(configMax, max) : configMax;
            }({
                label: label,
                layout: layout,
                max: max
            });
            var selected = Object(_config__WEBPACK_IMPORTED_MODULE_4__.f)(label);
            var sources = Object(_funding__WEBPACK_IMPORTED_MODULE_1__.b)({
                funding: funding,
                selected: selected,
                locale: locale,
                env: env,
                layout: layout,
                commit: commit
            });
            var multiple = (sources = Object(_lib_util__WEBPACK_IMPORTED_MODULE_2__.p)(sources.slice(0, max), _funding_config__WEBPACK_IMPORTED_MODULE_3__.b)).length > 1;
            multiple && (branding = !0);
            var _ref2;
            return {
                size: size,
                label: label,
                locale: locale,
                color: color,
                shape: shape,
                branding: branding,
                fundingicons: fundingicons,
                tagline: tagline = (_ref2 = {
                    tagline: tagline,
                    branding: branding,
                    fundingicons: fundingicons,
                    layout: layout
                }, Boolean(_ref2.tagline && _ref2.branding && !_ref2.fundingicons && _ref2.layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL)),
                funding: funding,
                layout: layout,
                sources: sources,
                max: max,
                multiple: multiple,
                env: env,
                height: height,
                cards: Object(_funding__WEBPACK_IMPORTED_MODULE_1__.a)({
                    funding: funding,
                    locale: locale
                }),
                installmentperiod: installmentperiod,
                checkoutCustomization: checkoutCustomization
            };
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return isFundingIneligible;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return isFundingAutoEligible;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return determineEligibleFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return determineEligibleCards;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return validateFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return logFundingEligibility;
        }));
        var constants = __webpack_require__(0);
        var config = __webpack_require__(20);
        var fundingEligibilityReasons = [];
        function isFundingIneligible(source, _ref) {
            var locale = _ref.locale, funding = _ref.funding, commit = _ref.commit, env = _ref.env;
            var isVertical = _ref.layout === constants.g.VERTICAL;
            if (!Object(config.e)(source, isVertical ? "allowVertical" : "allowHorizontal")) return constants.x.SECONDARY_DISALLOWED;
            if (-1 !== funding.disallowed.indexOf(source) && Object(config.e)(source, "allowOptOut")) return constants.x.OPT_OUT;
            if (-1 !== funding.disallowed.indexOf(source) && source === constants.v.VENMO) return constants.x.OPT_OUT;
            if (-1 !== funding.disallowed.indexOf(source) && source === constants.v.ITAU) return constants.x.OPT_OUT;
            if (-1 === Object(config.e)(source, "allowedCountries", [ locale.country ]).indexOf(locale.country)) return constants.x.DISALLOWED_COUNTRY;
            if (Object(config.e)(source, "requireCommitAsTrue") && !commit) return constants.x.COMMIT_NOT_SET;
            var allowedEnvs = Object(config.e)(source, "allowedEnvs");
            return allowedEnvs && -1 === allowedEnvs.indexOf(env) ? constants.x.INVALID_ENV : void 0;
        }
        function isFundingAutoEligible(source, _ref2) {
            var locale = _ref2.locale, funding = _ref2.funding;
            return _ref2.layout === constants.g.VERTICAL && -1 !== Object(config.e)(source, "defaultVerticalCountries", []).indexOf(locale.country) ? constants.x.DEFAULT_COUNTRY : Object(config.e)(source, "default") ? constants.x.DEFAULT : -1 !== funding.allowed.indexOf(source) && Object(config.e)(source, "allowOptIn") ? constants.x.OPT_IN : -1 !== funding.remembered.indexOf(source) && Object(config.e)(source, "allowRemember") ? constants.x.REMEMBERED : void 0;
        }
        function determineEligibleFunding(_ref4) {
            var funding = _ref4.funding, selected = _ref4.selected, locale = _ref4.locale, env = _ref4.env, layout = _ref4.layout, commit = _ref4.commit;
            var reasons = {};
            var eligibleFunding = config.c.filter((function(source) {
                var _isFundingEligible = function(source, _ref3) {
                    var locale = _ref3.locale, funding = _ref3.funding, env = _ref3.env, layout = _ref3.layout, selected = _ref3.selected, commit = _ref3.commit;
                    if (selected && source === selected) return {
                        eligible: !0,
                        reason: constants.x.PRIMARY
                    };
                    if (!(Object(config.e)(source, "enabled") || env === constants.t.TEST && Object(config.e)(source, "test"))) return {
                        eligible: !1,
                        reason: constants.x.NOT_ENABLED
                    };
                    var ineligibleReason = isFundingIneligible(source, {
                        locale: locale,
                        funding: funding,
                        layout: layout,
                        commit: commit,
                        env: env
                    });
                    if (ineligibleReason) return {
                        eligible: !1,
                        reason: ineligibleReason
                    };
                    var autoEligibleReason = isFundingAutoEligible(source, {
                        locale: locale,
                        funding: funding,
                        layout: layout
                    });
                    return autoEligibleReason ? {
                        eligible: !0,
                        reason: autoEligibleReason
                    } : {
                        eligible: !1,
                        reason: constants.x.NEED_OPT_IN
                    };
                }(source, {
                    selected: selected,
                    locale: locale,
                    funding: funding,
                    env: env,
                    layout: layout,
                    commit: commit
                }), eligible = _isFundingEligible.eligible;
                reasons[source] = {
                    eligible: eligible,
                    reason: _isFundingEligible.reason,
                    factors: {
                        env: env,
                        locale: locale,
                        layout: layout
                    }
                };
                return eligible;
            }));
            fundingEligibilityReasons.push(reasons);
            eligibleFunding.splice(eligibleFunding.indexOf(selected), 1);
            eligibleFunding.unshift(selected);
            return eligibleFunding;
        }
        function determineEligibleCards(_ref5) {
            var funding = _ref5.funding, locale = _ref5.locale;
            return Object(config.d)(locale.country, "priority").filter((function(card) {
                return -1 === funding.disallowed.indexOf(card);
            }));
        }
        function validateFunding(funding) {
            void 0 === funding && (funding = {
                allowed: [],
                disallowed: [],
                remembered: []
            });
            if (funding.allowed) for (var _i2 = 0, _funding$allowed2 = funding.allowed; _i2 < _funding$allowed2.length; _i2++) {
                var source = _funding$allowed2[_i2];
                if (-1 === constants.p.indexOf(source)) {
                    if (!config.a.hasOwnProperty(source)) throw new Error("Invalid funding source: " + source);
                    if (!Object(config.e)(source, "allowOptIn")) throw new Error("Can not allow funding source: " + source);
                    if (funding.disallowed && -1 !== funding.disallowed.indexOf(source)) throw new Error("Can not allow and disallow funding source: " + source);
                }
            }
            if (funding.disallowed) for (var _i4 = 0, _funding$disallowed2 = funding.disallowed; _i4 < _funding$disallowed2.length; _i4++) {
                var _source = _funding$disallowed2[_i4];
                if (-1 === constants.p.indexOf(_source)) {
                    if (!config.a.hasOwnProperty(_source)) throw new Error("Invalid funding source: " + _source);
                    if (!Object(config.e)(_source, "allowOptOut")) throw new Error("Can not disallow funding source: " + _source);
                }
            }
        }
        function logFundingEligibility() {
            fundingEligibilityReasons.forEach((function(reasons, i) {
                console.log("\nButton " + (i + 1) + ":\n");
                console.table(Object.keys(reasons).map((function(source) {
                    var _reasons$source = reasons[source];
                    return {
                        Funding: source,
                        Reason: _reasons$source.reason,
                        Eligibility: _reasons$source.eligible ? "eligible" : "ineligible",
                        Factors: JSON.stringify(_reasons$source.factors)
                    };
                })));
            }));
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return checkout.a;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return checkout.c;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return checkout.b;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return awaitBraintreeClient;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return mapPaymentToBraintree;
        }));
        var checkout = __webpack_require__(32);
        var src = __webpack_require__(2);
        function awaitBraintreeClient(braintree, auth) {
            return src.a.resolve(auth).then((function(authorization) {
                return braintree.client.create({
                    authorization: authorization
                });
            })).then((function(client) {
                return braintree.paypalCheckout.create({
                    client: client
                });
            }));
        }
        var SUPPORTED_REST_FIELDS = {
            intent: 1,
            transactions: [ {
                amount: {
                    total: 1,
                    currency: 1
                }
            } ],
            payer: {
                external_selected_funding_instrument_type: 1,
                shipping_address: {
                    line1: 1,
                    line2: 1,
                    city: 1,
                    state: 1,
                    postal_code: 1,
                    country_code: 1,
                    phone: 1,
                    recipient_name: 1
                }
            },
            application_context: {
                brand_name: 1,
                shipping_preference: 1,
                landing_page: 1
            }
        };
        function mapPaymentToBraintree(payment) {
            !function validate(obj, supported, name) {
                var supportedKeys = Object.keys(supported);
                for (var _i2 = 0, _Object$keys2 = Object.keys(obj); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    if (-1 === supportedKeys.indexOf(key)) throw new Error("Unsupported REST key for Braintree: " + name + "." + key);
                    "object" == typeof obj[key] && validate(obj[key], supported[key], name + "." + key);
                }
            }(payment, SUPPORTED_REST_FIELDS, "payment");
            var btPayment = {};
            btPayment.intent = payment.intent || "sale";
            btPayment.flow = "checkout";
            btPayment.amount = payment.transactions[0].amount.total;
            btPayment.currency = payment.transactions[0].amount.currency;
            if (payment.payer) {
                "CREDIT" === payment.payer.external_selected_funding_instrument_type && (btPayment.offerCredit = !0);
                payment.payer.shipping_address && (btPayment.shippingAddressOverride = {
                    line1: payment.payer.shipping_address.line1,
                    line2: payment.payer.shipping_address.line2,
                    city: payment.payer.shipping_address.city,
                    state: payment.payer.shipping_address.state,
                    postalCode: payment.payer.shipping_address.postal_code,
                    countryCode: payment.payer.shipping_address.country_code,
                    phone: payment.payer.shipping_address.phone,
                    recipientName: payment.payer.shipping_address.recipient_name
                });
            }
            if (payment.application_context) {
                btPayment.displayName = payment.application_context.brand_name;
                btPayment.landingPageType = payment.application_context.landing_page;
                if (payment.application_context) if ("NO_SHIPPING" === payment.application_context.shipping_preference) btPayment.enableShippingAddress = !1; else if ("GET_FROM_FILE" === payment.application_context.shipping_preference) {
                    btPayment.enableShippingAddress = !0;
                    btPayment.shippingAddressEditable = !0;
                } else if ("SET_PROVIDED_ADDRESS" === payment.application_context.shipping_preference) {
                    btPayment.enableShippingAddress = !0;
                    btPayment.shippingAddressEditable = !1;
                }
            }
            return btPayment;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
        __webpack_require__.d(__webpack_exports__, "script", (function() {
            return _script__WEBPACK_IMPORTED_MODULE_0__.a;
        }));
        var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36);
        __webpack_require__.d(__webpack_exports__, "react", (function() {
            return _react__WEBPACK_IMPORTED_MODULE_1__.a;
        }));
        var _vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
        __webpack_require__.d(__webpack_exports__, "vue", (function() {
            return _vue__WEBPACK_IMPORTED_MODULE_2__.a;
        }));
        var _angular__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38);
        __webpack_require__.d(__webpack_exports__, "angular", (function() {
            return _angular__WEBPACK_IMPORTED_MODULE_3__.a;
        }));
        var _ember__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39);
        __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "angular2") && __webpack_require__.d(__webpack_exports__, "angular2", (function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.angular2;
        }));
        __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "glimmer") && __webpack_require__.d(__webpack_exports__, "glimmer", (function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.glimmer;
        }));
        var _glimmer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40);
        __webpack_require__.d(__webpack_exports__, "glimmer", (function() {
            return _glimmer__WEBPACK_IMPORTED_MODULE_5__.a;
        }));
        var _angular2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41);
        __webpack_require__.d(__webpack_exports__, "angular2", (function() {
            return _angular2__WEBPACK_IMPORTED_MODULE_6__.a;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _setPrototypeOf;
        }));
        function _setPrototypeOf(o, p) {
            return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o;
            })(o, p);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return componentTemplate;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getContainerStyle;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getSandboxStyle;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return containerTemplate;
        }));
        function componentTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("title", null, "PayPal"), jsxDom("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            })), jsxDom("body", null, jsxDom("div", {
                class: "preloader spinner"
            }, jsxDom("style", null, "\n\n    body {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0;\n    }\n\n    .spinner {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        z-index: 10\n    }\n\n    .spinner .spinWrap {\n        width: 200px;\n        height: 100px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -100px;\n        margin-top: -50px\n    }\n\n    .spinner .loader,\n    .spinner .spinnerImage {\n        height: 100px;\n        width: 100px;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        opacity: 1;\n        filter: alpha(opacity=100)\n    }\n\n    .spinner .spinnerImage {\n        margin: 28px 0 0 -25px;\n        background: url(https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png) no-repeat\n    }\n\n    .spinner .loader {\n        margin: 0 0 0 -55px;\n        background-color: transparent;\n        -webkit-animation: rotation .7s infinite linear;\n        -moz-animation: rotation .7s infinite linear;\n        -o-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        border-left: 5px solid #cbcbca;\n        border-right: 5px solid #cbcbca;\n        border-bottom: 5px solid #cbcbca;\n        border-top: 5px solid #2380be;\n        border-radius: 100%\n    }\n\n    @-webkit-keyframes rotation {\n        from {\n            -webkit-transform: rotate(0deg)\n        }\n        to {\n            -webkit-transform: rotate(359deg)\n        }\n    }\n    @-moz-keyframes rotation {\n        from {\n            -moz-transform: rotate(0deg)\n        }\n        to {\n            -moz-transform: rotate(359deg)\n        }\n    }\n    @-o-keyframes rotation {\n        from {\n            -o-transform: rotate(0deg)\n        }\n        to {\n            -o-transform: rotate(359deg)\n        }\n    }\n    @keyframes rotation {\n        from {\n            transform: rotate(0deg)\n        }\n        to {\n            transform: rotate(359deg)\n        }\n    }\n"), jsxDom("div", {
                class: "spinWrap"
            }, jsxDom("p", {
                class: "spinnerImage"
            }), jsxDom("p", {
                class: "loader"
            })))));
        }
        var src = __webpack_require__(11);
        var zalgo_promise_src = __webpack_require__(2);
        var resources = __webpack_require__(19);
        var constants = __webpack_require__(0);
        var containerContent = __webpack_require__(33);
        function getContainerStyle(_ref) {
            var id = _ref.id, tag = _ref.tag, CONTEXT = _ref.CONTEXT, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + " {\n            position: absolute;\n            z-index: 2147483647;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            -webkit-transform: translate3d(0, 0, 0);\n            -moz-transform: translate3d(0, 0, 0);\n            -ms-transform: translate3d(0, 0, 0);\n            -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " {\n            background-color: black;\n            background-color: rgba(0, 0, 0, 0.75);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " {\n            background-color: white;\n            background-color: rgba(255, 255, 255, 0.4);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " a {\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " a {\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:after {\n            background-color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:after {\n            background-color: #111;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + " a {\n            text-decoration: none;\n        }\n\n        #" + id + ' .paypal-checkout-modal {\n            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;\n            font-size: 14px;\n            text-align: center;\n\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -ms-box-sizing: border-box;\n            box-sizing: border-box;\n            max-width: 350px;\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            transform: translateX(-50%) translateY(-50%);\n            -webkit-transform: translateX(-50%) translateY(-50%);\n            -moz-transform: translateX(-50%) translateY(-50%);\n            -o-transform: translateX(-50%) translateY(-50%);\n            -ms-transform: translateX(-50%) translateY(-50%);\n            cursor: pointer;\n            text-align: center;\n        }\n\n        #' + id + "." + tag + "-loading .paypal-checkout-message, #" + id + "." + tag + "-loading .paypal-checkout-continue {\n            display: none;\n        }\n\n        .paypal-checkout-loader {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-loader {\n            display: block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo {\n            cursor: pointer;\n            margin-bottom: 30px;\n            display: inline-block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img {\n            height: 36px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img.paypal-checkout-logo-pp {\n            margin-right: 10px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-message {\n            font-size: 15px;\n            line-height: 1.5;\n            padding: 10px 0;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-message, #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-continue {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue {\n            font-size: 15px;\n            line-height: 1.35;\n            padding: 10px 0;\n            font-weight: bold;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue a {\n            border-bottom: 1px solid currentColor;\n        }\n\n        #" + id + " .paypal-checkout-close {\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            width: 16px;\n            height: 16px;\n            opacity: 0.6;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-close {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-close:hover {\n            opacity: 1;\n        }\n\n        #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n            position: absolute;\n            left: 8px;\n            content: ' ';\n            height: 16px;\n            width: 2px;\n        }\n\n        #" + id + " .paypal-checkout-close:before {\n            transform: rotate(45deg);\n            -webkit-transform: rotate(45deg);\n            -moz-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n        }\n\n        #" + id + " .paypal-checkout-close:after {\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n            -moz-transform: rotate(-45deg);\n            -o-transform: rotate(-45deg);\n            -ms-transform: rotate(-45deg);\n        }\n\n        #" + id + " .paypal-checkout-iframe-container {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + ",\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + " > iframe {\n            max-height: calc(95vh - 60px);\n            max-width: 95vw;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container {\n\n            display: block;\n\n            position: absolute;\n\n            top: 50%;\n            left: 50%;\n\n            min-width: 450px;\n\n            transform: translate(-50%, -50%);\n            -webkit-transform: translate(-50%, -50%);\n            -moz-transform: translate(-50%, -50%);\n            -o-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n\n            transform: translate3d(-50%, -50%, 0);\n            -webkit-transform: translate3d(-50%, -50%, 0);\n            -moz-transform: translate3d(-50%, -50%, 0);\n            -o-transform: translate3d(-50%, -50%, 0);\n            -ms-transform: translate3d(-50%, -50%, 0);\n\n            border-radius: 10px;\n            overflow: hidden;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n\n            position: relative;\n\n            -webkit-transition: all 0.3s ease;\n            -moz-transition: all 0.3s ease;\n            -ms-transition: all 0.3s ease;\n            -o-transition: all 0.3 ease;\n            transition: all 0.3s ease;\n\n            -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n\n            min-width: 450px;\n            max-width: 450px;\n            width: 450px;\n            height: 535px;\n\n            background-color: white;\n\n            overflow: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: opacity .4s ease-in-out;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n            z-index: 100;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n            opacity: 1;\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n            opacity: 0;\n            z-index: 100;\n        }\n\n        @media screen and (-ms-high-contrast: active) {\n            #" + id + " .paypal-checkout-close {\n                opacity: 1;\n            }\n\n            #" + id + " .paypal-checkout-close:before , .paypal-checkout-close:after {\n                background-color: currentColor;\n            }\n        }\n\n        @media screen and (max-width: 470px) {\n\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                min-width: 100%;\n                min-width: calc(100% - 20px);\n                min-width: -webkit-calc(100% - 20px);\n                min-width: -moz-calc(100% - 20px);\n                min-width: -o-calc(100% - 20px);\n                min-width: -ms-calc(100% - 20px);\n\n                max-width: 100%;\n                max-width: calc(100% - 20px);\n                max-width: -webkit-calc(100% - 20px);\n                max-width: -moz-calc(100% - 20px);\n                max-width: -o-calc(100% - 20px);\n                max-width: -ms-calc(100% - 20px);\n            }\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " iframe {\n            width: 1px;\n            min-width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        .paypal-spinner {\n            height: 30px;\n            width: 30px;\n            display: inline-block;\n            box-sizing: content-box;\n            opacity: 1;\n            filter: alpha(opacity=100);\n            -webkit-animation: rotation .7s infinite linear;\n            -moz-animation: rotation .7s infinite linear;\n            -o-animation: rotation .7s infinite linear;\n            animation: rotation .7s infinite linear;\n            border-left: 8px solid rgba(0, 0, 0, .2);\n            border-right: 8px solid rgba(0, 0, 0, .2);\n            border-bottom: 8px solid rgba(0, 0, 0, .2);\n            border-top: 8px solid #fff;\n            border-radius: 100%\n        }\n\n        @-webkit-keyframes rotation {\n            from {\n                -webkit-transform: rotate(0deg)\n            }\n            to {\n                -webkit-transform: rotate(359deg)\n            }\n        }\n        @-moz-keyframes rotation {\n            from {\n                -moz-transform: rotate(0deg)\n            }\n            to {\n                -moz-transform: rotate(359deg)\n            }\n        }\n        @-o-keyframes rotation {\n            from {\n                -o-transform: rotate(0deg)\n            }\n            to {\n                -o-transform: rotate(359deg)\n            }\n        }\n        @keyframes rotation {\n            from {\n                transform: rotate(0deg)\n            }\n            to {\n                transform: rotate(359deg)\n            }\n        }\n    ";
        }
        function getSandboxStyle(_ref) {
            var id = _ref.id, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + ".paypal-checkout-sandbox {\n            display: block;\n            position: fixed;\n            top: 0;\n            left: 0;\n\n            width: 100%;\n            height: 100%;\n            width: 100vw;\n            height: 100vh;\n            max-width: 100%;\n            max-height: 100%;\n            min-width: 100%;\n            min-height: 100%;\n\n            z-index: 2147483647;\n\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n\n            animation-fill-mode:forwards;\n            animation-iteration-count: 1;\n\n            -webkit-animation-fill-mode:forwards;\n            -webkit-animation-iteration-count: 1;\n        }\n\n        #" + id + ".paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n    ";
        }
        var _LOGO_COLOR;
        var LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, 
        _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
            var _props$locale$split = props.locale.split("_");
            var content = containerContent.a[_props$locale$split[1]][_props$locale$split[0]];
            function focus(event) {
                event.preventDefault();
                event.stopPropagation();
                Object(src.j)() && Object(src.p)() ? window.alert("Please switch tabs to reactivate the PayPal window") : zalgo_promise_src.a.try(actions.focus).catch(src.n);
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK;
            var logoColor = LOGO_COLOR[overlayColor];
            var ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor];
            var paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor];
            var el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, getContainerStyle({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            })));
            var container = jsxDom("html", null, jsxDom("body", null, el));
            on(EVENT.CLOSE, (function() {
                el.className += " " + tag + "-loading";
            }));
            return jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, getSandboxStyle({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return determineParameterFromToken;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getPaymentType;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return determineUrl;
        }));
        var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
        var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
        function determineParameterFromToken(token) {
            return token && 0 === token.indexOf("BA-") ? "ba_token" : "token";
        }
        function getPaymentType(payment) {
            return 0 === payment.indexOf("BA-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.C.BA_TOKEN : 0 === payment.indexOf("PAY-") || 0 === payment.indexOf("PAYID-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.C.PAY_ID : (payment.indexOf("EC-"), 
            _constants__WEBPACK_IMPORTED_MODULE_1__.C.EC_TOKEN);
        }
        function determineUrl(env, fundingSource, payment) {
            return getPaymentType(payment) === _constants__WEBPACK_IMPORTED_MODULE_1__.C.BA_TOKEN ? _config__WEBPACK_IMPORTED_MODULE_0__.a.billingUrls[env] : fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.IDEAL || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BANCONTACT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.GIROPAY || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.SOFORT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.EPS || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MYBANK || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.P24 || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BLIK || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MAXIMA || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BOLETO || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.OXXO || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MERCADOPAGO ? _config__WEBPACK_IMPORTED_MODULE_0__.a.altpayUrls[env] : _config__WEBPACK_IMPORTED_MODULE_0__.a.checkoutUrls[env];
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return containerContent;
        }));
        var containerContent = {
            AT: {
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZW: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            WS: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            WF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            VC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            UY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            UG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            TO: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            TM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SV: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            ST: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SB: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            RW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            RS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            QA: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PY: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PA: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            OM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            NU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NP: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            NG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            NC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MV: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MT: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            MR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MQ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ML: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ME: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MD: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MC: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            LS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LK: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            LA: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            KN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            KI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            JO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            JM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            IS: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HR: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GP: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            GM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            GI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GD: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            FO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            FM: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FK: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            FJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ET: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ER: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            EC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            DO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            DJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CM: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CL: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CK: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CI: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BZ: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BT: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            BG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BB: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BA: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AW: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AL: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AE: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                }
            },
            GB: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AR: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            US: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Click to Continue"
                }
            },
            VN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            UA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TW: {
                zh: {
                    windowMessage: "看不到安全連線的 PayPal 瀏覽器？我們將會重新啟動視窗以完成付款。  ",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            TR: {
                tr: {
                    windowMessage: "Güvenli PayPal tarayıcısını görmüyor musunuz? Alışverişinizi tamamlamak için pencereyi yeniden başlatmanıza yardımcı olacağız.  ",
                    continue: "Devam"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TH: {
                th: {
                    windowMessage: "ถ้าคุณไม่เห็นเบราว์เซอร์ที่มีระบบความปลอดภัยของ PayPal เราจะช่วยคุณเปิดหน้าต่างอีกครั้งเพื่อชำระเงินให้เรียบร้อย ",
                    continue: "ดำเนินการต่อ"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SK: {
                sk: {
                    windowMessage: "Nezobrazuje sa vám zabezpečený prehliadač PayPal? Pomôžeme vám znova otvoriť okno, aby ste mohli nákup dokončiť.  ",
                    continue: "Pokračovať"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SG: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SE: {
                sv: {
                    windowMessage: "Ser du inte den säkra PayPal-webbläsaren? Vi hjälper dig att starta om fönstret för att slutföra ditt köp. ",
                    continue: "Fortsätt"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RU: {
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.",
                    continue: "Продолжить"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            RO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PT: {
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PL: {
                pl: {
                    windowMessage: "Nie widzisz bezpiecznej przeglądarki PayPal? Pomożemy Ci ponownie uruchomić to okno w celu dokonania zakupu.  ",
                    continue: "Kontynuuj"
                },
                en: {
                    windowMessage: "You don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à relancer la fenêtre pour effectuer votre paiement.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar su pago.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NO: {
                no: {
                    windowMessage: "Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med å starte vinduet på nytt så du kan fullføre kjøpet.  ",
                    continue: "Fortsett"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NL: {
                nl: {
                    windowMessage: "Ziet u geen beveiligde PayPal-browser? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MY: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            MX: {
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Das PayPal-Fenster wird nicht angezeigt? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            LT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KR: {
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 결제를 완료할 수 있도록 도와드리겠습니다.  ",
                    continue: "계속"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            JP: {
                ja: {
                    windowMessage: "セキュアなブラウザが表示されない場合は、ウィンドウを再起動して、支払いを完了できるようお手伝いいたします。",
                    continue: "続行"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            IT: {
                it: {
                    windowMessage: "Non vedi la pagina sicura di PayPal? Ti aiuteremo a riaprire la finestra per completare l'acquisto.  ",
                    continue: "Continua"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IL: {
                he: {
                    windowMessage: "לא רואה את דפדפן PayPal המאובטח? נעזור לך לפתוח מחדש את החלון כדי להשלים את הקנייה שלך.  ",
                    continue: "המשך"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HU: {
                hu: {
                    windowMessage: "Nem látja a biztonságos PayPal-böngészőt? Segítünk újra betölteni az ablakot, hogy befejezhesse a vásárlást.  ",
                    continue: "Folytatás"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ID: {
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembayaran Anda.  ",
                    continue: "Lanjutkan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            HK: {
                zh: {
                    windowMessage: "看不到安全的 PayPal 瀏覽器視窗？我們會助你重新開啟視窗，以完成付款。",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            "GROUP-LATAM": {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            "GROUP-EMEA": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            "GROUP-APAC": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 구매를 완료할 수 있도록 도와드리겠습니다. ",
                    continue: "계속"
                },
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembelian Anda. ",
                    continue: "Lanjutkan"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GR: {
                el: {
                    windowMessage: "Δεν βλέπετε το ασφαλές πρόγραμμα περιήγησης PayPal; Θα σας βοηθήσουμε να επανεκκινήσετε το παράθυρο για να ολοκληρώσετε την αγορά σας.  ",
                    continue: "Συνέχεια"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FR: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ES: {
                es: {
                    windowMessage: "¿No ve el símbolo de navegación segura de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar la compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FI: {
                fi: {
                    windowMessage: "Eikö suojattua PayPal-selainta näy? Autamme avaamaan ikkunan uudelleen oston viimeistelyä varten.  ",
                    continue: "Jatka"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            CZ: {
                cs: {
                    windowMessage: "Nezobrazuje se vám bezpečný prohlížeč PayPal? Pomůžeme vám okno znovu otevřít, abyste mohli nákup dokončit.",
                    continue: "Pokračovat"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DE: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CH: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CA: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé de PayPal ? Nous vous aiderons à relancer la fenêtre afin d'effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you relaunch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            C2: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            BE: {
                nl: {
                    windowMessage: "Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BR: {
                pt: {
                    windowMessage: "Não está vendo o navegador seguro do PayPal? Ajudaremos você a reabrir a janela para concluir a compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AU: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__;
        !function() {
            "use strict";
            var root = "object" == typeof window ? window : {};
            !root.HI_BASE32_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node && (root = window);
            var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && "object" == typeof module && module.exports;
            var AMD = __webpack_require__(46);
            var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
            var BASE32_DECODE_CHAR = {
                A: 0,
                B: 1,
                C: 2,
                D: 3,
                E: 4,
                F: 5,
                G: 6,
                H: 7,
                I: 8,
                J: 9,
                K: 10,
                L: 11,
                M: 12,
                N: 13,
                O: 14,
                P: 15,
                Q: 16,
                R: 17,
                S: 18,
                T: 19,
                U: 20,
                V: 21,
                W: 22,
                X: 23,
                Y: 24,
                Z: 25,
                2: 26,
                3: 27,
                4: 28,
                5: 29,
                6: 30,
                7: 31
            };
            var blocks = [ 0, 0, 0, 0, 0, 0, 0, 0 ];
            var throwInvalidUtf8 = function(position, partial) {
                partial.length > 10 && (partial = "..." + partial.substr(-10));
                var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position + " bytes: " + partial + " <-");
                err.position = position;
                throw err;
            };
            var decodeAsBytes = function(base32Str) {
                if ("" === base32Str) return [];
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = (base32Str = base32Str.replace(/=/g, "")).length;
                for (var i = 0, count = length >> 3 << 3; i < count; ) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                    bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                    bytes[index++] = 255 & (v7 << 5 | v8);
                }
                var remain = length - count;
                if (2 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                } else if (4 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                } else if (5 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                } else if (7 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                    bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                }
                return bytes;
            };
            var decode = function(base32Str, asciiOnly) {
                if (!asciiOnly) return function(bytes) {
                    var b, c, str = "", length = bytes.length, i = 0, followingChars = 0;
                    for (;i < length; ) if ((b = bytes[i++]) <= 127) str += String.fromCharCode(b); else {
                        if (b > 191 && b <= 223) {
                            c = 31 & b;
                            followingChars = 1;
                        } else if (b <= 239) {
                            c = 15 & b;
                            followingChars = 2;
                        } else if (b <= 247) {
                            c = 7 & b;
                            followingChars = 3;
                        } else throwInvalidUtf8(i, str);
                        for (var j = 0; j < followingChars; ++j) {
                            ((b = bytes[i++]) < 128 || b > 191) && throwInvalidUtf8(i, str);
                            c <<= 6;
                            c += 63 & b;
                        }
                        c >= 55296 && c <= 57343 && throwInvalidUtf8(i, str);
                        c > 1114111 && throwInvalidUtf8(i, str);
                        if (c <= 65535) str += String.fromCharCode(c); else {
                            c -= 65536;
                            str += String.fromCharCode(55296 + (c >> 10));
                            str += String.fromCharCode(56320 + (1023 & c));
                        }
                    }
                    return str;
                }(decodeAsBytes(base32Str));
                if ("" === base32Str) return "";
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
                -1 === length && (length = base32Str.length);
                for (var i = 0, count = length >> 3 << 3; i < count; ) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3)) + String.fromCharCode(255 & (v7 << 5 | v8));
                }
                var remain = length - count;
                if (2 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2));
                } else if (4 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4));
                } else if (5 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1));
                } else if (7 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3));
                }
                return str;
            };
            var exports = {
                encode: function(input, asciiOnly) {
                    var notString = "string" != typeof input;
                    notString && input.constructor === ArrayBuffer && (input = new Uint8Array(input));
                    return notString ? function(bytes) {
                        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
                        for (var i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i++];
                            v5 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) base32Str += BASE32_ENCODE_CHAR[(v1 = bytes[i]) >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======"; else if (2 === remain) {
                            v1 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = bytes[i]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = bytes[i]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = bytes[i]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }(input) : asciiOnly ? function(str) {
                        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
                        for (var i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i++);
                            v5 = str.charCodeAt(i++);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) {
                            v1 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }(input) : function(str) {
                        var v1, v2, v3, v4, v5, code, i, end = !1, base32Str = "", index = 0, start = 0, length = str.length;
                        if ("" === str) return base32Str;
                        do {
                            blocks[0] = blocks[5];
                            blocks[1] = blocks[6];
                            blocks[2] = blocks[7];
                            for (i = start; index < length && i < 5; ++index) if ((code = str.charCodeAt(index)) < 128) blocks[i++] = code; else if (code < 2048) {
                                blocks[i++] = 192 | code >> 6;
                                blocks[i++] = 128 | 63 & code;
                            } else if (code < 55296 || code >= 57344) {
                                blocks[i++] = 224 | code >> 12;
                                blocks[i++] = 128 | code >> 6 & 63;
                                blocks[i++] = 128 | 63 & code;
                            } else {
                                code = 65536 + ((1023 & code) << 10 | 1023 & str.charCodeAt(++index));
                                blocks[i++] = 240 | code >> 18;
                                blocks[i++] = 128 | code >> 12 & 63;
                                blocks[i++] = 128 | code >> 6 & 63;
                                blocks[i++] = 128 | 63 & code;
                            }
                            start = i - 5;
                            index === length && ++index;
                            index > length && i < 6 && (end = !0);
                            v1 = blocks[0];
                            base32Str += i > 4 ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | (v5 = blocks[4]) >>> 5)] + BASE32_ENCODE_CHAR[31 & v5] : 1 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======" : 2 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====" : 3 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===" : BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        } while (!end);
                        return base32Str;
                    }(input);
                },
                decode: decode
            };
            decode.asBytes = decodeAsBytes;
            if (COMMON_JS) module.exports = exports; else {
                root.base32 = exports;
                AMD && void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
                    return exports;
                }.call(exports, __webpack_require__, exports, module)) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            }
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return script;
        }));
        var script = {
            global: function() {
                return window.document;
            },
            register: function(component, document) {
                function render(element) {
                    if (element && element.tagName && "script" === element.tagName.toLowerCase() && element.attributes.type && "application/x-component" === element.attributes.type.value && element.parentNode) {
                        var tag = element.getAttribute("data-component");
                        if (tag && tag === component.tag) {
                            component.log("instantiate_script_component_error");
                            throw new Error("\n               'x-component' script type is no longer supported.  \n               Please migrate to another integration pattern.\n            ");
                        }
                    }
                }
                function scan() {
                    var scriptTags = [].slice.call(document.getElementsByTagName("script"));
                    for (var _i2 = 0; _i2 < scriptTags.length; _i2++) render(scriptTags[_i2]);
                }
                scan();
                document.addEventListener("DOMContentLoaded", scan);
                window.addEventListener("load", scan);
                document.addEventListener("DOMNodeInserted", (function(event) {
                    render(event.target);
                }));
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return react;
        }));
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
        var react = {
            global: function() {
                if (window.React && window.ReactDOM) return {
                    React: window.React,
                    ReactDOM: window.ReactDOM
                };
            },
            register: function(component, _ref) {
                var React = _ref.React, ReactDOM = _ref.ReactDOM;
                component.react = React.createClass ? React.createClass({
                    displayName: "react",
                    render: function() {
                        return React.createElement("div", null);
                    },
                    componentDidMount: function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this);
                        var parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        });
                        parent.render(el);
                    },
                    componentDidUpdate: function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    },
                    componentWillUnmount: function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    }
                }) : function(_React$Component) {
                    Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(_class, _React$Component);
                    function _class() {
                        return _React$Component.apply(this, arguments) || this;
                    }
                    var _proto = _class.prototype;
                    _proto.render = function() {
                        return React.createElement("div", null);
                    };
                    _proto.componentDidMount = function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this);
                        var parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        });
                        parent.render(el);
                    };
                    _proto.componentDidUpdate = function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    };
                    _proto.componentWillUnmount = function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    };
                    return _class;
                }(React.Component);
                return component.react;
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return vue;
        }));
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
        var vue = {
            global: function() {},
            register: function(component) {
                return {
                    render: function(createElement) {
                        return createElement("div");
                    },
                    inheritAttrs: !1,
                    mounted: function() {
                        var el = this.$el;
                        this.parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs), null, el);
                        this.parent.render(el);
                    },
                    beforeUpdate: function() {
                        this.parent && this.$attrs && this.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs));
                    }
                };
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return angular;
        }));
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
        var angular = {
            global: function() {
                return window.angular;
            },
            register: function(component, ng) {
                return ng.module(component.tag, []).directive(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.h)(component.tag), (function() {
                    var scope = {};
                    for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) scope[_component$getPropNam2[_i2]] = "=";
                    component.looseProps && (scope.props = "=");
                    return {
                        scope: scope,
                        restrict: "E",
                        controller: [ "$scope", "$element", function($scope, $element) {
                            if (component.looseProps && !$scope.props) throw new Error("For angular bindings to work, prop definitions must be passed to zoid.create");
                            component.log("instantiate_angular_component");
                            function safeApply() {
                                if ("$apply" !== $scope.$root.$$phase && "$digest" !== $scope.$root.$$phase) try {
                                    $scope.$apply();
                                } catch (err) {}
                            }
                            var getProps = function() {
                                var scopeProps;
                                if ($scope.props) scopeProps = $scope.props; else {
                                    scopeProps = {};
                                    for (var _i4 = 0, _Object$keys2 = Object.keys(scope); _i4 < _Object$keys2.length; _i4++) {
                                        var _key = _Object$keys2[_i4];
                                        void 0 !== $scope[_key] && (scopeProps[_key] = $scope[_key]);
                                    }
                                }
                                return Object(_lib__WEBPACK_IMPORTED_MODULE_0__.M)(scopeProps, {
                                    function: function(value) {
                                        return function() {
                                            var result = value.apply(this, arguments);
                                            safeApply();
                                            return result;
                                        };
                                    }
                                });
                            };
                            var parent = component.init(getProps(), null, $element[0]);
                            parent.render($element[0]);
                            $scope.$watch((function() {
                                parent.updateProps(getProps());
                            }));
                        } ]
                    };
                }));
            }
        };
    }, function(module, exports) {}, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return glimmer;
        }));
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
        var glimmer = {
            global: function() {},
            register: function(component, GlimmerComponent) {
                return function(_GlimmerComponent) {
                    Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__.a)(_class, _GlimmerComponent);
                    function _class() {
                        return _GlimmerComponent.apply(this, arguments) || this;
                    }
                    _class.prototype.didInsertElement = function() {
                        component.render(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, this.args), this.element);
                    };
                    return _class;
                }(GlimmerComponent);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return angular2;
        }));
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
        var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
        var angular2 = {
            global: function() {},
            register: function(zoid, _ref) {
                var AngularComponent = _ref.Component, NgModule = _ref.NgModule, ElementRef = _ref.ElementRef, NgZone = _ref.NgZone;
                zoid.log("initializing angular2 component");
                var getProps = function(component) {
                    return Object(_lib__WEBPACK_IMPORTED_MODULE_1__.M)(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, component.internalProps, component.props), {
                        function: function(value) {
                            if ("function" == typeof value) return function() {
                                var _arguments = arguments, _this = this;
                                return component.zone.run((function() {
                                    return value.apply(_this, _arguments);
                                }));
                            };
                        }
                    });
                };
                var ComponentInstance = AngularComponent({
                    selector: zoid.tag,
                    template: "<div></div>",
                    inputs: [ "props" ]
                }).Class({
                    constructor: [ ElementRef, NgZone, function(elementRef, zone) {
                        this.elementRef = elementRef;
                        this.zone = zone;
                    } ],
                    ngOnInit: function() {
                        var targetElement = this.elementRef.nativeElement;
                        var parent = zoid.init(getProps(this), null, targetElement);
                        parent.render(targetElement);
                        this.parent = parent;
                    },
                    ngOnChanges: function() {
                        this.parent && this.parent.updateProps(getProps(this));
                    }
                });
                return NgModule({
                    declarations: [ ComponentInstance ],
                    exports: [ ComponentInstance ]
                }).Class({
                    constructor: function() {}
                });
            }
        };
    }, function(module, exports, __webpack_require__) {
        !function(e, t, n) {
            module.exports ? module.exports = n() : __webpack_require__(47)("bowser", n);
        }(0, 0, (function() {
            function t(t) {
                function n(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[1] || "";
                }
                function r(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[2] || "";
                }
                var N, i = n(/(ipod|iphone|ipad)/i).toLowerCase(), u = !/like android/i.test(t) && /android/i.test(t), a = /nexus\s*[0-6]\s*/i.test(t), f = !a && /nexus\s*[0-9]+/i.test(t), l = /CrOS/.test(t), c = /silk/i.test(t), h = /sailfish/i.test(t), p = /tizen/i.test(t), d = /(web|hpw)(o|0)s/i.test(t), v = /windows phone/i.test(t), g = (/SamsungBrowser/i.test(t), 
                !v && /windows/i.test(t)), y = !i && !c && /macintosh/i.test(t), b = !u && !h && !p && !d && /linux/i.test(t), w = r(/edg([ea]|ios)\/(\d+(\.\d+)?)/i), E = n(/version\/(\d+(\.\d+)?)/i), S = /tablet/i.test(t) && !/tablet pc/i.test(t), x = !S && /[^-]mobi/i.test(t), T = /xbox/i.test(t);
                /opera/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: E || n(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
                } : /opr\/|opios/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: n(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || E
                } : /SamsungBrowser/i.test(t) ? N = {
                    name: "Samsung Internet for Android",
                    samsungBrowser: e,
                    version: E || n(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /Whale/i.test(t) ? N = {
                    name: "NAVER Whale browser",
                    whale: e,
                    version: n(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
                } : /MZBrowser/i.test(t) ? N = {
                    name: "MZ Browser",
                    mzbrowser: e,
                    version: n(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /coast/i.test(t) ? N = {
                    name: "Opera Coast",
                    coast: e,
                    version: E || n(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
                } : /focus/i.test(t) ? N = {
                    name: "Focus",
                    focus: e,
                    version: n(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
                } : /yabrowser/i.test(t) ? N = {
                    name: "Yandex Browser",
                    yandexbrowser: e,
                    version: E || n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /ucbrowser/i.test(t) ? N = {
                    name: "UC Browser",
                    ucbrowser: e,
                    version: n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /mxios/i.test(t) ? N = {
                    name: "Maxthon",
                    maxthon: e,
                    version: n(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
                } : /epiphany/i.test(t) ? N = {
                    name: "Epiphany",
                    epiphany: e,
                    version: n(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
                } : /puffin/i.test(t) ? N = {
                    name: "Puffin",
                    puffin: e,
                    version: n(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
                } : /sleipnir/i.test(t) ? N = {
                    name: "Sleipnir",
                    sleipnir: e,
                    version: n(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
                } : /k-meleon/i.test(t) ? N = {
                    name: "K-Meleon",
                    kMeleon: e,
                    version: n(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
                } : v ? (N = {
                    name: "Windows Phone",
                    osname: "Windows Phone",
                    windowsphone: e
                }, w ? (N.msedge = e, N.version = w) : (N.msie = e, N.version = n(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? N = {
                    name: "Internet Explorer",
                    msie: e,
                    version: n(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                } : l ? N = {
                    name: "Chrome",
                    osname: "Chrome OS",
                    chromeos: e,
                    chromeBook: e,
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : /edg([ea]|ios)/i.test(t) ? N = {
                    name: "Microsoft Edge",
                    msedge: e,
                    version: w
                } : /vivaldi/i.test(t) ? N = {
                    name: "Vivaldi",
                    vivaldi: e,
                    version: n(/vivaldi\/(\d+(\.\d+)?)/i) || E
                } : h ? N = {
                    name: "Sailfish",
                    osname: "Sailfish OS",
                    sailfish: e,
                    version: n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
                } : /seamonkey\//i.test(t) ? N = {
                    name: "SeaMonkey",
                    seamonkey: e,
                    version: n(/seamonkey\/(\d+(\.\d+)?)/i)
                } : /firefox|iceweasel|fxios/i.test(t) ? (N = {
                    name: "Firefox",
                    firefox: e,
                    version: n(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
                }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (N.firefoxos = e, N.osname = "Firefox OS")) : c ? N = {
                    name: "Amazon Silk",
                    silk: e,
                    version: n(/silk\/(\d+(\.\d+)?)/i)
                } : /phantom/i.test(t) ? N = {
                    name: "PhantomJS",
                    phantom: e,
                    version: n(/phantomjs\/(\d+(\.\d+)?)/i)
                } : /slimerjs/i.test(t) ? N = {
                    name: "SlimerJS",
                    slimer: e,
                    version: n(/slimerjs\/(\d+(\.\d+)?)/i)
                } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? N = {
                    name: "BlackBerry",
                    osname: "BlackBerry OS",
                    blackberry: e,
                    version: E || n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
                } : d ? (N = {
                    name: "WebOS",
                    osname: "WebOS",
                    webos: e,
                    version: E || n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
                }, /touchpad\//i.test(t) && (N.touchpad = e)) : /bada/i.test(t) ? N = {
                    name: "Bada",
                    osname: "Bada",
                    bada: e,
                    version: n(/dolfin\/(\d+(\.\d+)?)/i)
                } : p ? N = {
                    name: "Tizen",
                    osname: "Tizen",
                    tizen: e,
                    version: n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || E
                } : /qupzilla/i.test(t) ? N = {
                    name: "QupZilla",
                    qupzilla: e,
                    version: n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || E
                } : /chromium/i.test(t) ? N = {
                    name: "Chromium",
                    chromium: e,
                    version: n(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || E
                } : /chrome|crios|crmo/i.test(t) ? N = {
                    name: "Chrome",
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : u ? N = {
                    name: "Android",
                    version: E
                } : /safari|applewebkit/i.test(t) ? (N = {
                    name: "Safari",
                    safari: e
                }, E && (N.version = E)) : i ? (N = {
                    name: "iphone" == i ? "iPhone" : "ipad" == i ? "iPad" : "iPod"
                }, E && (N.version = E)) : N = /googlebot/i.test(t) ? {
                    name: "Googlebot",
                    googlebot: e,
                    version: n(/googlebot\/(\d+(\.\d+))/i) || E
                } : {
                    name: n(/^(.*)\/(.*) /),
                    version: r(/^(.*)\/(.*) /)
                }, !N.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (N.name = N.name || "Blink", 
                N.blink = e) : (N.name = N.name || "Webkit", N.webkit = e), !N.version && E && (N.version = E)) : !N.opera && /gecko\//i.test(t) && (N.name = N.name || "Gecko", 
                N.gecko = e, N.version = N.version || n(/gecko\/(\d+(\.\d+)?)/i)), N.windowsphone || !u && !N.silk ? !N.windowsphone && i ? (N[i] = e, 
                N.ios = e, N.osname = "iOS") : y ? (N.mac = e, N.osname = "macOS") : T ? (N.xbox = e, 
                N.osname = "Xbox") : g ? (N.windows = e, N.osname = "Windows") : b && (N.linux = e, 
                N.osname = "Linux") : (N.android = e, N.osname = "Android");
                var k = "";
                N.windows ? k = function(e) {
                    switch (e) {
                      case "NT":
                        return "NT";

                      case "XP":
                        return "XP";

                      case "NT 5.0":
                        return "2000";

                      case "NT 5.1":
                        return "XP";

                      case "NT 5.2":
                        return "2003";

                      case "NT 6.0":
                        return "Vista";

                      case "NT 6.1":
                        return "7";

                      case "NT 6.2":
                        return "8";

                      case "NT 6.3":
                        return "8.1";

                      case "NT 10.0":
                        return "10";

                      default:
                        return;
                    }
                }(n(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : N.windowsphone ? k = n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : N.mac ? k = (k = n(/Mac OS X (\d+([_\.\s]\d+)*)/i)).replace(/[_\s]/g, ".") : i ? k = (k = n(/os (\d+([_\s]\d+)*) like mac os x/i)).replace(/[_\s]/g, ".") : u ? k = n(/android[ \/-](\d+(\.\d+)*)/i) : N.webos ? k = n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : N.blackberry ? k = n(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : N.bada ? k = n(/bada\/(\d+(\.\d+)*)/i) : N.tizen && (k = n(/tizen[\/\s](\d+(\.\d+)*)/i)), 
                k && (N.osversion = k);
                var L = !N.windows && k.split(".")[0];
                S || f || "ipad" == i || u && (3 == L || L >= 4 && !x) || N.silk ? N.tablet = e : (x || "iphone" == i || "ipod" == i || u || a || N.blackberry || N.webos || N.bada) && (N.mobile = e);
                return N.msedge || N.msie && N.version >= 10 || N.yandexbrowser && N.version >= 15 || N.vivaldi && N.version >= 1 || N.chrome && N.version >= 20 || N.samsungBrowser && N.version >= 4 || N.whale && 1 === s([ N.version, "1.0" ]) || N.mzbrowser && 1 === s([ N.version, "6.0" ]) || N.focus && 1 === s([ N.version, "1.0" ]) || N.firefox && N.version >= 20 || N.safari && N.version >= 6 || N.opera && N.version >= 10 || N.ios && N.osversion && N.osversion.split(".")[0] >= 6 || N.blackberry && N.version >= 10.1 || N.chromium && N.version >= 20 ? N.a = e : N.msie && N.version < 10 || N.chrome && N.version < 20 || N.firefox && N.version < 20 || N.safari && N.version < 6 || N.opera && N.version < 10 || N.ios && N.osversion && N.osversion.split(".")[0] < 6 || N.chromium && N.version < 20 ? N.c = e : N.x = e, 
                N;
            }
            function r(e) {
                return e.split(".").length;
            }
            function i(e, t) {
                var r, n = [];
                if ([].map) return [].map.call(e, t);
                for (r = 0; r < e.length; r++) n.push(t(e[r]));
                return n;
            }
            function s(e) {
                var t = Math.max(r(e[0]), r(e[1])), n = i(e, (function(e) {
                    var n = t - r(e);
                    return i((e += new Array(n + 1).join(".0")).split("."), (function(e) {
                        return new Array(20 - e.length).join("0") + e;
                    })).reverse();
                }));
                for (;--t >= 0; ) {
                    if (n[0][t] > n[1][t]) return 1;
                    if (n[0][t] !== n[1][t]) return -1;
                    if (0 === t) return 0;
                }
            }
            function o(e, r, i) {
                var o = n;
                "string" == typeof r && (i = r, r = void 0), void 0 === r && (r = !1), i && (o = t(i));
                var u = "" + o.version;
                for (var a in e) if (e.hasOwnProperty(a) && o[a]) {
                    if ("string" != typeof e[a]) throw new Error("Browser version in the minVersion map should be a string: " + a + ": " + String(e));
                    return s([ u, e[a] ]) < 0;
                }
                return r;
            }
            var e = !0, n = t("undefined" != typeof navigator && navigator.userAgent || "");
            return n.test = function(e) {
                for (var t = 0; t < e.length; ++t) {
                    var r = e[t];
                    if ("string" == typeof r && r in n) return !0;
                }
                return !1;
            }, n.isUnsupportedBrowser = o, n.compareVersions = s, n.check = function(e, t, n) {
                return !o(e, t, n);
            }, n._detect = t, n.detect = t, n;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "emulateIERestrictions", (function() {
            return emulateIERestrictions;
        }));
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        function emulateIERestrictions(sourceWindow, targetWindow) {
            if (!conf.a.ALLOW_POSTMESSAGE_POPUP && !1 === Object(src.w)(sourceWindow, targetWindow)) throw new Error("Can not send and receive post messages between two different windows (disabled to emulate IE)");
        }
    }, function(module, exports) {
        var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
        var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
        var brackets = /(\[[^\[\]]*\])/g;
        function hash_serializer(result, key, value) {
            if (key.match(brackets)) !function hash_assign(result, keys, value) {
                if (0 === keys.length) return value;
                var key = keys.shift();
                var between = key.match(/^\[(.+?)\]$/);
                if ("[]" === key) {
                    result = result || [];
                    if (Array.isArray(result)) result.push(hash_assign(null, keys, value)); else {
                        result._values = result._values || [];
                        result._values.push(hash_assign(null, keys, value));
                    }
                    return result;
                }
                if (between) {
                    var string = between[1];
                    var index = +string;
                    isNaN(index) ? (result = result || {})[string] = hash_assign(result[string], keys, value) : (result = result || [])[index] = hash_assign(result[index], keys, value);
                } else result[key] = hash_assign(result[key], keys, value);
                return result;
            }(result, function(string) {
                var keys = [];
                var children = new RegExp(brackets);
                var match = /^([^\[\]]*)/.exec(string);
                match[1] && keys.push(match[1]);
                for (;null !== (match = children.exec(string)); ) keys.push(match[1]);
                return keys;
            }(key), value); else {
                var existing = result[key];
                if (existing) {
                    Array.isArray(existing) || (result[key] = [ existing ]);
                    result[key].push(value);
                } else result[key] = value;
            }
            return result;
        }
        function str_serialize(result, key, value) {
            value = value.replace(/(\r)?\n/g, "\r\n");
            value = (value = encodeURIComponent(value)).replace(/%20/g, "+");
            return result + (result ? "&" : "") + encodeURIComponent(key) + "=" + value;
        }
        module.exports = function(form, options) {
            "object" != typeof options ? options = {
                hash: !!options
            } : void 0 === options.hash && (options.hash = !0);
            var result = options.hash ? {} : "";
            var serializer = options.serializer || (options.hash ? hash_serializer : str_serialize);
            var elements = form && form.elements ? form.elements : [];
            var radio_store = Object.create(null);
            for (var i = 0; i < elements.length; ++i) {
                var element = elements[i];
                if ((options.disabled || !element.disabled) && element.name && k_r_success_contrls.test(element.nodeName) && !k_r_submitter.test(element.type)) {
                    var key = element.name;
                    var val = element.value;
                    "checkbox" !== element.type && "radio" !== element.type || element.checked || (val = void 0);
                    if (options.empty) {
                        "checkbox" !== element.type || element.checked || (val = "");
                        "radio" === element.type && (radio_store[element.name] || element.checked ? element.checked && (radio_store[element.name] = !0) : radio_store[element.name] = !1);
                        if (null == val && "radio" == element.type) continue;
                    } else if (!val) continue;
                    if ("select-multiple" !== element.type) result = serializer(result, key, val); else {
                        val = [];
                        var selectOptions = element.options;
                        var isSelectedOptions = !1;
                        for (var j = 0; j < selectOptions.length; ++j) {
                            var option = selectOptions[j];
                            if (option.selected && (option.value || options.empty && !option.value)) {
                                isSelectedOptions = !0;
                                result = options.hash && "[]" !== key.slice(key.length - 2) ? serializer(result, key + "[]", option.value) : serializer(result, key, option.value);
                            }
                        }
                        !isSelectedOptions && options.empty && (result = serializer(result, key, ""));
                    }
                }
            }
            if (options.empty) for (var key in radio_store) radio_store[key] || (result = serializer(result, key, ""));
            return result;
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
        __webpack_require__.d(__webpack_exports__, "openBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "linkUrl", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.linkUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "isBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.isBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "hasBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.hasBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForWin;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openTunnelToOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyBridges", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.destroyBridges;
        }));
    }, function(module, exports) {
        (function(__webpack_amd_options__) {
            module.exports = __webpack_amd_options__;
        }).call(this, {});
    }, function(module, exports) {
        module.exports = function() {
            throw new Error("define cannot be used indirect");
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(__webpack_exports__, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(__webpack_exports__, "PopupOpenError", (function() {
            return src.b;
        }));
        __webpack_require__.d(__webpack_exports__, "rest", (function() {
            return rest;
        }));
        __webpack_require__.d(__webpack_exports__, "Button", (function() {
            return component_Button;
        }));
        __webpack_require__.d(__webpack_exports__, "Card", (function() {
            return Card;
        }));
        __webpack_require__.d(__webpack_exports__, "setup", (function() {
            return setup;
        }));
        __webpack_require__.d(__webpack_exports__, "config", (function() {
            return config.a;
        }));
        __webpack_require__.d(__webpack_exports__, "ENV", (function() {
            return constants.t;
        }));
        __webpack_require__.d(__webpack_exports__, "USERS", (function() {
            return constants.G;
        }));
        __webpack_require__.d(__webpack_exports__, "SOURCE", (function() {
            return constants.F;
        }));
        __webpack_require__.d(__webpack_exports__, "FUNDING", (function() {
            return constants.v;
        }));
        __webpack_require__.d(__webpack_exports__, "CARD", (function() {
            return constants.o;
        }));
        __webpack_require__.d(__webpack_exports__, "request", (function() {
            return lib.R;
        }));
        __webpack_require__.d(__webpack_exports__, "isEligible", (function() {
            return lib.D;
        }));
        __webpack_require__.d(__webpack_exports__, "isFundingRemembered", (function() {
            return lib.E;
        }));
        __webpack_require__.d(__webpack_exports__, "forceIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "isWebView", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "allowIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", (function() {
            return logExperimentTreatment;
        }));
        __webpack_require__.d(__webpack_exports__, "logFundingEligibility", (function() {
            return src_funding.e;
        }));
        __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", (function() {
            return onPossiblyUnhandledException;
        }));
        __webpack_require__.d(__webpack_exports__, "version", (function() {
            return interface_version;
        }));
        __webpack_require__.d(__webpack_exports__, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(__webpack_exports__, "Checkout", (function() {
            return interface_Checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "BillingPage", (function() {
            return interface_BillingPage;
        }));
        __webpack_require__.d(__webpack_exports__, "PayPalCheckout", (function() {
            return PayPalCheckout;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyAll", (function() {
            return destroyAll;
        }));
        __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", (function() {
            return enableCheckoutIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "logger", (function() {
            return logger;
        }));
        __webpack_require__.d(__webpack_exports__, "ThreeDomainSecure", (function() {
            return interface_ThreeDomainSecure;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(interface_namespaceObject, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "PopupOpenError", (function() {
            return src.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "rest", (function() {
            return rest;
        }));
        __webpack_require__.d(interface_namespaceObject, "Button", (function() {
            return component_Button;
        }));
        __webpack_require__.d(interface_namespaceObject, "Card", (function() {
            return Card;
        }));
        __webpack_require__.d(interface_namespaceObject, "setup", (function() {
            return setup;
        }));
        __webpack_require__.d(interface_namespaceObject, "config", (function() {
            return config.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "ENV", (function() {
            return constants.t;
        }));
        __webpack_require__.d(interface_namespaceObject, "USERS", (function() {
            return constants.G;
        }));
        __webpack_require__.d(interface_namespaceObject, "SOURCE", (function() {
            return constants.F;
        }));
        __webpack_require__.d(interface_namespaceObject, "FUNDING", (function() {
            return constants.v;
        }));
        __webpack_require__.d(interface_namespaceObject, "CARD", (function() {
            return constants.o;
        }));
        __webpack_require__.d(interface_namespaceObject, "request", (function() {
            return lib.R;
        }));
        __webpack_require__.d(interface_namespaceObject, "isEligible", (function() {
            return lib.D;
        }));
        __webpack_require__.d(interface_namespaceObject, "isFundingRemembered", (function() {
            return lib.E;
        }));
        __webpack_require__.d(interface_namespaceObject, "forceIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "isWebView", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "allowIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "logExperimentTreatment", (function() {
            return logExperimentTreatment;
        }));
        __webpack_require__.d(interface_namespaceObject, "logFundingEligibility", (function() {
            return src_funding.e;
        }));
        __webpack_require__.d(interface_namespaceObject, "onPossiblyUnhandledException", (function() {
            return onPossiblyUnhandledException;
        }));
        __webpack_require__.d(interface_namespaceObject, "version", (function() {
            return interface_version;
        }));
        __webpack_require__.d(interface_namespaceObject, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(interface_namespaceObject, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(interface_namespaceObject, "Checkout", (function() {
            return interface_Checkout;
        }));
        __webpack_require__.d(interface_namespaceObject, "BillingPage", (function() {
            return interface_BillingPage;
        }));
        __webpack_require__.d(interface_namespaceObject, "PayPalCheckout", (function() {
            return PayPalCheckout;
        }));
        __webpack_require__.d(interface_namespaceObject, "destroyAll", (function() {
            return destroyAll;
        }));
        __webpack_require__.d(interface_namespaceObject, "enableCheckoutIframe", (function() {
            return enableCheckoutIframe;
        }));
        __webpack_require__.d(interface_namespaceObject, "logger", (function() {
            return logger;
        }));
        __webpack_require__.d(interface_namespaceObject, "ThreeDomainSecure", (function() {
            return interface_ThreeDomainSecure;
        }));
        var beaver_logger_client = __webpack_require__(4);
        var src = __webpack_require__(22);
        var zalgo_promise_src = __webpack_require__(2);
        var post_robot_src = __webpack_require__(15);
        var lib = __webpack_require__(3);
        var src_checkout = __webpack_require__(18);
        var esm_extends = __webpack_require__(13);
        var belter_src = __webpack_require__(11);
        var constants = __webpack_require__(0);
        var config = __webpack_require__(5);
        var resources = __webpack_require__(19);
        var containerContent = __webpack_require__(33);
        var checkout_template = __webpack_require__(31);
        var _LOGO_COLOR;
        var LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, 
        _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
            var _props$locale$split = props.locale.split("_"), lang = _props$locale$split[0], country = _props$locale$split[1];
            var containerStyle = "\n        " + Object(checkout_template.c)({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            }) + "\n        @media screen and (max-width: 470px) {\n            #" + id + " .paypal-checkout-close {\n                position: absolute;\n                right: 20px;\n                width: 40px;\n                height: 40px;\n                opacity: 0.6;\n                top: 20px;\n                opacity: 0.6;\n                z-index: 2;\n            }\n\n            #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n                position: absolute;\n                left: 20px;\n                content: ' ';\n                height: 40px;\n                width: 1px;\n                background-color: #111 !important;\n            }\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                height: 100%;\n                min-height: 100%;\n                max-height: 100%;\n                min-width: 100%;\n                max-width: 100%;\n                border-radius: 0px;\n            }\n            #" + id + " ." + CLASS.OUTLET + " {\n                height: 100%;\n            }\n        }\n    ";
            var content = containerContent.a[country][lang];
            function focus(event) {
                event.preventDefault();
                event.stopPropagation();
                Object(belter_src.j)() && Object(belter_src.p)() ? window.alert("Please switch tabs to reactivate the PayPal window") : actions.focus();
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK;
            var logoColor = LOGO_COLOR[overlayColor];
            var ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor];
            var paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor];
            var el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "PayPal Checkout Overlay"
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    props.onCancel && props.onCancel();
                    actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, containerStyle));
            var container = jsxDom("html", null, jsxDom("body", null, el));
            on(EVENT.CLOSE, (function() {
                el.className += " " + tag + "-loading";
            }));
            return jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, Object(checkout_template.d)({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
        var BillingPage = Object(src.c)({
            tag: "billing-page",
            name: "billing-page",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/billing";
            },
            get domain() {
                var _extends2;
                return Object(esm_extends.a)({}, config.a.paypalDomains, ((_extends2 = {})[constants.t.LOCAL] = /^http:\/\/localhost.paypal.com:\d+$/, 
                _extends2));
            },
            scrolling: !0,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.x)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.k)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.j)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                cardType: {
                    type: "string",
                    required: !1
                },
                prefilledZipCode: {
                    type: "string",
                    required: !1
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.m)()
                        }));
                    }
                }
            },
            containerTemplate: containerTemplate
        });
        var ThreeDomainSecure = Object(src.c)({
            tag: "paypal-3ds",
            name: "3ds",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/init3ds";
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            scrolling: !0,
            props: {
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.m)()
                        }));
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.j)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                challengeUrl: {
                    type: "string"
                },
                threeDomainSecureToken: {
                    type: "string"
                },
                method: {
                    type: "string"
                },
                onSuccess: {
                    type: "function",
                    required: !1
                },
                onError: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !0,
                    allowDelegate: !0
                }
            },
            containerTemplate: containerTemplate
        });
        var cross_domain_utils_src = __webpack_require__(7);
        var src_lib = __webpack_require__(6);
        var pptm = (noContentFoundInContainer = !1, callback = "__pptmLoadedWithNoContent", 
        obj = {
            reloadPptmScript: function(clientId) {
                !function tryCreatePptmScript() {
                    if (obj.shouldReloadPptmScript(clientId)) {
                        obj.removePptm();
                        obj.createPptmScript(clientId);
                    } else listener = tryCreatePptmScript;
                }();
            },
            listenForLoadWithNoContent: function() {
                window[callback] = function() {
                    noContentFoundInContainer = !0;
                    if (listener) {
                        listener();
                        listener = void 0;
                    }
                };
            },
            listenForButtonRender: function() {
                window.paypalDDL = window.paypalDDL || [];
                0 === window.paypalDDL.filter((function(e) {
                    return "paypalButtonRender" === e.event;
                })).length && window.paypalDDL.push({
                    event: "paypalButtonRender"
                });
            },
            get callback() {
                return callback;
            },
            get noContentFoundInContainer() {
                return noContentFoundInContainer;
            },
            createPptmScript: function(clientId) {
                var _track;
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOAD, _track));
                var params = {
                    t: "xo",
                    id: window.location.hostname,
                    mrid: config.a.merchantID,
                    client_id: "",
                    v: config.a.version,
                    source: "checkoutjs"
                };
                clientId ? params.client_id = clientId : delete params.client_id;
                var fullUrl = Object(lib.h)(config.a.pptmUrl, params);
                Object(lib.H)(fullUrl, 0, {
                    async: !0,
                    id: constants.E
                }).then((function() {
                    var _track2;
                    window.paypalDDL && window.paypalDDL[0] && "snippetRun" === window.paypalDDL[0].event || window[callback]();
                    Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                    _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOADED, _track2));
                })).catch((function(err) {
                    Object(beaver_logger_client.k)("pptm_script_error", {
                        error: Object(lib.U)(err)
                    });
                }));
            },
            shouldCreateInitialPptmScript: function() {
                if (!window.location.hostname) return !1;
                if (Object(lib.F)()) return !1;
                var existingScript = Object(lib.o)(constants.E);
                if (Boolean(existingScript)) {
                    Object(beaver_logger_client.k)("pptm_tried_loading_twice");
                    return !1;
                }
                return !0;
            },
            shouldReloadPptmScript: function(clientId) {
                return !1 !== noContentFoundInContainer && !Object(lib.F)() && !config.a.merchantID && !!clientId;
            },
            removePptm: function() {
                var script = Object(lib.o)(constants.E);
                script && script.parentNode.removeChild(script);
            }
        });
        var noContentFoundInContainer, callback, listener, obj;
        var proxyRest = {};
        var createAccessToken = Object(lib.I)((function(env, client) {
            Object(beaver_logger_client.k)("rest_api_create_access_token");
            var clientID = client[env = env || config.a.env];
            if (!clientID) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createAccessToken && !proxyRest.createAccessToken.source.closed) return proxyRest.createAccessToken(env, client);
            var basicAuth = Object(belter_src.a)(clientID + ":");
            return Object(lib.R)({
                method: "post",
                url: config.a.authApiUrls[env],
                headers: {
                    Authorization: "Basic " + basicAuth
                },
                data: {
                    grant_type: "client_credentials"
                }
            }).then((function(res) {
                if (res && "invalid_client" === res.error) throw new Error("Auth Api invalid " + env + " client id: " + clientID + ":\n\n" + JSON.stringify(res, null, 4));
                if (!res || !res.access_token) throw new Error("Auth Api response error:\n\n" + JSON.stringify(res, null, 4));
                return res.access_token;
            }));
        }), {
            time: 6e5
        });
        var createExperienceProfile = Object(lib.I)((function(env, client, experienceDetails) {
            void 0 === experienceDetails && (experienceDetails = {});
            Object(beaver_logger_client.k)("rest_api_create_experience_profile");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createExperienceProfile && !proxyRest.createExperienceProfile.source.closed) return proxyRest.createExperienceProfile(env, client, experienceDetails);
            experienceDetails.temporary = !0;
            experienceDetails.name = experienceDetails.name ? experienceDetails.name + "_" + Math.random().toString() : Math.random().toString();
            return createAccessToken(env, client).then((function(accessToken) {
                return Object(lib.R)({
                    method: "post",
                    url: config.a.experienceApiUrls[env],
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                    json: experienceDetails
                });
            })).then((function(res) {
                if (res && res.error) throw new Error(res.error);
                if (!res.id) throw new Error("No id in experience profile response:\n\n" + JSON.stringify(res, null, 4));
                return res.id;
            }));
        }), {
            time: 6e5
        });
        function logPaymentResponse(res) {
            var _track;
            if (res) {
                var paymentToken;
                var paymentID;
                res.id && (paymentID = res.id);
                if (res.links && res.links.length) for (var i = 0; i < res.links.length; i++) if ("REDIRECT" === res.links[i].method && "approval_url" === res.links[i].rel) {
                    var match = res.links[i].href.match(/token=((EC-)?[A-Z0-9]{17})/);
                    match && (paymentToken = match[1]);
                }
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CREATE_PAYMENT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.C.PAY_ID], 
                _track[constants.u.KEY.PAY_ID] = paymentID, _track[constants.u.KEY.TOKEN] = paymentToken, 
                _track[constants.u.KEY.CONTEXT_ID] = paymentID, _track));
            }
        }
        function createPayment(env, client, paymentDetails) {
            Object(beaver_logger_client.k)("rest_api_create_checkout_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var payment = paymentDetails.payment, experience = paymentDetails.experience, meta = paymentDetails.meta, tracking = paymentDetails.tracking;
            if (!payment) throw new Error("Expected payment details to be passed");
            if (proxyRest.createPayment && !proxyRest.createPayment.source.closed) return proxyRest.createPayment(env, client, {
                payment: payment,
                experience: experience,
                meta: meta,
                tracking: tracking
            });
            (payment = Object(esm_extends.a)({}, payment)).intent = payment.intent || "sale";
            payment.redirect_urls = payment.redirect_urls || {};
            payment.redirect_urls.return_url = payment.redirect_urls.return_url || "https://www.paypal.com/checkoutnow/error";
            payment.redirect_urls.cancel_url = payment.redirect_urls.cancel_url || "https://www.paypal.com/checkoutnow/error";
            payment.payer = payment.payer || {};
            payment.payer.payment_method = payment.payer.payment_method || "paypal";
            return createAccessToken(env, client).then((function(accessToken) {
                return zalgo_promise_src.a.try((function() {
                    if (experience) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experience));
                })).then((function(experienceID) {
                    return zalgo_promise_src.a.try((function() {
                        if (tracking) return zalgo_promise_src.a.resolve(function(env, client, merchantID, trackingData) {
                            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
                            var trackingID = Object(lib.W)();
                            return createAccessToken(env, client).then((function(accessToken) {
                                var headers = {
                                    Authorization: "Bearer " + accessToken
                                };
                                return Object(lib.R)({
                                    method: "put",
                                    url: config.a.trackingApiUrls[env] + "/" + merchantID + "/" + trackingID,
                                    headers: headers,
                                    json: {
                                        tracking_id: trackingID,
                                        additional_data: trackingData
                                    }
                                });
                            })).then((function() {
                                return trackingID;
                            }));
                        }(env, client, tracking.id, tracking.data));
                    })).then((function(trackingID) {
                        experienceID && (payment.experience_profile_id = experienceID);
                        var headers = {
                            Authorization: "Bearer " + accessToken
                        };
                        trackingID && (headers["Paypal-Client-Metadata-Id"] = trackingID);
                        meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                        return Object(lib.R)({
                            method: "post",
                            url: config.a.paymentApiUrls[env],
                            headers: headers,
                            json: payment
                        });
                    }));
                }));
            })).then((function(res) {
                logPaymentResponse(res);
                if (res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createOrder(env, client, paymentDetails) {
            Object(beaver_logger_client.k)("rest_api_create_order_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var order = paymentDetails.order, meta = paymentDetails.meta;
            if (!order) throw new Error("Expected order details to be passed");
            if (proxyRest.createOrder && !proxyRest.createOrder.source.closed) return proxyRest.createOrder(env, client, {
                order: order,
                meta: meta
            });
            (order = Object(esm_extends.a)({}, order)).intent = order.intent || "CAPTURE";
            order.application_context = order.application_context || {};
            order.application_context.return_url = order.application_context.return_url || "https://www.paypal.com/checkoutnow/error";
            order.application_context.cancel_url = order.application_context.cancel_url || "https://www.paypal.com/checkoutnow/error";
            order.purchase_units = order.purchase_units || [];
            order.purchase_units[0] = order.purchase_units[0] || {};
            order.purchase_units.forEach((function(unit) {
                unit.reference_id = unit.reference_id || Math.random().toString();
            }));
            return createAccessToken(env, client).then((function(accessToken) {
                var headers = {
                    Authorization: "Bearer " + accessToken
                };
                meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                return Object(lib.R)({
                    method: "post",
                    url: config.a.orderApiUrls[env],
                    headers: headers,
                    json: order
                });
            })).then((function(res) {
                logPaymentResponse(res);
                if (res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createBillingAgreement(env, client, billingDetails, experienceDetails) {
            Object(beaver_logger_client.k)("rest_api_create_billing_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createBillingAgreement && !proxyRest.createBillingAgreement.source.closed) return proxyRest.createBillingAgreement(env, client, billingDetails, experienceDetails);
            (billingDetails = Object(esm_extends.a)({}, billingDetails)).plan = billingDetails.plan || {};
            billingDetails.plan.merchant_preferences = billingDetails.plan.merchant_preferences || {};
            billingDetails.plan.merchant_preferences.return_url = billingDetails.plan.merchant_preferences.return_url || "https://www.paypal.com/checkoutnow/error";
            billingDetails.plan.merchant_preferences.cancel_url = billingDetails.plan.merchant_preferences.cancel_url || "https://www.paypal.com/checkoutnow/error";
            billingDetails.payer = billingDetails.payer || {};
            billingDetails.payer.payment_method = billingDetails.payer.payment_method || "paypal";
            return createAccessToken(env, client).then((function(accessToken) {
                return zalgo_promise_src.a.try((function() {
                    if (experienceDetails) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experienceDetails));
                })).then((function(experienceID) {
                    experienceID && (billingDetails.experience_profile_id = experienceID);
                    return Object(lib.R)({
                        method: "post",
                        url: config.a.billingApiUrls[env],
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        json: billingDetails
                    });
                }));
            })).then((function(res) {
                if (res && res.token_id) return res.token_id;
                throw new Error("Billing Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        var rest = {
            payment: {
                create: createPayment
            },
            order: {
                create: createOrder
            },
            billingAgreement: {
                create: createBillingAgreement
            },
            experience: {
                create: createExperienceProfile
            }
        };
        var parentWin = Object(cross_domain_utils_src.f)();
        Object(post_robot_src.on)("proxy_rest", {
            domain: config.a.paypal_domain_regex
        }, (function(_ref) {
            proxyRest = _ref.data;
        }));
        parentWin && Object(lib.F)() && !Object(cross_domain_utils_src.v)(parentWin) && Object(post_robot_src.send)(parentWin, "proxy_rest", {
            createAccessToken: createAccessToken,
            createExperienceProfile: createExperienceProfile,
            createPayment: createPayment,
            createBillingAgreement: createBillingAgreement,
            createOrder: createOrder
        }).catch((function() {}));
        var onAuthorizeListener = Object(lib.f)();
        function log(experiment, treatment, token, state) {
            Object(lib.y)((function(session) {
                var event = experiment + "_" + treatment + "_" + state;
                var loggedEvents = session.loggedExperimentEvents = session.loggedExperimentEvents || [];
                if (-1 !== loggedEvents.indexOf(event)) Object(beaver_logger_client.k)("duplicate_" + event); else {
                    var _track;
                    Object(beaver_logger_client.k)(event);
                    loggedEvents.push(event);
                    var edge = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/Edge\/[0-9]{2}/);
                    edge && (event = Object(beaver_logger_client.k)(edge[0].toLowerCase().replace("/", "_") + "_" + event));
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                    _track[constants.u.KEY.TRANSITION] = state, _track[constants.u.KEY.EXPERIMENT_NAME] = experiment, 
                    _track[constants.u.KEY.TREATMENT_NAME] = treatment, _track[constants.u.KEY.TOKEN] = token, 
                    _track[constants.u.KEY.CONTEXT_ID] = token, _track[constants.u.KEY.CONTEXT_TYPE] = token ? constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN] : constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID, 
                    _track));
                    Object(beaver_logger_client.j)();
                }
            }));
        }
        function logExperimentTreatment(_ref) {
            var experiment = _ref.experiment, treatment = _ref.treatment, state = _ref.state, token = _ref.token;
            if (experiment && treatment) {
                Object(lib.y)((function(session) {
                    session.externalExperiment = experiment;
                    session.externalExperimentTreatment = treatment;
                    token && (session.externalExperimentToken = token);
                }));
                log(experiment, treatment, token, state);
            }
        }
        function logReturn(token) {
            var _getSessionState = Object(lib.y)((function(session) {
                return session;
            })), externalExperiment = _getSessionState.externalExperiment, externalExperimentTreatment = _getSessionState.externalExperimentTreatment, externalExperimentToken = _getSessionState.externalExperimentToken;
            externalExperiment && externalExperimentTreatment && externalExperimentToken === token ? log(externalExperiment, externalExperimentTreatment, token, "complete") : Object(beaver_logger_client.k)("experiment_mismatch", {
                token: token,
                externalExperiment: externalExperiment,
                externalExperimentTreatment: externalExperimentTreatment,
                externalExperimentToken: externalExperimentToken
            });
        }
        if (Object(lib.n)("log_authorize")) {
            onAuthorizeListener.once((function(_ref2) {
                var paymentToken = _ref2.paymentToken;
                setTimeout((function() {
                    logReturn(paymentToken);
                }), 1);
            }));
            var returnToken = Object(lib.v)();
            returnToken && setTimeout((function() {
                returnToken && logReturn(returnToken);
            }), 1);
        }
        var integrations = __webpack_require__(28);
        var integrations_checkout = __webpack_require__(32);
        function normalizeCheckoutProps(props) {
            return {
                env: props.env = props.env || config.a.env,
                payment: props.payment,
                onAuthorize: Object(src_lib.H)(props.onAuthorize),
                onCancel: Object(src_lib.H)(props.onCancel || src_lib.F)
            };
        }
        function awaitPopupBridge(Button) {
            return Button.xprops && Button.xprops.awaitPopupBridge ? Button.xprops.awaitPopupBridge() : Object(lib.b)(window, "popupBridge").then((function(popupBridge) {
                return function(popupBridge) {
                    return {
                        open: function(url) {
                            return new zalgo_promise_src.a((function(resolve, reject) {
                                popupBridge.onComplete = function(err, result) {
                                    return result ? err ? reject(err) : resolve(result) : reject(new Error("No payload passed in popupBridge.onComplete"));
                                };
                                popupBridge.onCancel = function() {
                                    var err = new Error("PAYMENT_CANCELLED");
                                    err.code = "PAYMENT_CANCELLED";
                                    return reject(err);
                                };
                                popupBridge.open(Object(lib.h)(url, {
                                    redirect_uri: popupBridge.getReturnUrlPrefix()
                                }));
                            }));
                        }
                    };
                }(popupBridge);
            }));
        }
        var src_funding = __webpack_require__(27);
        var button_config = __webpack_require__(12);
        var button_props = __webpack_require__(26);
        var jsx = __webpack_require__(1);
        function validateButtonLocale(locale) {
            if (!locale) throw new Error("Expected props.locale to be set");
            if (!locale.match(/^[a-z]{2}[_][A-Z][A-Z0-9]$/)) throw new Error("Expected props.locale to be valid, got " + locale);
            var _locale$split = locale.split("_"), country = _locale$split[1];
            if (!constants.A[country] || -1 === constants.A[country].indexOf(_locale$split[0])) throw new Error("Expected props.locale to be valid");
        }
        function validateButtonStyle(style, props) {
            void 0 === style && (style = {});
            if (!style) throw new Error("Expected props.style to be set");
            var label = style[constants.m.LABEL] || Object(button_config.e)("DEFAULT", style[constants.m.LAYOUT] === constants.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
            if (!button_config.a[label]) throw new Error("Invalid button label: " + label + ", expected: " + Object.keys(button_config.a[label]).join(", "));
            var color = style[constants.m.COLOR], shape = style[constants.m.SHAPE], size = style[constants.m.SIZE], branding = style[constants.m.BRANDING], fundingicons = style[constants.m.FUNDINGICONS], tagline = style[constants.m.TAGLINE], layout = style[constants.m.LAYOUT], maxbuttons = style[constants.m.MAXBUTTONS], height = style[constants.m.HEIGHT];
            if (color && -1 === Object(button_config.e)(label, "colors").indexOf(color)) throw new Error("Unexpected style." + constants.m.COLOR + " for " + label + " button: " + color + ", expected " + Object(button_config.e)(label, "colors").join(", "));
            if (shape && -1 === Object(button_config.e)(label, "shapes").indexOf(shape)) throw new Error("Unexpected style." + constants.m.SHAPE + " for " + label + " button: " + shape + ", expected " + Object(button_config.e)(label, "shapes").join(", "));
            if (size && -1 === Object(button_config.e)(label, "sizes").indexOf(size)) throw new Error("Unexpected style." + constants.m.SIZE + " for " + label + " button: " + size + ", expected " + Object(button_config.e)(label, "sizes").join(", "));
            if (!1 === branding) throw new Error("style." + constants.m.BRANDING + ":false is not allowed");
            if (fundingicons && !Object(button_config.e)(label, "allowFundingIcons")) throw new Error("style." + constants.m.FUNDINGICONS + ":true is not allowed for " + label + " button");
            if (layout && -1 === Object(button_config.e)(label, "layouts").indexOf(layout)) throw new Error("Unexpected style." + constants.m.LAYOUT + " for " + label + " button: " + layout + ", expected " + Object(button_config.e)(label, "layouts").join(", "));
            if (void 0 !== maxbuttons) {
                if ("number" != typeof maxbuttons) throw new TypeError("Expected style." + constants.m.MAXBUTTONS + " to be a number, got: " + maxbuttons);
                if (maxbuttons < 1) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be a at least 1, got: " + maxbuttons);
                var minButtons = layout === constants.g.VERTICAL ? Object(button_config.e)(label, "minVerticalButtons") : Object(button_config.e)(label, "minHorizontalButtons");
                if (maxbuttons < minButtons) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be no fewer than " + minButtons + ", got " + maxbuttons);
            }
            if (void 0 !== height) {
                if ("number" != typeof height) throw new TypeError("Expected style." + constants.m.HEIGHT + " to be a number, got: " + maxbuttons);
                var buttonSize = size || Object(button_config.e)(label, style.layout === constants.g.VERTICAL ? "defaultVerticalSize" : "defaultSize");
                var _ref = size === constants.l.RESPONSIVE ? {
                    minHeight: button_config.c[constants.l.SMALL].minHeight,
                    maxHeight: button_config.c[constants.l.HUGE].maxHeight
                } : button_config.c[buttonSize], minHeight = _ref.minHeight, maxHeight = _ref.maxHeight;
                if (height < minHeight || height > maxHeight) throw new Error("Expected style." + constants.m.HEIGHT + " to be between " + minHeight + "px and " + maxHeight + "px - got " + height + "px");
            }
            if (!Object(button_config.e)(label, "allowPrimary")) throw new Error(label + " can not be used as primary button label");
            if (layout === constants.g.VERTICAL) {
                if (size && -1 === [ constants.l.MEDIUM, constants.l.LARGE, constants.l.RESPONSIVE ].indexOf(size)) throw new Error("Button must be at least " + constants.l.MEDIUM + " size for " + constants.g.VERTICAL + " layout");
                if (!Object(button_config.e)(label, "allowPrimaryVertical")) throw new Error("style." + constants.m.LABEL + " option is not allowed for " + constants.g.VERTICAL + " layout - got " + label);
                if (fundingicons) throw new Error("style." + constants.m.FUNDINGICONS + " not allowed for " + constants.g.VERTICAL + " layout - got " + fundingicons);
                if (tagline) throw new Error("style." + constants.m.TAGLINE + " is not allowed for " + constants.g.VERTICAL + " layout - got " + tagline);
            }
            !function(style, locale) {
                void 0 === style && (style = {});
                void 0 === locale && (locale = "en_US");
                var country = locale.split("_")[1];
                var isInstallmentAllowedCountry = -1 !== constants.a.indexOf(country);
                if (!isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT) throw new Error("Unexpected label: style." + style.label + " for country: " + country);
                if (!isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for country: " + country);
                if (isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD] && style.label !== constants.f.INSTALLMENT) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for label: style." + style.label);
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && "number" != typeof style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is expected to be a number");
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && -1 === constants.b[country].indexOf(style[constants.m.INSTALLMENTPERIOD])) throw new Error("style." + constants.m.INSTALLMENTPERIOD + ": " + style[constants.m.INSTALLMENTPERIOD] + " is not a valid installment number for " + style.label);
            }(style, props.locale);
        }
        var class_CLASS = {
            SHOULD_FOCUS: "paypal-should-focus",
            CONTAINER: "paypal-button-container",
            BUTTON: "paypal-button",
            BUTTON_LABEL: "paypal-button-label-container",
            LABEL: "paypal-button-label",
            COLOR: "paypal-button-color",
            LOGO_COLOR: "paypal-button-logo-color",
            SHAPE: "paypal-button-shape",
            BRANDING: "paypal-button-branding",
            LAYOUT: "paypal-button-layout",
            NUMBER: "paypal-button-number",
            ENV: "paypal-button-env",
            TAGLINE: "paypal-button-tagline",
            TAGLINE_COLOR: "paypal-button-tagline-color",
            FUNDINGICONS: "paypal-button-fundingicons",
            TEXT: "paypal-button-text",
            LOGO: "paypal-button-logo",
            CARD: "paypal-button-card",
            SEPARATOR: "paypal-separator",
            HIDDEN: "hidden",
            DOM_READY: "dom-ready",
            PERSONALIZATION_TEXT: "personalization-text"
        };
        var pageStyle = "\n    html, body {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n    }\n\n    body {\n        display: inline-block;\n        vertical-align: top;\n    }\n\n    * {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: default;\n        box-sizing: border-box;\n    }\n    \n    ." + class_CLASS.HIDDEN + " {\n        position: absolute;\n        visibility: hidden;\n    }\n";
        var buttonStyle = "\n\n    ." + class_CLASS.CONTAINER + ' {\n        display: block;\n        white-space: nowrap;\n        margin: 0;\n        background: 0;\n        border: 0;\n        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n        text-transform: none;\n        font-weight: 500;R\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        z-index: 0;\n        font-size: 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .' + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n        border: 1px solid transparent;\n        border-radius: 0 3px 3px 0;\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        vertical-align: top;\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        cursor: auto;\n    }\n\n    ." + class_CLASS.BUTTON + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.ENV + "-" + constants.t.TEST + " ." + class_CLASS.TEXT + " {\n        font-family: Arial !important;\n        background: rgba(0, 0, 0, 0.5) !important;\n        color: transparent  !important;\n        text-shadow: none  !important;\n    }\n\n    ." + class_CLASS.BUTTON + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + ":hover,\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);\n    }\n\n    ." + class_CLASS.CARD + ", ." + class_CLASS.CARD + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CARD + ":hover {\n        filter: brightness(1.2);\n    }\n\n    ." + class_CLASS.BUTTON + ":focus, ." + class_CLASS.CARD + ":focus {\n        outline: none;\n    }\n\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.BUTTON + ":focus,\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.CARD + ":focus {\n        outline: solid 2px Highlight;\n        outline: auto 5px -webkit-focus-ring-color;\n        outline-offset: -3px;\n    }\n\n    ." + class_CLASS.BUTTON + ":focus {\n        box-shadow: -1px -1px 18px 1px rgba(0, 0, 0, 0.25) inset;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + ":focus {\n        box-shadow: none;\n        outline: none;\n    }\n\n    ." + class_CLASS.LOGO + " {\n        padding: 0;\n        display: inline-block;\n        background: none;\n        border: none;\n        width: auto;\n    }\n\n    ." + class_CLASS.TEXT + " {\n        display: inline-block;\n        white-space: pre;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " {\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n    }\n    \n    ." + class_CLASS.BUTTON + " > ." + class_CLASS.BUTTON_LABEL + " > * {\n        vertical-align: top;\n        height: 100%;\n        text-align: left;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n        border-radius: 4px;\n    }\n\n    .powered-by-paypal > ." + class_CLASS.TEXT + " {\n        vertical-align: top;\n        line-height: 18px;\n    }\n\n    .powered-by-paypal > ." + class_CLASS.LOGO + " {\n        height: 16px;\n        min-height: 16px;\n    }\n\n    ." + class_CLASS.TAGLINE + " {\n        max-width: 100%;\n        font-weight: normal;\n        display: block;\n        text-align: center;\n        width: auto;\n    }\n\n    ." + class_CLASS.SEPARATOR + " {\n        height: 80%;\n        border-left: 1px solid rgba(0, 0, 0, 0.15);\n        margin: 0 8px;\n        display: inline-block;\n        position: relative;\n        top: 10%;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " ." + class_CLASS.SEPARATOR + " {\n        border-color: rgba(255, 255, 255, 0.45);\n    }\n";
        var layoutStyle = "\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " ." + class_CLASS.TAGLINE + " {\n        display: none;\n    }\n";
        var brandingStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + "  {\n        min-width: 60%;\n        width: auto;\n        font-weight: 900;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " ." + class_CLASS.LOGO + " {\n        display: none;\n    }\n";
        var labelStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CARD + " {\n        border-radius: 0 !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.TEXT + " {\n        display: none !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n        display: none;\n    }\n\n    @media only screen and (max-width : " + button_config.c[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: none;\n        }\n    }\n\n    @media only screen and (min-width : " + button_config.c[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: inline-block;\n        }\n    }\n";
        var util = __webpack_require__(14);
        var buttonColorStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + " {\n        background: #ffc439;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLUE + " {\n        background: #009cde;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + " {\n        background: #eee;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " {\n        background: #2C2E2F;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.DARKBLUE + " {\n        background: #003087;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        background: transparent;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.WHITE + " {\n        background: #fff;\n        color: #2C2E2F;\n        border: 1px solid #2C2E2F;\n    }\n";
        var componentContent = {
            AD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            AG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AT: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AU: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BE: {
                en: {
                    checkout: "Pay with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                nl: {
                    checkout: "Betalen met {logo:pp} {logo:paypal}",
                    safer_tag: "De veiligere en snellere manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            BF: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BH: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BR: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Finalizar",
                    safer_tag: "A maneira fácil e segura de pagar.",
                    later_tag: "Compre agora e pague depois.",
                    pay: "Pague com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    installment: "{logo:pp} {logo:paypal}  Pagamentos parcelados",
                    installment_period: "{logo:pp} {logo:paypal}  Pague em até [installmentperiod]x sem juros",
                    poweredBy: "Com tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BT: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            C2: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer",
                    later_tag: "Acheter. Payer plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            CD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CH: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CL: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CN: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CZ: {
                cs: {
                    checkout: "Zaplatit přes {logo:pp} {logo:paypal}",
                    safer_tag: "Jednodušší a bezpečnější způsob placení",
                    later_tag: "Nakupujte nyní, plaťte později.",
                    pay: "Zaplatit přes {logo: paypal}",
                    buynow: "Koupit ihned přes {logo:pp} {logo:paypal}",
                    poweredBy: "Využívá službu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DE: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Überall schnell und sicher bezahlen.",
                    later_tag: "Jetzt bei uns bequem in Raten zahlen.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DK: {
                da: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DZ: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EC: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EG: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ER: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ES: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Tecnología de {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ET: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FI: {
                fi: {
                    checkout: "{logo:pp} {logo:paypal}-maksu",
                    safer_tag: "Turvallisempi ja helpompi maksutapa",
                    later_tag: "Osta nyt. Maksa vähitellen.",
                    pay: "{logo:paypal}-maksu",
                    buynow: "{logo:pp} {logo:paypal} Osta nyt",
                    poweredBy: "Palvelun tarjoaa {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FM: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            FO: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FR: {
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Pay",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GA: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GB: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GL: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GP: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GR: {
                el: {
                    checkout: "Ολοκλήρωση αγοράς μέσω {logo:pp} {logo:paypal}",
                    safer_tag: "Ο ασφαλέστερος και ευκολότερος τρόπος πληρωμής",
                    later_tag: "Αγοράστε τώρα.  Πληρώστε σε δόσεις.",
                    pay: "Πληρωμή μέσω {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Αγορά τώρα",
                    poweredBy: "Με την υποστήριξη του {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GT: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即買",
                    poweredBy: "支援方： {logo:paypal}"
                }
            },
            HN: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            HU: {
                hu: {
                    checkout: "{logo:pp} {logo:paypal}-fizetés",
                    safer_tag: "Biztonságosabb, könnyebb fizetési mód.",
                    later_tag: "Vásároljon most. Fizessen később.",
                    pay: "{logo:paypal}-fizetés",
                    buynow: "{logo:pp} {logo:paypal} Vásárlás",
                    poweredBy: "Üzemeltető: {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ID: {
                id: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "Cara yang lebih mudah dan aman untuk membayar.",
                    later_tag: "Beli Sekarang. Bayar dalam Jangka Waktu Tertentu.",
                    pay: "Bayar dengan {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Beli Sekarang",
                    poweredBy: "Ditunjang teknologi {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            IL: {
                he: {
                    checkout: "{logo:pp} {logo:paypal} שלם",
                    safer_tag: ".הדרך הקלה והבטוחה יותר לשלם",
                    later_tag: "קנה עכשיו. שלם לאורך זמן.",
                    pay: "שלם באמצעות {logo:paypal}‏",
                    buynow: "{logo:pp} {logo:paypal} קנה עכשיו",
                    poweredBy: "{logo:paypal} מופעל על-ידי"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IT: {
                it: {
                    checkout: "{logo:pp} {logo:paypal} Paga adesso",
                    safer_tag: "Il modo rapido e sicuro per pagare",
                    later_tag: "Acquista ora. Paga più tardi.",
                    pay: "Paga con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Paga adesso",
                    poweredBy: "Con tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            JM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JO: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JP: {
                ja: {
                    checkout: "{logo:pp} {logo:paypal}で支払う",
                    safer_tag: "より安全・簡単にお支払い",
                    later_tag: "今すぐ購入して、分割してお支払い。",
                    pay: "{logo:paypal}で支払う",
                    buynow: "{logo:pp} {logo:paypal} 購入",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KR: {
                ko: {
                    checkout: "{logo:pp} {logo:paypal} 체크 아웃",
                    safer_tag: "더 안전하고 빠른 결제 방법",
                    later_tag: "지금 구매하고 천천히 결제하세요.",
                    pay: "{logo:paypal}로 지불하기",
                    buynow: "{logo:pp} {logo:paypal} 바로 구매",
                    poweredBy: "제공: {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KW: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ME: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ML: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MQ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MV: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MX: {
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    installment: "{logo:pp} {logo:paypal}  Pagos en mensualidades",
                    installment_period: "{logo:pp} {logo:paypal}  Pague hasta en [installmentperiod]x mensualidades",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MY: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NE: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NI: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NL: {
                nl: {
                    checkout: "{logo:pp} {logo:paypal} Betalen",
                    safer_tag: "Een veilige en makkelijke manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NO: {
                no: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "En trygg og enkel betalingsmetode",
                    later_tag: "Kjøp nå, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kjøp nå",
                    poweredBy: "Leveres av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NP: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NZ: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Un réflexe sécurité.",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar.",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            OM: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PA: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PL: {
                pl: {
                    checkout: "{logo:pp} {logo:paypal} Do kasy",
                    safer_tag: "Płać wygodnie i bezpiecznie",
                    later_tag: "Kup teraz. Płać w ratach",
                    pay: "Zapłać z {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kup teraz",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PT: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A forma rápida e segura de pagar",
                    later_tag: "Compre agora. Vá pagando.",
                    pay: "Pagar com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            QA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            RE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RU: {
                ru: {
                    checkout: "{logo:pp} {logo:paypal} Оформить покупку",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            RW: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SE: {
                sv: {
                    checkout: "{logo:pp} {logo:paypal} Betala",
                    safer_tag: "Ett tryggt och smidigt sätt att betala",
                    later_tag: "Köp nu, betala senare",
                    pay: "Betala med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Köp nu",
                    poweredBy: "Tillhandahålls av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SG: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SK: {
                sk: {
                    checkout: "Zaplatiť cez {logo:pp} {logo:paypal}",
                    safer_tag: "Jednoduchší a bezpečnejší spôsob platby",
                    later_tag: "Nakúpte teraz, zaplaťte postupne",
                    pay: "Zaplatiť cez {logo: paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kúpiť",
                    poweredBy: "Používa technológiu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ST: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SV: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TG: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TH: {
                th: {
                    checkout: "{logo:pp} {logo:paypal} ชำระเงิน",
                    safer_tag: "วิธีชำระเงินที่ปลอดภัยและง่ายกว่า",
                    later_tag: "ซื้อวันนี้ แล้วค่อยๆ จ่ายทีหลัง",
                    pay: "ชำระเงินด้วย {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} ซื้อทันที",
                    poweredBy: "ให้บริการโดย {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TN: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TO: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TR: {
                tr: {
                    checkout: "{logo:pp} {logo:paypal} ile Satın Alın",
                    safer_tag: "Ödeme yapmanın daha güvenli ve kolay yolu",
                    later_tag: "Şimdi Alın. Daha Sonra Ödeyin.",
                    pay: "{logo:paypal} ile Öde",
                    buynow: "{logo:pp} {logo:paypal} Hemen Satın Alın",
                    poweredBy: "Çalıştıran {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TW: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即購",
                    poweredBy: "服務提供者： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            US: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    dual_tag: "Two easy ways to pay",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "使用{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            VU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            YE: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            YT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            }
        };
        var allowedPersonalizationLabels = [ constants.f.CHECKOUT, constants.f.BUYNOW, constants.f.PAY ];
        function getCommonButtonClasses(_ref) {
            return [ class_CLASS.LAYOUT + "-" + _ref.layout, class_CLASS.SHAPE + "-" + _ref.shape, class_CLASS.BRANDING + "-" + (_ref.branding ? constants.d.BRANDED : constants.d.UNBRANDED), class_CLASS.NUMBER + "-" + (_ref.multiple ? constants.j.MULTIPLE : constants.j.SINGLE), class_CLASS.ENV + "-" + _ref.env, "" + class_CLASS.SHOULD_FOCUS ].join(" ");
        }
        function getLocaleContent(locale) {
            return componentContent[locale.country][locale.lang];
        }
        function determineLabel(_ref3) {
            var label = _ref3.label, source = _ref3.source, multiple = _ref3.multiple, layout = _ref3.layout;
            var defaultLabel = Object(button_config.d)(source);
            return Object(button_config.f)(label) === source ? multiple && layout === constants.g.HORIZONTAL ? defaultLabel : label : defaultLabel;
        }
        function renderCards(_ref5) {
            var layout = _ref5.layout, size = _ref5.size;
            return _ref5.cards.map((function(name) {
                var _ref6, _ref7, _ref8;
                var logo = resources.a[name];
                return Object(jsx.c)("div", Object(esm_extends.a)({}, ((_ref6 = {})[constants.c.LAYOUT] = layout || "", 
                _ref6), ((_ref7 = {})[constants.c.SIZE] = size || "", _ref7), ((_ref8 = {})[constants.c.FUNDING_SOURCE] = "" + constants.v.CARD, 
                _ref8[constants.c.CARD] = "" + name, _ref8), {
                    class: class_CLASS.CARD + " " + class_CLASS.CARD + "-" + name,
                    tabindex: "0"
                }), Object(jsx.c)("img", {
                    style: " display: block; ",
                    src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                    alt: name
                }));
            }));
        }
        function renderContent(text, _ref11) {
            var label = _ref11.label, locale = _ref11.locale, color = _ref11.color, branding = _ref11.branding, logoColor = _ref11.logoColor, funding = _ref11.funding, env = _ref11.env, _cards = _ref11.cards, dynamicContent = _ref11.dynamicContent, layout = _ref11.layout, size = _ref11.size;
            var _content = getLocaleContent(locale);
            return Object(jsx.b)(text, {
                text: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.c)("span", {
                        class: className,
                        optional: !0
                    }, value);
                },
                logo: function(name) {
                    if (branding) {
                        if (!logoColor) throw new Error("Can not determine logo without logo color");
                        var logo = "function" == typeof resources.b[name] ? resources.b[name]({
                            label: label,
                            locale: locale,
                            color: color,
                            branding: branding,
                            logoColor: logoColor,
                            funding: funding,
                            env: env,
                            cards: _cards
                        }) : resources.b[name][logoColor] || resources.b[name][constants.i.ANY];
                        return Object(jsx.c)("img", {
                            class: class_CLASS.LOGO + " " + class_CLASS.LOGO + "-" + name + " " + class_CLASS.LOGO + "-" + color,
                            src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                            alt: "",
                            "aria-label": name
                        });
                    }
                },
                content: function(name) {
                    var contentString;
                    for (var _i2 = 0, _name$split2 = name.split("|"); _i2 < _name$split2.length; _i2++) {
                        var key = _name$split2[_i2];
                        if (_content[key]) {
                            contentString = _content[key];
                            break;
                        }
                    }
                    if (!(contentString = contentString && contentString.replace(/\[([a-z]+)\]/g, (function(match, contentVariable) {
                        if (match && contentVariable) return dynamicContent && dynamicContent[contentVariable];
                    }))) && env === constants.t.TEST) throw new Error("Could not find content " + name + " for " + locale.lang + "_" + locale.country);
                    return renderContent(contentString || "", {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: _cards
                    });
                },
                cards: function() {
                    if (!funding) throw new Error("Can not determine card types without funding");
                    return renderCards({
                        cards: _cards,
                        layout: layout,
                        size: size
                    });
                },
                separator: function() {
                    return Object(jsx.c)("span", {
                        class: class_CLASS.SEPARATOR
                    });
                },
                break: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.c)("span", {
                        class: className
                    }, value.split("<br>")[0], Object(jsx.c)("br", null), value.split("<br>")[1]);
                }
            });
        }
        function componentTemplate(_ref20) {
            var _ref21;
            var props = _ref20.props;
            if (props && props.style) {
                var style = props.style;
                "generic" === style.label && (style.label = "paypal");
                "creditblue" === style.color && delete style.color;
                1 !== style.maxbuttons || !1 !== style.tagline || "responsive" !== style.size || "horizontal" !== style.layout || style.height || (style.height = 44);
            }
            !function(props) {
                if (!props) throw new Error("Expected props");
                var style = props.style;
                validateButtonLocale(props.locale);
                validateButtonStyle(style, props);
            }(props);
            var _normalizeProps = Object(button_props.a)(props), locale = _normalizeProps.locale, shape = _normalizeProps.shape, branding = _normalizeProps.branding, tagline = _normalizeProps.tagline, funding = _normalizeProps.funding, layout = _normalizeProps.layout, multiple = _normalizeProps.multiple, env = _normalizeProps.env, height = _normalizeProps.height, cards = _normalizeProps.cards, installmentperiod = _normalizeProps.installmentperiod, fundingicons = _normalizeProps.fundingicons, size = _normalizeProps.size, checkoutCustomization = _normalizeProps.checkoutCustomization;
            var buttonNodes = function(_ref4) {
                var label = _ref4.label, color = _ref4.color, multiple = _ref4.multiple, layout = _ref4.layout;
                return _ref4.sources.map((function(source, i) {
                    var buttonLabel = determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    });
                    return {
                        source: source,
                        label: buttonLabel,
                        color: multiple && i > 0 ? Object(button_config.e)(buttonLabel, "secondaryColors")[color] : color
                    };
                }));
            }({
                label: _normalizeProps.label,
                color: _normalizeProps.color,
                sources: _normalizeProps.sources,
                multiple: multiple,
                layout: layout
            }).map((function(button, i) {
                return function(_ref14) {
                    var _ref15, _ref16, _ref17;
                    var size = _ref14.size, label = _ref14.label, color = _ref14.color, locale = _ref14.locale, branding = _ref14.branding, multiple = _ref14.multiple, layout = _ref14.layout, shape = _ref14.shape, source = _ref14.source, funding = _ref14.funding, i = _ref14.i, env = _ref14.env, cards = _ref14.cards, installmentperiod = _ref14.installmentperiod;
                    var logoColor = Object(button_config.e)(label, "logoColors")[color];
                    var buttonLabel = determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    });
                    var contentText;
                    var allowedAnimation;
                    -1 !== allowedPersonalizationLabels.indexOf(label) && (allowedAnimation = !0);
                    var dynamicContent = {
                        installmentperiod: installmentperiod,
                        locale: locale
                    };
                    contentText = renderContent(contentText = "function" == typeof (contentText = buttonLabel !== label || label !== constants.f.BUYNOW || branding ? Object(button_config.e)(label, "logoLabel") : Object(button_config.e)(label, "label")) ? contentText(dynamicContent) : contentText, {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: cards,
                        dynamicContent: dynamicContent,
                        layout: layout,
                        size: size
                    });
                    var title = button_config.a[label].title;
                    var buttonTitle = "string" == typeof title ? title : function(_ref13) {
                        var label = _ref13.label, branding = _ref13.branding;
                        var localeContent = getLocaleContent(_ref13.locale);
                        var labelContent = localeContent && localeContent[label];
                        if (labelContent) {
                            var str = labelContent.replace(/({logo:(pp|paypal)})+(\s)*({logo:(pp|paypal)})*/, constants.w.PAYPAL);
                            label !== constants.f.BUYNOW || branding || (str = str.replace(constants.w.PAYPAL, ""));
                            return str;
                        }
                        return label;
                    }({
                        locale: locale,
                        label: label,
                        branding: branding
                    });
                    var hasTabIndex = -1 === [ constants.v.CARD ].indexOf(source);
                    var role = source === constants.v.CARD ? {} : {
                        role: "button"
                    };
                    return Object(jsx.c)("div", Object(esm_extends.a)({}, ((_ref15 = {})[constants.c.LAYOUT] = layout || "", 
                    _ref15), ((_ref16 = {})[constants.c.SIZE] = size || "", _ref16), ((_ref17 = {})[constants.c.FUNDING_SOURCE] = source, 
                    _ref17[constants.c.BUTTON] = !0, _ref17), {
                        class: class_CLASS.BUTTON + " " + class_CLASS.NUMBER + "-" + i + " " + getCommonButtonClasses({
                            layout: layout,
                            shape: shape,
                            branding: branding,
                            multiple: multiple,
                            env: env
                        }) + " " + (_ref2 = {
                            label: label,
                            color: color,
                            logoColor: logoColor
                        }, [ class_CLASS.LABEL + "-" + _ref2.label, class_CLASS.COLOR + "-" + _ref2.color, class_CLASS.LOGO_COLOR + "-" + _ref2.logoColor ].join(" "))
                    }, role, {
                        tabindex: hasTabIndex && 0,
                        "aria-label": buttonTitle
                    }), source === constants.v.CARD ? contentText : function(_ref12) {
                        var contentText = _ref12.contentText, personalizedButtonText = _ref12.personalizedButtonText, impression = _ref12.impression, branding = _ref12.branding, allowedAnimation = _ref12.allowedAnimation;
                        return Object(jsx.c)("div", {
                            class: "" + class_CLASS.BUTTON_LABEL
                        }, function(_ref10) {
                            var personalizedButtonText = _ref10.personalizedButtonText;
                            if (_ref10.branding && _ref10.allowedAnimation) {
                                var COMPRESSED = "\n        max-width: 0%;\n        opacity: 0;\n    ";
                                var EXPANDED = "\n        max-width: 100%;\n        opacity: 1;\n    ";
                                var HIDDEN = "\n        position: absolute;\n        visibility: hidden;\n    ";
                                var VISIBLE = "\n        position: static;\n        visibility: visible;\n    ";
                                var PAYPAL_BUTTON = "." + class_CLASS.BUTTON + "[" + constants.c.FUNDING_SOURCE + "=" + constants.v.PAYPAL + "]";
                                var PAYPAL_LOGO = PAYPAL_BUTTON + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.v.PAYPAL;
                                var BUTTON_TEXT = PAYPAL_BUTTON + " ." + class_CLASS.TEXT + ":not(.personalization-text)";
                                var PERSONALIZATION_TEXT = PAYPAL_BUTTON + " .personalization-text";
                                return Object(jsx.c)("style", {
                                    innerHTML: "\n\n            " + BUTTON_TEXT + ", " + PERSONALIZATION_TEXT + " {\n                " + HIDDEN + "\n            }\n\n            .dom-ready " + BUTTON_TEXT + ":not(." + class_CLASS.HIDDEN + ") {\n                " + VISIBLE + "\n                " + COMPRESSED + "\n                animation: show-text 1s 0s forwards;\n            }\n\n            @media only screen and (max-width: 300px) {\n                .dom-ready " + PERSONALIZATION_TEXT + " {\n                    " + HIDDEN + "\n                }\n            }\n\n            @media only screen and (min-width: 300px) {\n                .dom-ready " + PAYPAL_LOGO + " {\n                    animation: " + (personalizedButtonText ? "toggle-paypal-logo 5s 0s forwards" : "none") + ";\n                }\n\n                .dom-ready " + BUTTON_TEXT + ":not(." + class_CLASS.HIDDEN + ") {\n                    " + COMPRESSED + "\n                    " + VISIBLE + "\n                    animation: " + (personalizedButtonText ? "show-text-delayed 5s 0s forwards" : "show-text 1s 0s forwards") + ";\n                }\n\n                .dom-ready " + PERSONALIZATION_TEXT + " {\n                    " + COMPRESSED + "\n                    " + VISIBLE + "\n                    animation: show-personalization-text 5s 0s forwards;\n                }\n            }\n\n            @keyframes show-text {\n                0% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes toggle-paypal-logo {\n                0% { " + EXPANDED + " }\n                8% { " + COMPRESSED + " }\n                85% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes show-text-delayed {\n                0% { " + COMPRESSED + " }\n                85% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes show-personalization-text {\n                0% { " + COMPRESSED + " }\n                25% { " + EXPANDED + " }\n                75% { " + EXPANDED + " }\n                100% { " + COMPRESSED + " }\n            }\n        "
                                });
                            }
                        }({
                            personalizedButtonText: personalizedButtonText,
                            branding: branding,
                            allowedAnimation: allowedAnimation
                        }), contentText, personalizedButtonText, impression && function(impression) {
                            return Object(jsx.c)("div", {
                                class: "tracking-beacon"
                            }, Object(jsx.c)("style", {
                                innerHTML: "\n            .tracking-beacon {\n                visibility: hidden;\n                position: absolute;\n                height: 1px;\n                width: 1px;\n            }\n        "
                            }), Object(jsx.c)("img", {
                                class: "tracking-beacon",
                                src: impression
                            }));
                        }(impression));
                    }({
                        contentText: contentText,
                        personalizedButtonText: void 0,
                        impression: void 0,
                        branding: branding,
                        allowedAnimation: allowedAnimation
                    }));
                    var _ref2;
                }({
                    label: button.label,
                    color: button.color,
                    source: button.source,
                    env: env,
                    i: i,
                    funding: funding,
                    multiple: multiple,
                    locale: locale,
                    branding: branding,
                    tagline: tagline,
                    layout: layout,
                    shape: shape,
                    cards: cards,
                    installmentperiod: installmentperiod,
                    size: size,
                    checkoutCustomization: checkoutCustomization
                });
            }));
            var fundingiconNode = function(_ref9) {
                var cards = _ref9.cards, size = _ref9.size, layout = _ref9.layout;
                if (_ref9.fundingicons) return Object(jsx.c)("div", {
                    class: "" + class_CLASS.FUNDINGICONS
                }, renderCards({
                    cards: cards,
                    size: size,
                    layout: layout
                }));
            }({
                cards: cards,
                fundingicons: fundingicons,
                size: size,
                layout: layout
            });
            var styleNode = function(_ref19) {
                var height = _ref19.height, cardNumber = _ref19.cardNumber;
                return Object(jsx.c)("style", {
                    innerHTML: (_ref = {
                        height: height,
                        cardNumber: cardNumber
                    }, "\n        " + pageStyle + "\n        " + buttonStyle + "\n        " + buttonColorStyle + "\n        " + layoutStyle + "\n        " + brandingStyle + "\n        " + labelStyle + "\n        " + function(_ref) {
                        var height = _ref.height, _ref$cardNumber = _ref.cardNumber, cardNumber = void 0 === _ref$cardNumber ? 4 : _ref$cardNumber;
                        return Object.keys(button_config.c).map((function(size) {
                            var style = button_config.c[size];
                            var buttonHeight = height || style.defaultHeight;
                            var buttonTextMarginTop = style.buttonTextMargin;
                            var minDualWidth = Math.round(2.8 * buttonHeight * 2);
                            return "\n\n            @media only screen and (min-width: " + style.minWidth + "px) {\n\n                ." + class_CLASS.CONTAINER + " {\n                    min-width: " + style.minWidth + "px;\n                    max-width: " + style.maxWidth + "px;\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 32), 10) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n                    height: " + buttonHeight + "px;\n                    min-height: " + (height || style.minHeight) + "px;\n                    max-height: " + (height || style.maxHeight) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " ." + class_CLASS.BUTTON_LABEL + " {\n                    height: 100%;\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 45), 10) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " {\n                    height: " + (Object(util.m)(buttonHeight, 35) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 60) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n                \n                ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " ." + class_CLASS.TEXT + " {\n                    margin-top: " + buttonTextMarginTop + "px;\n                }\n                \n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.EPS + ",\n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.MYBANK + " {\n                    height: " + (Object(util.m)(buttonHeight, 50) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.PILL + " {\n                    border-radius: " + Math.ceil(buttonHeight / 2) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.RECT + " {\n                    border-radius: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " {\n                    margin-bottom: " + Object(util.m)(buttonHeight, button_config.b.VERTICAL_MARGIN) + "px;\n                }\n\n                ." + class_CLASS.SEPARATOR + " {\n                    margin: 0 " + Object(util.m)(buttonHeight, 5) + "px;\n                }\n\n                ." + class_CLASS.TAGLINE + " {\n                    display: " + (style.allowTagline ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, button_config.b.TAGLINE) + "px;\n                    line-height: " + Object(util.m)(buttonHeight, button_config.b.TAGLINE) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " {\n                    display: " + (style.allowFunding ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, button_config.b.FUNDINGICONS) + "px;\n                }\n\n                ." + class_CLASS.CARD + " {\n                    display: inline-block;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n                    width: " + (90 / cardNumber).toFixed(2) + "%;\n                    max-width: " + Object(util.m)(buttonHeight, 160) + "px;\n                    margin-top: 0;\n                    margin-left: " + (5 / cardNumber).toFixed(2) + "%;\n                    margin-right: " + (5 / cardNumber).toFixed(2) + "%;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " img {\n                    width: 100%;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " {\n                    height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    margin-top: " + Object(util.m)(buttonHeight, 15) + "px;\n                    margin-left: " + Object(util.m)(buttonHeight, 7) + "px;\n                    margin-right: " + Object(util.m)(buttonHeight, 7) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " img {\n                    height: 100%;\n                }\n            }\n\n            @media only screen and (min-width: " + style.minWidth + "px) and (max-width: " + minDualWidth + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    width: 100%;\n                    margin-right: 0;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: none;\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: none;\n                }\n            }\n\n            @media only screen and (min-width: " + Object(util.h)(style.minWidth, minDualWidth) + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                    margin-right: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: block;\n                }\n            }\n        ";
                        })).join("\n");
                    }({
                        height: _ref.height,
                        cardNumber: _ref.cardNumber
                    }) + "\n    ")
                });
                var _ref;
            }({
                height: height,
                cardNumber: cards.length
            });
            var scriptNode = function() {
                var script = function() {
                    var SELECTOR_ALL = "*", SELECTOR_OPTIONAL = "[optional]";
                    function toArray(item) {
                        return [].slice.call(item);
                    }
                    function getElements(selector, parent) {
                        return toArray((parent = parent || document).querySelectorAll(selector)).filter((function(el) {
                            return "style" !== el.tagName.toLowerCase();
                        }));
                    }
                    function getOptionalIndex(element) {
                        return parseInt(element.getAttribute("optional") || 0, 10);
                    }
                    function getElementsTotalWidth(elements) {
                        return function(arr) {
                            var result = 0;
                            for (var _i2 = 0; _i2 < arr.length; _i2++) result += arr[_i2];
                            return result;
                        }(elements.map((function(child) {
                            return child.offsetWidth;
                        })));
                    }
                    var children = function(arr) {
                        var result = [];
                        for (var _i4 = 0; _i4 < arr.length; _i4++) {
                            var el = arr[_i4];
                            -1 === result.indexOf(el) && result.push(el);
                        }
                        return result;
                    }([].concat(getElements(SELECTOR_OPTIONAL), getElements(".{ CLASS.FUNDINGICONS } .{ CLASS.CARD }"), getElements(".{ CLASS.BUTTON }-label-credit .{ CLASS.BUTTON }-logo-paypal")).map((function(element) {
                        return element.parentElement;
                    })).filter(Boolean)).map((function(optionalParent) {
                        return {
                            optionalParent: optionalParent,
                            allChildren: getElements(SELECTOR_ALL, optionalParent),
                            optionalChildren: toArray(getElements(SELECTOR_OPTIONAL, optionalParent)).sort((function(first, second) {
                                return getOptionalIndex(first) - getOptionalIndex(second);
                            }))
                        };
                    }));
                    function toggleOptionals() {
                        for (var _i6 = 0; _i6 < children.length; _i6++) {
                            var _children$_i = children[_i6], optionalChildren = _children$_i.optionalChildren;
                            var parentWidth = _children$_i.optionalParent.offsetWidth;
                            var usedWidth = getElementsTotalWidth(_children$_i.allChildren) - getElementsTotalWidth(optionalChildren);
                            for (var _i8 = 0; _i8 < optionalChildren.length; _i8++) {
                                var optionalChild = optionalChildren[_i8];
                                (usedWidth += optionalChild.offsetWidth) + 4 >= parentWidth ? optionalChild.classList.add("hidden") : optionalChild.classList.remove("hidden");
                            }
                        }
                    }
                    var setDomReady = function(handler) {
                        var called = !1;
                        return function() {
                            if (!called) {
                                called = !0;
                                handler.apply(void 0, arguments);
                            }
                        };
                    }(function(handler, time) {
                        void 0 === time && (time = 50);
                        var timeout;
                        return function() {
                            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                            clearTimeout(timeout);
                            timeout = setTimeout((function() {
                                handler.apply(void 0, args);
                            }), time);
                        };
                    }((function() {
                        window.addEventListener("resize", toggleOptionals);
                        document.body && document.body.classList.add("dom-ready");
                    })));
                    var load = function() {
                        toggleOptionals();
                        setDomReady();
                    };
                    toggleOptionals();
                    !function() {
                        var buttonsContainer = document.getElementsByClassName("{ CLASS.CONTAINER }")[0];
                        function handleMouseDownOnce() {
                            buttonsContainer.classList.remove("{ CLASS.SHOULD_FOCUS }");
                            window.removeEventListener("mousedown", handleMouseDownOnce);
                            window.addEventListener("keydown", handleFirstTab);
                        }
                        function handleFirstTab(e) {
                            if (9 === e.keyCode) {
                                buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }");
                                window.removeEventListener("keydown", handleFirstTab);
                                window.addEventListener("mousedown", handleMouseDownOnce);
                            }
                        }
                        buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }");
                        window.addEventListener("keydown", handleFirstTab);
                    }();
                    document.addEventListener("DOMContentLoaded", load);
                    window.addEventListener("load", load);
                    window.addEventListener("resize", load);
                }.toString();
                script = script.replace(/\{\s*CLASS\.([A-Z0-9_]+)\s*\}/g, (function(match, name) {
                    return class_CLASS[name];
                }));
                return Object(jsx.c)("script", {
                    innerHTML: "(" + script + ")();"
                });
            }();
            var labelPowerByPayPal = cards.length > 0 ? function(props) {
                if (!props) return null;
                var _props$sources = props.sources;
                return props.layout !== constants.g.VERTICAL || -1 === (void 0 === _props$sources ? [] : _props$sources).indexOf(constants.v.CARD) ? null : Object(jsx.c)("div", {
                    class: "powered-by-paypal",
                    style: "\n                text-align: center;\n                margin: 10px auto;\n                height: 14px;\n                font-family: PayPal-Sans, HelveticaNeue, sans-serif;\n                font-size: 11px;\n                font-weight: normal;\n                font-style: italic;\n                font-stretch: normal;\n                color: #7b8388;\n                position: relative;\n                margin-right: 3px;\n                bottom: 3px;\n            "
                }, renderContent("{ content: poweredBy }", Object(esm_extends.a)({}, props, {
                    logoColor: "blue"
                })));
            }(Object(button_props.a)(props)) : null;
            return Object(jsx.c)("div", Object(esm_extends.a)({}, (_ref21 = {}, _ref21[constants.c.VERSION] = "4.0.338", 
            _ref21), {
                class: class_CLASS.CONTAINER + " " + getCommonButtonClasses({
                    layout: layout,
                    shape: shape,
                    branding: branding,
                    multiple: multiple,
                    env: env
                })
            }), styleNode, buttonNodes, fundingiconNode, labelPowerByPayPal, scriptNode).toString();
        }
        pptm.listenForLoadWithNoContent();
        var creditThrottle;
        var component_Button = Object(src.c)({
            tag: "paypal-button",
            name: "ppbutton",
            buildUrl: function(props) {
                return config.a.buttonUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            scrolling: !1,
            listenForResize: !0,
            containerTemplate: function(_ref) {
                var _ref3;
                var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, tag = _ref.tag, context = _ref.context, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
                var _normalizeProps = Object(button_props.a)(props), size = _normalizeProps.size, label = _normalizeProps.label, layout = _normalizeProps.layout, buttonHeight = _normalizeProps.height;
                var minimumSize = Object(button_config.e)(label, layout === constants.g.VERTICAL ? "minimumVerticalSize" : "minimumSize");
                var maximumSize = Object(button_config.e)(label, layout === constants.g.VERTICAL ? "maximumVerticalSize" : "maximumSize");
                if (buttonHeight) {
                    var possibleSizes = Object(util.t)(constants.l).filter((function(possibleSize) {
                        return button_config.c[possibleSize] && buttonHeight && button_config.c[possibleSize].minHeight <= buttonHeight && button_config.c[possibleSize].maxHeight >= buttonHeight;
                    }));
                    possibleSizes.sort((function(sizeA, sizeB) {
                        return button_config.c[sizeA].defaultWidth - button_config.c[sizeB].defaultWidth;
                    }));
                    minimumSize = possibleSizes[0];
                    maximumSize = possibleSizes[possibleSizes.length - 1];
                }
                var _ref2 = button_config.c[size] || button_config.c[constants.l.SMALL], defaultWidth = _ref2.defaultWidth, defaultHeight = _ref2.defaultHeight;
                setTimeout((function() {
                    outlet.style.transition = "all 0.5s ease-in-out 0.3s";
                }), 3e3);
                return jsxDom("div", Object(esm_extends.a)({
                    id: id,
                    class: tag + " " + tag + "-context-" + context + " " + tag + "-label-" + label + " " + tag + "-size-" + size + " " + tag + "-layout-" + layout
                }, ((_ref3 = {})[constants.c.SMART_BUTTON_VERSION] = "4.0.338", _ref3)), jsxDom("style", null, "\n                    #" + id + " {\n                        font-size: 0;\n                        width: 100%;\n                        overflow: hidden;\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " {\n                        text-align: center;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                        max-width: " + button_config.c[maximumSize].maxWidth + "px;\n                        position: relative;\n                    }\n\n                    #" + id + "." + tag + "-layout-" + constants.g.VERTICAL + " > ." + CLASS.OUTLET + " {\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        width:  " + defaultWidth + "px;\n                        height: " + defaultHeight + "px;\n                    }\n\n                     #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " > ." + CLASS.OUTLET + " {\n                        width: 100%;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        min-width: 100%;\n                        max-width: 100%;\n                        width: " + button_config.c[minimumSize].minWidth + "px;\n                        height: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n                        z-index: 100;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n                        transition: opacity .2s linear;\n                        z-index: 200;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                        pointer-events: none;\n                    }\n                "), outlet);
            },
            autoResize: {
                height: !0,
                width: !1
            },
            prerenderTemplate: function(_ref) {
                var _this = this;
                var jsxDom = _ref.jsxDom;
                var template = jsxDom("div", {
                    innerHTML: componentTemplate({
                        props: _ref.props
                    })
                });
                template.addEventListener("click", (function() {
                    Object(beaver_logger_client.q)("button_pre_template_click");
                    if (Object(belter_src.i)()) {
                        Object(beaver_logger_client.q)("button_pre_template_click_intranet_mode");
                        Object(beaver_logger_client.h)();
                        alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.");
                    }
                    if (Object(lib.n)("allow_full_page_fallback")) {
                        Object(beaver_logger_client.k)("pre_template_force_full_page");
                        _this.props.payment().then((function(token) {
                            window.top.location = Object(lib.h)(config.a.checkoutUrl, {
                                token: token
                            });
                        }));
                    }
                }));
                return jsxDom("html", null, jsxDom("body", null, template));
            },
            get version() {
                return Object(lib.w)();
            },
            get domain() {
                return config.a.paypalDomains;
            },
            attributes: {
                iframe: {
                    allowpaymentrequest: "allowpaymentrequest",
                    title: constants.w.PAYPAL
                }
            },
            validate: function() {
                Object(lib.D)() || Object(beaver_logger_client.q)("button_render_ineligible");
            },
            props: {
                domain: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return window.location.host;
                    },
                    queryParam: !0
                },
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.x)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.W)();
                    },
                    queryParam: !0
                },
                renderedButtons: {
                    type: "string",
                    required: !1,
                    def: function(props) {
                        return Object(lib.t)(props);
                    },
                    queryParam: !0
                },
                storageID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.z)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (env && !config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                enableNativeCheckout: {
                    type: "boolean",
                    required: !1,
                    def: function() {
                        return !1;
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if ("string" == typeof client[env]) {
                            if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                        } else if (!zalgo_promise_src.a.isPromise(client[env])) throw new Error("Expected client token to be either a string or a promise");
                    },
                    decorate: function(client) {
                        client && "demo_sandbox_client_id" === client.sandbox && (client.sandbox = "AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R");
                        return client;
                    }
                },
                source: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return constants.F.MANUAL;
                    }
                },
                prefetchLogin: {
                    type: "boolean",
                    required: !1
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                updateClientConfiguration: {
                    type: "boolean",
                    required: !1,
                    def: function() {
                        return !0;
                    }
                },
                braintree: {
                    type: "object",
                    required: !1,
                    validate: function(braintree, props) {
                        if (!braintree.paypalCheckout) throw new Error("Expected Braintree paypal-checkout component to be loaded");
                        if (!props.client) throw new Error("Expected client prop to be passed with Braintree authorization keys");
                    },
                    decorate: function(braintree, props) {
                        var env = props.env || config.a.env;
                        return zalgo_promise_src.a.hash(props.client).then((function(client) {
                            return Object(integrations.a)(braintree, client[env]);
                        }));
                    }
                },
                payment: {
                    type: "function",
                    required: !0,
                    memoize: !1,
                    timeout: 1e4,
                    alias: "billingAgreement",
                    decorate: function(original) {
                        return function(data) {
                            var _this2 = this;
                            void 0 === data && (data = {});
                            var actions = {
                                request: lib.R,
                                payment: {
                                    create: function(options) {
                                        return _this2.props.braintree ? _this2.props.braintree.then((function(client) {
                                            return client.createPayment(Object(integrations.e)(options.payment || options));
                                        })) : zalgo_promise_src.a.hash(_this2.props.client).then((function(client) {
                                            return rest.payment.create(_this2.props.env, client, options);
                                        }));
                                    }
                                },
                                order: {
                                    create: function(options) {
                                        return zalgo_promise_src.a.hash(_this2.props.client).then((function(client) {
                                            return rest.order.create(_this2.props.env, client, options);
                                        }));
                                    }
                                },
                                braintree: {
                                    create: function(options) {
                                        if (!_this2.props.braintree) throw new Error("Can not create using Braintree - no braintree client provided");
                                        return _this2.props.braintree.then((function(client) {
                                            return client.createPayment(options);
                                        }));
                                    }
                                }
                            };
                            if (Object(lib.n)("memoize_payment") && this.memoizedToken) return this.memoizedToken;
                            this.memoizedToken = zalgo_promise_src.a.try(original, this, [ data, actions ]);
                            var startTime = Date.now();
                            this.memoizedToken = this.memoizedToken.then((function(token) {
                                var _track;
                                if (!token) {
                                    Object(beaver_logger_client.g)("no_token_passed_to_payment");
                                    throw new Error("No value passed to payment");
                                }
                                var elapsed = Date.now() - startTime;
                                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.RECIEVE_PAYMENT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[Object(integrations.d)(token)], 
                                _track[constants.u.KEY.CONTEXT_ID] = token, _track[constants.u.KEY.BUTTON_SESSION_UID] = _this2.props.buttonSessionID, 
                                _track[constants.u.KEY.RESPONSE_DURATION] = elapsed, _track[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                                _track));
                                Object(beaver_logger_client.h)();
                                return token;
                            }));
                            return this.memoizedToken;
                        };
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    }
                },
                funding: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    validate: function(_temp) {
                        var _ref2 = void 0 === _temp ? {} : _temp, _ref2$allowed = _ref2.allowed, allowed = void 0 === _ref2$allowed ? [] : _ref2$allowed, _ref2$disallowed = _ref2.disallowed, disallowed = void 0 === _ref2$disallowed ? [] : _ref2$disallowed;
                        Object(src_funding.f)({
                            allowed: allowed,
                            disallowed: disallowed,
                            remembered: []
                        });
                    },
                    def: function() {
                        return {};
                    },
                    decorate: function(_temp2, props) {
                        var _ref3 = void 0 === _temp2 ? {} : _temp2, _ref3$allowed = _ref3.allowed, allowed = void 0 === _ref3$allowed ? [] : _ref3$allowed, _ref3$disallowed = _ref3.disallowed, disallowed = void 0 === _ref3$disallowed ? [] : _ref3$disallowed;
                        allowed = Array.isArray(allowed) ? allowed : [];
                        disallowed = Array.isArray(disallowed) ? disallowed : [];
                        allowed && -1 !== allowed.indexOf(constants.v.ITAU) && (allowed = allowed.filter((function(source) {
                            return source !== constants.v.ITAU;
                        })));
                        (function(props) {
                            var _normalizeProps = Object(button_props.a)(props, {
                                locale: Object(lib.j)()
                            }), label = _normalizeProps.label, funding = _normalizeProps.funding, layout = _normalizeProps.layout, locale = _normalizeProps.locale, max = _normalizeProps.max, sources = _normalizeProps.sources, env = _normalizeProps.env;
                            var allowed = funding.allowed;
                            var country = locale.country;
                            if (allowed && -1 !== allowed.indexOf(constants.v.CREDIT)) return !1;
                            if (layout !== constants.g.HORIZONTAL) return !1;
                            if (1 === max) return !1;
                            if (label === constants.f.CREDIT) return !1;
                            if (country !== constants.r.US) return !1;
                            if (Object(src_funding.d)(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout,
                                env: env
                            })) return !1;
                            if (Object(src_funding.c)(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout
                            })) return !1;
                            if (-1 !== sources.indexOf(constants.v.CREDIT)) return !1;
                            var domain = Object(cross_domain_utils_src.h)().replace(/^https?:\/\//, "").replace(/^www\./, "");
                            return -1 !== config.a.creditTestDomains.indexOf(domain);
                        })(props) && (creditThrottle = Object(lib.A)("dual_credit_automatic", 50)).isEnabled() && (allowed = [].concat(allowed, [ constants.v.CREDIT ]));
                        var remembered = Object(lib.s)((function(sources) {
                            return sources;
                        }));
                        remembered && -1 !== remembered.indexOf(constants.v.VENMO) && (remembered = remembered.filter((function(source) {
                            return source !== constants.v.VENMO;
                        })));
                        Object(lib.G)() && !Object(lib.n)("disable_venmo") || disallowed && -1 === disallowed.indexOf(constants.v.VENMO) && (disallowed = [].concat(disallowed, [ constants.v.VENMO ]));
                        return {
                            allowed: allowed,
                            disallowed: disallowed,
                            remembered: remembered,
                            remember: function(sources) {
                                Object(lib.Q)(sources);
                            }
                        };
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0,
                    queryValue: function(val) {
                        return val ? "true" : "false";
                    }
                },
                onRender: {
                    type: "function",
                    promisify: !0,
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function() {
                            var _track2;
                            var _getBrowser = Object(lib.i)(), _getBrowser$browser = _getBrowser.browser, browser = void 0 === _getBrowser$browser ? "unrecognized" : _getBrowser$browser, _getBrowser$version = _getBrowser.version, version = void 0 === _getBrowser$version ? "unrecognized" : _getBrowser$version;
                            Object(beaver_logger_client.k)("button_render_browser_" + browser + "_" + (Object(belter_src.f)() ? "mobile" : "desktop") + "_" + version);
                            var style = this.props.style || {};
                            Object(beaver_logger_client.k)("button_render");
                            Object(beaver_logger_client.k)("button_render_color_" + (style.color || "default"));
                            Object(beaver_logger_client.k)("button_render_shape_" + (style.shape || "default"));
                            Object(beaver_logger_client.k)("button_render_size_" + (style.size || "default"));
                            Object(beaver_logger_client.k)("button_render_label_" + (style.label || "default"));
                            Object(beaver_logger_client.k)("button_render_branding_" + (style.branding || "default"));
                            Object(beaver_logger_client.k)("button_render_fundingicons_" + (style.fundingicons || "default"));
                            Object(beaver_logger_client.k)("button_render_tagline_" + (style.tagline || "default"));
                            pptm.listenForButtonRender();
                            pptm.reloadPptmScript(this.props.client[this.props.env]);
                            Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
                            _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, _track2[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track2[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track2[constants.u.KEY.BUTTON_SOURCE] = this.props.source, 
                            _track2));
                            Object(belter_src.i)() && Object(beaver_logger_client.q)("button_render_intranet_mode");
                            if (creditThrottle) {
                                var _creditThrottle$logSt;
                                creditThrottle.logStart(((_creditThrottle$logSt = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$logSt));
                            }
                            Object(beaver_logger_client.h)();
                            return original.apply(this, arguments);
                        };
                    }
                },
                onAuthorize: {
                    type: "function",
                    alias: "onApprove",
                    required: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track3, _this3 = this;
                            data && !data.intent && Object(beaver_logger_client.q)("button_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            Object(beaver_logger_client.k)("button_authorize");
                            Object(beaver_logger_client.p)(((_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_APPROVE, _track3[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track3[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, _track3));
                            Object(belter_src.i)() && Object(beaver_logger_client.q)("button_authorize_intranet_mode");
                            Object(lib.D)() || Object(beaver_logger_client.k)("button_authorize_ineligible");
                            Object(lib.e)("authorize");
                            Object(beaver_logger_client.h)();
                            var restart = actions.restart;
                            actions.restart = function() {
                                return restart().then((function() {
                                    return new zalgo_promise_src.a;
                                }));
                            };
                            actions.redirect = function(win, url) {
                                return zalgo_promise_src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return Object(lib.P)(win || window.top, url || data.returnUrl);
                                }));
                            };
                            actions.payment.tokenize = Object(lib.I)((function() {
                                if (!_this3.props.braintree) throw new Error("Must pass in Braintree client to tokenize payment");
                                return _this3.props.braintree.then((function(client) {
                                    return client.tokenizePayment(data);
                                }));
                            }));
                            var execute = actions.payment.execute;
                            actions.payment.execute = function() {
                                return execute().then((function(result) {
                                    if (!(result && result.id && result.intent && result.state)) {
                                        Object(beaver_logger_client.q)("execute_result_missing_data");
                                        return new zalgo_promise_src.a;
                                    }
                                    return result;
                                }));
                            };
                            var get = actions.payment.get;
                            actions.payment.get = function() {
                                return get().then((function(result) {
                                    if (!(result && result.id && result.intent && result.state)) {
                                        Object(beaver_logger_client.q)("get_result_missing_data");
                                        return new zalgo_promise_src.a;
                                    }
                                    return result;
                                }));
                            };
                            actions.request = lib.R;
                            onAuthorizeListener.trigger({
                                paymentToken: data.paymentToken
                            });
                            if (creditThrottle) {
                                var _creditThrottle$logCo;
                                creditThrottle.logComplete(((_creditThrottle$logCo = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$logCo));
                            }
                            return zalgo_promise_src.a.try((function() {
                                if (_this3.props.braintree) return actions.payment.tokenize().then((function(_ref4) {
                                    var nonce = _ref4.nonce;
                                    Object.defineProperty(data, "nonce", {
                                        get: function() {
                                            Object(beaver_logger_client.k)("nonce_getter");
                                            Object(beaver_logger_client.h)();
                                            return nonce;
                                        }
                                    });
                                }));
                            })).then((function() {
                                return original.call(_this3, data, actions);
                            })).catch((function(err) {
                                if (_this3.props.onError) return _this3.props.onError(err);
                                throw err;
                            }));
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _track4, _this4 = this;
                            Object(beaver_logger_client.k)("button_shipping_change");
                            Object(beaver_logger_client.p)(((_track4 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track4[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_SHIPPING_CHANGE, 
                            _track4[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track4[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                            _track4));
                            Object(beaver_logger_client.h)();
                            var patch = actions.payment.patch;
                            actions.payment.patch = function(patchObject) {
                                return zalgo_promise_src.a.try((function() {
                                    return patch(patchObject);
                                }));
                            };
                            var resolve = function() {
                                return zalgo_promise_src.a.resolve();
                            };
                            var reject = actions.reject || function() {
                                throw new Error("Missing reject action callback");
                            };
                            return zalgo_promise_src.a.try((function() {
                                return original.call(_this4, data, Object(esm_extends.a)({}, actions, {
                                    resolve: resolve,
                                    reject: reject
                                }));
                            })).timeout(1e4, new Error("Timed out waiting 10000ms for payment")).catch((function(err) {
                                _this4.props.onError && _this4.props.onError(err);
                                throw err;
                            }));
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    sendToChild: !0,
                    once: !0,
                    def: function() {
                        return function(err) {
                            if (Object(belter_src.i)()) {
                                Object(beaver_logger_client.q)("button_error_intranet_mode");
                                Object(beaver_logger_client.h)();
                                alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.");
                            }
                            setTimeout((function() {
                                throw err;
                            }));
                        };
                    }
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track5;
                            Object(beaver_logger_client.k)("button_cancel");
                            Object(beaver_logger_client.p)(((_track5 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track5[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_CANCEL, _track5[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track5[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, _track5));
                            Object(beaver_logger_client.h)();
                            return original.call(this, data, Object(esm_extends.a)({}, actions, {
                                redirect: function(win, url) {
                                    return zalgo_promise_src.a.all([ Object(lib.P)(win || window.top, url || data.cancelUrl), actions.close() ]);
                                }
                            }));
                        };
                    }
                },
                onClick: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track6;
                            Object(beaver_logger_client.k)("button_click");
                            data && data.flow && Object(beaver_logger_client.k)("pay_flow_" + data.flow);
                            Object(beaver_logger_client.p)(((_track6 = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                            _track6[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, _track6[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track6[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track6[constants.u.KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), 
                            _track6[constants.u.KEY.PAYMENT_FLOW] = data && data.flow, _track6[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                            _track6));
                            Object(belter_src.i)() && Object(beaver_logger_client.q)("button_click_intranet_mode");
                            if (creditThrottle) {
                                var _creditThrottle$log;
                                creditThrottle.log("click", ((_creditThrottle$log = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                                _creditThrottle$log[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, 
                                _creditThrottle$log[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$log));
                            }
                            var _ref5 = this.props.style || {}, _ref5$color = _ref5.color, color = void 0 === _ref5$color ? "default" : _ref5$color;
                            Object(beaver_logger_client.k)("button_click_color_" + color);
                            Object(beaver_logger_client.h)();
                            return original.apply(this, arguments);
                        };
                    }
                },
                onResize: {
                    type: "function",
                    required: !1,
                    get value() {
                        var initialHeight;
                        var logInlineGuestOutOfViewPortOnlyOnce = Object(src_lib.H)((function(data) {
                            Object(beaver_logger_client.k)("buttons_expansion_outside_viewport", data);
                            Object(beaver_logger_client.j)();
                        }));
                        return function() {
                            var container = this.container;
                            if (container) {
                                initialHeight || (initialHeight = container.offsetHeight);
                                var isContainerExpanded = container && container.offsetHeight > initialHeight;
                                var isExpansionInViewport = function() {
                                    try {
                                        var scrollOffsetY = window.pageYOffset ? window.pageYOffset : document.documentElement ? document.documentElement.scrollTop : 0;
                                        var windowHeight = window.innerHeight;
                                        var containerOffsetY = container.getBoundingClientRect().top;
                                        return scrollOffsetY + windowHeight > initialHeight + containerOffsetY + 200;
                                    } catch (err) {
                                        Object(beaver_logger_client.k)("cannot_get_the_viewport_information");
                                        return !1;
                                    }
                                }();
                                isContainerExpanded && !isExpansionInViewport && logInlineGuestOutOfViewPortOnlyOnce({
                                    height: container.offsetHeight,
                                    window: {
                                        width: window.innerWidth,
                                        height: window.innerHeight
                                    }
                                });
                            }
                        };
                    },
                    decorate: function(original) {
                        return Object(src_lib.i)(original);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    def: function() {
                        var _getBrowserLocale = Object(lib.j)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    },
                    validate: validateButtonLocale
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    alias: "buttonStyle",
                    def: function() {
                        return {
                            color: constants.e.GOLD,
                            shape: constants.k.PILL,
                            size: constants.l.SMALL,
                            label: constants.f.CHECKOUT,
                            fundingicons: !1,
                            layout: constants.g.HORIZONTAL
                        };
                    },
                    decorate: function(style) {
                        var label = style.label, _style$layout = style.layout, layout = void 0 === _style$layout ? constants.g.HORIZONTAL : _style$layout;
                        if (!label && layout === constants.g.HORIZONTAL) {
                            style.label = constants.f.CHECKOUT;
                            return style;
                        }
                        if (!label && layout === constants.g.VERTICAL) {
                            style.label = constants.f.PAYPAL;
                            return style;
                        }
                        return style;
                    },
                    validate: function(style, props) {
                        void 0 === style && (style = {});
                        validateButtonStyle(style, props);
                        Object(beaver_logger_client.h)();
                    }
                },
                validate: {
                    type: "function",
                    required: !1,
                    decorate: function(validate) {
                        return function(actions) {
                            if (!this.validateCalled) {
                                this.validateCalled = !0;
                                return validate(actions);
                            }
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.m)()
                        }));
                    }
                },
                awaitPopupBridge: {
                    type: "object",
                    required: !1,
                    value: function() {
                        return awaitPopupBridge(component_Button);
                    }
                },
                getPageUrl: {
                    type: "function",
                    queryParam: !1,
                    required: !1,
                    def: function() {
                        return function() {
                            return window.location.href;
                        };
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {
                            action: "checkout"
                        };
                    }
                }
            }
        });
        var instances = component_Button.instances = [];
        var _render = component_Button.render;
        component_Button.render = function(props) {
            void 0 === props && (props = {});
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
            var instance = {
                clone: function(_temp3) {
                    var _ref6$decorate = (void 0 === _temp3 ? {} : _temp3).decorate, decorate = void 0 === _ref6$decorate ? belter_src.c : _ref6$decorate;
                    return {
                        render: function(container) {
                            var decoratedProps = decorate(props);
                            return _render.call(component_Button, decoratedProps, container);
                        }
                    };
                }
            };
            instances.push(instance);
            var _props = props, _props$onDestroy = _props.onDestroy, onDestroy = void 0 === _props$onDestroy ? belter_src.n : _props$onDestroy;
            var newProps = Object(esm_extends.a)({}, props, {
                onDestroy: function() {
                    var index = instances.indexOf(instance);
                    -1 !== index && instances.splice(index, 1);
                    return onDestroy.apply(this, arguments);
                }
            });
            return _render.call.apply(_render, [ component_Button, newProps ].concat(args));
        };
        component_Button.isChild() && function(ButtonComponent) {
            !function(Checkout, Button) {
                var popupBridge;
                awaitPopupBridge(Button).then((function(bridge) {
                    popupBridge = bridge;
                }));
                function doRender(props, original) {
                    return popupBridge ? function(props, popupBridge) {
                        return zalgo_promise_src.a.try((function() {
                            !function(props) {
                                if (!props.payment) throw new Error("Expected props.payment to be passed");
                                if (!props.onAuthorize) throw new Error("Expected props.onAuthorize to be passed");
                                if (props.env && !config.a.checkoutUrls[props.env]) throw new Error("Invalid props.env: " + props.env);
                            }(props);
                        })).then((function() {
                            return function(props) {
                                var _normalizeCheckoutPro = normalizeCheckoutProps(props), env = _normalizeCheckoutPro.env;
                                return zalgo_promise_src.a.try(_normalizeCheckoutPro.payment, {
                                    props: props
                                }).then((function(token) {
                                    var _extendUrl;
                                    if (!token) throw new Error("Expected props.payment to return a payment id or token");
                                    return Object(lib.h)(Object(integrations_checkout.b)(env, constants.v.PAYPAL, token), ((_extendUrl = {})[Object(integrations_checkout.a)(token)] = token, 
                                    _extendUrl.useraction = props.commit ? "commit" : "", _extendUrl.native_xo = "1", 
                                    _extendUrl));
                                }));
                            }(props);
                        })).then((function(url) {
                            return popupBridge.open(url);
                        })).then((function(payload) {
                            var opType = payload.queryItems.opType;
                            var _normalizeCheckoutPro2 = normalizeCheckoutProps(props), onAuthorize = _normalizeCheckoutPro2.onAuthorize, onCancel = _normalizeCheckoutPro2.onCancel;
                            var data = function(query) {
                                var data = {
                                    paymentToken: query.token,
                                    billingToken: query.ba_token,
                                    paymentID: query.paymentId,
                                    payerID: query.PayerID,
                                    intent: query.intent
                                };
                                var opType = query.opType, cancel_uri = query.cancel_uri;
                                "payment" === opType ? data.returnUrl = query.return_uri : "cancel" === opType && (data.cancelUrl = cancel_uri);
                                return data;
                            }(payload.queryItems);
                            var actions = function(query) {
                                var actions = {
                                    close: src_lib.F,
                                    closeComponent: src_lib.F
                                };
                                var opType = query.opType, return_uri = query.return_uri, cancel_uri = query.cancel_uri;
                                "payment" === opType ? actions.redirect = function(win, redirectUrl) {
                                    void 0 === win && (win = window);
                                    void 0 === redirectUrl && (redirectUrl = return_uri);
                                    return Object(lib.P)(win, redirectUrl);
                                } : "cancel" === opType && (actions.redirect = function(win, redirectUrl) {
                                    void 0 === win && (win = window);
                                    void 0 === redirectUrl && (redirectUrl = cancel_uri);
                                    return Object(lib.P)(win, redirectUrl);
                                });
                                return actions;
                            }(payload.queryItems);
                            if ("payment" === opType) return onAuthorize(data, actions);
                            if ("cancel" === opType) return onCancel(data, actions);
                            throw new Error("Invalid opType: " + opType);
                        })).catch((function(err) {
                            if (err && "PAYMENT_CANCELLED" === err.code) return (0, normalizeCheckoutProps(props).onCancel)({}, {});
                            throw err;
                        }));
                    }(props, popupBridge).catch((function(err) {
                        Object(beaver_logger_client.g)("popup_bridge_error", {
                            err: Object(lib.U)(err)
                        });
                        return original();
                    })) : original();
                }
                var render = Checkout.render;
                Checkout.render = function(props) {
                    var _arguments = arguments, _this = this;
                    return doRender(props, (function() {
                        return render.apply(_this, _arguments);
                    }));
                };
                var renderTo = Checkout.renderTo;
                Checkout.renderTo = function(win, props) {
                    var _arguments2 = arguments, _this2 = this;
                    return doRender(props, (function() {
                        return renderTo.apply(_this2, _arguments2);
                    }));
                };
                var renderPopupTo = Checkout.renderPopupTo;
                Checkout.renderPopupTo = function(win, props) {
                    var _arguments3 = arguments, _this3 = this;
                    return doRender(props, (function() {
                        return renderPopupTo.apply(_this3, _arguments3);
                    }));
                };
            }(src_checkout.a, ButtonComponent);
            Object(lib.q)().then((function(pageRenderTime) {
                var _track;
                var fundingSources = [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map((function(el) {
                    return el.getAttribute(constants.c.CARD) || el.getAttribute(constants.c.FUNDING_SOURCE);
                })).filter((function(source) {
                    return source && source !== constants.v.CARD;
                }));
                var xprops = ButtonComponent.xprops;
                if (xprops) {
                    var _ref = xprops.style || {}, _ref$layout = _ref.layout, layout = void 0 === _ref$layout ? constants.g.HORIZONTAL : _ref$layout, _ref$color = _ref.color, color = void 0 === _ref$color ? constants.e.GOLD : _ref$color, _ref$size = _ref.size, size = void 0 === _ref$size ? constants.l.SMALL : _ref$size, _ref$shape = _ref.shape, shape = void 0 === _ref$shape ? constants.k.PILL : _ref$shape, _ref$label = _ref.label, label = void 0 === _ref$label ? constants.f.CHECKOUT : _ref$label, maxbuttons = _ref.maxbuttons, tagline = _ref.tagline;
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                    _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_LOAD, _track[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                    _track[constants.u.KEY.FUNDING_LIST] = fundingSources.join(":"), _track[constants.u.KEY.FUNDING_COUNT] = fundingSources.length, 
                    _track[constants.u.KEY.PAGE_LOAD_TIME] = pageRenderTime, _track[constants.u.KEY.BUTTON_LAYOUT] = layout, 
                    _track[constants.u.KEY.BUTTON_COLOR] = color, _track[constants.u.KEY.BUTTON_SIZE] = size, 
                    _track[constants.u.KEY.BUTTON_SHAPE] = shape, _track[constants.u.KEY.BUTTON_LABEL] = label, 
                    _track[constants.u.KEY.BUTTON_WIDTH] = window.innerWidth, _track[constants.u.KEY.MAX_BUTTONS] = maxbuttons, 
                    _track[constants.u.KEY.BUTTON_TAGLINE_ENABLED] = tagline ? "1" : "0", _track));
                    Object(beaver_logger_client.h)();
                }
            }));
            var xprops = ButtonComponent.xprops || src_checkout.a.xprops;
            xprops && xprops.logLevel && Object(lib.T)(xprops.logLevel);
            xprops.payment && !xprops.createOrder && (xprops.createOrder = xprops.payment);
            xprops.onAuthorize && !xprops.onApprove && (xprops.onApprove = xprops.onAuthorize);
            try {
                xprops && xprops.onShippingChange && window.pre && window.pre.inlineGuest && window.pre.inlineGuest.res && window.pre.inlineGuest.res.data && window.pre.inlineGuest.res.data.treatments && (window.pre.inlineGuest.res.data.treatments = []);
            } catch (err) {}
        }(component_Button);
        Object(belter_src.g)() && Object(lib.n)("ie_full_page") && (src_checkout.a.renderTo = function(win) {
            Object(beaver_logger_client.k)("force_ie_full_page");
            Object(beaver_logger_client.h)();
            var checkout = src_checkout.a.init({
                onAuthorize: belter_src.n
            });
            checkout.delegate(win);
            checkout.openContainer().then((function() {
                checkout.event.triggerOnce(src.a.EVENTS.CLOSE);
                checkout.showContainer();
            }));
            component_Button.xprops.payment().then((function(token) {
                window.top.location = Object(lib.h)(config.a.checkoutUrl, {
                    token: token
                });
            })).catch((function(err) {
                checkout.error(err);
            }));
        });
        var hacks_parent = Object(cross_domain_utils_src.n)(window);
        var hacks_top = Object(cross_domain_utils_src.o)(window);
        if (hacks_top && hacks_parent) {
            var canRenderTop = hacks_top === hacks_parent;
            if (!canRenderTop) {
                src_checkout.a.canRenderTo(hacks_top).then((function(result) {
                    canRenderTop = result;
                }));
                Object(lib.N)(src_checkout.a, "renderTo", (function(_ref) {
                    var _ref$args = _ref.args, win = _ref$args[0], props = _ref$args[1], el = _ref$args[2], original = _ref.original, context = _ref.context;
                    canRenderTop || (win = Object(cross_domain_utils_src.n)(window));
                    return original.call(context, win, props, el);
                }));
            }
        }
        Object(lib.N)(src_checkout.a, "renderTo", (function(_ref2) {
            var callOriginal = _ref2.callOriginal, props = _ref2.args[1];
            if (Object(lib.n)("allow_full_page_fallback")) {
                var handleError = Object(lib.L)((function(err) {
                    try {
                        console.error(err && err.stack);
                    } catch (err2) {}
                    return component_Button.xprops.payment().then((function(token) {
                        window.top.location = Object(lib.h)(config.a.checkoutUrl, {
                            token: token
                        });
                    }));
                }));
                props.onError = handleError;
                return callOriginal().catch(handleError);
            }
            return callOriginal();
        }));
        var debounce = !1;
        Object(lib.N)(src_checkout.a, "renderTo", (function(_ref3) {
            var callOriginal = _ref3.callOriginal, props = _ref3.args[1];
            if (debounce) {
                Object(beaver_logger_client.q)("button_mutliple_click_debounce");
                return new zalgo_promise_src.a(belter_src.n);
            }
            debounce = !0;
            var _loop = function() {
                var methodName = _ref5[_i2];
                var original = props[methodName];
                props[methodName] = function() {
                    debounce = !1;
                    if (original) return original.apply(this, arguments);
                };
            };
            for (var _i2 = 0, _ref5 = [ "onAuthorize", "onCancel", "onError", "onClose" ]; _i2 < _ref5.length; _i2++) _loop();
            return callOriginal();
        }));
        Object(lib.N)(rest.payment, "create", (function(_ref6) {
            var _ref6$args = _ref6.args, options = _ref6$args[2];
            options.payment || (options = {
                payment: options,
                experience: _ref6$args[3]
            });
            return _ref6.original.call(_ref6.context, _ref6$args[0], _ref6$args[1], options);
        }));
        Object(lib.N)(component_Button.props.style, "validate", (function(_ref7) {
            var callOriginal = _ref7.callOriginal, style = _ref7.args[0];
            if (!style) return callOriginal();
            style && "creditblue" === style.color && (style.color = constants.e.DARKBLUE);
            style && "generic" === style.label && (style.label = constants.f.PAYPAL);
            if (style && (!style.label || style.label === constants.f.CHECKOUT) && "tiny" === style.size) {
                Object(beaver_logger_client.q)("unsupported_button_size_tiny");
                style.size = constants.l.SMALL;
            }
            return callOriginal();
        }));
        Object(lib.N)(component_Button, "render", (function(_ref8) {
            var callOriginal = _ref8.callOriginal, props = _ref8.args[0];
            if (props.billingAgreement) {
                props.payment = props.billingAgreement;
                delete props.billingAgreement;
            }
            return callOriginal();
        }));
        Object(lib.N)(component_Button.props.payment, "decorate", (function(_ref9) {
            var originalPayment = _ref9.args[0];
            return _ref9.original.call(_ref9.context, (function(data, actions) {
                var _this = this;
                return new zalgo_promise_src.a((function(resolve, reject) {
                    Object(lib.N)(actions.payment, "create", (function(_ref10) {
                        var _ref10$args = _ref10.args, options = _ref10$args[0];
                        options.payment || (options = {
                            payment: options,
                            experience: _ref10$args[1]
                        });
                        return _ref10.original.call(_ref10.context, options);
                    }));
                    function resolveData(token) {
                        resolve(token);
                    }
                    function rejectActions(err) {
                        reject(err);
                    }
                    Object(lib.g)(resolveData, data);
                    Object(lib.g)(resolveData, actions);
                    Object(lib.g)(rejectActions, actions);
                    var ctx = {
                        props: {
                            env: _this.props.env,
                            client: _this.props.client
                        }
                    };
                    var result;
                    try {
                        result = originalPayment.call(ctx, resolveData, rejectActions);
                    } catch (err) {
                        return reject(err);
                    }
                    return result && "function" == typeof result.then ? result.then(resolve, reject) : void 0 !== result ? resolve(result) : void 0;
                }));
            }));
        }));
        component_Button.isChild() && (window.Promise || (window.Promise = zalgo_promise_src.a));
        var Card = Object(src.c)({
            tag: "card-fields",
            name: "ppcard",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            dimensions: {
                height: "300px",
                width: "100%"
            },
            autoResize: {
                height: !0,
                width: !1
            },
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.x)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.k)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.j)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                initialFormValues: {
                    type: "object",
                    required: !1
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                getState: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.m)()
                        }));
                    }
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return {
                            cardIcons: {
                                display: !1
                            },
                            submitButton: {
                                display: !0
                            },
                            currencyConversion: {
                                display: !0
                            }
                        };
                    }
                }
            }
        });
        (currentDomainEnv = function(domain) {
            for (var _i2 = 0, _Object$keys2 = Object.keys(config.a.paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2];
                if (config.a.paypalUrls[env] === domain) return env;
            }
        }(window.location.protocol + "//" + window.location.host)) && "test" !== currentDomainEnv && (config.a.env = currentDomainEnv);
        var currentDomainEnv;
        zalgo_promise_src.a.onPossiblyUnhandledException((function(err) {
            var _track;
            Object(beaver_logger_client.g)("unhandled_error", {
                stack: Object(lib.U)(err),
                errtype: {}.toString.call(err)
            });
            Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.ERROR_CODE] = "checkoutjs_error", 
            _track[constants.u.KEY.ERROR_DESC] = Object(lib.V)(err), _track));
            return Object(beaver_logger_client.h)().catch((function(err2) {
                if (window.console) try {
                    window.console.error ? window.console.error("Error flushing:", Object(lib.U)(err2)) : window.console.log && window.console.log("Error flushing:", Object(lib.U)(err2));
                } catch (err3) {
                    setTimeout((function() {
                        throw err3;
                    }), 1);
                }
            }));
        }));
        var currentScript = Object(lib.l)();
        var currentProtocol = window.location.protocol.split(":")[0];
        var init = Object(lib.L)((function(_ref2) {
            var precacheRemembered = _ref2.precacheRemembered;
            Object(lib.D)() || Object(beaver_logger_client.q)("ineligible");
            Object(lib.c)();
            Object(lib.B)();
            window.addEventListener("load", lib.d);
            pptm.shouldCreateInitialPptmScript() && pptm.createPptmScript();
            precacheRemembered && Object(lib.O)();
            Object(lib.n)("force_bridge") && !Object(lib.F)() && Object(lib.M)(config.a.env);
            Object(beaver_logger_client.k)("setup_" + config.a.env);
            Object(beaver_logger_client.f)("current_protocol_" + currentProtocol);
        }));
        function setup(options) {
            void 0 === options && (options = {});
            !function(_temp) {
                var _ref = void 0 === _temp ? {} : _temp, env = _ref.env, stage = _ref.stage, stageUrl = _ref.stageUrl, apiStage = _ref.apiStage, localhostUrl = _ref.localhostUrl, checkoutUri = _ref.checkoutUri, state = _ref.state, logLevel = _ref.logLevel, merchantID = _ref.merchantID, authCode = _ref.authCode;
                if (env) {
                    if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    delete config.a.env;
                    config.a.env = env;
                } else if (component_Button.xprops && component_Button.xprops.env) {
                    delete config.a.env;
                    config.a.env = component_Button.xprops.env;
                } else if (src_checkout.a.xprops && src_checkout.a.xprops.env) {
                    delete config.a.env;
                    config.a.env = src_checkout.a.xprops.env;
                }
                if (stage) {
                    delete config.a.stage;
                    config.a.stage = stage;
                } else if (component_Button.xprops && component_Button.xprops.stage) {
                    delete config.a.stage;
                    config.a.stage = component_Button.xprops.stage;
                } else if (src_checkout.a.xprops && src_checkout.a.xprops.stage) {
                    delete config.a.stage;
                    config.a.stage = src_checkout.a.xprops.stage;
                }
                if (stageUrl) {
                    delete config.a.stageUrl;
                    config.a.stageUrl = stageUrl;
                }
                if (authCode = authCode || component_Button.xprops && component_Button.xprops.authCode || src_checkout.a.xprops && src_checkout.a.xprops.authCode) {
                    delete config.a.authCode;
                    config.a.authCode = authCode;
                }
                if (apiStage) {
                    delete config.a.apiStage;
                    config.a.apiStage = apiStage;
                }
                localhostUrl && (config.a.localhostUrl = localhostUrl);
                checkoutUri && (config.a.checkoutUri = checkoutUri);
                if (state) {
                    delete config.a.state;
                    config.a.state = state;
                }
                merchantID && (config.a.merchantID = merchantID);
                logLevel ? Object(lib.T)(logLevel) : Object(lib.T)(config.a.logLevel);
            }(options);
            init(options);
        }
        currentScript ? setup({
            env: currentScript.getAttribute("data-env"),
            stage: currentScript.getAttribute("data-stage"),
            apiStage: currentScript.getAttribute("data-api-stage"),
            stageUrl: Object(lib.F)() ? currentScript.getAttribute("data-stage-url") : void 0,
            localhostUrl: Object(lib.F)() ? currentScript.getAttribute("data-localhost-url") : void 0,
            checkoutUri: Object(lib.F)() ? currentScript.getAttribute("data-checkout-uri") : void 0,
            state: currentScript.getAttribute("data-state"),
            logLevel: currentScript.getAttribute("data-log-level"),
            merchantID: currentScript.getAttribute("data-merchant-id"),
            authCode: currentScript.getAttribute("data-auth-code"),
            precacheRemembered: currentScript.hasAttribute("data-precache-remembered-funding")
        }) : setup();
        if (!Object(lib.F)()) if (currentScript) {
            var setup_track2;
            var scriptProtocol = currentScript.src.split(":")[0];
            var loadTime = Object(lib.u)(currentScript.src);
            Object(beaver_logger_client.f)("current_script_protocol_" + scriptProtocol);
            Object(beaver_logger_client.f)("current_script_protocol_" + (currentProtocol === scriptProtocol ? "match" : "mismatch"));
            Object(beaver_logger_client.f)("current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_"));
            if (loadTime) {
                Object(beaver_logger_client.f)("current_script_time", {
                    loadTime: loadTime
                });
                Object(beaver_logger_client.f)("current_script_time_" + Math.floor(loadTime / 1e3));
            }
            Object(beaver_logger_client.p)(((setup_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track2[constants.u.KEY.TRANSITION_TIME] = loadTime, 
            setup_track2[constants.u.KEY.FUNDING_REMEMBERED] = Object(lib.s)().join(","), setup_track2));
        } else {
            var setup_track3;
            Object(beaver_logger_client.f)("no_current_script");
            Object(beaver_logger_client.f)("no_current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_"));
            document.currentScript && Object(beaver_logger_client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            });
            Object(beaver_logger_client.p)(((setup_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track3));
        }
        var postRobot = post_robot_src;
        var onPossiblyUnhandledException = zalgo_promise_src.a.onPossiblyUnhandledException;
        var interface_version = "4.0.338";
        var interface_checkout;
        var apps;
        var legacy = __webpack_require__(49);
        interface_checkout = legacy.checkout;
        apps = legacy.apps;
        var interface_Checkout;
        var interface_BillingPage;
        var PayPalCheckout;
        var destroyAll;
        var enableCheckoutIframe;
        var logger;
        var interface_ThreeDomainSecure;
        if (Object(lib.F)()) {
            interface_Checkout = src_checkout.a;
            interface_BillingPage = BillingPage;
            interface_ThreeDomainSecure = ThreeDomainSecure;
            PayPalCheckout = src_checkout.a;
            enableCheckoutIframe = function() {
                src_checkout.a.contexts.iframe = !0;
            };
            destroyAll = src.d;
            logger = {
                debug: beaver_logger_client.f,
                info: beaver_logger_client.k,
                warn: beaver_logger_client.q,
                error: beaver_logger_client.g,
                track: beaver_logger_client.p,
                flush: beaver_logger_client.h
            };
        }
        __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "renderButtons", (function() {
            return renderButtons;
        }));
        __webpack_require__.d(__webpack_exports__, "getHijackTargetElement", (function() {
            return getHijackTargetElement;
        }));
        __webpack_require__.d(__webpack_exports__, "LOG_PREFIX", (function() {
            return LOG_PREFIX;
        }));
        __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", (function() {
            return ATTRIBUTES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLASSES", (function() {
            return CLASSES;
        }));
        __webpack_require__.d(__webpack_exports__, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(__webpack_exports__, "reset", (function() {
            return interface_reset;
        }));
        __webpack_require__.d(__webpack_exports__, "setup", (function() {
            return setup;
        }));
        var client = __webpack_require__(4);
        var lib = __webpack_require__(3);
        var constants = __webpack_require__(0);
        var LOG_PREFIX = "paypal_legacy";
        var ATTRIBUTES = {
            BUTTON: "data-paypal-button",
            MERCHANT_ID: "data-paypal-id",
            ENV: "data-env",
            SANDBOX: "data-sandbox"
        };
        var CLASSES = {
            HIDDEN_BUTTON: "paypal-button-hidden"
        };
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(2);
        var form_serialize = __webpack_require__(44);
        var form_serialize_default = __webpack_require__.n(form_serialize);
        var belter_src = __webpack_require__(11);
        var checkout = __webpack_require__(18);
        var config = __webpack_require__(5);
        var post_robot_src = __webpack_require__(15);
        function isLegacyEligible() {
            return !!Object(lib.D)() && !!Object(belter_src.p)() && !Object(belter_src.f)();
        }
        var warn = Object(client.n)(LOG_PREFIX).warn;
        var DEFAULT_COUNTRY = constants.r.US;
        var DEFAULT_LANG = constants.y.EN;
        function normalizeLocale(locale) {
            var _locale$split = locale.split("_"), lang = _locale$split[0], country = _locale$split[1];
            if (!country) if (constants.A[lang]) {
                country = lang;
                lang = null;
            } else country = DEFAULT_COUNTRY;
            if (!constants.A[country]) {
                warn("invalid_user_country", {
                    country: country
                });
                country = DEFAULT_COUNTRY;
            }
            lang || (lang = DEFAULT_LANG);
            if (-1 === constants.A[country].indexOf(lang)) {
                warn("invalid_user_lang", {
                    lang: lang
                });
                lang = -1 !== constants.A[country].indexOf(DEFAULT_LANG) ? DEFAULT_LANG : constants.A[country][0];
            }
            return {
                country: country,
                lang: lang
            };
        }
        var button_prefix = Object(client.n)(LOG_PREFIX), info = button_prefix.info, debug = button_prefix.debug, error = button_prefix.error;
        var loadButtonJS = Object(lib.I)((function() {
            debug("buttonjs_load");
            return Object(lib.H)(config.a.buttonJSUrl).catch((function(err) {
                info("buttonjs_load_error_retry", {
                    error: Object(lib.U)(err)
                });
                return Object(lib.H)(config.a.buttonJSUrl);
            })).then((function(result) {
                debug("buttonjs_load_success");
                return result;
            })).catch((function(err) {
                error("buttonjs_load_error", {
                    error: Object(lib.U)(err)
                });
                throw err;
            }));
        }));
        function renderButtons(id, buttons) {
            return src.a.map(buttons, (function(button) {
                return src.a.try((function() {
                    return button.container ? function(id, _ref) {
                        var container = _ref.container, locale = _ref.locale, type = _ref.type, color = _ref.color, shape = _ref.shape, size = _ref.size;
                        return loadButtonJS().then((function() {
                            if (locale) {
                                var _normalizeLocale = normalizeLocale(locale);
                                locale = _normalizeLocale.lang + "_" + _normalizeLocale.country;
                            }
                            color = color || constants.e.GOLD;
                            shape = shape || constants.k.PILL;
                            size = size || constants.l.SMALL;
                            type = type || constants.f.CHECKOUT;
                            debug("render_button_lc_" + (locale = locale || config.a.locale.lang + "_" + config.a.locale.country));
                            debug("render_button_color_" + color);
                            debug("render_button_shape_" + shape);
                            debug("render_button_size_" + size);
                            debug("render_button_label_" + type);
                            var el = window.paypal.button.create(id, {
                                lc: locale,
                                color: color,
                                shape: shape,
                                size: size
                            }, {
                                type: "button",
                                label: type
                            }).el;
                            container.appendChild(el);
                            try {
                                info("in_page_button_" + (Object(lib.C)(el) ? "visible" : "not_visible"));
                            } catch (err) {}
                            return el.childNodes[0];
                        }));
                    }(id, button) : button.button;
                })).then((function(element) {
                    var container;
                    var type;
                    if (button.container) {
                        container = button.container;
                        type = constants.u.BUTTON_TYPE.HTML;
                    } else {
                        container = button.button;
                        type = constants.u.BUTTON_TYPE.CUSTOM;
                    }
                    return {
                        container: container,
                        element: element,
                        type: type,
                        condition: button.condition,
                        click: button.click
                    };
                }));
            }));
        }
        function getHijackTargetElement(button) {
            var form = button.form;
            if (form) {
                debug("target_element_button_form");
                return form;
            }
            var tagName = button.tagName && button.tagName.toLowerCase();
            if ("a" === tagName) {
                debug("target_element_link");
                return button;
            }
            var parentElement = button.parentElement;
            var parentTagName = parentElement && parentElement.tagName && parentElement.tagName.toLowerCase();
            if (("img" === tagName || "button" === tagName) && "a" === parentTagName) {
                debug("target_element_parent_link");
                return parentElement;
            }
            var grandparentElement = parentElement && parentElement.parentElement;
            var grandparentTagName = grandparentElement && grandparentElement.tagName && grandparentElement.tagName.toLowerCase();
            if ("button" === tagName && "a" === grandparentTagName) {
                debug("target_element_grandparent_link");
                return button.parentElement && button.parentElement.parentElement;
            }
        }
        var util_warn = Object(client.n)(LOG_PREFIX).warn;
        var redirected = !1;
        function logRedirect(location) {
            redirected && util_warn("multiple_redirects");
            Object(lib.X)(location) && (redirected = !0);
            Object(client.h)();
        }
        function redirect(url) {
            return src.a.try((function() {
                if (!url) throw new Error("Redirect url undefined");
                if (config.a.env === constants.t.TEST && Object(lib.X)(url)) return Object(lib.P)(window, "#fullpageRedirect?url=" + url);
                logRedirect(url);
                return Object(lib.P)(window, url);
            }));
        }
        var options_prefix = Object(client.n)(LOG_PREFIX), options_info = options_prefix.info, options_warn = options_prefix.warn;
        var interface_prefix = Object(client.n)(LOG_PREFIX), interface_info = interface_prefix.info, interface_debug = interface_prefix.debug, interface_warn = interface_prefix.warn, interface_error = interface_prefix.error, track = interface_prefix.track;
        var interface_checkout = {};
        var apps = {
            checkout: interface_checkout,
            Checkout: interface_checkout
        };
        function interface_reset() {
            interface_debug("reset");
            interface_checkout.initXO = initXO;
            interface_checkout.startFlow = startFlow;
            interface_checkout.closeFlow = closeFlow;
        }
        interface_checkout.reset = interface_reset;
        Object.defineProperty(interface_checkout, "urlPrefix", {
            get: function() {
                return config.a.checkoutUrl + (-1 === config.a.checkoutUrl.indexOf("?") ? "?" : "&") + "token=";
            }
        });
        function matchUrlAndPaymentToken(item) {
            if (!item || !item.trim()) {
                interface_error("startflow_no_url_or_token", {
                    item: item
                });
                throw new Error("startflow_no_url_or_token");
            }
            var paymentToken = function(token) {
                if (token) {
                    if ((token = decodeURIComponent(decodeURIComponent(token))).match(/^(EC-)?[A-Z0-9]{17}$/)) return token;
                    var match = token.match(/token=((EC-)?[A-Z0-9]{17})/);
                    return match || (match = token.match(/(EC-[A-Z0-9]{17})/)) ? match[1] : void 0;
                }
            }(item);
            var url = paymentToken && paymentToken === item ? "" : item;
            if (url) if (url.match(/^https?:\/\/|^\//)) paymentToken ? -1 !== url.indexOf(".paypal.com") ? interface_debug("startflow_paypalurl_with_token", {
                url: url
            }) : interface_debug("startflow_url_with_token", {
                url: url
            }) : interface_debug("startflow_url_no_token", {
                url: url
            }); else {
                interface_info(paymentToken ? "startflow_relative_url_with_token" : "startflow_relative_url_no_token", {
                    url: url
                });
                0 === url.toLowerCase().indexOf("ec-") && paymentToken && (url = "" + config.a.checkoutUrl + url);
            } else {
                if (!paymentToken) {
                    interface_error("startflow_no_url_or_token", {
                        url: url
                    });
                    throw new Error('Could not determine url or token from "' + item + '"');
                }
                url = Object(lib.h)(config.a.checkoutUrl, {
                    token: paymentToken
                });
                interface_debug("startflow_with_token", {
                    url: url
                });
            }
            return {
                paymentToken: paymentToken,
                url: url
            };
        }
        function checkUrlAgainstEnv(url) {
            var paypalUrls = config.a.paypalUrls;
            for (var _i2 = 0, _Object$keys2 = Object.keys(paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2];
                var paypalUrl = paypalUrls[env];
                if (env !== constants.t.TEST && env !== constants.t.DEMO && env !== config.a.env && (0 === url.indexOf(paypalUrl) || 0 === url.indexOf(paypalUrl.replace("//www.", "//")))) {
                    interface_warn("mismatched_env_startflow_url", {
                        env: config.a.env,
                        url: url
                    });
                    redirect(url);
                    throw new Error(url + " is not a " + config.a.env + " url");
                }
            }
        }
        function awaitPaymentTokenAndUrl(event, targetElement) {
            var paymentTokenAndUrl = new src.a((function(resolve) {
                if (event && targetElement && (Math.random() < .001 || window.enablev3ajax)) {
                    var method;
                    var _url;
                    var body;
                    var contentType;
                    interface_info("gettoken_targetelement_start");
                    Object(client.h)();
                    if ("a" === targetElement.tagName.toLowerCase()) {
                        method = "get";
                        _url = targetElement.getAttribute("href");
                    } else if ("form" === targetElement.tagName.toLowerCase()) {
                        method = (targetElement.getAttribute("method") || "get").toLowerCase();
                        _url = targetElement.getAttribute("action");
                        body = form_serialize_default()(targetElement);
                        contentType = targetElement.getAttribute("enctype") || "application/x-www-form-urlencoded";
                    }
                    if (method && _url) {
                        event.preventDefault();
                        Object(lib.R)({
                            method: method,
                            url: _url,
                            body: body,
                            headers: {
                                Accept: "application/paypal-json-token",
                                "Content-type": contentType || ""
                            }
                        }).then((function(json) {
                            var urlAndPaymentToken = matchUrlAndPaymentToken(json.token);
                            resolve(urlAndPaymentToken);
                            interface_info("gettoken_targetelement_success", urlAndPaymentToken);
                            Object(client.h)();
                        })).catch((function(err) {
                            interface_warn("gettoken_targetelement_error", {
                                err: err.stack || err.toString()
                            });
                            Object(client.h)();
                        }));
                    } else {
                        interface_warn("gettoken_targetelement_no_method_or_url");
                        Object(client.h)();
                    }
                }
                interface_checkout.initXO = function() {
                    interface_warn("gettoken_initxo");
                };
                interface_checkout.startFlow = Object(lib.L)((function(item) {
                    interface_debug("gettoken_startflow", {
                        item: item
                    });
                    var _matchUrlAndPaymentTo = matchUrlAndPaymentToken(item), url = _matchUrlAndPaymentTo.url, paymentToken = _matchUrlAndPaymentTo.paymentToken;
                    checkUrlAgainstEnv(url);
                    return resolve({
                        url: url,
                        paymentToken: paymentToken
                    });
                }));
            }));
            return {
                url: paymentTokenAndUrl.then((function(result) {
                    return result.url;
                })),
                paymentToken: paymentTokenAndUrl.then((function(result) {
                    return result.paymentToken;
                }))
            };
        }
        var paypalCheckoutInited = !1;
        var closeFlowCalled = !1;
        function initPayPalCheckout(props) {
            void 0 === props && (props = {});
            interface_info("init_checkout");
            paypalCheckoutInited && config.a.env !== constants.t.TEST && interface_warn("multiple_init_paypal_checkout");
            closeFlowCalled && interface_debug("init_after_closeflow");
            paypalCheckoutInited = !0;
            var paypalCheckout = checkout.a.init(Object(esm_extends.a)({
                onAuthorize: function(data, actions) {
                    interface_info("payment_authorized");
                    logRedirect(data.returnUrl);
                    return actions.redirect(window);
                },
                onCancel: function(data, actions) {
                    if (data.cancelUrl) {
                        interface_info("payment_canceled");
                        logRedirect(data.cancelUrl);
                        return actions.redirect(window);
                    }
                },
                fallback: function(url) {
                    interface_error("fallback_handler", {
                        url: url
                    });
                    this.destroy();
                    return redirect(url);
                }
            }, props));
            interface_checkout.closeFlow = function(closeUrl) {
                interface_warn("closeflow");
                closeFlowCalled = !0;
                interface_reset();
                paypalCheckout.destroy();
                if (closeUrl) {
                    interface_warn("closeflow_with_url", {
                        closeUrl: closeUrl
                    });
                    return redirect(closeUrl);
                }
            };
            return paypalCheckout;
        }
        function renderPayPalCheckout(props, hijackTarget) {
            void 0 === props && (props = {});
            var urlProp = src.a.resolve(props.url);
            var paymentToken = new src.a((function(resolve) {
                props.init = function(data) {
                    resolve(data.paymentToken);
                };
            }));
            var errorHandler = Object(lib.L)((function(err) {
                interface_error("component_error", {
                    error: Object(lib.U)(err)
                });
                if (hijackTarget) {
                    interface_warn("render_error_hijack_revert_target");
                    hijackTarget.removeAttribute("target");
                }
                urlProp.then((function(url) {
                    interface_warn("render_error_redirect_using_url");
                    return redirect(url);
                }));
                paymentToken.then((function(token) {
                    interface_warn("render_error_redirect_using_token");
                    return redirect(Object(lib.h)(config.a.checkoutUrl, {
                        token: token
                    }));
                }));
            }));
            props.onError = errorHandler;
            var paypalCheckout;
            if (hijackTarget) {
                delete props.url;
                (paypalCheckout = initPayPalCheckout(props)).hijack(hijackTarget);
                paypalCheckout.runTimeout();
                urlProp.then((function(url) {
                    interface_warn("hijack_then_url_passed");
                    paypalCheckout.loadUrl(url);
                }));
            } else paypalCheckout = initPayPalCheckout(props);
            var render = paypalCheckout.render(null, !hijackTarget);
            interface_checkout.win = paypalCheckout.window;
            return render.catch(errorHandler);
        }
        function instrumentButtonRender(type) {
            var _track;
            interface_info("render_" + type + "_button");
            track(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, 
            _track[constants.u.KEY.BUTTON_TYPE] = type, _track));
            Object(client.h)();
        }
        var setupCalled = !1;
        function setup(id, options) {
            void 0 === options && (options = {});
            interface_info("setup", {
                id: id = id || "merchant",
                env: options.environment,
                options: Object(lib.S)(options)
            });
            setupCalled && interface_debug("setup_called_multiple_times");
            setupCalled = !0;
            !function(options) {
                if (options.environment) {
                    "live" === options.environment && (options.environment = constants.t.PRODUCTION);
                    if (!config.a.paypalUrls[options.environment]) {
                        options_warn("invalid_env", {
                            badenv: options.environment
                        });
                        options.environment = config.a.env;
                    }
                }
                if (options.button && !Array.isArray(options.button)) {
                    options_info("options_button_single_button_passed");
                    options.button = [ options.button ];
                }
                if (options.buttons && Object(lib.p)(options.buttons).length) {
                    options_info("options_buttons_with_elements_passed");
                    options.button = options.buttons;
                    delete options.buttons;
                }
                if (options.button && 0 === options.button.length) {
                    options_info("options_button_empty");
                    delete options.button;
                }
                if (options.button && options.container) {
                    options_info("options_button_and_container_passed", {
                        button: options.button,
                        container: options.container
                    });
                    options.button = options.button.concat(options.container);
                    delete options.container;
                }
                if (options.button) {
                    var button = Object(lib.p)(options.button);
                    if (button.length) options.button = button; else {
                        options_warn("options_button_element_not_found", {
                            element: JSON.stringify(options.button)
                        });
                        delete options.button;
                    }
                }
                if (options.button) {
                    options.buttons = options.button.map((function(button) {
                        return {
                            button: button,
                            click: options.click,
                            condition: options.condition
                        };
                    }));
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                } else if (options.buttons && Array.isArray(options.buttons)) {
                    var buttons = [];
                    options.buttons.forEach((function(button) {
                        if (button) {
                            button.container && button.container !== options.container && options_warn("mismatched_container_and_button_passed", {
                                options: options.container,
                                button: button.container
                            });
                            Object(lib.p)(button.container || button.button).forEach((function(element) {
                                var _buttons$push;
                                buttons.push(((_buttons$push = {})[button.container ? "container" : "button"] = element, 
                                _buttons$push.click = button.click || options.click, _buttons$push.condition = button.condition || options.condition, 
                                _buttons$push.type = button.type || options.type, _buttons$push.locale = button.locale || options.locale, 
                                _buttons$push.color = button.color || options.color, _buttons$push.shape = button.shape || options.shape, 
                                _buttons$push.size = button.size || options.size, _buttons$push));
                            }));
                        }
                    }));
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    buttons.length && (options.buttons = buttons);
                } else if (options.container && !Array.isArray(options.buttons)) {
                    var _buttons = [];
                    Object(lib.p)(options.container).forEach((function(container, i) {
                        _buttons.push({
                            container: container,
                            click: options.click,
                            condition: options.condition,
                            type: Array.isArray(options.type) ? options.type[i] : options.type,
                            locale: Array.isArray(options.locale) ? options.locale[i] : options.locale,
                            color: Array.isArray(options.color) ? options.color[i] : options.color,
                            shape: Array.isArray(options.shape) ? options.shape[i] : options.shape,
                            size: Array.isArray(options.size) ? options.size[i] : options.size
                        });
                    }));
                    delete options.container;
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    _buttons.length && (options.buttons = _buttons);
                }
                options.buttons || (options.buttons = []);
            }(options);
            !function(options) {
                options.environment && config.a.paypalUrls[options.environment] && (config.a.env = options.environment);
                if (options.locale) {
                    config.a.locale = normalizeLocale(options.locale);
                    config.a.customCountry = !0;
                }
            }(options);
            env = config.a.env, src.a.try((function() {
                if (!post_robot_src.bridge || !post_robot_src.bridge.needsBridge({
                    domain: config.a.paypalDomains[env]
                })) return Object(client.f)("post_bridge_not_required", {
                    env: env
                });
                Object(client.f)("setup_post_bridge", {
                    env: env
                });
                return Object(lib.M)(env).then(lib.J);
            }));
            var env;
            return src.a.try((function() {
                return options.buttons.length ? renderButtons(id, options.buttons).then((function(buttons) {
                    buttons.forEach((function(button) {
                        instrumentButtonRender(button.type);
                        !function(container, button, clickHandler, condition, tracker) {
                            var element = "a" === container.tagName.toLowerCase() ? container : button;
                            var isClick = "function" == typeof clickHandler;
                            if (element.hasAttribute("data-paypal-click-listener")) return interface_warn("button_already_has_paypal_click_listener");
                            element.setAttribute("data-paypal-click-listener", "");
                            getHijackTargetElement(element) && isClick && interface_info("button_link_or_form");
                            element.addEventListener("click", (function(event) {
                                tracker();
                                var eligible = isLegacyEligible();
                                if (Object(belter_src.p)()) {
                                    interface_debug("click_popups_supported");
                                    eligible || interface_debug("click_popups_supported_but_ineligible");
                                } else {
                                    interface_debug("click_popups_not_supported");
                                    eligible && interface_debug("click_popups_not_supported_but_eligible");
                                }
                                if (!isClick && !eligible) return interface_debug("ineligible_listenclick");
                                interface_info("button_click");
                                if ("function" == typeof condition) {
                                    if (!condition.call()) return interface_info("button_click_condition_disabled");
                                    interface_info("button_click_condition_enabled");
                                }
                                return isClick ? function(clickHandler, event) {
                                    interface_debug("button_click_handler");
                                    try {
                                        clickHandler(event);
                                    } catch (err) {
                                        interface_error("click_handler_error", {
                                            error: Object(lib.U)(err)
                                        });
                                    }
                                }(clickHandler, event) : function(event, element) {
                                    var targetElement = getHijackTargetElement(element);
                                    if (!targetElement) return interface_error("target_element_not_found");
                                    interface_info("init_paypal_checkout_hijack");
                                    var _awaitPaymentTokenAnd = awaitPaymentTokenAndUrl(event, targetElement), url = _awaitPaymentTokenAnd.url;
                                    var token;
                                    _awaitPaymentTokenAnd.paymentToken.then((function(result) {
                                        token = result;
                                    }));
                                    renderPayPalCheckout({
                                        url: url,
                                        payment: function() {
                                            return src.a.resolve(token);
                                        }
                                    }, targetElement);
                                }(event, element);
                            }));
                        }(button.container, button.element, button.click, button.condition, (function() {
                            !function(type) {
                                var _track2;
                                track(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, 
                                _track2[constants.u.KEY.BUTTON_TYPE] = type, _track2));
                                Object(client.h)();
                            }(button.type);
                        }));
                    }));
                })) : instrumentButtonRender(constants.u.BUTTON_TYPE.CUSTOM);
            }));
        }
        interface_checkout.setup = setup;
        function initXO() {
            interface_debug("initxo");
            if (!isLegacyEligible()) return interface_debug("ineligible_initxo");
            var _awaitPaymentTokenAnd2 = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd2.url, paymentToken = _awaitPaymentTokenAnd2.paymentToken;
            interface_info("init_paypal_checkout_initxo");
            renderPayPalCheckout({
                url: url,
                payment: function() {
                    return paymentToken;
                }
            });
        }
        interface_checkout.initXO = initXO;
        function startFlow(item) {
            interface_debug("startflow", {
                item: item
            });
            var _matchUrlAndPaymentTo2 = matchUrlAndPaymentToken(item), paymentToken = _matchUrlAndPaymentTo2.paymentToken, url = _matchUrlAndPaymentTo2.url;
            checkUrlAgainstEnv(url);
            if (isLegacyEligible()) {
                interface_info("init_paypal_checkout_startflow");
                renderPayPalCheckout({
                    url: url,
                    payment: function() {
                        return src.a.resolve(paymentToken);
                    }
                });
            } else {
                interface_debug("ineligible_startflow_global", {
                    url: url
                });
                redirect(url);
            }
        }
        interface_checkout.startFlow = startFlow;
        function closeFlow(closeUrl) {
            interface_warn("closeflow_not_opened");
            if (closeUrl) {
                interface_warn("closeflow_with_url", {
                    closeUrl: closeUrl
                });
                redirect(closeUrl);
            }
        }
        interface_checkout.closeFlow = closeFlow;
        var ready_prefix = Object(client.n)(LOG_PREFIX), ready_error = ready_prefix.error, ready_debug = ready_prefix.debug;
        !function(obj, key, callback) {
            if (obj) {
                var value = obj[key];
                value && (value = callback(value) || value);
                try {
                    delete obj[key];
                    Object.defineProperty(obj, key, {
                        configurable: !0,
                        set: function(item) {
                            (value = item) && (value = callback(value) || value);
                        },
                        get: function() {
                            return value;
                        }
                    });
                } catch (err) {}
            }
        }(window, "paypalCheckoutReady", (function(method) {
            if ("function" == typeof method) {
                var oneTimeReady = function() {
                    if (!method.called) {
                        method.called = !0;
                        return method.apply(this, arguments);
                    }
                };
                !function(method) {
                    Object(lib.K)((function() {
                        ready_debug("paypal_checkout_ready");
                        setTimeout((function() {
                            window.paypal || ready_error("paypal_checkout_ready_no_window_paypal");
                            method();
                        }), 1);
                    }));
                }(oneTimeReady);
                return oneTimeReady;
            }
        }));
        Object(lib.K)((function() {
            var buttons = [].slice.call(document.querySelectorAll("[" + ATTRIBUTES.BUTTON + "]"));
            if (buttons && buttons.length) {
                ready_debug("data_paypal_button", {
                    number: buttons.length
                });
                for (var _i2 = 0; _i2 < buttons.length; _i2++) {
                    var button = buttons[_i2];
                    var id = button.getAttribute(ATTRIBUTES.MERCHANT_ID);
                    var environment = void 0;
                    button.hasAttribute(ATTRIBUTES.ENV) ? environment = button.getAttribute(ATTRIBUTES.ENV) : button.hasAttribute(ATTRIBUTES.SANDBOX) && (environment = constants.t.SANDBOX);
                    setup(id, {
                        environment: environment,
                        button: button
                    });
                }
            }
            [].slice.call(document.getElementsByClassName(CLASSES.HIDDEN_BUTTON)).forEach((function(el) {
                el.className = el.className.replace(CLASSES.HIDDEN_BUTTON, "");
            }));
        }));
    } ]);
}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23), __webpack_require__(172).Buffer))

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(173)
var ieee754 = __webpack_require__(174)
var isArray = __webpack_require__(175)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 174 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 175 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(177), __esModule: true };

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(178);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(21);
var $keys = __webpack_require__(18);

__webpack_require__(179)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(15);
var core = __webpack_require__(0);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(181);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
        state: {
                // APP
                APP_VERSION: '1.0.1 / 14-10-2023.01',
                APP_TITLE: 'APP - Thalo Global Group',
                APP_LOGO: '/src/assets/images/logo.png',
                APP_AGENCIA: 'System',
                DEFAULT_LANGUAGE: 1,
                ID_LANGUAGE: 1,
                TYPE_MENU: 'ME',
                DEFAULT_USER: 'a',
                DEFAULT_PASSWORD: 'a',

                // LOCAL STORAGE
                LS_USER_LOGIN: 'userLogin',
                LS_MENU_LABEL: 'menuLabel',
                LS_MENU_ICON: 'menuIcon',
                LS_MENU_CLICK: 'menuClick',

                // PRINT
                PROPERTIES_PRINT_LIST: { pageOrientation: 'portrait',
                        pageSize: 'a4',
                        format: 'list',
                        fileName: ' (list)'
                },
                PROPERTIES_PRINT_FORM: { pageOrientation: 'portrait',
                        pageSize: 'a4',
                        format: 'form',
                        fileName: ' (form)'
                },

                RESPONSE_CODE_OK: 200,
                TOTAL_RECORD_LIST: 13,
                CURRENT_RECORD: 0,

                // FORM
                FORM_LOGIN: 2,
                FORM_MENU: 3,
                FORM_USUARIO: 4,
                FORM_SEXO: 6,
                FORM_ESTADO_CIVIL: 7,
                FORM_PRODUCTO: 10,
                FORM_CIUDAD: 11,
                FORM_COBERTURA: 12,
                FORM_COMPANIA: 13,
                FORM_DOCUMENTO_FISCAL: 14,
                FORM_ESTADO: 15,
                FORM_GRUPO_COBERTURA: 16,
                FORM_IDIOMA: 17,
                FORM_MONEDA: 18,
                FORM_PAIS: 19,
                FORM_PLAN: 21,
                FORM_RAMO: 22,
                FORM_TERRITORIO: 23,
                FORM_TIPO_CONTACTO: 24,
                FORM_TIPO_CORREO: 25,
                FORM_TIPO_TELEFONO: 26,
                FORM_ETIQUETA: 28,
                FORM_FORMULARIO: 29,
                FORM_RANGO_EDAD: 39,
                FORM_RANGO_TIEMPO: 40,
                FORM_ORIGEN_DESTINO: 43,
                FORM_CATEGORIA: 47,
                FORM_TARIFA: 51,
                FORM_TIPO_CAMBIO: 52,
                FORM_COTIZACION_VIAJERO: 62,
                FORM_ANEXO: 65,
                FORM_DEPORTE: 69,
                FORM_VARIABLE: 71,
                FORM_COTIZACION: 72,
                FORM_METODO_PAGO: 74,
                FORM_VALIDAR_METODO_PAGO: 76,

                // VARIABLE
                LIST_VARIABLE: 'lst_variable',

                // LIST
                ID_LIST_MESSAGE: 1,
                LIST_MESSAGES: 'messages',
                ID_LIST_ESTATUS: 5,
                LIST_ESTATUS: 'lst_estatus',
                ID_LIST_SI_NO: 37,
                LIST_SI_NO: 'lst_si_no',
                ID_LIST_FORMATO_CATEGORIA: 38,
                LIST_FORMATO_CATEGORIA: 'lts_formato_categoria',
                ID_LIST_TIPO_COBERTURA: 55,
                LIST_TIPO_COBERTURA: 'lts_tipo_cobertura',
                ID_LIST_CALCULO_COSTO: 56,
                LIST_CALCULO_COSTO: 'lst_calculo_costo',
                ID_LIST_CALCULO_TARIFA: 57,
                LIST_CALCULO_TARIFA: 'lst_calculo_tarifa',
                ID_LIST_CALCULO_PVP: 58,
                LIST_CALCULO_PVP: 'lst_calculo_pvp',
                ID_LIST_TIPO_PLAN: 59,
                LIST_TIPO_PLAN: 'lst_tipo_plan',
                ID_LIST_TIPO_ORIGEN_DESTINO: 60,
                LIST_TIPO_ORIGEN_DESTINO: 'lst_tipo_origen_destino',
                ID_LIST_TIPO_RANGO_TIEMPO: 61,
                LIST_TIPO_RANGO_TIEMPO: 'lst_tipo_rango_tiempo',
                ID_LIST_FIJO_OPCIONAL: 63,
                LIST_FIJO_OPCIONAL: 'lst_fijo_opcional',
                ID_LIST_CALCULO_COBERTURA: 64,
                LIST_CALCULO_COBERTURA: 'lst_calculo_cobertura',
                ID_LIST_CALCULO_SA_COBERTURA: 66,
                LIST_CALCULO_SA_COBERTURA: 'lst_calculo_sa_cobertura',
                ID_LIST_TIPO_SEGURO: 67,
                LIST_TIPO_SEGURO: 'lst_tipo_seguro',
                ID_LIST_CALCULO_FACTOR: 68,
                LIST_CALCULO_FACTOR: 'lst_calculo_factor',
                ID_LIST_RIESGO: 70,
                LIST_RIESGO: 'lst_riesgo',
                ID_LIST_PENDIENTE: 73,
                LIST_PENDIENTE: 'lst_pendiente',
                ID_LIST_TIPO_VALIDACION: 75,
                LIST_TIPO_VALIDACION: 'lst_tipo_validacion',

                // VARIABLE INITIALIZATION
                MESSAGES: { msg_error_3: "Error de conexión al servidor",
                        data: []
                }
        },
        mutations: {
                setMessages: function setMessages(state, messagesList) {
                        state.MESSAGES = messagesList;
                },
                setCurrentRecord: function setCurrentRecord(state, newCurrentRecord) {
                        state.currentRecord = newCurrentRecord;
                }
        }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
/*!
 * vuex v3.6.0
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printDataToPdf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jspdf__ = __webpack_require__(183);

var MARGIN_TOP = 5;
var MARGIN_DOWN = 5;
var MARGIN_RIGHT = 5;
var MARGIN_LEFT = 15;

function setWidthAndHeight(p_properties, p_header) {
    var widthPage = void 0;
    var heightPage = void 0;
    if (p_properties.pageSize == 'letter') {
        widthPage = 216;
        heightPage = 279;
    } else if (p_properties.pageSize == 'legal') {
        widthPage = 216;
        heightPage = 356;
    } else if (p_properties.pageSize == 'a3') {
        widthPage = 297;
        heightPage = 420;
    } else if (p_properties.pageSize == 'a5') {
        widthPage = 148;
        heightPage = 210;
    } else {
        //'a4'
        widthPage = 210;
        heightPage = 297;
    }
    if (p_properties.pageOrientation == 'portrait') {
        p_properties.width = widthPage;
        p_properties.height = heightPage;
    } else {
        // landscape
        p_properties.width = heightPage;
        p_properties.height = widthPage;
    }
    p_properties.halfWidth = Math.round(p_properties.width / 2, 0);
    p_properties.page = 1;
}

function setWidthFormData(p_properties, p_header) {
    if (p_header.dataTitle && p_header.dataTitle.length > 0) {
        var widthwidthoutMargin = p_properties.width - MARGIN_RIGHT - MARGIN_LEFT;
        var average = widthwidthoutMargin / p_header.dataTitle.length;
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            var newWidth = average;
            if (p_header.dataTitle[index].widthTitle) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].widthTitle / 100), 0);
            }
            p_header.dataTitle[index].widthTitle = newWidth;
            newWidth = average;
            if (p_header.dataTitle[index].widthField) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].widthField / 100), 0);
            }
            p_header.dataTitle[index].widthField = newWidth;
        }
    }
}

function setWidthListData(p_properties, p_header) {
    if (p_header.dataTitle && p_header.dataTitle.length > 0) {
        var widthwidthoutMargin = p_properties.width - MARGIN_RIGHT - MARGIN_LEFT;
        var average = widthwidthoutMargin / p_header.dataTitle.length;
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            var newWidth = average;
            if (p_header.dataTitle[index].width) {
                newWidth = Math.round(widthwidthoutMargin * (p_header.dataTitle[index].width / 100), 0);
            }
            p_header.dataTitle[index].width = newWidth;
        }
    }
}

function textFormat(p_text, p_type) {
    var text = '';
    if (p_text && p_type == 'I') {
        text = p_text.toString();
    } else if (p_text) {
        text = p_text;
    }
    return text;
}

function printCell(p_pdf, p_properties, p_header, p_index, p_text) {
    var alignment = 'left';
    var colAdd = 0;
    if (p_header.dataTitle[p_index].alignment == 'right') {
        alignment = 'right';
        colAdd = p_header.dataTitle[p_index].width;
    } else if (p_header.dataTitle[p_index].alignment == 'center') {
        colAdd = Math.round(p_header.dataTitle[p_index].width / 2, 0);
        alignment = 'center';
    }
    var type = p_header.dataTitle[p_index].type;
    var text = textFormat(p_text, type);
    p_pdf.text(text, p_properties.col + colAdd, p_properties.fila, alignment);
}

function printHeader(p_pdf, p_properties, p_header, p_isList) {
    p_properties.fila = MARGIN_TOP + 7;
    if (p_header.logo) {
        p_pdf.addImage(p_header.logo, "PNG", MARGIN_LEFT, MARGIN_TOP, 20, 20);
    }
    p_pdf.setFont("helvetica", "bolditalic");
    p_pdf.setFontSize(12);
    p_pdf.text(p_header.agencia, 37, p_properties.fila, 'left');
    p_properties.fila += 4;
    p_pdf.setFont("helvetica", "normal");
    p_pdf.setFontSize(8);
    p_pdf.text(p_header.notaAgencia, 37, p_properties.fila, 'left');
    p_properties.fila += 3;
    p_pdf.setFont("helvetica", "bolditalic");
    p_pdf.setFontSize(12);
    p_pdf.text(p_header.title, p_properties.halfWidth, p_properties.fila, 'center');
    p_properties.fila += 4;
    if (p_header.subTitle) {
        p_pdf.setFont("helvetica", "normal");
        p_pdf.setFontSize(10);
        p_pdf.text(p_header.subTitle, p_properties.halfWidth, p_properties.fila, 'center');
    }
    p_properties.fila += 2;
    if (p_isList && p_header.dataTitle && p_header.dataTitle.length > 0) {
        p_pdf.setFont("arial", "bold");
        p_pdf.setFontSize(8);
        p_properties.col = MARGIN_LEFT;
        p_pdf.setFillColor(244, 245, 245);
        p_pdf.rect(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT - MARGIN_LEFT, 5, "F");
        p_pdf.setLineWidth(0.1);
        p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
        p_properties.fila += 3;
        for (var index = 0; index < p_header.dataTitle.length; index++) {
            printCell(p_pdf, p_properties, p_header, index, p_header.dataTitle[index].title);
            p_properties.col += p_header.dataTitle[index].width;
        }
        p_properties.fila += 2;
    }
    p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
    p_properties.fila += 4;
}

function printFooter(p_pdf, p_properties) {
    p_properties.fila = p_properties.height - MARGIN_DOWN - 8;
    p_pdf.setLineWidth(0.1);
    p_pdf.line(MARGIN_LEFT, p_properties.fila, p_properties.width - MARGIN_RIGHT, p_properties.fila);
    p_properties.fila += 4;
    p_pdf.setFont("helvetica", "normal");
    p_pdf.setFontSize(12);
    p_pdf.text(p_properties.page.toString(), p_properties.halfWidth, p_properties.fila, 'center');
}

function addPage(p_pdf, p_properties) {
    p_properties.page += 1;
    p_pdf.addPage();
}

function getListValue(p_id, p_listValues) {
    var value = "";
    var index = 0;
    while (index < p_listValues.length && value == "") {
        if (p_listValues[index].value == p_id) {
            value = p_listValues[index].text;
        }
        index++;
    }
    return value;
}

function printDataList(p_pdf, p_properties, p_header, p_data) {
    if (p_data && p_data.length > 0) {
        var isPrintHeader = true;
        for (var record = 0; record < p_data.length; record++) {
            if (isPrintHeader) {
                isPrintHeader = false;
                printHeader(p_pdf, p_properties, p_header, true);
                p_pdf.setFont("arial", "normal");
                p_pdf.setFontSize(8);
            }
            p_properties.col = MARGIN_LEFT;
            for (var index = 0; index < p_header.dataTitle.length; index++) {
                var textValue = p_data[record][p_header.dataTitle[index].field];
                if (p_header.dataTitle[index].listValues) {
                    textValue = p_header.dataTitle[index].listValues[textValue].text;
                    //textValue = getListValue(textValue, p_header.dataTitle[index].listValues);
                }
                printCell(p_pdf, p_properties, p_header, index, textValue);
                p_properties.col += p_header.dataTitle[index].width;
            }
            p_properties.fila += 4;
        }
        if (!isPrintHeader) {
            printFooter(p_pdf, p_properties);
        }
    }
}

function printDataForm(p_pdf, p_properties, p_header, p_data) {
    if (p_data && p_data.length > 0) {
        var isPrintHeader = true;
        for (var record = 0; record < p_header.dataTitle.length; record++) {
            if (isPrintHeader) {
                isPrintHeader = false;
                printHeader(p_pdf, p_properties, p_header, false);
                p_pdf.setFontSize(10);
                p_properties.fila += 4;
            }
            var fieds = p_header.dataTitle[record].fields;
            var titles = p_header.dataTitle[record].titles;
            var types = p_header.dataTitle[record].types;
            p_properties.col = MARGIN_LEFT;
            for (var index = 0; index < fieds.length; index++) {
                p_pdf.setFont("arial", "bold");
                var textTitle = titles[index] + ': ';
                p_properties.col += p_header.dataTitle[record].widthTitle;
                p_pdf.text(textTitle, p_properties.col, p_properties.fila, 'right');
                p_pdf.setFont("arial", "normal");
                var text = textFormat(p_data[0][fieds[index]], types[index]);
                p_pdf.text(text, p_properties.col, p_properties.fila, 'left');
                p_properties.col += p_header.dataTitle[record].widthField;
            }
            p_properties.fila += 6;
        }
        if (!isPrintHeader) {
            printFooter(p_pdf, p_properties);
        }
    }
}

function printDataToPdf(p_properties, p_header, p_data) {
    var pdf = new __WEBPACK_IMPORTED_MODULE_0_jspdf__["a" /* default */](p_properties.pageOrientation, 'mm', p_properties.pageSize);
    pdf.setProperties({
        title: p_header.title,
        author: p_header.agencia,
        creator: p_header.agencia
    });
    setWidthAndHeight(p_properties, p_header);
    if (p_properties.format == 'list') {
        setWidthListData(p_properties, p_header);
        printDataList(pdf, p_properties, p_header, p_data);
    } else if (p_properties.format == 'form') {
        setWidthFormData(p_properties, p_header);
        printDataForm(pdf, p_properties, p_header, p_data);
    }
    var fileName = p_header.title + p_properties.fileName;
    pdf.save(fileName);
}

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export AcroForm */
/* unused harmony export AcroFormAppearance */
/* unused harmony export AcroFormButton */
/* unused harmony export AcroFormCheckBox */
/* unused harmony export AcroFormChoiceField */
/* unused harmony export AcroFormComboBox */
/* unused harmony export AcroFormEditBox */
/* unused harmony export AcroFormListBox */
/* unused harmony export AcroFormPasswordField */
/* unused harmony export AcroFormPushButton */
/* unused harmony export AcroFormRadioButton */
/* unused harmony export AcroFormTextField */
/* unused harmony export GState */
/* unused harmony export ShadingPattern */
/* unused harmony export TilingPattern */
/* unused harmony export jsPDF */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fflate__ = __webpack_require__(185);
/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.1 Built on 2022-01-28T15:37:57.791Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */

var n=function(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function i(){n.console&&"function"==typeof n.console.log&&n.console.log.apply(n.console,arguments)}var a={log:i,warn:function(t){n.console&&("function"==typeof n.console.warn?n.console.warn.apply(n.console,arguments):i.call(null,arguments))},error:function(t){n.console&&("function"==typeof n.console.error?n.console.error.apply(n.console,arguments):i(t))}};function o(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r)},n.onerror=function(){a.error("could not download file")},n.send()}function s(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send()}catch(t){}return e.status>=200&&e.status<=299}function c(t){try{t.dispatchEvent(new MouseEvent("click"))}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e)}}var u,h,l=n.saveAs||("object"!==("undefined"==typeof window?"undefined":__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(window))||window!==n?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,r){var i=n.URL||n.webkitURL,a=document.createElement("a");e=e||t.name||"download",a.download=e,a.rel="noopener","string"==typeof t?(a.href=t,a.origin!==location.origin?s(a.href)?o(t,e,r):c(a,a.target="_blank"):c(a)):(a.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(a.href)}),4e4),setTimeout((function(){c(a)}),0))}:"msSaveOrOpenBlob"in navigator?function(e,r,n){if(r=r||e.name||"download","string"==typeof e)if(s(e))o(e,r,n);else{var i=document.createElement("a");i.href=e,i.target="_blank",setTimeout((function(){c(i)}))}else navigator.msSaveOrOpenBlob(function(e,r){return void 0===r?r={autoBom:!1}:"object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)&&(a.warn("Deprecated: Expected third argument to be a object"),r={autoBom:!r}),r.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)?new Blob([String.fromCharCode(65279),e],{type:e.type}):e}(e,n),r)}:function(e,r,i,a){if((a=a||open("","_blank"))&&(a.document.title=a.document.body.innerText="downloading..."),"string"==typeof e)return o(e,r,i);var s="application/octet-stream"===e.type,c=/constructor/i.test(n.HTMLElement)||n.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||s&&c)&&"object"===("undefined"==typeof FileReader?"undefined":__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(FileReader))){var h=new FileReader;h.onloadend=function(){var t=h.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),a?a.location.href=t:location=t,a=null},h.readAsDataURL(e)}else{var l=n.URL||n.webkitURL,f=l.createObjectURL(e);a?a.location=f:location.href=f,a=null,setTimeout((function(){l.revokeObjectURL(f)}),4e4)}});
/**
 * A class to parse color values
 * @author Stoyan Stefanov <sstoo@gmail.com>
 * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
 * @license Use it if you like it
 */function f(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r}}
/**
 * @license
 * Joseph Myers does not specify a particular license for his work.
 *
 * Author: Joseph Myers
 * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
 *
 * Modified by: Owen Leong
 */
function d(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=g(r,n,i,a,e[0],7,-680876936),a=g(a,r,n,i,e[1],12,-389564586),i=g(i,a,r,n,e[2],17,606105819),n=g(n,i,a,r,e[3],22,-1044525330),r=g(r,n,i,a,e[4],7,-176418897),a=g(a,r,n,i,e[5],12,1200080426),i=g(i,a,r,n,e[6],17,-1473231341),n=g(n,i,a,r,e[7],22,-45705983),r=g(r,n,i,a,e[8],7,1770035416),a=g(a,r,n,i,e[9],12,-1958414417),i=g(i,a,r,n,e[10],17,-42063),n=g(n,i,a,r,e[11],22,-1990404162),r=g(r,n,i,a,e[12],7,1804603682),a=g(a,r,n,i,e[13],12,-40341101),i=g(i,a,r,n,e[14],17,-1502002290),r=m(r,n=g(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=m(a,r,n,i,e[6],9,-1069501632),i=m(i,a,r,n,e[11],14,643717713),n=m(n,i,a,r,e[0],20,-373897302),r=m(r,n,i,a,e[5],5,-701558691),a=m(a,r,n,i,e[10],9,38016083),i=m(i,a,r,n,e[15],14,-660478335),n=m(n,i,a,r,e[4],20,-405537848),r=m(r,n,i,a,e[9],5,568446438),a=m(a,r,n,i,e[14],9,-1019803690),i=m(i,a,r,n,e[3],14,-187363961),n=m(n,i,a,r,e[8],20,1163531501),r=m(r,n,i,a,e[13],5,-1444681467),a=m(a,r,n,i,e[2],9,-51403784),i=m(i,a,r,n,e[7],14,1735328473),r=v(r,n=m(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=v(a,r,n,i,e[8],11,-2022574463),i=v(i,a,r,n,e[11],16,1839030562),n=v(n,i,a,r,e[14],23,-35309556),r=v(r,n,i,a,e[1],4,-1530992060),a=v(a,r,n,i,e[4],11,1272893353),i=v(i,a,r,n,e[7],16,-155497632),n=v(n,i,a,r,e[10],23,-1094730640),r=v(r,n,i,a,e[13],4,681279174),a=v(a,r,n,i,e[0],11,-358537222),i=v(i,a,r,n,e[3],16,-722521979),n=v(n,i,a,r,e[6],23,76029189),r=v(r,n,i,a,e[9],4,-640364487),a=v(a,r,n,i,e[12],11,-421815835),i=v(i,a,r,n,e[15],16,530742520),r=b(r,n=v(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=b(a,r,n,i,e[7],10,1126891415),i=b(i,a,r,n,e[14],15,-1416354905),n=b(n,i,a,r,e[5],21,-57434055),r=b(r,n,i,a,e[12],6,1700485571),a=b(a,r,n,i,e[3],10,-1894986606),i=b(i,a,r,n,e[10],15,-1051523),n=b(n,i,a,r,e[1],21,-2054922799),r=b(r,n,i,a,e[8],6,1873313359),a=b(a,r,n,i,e[15],10,-30611744),i=b(i,a,r,n,e[6],15,-1560198380),n=b(n,i,a,r,e[13],21,1309151649),r=b(r,n,i,a,e[4],6,-145523070),a=b(a,r,n,i,e[11],10,-1120210379),i=b(i,a,r,n,e[2],15,718787259),n=b(n,i,a,r,e[9],21,-343485551),t[0]=_(r,t[0]),t[1]=_(n,t[1]),t[2]=_(i,t[2]),t[3]=_(a,t[3])}function p(t,e,r,n,i,a){return e=_(_(e,t),_(n,a)),_(e<<i|e>>>32-i,r)}function g(t,e,r,n,i,a,o){return p(e&r|~e&n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return p(e&n|r&~n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return p(e^r^n,t,e,i,a,o)}function b(t,e,r,n,i,a,o){return p(r^(e|~n),t,e,i,a,o)}function y(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)d(n,w(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(d(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,d(n,i),n}function w(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}u=n.atob.bind(n),h=n.btoa.bind(n);var N="0123456789abcdef".split("");function L(t){for(var e="",r=0;r<4;r++)e+=N[t>>8*r+4&15]+N[t>>8*r&15];return e}function A(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function x(t){return y(t).map(A).join("")}var S="5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=L(t[e]);return t.join("")}(y("hello"));function _(t,e){if(S){var r=(65535&t)+(65535&e);return(t>>16)+(e>>16)+(r>>16)<<16|65535&r}return t+e&4294967295}
/**
 * @license
 * FPDF is released under a permissive license: there is no usage restriction.
 * You may embed it freely in your application (commercial or not), with or
 * without modifications.
 *
 * Reference: http://www.fpdf.org/en/script/script37.php
 */function P(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],c=0;c<256;c++)s[c]=c;var u=0;for(c=0;c<256;c++){var h=s[c];u=(u+h+o.charCodeAt(c))%256,s[c]=s[u],s[u]=h}r=t,n=s}else s=n;var l=e.length,f=0,d=0,p="";for(c=0;c<l;c++)d=(d+(h=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=h,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(c)^o);return p}
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 * Author: Owen Leong (@owenl131)
 * Date: 15 Oct 2020
 * References:
 * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
 * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
 * http://www.fpdf.org/en/script/script37.php
 */var k={print:4,modify:8,copy:16,"annot-forms":32};function I(t,e,r,n){this.v=1,this.r=2;var i=192;t.forEach((function(t){if(void 0!==k.perm)throw new Error("Invalid permission: "+t);i+=k[t]})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";var a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=x(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=P(this.encryptionKey,this.padding)}function F(t){if(/[^\u0000-\u00ff]/.test(t))throw new Error("Invalid PDF Name Object: "+t+", Only accept ASCII characters.");for(var e="",r=t.length,n=0;n<r;n++){var i=t.charCodeAt(n);if(i<33||35===i||37===i||40===i||41===i||47===i||60===i||62===i||91===i||93===i||123===i||125===i||i>126)e+="#"+("0"+i.toString(16)).slice(-2);else e+=t[n]}return e}function C(e){if("object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var r={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");r.hasOwnProperty(t)||(r[t]={});var i=Math.random().toString(35);return r[t][i]=[e,!!n],i},this.unsubscribe=function(t){for(var e in r)if(r[e][t])return delete r[e][t],0===Object.keys(r[e]).length&&delete r[e],!0;return!1},this.publish=function(t){if(r.hasOwnProperty(t)){var i=Array.prototype.slice.call(arguments,1),o=[];for(var s in r[t]){var c=r[t][s];try{c[0].apply(e,i)}catch(t){n.console&&a.error("jsPDF PubSub Error",t.message,t)}c[1]&&o.push(s)}o.length&&o.forEach(this.unsubscribe)}},this.getTopics=function(){return r}}function j(t){if(!(this instanceof j))return new j(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1}function O(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1}function B(t,e,r,n,i){if(!(this instanceof B))return new B(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,O.call(this,n,i)}function M(t,e,r,n,i){if(!(this instanceof M))return new M(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,O.call(this,n,i)}function E(e){var r,i="string"==typeof arguments[0]?arguments[0]:"p",o=arguments[1],s=arguments[2],c=arguments[3],u=[],d=1,p=16,g="S",m=null;"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e=e||{})&&(i=e.orientation,o=e.unit||o,s=e.format||s,c=e.compress||e.compressPdf||c,null!==(m=e.encryption||null)&&(m.userPassword=m.userPassword||"",m.ownerPassword=m.ownerPassword||"",m.userPermissions=m.userPermissions||[]),d="number"==typeof e.userUnit?Math.abs(e.userUnit):1,void 0!==e.precision&&(r=e.precision),void 0!==e.floatPrecision&&(p=e.floatPrecision),g=e.defaultPathOperation||"S"),u=e.filters||(!0===c?["FlateEncode"]:u),o=o||"mm",i=(""+(i||"P")).toLowerCase();var v=e.putOnlyUsedFonts||!1,b={},y={internal:{},__private__:{}};y.__private__.PubSub=C;var w="1.3",N=y.__private__.getPdfVersion=function(){return w};y.__private__.setPdfVersion=function(t){w=t};var L={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};y.__private__.getPageFormats=function(){return L};var A=y.__private__.getPageFormat=function(t){return L[t]};s=s||"a4";var x={COMPAT:"compat",ADVANCED:"advanced"},S=x.COMPAT;function _(){this.saveGraphicsState(),lt(new Vt(_t,0,0,-_t,0,Rr()*_t).toString()+" cm"),this.setFontSize(this.getFontSize()/_t),g="n",S=x.ADVANCED}function P(){this.restoreGraphicsState(),g="S",S=x.COMPAT}var k=y.__private__.combineFontStyleAndFontWeight=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&(t=400==e||"normal"===e?"italic"===t?"italic":"normal":700!=e&&"bold"!==e||"normal"!==t?(700==e?"bold":e)+""+t:"bold"),t};y.advancedAPI=function(t){var e=S===x.COMPAT;return e&&_.call(this),"function"!=typeof t||(t(this),e&&P.call(this)),this},y.compatAPI=function(t){var e=S===x.ADVANCED;return e&&P.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},y.isAdvancedAPI=function(){return S===x.ADVANCED};var O,q=function(t){if(S!==x.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},D=y.roundToPrecision=y.__private__.roundToPrecision=function(t,e){var n=r||e;if(isNaN(t)||isNaN(n))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(n).replace(/0+$/,"")};O=y.hpf=y.__private__.hpf="number"==typeof p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,p)}:"smart"===p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,16)};var R=y.f2=y.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return D(t,2)},T=y.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return D(t,3)},U=y.scale=y.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return S===x.COMPAT?t*_t:S===x.ADVANCED?t:void 0},z=function(t){return S===x.COMPAT?Rr()-t:S===x.ADVANCED?t:void 0},H=function(t){return U(z(t))};y.__private__.setPrecision=y.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(r=parseInt(t,10))};var W,V="00000000000000000000000000000000",G=y.__private__.getFileId=function(){return V},Y=y.__private__.setFileId=function(t){return V=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():V.split("").map((function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==m&&(Ye=new I(m.userPermissions,m.userPassword,m.ownerPassword,V)),V};y.setFileId=function(t){return Y(t),this},y.getFileId=function(){return G()};var J=y.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Q(n),"'",Q(i),"'"].join("");return["D:",t.getFullYear(),Q(t.getMonth()+1),Q(t.getDate()),Q(t.getHours()),Q(t.getMinutes()),Q(t.getSeconds()),a].join("")},X=y.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},K=y.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=J(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return W=e},Z=y.__private__.getCreationDate=function(t){var e=W;return"jsDate"===t&&(e=X(W)),e};y.setCreationDate=function(t){return K(t),this},y.getCreationDate=function(t){return Z(t)};var $,Q=y.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},tt=y.__private__.padd2Hex=function(t){return("00"+(t=t.toString())).substr(t.length)},et=0,rt=[],nt=[],it=0,at=[],ot=[],st=!1,ct=nt,ut=function(){et=0,it=0,nt=[],rt=[],at=[],Qt=Kt(),te=Kt()};y.__private__.setCustomOutputDestination=function(t){st=!0,ct=t};var ht=function(t){st||(ct=t)};y.__private__.resetCustomOutputDestination=function(){st=!1,ct=nt};var lt=y.__private__.out=function(t){return t=t.toString(),it+=t.length+1,ct.push(t),ct},ft=y.__private__.write=function(t){return lt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},dt=y.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},pt=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];y.__private__.getStandardFonts=function(){return pt};var gt=e.fontSize||16;y.__private__.setFontSize=y.setFontSize=function(t){return gt=S===x.ADVANCED?t/_t:t,this};var mt,vt=y.__private__.getFontSize=y.getFontSize=function(){return S===x.COMPAT?gt:gt*_t},bt=e.R2L||!1;y.__private__.setR2L=y.setR2L=function(t){return bt=t,this},y.__private__.getR2L=y.getR2L=function(){return bt};var yt,wt=y.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t))mt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');mt=t}else mt=parseInt(t,10)};y.__private__.getZoomMode=function(){return mt};var Nt,Lt=y.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');yt=t};y.__private__.getPageMode=function(){return yt};var At=y.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');Nt=t};y.__private__.getLayoutMode=function(){return Nt},y.__private__.setDisplayMode=y.setDisplayMode=function(t,e,r){return wt(t),At(e),Lt(r),this};var xt={title:"",subject:"",author:"",keywords:"",creator:""};y.__private__.getDocumentProperty=function(t){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return xt[t]},y.__private__.getDocumentProperties=function(){return xt},y.__private__.setDocumentProperties=y.setProperties=y.setDocumentProperties=function(t){for(var e in xt)xt.hasOwnProperty(e)&&t[e]&&(xt[e]=t[e]);return this},y.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return xt[t]=e};var St,_t,Pt,kt,It,Ft={},Ct={},jt=[],Ot={},Bt={},Mt={},Et={},qt=null,Dt=0,Rt=[],Tt=new C(y),Ut=e.hotfixes||[],zt={},Ht={},Wt=[],Vt=function t(e,r,n,i,a,o){if(!(this instanceof __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a))return new __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a(e,r,n,i,a,o);isNaN(e)&&(e=1),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(i)&&(i=1),isNaN(a)&&(a=0),isNaN(o)&&(o=0),this._matrix=[e,r,n,i,a,o]};Object.defineProperty(Vt.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Vt.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Vt.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Vt.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Vt.prototype.join=function(t){return[this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(O).join(t)},Vt.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Vt(e,r,n,i,a,o)},Vt.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var c=Math.sqrt(r*r+n*n);return s/=c,t*(n/=c)<e*(r/=c)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Vt(o,0,0,c,0,0),translate:new Vt(1,0,0,1,i,a),rotate:new Vt(t,e,-e,t,0,0),skew:new Vt(1,0,s,1,0,0)}},Vt.prototype.toString=function(t){return this.join(" ")},Vt.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,c=-e*o,u=-r*o,h=t*o;return new Vt(s,c,u,h,-s*i-u*a,-c*i-h*a)},Vt.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new Cr(e,r)},Vt.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new Cr(t.x+t.w,t.y+t.h));return new jr(e.x,e.y,r.x-e.x,r.y-e.y)},Vt.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Vt(t,e,r,n,i,a)},y.Matrix=Vt;var Gt=y.matrixMult=function(t,e){return e.multiply(t)},Yt=new Vt(1,0,0,1,0,0);y.unitMatrix=y.identityMatrix=Yt;var Jt=function(t,e){if(!Bt[t]){var r=(e instanceof B?"Sh":"P")+(Object.keys(Ot).length+1).toString(10);e.id=r,Bt[t]=r,Ot[r]=e,Tt.publish("addPattern",e)}};y.ShadingPattern=B,y.TilingPattern=M,y.addShadingPattern=function(t,e){return q("addShadingPattern()"),Jt(t,e),this},y.beginTilingPattern=function(t){q("beginTilingPattern()"),Br(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix)},y.endTilingPattern=function(t,e){q("endTilingPattern()"),e.stream=ot[$].join("\n"),Jt(t,e),Tt.publish("endTilingPattern",e),Wt.pop().restore()};var Xt=y.__private__.newObject=function(){var t=Kt();return Zt(t,!0),t},Kt=y.__private__.newObjectDeferred=function(){return et++,rt[et]=function(){return it},et},Zt=function(t,e){return e="boolean"==typeof e&&e,rt[t]=it,e&&lt(t+" 0 obj"),t},$t=y.__private__.newAdditionalObject=function(){var t={objId:Kt(),content:""};return at.push(t),t},Qt=Kt(),te=Kt(),ee=y.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"]}}else{var r=parseFloat(e[0]);e=[r,r,r,"r"]}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},re=y.__private__.encodeColorString=function(e){var r;"string"==typeof e&&(e={ch1:e});var n=e.ch1,i=e.ch2,a=e.ch3,o=e.ch4,s="draw"===e.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var c=new f(n);if(c.ok)n=c.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,i=u>>8&255,a=255&u}if(void 0===i||void 0===o&&n===i&&i===a)if("string"==typeof n)r=n+" "+s[0];else switch(e.precision){case 2:r=R(n/255)+" "+s[0];break;case 3:default:r=T(n/255)+" "+s[0]}else if(void 0===o||"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(o)){if(o&&!isNaN(o.a)&&0===o.a)return r=["1.","1.","1.",s[1]].join(" ");if("string"==typeof n)r=[n,i,a,s[1]].join(" ");else switch(e.precision){case 2:r=[R(n/255),R(i/255),R(a/255),s[1]].join(" ");break;default:case 3:r=[T(n/255),T(i/255),T(a/255),s[1]].join(" ")}}else if("string"==typeof n)r=[n,i,a,o,s[2]].join(" ");else switch(e.precision){case 2:r=[R(n),R(i),R(a),R(o),s[2]].join(" ");break;case 3:default:r=[T(n),T(i),T(a),T(o),s[2]].join(" ")}return r},ne=y.__private__.getFilters=function(){return u},ie=y.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ne(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==m&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==m&&(s=Ye.encryptor(o,0));var c={};!0===r&&(r=["FlateEncode"]);var u=t.additionalKeyValues||[],h=(c=void 0!==E.API.processDataByFilters?E.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==c.data.length&&(u.push({key:"Length",value:c.data.length}),!0===i&&u.push({key:"Length1",value:a})),0!=h.length)if(h.split("/").length-1==1)u.push({key:"Filter",value:h});else{u.push({key:"Filter",value:"["+h+"]"});for(var l=0;l<u.length;l+=1)if("DecodeParms"===u[l].key){for(var f=[],d=0;d<c.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(u[l].value),u[l].value="["+f.join(" ")+"]"}}lt("<<");for(var p=0;p<u.length;p++)lt("/"+u[p].key+" "+u[p].value);lt(">>"),0!==c.data.length&&(lt("stream"),lt(s(c.data)),lt("endstream"))},ae=y.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Zt(n,!0),lt("<</Type /Page"),lt("/Parent "+t.rootDictionaryObjId+" 0 R"),lt("/Resources "+t.resourceDictionaryObjId+" 0 R"),lt("/MediaBox ["+parseFloat(O(t.mediaBox.bottomLeftX))+" "+parseFloat(O(t.mediaBox.bottomLeftY))+" "+O(t.mediaBox.topRightX)+" "+O(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&lt("/CropBox ["+O(t.cropBox.bottomLeftX)+" "+O(t.cropBox.bottomLeftY)+" "+O(t.cropBox.topRightX)+" "+O(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&lt("/BleedBox ["+O(t.bleedBox.bottomLeftX)+" "+O(t.bleedBox.bottomLeftY)+" "+O(t.bleedBox.topRightX)+" "+O(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&lt("/TrimBox ["+O(t.trimBox.bottomLeftX)+" "+O(t.trimBox.bottomLeftY)+" "+O(t.trimBox.topRightX)+" "+O(t.trimBox.topRightY)+"]"),null!==t.artBox&&lt("/ArtBox ["+O(t.artBox.bottomLeftX)+" "+O(t.artBox.bottomLeftY)+" "+O(t.artBox.topRightX)+" "+O(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&lt("/UserUnit "+t.userUnit),Tt.publish("putPage",{objId:n,pageContext:Rt[e],pageNumber:e,page:r}),lt("/Contents "+i+" 0 R"),lt(">>"),lt("endobj");var a=r.join("\n");return S===x.ADVANCED&&(a+="\nQ"),Zt(i,!0),ie({data:a,filters:ne(),objectId:i}),lt("endobj"),n},oe=y.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Dt;t++)Rt[t].objId=Kt(),Rt[t].contentsObjId=Kt();for(t=1;t<=Dt;t++)r.push(ae({number:t,data:ot[t],objId:Rt[t].objId,contentsObjId:Rt[t].contentsObjId,mediaBox:Rt[t].mediaBox,cropBox:Rt[t].cropBox,bleedBox:Rt[t].bleedBox,trimBox:Rt[t].trimBox,artBox:Rt[t].artBox,userUnit:Rt[t].userUnit,rootDictionaryObjId:Qt,resourceDictionaryObjId:te}));Zt(Qt,!0),lt("<</Type /Pages");var n="/Kids [";for(e=0;e<Dt;e++)n+=r[e]+" 0 R ";lt(n+"]"),lt("/Count "+Dt),lt(">>"),lt("endobj"),Tt.publish("postPutPages")},se=function(t){Tt.publish("putFont",{font:t,out:lt,newObject:Xt,putStream:ie}),!0!==t.isAlreadyPutted&&(t.objectNumber=Xt(),lt("<<"),lt("/Type /Font"),lt("/BaseFont /"+F(t.postScriptName)),lt("/Subtype /Type1"),"string"==typeof t.encoding&&lt("/Encoding /"+t.encoding),lt("/FirstChar 32"),lt("/LastChar 255"),lt(">>"),lt("endobj"))},ce=function(){for(var t in Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&se(Ft[t])},ue=function(t){t.objectNumber=Xt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[O(t.x),O(t.y),O(t.x+t.width),O(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");ie({data:r,additionalKeyValues:e,objectId:t.objectNumber}),lt("endobj")},he=function(){for(var t in zt)zt.hasOwnProperty(t)&&ue(zt[t])},le=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a)}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o)}for(var s="",c=0,u=0;u<n.length;u++){for(r=n[u];r>t[c+1].offset;)c++;var h=t[c].offset,l=(r-h)/(t[c+1].offset-h),f=t[c].color,d=t[c+1].color;s+=tt(Math.round((1-l)*f[0]+l*d[0]).toString(16))+tt(Math.round((1-l)*f[1]+l*d[1]).toString(16))+tt(Math.round((1-l)*f[2]+l*d[2]).toString(16))}return s.trim()},fe=function(t,e){e||(e=21);var r=Xt(),n=le(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ie({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),lt("endobj"),t.objectNumber=Xt(),lt("<< /ShadingType "+t.type),lt("/ColorSpace /DeviceRGB");var a="/Coords ["+O(parseFloat(t.coords[0]))+" "+O(parseFloat(t.coords[1]))+" ";2===t.type?a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3])):a+=O(parseFloat(t.coords[2]))+" "+O(parseFloat(t.coords[3]))+" "+O(parseFloat(t.coords[4]))+" "+O(parseFloat(t.coords[5])),lt(a+="]"),t.matrix&&lt("/Matrix ["+t.matrix.toString()+"]"),lt("/Function "+r+" 0 R"),lt("/Extend [true true]"),lt(">>"),lt("endobj")},de=function(t,e){var r=Kt(),n=Xt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(O).join(" ")+"]"}),i.push({key:"XStep",value:O(t.xStep)}),i.push({key:"YStep",value:O(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ie({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),lt("endobj")},pe=function(t){var e;for(e in Ot)Ot.hasOwnProperty(e)&&(Ot[e]instanceof B?fe(Ot[e]):Ot[e]instanceof M&&de(Ot[e],t))},ge=function(t){for(var e in t.objectNumber=Xt(),lt("<<"),t)switch(e){case"opacity":lt("/ca "+R(t[e]));break;case"stroke-opacity":lt("/CA "+R(t[e]))}lt(">>"),lt("endobj")},me=function(){var t;for(t in Mt)Mt.hasOwnProperty(t)&&ge(Mt[t])},ve=function(){for(var t in lt("/XObject <<"),zt)zt.hasOwnProperty(t)&&zt[t].objectNumber>=0&&lt("/"+t+" "+zt[t].objectNumber+" 0 R");Tt.publish("putXobjectDict"),lt(">>")},be=function(){Ye.oid=Xt(),lt("<<"),lt("/Filter /Standard"),lt("/V "+Ye.v),lt("/R "+Ye.r),lt("/U <"+Ye.toHexString(Ye.U)+">"),lt("/O <"+Ye.toHexString(Ye.O)+">"),lt("/P "+Ye.P),lt(">>"),lt("endobj")},ye=function(){for(var t in lt("/Font <<"),Ft)Ft.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&lt("/"+t+" "+Ft[t].objectNumber+" 0 R");lt(">>")},we=function(){if(Object.keys(Ot).length>0){for(var t in lt("/Shading <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t]instanceof B&&Ot[t].objectNumber>=0&&lt("/"+t+" "+Ot[t].objectNumber+" 0 R");Tt.publish("putShadingPatternDict"),lt(">>")}},Ne=function(t){if(Object.keys(Ot).length>0){for(var e in lt("/Pattern <<"),Ot)Ot.hasOwnProperty(e)&&Ot[e]instanceof y.TilingPattern&&Ot[e].objectNumber>=0&&Ot[e].objectNumber<t&&lt("/"+e+" "+Ot[e].objectNumber+" 0 R");Tt.publish("putTilingPatternDict"),lt(">>")}},Le=function(){if(Object.keys(Mt).length>0){var t;for(t in lt("/ExtGState <<"),Mt)Mt.hasOwnProperty(t)&&Mt[t].objectNumber>=0&&lt("/"+t+" "+Mt[t].objectNumber+" 0 R");Tt.publish("putGStateDict"),lt(">>")}},Ae=function(t){Zt(t.resourcesOid,!0),lt("<<"),lt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ye(),we(),Ne(t.objectOid),Le(),ve(),lt(">>"),lt("endobj")},xe=function(){var t=[];ce(),me(),he(),pe(t),Tt.publish("putResources"),t.forEach(Ae),Ae({resourcesOid:te,objectOid:Number.MAX_SAFE_INTEGER}),Tt.publish("postPutResources")},Se=function(){Tt.publish("putAdditionalObjects");for(var t=0;t<at.length;t++){var e=at[t];Zt(e.objId,!0),lt(e.content),lt("endobj")}Tt.publish("postPutAdditionalObjects")},_e=function(t){Ct[t.fontName]=Ct[t.fontName]||{},Ct[t.fontName][t.fontStyle]=t.id},Pe=function(t,e,r,n,i){var a={id:"F"+(Object.keys(Ft).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Tt.publish("addFont",{font:a,instance:this}),Ft[a.id]=a,_e(a),a.id},ke=function(t){for(var e=0,r=pt.length;e<r;e++){var n=Pe.call(this,t[e][0],t[e][1],t[e][2],pt[e][3],!0);!1===v&&(b[n]=!0);var i=t[e][0].split("-");_e({id:n,fontName:i[0],fontStyle:i[1]||""})}Tt.publish("addFonts",{fonts:Ft,dictionary:Ct})},Ie=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var r="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!n.console)throw new Error(r);n.console.error(r,t),n.alert&&alert(r)}},t.foo.bar=t,t.foo},Fe=function(t,e){var r,n,i,a,o,s,c,u,h;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&Ft[St].metadata&&Ft[St].metadata[i]&&Ft[St].metadata[i].encoding&&(a=Ft[St].metadata[i].encoding,!o&&Ft[St].encoding&&(o=Ft[St].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(c=!1,s=[],r=0,n=t.length;r<n;r++)(u=o[t.charCodeAt(r)])?s.push(String.fromCharCode(u)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(r=t.length;void 0===c&&0!==r;)t.charCodeAt(r-1)>>8&&(c=!0),r--;if(!c)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((h=(u=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(h),s.push(u-(h<<8))}return String.fromCharCode.apply(void 0,s)},Ce=y.__private__.pdfEscape=y.pdfEscape=function(t,e){return Fe(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},je=y.__private__.beginPage=function(t){ot[++Dt]=[],Rt[Dt]={objId:0,contentsObjId:0,userUnit:Number(d),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Me(Dt),ht(ot[$])},Oe=function(t,e){var r,n,o;switch(i=e||i,"string"==typeof t&&(r=A(t.toLowerCase()),Array.isArray(r)&&(n=r[0],o=r[1])),Array.isArray(t)&&(n=t[0]*_t,o=t[1]*_t),isNaN(n)&&(n=s[0],o=s[1]),(n>14400||o>14400)&&(a.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),n=Math.min(14400,n),o=Math.min(14400,o)),s=[n,o],i.substr(0,1)){case"l":o>n&&(s=[o,n]);break;case"p":n>o&&(s=[o,n])}je(s),pr(fr),lt(Lr),0!==kr&&lt(kr+" J"),0!==Ir&&lt(Ir+" j"),Tt.publish("addPage",{pageNumber:Dt})},Be=function(t){t>0&&t<=Dt&&(ot.splice(t,1),Rt.splice(t,1),Dt--,$>Dt&&($=Dt),this.setPage($))},Me=function(t){t>0&&t<=Dt&&($=t)},Ee=y.__private__.getNumberOfPages=y.getNumberOfPages=function(){return ot.length-1},qe=function(t,e,r){var n,i=void 0;return r=r||{},t=void 0!==t?t:Ft[St].fontName,e=void 0!==e?e:Ft[St].fontStyle,n=t.toLowerCase(),void 0!==Ct[n]&&void 0!==Ct[n][e]?i=Ct[n][e]:void 0!==Ct[t]&&void 0!==Ct[t][e]?i=Ct[t][e]:!1===r.disableWarning&&a.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||r.noFallback||null==(i=Ct.times[e])&&(i=Ct.times.normal),i},De=y.__private__.putInfo=function(){var t=Xt(),e=function(t){return t};for(var r in null!==m&&(e=Ye.encryptor(t,0)),lt("<<"),lt("/Producer ("+Ce(e("jsPDF "+E.version))+")"),xt)xt.hasOwnProperty(r)&&xt[r]&&lt("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ce(e(xt[r]))+")");lt("/CreationDate ("+Ce(e(W))+")"),lt(">>"),lt("endobj")},Re=y.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Qt;switch(Xt(),lt("<<"),lt("/Type /Catalog"),lt("/Pages "+e+" 0 R"),mt||(mt="fullwidth"),mt){case"fullwidth":lt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":lt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":lt("/OpenAction [3 0 R /Fit]");break;case"original":lt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+mt;"%"===r.substr(r.length-1)&&(mt=parseInt(mt)/100),"number"==typeof mt&&lt("/OpenAction [3 0 R /XYZ null null "+R(mt)+"]")}switch(Nt||(Nt="continuous"),Nt){case"continuous":lt("/PageLayout /OneColumn");break;case"single":lt("/PageLayout /SinglePage");break;case"two":case"twoleft":lt("/PageLayout /TwoColumnLeft");break;case"tworight":lt("/PageLayout /TwoColumnRight")}yt&&lt("/PageMode /"+yt),Tt.publish("putCatalog"),lt(">>"),lt("endobj")},Te=y.__private__.putTrailer=function(){lt("trailer"),lt("<<"),lt("/Size "+(et+1)),lt("/Root "+et+" 0 R"),lt("/Info "+(et-1)+" 0 R"),null!==m&&lt("/Encrypt "+Ye.oid+" 0 R"),lt("/ID [ <"+V+"> <"+V+"> ]"),lt(">>")},Ue=y.__private__.putHeader=function(){lt("%PDF-"+w),lt("%ºß¬à")},ze=y.__private__.putXRef=function(){var t="0000000000";lt("xref"),lt("0 "+(et+1)),lt("0000000000 65535 f ");for(var e=1;e<=et;e++){"function"==typeof rt[e]?lt((t+rt[e]()).slice(-10)+" 00000 n "):void 0!==rt[e]?lt((t+rt[e]).slice(-10)+" 00000 n "):lt("0000000000 00000 n ")}},He=y.__private__.buildDocument=function(){ut(),ht(nt),Tt.publish("buildDocument"),Ue(),oe(),Se(),xe(),null!==m&&be(),De(),Re();var t=it;return ze(),Te(),lt("startxref"),lt(""+t),lt("%%EOF"),ht(ot[$]),nt.join("\n")},We=y.__private__.getBlob=function(t){return new Blob([dt(t)],{type:"application/pdf"})},Ve=y.output=y.__private__.output=Ie((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return He();case"save":y.save(e.filename);break;case"arraybuffer":return dt(He());case"blob":return We(He());case"bloburi":case"bloburl":if(void 0!==n.URL&&"function"==typeof n.URL.createObjectURL)return n.URL&&n.URL.createObjectURL(We(He()))||void 0;a.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var r="",i=He();try{r=h(i)}catch(t){r=h(unescape(encodeURIComponent(i)))}return"data:application/pdf;filename="+e.filename+";base64,"+r;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var o="https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",s=' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';e.pdfObjectUrl&&(o=e.pdfObjectUrl,s="");var c='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+o+'"'+s+'><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",u=n.open();return null!==u&&u.document.write(c),u}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(n)){var l='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',f=n.open();if(null!==f){f.document.write(l);var d=this;f.document.documentElement.querySelector("#pdfViewer").onload=function(){f.document.title=e.filename,f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"))}}return f}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(n))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var p='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',g=n.open();if(null!==g&&(g.document.write(p),g.document.title=e.filename),g||"undefined"==typeof safari)return g;break;case"datauri":case"dataurl":return n.document.location.href=this.output("datauristring",e);default:return null}})),Ge=function(t){return!0===Array.isArray(Ut)&&Ut.indexOf(t)>-1};switch(o){case"pt":_t=1;break;case"mm":_t=72/25.4;break;case"cm":_t=72/2.54;break;case"in":_t=72;break;case"px":_t=1==Ge("px_scaling")?.75:96/72;break;case"pc":case"em":_t=12;break;case"ex":_t=6;break;default:if("number"!=typeof o)throw new Error("Invalid unit: "+o);_t=o}var Ye=null;K(),Y();var Je=function(t){return null!==m?Ye.encryptor(t,0):function(t){return t}},Xe=y.__private__.getPageInfo=y.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:Rt[t].objId,pageNumber:t,pageContext:Rt[t]}},Ke=y.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Rt)if(Rt[e].objId===t)break;return Xe(e)},Ze=y.__private__.getCurrentPageInfo=y.getCurrentPageInfo=function(){return{objId:Rt[$].objId,pageNumber:$,pageContext:Rt[$]}};y.addPage=function(){return Oe.apply(this,arguments),this},y.setPage=function(){return Me.apply(this,arguments),ht.call(this,ot[$]),this},y.insertPage=function(t){return this.addPage(),this.movePage($,t),this},y.movePage=function(t,e){var r,n;if(t>e){r=ot[t],n=Rt[t];for(var i=t;i>e;i--)ot[i]=ot[i-1],Rt[i]=Rt[i-1];ot[e]=r,Rt[e]=n,this.setPage(e)}else if(t<e){r=ot[t],n=Rt[t];for(var a=t;a<e;a++)ot[a]=ot[a+1],Rt[a]=Rt[a+1];ot[e]=r,Rt[e]=n,this.setPage(e)}return this},y.deletePage=function(){return Be.apply(this,arguments),this},y.__private__.text=y.text=function(e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g=(i=i||{}).scope||this;if("number"==typeof e&&"number"==typeof r&&("string"==typeof n||Array.isArray(n))){var m=n;n=r,r=e,e=m}if(arguments[3]instanceof Vt==!1?(c=arguments[4],u=arguments[5],"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(f=arguments[3])&&null!==f||("string"==typeof c&&(u=c,c=null),"string"==typeof f&&(u=f,f=null),"number"==typeof f&&(c=f,f=null),i={flags:f,angle:c,align:u})):(q("The transform parameter of text() with a Matrix value"),p=a),isNaN(r)||isNaN(n)||null==e)throw new Error("Invalid arguments passed to jsPDF.text");if(0===e.length)return g;var v="",y=!1,w="number"==typeof i.lineHeightFactor?i.lineHeightFactor:lr,N=g.internal.scaleFactor;function L(t){return t=t.split("\t").join(Array(i.TabLen||9).join(" ")),Ce(t,f)}function A(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function _(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o}return r}var P=!1,k=!0;if("string"==typeof e)P=!0;else if(Array.isArray(e)){var I=e.concat();s=[];for(var F,C=I.length;C--;)("string"!=typeof(F=I.shift())||Array.isArray(F)&&"string"!=typeof F[0])&&(k=!1);P=k}if(!1===P)throw new Error('Type of text must be string or Array. "'+e+'" is not recognized.');"string"==typeof e&&(e=e.match(/[\r?\n]/)?e.split(/\r\n|\r|\n/g):[e]);var j=gt/g.internal.scaleFactor,B=j*(w-1);switch(i.baseline){case"bottom":n-=B;break;case"top":n+=j-B;break;case"hanging":n+=j-2*B;break;case"middle":n+=j/2-B}if((l=i.maxWidth||0)>0&&("string"==typeof e?e=g.splitTextToSize(e,l):"[object Array]"===Object.prototype.toString.call(e)&&(e=e.reduce((function(t,e){return t.concat(g.splitTextToSize(e,l))}),[]))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("preProcessText",o),e=o.text,c=(i=o.options).angle,p instanceof Vt==!1&&c&&"number"==typeof c){c*=Math.PI/180,0===i.rotationDirection&&(c=-c),S===x.ADVANCED&&(c=-c);var M=Math.cos(c),E=Math.sin(c);p=new Vt(M,E,-E,M,0,0)}else c&&c instanceof Vt&&(p=c);S!==x.ADVANCED||p||(p=Yt),void 0!==(h=i.charSpace||_r)&&(v+=O(U(h))+" Tc\n",this.setCharSpace(this.getCharSpace()||0)),void 0!==(d=i.horizontalScale)&&(v+=O(100*d)+" Tz\n");i.lang;var D=-1,R=void 0!==i.renderingMode?i.renderingMode:i.stroke,T=g.internal.getCurrentPageInfo().pageContext;switch(R){case 0:case!1:case"fill":D=0;break;case 1:case!0:case"stroke":D=1;break;case 2:case"fillThenStroke":D=2;break;case 3:case"invisible":D=3;break;case 4:case"fillAndAddForClipping":D=4;break;case 5:case"strokeAndAddPathForClipping":D=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":D=6;break;case 7:case"addToPathForClipping":D=7}var z=void 0!==T.usedRenderingMode?T.usedRenderingMode:-1;-1!==D?v+=D+" Tr\n":-1!==z&&(v+="0 Tr\n"),-1!==D&&(T.usedRenderingMode=D),u=i.align||"left";var H,W=gt*w,V=g.internal.pageSize.getWidth(),G=Ft[St];h=i.charSpace||_r,l=i.maxWidth||0,f=Object.assign({autoencode:!0,noBOM:!0},i.flags);var Y=[];if("[object Array]"===Object.prototype.toString.call(e)){var J;s=A(e),"left"!==u&&(H=s.map((function(t){return g.getStringUnitWidth(t,{font:G,charSpace:h,fontSize:gt,doKerning:!1})*gt/N})));var X,K=0;if("right"===u){r-=H[0],e=[],C=s.length;for(var Z=0;Z<C;Z++)0===Z?(X=br(r),J=yr(n)):(X=U(K-H[Z]),J=-W),e.push([s[Z],X,J]),K=H[Z]}else if("center"===u){r-=H[0]/2,e=[],C=s.length;for(var $=0;$<C;$++)0===$?(X=br(r),J=yr(n)):(X=U((K-H[$])/2),J=-W),e.push([s[$],X,J]),K=H[$]}else if("left"===u){e=[],C=s.length;for(var Q=0;Q<C;Q++)e.push(s[Q])}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');e=[],C=s.length,l=0!==l?l:V;for(var tt=0;tt<C;tt++)J=0===tt?yr(n):-W,X=0===tt?br(r):0,tt<C-1?Y.push(O(U((l-H[tt])/(s[tt].split(" ").length-1)))):Y.push(0),e.push([s[tt],X,J])}}var et="boolean"==typeof i.R2L?i.R2L:bt;!0===et&&(e=_(e,(function(t,e,r){return[t.split("").reverse().join(""),e,r]}))),o={text:e,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:Ft,activeFontSize:gt}},Tt.publish("postProcessText",o),e=o.text,y=o.mutex.isHex||!1;var rt=Ft[St].encoding;"WinAnsiEncoding"!==rt&&"StandardEncoding"!==rt||(e=_(e,(function(t,e,r){return[L(t),e,r]}))),s=A(e),e=[];for(var nt,it,at,ot=0,st=1,ct=Array.isArray(s[0])?st:ot,ut="",ht=function(t,e,r){var n="";return r instanceof Vt?(r="number"==typeof i.angle?Gt(r,new Vt(1,0,0,1,t,e)):Gt(new Vt(1,0,0,1,t,e),r),S===x.ADVANCED&&(r=Gt(new Vt(1,0,0,-1,0,0),r)),n=r.join(" ")+" Tm\n"):n=O(t)+" "+O(e)+" Td\n",n},ft=0;ft<s.length;ft++){switch(ut="",ct){case st:at=(y?"<":"(")+s[ft][0]+(y?">":")"),nt=parseFloat(s[ft][1]),it=parseFloat(s[ft][2]);break;case ot:at=(y?"<":"(")+s[ft]+(y?">":")"),nt=br(r),it=yr(n)}void 0!==Y&&void 0!==Y[ft]&&(ut=Y[ft]+" Tw\n"),0===ft?e.push(ut+ht(nt,it,p)+at):ct===ot?e.push(ut+at):ct===st&&e.push(ut+ht(nt,it,p)+at)}e=ct===ot?e.join(" Tj\nT* "):e.join(" Tj\n"),e+=" Tj\n";var dt="BT\n/";return dt+=St+" "+gt+" Tf\n",dt+=O(gt*w)+" TL\n",dt+=xr+"\n",dt+=v,dt+=e,lt(dt+="ET"),b[St]=!0,g};var $e=y.__private__.clip=y.clip=function(t){return lt("evenodd"===t?"W*":"W"),this};y.clipEvenOdd=function(){return $e("evenodd")},y.__private__.discardPath=y.discardPath=function(){return lt("n"),this};var Qe=y.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};y.__private__.setDefaultPathOperation=y.setDefaultPathOperation=function(t){return Qe(t)&&(g=t),this};var tr=y.__private__.getStyle=y.getStyle=function(t){var e=g;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t}return e},er=y.close=function(){return lt("h"),this};y.stroke=function(){return lt("S"),this},y.fill=function(t){return rr("f",t),this},y.fillEvenOdd=function(t){return rr("f*",t),this},y.fillStroke=function(t){return rr("B",t),this},y.fillStrokeEvenOdd=function(t){return rr("B*",t),this};var rr=function(e,r){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)?ar(r,e):lt(e)},nr=function(t){null===t||S===x.ADVANCED&&void 0===t||(t=tr(t),lt(t))};function ir(t,e,r,n,i){var a=new M(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Jt(o,a),a}var ar=function(t,e){var r=Bt[t.key],n=Ot[r];if(n instanceof B)lt("q"),lt(or(e)),n.gState&&y.setGState(n.gState),lt(t.matrix.toString()+" cm"),lt("/"+r+" sh"),lt("Q");else if(n instanceof M){var i=new Vt(1,0,0,-1,0,Rr());t.matrix&&(i=i.multiply(t.matrix||Yt),r=ir.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),lt("q"),lt("/Pattern cs"),lt("/"+r+" scn"),n.gState&&y.setGState(n.gState),lt(e),lt("Q")}},or=function(t){switch(t){case"f":case"F":return"W n";case"f*":return"W* n";case"B":return"W S";case"B*":return"W* S";case"S":return"W S";case"n":return"W n"}},sr=y.moveTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" m"),this},cr=y.lineTo=function(t,e){return lt(O(U(t))+" "+O(H(e))+" l"),this},ur=y.curveTo=function(t,e,r,n,i,a){return lt([O(U(t)),O(H(e)),O(U(r)),O(H(n)),O(U(i)),O(H(a)),"c"].join(" ")),this};y.__private__.line=y.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.line");return S===x.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},y.__private__.lines=y.lines=function(t,e,r,n,i,a){var o,s,c,u,h,l,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Qe(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(sr(e,r),o=n[0],s=n[1],u=t.length,g=e,m=r,c=0;c<u;c++)2===(h=t[c]).length?(g=h[0]*o+g,m=h[1]*s+m,cr(g,m)):(l=h[0]*o+g,f=h[1]*s+m,d=h[2]*o+g,p=h[3]*s+m,g=h[4]*o+g,m=h[5]*s+m,ur(l,f,d,p,g,m));return a&&er(),nr(i),this},y.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":sr(n[0],n[1]);break;case"l":cr(n[0],n[1]);break;case"c":ur.apply(this,n);break;case"h":er()}}return this},y.__private__.rect=y.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.rect");return S===x.COMPAT&&(n=-n),lt([O(U(t)),O(H(e)),O(U(r)),O(U(n)),"re"].join(" ")),nr(i),this},y.__private__.triangle=y.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},y.__private__.roundedRect=y.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},y.__private__.ellipse=y.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return sr(t+r,e),ur(t+r,e-o,t+a,e-n,t,e-n),ur(t-a,e-n,t-r,e-o,t-r,e),ur(t-r,e+o,t-a,e+n,t,e+n),ur(t+a,e+n,t+r,e+o,t+r,e),nr(i),this},y.__private__.circle=y.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Qe(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},y.setFont=function(t,e,r){return r&&(e=k(e,r)),St=qe(t,e,{disableWarning:!1}),this};var hr=y.__private__.getFont=y.getFont=function(){return Ft[qe.apply(y,arguments)]};y.__private__.getFontList=y.getFontList=function(){var t,e,r={};for(t in Ct)if(Ct.hasOwnProperty(t))for(e in r[t]=[],Ct[t])Ct[t].hasOwnProperty(e)&&r[t].push(e);return r},y.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=k(r,n)),i=i||"Identity-H",Pe.call(this,t,e,r,i)};var lr,fr=e.lineWidth||.200025,dr=y.__private__.getLineWidth=y.getLineWidth=function(){return fr},pr=y.__private__.setLineWidth=y.setLineWidth=function(t){return fr=t,lt(O(U(t))+" w"),this};y.__private__.setLineDash=E.API.setLineDash=E.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return O(U(t))})).join(" "),e=O(U(e)),lt("["+t+"] "+e+" d"),this};var gr=y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};y.__private__.getLineHeight=y.getLineHeight=function(){return gt*lr};var mr=y.__private__.setLineHeightFactor=y.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(lr=t),this},vr=y.__private__.getLineHeightFactor=y.getLineHeightFactor=function(){return lr};mr(e.lineHeight);var br=y.__private__.getHorizontalCoordinate=function(t){return U(t)},yr=y.__private__.getVerticalCoordinate=function(t){return S===x.ADVANCED?t:Rt[$].mediaBox.topRightY-Rt[$].mediaBox.bottomLeftY-U(t)},wr=y.__private__.getHorizontalCoordinateString=y.getHorizontalCoordinateString=function(t){return O(br(t))},Nr=y.__private__.getVerticalCoordinateString=y.getVerticalCoordinateString=function(t){return O(yr(t))},Lr=e.strokeColor||"0 G";y.__private__.getStrokeColor=y.getDrawColor=function(){return ee(Lr)},y.__private__.setStrokeColor=y.setDrawColor=function(t,e,r,n){return Lr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),lt(Lr),this};var Ar=e.fillColor||"0 g";y.__private__.getFillColor=y.getFillColor=function(){return ee(Ar)},y.__private__.setFillColor=y.setFillColor=function(t,e,r,n){return Ar=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),lt(Ar),this};var xr=e.textColor||"0 g",Sr=y.__private__.getTextColor=y.getTextColor=function(){return ee(xr)};y.__private__.setTextColor=y.setTextColor=function(t,e,r,n){return xr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var _r=e.charSpace,Pr=y.__private__.getCharSpace=y.getCharSpace=function(){return parseFloat(_r||0)};y.__private__.setCharSpace=y.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return _r=t,this};var kr=0;y.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},y.__private__.setLineCap=y.setLineCap=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return kr=e,lt(e+" J"),this};var Ir=0;y.__private__.setLineJoin=y.setLineJoin=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Ir=e,lt(e+" j"),this},y.__private__.setLineMiterLimit=y.__private__.setMiterLimit=y.setLineMiterLimit=y.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return lt(O(U(t))+" M"),this},y.GState=j,y.setGState=function(t){(t="string"==typeof t?Mt[Et[t]]:Fr(null,t)).equals(qt)||(lt("/"+t.id+" gs"),qt=t)};var Fr=function(t,e){if(!t||!Et[t]){var r=!1;for(var n in Mt)if(Mt.hasOwnProperty(n)&&Mt[n].equals(e)){r=!0;break}if(r)e=Mt[n];else{var i="GS"+(Object.keys(Mt).length+1).toString(10);Mt[i]=e,e.id=i}return t&&(Et[t]=e.id),Tt.publish("addGState",e),e}};y.addGState=function(t,e){return Fr(t,e),this},y.saveGraphicsState=function(){return lt("q"),jt.push({key:St,size:gt,color:xr}),this},y.restoreGraphicsState=function(){lt("Q");var t=jt.pop();return St=t.key,gt=t.size,xr=t.color,qt=null,this},y.setCurrentTransformationMatrix=function(t){return lt(t.toString()+" cm"),this},y.comment=function(t){return lt("#"+t),this};var Cr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},jr=function(t,e,r,n){Cr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t))}}),this},Or=function(){this.page=Dt,this.currentPage=$,this.pages=ot.slice(0),this.pagesContext=Rt.slice(0),this.x=Pt,this.y=kt,this.matrix=It,this.width=qr($),this.height=Rr($),this.outputDestination=ct,this.id="",this.objectNumber=-1};Or.prototype.restore=function(){Dt=this.page,$=this.currentPage,Rt=this.pagesContext,ot=this.pages,Pt=this.x,kt=this.y,It=this.matrix,Dr($,this.width),Tr($,this.height),ct=this.outputDestination};var Br=function(t,e,r,n,i){Wt.push(new Or),Dt=$=0,ot=[],Pt=t,kt=e,It=i,je([r,n])},Mr=function(t){if(Ht[t])Wt.pop().restore();else{var e=new Or,r="Xo"+(Object.keys(zt).length+1).toString(10);e.id=r,Ht[t]=r,zt[r]=e,Tt.publish("addFormObject",e),Wt.pop().restore()}};for(var Er in y.beginFormObject=function(t,e,r,n,i){return Br(t,e,r,n,i),this},y.endFormObject=function(t){return Mr(t),this},y.doFormObject=function(t,e){var r=zt[Ht[t]];return lt("q"),lt(e.toString()+" cm"),lt("/"+r.id+" Do"),lt("Q"),this},y.getFormObject=function(t){var e=zt[Ht[t]];return{x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},y.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(We(He()),t),"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,r){try{var i=l(We(He()),t);"function"==typeof l.unload&&n.setTimeout&&setTimeout(l.unload,911),e(i)}catch(t){r(t.message)}}))},E.API)E.API.hasOwnProperty(Er)&&("events"===Er&&E.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n))}(Tt,E.API.events):y[Er]=E.API[Er]);var qr=y.getPageWidth=function(t){return(Rt[t=t||$].mediaBox.topRightX-Rt[t].mediaBox.bottomLeftX)/_t},Dr=y.setPageWidth=function(t,e){Rt[t].mediaBox.topRightX=e*_t+Rt[t].mediaBox.bottomLeftX},Rr=y.getPageHeight=function(t){return(Rt[t=t||$].mediaBox.topRightY-Rt[t].mediaBox.bottomLeftY)/_t},Tr=y.setPageHeight=function(t,e){Rt[t].mediaBox.topRightY=e*_t+Rt[t].mediaBox.bottomLeftY};return y.internal={pdfEscape:Ce,getStyle:tr,getFont:hr,getFontSize:vt,getCharSpace:Pr,getTextColor:Sr,getLineHeight:gr,getLineHeightFactor:vr,getLineWidth:dr,write:ft,getHorizontalCoordinate:br,getVerticalCoordinate:yr,getCoordinateString:wr,getVerticalCoordinateString:Nr,collections:{},newObject:Xt,newAdditionalObject:$t,newObjectDeferred:Kt,newObjectDeferredBegin:Zt,getFilters:ne,putStream:ie,events:Tt,scaleFactor:_t,pageSize:{getWidth:function(){return qr($)},setWidth:function(t){Dr($,t)},getHeight:function(){return Rr($)},setHeight:function(t){Tr($,t)}},encryptionOptions:m,encryption:Ye,getEncryptor:Je,output:Ve,getNumberOfPages:Ee,pages:ot,out:lt,f2:R,f3:T,getPageInfo:Xe,getPageInfoByObjId:Ke,getCurrentPageInfo:Ze,getPDFVersion:N,Point:Cr,Rectangle:jr,Matrix:Vt,hasHotfix:Ge},Object.defineProperty(y.internal.pageSize,"width",{get:function(){return qr($)},set:function(t){Dr($,t)},enumerable:!0,configurable:!0}),Object.defineProperty(y.internal.pageSize,"height",{get:function(){return Rr($)},set:function(t){Tr($,t)},enumerable:!0,configurable:!0}),ke.call(y,pt),St="F1",Oe(s,i),Tt.publish("initialized"),y}I.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},I.prototype.toHexString=function(t){return t.split("").map((function(t){return("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},I.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},I.prototype.processOwnerPassword=function(t,e){return P(x(e).substr(0,5),t)},I.prototype.encryptor=function(t,e){var r=x(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return P(r,t)}},j.prototype.equals=function(e){var r,n="id,objectNumber,equals";if(!e||__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(this))return!1;var i=0;for(r in this)if(!(n.indexOf(r)>=0)){if(this.hasOwnProperty(r)&&!e.hasOwnProperty(r))return!1;if(this[r]!==e[r])return!1;i++}for(r in e)e.hasOwnProperty(r)&&n.indexOf(r)<0&&i--;return 0===i},E.API={events:[]},E.version="2.5.1";var q=E.API,D=1,R=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},T=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},U=function(t){return t.toFixed(2)},z=function(t){return t.toFixed(5)};q.__acroform__={};var H=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},W=function(t){return t*D},V=function(t){var e=new ut,r=At.internal.getHeight(t)||0,n=At.internal.getWidth(t)||0;return e.BBox=[0,0,Number(U(n)),Number(U(r))],e},G=q.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},Y=q.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},J=q.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},X=q.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return J(t,e-1)},K=q.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return G(t,e-1)},Z=q.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return Y(t,e-1)},$=q.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],c={};return c.lowerLeft_X=r(i)||0,c.lowerLeft_Y=n(a+s)||0,c.upperRight_X=r(i+o)||0,c.upperRight_Y=n(a)||0,[Number(U(c.lowerLeft_X)),Number(U(c.lowerLeft_Y)),Number(U(c.upperRight_X)),Number(U(c.upperRight_Y))]},Q=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=tt(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+U(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=V(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},tt=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" ");i=t.multiline?i.map((function(t){return t.split("\n")})):i.map((function(t){return[t]}));var a=r,o=At.internal.getHeight(t)||0;o=o<0?-o:o;var s=At.internal.getWidth(t)||0;s=s<0?-s:s;var c=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1][0];return et(a,t,n).width<=s-4}return!1};a++;t:for(;a>0;){e="",a--;var u,h,l=et("3",t,a).height,f=t.multiline?o-a:(o-l)/2,d=f+=2,p=0,g=0,m=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+et(e,t,a=12).width+", FieldWidth:"+s+"\n";break}for(var v="",b=0,y=0;y<i.length;y++)if(i.hasOwnProperty(y)){var w=!1;if(1!==i[y].length&&m!==i[y].length-1){if((l+2)*(b+2)+2>o)continue t;v+=i[y][m],w=!0,g=y,y--}else{v=" "==(v+=i[y][m]+" ").substr(v.length-1)?v.substr(0,v.length-1):v;var N=parseInt(y),L=c(N,v,a),A=y>=i.length-1;if(L&&!A){v+=" ",m=0;continue}if(L||A){if(A)g=N;else if(t.multiline&&(l+2)*(b+2)+2>o)continue t}else{if(!t.multiline)continue t;if((l+2)*(b+2)+2>o)continue t;g=N}}for(var x="",S=p;S<=g;S++){var _=i[S];if(t.multiline){if(S===g){x+=_[m]+" ",m=(m+1)%_.length;continue}if(S===p){x+=_[_.length-1]+" ";continue}}x+=_[0]+" "}switch(x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x,h=et(x,t,a).width,t.textAlign){case"right":u=s-h-2;break;case"center":u=(s-h)/2;break;case"left":default:u=2}e+=U(u)+" "+U(d)+" Td\n",e+="("+R(x)+") Tj\n",e+=-U(u)+" 0 Td\n",d=-(a+2),h=0,p=w?g:g+1,b++,v=""}else;break}return n.text=e,n.fontSize=a,n},et=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return{height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},rt={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},nt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r)},it=function(e,r){for(var n in e)if(e.hasOwnProperty(n)){var i=n,a=e[n];r.internal.newObjectDeferredBegin(a.objId,!0),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(a)&&"function"==typeof a.putStream&&a.putStream(),delete e[i]}},at=function(e,r){if(r.scope=e,void 0!==e.internal&&(void 0===e.internal.acroformPlugin||!1===e.internal.acroformPlugin.isInitialized)){if(lt.FieldNum=0,e.internal.acroformPlugin=JSON.parse(JSON.stringify(rt)),e.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");D=e.internal.scaleFactor,e.internal.acroformPlugin.acroFormDictionaryRoot=new ht,e.internal.acroformPlugin.acroFormDictionaryRoot.scope=e,e.internal.acroformPlugin.acroFormDictionaryRoot._eventID=e.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0}(e)})),e.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&nt(n,t)}}(e)})),e.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")}(e)})),e.internal.events.subscribe("postPutPages",(function(r){!function(e,r){var n=!e;for(var i in e||(r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),e=e||r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(e.hasOwnProperty(i)){var a=e[i],o=[],s=a.Rect;if(a.Rect&&(a.Rect=$(a.Rect,r)),r.internal.newObjectDeferredBegin(a.objId,!0),a.DA=At.createDefaultAppearanceStream(a),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(a)&&"function"==typeof a.getKeyValueListForStream&&(o=a.getKeyValueListForStream()),a.Rect=s,a.hasAppearanceStream&&!a.appearanceStreamContent){var c=Q(a);o.push({key:"AP",value:"<</N "+c+">>"}),r.internal.acroformPlugin.xForms.push(c)}if(a.appearanceStreamContent){var u="";for(var h in a.appearanceStreamContent)if(a.appearanceStreamContent.hasOwnProperty(h)){var l=a.appearanceStreamContent[h];if(u+="/"+h+" ",u+="<<",Object.keys(l).length>=1||Array.isArray(l)){for(var i in l)if(l.hasOwnProperty(i)){var f=l[i];"function"==typeof f&&(f=f.call(r,a)),u+="/"+i+" "+f+" ",r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f)}}else"function"==typeof(f=l)&&(f=f.call(r,a)),u+="/"+i+" "+f,r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);u+=">>"}o.push({key:"AP",value:"<<\n"+u+">>"})}r.internal.putStream({additionalKeyValues:o,objectId:a.objId}),r.internal.out("endobj")}n&&it(r.internal.acroformPlugin.xForms,r)}(r,e)})),e.internal.acroformPlugin.isInitialized=!0}},ot=q.__acroform__.arrayToPdfArray=function(e,r,n){var i=function(t){return t};if(Array.isArray(e)){for(var a="[",o=0;o<e.length;o++)switch(0!==o&&(a+=" "),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e[o])){case"boolean":case"number":case"object":a+=e[o].toString();break;case"string":"/"!==e[o].substr(0,1)?(void 0!==r&&n&&(i=n.internal.getEncryptor(r)),a+="("+R(i(e[o].toString()))+")"):a+=e[o].toString()}return a+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var st=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+R(n(t))+")"},ct=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred()}return this._objId},set:function(t){this._objId=t}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0})};ct.prototype.toString=function(){return this.objId+" 0 R"},ct.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj")},ct.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:ot(i,this.objId,this.scope)}):i instanceof ct?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}))}return t};var ut=function(){ct.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim()},get:function(){return t||null}})};H(ut,ct);var ht=function(){ct.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(t))+")"}},set:function(e){t=e}})};H(ht,ct);var lt=function t(){ct.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(e,3))},set:function(t){!0===Boolean(t)?this.F=K(e,3):this.F=Z(e,3)}});var r=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');r=t}});var n=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==n.length)return n},set:function(t){n=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[0])?0:n[0]},set:function(t){n[0]=t}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[1])?0:n[1]},set:function(t){n[1]=t}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[2])?0:n[2]},set:function(t){n[2]=t}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[3])?0:n[3]},set:function(t){n[3]=t}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof yt)return;a="FieldObject"+__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.FieldNum++}var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+R(e(a))+")"},set:function(t){a=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var c=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/D:u},set:function(t){u=t}});var h="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return h},set:function(t){h=t}});var l="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!l||this instanceof yt||this instanceof Nt))return st(l,this.objId,this.scope)},set:function(t){t=t.toString(),l=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof mt==!1?st(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof mt==!0?"/"+t:t}});var d=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(d)return d},set:function(t){this.V=t}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof mt==!1?st(d,this.objId,this.scope):d},set:function(t){t=t.toString(),d=this instanceof mt==!1?"("===t.substr(0,1)?T(t.substr(1,t.length-2)):T(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof mt==!0?T(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof mt==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(p)return p},set:function(t){p=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,1):this.Ff=Z(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,2):this.Ff=Z(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,3):this.Ff=Z(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};H(lt,ct);var ft=function(){lt.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return ot(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort()},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort()},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,18):this.Ff=Z(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=K(this.Ff,19):this.Ff=Z(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=K(this.Ff,20),e.sort()):this.Ff=Z(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,22):this.Ff=Z(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,27):this.Ff=Z(this.Ff,27)}}),this.hasAppearanceStream=!1};H(ft,lt);var dt=function(){ft.call(this),this.fontName="helvetica",this.combo=!1};H(dt,ft);var pt=function(){dt.call(this),this.combo=!0};H(pt,dt);var gt=function(){pt.call(this),this.edit=!0};H(gt,pt);var mt=function(){lt.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,15):this.Ff=Z(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,16):this.Ff=Z(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,17):this.Ff=Z(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26)}});var e,r={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(r).length){var e,n=[];for(e in n.push("<<"),r)n.push("/"+e+" ("+R(t(r[e]))+")");return n.push(">>"),n.join("\n")}},set:function(e){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=e)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return r.CA||""},set:function(t){"string"==typeof t&&(r.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};H(mt,lt);var vt=function(){mt.call(this),this.pushButton=!0};H(vt,mt);var bt=function(){mt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[]}})};H(bt,mt);var yt=function(){var e,r;lt.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return r},set:function(t){r=t}});var n,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),i)r.push("/"+e+" ("+R(t(i[e]))+")");return r.push(">>"),r.join("\n")},set:function(e){"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(i=e)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return n.substr(1,n.length-1)},set:function(t){n="/"+t}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=At.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName)};H(yt,lt),bt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA()}},bt.prototype.createOption=function(t){var e=new yt;return e.Parent=this,e.optionName=t,this.Kids.push(e),xt.call(this.scope,e),e};var wt=function(){mt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=At.CheckBox.createAppearanceStream()};H(wt,mt);var Nt=function(){lt.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,13):this.Ff=Z(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,21):this.Ff=Z(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,23):this.Ff=Z(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,24):this.Ff=Z(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,25):this.Ff=Z(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,26):this.Ff=Z(this.Ff,26)}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};H(Nt,lt);var Lt=function(){Nt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(X(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=K(this.Ff,14):this.Ff=Z(this.Ff,14)}}),this.password=!0};H(Lt,Nt);var At={CheckBox:{createAppearanceStream:function(){return{N:{On:At.CheckBox.YesNormal},D:{On:At.CheckBox.YesPushDown,Off:At.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=tt(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+U(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=At.internal.getHeight(t),o=At.internal.getWidth(t),s=tt(t,t.caption);return i.push("1 g"),i.push("0 0 "+U(o)+" "+U(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+U(o-1)+" "+U(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+U(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Circle.YesNormal,e.D[t]=At.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=At.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5)),o=Number((n*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.getWidth(t)<=At.internal.getHeight(t)?At.internal.getWidth(t)/4:At.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*At.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+z(At.internal.getWidth(t)/2)+" "+z(At.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:At.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=At.RadioButton.Cross.YesNormal,e.D[t]=At.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=V(t);e.scope=t.scope;var r=[],n=At.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(U(n.x1.x)+" "+U(n.x1.y)+" m"),r.push(U(n.x2.x)+" "+U(n.x2.y)+" l"),r.push(U(n.x4.x)+" "+U(n.x4.y)+" m"),r.push(U(n.x3.x)+" "+U(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=V(t);e.scope=t.scope;var r=At.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+U(At.internal.getWidth(t)-2)+" "+U(At.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(U(r.x1.x)+" "+U(r.x1.y)+" m"),n.push(U(r.x2.x)+" "+U(r.x2.y)+" l"),n.push(U(r.x4.x)+" "+U(r.x4.y)+" m"),n.push(U(r.x3.x)+" "+U(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=V(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+U(At.internal.getWidth(t))+" "+U(At.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+r}};At.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=At.internal.getWidth(t),r=At.internal.getHeight(t),n=Math.min(e,r);return{x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},At.internal.getWidth=function(e){var r=0;return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=W(e.Rect[2])),r},At.internal.getHeight=function(e){var r=0;return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&(r=W(e.Rect[3])),r};var xt=q.addField=function(t){if(at(this,t),!(t instanceof lt))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return(e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};q.AcroFormChoiceField=ft,q.AcroFormListBox=dt,q.AcroFormComboBox=pt,q.AcroFormEditBox=gt,q.AcroFormButton=mt,q.AcroFormPushButton=vt,q.AcroFormRadioButton=bt,q.AcroFormCheckBox=wt,q.AcroFormTextField=Nt,q.AcroFormPasswordField=Lt,q.AcroFormAppearance=At,q.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At},E.AcroForm={ChoiceField:ft,ListBox:dt,ComboBox:pt,EditBox:gt,Button:mt,PushButton:vt,RadioButton:bt,CheckBox:wt,TextField:Nt,PasswordField:Lt,Appearance:At};var St=E.AcroForm;function _t(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(e){e.__addimage__={};var r="UNKNOWN",n={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},i=e.__addimage__.getImageFileTypeByImageData=function(t,e){var i,a,o,s,c,u=r;if("RGBA"===(e=e||r)||void 0!==t.data&&t.data instanceof Uint8ClampedArray&&"height"in t&&"width"in t)return"RGBA";if(x(t))for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){u=c;break}}else for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){u=c;break}}return u===r&&e!==r&&(u=e),u},a=function t(e){for(var r=this.internal.write,n=this.internal.putStream,i=(0,this.internal.getFilters)();-1!==i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"),1);e.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.width}),a.push({key:"Height",value:e.height}),e.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.palette.length/3-1)+" "+("sMask"in e&&void 0!==e.sMask?e.objectId+2:e.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.colorSpace}),e.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bitsPerComponent}),"decodeParameters"in e&&void 0!==e.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+e.decodeParameters+">>"}),"transparency"in e&&Array.isArray(e.transparency)){for(var o="",s=0,c=e.transparency.length;s<c;s++)o+=e.transparency[s]+" "+e.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"})}void 0!==e.sMask&&a.push({key:"SMask",value:e.objectId+1+" 0 R"});var u=void 0!==e.filter?["/"+e.filter]:void 0;if(n({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u,objectId:e.objectId}),r("endobj"),"sMask"in e&&void 0!==e.sMask){var h="/Predictor "+e.predictor+" /Colors 1 /BitsPerComponent "+e.bitsPerComponent+" /Columns "+e.width,l={width:e.width,height:e.height,colorSpace:"DeviceGray",bitsPerComponent:e.bitsPerComponent,decodeParameters:h,data:e.sMask};"filter"in e&&(l.filter=e.filter),__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.call(this,l)}if(e.colorSpace===b.INDEXED){var f=this.internal.newObject();n({data:_(new Uint8Array(e.palette)),objectId:f}),r("endobj")}},o=function(){var t=this.internal.collections.addImage_images;for(var e in t)a.call(this,t[e])},s=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R")},c=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",s))},h=function(){var t=this.internal.collections.addImage_images;return c.call(this),t},l=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(t){return"function"==typeof e["process"+t.toUpperCase()]},d=function(e){return"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)&&1===e.nodeType},p=function(t,r){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return u(unescape(n).split("base64,").pop());var i=e.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===t.nodeName){if(0===t.width||0===t.height)throw new Error("Given canvas must have data. Canvas width: "+t.width+", height: "+t.height);var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg"}return u(t.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,c=this.internal.getVerticalCoordinateString,u=h.call(this);if(r=o[0],n=o[1],u[i.index]=i,a){a*=Math.PI/180;var l=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(l),d(f),d(-1*f),d(l),0,0,"cm"]}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),c(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),c(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q")},b=e.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};e.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=e.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=e.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=e.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=e.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]})}return r},A=e.__addimage__.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};e.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=e.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=e.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=e.__addimage__.arrayBufferToBinaryString=function(t){for(var e="",r=x(t)?t:new Uint8Array(t),n=0;n<r.length;n+=8192)e+=String.fromCharCode.apply(null,r.subarray(n,n+8192));return e};e.addImage=function(){var e,n,i,a,o,s,u,h,l;if("number"==typeof arguments[1]?(n=r,i=arguments[1],a=arguments[2],o=arguments[3],s=arguments[4],u=arguments[5],h=arguments[6],l=arguments[7]):(n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],s=arguments[5],u=arguments[6],h=arguments[7],l=arguments[8]),"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e=arguments[0])&&!d(e)&&"imageData"in e){var f=e;e=f.imageData,n=f.format||n||r,i=f.x||i||0,a=f.y||a||0,o=f.w||f.width||o,s=f.h||f.height||s,u=f.alias||u,h=f.compression||h,l=f.rotation||f.angle||l}var p=this.internal.getFilters();if(void 0===h&&-1!==p.indexOf("FlateEncode")&&(h="SLOW"),isNaN(i)||isNaN(a))throw new Error("Invalid coordinates passed to jsPDF.addImage");c.call(this);var g=P.call(this,e,n,u,h);return v.call(this,i,a,o,s,g,l),this};var P=function(t,n,a,o){var s,c,u;if("string"==typeof t&&i(t)===r){t=unescape(t);var h=k(t,!1);(""!==h||void 0!==(h=e.loadFile(t,!0)))&&(t=h)}if(d(t)&&(t=p(t,n)),n=i(t,n),!f(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if((null==(u=a)||0===u.length)&&(a=function(t){return"string"==typeof t||x(t)?w(t):x(t.data)?w(t.data):null}(t)),(s=g.call(this,a))||(A()&&(t instanceof Uint8Array||"RGBA"===n||(c=t,t=S(t))),s=this["process"+n.toUpperCase()](t,l.call(this),a,function(t){return t&&"string"==typeof t&&(t=t.toUpperCase()),t in e.image_compression?t:y.NONE}(o),c)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=e.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=u(n)}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};e.getImageProperties=function(t){var n,a,o="";if(d(t)&&(t=p(t)),"string"==typeof t&&i(t)===r&&(""===(o=k(t,!1))&&(o=e.loadFile(t)||""),t=o),a=i(t),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||t instanceof Uint8Array||(t=S(t)),!(n=this["process"+a.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return n.fileType=a,n}}(E.API),
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){if(void 0!==t&&""!=t)return!0};E.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),c=t.pageContext.annotations,u=!1,h=0;h<c.length&&!u;h++)switch((r=c[h]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0}if(0!=u){this.internal.write("/Annots [");for(var l=0;l<c.length;l++){r=c[l];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]"}}""!=i&&(i+=" >>",this.internal.write(i))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"})},t.textWithLink=function(t,e,r,n){var i,a,o=this.getTextWidth(t),s=this.internal.getLineHeight()/this.internal.scaleFactor;if(void 0!==n.maxWidth){a=n.maxWidth;var c=this.splitTextToSize(t,a).length;i=Math.ceil(s*c)}else a=o,i=s;return this.text(t,e,r,n),r+=.2*s,"center"===n.align&&(e-=o/2),"right"===n.align&&(e-=o),this.link(e,r-s,a,i,n),o},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor}}(E.API),
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},c=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var u=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var h=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},l=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!u(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&c(e)||s(t)&&s(e)?0:h(t)&&o(e)&&!s(e)&&o(r)&&u(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",c="",u=(t=t||"").split("\\s+"),h=[];for(r=0;r<u.length;r+=1){for(h.push(""),n=0;n<u[r].length;n+=1)a=u[r][n],s=u[r][n-1],c=u[r][n+1],o(a)?(i=f(a,s,c),h[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):h[r]+=a;h[r]=l(h[r])}return h.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r}else t=d(e);return"string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p])}(E.API),E.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R")}))}return this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"parentNode",{})};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this}])}(E.API),function(e){var r={left:0,top:0,bottom:0,right:0},n=!1,i=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},r),this.internal.__cell__.margins.width=this.getPageWidth(),a.call(this))},a=function(){this.internal.__cell__.lastCell=new o,this.internal.__cell__.pages=1},o=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t}}),this};o.prototype.clone=function(){return new o(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},o.prototype.toArray=function(){return[this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},e.setHeaderFunction=function(t){return i.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},e.getTextDimensions=function(t,e){i.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),n=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,c=0,u=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t)}var h=e.maxWidth;h>0?"string"==typeof t?t=this.splitTextToSize(t,h):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(u.splitTextToSize(e,h))}),[])):t=Array.isArray(t)?t:[t];for(var l=0;l<t.length;l++)o<(c=this.getStringUnitWidth(t[l],{font:n})*r)&&(o=c);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},e.cellAddPage=function(){i.call(this),this.addPage();var t=this.internal.__cell__.margins||r;return this.internal.__cell__.lastCell=new o(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var s=e.cell=function(){var t;t=arguments[0]instanceof o?arguments[0]:new o(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),i.call(this);var e=this.internal.__cell__.lastCell,a=this.internal.__cell__.padding,s=this.internal.__cell__.margins||r,c=this.internal.__cell__.tableHeaderRow,u=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,u&&c&&(this.printHeaderRow(t.lineNumber,!0),t.y+=c[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===n?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-a,t.y+a,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+a,{align:"center",baseline:"top",maxWidth:t.width-a-a}):this.text(t.text,t.x+a,t.y+a,{align:"left",baseline:"top",maxWidth:t.width-a-a})),this.internal.__cell__.lastCell=t,this};e.table=function(e,n,u,h,l){if(i.call(this),!u)throw new Error("No data for PDF table.");var f,d,p,g,m=[],v=[],b=[],y={},w={},N=[],L=[],A=(l=l||{}).autoSize||!1,x=!1!==l.printHeaders,S=l.css&&void 0!==l.css["font-size"]?16*l.css["font-size"]:l.fontSize||12,_=l.margins||Object.assign({width:this.getPageWidth()},r),P="number"==typeof l.padding?l.padding:3,k=l.headerBackgroundColor||"#c8c8c8",I=l.headerTextColor||"#000";if(a.call(this),this.internal.__cell__.printHeaders=x,this.internal.__cell__.margins=_,this.internal.__cell__.table_font_size=S,this.internal.__cell__.padding=P,this.internal.__cell__.headerBackgroundColor=k,this.internal.__cell__.headerTextColor=I,this.setFontSize(S),null==h)v=m=Object.keys(u[0]),b=m.map((function(){return"left"}));else if(Array.isArray(h)&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(h[0]))for(m=h.map((function(t){return t.name})),v=h.map((function(t){return t.prompt||t.name||""})),b=h.map((function(t){return t.align||"left"})),f=0;f<h.length;f+=1)w[h[f].name]=h[f].width*(19.049976/25.4);else Array.isArray(h)&&"string"==typeof h[0]&&(v=m=h,b=m.map((function(){return"left"})));if(A||Array.isArray(h)&&"string"==typeof h[0])for(f=0;f<m.length;f+=1){for(y[g=m[f]]=u.map((function(t){return t[g]})),this.setFont(void 0,"bold"),N.push(this.getTextDimensions(v[f],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),d=y[g],this.setFont(void 0,"normal"),p=0;p<d.length;p+=1)N.push(this.getTextDimensions(d[p],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);w[g]=Math.max.apply(null,N)+P+P,N=[]}if(x){var F={};for(f=0;f<m.length;f+=1)F[m[f]]={},F[m[f]].text=v[f],F[m[f]].align=b[f];var C=c.call(this,F,w);L=m.map((function(t){return new o(e,n,w[t],C,F[t].text,void 0,F[t].align)})),this.setTableHeaderRow(L),this.printHeaderRow(1,!1)}var j=h.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(f=0;f<u.length;f+=1){"rowStart"in l&&l.rowStart instanceof Function&&l.rowStart({row:f,data:u[f]},this);var O=c.call(this,u[f],w);for(p=0;p<m.length;p+=1){var B=u[f][m[p]];"cellStart"in l&&l.cellStart instanceof Function&&l.cellStart({row:f,col:p,data:B},this),s.call(this,new o(e,n,w[m[p]],O,B,f+2,j[m[p]]))}}return this.internal.__cell__.table_x=e,this.internal.__cell__.table_y=n,this};var c=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};e.setTableHeaderRow=function(t){i.call(this),this.internal.__cell__.tableHeaderRow=t},e.printHeaderRow=function(t,e){if(i.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var r;if(n=!0,"function"==typeof this.internal.__cell__.headerFunction){var a=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new o(a[0],a[1],a[2],a[3],void 0,-1)}this.setFont(void 0,"bold");for(var c=[],u=0;u<this.internal.__cell__.tableHeaderRow.length;u+=1){r=this.internal.__cell__.tableHeaderRow[u].clone(),e&&(r.y=this.internal.__cell__.margins.top||0,c.push(r)),r.lineNumber=t;var h=this.getTextColor();this.setTextColor(this.internal.__cell__.headerTextColor),this.setFillColor(this.internal.__cell__.headerBackgroundColor),s.call(this,r),this.setTextColor(h)}c.length>0&&this.setTableHeaderRow(c),this.setFont(void 0,"normal"),n=!1}}(E.API);var Pt={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},kt=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],It=_t(kt),Ft=[100,200,300,400,500,600,700,800,900],Ct=_t(Ft);function jt(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return Pt[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return"number"==typeof It[t=t||"normal"]?t:"normal"}(t.stretch);return{family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function Ot(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Bt={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},Mt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Et(t){return[t.stretch,t.style,t.weight,t.family].join(" ")}function qt(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Bt,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=jt(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Et(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=It[t],n=r<=It.normal?-1:1,i=Ot(e,kt,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=Pt[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=Ct[t],n=Ot(e,Ft,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Et(a)+"'.");return o}function Dt(t){return t.trimLeft()}function Rt(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return[t.substring(0,r),t.substring(r+1)];r+=1}return null}function Tt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Ut,zt,Ht,Wt=["times"];!function(e){var r,n,i,o,s,c,u,h,l,d=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new h,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new c,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new c,this.lineDashOffset=t.lineDashOffset||0,this.lineDash=t.lineDash||[],this.margin=t.margin||[0,0,0,0],this.prevPageLastElemOffset=t.prevPageLastElemOffset||0,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};e.events.push(["initialized",function(){this.context2d=new p(this),r=this.internal.f2,n=this.internal.getCoordinateString,i=this.internal.getVerticalCoordinateString,o=this.internal.getHorizontalCoordinate,s=this.internal.getVerticalCoordinate,c=this.internal.Point,u=this.internal.Rectangle,h=this.internal.Matrix,l=new d}]);var p=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t)}}),Object.defineProperty(this,"margin",{get:function(){return l.margin},set:function(t){var e;"number"==typeof t?e=[t,t,t,t]:((e=new Array(4))[0]=t[0],e[1]=t.length>=2?t[1]:e[0],e[2]=t.length>=3?t[2]:e[0],e[3]=t.length>=4?t[3]:e[1]),l.margin=e}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=t}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t}});var c=[];Object.defineProperty(this,"pageBreaks",{get:function(){return c},set:function(t){c=t}}),Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof d&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var u=[];Object.defineProperty(this,"ctxStack",{get:function(){return u},set:function(t){u=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=g(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=g(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}});var h=null;function f(t,e){if(null===h){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r}}null!==n&&(n.ref={name:r,style:t},e.push(n))}))})),e}(t.getFontList());h=function(t){for(var e={},r=0;r<t.length;++r){var n=jt(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n}return e}(r.concat(e))}return h}var p=null;Object.defineProperty(this,"fontFaces",{get:function(){return p},set:function(t){h=null,p=t}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Wt;if(i in Mt)return[Mt[i]];for(;""!==i;){switch(r=null,e=(i=Dt(i)).charAt(0)){case'"':case"'":r=Rt(i.substring(1),e);break;default:r=Tt(i)}if(null===r)return Wt;if(n.push(r[0]),""!==(i=Dt(r[1]))&&","!==i.charAt(0))return Wt;i=i.replace(/^,/,"")}return n}(a);if(this.fontFaces){var c=qt(f(this.pdf,this.fontFaces),s.map((function(t){return{family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(c.ref.name,c.ref.style)}else{var u="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(u="bold"),"italic"===r&&(u+="italic"),0===u.length&&(u="normal");for(var h="",l={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},d=0;d<s.length;d++){if(void 0!==this.pdf.internal.getFont(s[d],u,{noFallback:!0,disableWarning:!0})){h=s[d];break}if("bolditalic"===u&&void 0!==this.pdf.internal.getFont(s[d],"bold",{noFallback:!0,disableWarning:!0}))h=s[d],u="bold";else if(void 0!==this.pdf.internal.getFont(s[d],"normal",{noFallback:!0,disableWarning:!0})){h=s[d],u="normal";break}}if(""===h)for(var p=0;p<s.length;p++)if(l[s[p]]){h=l[s[p]];break}h=""===h?"Times":h,this.pdf.setFont(h,u)}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"lineDashOffset",{get:function(){return this.ctx.lineDashOffset},set:function(t){this.ctx.lineDashOffset=t,T.call(this)}}),Object.defineProperty(this,"lineDash",{get:function(){return this.ctx.lineDash},set:function(t){this.ctx.lineDash=t,T.call(this)}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};p.prototype.setLineDash=function(t){this.lineDash=t},p.prototype.getLineDash=function(){return this.lineDash.length%2?this.lineDash.concat(this.lineDash):this.lineDash.slice()},p.prototype.fill=function(){A.call(this,"fill",!1)},p.prototype.stroke=function(){A.call(this,"stroke",!1)},p.prototype.beginPath=function(){this.path=[{type:"begin"}]},p.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(t,e)},p.prototype.closePath=function(){var e=new c(0,0),r=0;for(r=this.path.length-1;-1!==r;r--)if("begin"===this.path[r].type&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(this.path[r+1])&&"number"==typeof this.path[r+1].x){e=new c(this.path[r+1].x,this.path[r+1].y);break}this.path.push({type:"close"}),this.ctx.lastPoint=new c(e.x,e.y)},p.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(r.x,r.y)},p.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),A.call(this,null,!0)},p.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new c(r,n)),o=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new c(i.x,i.y)},p.prototype.bezierCurveTo=function(t,e,r,n,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var s=this.ctx.transform.applyToPoint(new c(i,o)),u=this.ctx.transform.applyToPoint(new c(t,e)),h=this.ctx.transform.applyToPoint(new c(r,n));this.path.push({type:"bct",x1:u.x,y1:u.y,x2:h.x,y2:h.y,x:s.x,y:s.y}),this.ctx.lastPoint=new c(s.x,s.y)},p.prototype.arc=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i))throw a.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var s=this.ctx.transform.applyToPoint(new c(t,e));t=s.x,e=s.y;var u=this.ctx.transform.applyToPoint(new c(0,r)),h=this.ctx.transform.applyToPoint(new c(0,0));r=Math.sqrt(Math.pow(u.x-h.x,2)+Math.pow(u.y-h.y,2))}Math.abs(i-n)>=2*Math.PI&&(n=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:i,counterclockwise:o})},p.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},p.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e)},p.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!m.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},p.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");v.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke())},p.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw a.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n))},p.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new d(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n}},p.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin,this.lineDash=this.ctx.lineDash,this.lineDashOffset=this.ctx.lineDashOffset)},p.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var g=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new f(t);t=o.ok?o.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16)}}return{r:e,g:r,b:n,a:i,style:t}},m=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},v=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};p.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!m.call(this)){var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,angle:i,align:this.textAlign,maxWidth:n})}},p.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw a.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!v.call(this)){n=isNaN(n)?void 0:n;var i=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:n})}},p.prototype.measureText=function(t){if("string"!=typeof t)throw a.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:i*=Math.round(96*r/72*1e4)/1e4})},p.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new h(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.rotate=function(t){if(isNaN(t))throw a.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new h(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},p.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw a.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new h(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.transform=function(t,e,r,n,i,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(o))throw a.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new h(t,e,r,n,i,o);this.ctx.transform=this.ctx.transform.multiply(s)},p.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new h(t,e,r,n,i,a)};var b=function(){return this.margin[0]>0||this.margin[1]>0||this.margin[2]>0||this.margin[3]>0};p.prototype.drawImage=function(t,e,r,n,i,a,o,s,c){var l=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=c/i,f=l.width/n*s/n,d=l.height/i*c/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,c=i),void 0===n&&void 0===s&&(s=l.width,c=l.height);for(var m,v=this.ctx.transform.decompose(),w=q(v.rotate.shx),A=new h,S=(A=(A=(A=A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),_=y.call(this,S),P=[],k=0;k<_.length;k+=1)-1===P.indexOf(_[k])&&P.push(_[k]);if(L(P),this.autoPaging)for(var I=P[0],F=P[P.length-1],C=I;C<F+1;C++){this.pdf.setPage(C);var j=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],O=1===C?this.posY+this.margin[0]:this.margin[0],B=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],M=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],E=1===C?0:B+(C-2)*M;if(0!==this.ctx.clip_path.length){var D=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(m,this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset),x.call(this,"fill",!0),this.path=D}var R=JSON.parse(JSON.stringify(S));R=N([R],this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset)[0];var T=(C>I||C<F)&&b.call(this);T&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],j,M,null).clip().discardPath()),this.pdf.addImage(t,"JPEG",R.x,R.y,R.w,R.h,null,null,w),T&&this.pdf.restoreGraphicsState()}else this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,w)};var y=function(t,e,r){var n=[];e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2];var i=this.posY+this.ctx.prevPageLastElemOffset;switch(t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+i)/r)+1);break;case"arc":n.push(Math.floor((t.y+i-t.radius)/r)+1),n.push(Math.floor((t.y+i+t.radius)/r)+1);break;case"qct":var a=D(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor((a.y+i)/r)+1),n.push(Math.floor((a.y+a.h+i)/r)+1);break;case"bct":var o=R(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor((o.y+i)/r)+1),n.push(Math.floor((o.y+o.h+i)/r)+1);break;case"rect":n.push(Math.floor((t.y+i)/r)+1),n.push(Math.floor((t.y+t.h+i)/r)+1)}for(var s=0;s<n.length;s+=1)for(;this.pdf.internal.getNumberOfPages()<n[s];)w.call(this);return n},w=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a},N=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r}return t},L=function(t){return t.sort((function(t,e){return t-e}))},A=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,c=Math.abs(s*this.ctx.transform.scaleX),u=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),l=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<l.length;d++)if(void 0!==l[d].x)for(var p=y.call(this,l[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)w.call(this);if(L(f),this.autoPaging)for(var v=f[0],A=f[f.length-1],S=v;S<A+1;S++){this.pdf.setPage(S),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=c,this.lineJoin=u;var _=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],P=1===S?this.posY+this.margin[0]:this.margin[0],k=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],I=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],F=1===S?0:k+(S-2)*I;if(0!==this.ctx.clip_path.length){var C=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(r,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),x.call(this,t,!0),this.path=C}if(n=JSON.parse(JSON.stringify(h)),this.path=N(n,this.posX+this.margin[3],-F+P+this.ctx.prevPageLastElemOffset),!1===e||0===S){var j=(S>v||S<A)&&b.call(this);j&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],_,I,null).clip().discardPath()),x.call(this,t,e),j&&this.pdf.restoreGraphicsState()}this.lineWidth=s}else this.lineWidth=c,x.call(this,t,e),this.lineWidth=s;this.path=h},x=function(t,e){if(("stroke"!==t||e||!v.call(this))&&("stroke"===t||e||!m.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var c=i.length;if(a[o-1]&&!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],c>0))for(;c>=0;c--)if(!0!==i[c-1].close&&!0!==i[c-1].begin){i[c-1].deltas.push(r),i[c-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var u=a[o-1].x+2/3*(s.x1-a[o-1].x),h=a[o-1].y+2/3*(s.y1-a[o-1].y),l=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[u-a[o-1].x,h-a[o-1].y,l-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s)}}n=e?null:"stroke"===t?"stroke":"fill";for(var g=!1,b=0;b<i.length;b++)if(i[b].arc)for(var y=i[b].abs,w=0;w<y.length;w++){var N=y[w];"arc"===N.type?P.call(this,N.x,N.y,N.radius,N.startAngle,N.endAngle,N.counterclockwise,void 0,e,!g):j.call(this,N.x,N.y),g=!0}else if(!0===i[b].close)this.pdf.internal.out("h"),g=!1;else if(!0!==i[b].begin){var L=i[b].start.x,A=i[b].start.y;O.call(this,i[b].deltas,L,A),g=!0}n&&k.call(this,n),e&&I.call(this)}},S=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}},_=function(t){return t+this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor*(this.pdf.internal.getLineHeightFactor()-1)};p.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},p.prototype.createPattern=function(){return this.createLinearGradient()},p.prototype.createRadialGradient=function(){return this.createLinearGradient()};var P=function(t,e,r,n,i,a,o,s,c){for(var u=M.call(this,r,n,i,a),h=0;h<u.length;h++){var l=u[h];0===h&&(c?F.call(this,l.x1+t,l.y1+e):j.call(this,l.x1+t,l.y1+e)),B.call(this,t,e,l.x2,l.y2,l.x3,l.y3,l.x4,l.y4)}s?I.call(this):k.call(this,o)},k=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},I=function(){this.pdf.clip(),this.pdf.discardPath()},F=function(t,e){this.pdf.internal.out(n(t)+" "+i(e)+" m")},C=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var r=this.pdf.getTextDimensions(t.text),n=S.call(this,t.y),i=_.call(this,n)-r.h,a=this.ctx.transform.applyToPoint(new c(t.x,n)),o=this.ctx.transform.decompose(),s=new h;s=(s=(s=s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);for(var l,f,d,p=this.ctx.transform.applyToRectangle(new u(t.x,n,r.w,r.h)),g=s.applyToRectangle(new u(t.x,i,r.w,r.h)),m=y.call(this,g),v=[],w=0;w<m.length;w+=1)-1===v.indexOf(m[w])&&v.push(m[w]);if(L(v),this.autoPaging)for(var A=v[0],P=v[v.length-1],k=A;k<P+1;k++){this.pdf.setPage(k);var I=1===k?this.posY+this.margin[0]:this.margin[0],F=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],C=this.pdf.internal.pageSize.height-this.margin[2],j=C-this.margin[0],O=this.pdf.internal.pageSize.width-this.margin[1],B=O-this.margin[3],M=1===k?0:F+(k-2)*j;if(0!==this.ctx.clip_path.length){var E=this.path;l=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(l,this.posX+this.margin[3],-1*M+I),x.call(this,"fill",!0),this.path=E}var q=N([JSON.parse(JSON.stringify(g))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0];t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale);var D="text"!==this.autoPaging;if(D||q.y+q.h<=C){if(D||q.y>=I&&q.x<=O){var R=D?t.text:this.pdf.splitTextToSize(t.text,t.maxWidth||O-q.x)[0],T=N([JSON.parse(JSON.stringify(p))],this.posX+this.margin[3],-M+I+this.ctx.prevPageLastElemOffset)[0],U=D&&(k>A||k<P)&&b.call(this);U&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],B,j,null).clip().discardPath()),this.pdf.text(R,T.x,T.y,{angle:t.angle,align:e,renderingMode:t.renderingMode}),U&&this.pdf.restoreGraphicsState()}}else q.y<C&&(this.ctx.prevPageLastElemOffset+=C-q.y);t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)}else t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale),this.pdf.text(t.text,a.x+this.posX,a.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)},j=function(t,e,r,a){r=r||0,a=a||0,this.pdf.internal.out(n(t+r)+" "+i(e+a)+" l")},O=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},B=function(t,e,n,i,a,c,u,h){this.pdf.internal.out([r(o(n+t)),r(s(i+e)),r(o(a+t)),r(s(c+e)),r(o(u+t)),r(s(h+e)),"c"].join(" "))},M=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],c=n?-1:1,u=e;o>1e-5;){var h=u+c*Math.min(o,a);s.push(E.call(this,t,u,h)),o-=Math.abs(h-u),u=h}return s},E=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,c=o*o+s*s,u=c+o*i+s*a,h=4/3*(Math.sqrt(2*c*u)-u)/(o*a-s*i),l=o-h*s,f=s+h*o,d=l,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:l*m-f*v,y2:l*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},q=function(t){return 180*t/Math.PI},D=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),h=a+.5*(n-a),l=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,h),p=Math.max(e,a,s,h);return new u(l,d,f-l,p-d)},R=function(t,e,r,n,i,a,o,s){var c,h,l,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(h=0;h<41;h++)v=(g=(l=t+(c=h/40)*A)+c*((d=r+c*S)-l))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==h?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))},T=function(){if(this.prevLineDash||this.ctx.lineDash.length||this.ctx.lineDashOffset){var t,e,r=(t=this.ctx.lineDash,e=this.ctx.lineDashOffset,JSON.stringify({lineDash:t,lineDashOffset:e}));this.prevLineDash!==r&&(this.pdf.setLineDash(this.ctx.lineDash,this.ctx.lineDashOffset),this.prevLineDash=r)}}}(E.API),
/**
 * @license
 * jsPDF filters PlugIn
 * Copyright (c) 2014 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var r=function(t){var e,r,n,i,a,o,s,c,u,h;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(h=a%85))/85)-(u=a%85))/85)-(c=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,c+33,u+33,h+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop()}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},n=function(t){var e,r,n,i,a,o=String,s="length",c=255,u="charCodeAt",h="slice",l="replace";for(t[h](-2),t=t[h](0,-2)[l](/\s/g,"")[l]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[h](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(c&r>>24,c&r>>16,c&r>>8,c&r);return function(t,e){for(var r=e;r>0;r--)t.pop()}(n,e[s]),o.fromCharCode.apply(o,n)},i=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},a=function(t){for(var r=new Uint8Array(t.length),n=t.length;n--;)r[n]=t.charCodeAt(n);return t=(r=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */])(r)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};t.processDataByFilters=function(t,e){var o=0,s=t||"",c=[];for("string"==typeof(e=e||[])&&(e=[e]),o=0;o<e.length;o+=1)switch(e[o]){case"ASCII85Decode":case"/ASCII85Decode":s=n(s),c.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=r(s),c.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=i(s),c.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",c.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=a(s),c.push("/FlateDecode");break;default:throw new Error('The filter: "'+e[o]+'" is not implemented')}return{data:s,reverseChain:c.reverse().join(" ")}}}(E.API),
/**
 * @license
 * jsPDF fileloading PlugIn
 * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0)}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r)}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile}(E.API),function(e){function r(){return(n.html2canvas?Promise.resolve(n.html2canvas):__webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 186))).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function i(){return(n.DOMPurify?Promise.resolve(n.DOMPurify):__webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 187))).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var a=function(e){var r=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e);return"undefined"===r?"undefined":"string"===r||e instanceof String?"string":"number"===r||e instanceof Number?"number":"function"===r||e instanceof Function?"function":e&&e.constructor===Array?"array":e&&1===e.nodeType?"element":"object"===r?"object":"unknown"},o=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},s=function t(e){var r=Object.assign(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.convert(Promise.resolve()),JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.template))),n=__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a,1,[__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default.a])).set(e)};(s.prototype=Object.create(Promise.prototype)).constructor=s,s.convert=function(t,e){return t.__proto__=e||s.prototype,t},s.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},s.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(a(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.then(i).then((function(e){return this.set({src:o("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},s.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},s.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:("number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth):this.opt.windowWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=function t(e,r){for(var n=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==r&&1===i.nodeType&&"SCRIPT"===i.nodeName||n.appendChild(t(i,r));return 1===e.nodeType&&("CANVAS"===e.nodeName?(n.width=e.width,n.height=e.height,n.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(n.value=e.value),n.addEventListener("load",(function(){n.scrollTop=e.scrollTop,n.scrollLeft=e.scrollLeft}),!0)),n}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=o("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=o("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(o("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"}))},s.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(r).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n="number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?1:this.opt.width/this.opt.windowWidth,i=Object.assign({async:!0,allowTaint:!0,scale:n,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete i.onrendered,e.context2d.autoPaging=void 0===this.opt.autoPaging||this.opt.autoPaging,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.margin=this.opt.margin,e.context2d.fontFaces=r,r)for(var a=0;a<r.length;++a){var o=r[a],s=o.src.find((function(t){return"truetype"===t.format}));s&&e.addFont(s.url,o.ref.name,o.ref.style)}return i.windowHeight=i.windowHeight||0,i.windowHeight=0==i.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):i.windowHeight,e.context2d.save(!0),t(this.prop.container,i)})).then((function(t){this.opt.jsPDF.context2d.restore(!0),(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},s.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t}))},s.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF}))},s.prototype.output=function(t,e,r){return"img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},s.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},s.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}}))},s.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename)}))},s.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf)}))},s.prototype.set=function(t){if("object"!==a(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in s.template.prop)return function(){this.prop[e]=t[e]};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e]}}}),this);return this.then((function(){return this.thenList(e)}))},s.prototype.get=function(t,e){return this.then((function(){var r=t in s.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},s.prototype.setMargin=function(t){return this.then((function(){switch(a(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t})).then(this.setPageSize)},s.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||E.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t}))},s.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},s.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},s.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},s.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:s.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return s.convert(i,this.__proto__)},s.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},s.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t)})),e},s.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return s.convert(e,this)},s.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},s.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},s.prototype.using=s.prototype.set,s.prototype.saveAs=s.prototype.save,s.prototype.export=s.prototype.output,s.prototype.run=s.prototype.then,E.getPageSize=function(e,r,n){if("object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e)){var i=e;e=i.orientation,r=i.unit||r,n=i.format||n}r=r||"mm",n=n||"a4",e=(""+(e||"P")).toLowerCase();var a,o=(""+n).toLowerCase(),s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(r){case"pt":a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+r}var c,u=0,h=0;if(s.hasOwnProperty(o))u=s[o][1]/a,h=s[o][0]/a;else try{u=n[1],h=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===e||"portrait"===e)e="p",h>u&&(c=h,h=u,u=c);else{if("l"!==e&&"landscape"!==e)throw"Invalid orientation: "+e;e="l",u>h&&(c=h,h=u,u=c)}return{width:h,height:u,unit:r,k:a,orientation:e}},e.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(jt):null;var r=new s(e);return e.worker?r:r.from(t).doCallback()}}(E.API),E.API.addJS=function(t){return Ht=t,this.internal.events.subscribe("postPutResources",(function(){Ut=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(Ut+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),zt=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+Ht+")"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){void 0!==Ut&&void 0!==zt&&this.internal.out("/Names <</JavaScript "+Ut+" 0 R>>")})),this},
/**
 * @license
 * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1)}t.internal.write(a)}if(this.outline.createNamedDestinations){var c=this.internal.pages.length,u=[];for(i=0;i<c;i++){var h=t.internal.newObject();u.push(h);var l=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+l.objId+" 0 R /XYZ null null null]>> endobj")}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<u.length;i++)t.internal.write("(page_"+(i+1)+")"+u[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]")}this.objEnd()}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s])},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count}}])}(E.API),
/**
 * @license
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,c=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3)}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB}u={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:c,index:r,alias:n}}return u}}(E.API);var Vt,Gt,Yt,Jt,Xt,Kt=function(){var t,e,i;function a(t){var e,r,n,i,a,o,s,c,u,h,l,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((h=n-this.transparency.indexed.length)>0)for(d=0;0<=h?d<h:d>h;0<=h?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(l=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,l.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,l.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}a.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},a.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},a.prototype.decodePixels=function(t){var e=this.pixelBitlength/8,n=new Uint8Array(this.width*this.height*e),i=0,a=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function o(r,o,s,c){var u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F=Math.ceil((a.width-r)/s),C=Math.ceil((a.height-o)/c),j=a.width==F&&a.height==C;for(L=e*F,w=j?n:new Uint8Array(L*C),p=t.length,N=0,h=0;N<C&&i<p;){switch(t[i++]){case 0:for(f=S=0;S<L;f=S+=1)w[h++]=t[i++];break;case 1:for(f=_=0;_<L;f=_+=1)u=t[i++],d=f<e?0:w[h-e],w[h++]=(u+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)u=t[i++],l=(f-f%e)/e,A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(A+u)%256;break;case 3:for(f=k=0;k<L;f=k+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],A=N&&w[(N-1)*L+l*e+f%e],w[h++]=(u+Math.floor((d+A)/2))%256;break;case 4:for(f=I=0;I<L;f=I+=1)u=t[i++],l=(f-f%e)/e,d=f<e?0:w[h-e],0===N?A=x=0:(A=w[(N-1)*L+l*e+f%e],x=l&&w[(N-1)*L+(l-1)*e+f%e]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[h++]=(u+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[i-1])}if(!j){var O=((o+N*c)*a.width+r)*e,B=N*L;for(f=0;f<F;f+=1){for(var M=0;M<e;M+=1)n[O++]=w[B++];O+=(s-1)*e}}N++}}return t=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["a" /* unzlibSync */])(t),1==a.interlaceMethod?(o(0,0,8,8),o(4,0,8,8),o(0,4,4,8),o(2,0,4,4),o(0,2,2,4),o(1,0,2,2),o(0,1,1,2)):o(0,0,1,1),n},a.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,c;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(c=a[t++])?c:255;return i},a.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,c,u,h,l,f;if(n=this.colors,h=null,r=this.hasAlphaChannel,this.palette.length&&(h=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),u=(i=t.data||t).length,o=h||e,a=s=0,1===n)for(;a<u;)c=h?4*e[a/4]:s,l=o[c++],i[a++]=l,i[a++]=l,i[a++]=l,i[a++]=r?o[c++]:255,s=c;else for(;a<u;)c=h?4*e[a/4]:s,i[a++]=o[c++],i[a++]=o[c++],i[a++]=o[c++],i[a++]=r?o[c++]:255,s=c},a.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var o=function(){if("[object Window]"===Object.prototype.toString.call(n)){try{e=n.document.createElement("canvas"),i=e.getContext("2d")}catch(t){return!1}return!0}return!1};return o(),t=function(t){var r;if(!0===o())return i.width=t.width,i.height=t.height,i.clearRect(0,0,t.width,t.height),i.putImageData(t,0,0),(r=new Image).src=e.toDataURL(),r;throw new Error("This method requires a Browser with Canvas-capability.")},a.prototype.decodeFrames=function(e){var r,n,i,a,o,s,c,u;if(this.animation){for(u=[],n=o=0,s=(c=this.animation.frames).length;o<s;n=++o)r=c[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,u.push(r.image=t(i));return u}},a.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},a.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,c;if(o=r++%i,c=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,c.delay)})()},a.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},a.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},a}();
/**
 * @license
 *
 * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
/**
 * @license
 * (c) Dean McNamee <dean@gmail.com>, 2013.
 *
 * https://github.com/deanm/omggif
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
 * including animation and compression.  It does not rely on any specific
 * underlying system, so should run in the browser, Node, or Plask.
 */
function Zt(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,c=null;a&&(s=e,c=o,e+=3*o);var u=!0,h=[],l=0,f=null,d=0,p=null;for(this.width=r,this.height=n;u&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];l=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=c,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}h.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:l,disposal:d});break;case 59:u=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return h.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=h.length)throw new Error("Frame index out of range.");return h[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255}--l}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);$t(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,h=r-u,l=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*h;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===l&&(l=u,(p+=g)>=d&&(g=4*h+4*r*(m-1),p=f+(u+h)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255}--l}}}function $t(t,e,r,n){for(var i=t[e++],o=1<<i,s=o+1,c=s+1,u=i+1,h=(1<<u)-1,l=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;l<16&&0!==p;)f|=t[e++]<<l,l+=8,1===p?p=t[e++]:--p;if(l<u)break;var v=f&h;if(f>>=u,l-=u,v!==o){if(v===s)break;for(var b=v<c?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void a.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&c<4096&&(g[c++]=m<<8|N,c>=h+1&&u<12&&(++u,h=h<<1|1)),m=v}else c=s+1,h=(1<<(u=i+1))-1,m=null}return d!==n&&a.log("Warning, gif stream shorter than expected."),r}
/**
 * @license
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/function Qt(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),c=new Array(64),u=new Array(64),h=new Array(64),l=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],I=[0,1,2,3,4,5,6,7,8,9,10,11],F=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0)}function B(t){g.push(t)}function M(t){B(t>>8&255),B(255&t)}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],c=function(t,e){var r,n,i,a,o,s,c,u,h,l,f=0;for(h=0;h<8;++h){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],c=t[f+6];var p=r+(u=t[f+7]),g=r-u,m=n+c,v=n-c,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,I=1.306562965*S+P,F=.707106781*(x=y+v),C=g+F,j=g-F;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+I,t[f+7]=C-I,f+=8}for(f=0,h=0;h<8;++h){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],c=t[f+48];var O=r+(u=t[f+56]),B=r-u,M=n+c,E=n-c,q=i+s,D=i-s,R=a+o,T=a-o,U=O+R,z=O-R,H=M+q,W=M-q;t[f]=U+H,t[f+32]=U-H;var V=.707106781*(W+z);t[f+16]=z+V,t[f+48]=z-V;var G=.382683433*((U=T+D)-(W=E+B)),Y=.5411961*U+G,J=1.306562965*W+G,X=.707106781*(H=D+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++}for(h=0;h<64;++h)l=t[h]*e[h],d[h]=l>0?l+.5|0:l-.5|0;return d}(t,e),u=0;u<64;++u)p[A[u]]=c[u];var h=p[0]-r;r=p[0],0==h?O(n[0]):(O(n[f[a=32767+h]]),O(l[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15}a=32767+p[v],O(i[(y<<4)+f[a]]),O(l[a]),v++}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var l=o((i[a]*t+50)/100);l=Math.min(Math.max(l,1),255),c[A[a]]=l}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)u[d]=1/(s[A[d]]*f[p]*f[g]*8),h[d]=1/(c[A[d]]*f[p]*f[g]*8),d++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t)}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(c[e])}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1)}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(I[a]);B(17);for(var o=0;o<16;o++)B(F[o+1]);for(var s=0;s<=161;s++)B(C[s])}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,l=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,D,R,T,U,z=t.data,H=t.width,W=t.height,V=4*H,G=0;G<W;){for(d=0;d<V;){for(j=V*G+d,R=-1,T=0,U=0;U<64;U++)D=j+(T=U>>3)*V+(R=4*(7&U)),G+T>=W&&(D-=V*(G+1+T-W)),d+R>=V&&(D-=d+R-V+4),p=z[D++],N=z[D++],A=z[D++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,u,o,e,n),l=E(y,h,l,r,i),f=E(w,h,f,r,i),d+=32}G+=8}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y)}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e)}(),e=j(x,S),r=j(k,I),n=j(_,P),i=j(F,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,l[32767+n]=[],l[32767+n][1]=r,l[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,l[32767+i]=[],l[32767+i][1]=r,l[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t}(),q(t)}
/**
 * @license
 * Copyright (c) 2017 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */function te(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}function ee(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return!0;return!1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a]}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i)}(r,0,t),r}var c=function(){var t=this;function c(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function u(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a}while(0<i)}function h(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var h,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]]}if(g[0]==o)return 0;for(m[1]=0,h=1;15>h;++h){if(g[h]>1<<h)return 0;m[h+1]=m[h]+g[h]}for(f=0;f<o;++f)h=i[f],0<i[f]&&(s[m[h]++]=f);if(1==m[15])return(i=new l).g=0,i.value=s[0],u(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,h=1,o=2;h<=n;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h])(i=new l).g=h,i.value=s[f++],u(t,d+w,o,A,i),w=c(w,h)}for(h=n+1,o=2;15>=h;++h,o<<=1){if(N+=L<<=1,0>(L-=g[h]))return 0;for(;0<g[h];--g[h]){if(i=new l,(w&y)!=b){for(d+=A,v=1<<(b=h)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b}i.g=h-n,i.value=s[f++],u(t,d+(w>>n),o,A,i),w=c(w,h)}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function l(){this.value=this.g=0}function f(){this.value=this.g=0}function d(){this.G=o(5,l),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Dr,f)}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t)}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0)}function y(t,r){if(e(0<=r),!t.h&&r<=Tr){var n=L(t)&Rr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t)}function S(t){t.u>=zr&&(e(t.u>=zr),b(t))}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1))}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function I(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255}function F(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return F(t,e)|t[e+2]<<16}function j(t,e){return F(t,e)|F(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa)}function M(){this.X=[],this.Xa=this.Mb=0}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function D(t,e){return((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function R(e,r){t[r]=function(r,n,i,a,o,s,c){var u;for(u=0;u<o;++u){var h=t[e](s[c+u-1],i,a+u);s[c+u]=D(r[n+u],h)}}}function T(){this.ud=this.hd=this.jd=0}function U(t,e){return((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function W(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function V(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=D(t[e+r],n)}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,c=16711935&(c=(c=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+c>>>0}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],c=s>>>8,u=s,h=255&(h=(h=s>>>16)+((t.jd<<24>>24)*(c<<24>>24)>>>5));u=255&(u=(u=u+((t.hd<<24>>24)*(c<<24>>24)>>>5))+((t.ud<<24>>24)*(h<<24>>24)>>>5));i[a+o]=(4278255360&s)+(h<<16)+u}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,c,u,h){for(n=c;n<u;++n)for(c=0;c<h;++c)o[s++]=a(r[i(t[e++])])},t[e]=function(e,r,o,s,c,u,h){var l=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>l)for(e=(1<<e.b)-1,p=(1<<l)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[c++])),u[h++]=a(d[m&p]),m>>=l}else t["VP8LMapColor"+n](s,c,d,p,u,h,r,o,f)}}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)I(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r)}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"]}function nt(t){return t==Hn||t==Wn||t==Vn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0]}function ct(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0}function ut(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function ht(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],c=t.y,u=t.O,h=t.f,l=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(c,u,null,null,h,l,f,d,h,l,f,d,a,o,null,null,w):(s(e.ec,e.fc,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=h,g=l,m=f,v=d,l+=t.Rc,d+=t.Rc,o+=2*i.A,s(c,(u+=2*t.fa)-t.fa,c,u,p,g,m,v,h,l,f,d,a,o-i.A,a,o,w);return u+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,c,u,w),n(e.cc,e.dc,h,l,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(c,u,null,null,h,l,f,d,h,l,f,d,a,o+i.A,null,null,w),r}function lt(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,c=s==Tn||s==Vn;r=r.ba.f.RGBA;var u=[0],h=t.ka;u[0]=t.T,t.Kb&&(0==h?--u[0]:(--h,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-h));var l=r.eb;h=r.fb+h*r.A;t=Sn(i,a[0],t.width,o,u,l,h+(c?0:3),r.A),e(n==u),t&&nt(s)&&An(l,h,c,o,u,r.A)}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Rn||r==Tn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else{if(n){if(e.Ib=ut,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=ht,br()}}else alert("todo:EmitYUV");i&&(e.Jb=lt,n&&mr())}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Vt(e,255),qi[t-Pi]=Vt(e+8>>4,15);Ci=1}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return(2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,c=t.C;r=c+r;var u=i,h=a;for(a=t.Ta,i=t.Ua;0<o--;){var l=t.gc[o],f=c,d=r,p=u,g=h,m=(h=a,u=i,l.Ea);switch(e(f<d),e(d<=l.nc),l.hc){case 2:Gr(p,g,(d-f)*m,h,u);break;case 0:var v=f,b=d,y=h,w=u,N=(_=l).Ea;0==v&&(Wr(p,g,null,null,1,y,w),V(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,I=1;for(Vr(p,g,y,w-N,1,y,w);I<N;){var F=(I&~A)+L;F>N&&(F=N),(0,Zr[P[k++]>>8&15])(p,g+ +I,y,w+I-N,F-I,y,w+I),I=F}g+=N,w+=N,++v&A||(_+=x)}d!=l.nc&&n(h,u-m,h,u+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=l.Ea)-(w=p&~(y=(g=1<<l.b)-1)),v=q(p,l.b),L=l.K,l=l.w+(f>>l.b)*v;f<d;){for(A=L,x=l,S=new T,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,h,u),b+=g,u+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,h,u),b+=N,u+=N),++f&y||(l+=v)}break;case 3:if(p==h&&g==u&&0<l.b){for(b=h,p=m=u+(d-f)*m-(w=(d-f)*q(l.Ea,l.b)),g=h,y=u,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(l,f,d,h,m,h,u)}else Yr(l,f,d,p,g,h,u)}u=a,h=i}h!=i&&n(a,i,u,h,s)}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,c=t.Ua,u=o.width;if(Nt(t,a,n,i),a=c=[c],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var h=o.j-n;n=o.j;a[0]+=h*u}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(c=c[0],11>(n=t.ca).S){var l=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,h=l.eb,l.A),d=o;for(l=l.fb+t.Ma*l.A;0<d--;){var p=s,g=c,m=a,v=h,b=l;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Dn:nn(p,g,m,v,b);break;case Rn:et(p,g,m,v,b,1);break;case Wn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Tn:et(p,g,m,v,b,0);break;case Vn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0)}c+=u,l+=f}t.Ma+=o}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height)}}t.C=r,e(t.C<=t.i)}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,c=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,c,i,a,i,a,o),s=i,c=a,a+=o;t.qd=s,t.rd=c}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,c=t.V,u=t.Ba+t.c*i,h=t.gc;e(1==t.ab),e(3==h[0].hc),Xr(h[0],i,r,c,u,o,s),xt(n,i,r,o,s,a)}t.C=t.Ma=r}function _t(t,r,n,i,a,o,s){var c=t.$/i,u=t.$%i,h=t.m,l=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+l.ua,m=t.Pb?c:16777216,v=0<l.ua?l.Wa:null,b=l.wc,y=f<p?wt(l,u,c):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(c>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=c+ti}if(u&b||(y=wt(l,u,c)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(h),y.jc){N=h,_=r;var P=f,k=y.pd[L(N)&Dr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0)}else N=bt(y.G[0],y.H[0],h);if(h.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else{if(S(h),w=bt(y.G[1],y.H[1],h),S(h),_=bt(y.G[2],y.H[2],h),P=bt(y.G[3],y.H[3],h),h.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0}if(w=!1,++f,++u>=i&&(u=0,++c,null!=s&&c<=o&&!(c%16)&&s(t,c),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else if(280>N){if(N=mt(N-256,h),_=bt(y.G[4],y.H[4],h),S(h),_=vt(i,_=mt(_,h)),h.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,u+=N;u>=i;)u-=i,++c,null!=s&&c<=o&&!(c%16)&&s(t,c);if(e(f<=a),u&b&&(y=wt(l,u,c)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else{if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0}w||e(h.h==A(h))}if(t.Pb&&h.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else{if(h.h)break t;null!=s&&s(t,c>o?o:c),t.a=0,t.$=f-n}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t)}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function It(t,r,n,s,c){var u=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;u&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],I=y(P,2);if(A.Oc&1<<I)u=0;else{switch(A.Oc|=1<<I,k.hc=I,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),I){case 0:case 1:k.b=y(P,3)+2,_=It(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var F,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,F=_=It(C,1,0,A,k.K)){var B,M=C,E=k,R=1<<(8>>E.b),T=a(R);if(null==T)F=0;else{var U=E.K[0],z=E.w;for(T[0]=E.K[0][0],B=1;B<1*M;++B)T[B]=D(U[z+B],T[B-1]);for(;B<4*R;++B)T[B]=0;E.K[0]=null,E.K[0]=T,F=1}}_=F;break;case 2:break;default:e(0)}u=_}}if(f=f[0],p=p[0],u&&y(g,1)&&!(u=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=u)e:{var W,V,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!It(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,W=0;W<st;++W){var ct=tt[W]>>8&65535;tt[W]=ct,ct>=et&&(et=ct+1)}}if($.h)break r;for(V=0;5>V;++V){var ut=Xn[V];!V&&0<K&&(ut+=1<<K),rt<ut&&(rt=ut)}var ht=o(et*nt,l),lt=et,ft=o(lt,d);if(null==ft)var dt=null;else e(65536>=lt),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==ht){Y.a=1;break r}var gt=ht;for(W=G=0;W<et;++W){var mt=dt[W],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(V=0;5>V;++V){ut=Xn[V],vt[V]=gt,bt[V]=G,!V&&0<K&&(ut+=1<<K);n:{var At,xt=ut,St=Y,kt=pt,Ft=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Dt=1}else{var Rt=a(19),Tt=y(Ot,4)+4;if(19<Tt){St.a=3;var Ut=0;break n}for(At=0;At<Tt;++At)Rt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Wt=St,Vt=Rt,Gt=xt,Yt=kt,Jt=0,Xt=Wt.m,Kt=8,Zt=o(128,l);i:for(;h(Zt,0,7,Vt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else{var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae}}Jt=1;break i}Jt||(Wt.a=3),Dt=Jt}(Dt=Dt&&!Ot.h)&&(jt=h(Ft,Ct,8,kt,xt)),Dt&&0!=jt?Ut=jt:(St.a=3,Ut=0)}if(0==Ut)break r;if(Nt&&1==Kn[V]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=V){var oe,se=pt[0];for(oe=1;oe<ut;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ce,ue=mt;for(ce=0;ce<Dr;++ce){var he=ce,le=ue.pd[he],fe=ue.G[0][ue.H[0]+he];256<=fe.value?(le.g=fe.g+256,le.value=fe.value):(le.g=0,le.value=0,he>>=yt(fe,8,le),he>>=yt(ue.G[1][ue.H[1]+he],16,le),he>>=yt(ue.G[2][ue.H[2]+he],0,le),yt(ue.G[3][ue.H[3]+he],24,le))}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=ht,H=1;break e}H=0}if(!(u=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,u=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,u=0;break t}u=(u=_t(s,v,0,f,p,p,null))&&!g.h;break t}return u?(null!=c?c[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),u}function Ft(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,c=t.l.ma,u=t.l.width,h=u*s,l=c.ca,f=c.tb+u*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,l,f,h),xt(c,n,n+s,l,f,u),i-=s,a+=s*t.c,n+=s}e(n==r),t.C=t.Ma=r}function jt(){this.ub=this.yd=this.td=this.Rb=0}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4)}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n)}(t,0,[3,11]),t}()}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt)}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4)}function Dt(){this.ld=this.La=this.dd=this.tc=0}function Rt(){this.Na=this.la=0}function Tt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Dt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8)}function Wt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Tt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Rt),this.sb=0,this.wa=Array(new Dt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Dt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0}function Vt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0}function Yt(){var t=new Wt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,c=t.Od;if(c.Rb=!(1&s),c.td=s>>1&7,c.yd=s>>4&1,c.ub=s>>5,3<c.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!c.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var u=t.Kc;if(c.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");u.c=16383&(n[a+4]<<8|n[a+3]),u.Td=n[a+4]>>6,u.i=16383&(n[a+6]<<8|n[a+5]),u.Ud=n[a+6]>>6,a+=7,o-=7,t.za=u.c+15>>4,t.Ub=u.i+15>>4,r.width=u.c,r.height=u.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb)}if(c.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,c.ub),a+=c.ub,o-=c.ub,c.Rb&&(u.Ld=P(s),u.Kd=P(s)),u=t.Qa;var h,l=t.Pa;if(e(null!=s),e(null!=u),u.Cb=P(s),u.Cb){if(u.Bb=P(s),P(s)){for(u.Fb=P(s),h=0;4>h;++h)u.Zb[h]=P(s)?m(s,7):0;for(h=0;4>h;++h)u.Lb[h]=P(s)?m(s,6):0}if(u.Bb)for(h=0;3>h;++h)l.jb[h]=P(s)?g(s,8):255}else u.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((u=t.ed).zd=P(s),u.Tb=g(s,6),u.wb=g(s,3),u.Pc=P(s),u.Pc&&P(s)){for(l=0;4>l;++l)P(s)&&(u.vd[l]=m(s,6));for(l=0;4>l;++l)P(s)&&(u.od[l]=m(s,6))}if(t.L=0==u.Tb?0:u.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=h=a,a=h+f,u=f,t.Xb=(1<<g(t.m,2))-1,f<3*(l=t.Xb))n=7;else{for(h+=3*l,u-=3*l,f=0;f<l;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>u&&(d=u),p(t.Jc[+f],n,h,d),h+=d,u-=d,o+=3}p(t.Jc[+l],n,h,u),n=h<a?0:5}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(h=t.m,7),o=P(h)?m(h,4):0,a=P(h)?m(h,4):0,u=P(h)?m(h,4):0,l=P(h)?m(h,4):0,h=P(h)?m(h,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n)}else{if(0<d){t.pb[d]=t.pb[0];continue}v=n}var b=t.pb[d];b.Sc[0]=ei[Vt(v+o,127)],b.Sc[1]=ri[Vt(v+0,127)],b.Eb[0]=2*ei[Vt(v+a,127)],b.Eb[1]=101581*ri[Vt(v+u,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Vt(v+l,117)],b.Qc[1]=ri[Vt(v+h,127)],b.lc=v+h}if(!c.Rb)return Jt(t,4,"Not a key frame.");for(P(s),c=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(u=0;11>u;++u)l=k(s,ui[n][o][a][u])?g(s,8):si[n][o][a][u],c.Wc[n][o].Yb[a][u]=l;for(o=0;17>o;++o)c.Xc[n][o]=c.Wc[n][hi[o]]}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var c=e[i+1].Yb;if(k(t,s[r+2])){var u=t,h=0;if(k(u,(f=s)[(l=r)+3]))if(k(u,f[l+6])){for(s=0,l=2*(h=k(u,f[l+8]))+(f=k(u,f[l+9+h])),h=0,f=ii[l];f[s];++s)h+=h+k(u,f[s]);h+=3+(8<<l)}else k(u,f[l+7])?(h=7+2*k(u,165),h+=k(u,145)):h=5+k(u,159);else h=k(u,f[l+4])?3+k(u,f[l+5]):2;s=c[2]}else h=1,s=c[1];c=o+ai[i],0>(u=t).b&&_(u);var l,f=u.b,d=(l=u.Ca>>1)-(u.I>>f)>>31;--u.b,u.Ca+=d,u.Ca|=1,u.I-=(l+1&d)<<f,a[c]=((h^d)-d)*n[(0<i)+0]}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ri[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var c=t.ed;for(s=0;4>s;++s){var u;if(t.Qa.Cb){var h=t.Qa.Lb[s];t.Qa.Fb||(h+=c.Tb)}else h=c.Tb;for(u=0;1>=u;++u){var l=t.gd[s][u],f=h;if(c.Pc&&(f+=c.vd[0],u&&(f+=c.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<c.wb&&((d=4<c.wb?d>>2:d>>1)>9-c.wb&&(d=9-c.wb)),1>d&&(d=1),l.dd=d,l.tc=2*f+d,l.ld=40<=f?2:15<=f?1:0}else l.tc=0;l.La=u}}}s=0}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;c=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((l=c+832+(u=3*(16*s+Ri[t.L])/2*p)+(h=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=l)s=0;else{if(l>t.Vb){if(t.Vb=0,t.Ec=a(l),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=l}l=t.Ec,f=t.Fc,t.Ac=l,t.Bc=f,f+=c,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Rt),t.sb=1,t.wa=m?o(m,Dt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=l,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ri[t.L])*t.R,p=p/2*t.B,t.sa=l,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=u,t.mb=h?l:null,t.nb=h?f:null,e(f+h<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,c),s=1}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)In[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)Fn[255+s]=0>s?0:255<s?255:s;Cn=1}an=ue,on=ae,cn=oe,un=se,hn=ce,sn=ie,ln=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=We,Ln=Ve,fi[0]=xe,fi[1]=le,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Fe,fi[9]=Ie,li[0]=ve,li[1]=de,li[2]=pe,li[3]=ge,li[4]=be,li[5]=ye,li[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1}else s=0}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],c=t.m,u=t;for(o=0;o<u.za;++o){var h=c,l=u,f=l.Ac,d=l.Bc+4*o,p=l.zc,g=l.ya[l.aa+o];if(l.Qa.Bb?g.$b=k(h,l.Pa.jb[0])?2+k(h,l.Pa.jb[2]):k(h,l.Pa.jb[1]):g.$b=0,l.kc&&(g.Ad=k(h,l.Bd)),g.Za=!k(h,145)+0,g.Za){var m=g.Ob,v=0;for(l=0;4>l;++l){var b,y=p[0+l];for(b=0;4>b;++b){y=ci[f[d+b]][y];for(var w=oi[k(h,y[0])];0<w;)w=oi[2*w+k(h,y[w])];y=-w,f[d+b]=y}n(m,v,f,d,4),v+=4,p[0+l]=y}}else y=k(h,156)?k(h,128)?1:3:k(h,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(h,142)?k(h,114)?k(h,183)?1:3:2:0}if(u.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(u=s,h=(c=t).rb[c.sb-1],f=c.rb[c.sb+c.ja],o=c.ya[c.aa+c.ja],d=c.kc?o.Ad:0)h.la=f.la=0,o.Za||(h.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else{var N,L;h=f,f=u,d=c.Pa.Xc,p=c.ya[c.aa+c.ja],g=c.pb[p.$b];if(l=p.ad,m=0,v=c.rb[c.sb-1],y=b=0,i(l,m,0,384),p.Za)var A=0,x=d[3];else{w=a(16);var S=h.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),h.Na=v.Na=(0<S)+0,1<S)an(w,0,l,m);else{var _=w[0]+3>>3;for(w=0;256>w;w+=16)l[m+w]=_}A=1,x=d[0]}var P=15&h.la,I=15&v.la;for(w=0;4>w;++w){var F=1&I;for(_=L=0;4>_;++_)P=P>>1|(F=(S=ni(f,x,S=F+(1&P),g.Sc,A,l,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=4,I=I>>1|F<<7,b=(b<<8|L)>>>0}for(x=P,A=I>>4,N=0;4>N;N+=2){for(L=0,P=h.la>>4+N,I=v.la>>4+N,w=0;2>w;++w){for(F=1&I,_=0;2>_;++_)S=F+(1&P),P=P>>1|(F=0<(S=ni(f,d[2],S,g.Qc,0,l,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=l[m+0]),m+=16;P>>=2,I=I>>1|F<<5}y|=L<<4*N,x|=P<<4<<N,A|=(240&I)<<N}h.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y)}if(0<c.L&&(c.wa[c.Y+c.ja]=c.gd[o.$b][o.Za],c.wa[c.Y+c.ja].La|=!d),u.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),c=r,u=1,o=(s=t).D,h=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=h,Or(s,o),u=1,o=(L=s.D).Nb,h=(y=Ri[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-h+w,g=s.qa,l=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,I=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(F=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=F;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else{var q=U.B,D=U.qa,R=U.ra+8*C*q+8*A,T=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(D,R,T,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(D,R,T,U,q,E,M,C)),0<x&&(ln(O,B,N,E+4,M,C),dn(D,R,T,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(D,R,T,U,q,E,M,C))}}if(s.ia&&alert("todo:DitherRow"),null!=c.put){if(L=16*P,P=16*(P+1),I?(c.y=s.sa,c.O=s.ta+w,c.f=s.qa,c.N=s.ra+_,c.ea=s.Ha,c.W=s.Ia+_):(L-=y,c.y=d,c.O=p,c.f=g,c.N=l,c.ea=m,c.W=v),b||(P-=y),P>c.o&&(P=c.o),c.F=null,c.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(c.J=lr(s,c,L,P-L),c.F=s.mb,null==c.F&&0==c.F.length)){u=Jt(s,3,"Could not decode alpha data.");break t}L<c.j&&(y=c.j-L,L=c.j,e(!(1&y)),c.O+=s.R*y,c.N+=s.B*(y>>1),c.W+=s.B*(y>>1),null!=c.F&&(c.J+=c.width*y)),L<P&&(c.O+=c.v,c.N+=c.v>>1,c.W+=c.v>>1,null!=c.F&&(c.J+=c.v),c.ka=L-c.j,c.U=c.va-c.v,c.T=P-L,u=c.put(c))}o+1!=s.Ic||b||(n(s.sa,s.ta-h,d,p+16*s.R,h),n(s.qa,s.ra-f,g,l+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f))}if(!u)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i)}function re(t){return(20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var c=t[e+0]+t[e+8],u=t[e+0]-t[e+8],h=(35468*t[e+4]>>16)-re(t[e+12]),l=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=c+l,s[o+1]=u+h,s[o+2]=u-h,s[o+3]=c-l,o+=4,e++}for(i=o=0;4>i;++i)c=(t=s[o+0]+4)+s[o+8],u=t-s[o+8],h=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,c+(l=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,u+h),te(r,n,2,0,u-h),te(r,n,3,0,c-l),o++,n+=32}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s)}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4)}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1)}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t)}function ce(t,e,r,n){t[e+0]&&un(t,e+0,r,n),t[e+16]&&un(t,e+16,r,n+4),t[e+32]&&un(t,e+32,r,n+128),t[e+48]&&un(t,e+48,r,n+128+4)}function ue(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],c=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],h=t[e+0+i]-t[e+12+i];o[0+i]=s+c,o[8+i]=s-c,o[4+i]=h+u,o[12+i]=h-u}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],c=o[1+4*i]+o[2+4*i],u=o[1+4*i]-o[2+4*i],h=t-o[3+4*i],r[n+0]=s+c>>3,r[n+16]=h+u>>3,r[n+32]=s-c>>3,r[n+48]=h-u>>3,n+=64}function he(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,c=a,u=o+t[e-1];for(s=0;s<r;++s)t[e+s]=c[u+t[i+s]];e+=32}}function le(t,e){he(t,e,4)}function fe(t,e){he(t,e,8)}function de(t,e){he(t,e,16)}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16)}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16)}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e)}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e)}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e)}function we(t,e){me(128,t,e)}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length)}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];I(t,e+0,16843009*Ne(t[e-1-32],r,n)),I(t,e+32,16843009*Ne(r,n,i)),I(t,e+64,16843009*Ne(n,i,a)),I(t,e+96,16843009*Ne(i,a,a))}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4)}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(c,s,o),t[e+3+0]=Ne(u,c,s)}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],c=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,c),t[e+3+96]=Ne(s,c,c)}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+c+1>>1,t[e+3+0]=c+u+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,c),t[e+3+32]=Ne(s,c,u)}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],c=t[e+6-32],u=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,c),t[e+3+96]=Ne(s,c,u)}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],c=t[e+1-32],u=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,c,u),t[e+2+0]=Ne(o,s,c),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n)}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8)}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8)}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e)}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e)}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e)}function qe(t,e){Oe(128,t,e)}function De(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o]}function Re(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function Te(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],c=t[e+0],u=t[e+r],h=t[e+2*r],l=t[e+3*r];return 4*Mn[255+s-c]+Mn[255+o-u]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+l-h]<=i&&Mn[255+h-u]<=i&&Mn[255+u-c]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n,r,i)&&De(t,e+n,r)}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n*r,1,i)&&De(t,e+n*r,1)}function We(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n)}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n)}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-2*h],f=c[u-h],d=c[u+0],p=c[u+h],g=c[u+2*h],m=27*(b=jn[1020+3*(d-f)+jn[1020+l-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;c[u-3*h]=Bn[255+c[u-3*h]+b],c[u-2*h]=Bn[255+l+v],c[u-h]=Bn[255+f+m],c[u+0]=Bn[255+d-m],c[u+h]=Bn[255+p-v],c[u+2*h]=Bn[255+g-b]}e+=n}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,h=r,l=c[u-h],f=c[u+0],d=c[u+h],p=On[112+((g=3*(f-l))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;c[u-2*h]=Bn[255+c[u-2*h]+m],c[u-h]=Bn[255+l+g],c[u+0]=Bn[255+f-p],c[u+h]=Bn[255+d-m]}e+=n}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a)}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a)}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a)}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a)}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s)}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s)}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s)}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s)}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ct,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc"}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new l}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0}function cr(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e]}function ur(t,e,r,n,i,a,o){var s;if(null==t)cr(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255}function hr(t,e,r,n,i,a,o){if(null==t)cr(null,null,r,n,i,a,o);else{var s,c=t[e+0],u=c,h=c;for(s=0;s<o;++s)u=h+(c=t[e+s])-u,h=r[n+s]+(-256&u?0>u?0:255:u)&255,u=c,i[a+s]=h}}function lr(t,r,i,o){var s=r.width,c=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>c)return null;if(!t.Cc){if(null==t.ga){var u;if(t.ga=new sr,(u=null==t.ga)||(u=r.width*r.o,e(0==t.Gb.length),t.Gb=a(u),t.Uc=0,null==t.Gb?u=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,u=1),u=!u),!u){u=t.ga;var h=t.Fa,l=t.P,f=t.qc,d=t.mb,p=t.nb,g=l+1,m=f-1,b=u.l;if(e(null!=h&&null!=d&&null!=r),mi[0]=null,mi[1]=cr,mi[2]=ur,mi[3]=hr,u.ca=d,u.tb=p,u.c=r.width,u.i=r.height,e(0<u.c&&0<u.i),1>=f)r=0;else if(u.$a=h[l+0]>>0&3,u.Z=h[l+0]>>2&3,u.Lc=h[l+0]>>4&3,l=h[l+0]>>6&3,0>u.$a||1<u.$a||4<=u.Z||1<u.Lc||l)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=u,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,u.$a)t:{e(1==u.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=u),u.mc=r,r.c=u.c,r.i=u.i,r.l=u.l,r.l.ma=u,r.l.width=u.c,r.l.height=u.i,r.a=0,v(r.m,h,g,m),!It(u.c,u.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(u.ic=1,h=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(h),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(u.ic=0,r=Ft(r,u.c)),!r)break e;r=1;break t}u.mc=null,r=0}else r=m>=u.c*u.i;u=!r}if(u)return null;1!=t.ga.Lc?t.Ga=0:o=c-i}e(null!=t.ga),e(i+o<=c);t:{if(r=(h=t.ga).c,c=h.l.o,0==h.$a){if(g=t.rc,m=t.Vc,b=t.Fa,l=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(l<=t.P+t.qc),0!=h.Z)for(e(null!=mi[h.Z]),u=0;u<o;++u)mi[h.Z](g,m,b,l,f,d,r),g=f,m=d,d+=r,l+=r;else for(u=0;u<o;++u)n(f,d,b,l,r),g=f,m=d,d+=r,l+=r;t.rc=g,t.Vc=m}else{if(e(null!=h.mc),r=i+o,e(null!=(u=h.mc)),e(r<=u.i),u.C>=r)r=1;else if(h.ic||mr(),h.ic){h=u.V,g=u.Ba,m=u.c;var y=u.i,w=(b=1,l=u.$/m,f=u.$%m,d=u.m,p=u.s,u.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,l):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,l)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))h[g+w]=y,++w,++f>=m&&(f=0,++l<=r&&!(l%16)&&St(u,l));else{if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)h[g+w+P]=h[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++l<=r&&!(l%16)&&St(u,l);w<L&&f&x&&(_=wt(p,f,l))}e(d.h==A(d))}St(u,l>r?r:l);break e}!b||d.h&&w<N?(b=0,u.a=d.h?5:3):u.$=w,r=b}else r=_t(u,u.V,u.Ba,u.c,u.i,r,Ct);if(!r){o=0;break t}}i+o>=c&&(t.Cc=1),o=1}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,c=e+(r?1:0),u=t,h=e+(r?0:3);for(o=0;o<n;++o){var l=u[h+4*o];255!=l&&(l*=32897,s[c+4*o+0]=s[c+4*o+0]*l>>23,s[c+4*o+1]=s[c+4*o+1]*l>>23,s[c+4*o+2]=s[c+4*o+2]*l>>23)}e+=a}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(u=t[e+2*a+1]),c=4369*s,u=(240&u|u>>4)*c>>16;t[e+2*a+0]=(240&o|o>>4)*c>>16&240|(15&o|o<<4)*c>>16>>4&15,t[e+2*a+1]=240&u|s}e+=i}}function pr(t,e,r,n,i,a,o,s){var c,u,h=255;for(u=0;u<i;++u){for(c=0;c<n;++c){var l=t[e+c];a[o+4*c]=l,h&=l}e+=r,o+=s}return 255!=h}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8}function mr(){An=fr,xn=dr,Sn=pr,_n=gr}function vr(r,n,i){t[r]=function(t,r,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[c+0]|u[h+0]<<16,A=l[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[c+w]|u[h+w]<<16,_=l[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)))}}function br(){vi[En]=bi,vi[qn]=wi,vi[Dn]=yi,vi[Rn]=Ni,vi[Tn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Wn]=Ni,vi[Vn]=Li,vi[Gn]=Ai}function yr(t){return t&~Fi?0>t?0:255:t>>Ii}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e)}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r)}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1)}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255}function Ir(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255}function Vt(t,e){return 0>t?0:t>e?e:t}function Fr(e,r,n){t[e]=function(t,e,i,a,o,s,c,u,h){for(var l=u+(-2&h)*n;u!=l;)r(t[e+0],i[a+0],o[s+0],c,u),r(t[e+1],i[a+0],o[s+0],c,u+n),e+=2,++a,++s,u+=2*n;1&h&&r(t[e+0],i[a+0],o[s+0],c,u)}}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:un(e,r,n,i)}}function Or(t,e){var r,a,o=e.M,s=e.Nb,c=t.oc,u=t.pc+40,h=t.oc,l=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)c[u+32*r-1]=129;for(r=0;8>r;++r)h[l+32*r-1]=129,f[d+32*r-1]=129;for(0<o?c[u-1-32]=h[l-1-32]=f[d-1-32]=129:(i(c,u-32-1,127,21),i(h,l-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(c,u+32*r-4,c,u+32*r+12,4);for(r=-1;8>r;++r)n(h,l+32*r-4,h,l+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4)}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(c,u-32,g[m].y,0,16),n(h,l-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=c,w=u-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=c,w=u+Di[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w)}else if(y=Cr(a,o,p.Ob[0]),li[y](c,u),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,c,u+Di[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](h,l),di[y](f,d),b=v,y=h,w=l,255&(p=r>>0)&&(170&p?cn(b,256,y,w):hn(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?cn(v,320,p,b):hn(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,c,u+480,16),n(g[m].f,0,h,l+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,c,u+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,h,l+32*r,8),n(b,y+r*t.B,f,d+32*r,8)}}function Br(t,n,i,a,o,s,c,u,h){var l=[0],f=[0],d=0,p=null!=h?h.kd:0,g=null!=h?h:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12}y=0}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=l,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else{if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1}y=0}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=c&&(c[0]=b),null!=u&&(u[0]=0),c=l[0],m=f[0],d&&b&&null==h){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var I=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=I,8>I){y=7;break t}var F=j(_,L+4);if(4294967286<F){y=3;break t}var O=8+F+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(I[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=F),L+=O,I-=O}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else{if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==u||b||(u[0]=g.xa?2:1),c=[c],m=[m],g.xa){if(5>i){y=7;break}u=c,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=u&&(u[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0}else{if(10>i){y=7;break}u=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(c&&(c[0]=b),u&&(u[0]=t),t=1))}if(!t)return 3;if(c=c[0],m=m[0],d&&(l[0]!=c||f[0]!=m))return 3;null!=h&&(h[0]=g,h.offset=n-h.w,e(4294967286>n-h.w),e(h.offset==h.ha-i));break}return 0==y||7==y&&d&&null==h?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=c),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,c=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,c=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=c||a+s>n||o+c>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+c,e.U=s,e.T=c,e.da=null!=t&&0<t.da,e.da){if(!E(s,c,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0]}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,c=-2&r.j;if(0>s||0>c||0>=i||0>=o||s+i>t||c+o>e)return 2;t=i,e=o}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0]}}n.width=t,n.height=e;t:{var u=n.width,h=n.height;if(t=n.S,0>=u||0>=h||!(t>=En&&13>t))t=2;else{if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var l=(c=u*zi[t])*h;if(11>t||(o=(h+1)/2*(e=(u+1)/2),12==t&&(s=(i=u)*h)),null==(h=a(l+2*o+s))){t=1;break t}n.sd=h,11>t?((u=n.f.RGBA).eb=h,u.fb=0,u.A=c,u.size=l):((u=n.f.kb).y=h,u.O=0,u.fa=c,u.Fd=l,u.f=h,u.N=0+l,u.Ab=e,u.Cd=o,u.ea=h,u.W=0+l+o,u.Db=e,u.Ed=o,12==t&&(u.F=h,u.J=0+l+2*o),u.Tc=s,u.lb=i)}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(c=Math.abs(t.A))*(s-1)+o<=t.size,e&=c>=o*zi[i],e&=null!=t.eb;else{t=n.f.kb,c=(o+1)/2,l=(s+1)/2,u=Math.abs(t.fa);h=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=u*(s-1)+o<=t.Fd,e&=h*(l-1)+c<=t.Cd,e=(e&=f*(l-1)+c<=t.Ed)&u>=o&h>=c&f>=c,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F)}else e=0;t=e?0:2}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Dr=64,Rr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Tr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];R("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=W(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+W(n>>16&255,t>>16&255,e>>16&255)+W(n>>8&255,t>>8&255,e>>8&255)+W(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return(z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return(H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Wr=t.PredictorAdd0;t.PredictorAdd1=V,R("Predictor2","PredictorAdd2"),R("Predictor3","PredictorAdd3"),R("Predictor4","PredictorAdd4"),R("Predictor5","PredictorAdd5"),R("Predictor6","PredictorAdd6"),R("Predictor7","PredictorAdd7"),R("Predictor8","PredictorAdd8"),R("Predictor9","PredictorAdd9"),R("Predictor10","PredictorAdd10"),R("Predictor11","PredictorAdd11"),R("Predictor12","PredictorAdd12"),R("Predictor13","PredictorAdd13");var Vr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,cn,un,hn,ln,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),In=a(225),Fn=a(767),Cn=0,jn=kn,On=In,Bn=Fn,Mn=Pn,En=0,qn=1,Dn=2,Rn=3,Tn=4,Un=5,zn=6,Hn=7,Wn=8,Vn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ci=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ui=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],hi=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],li=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Ir,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Ii=6,Fi=(256<<Ii)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Fr("YuvToRgbRow",Ar,3),Fr("YuvToBgrRow",xr,3),Fr("YuvToRgbaRow",Ir,4),Fr("YuvToBgraRow",kr,4),Fr("YuvToArgbRow",Pr,4),Fr("YuvToRgba4444Row",_r,2),Fr("YuvToRgb565Row",Sr,2);var Di=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ri=[0,2,8],Ti=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,c=new ot;s.ba=c,c.S=o,c.width=[c.width],c.height=[c.height];var u=c.width,h=c.height,l=new st;if(null==l||null==t)var f=2;else e(null!=l),f=Br(t,r,n,l.width,l.height,l.Pd,l.Qd,l.format,null);if(0!=f?u=0:(null!=u&&(u[0]=l.width[0]),null!=h&&(h[0]=l.height[0]),u=1),u){c.width=c.width[0],c.height=c.height[0],null!=i&&(i[0]=c.width),null!=a&&(a[0]=c.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!It(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Rn)){i.a=2;break r}if(!Ft(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0}i=!i}i&&(r=t.a)}else r=t.a}else{if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(u=0>(u=n.Md)?0:100<u?255:255*u/100)){for(h=l=0;4>h;++h)12>(f=a.pb[h]).lc&&(f.ia=u*Ti[0>f.lc?0:f.lc]>>3),l|=f.ia;l&&(alert("todo:VP8InitRandom"),a.ia=1)}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0)}Qt(t,i)||(r=t.a)}}else r=t.a}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba))}s=r}o=0!=s?null:11>o?c.f.RGBA.eb:c.f.kb.y}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1]};function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function h(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function l(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new c;var f=[0],d=[0],p=[],g=new c,m=t,v=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
   * Copyright (c) 2017 Dominik Homberger
  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  https://webpjs.appspot.com
  WebPRiffParser dominikhlbg@gmail.com
  */
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return!0;return!1}(t,e,"RIFF",4)){var s,c;l(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=l(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+h(t,g);g+=3;v.canvas_height=1+h(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=l(t,e);g=e+4;v.loop_count=(s=t)[(c=g)+0]<<0|s[c+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*h(t,e),e+=3,v.offset_y=2*h(t,e),e+=3,v.width=1+h(t,e),e+=3,v.height=1+h(t,e),e+=3,v.duration=h(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1}"ANMF"!=f&&(e+=p)}return r}}(m,0);v.response=m,v.rgbaoutput=!0,v.dataurl=!1;var b=v.header?v.header:null,y=v.frames?v.frames:null;if(b){b.loop_counter=b.loop_count,f=[b.canvas_height],d=[b.canvas_width];for(var w=0;w<y.length&&0!=y[w].blend;w++);}var N=y[0],L=g.WebPDecodeRGBA(m,N.src_off,N.src_size,d,f);N.rgba=L,N.imgwidth=d[0],N.imgheight=f[0];for(var A=0;A<d[0]*f[0]*4;A++)p[A]=L[A];return this.width=d,this.height=f,this.data=p,this}!function(t){var r=function(){return"function"==typeof __WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */]},n=function(r,n,a,h){var l=4,f=s;switch(h){case t.image_compression.FAST:l=1,f=o;break;case t.image_compression.MEDIUM:l=6,f=c;break;case t.image_compression.SLOW:l=9,f=u}r=i(r,n,a,f);var d=Object(__WEBPACK_IMPORTED_MODULE_1_fflate__["b" /* zlibSync */])(r,{level:l});return t.__addimage__.arrayBufferToBinaryString(d)},i=function(t,e,r,n){for(var i,a,o,s=t.length/e,c=new Uint8Array(t.length+s),u=l(),h=0;h<s;h+=1){if(o=h*e,i=t.subarray(o,o+e),n)c.set(n(i,r,a),o+h);else{for(var d,p=u.length,g=[];d<p;d+=1)g[d]=u[d](i,r,a);var m=f(g.concat());c.set(g[m],o+h)}a=i}return c},a=function(t){var e=Array.apply([],t);return e.unshift(0),e},o=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},s=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},c=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},u=function(t,e,r){var n,i,a,o,s=[],c=t.length;s[0]=4;for(var u=0;u<c;u+=1)n=t[u-e]||0,i=r&&r[u]||0,a=r&&r[u-e]||0,o=h(n,i,a),s[u+1]=t[u]-o+256&255;return s},h=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},l=function(){return[a,o,s,c,u]},f=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};t.processPNG=function(e,i,a,o){var s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(e)&&(e=new Uint8Array(e)),this.__addimage__.isArrayBufferView(e)){if(e=(u=new Kt(e)).imgData,c=u.bits,s=u.colorSpace,l=u.colors,-1!==[4,6].indexOf(u.colorType)){if(8===u.bits){g=(p=32==u.pixelBitlength?new Uint32Array(u.decodePixels().buffer):16==u.pixelBitlength?new Uint16Array(u.decodePixels().buffer):new Uint8Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*u.colors),m=new Uint8Array(g);var x,S=u.pixelBitlength-u.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=u.bits;m[w]=y>>>x&255}}if(16===u.bits){g=(p=new Uint32Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*(32/u.pixelBitlength)*u.colors),m=new Uint8Array(g*(32/u.pixelBitlength)),b=u.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;c=8}o!==t.image_compression.NONE&&r()?(e=n(v,u.width*u.colors,u.colors,o),d=n(m,u.width,1,o)):(e=v,d=m,L=void 0)}if(3===u.colorType&&(s=this.color_spaces.INDEXED,f=u.palette,u.transparency.indexed)){var P=u.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))h=[P.indexOf(0)];else if(k!==g){for(p=u.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=n(m,u.width,1)}}var I=function(e){var r;switch(e){case t.image_compression.FAST:r=11;break;case t.image_compression.MEDIUM:r=13;break;case t.image_compression.SLOW:r=14;break;default:r=12}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+I+" "),A+="/Colors "+l+" /BitsPerComponent "+c+" /Columns "+u.width,(this.__addimage__.isArrayBuffer(e)||this.__addimage__.isArrayBufferView(e))&&(e=this.__addimage__.arrayBufferToBinaryString(e)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:e,index:i,filter:L,decodeParameters:A,transparency:h,palette:f,sMask:d,predictor:I,width:u.width,height:u.height,bitsPerComponent:c,colorSpace:s}}}}(E.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Zt(e),o=a.width,s=a.height,c=[];a.decodeAndBlitFrameRGBA(0,c);var u={data:c,width:o,height:s},h=new Qt(100).encode(u,100);return t.processJPEG.call(this,h,r,n,i)},t.processGIF87A=t.processGIF89A}(E.API),te.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},te.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){a.log("bit decode error:"+t)}},te.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var c=this.palette[a>>7-s&1];this.data[o+4*s]=c.blue,this.data[o+4*s+1]=c.green,this.data[o+4*s+2]=c.red,this.data[o+4*s+3]=255}0!==r&&(this.pos+=4-r)}},te.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,c=15&a,u=this.palette[s];if(this.data[o]=u.blue,this.data[o+1]=u.green,this.data[o+2]=u.red,this.data[o+3]=255,2*i+1>=this.width)break;u=this.palette[c],this.data[o+4]=u.blue,this.data[o+4+1]=u.green,this.data[o+4+2]=u.red,this.data[o+4+3]=255}0!==e&&(this.pos+=4-e)}},te.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255}0!==t&&(this.pos+=4-t)}},te.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,c=(a>>10&e)/e*255|0,u=a>>15?255:0,h=n*this.width*4+4*i;this.data[h]=c,this.data[h+1]=s,this.data[h+2]=o,this.data[h+3]=u}this.pos+=t}},te.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,c=(o>>5&r)/r*255|0,u=(o>>11)/e*255|0,h=i*this.width*4+4*a;this.data[h]=u,this.data[h+1]=c,this.data[h+2]=s,this.data[h+3]=255}this.pos+=t}},te.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255}this.pos+=this.width%4}},te.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o}},te.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2018 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processBMP=function(e,r,n,i){var a=new te(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(E.API),ee.prototype.getData=function(){return this.data},
/**
 * @license
 * Copyright (c) 2019 Aras Abbasi
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){t.processWEBP=function(e,r,n,i){var a=new ee(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Qt(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(E.API),E.API.processRGBA=function(t,e,r){for(var n=t.data,i=n.length,a=new Uint8Array(i/4*3),o=new Uint8Array(i/4),s=0,c=0,u=0;u<i;u+=4){var h=n[u],l=n[u+1],f=n[u+2],d=n[u+3];a[s++]=h,a[s++]=l,a[s++]=f,o[c++]=d}var p=this.__addimage__.arrayBufferToBinaryString(a);return{alpha:this.__addimage__.arrayBufferToBinaryString(o),data:p,index:e,alias:r,colorSpace:"DeviceRGB",bitsPerComponent:8,width:t.width,height:t.height}},E.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"North Macedonia",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")})),this.internal.languageSettings.isSubscribed=!0)),this},Vt=E.API,Gt=Vt.getCharWidthsArray=function(e,r){var n,i,a=(r=r||{}).font||this.internal.getFont(),o=r.fontSize||this.internal.getFontSize(),s=r.charSpace||this.internal.getCharSpace(),c=r.widths?r.widths:a.metadata.Unicode.widths,u=c.fof?c.fof:1,h=r.kerning?r.kerning:a.metadata.Unicode.kerning,l=h.fof?h.fof:1,f=!1!==r.doKerning,d=0,p=e.length,g=0,m=c[0]||u,v=[];for(n=0;n<p;n++)i=e.charCodeAt(n),"function"==typeof a.metadata.widthOfString?v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i))+s*(1e3/o)||0)/1e3):(d=f&&"object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(h[i])&&!isNaN(parseInt(h[i][g],10))?h[i][g]/l:0,v.push((c[i]||m)/u+d)),g=i;return v},Yt=Vt.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return Vt.processArabic&&(t=Vt.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Gt.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Jt=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var c=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(c,a)),s=0,c=a),s+=e[a],a++;return c!==a&&i.push(t.slice(c,a)),i},Xt=function(t,e,r){r||(r={});var n,i,a,o,s,c,u,h=[],l=[h],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Gt.apply(this,[" ",r])[0];if(c=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(c).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return(e&&t.length?"\n":"")+t}))):b.push(t[0])})),g=b,c=Yt.apply(this,[v,r])}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],c&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Gt.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Jt.apply(this,[n,i,e-(f+d),e]),h.push(s.shift()),h=[s.pop()];s.length;)l.push([s.shift()]);p=i.slice(n.length-(h[0]?h[0].length:0)).reduce((function(t,e){return t+e}),0)}else h=[n];l.push(h),f=p+c,d=m}else h.push(n),f+=d+p,d=m}return u=c?function(t,e){return(e?v:"")+t.join(" ")}:function(t){return t.join(" ")},l.map(u)},Vt.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,c,u=[];for(s=0,c=n.length;s<c;s++)u=u.concat(Xt.apply(this,[n[s],o,a]));return u},function(e){e.__fontmetrics__=e.__fontmetrics__||{};for(var r="klmnopqrstuvwxyz",n={},i={},a=0;a<r.length;a++)n[r[a]]="0123456789abcdef"[a],i["0123456789abcdef"[a]]=r[a];var o=function(t){return"0x"+parseInt(t,10).toString(16)},s=e.__fontmetrics__.compress=function(e){var r,n,a,c,u=["{"];for(var h in e){if(r=e[h],isNaN(parseInt(h,10))?n="'"+h+"'":(h=parseInt(h,10),n=(n=o(h).slice(2)).slice(0,-1)+i[n.slice(-1)]),"number"==typeof r)r<0?(a=o(r).slice(3),c="-"):(a=o(r).slice(2),c=""),a=c+a.slice(0,-1)+i[a.slice(-1)];else{if("object"!==__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r))throw new Error("Don't know what to do with value type "+__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(r)+".");a=s(r)}u.push(n+a)}return u.push("}"),u.join("")},c=e.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,r,i,a,o={},s=1,c=o,u=[],h="",l="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(u.push([c,i]),c={},i=void 0):"}"==a?((r=u.pop())[0][r[1]]=c,i=void 0,c=r[0]):"-"==a?s=-1:void 0===i?n.hasOwnProperty(a)?(h+=n[a],i=parseInt(h,16)*s,s=1,h=""):h+=a:n.hasOwnProperty(a)?(l+=n[a],c[i]=parseInt(l,16)*s,s=1,i=void 0,l=""):l+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},h={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},l={Unicode:{"Courier-Oblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};e.events.push(["addFont",function(t){var e=t.font,r=l.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=h.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0])}])}(E.API),
/**
 * @license
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(u(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0]}(i,n)}}])}(E),
/** @license
 * Copyright (c) 2012 Willow Systems Corporation, https://github.com/willowsystems
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){function e(){return(n.canvg?Promise.resolve(n.canvg):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 188))).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}E.API.addSvgAsImage=function(t,r,n,i,o,s,c,u){if(isNaN(r)||isNaN(n))throw a.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(i)||isNaN(o))throw a.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var h=document.createElement("canvas");h.width=i,h.height=o;var l=h.getContext("2d");l.fillStyle="#fff",l.fillRect(0,0,h.width,h.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return e().then((function(e){return e.fromString(l,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(h.toDataURL("image/jpeg",1),r,n,i,o,c,u)}))}}(),E.API.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this},E.API.viewerPreferences=function(e,r){var n;e=e||{},r=r||!1;var i,a,o,s={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},c=Object.keys(s),u=[],h=0,l=0,f=0;function d(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(s)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===e||!0===r){var p=c.length;for(f=0;f<p;f+=1)n[c[f]].value=n[c[f]].defaultValue,n[c[f]].explicitSet=!1}if("object"===__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(e))for(a in e)if(o=e[a],d(c,a)&&void 0!==o){if("boolean"===n[a].type&&"boolean"==typeof o)n[a].value=o;else if("name"===n[a].type&&d(n[a].valueSet,o))n[a].value=o;else if("integer"===n[a].type&&Number.isInteger(o))n[a].value=o;else if("array"===n[a].type){for(h=0;h<o.length;h+=1)if(i=!0,1===o[h].length&&"number"==typeof o[h][0])u.push(String(o[h]-1));else if(o[h].length>1){for(l=0;l<o[h].length;l+=1)"number"!=typeof o[h][l]&&(i=!1);!0===i&&u.push([o[h][0]-1,o[h][1]-1].join(" "))}n[a].value="["+u.join(" ")+"]"}else n[a].value=n[a].defaultValue;n[a].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ====================================================================
 * @license
 * jsPDF XMP metadata plugin
 * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * ====================================================================
 */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj")},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R")};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this}}(E.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r)}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var s=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),u="",h=0;h<c.length;h++)u+=String.fromCharCode(c[h]);var l=a();o({data:u,addLength1:!0,objectId:l}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+F(r.fontName)),i("/FontFile2 "+l+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var p=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+F(r.fontName)),i("/FontDescriptor "+d+" 0 R"),i("/W "+t.API.PDFObject.convert(s)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+f+" 0 R"),i("/BaseFont /"+F(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+p+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var s=r.metadata.rawData,c="",u=0;u<s.length;u++)c+=String.fromCharCode(s[u]);var h=a();o({data:c,addLength1:!0,objectId:h}),i("endobj");var l=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:l}),i("endobj");var f=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+h+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+F(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var d=0;d<r.metadata.hmtx.widths.length;d++)r.metadata.hmtx.widths[d]=parseInt(r.metadata.hmtx.widths[d]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+F(r.fontName)+"/FontDescriptor "+f+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},c=s.pdfEscape,u=s.activeFontKey,h=s.fonts,l=u,f="",d=0,p="",g=h[l].encoding;if("Identity-H"!==h[l].encoding)return{text:n,x:i,y:a,options:o,mutex:s};for(p=n,l=u,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)h[l].metadata.hasOwnProperty("cmap")&&(e=h[l].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&h[l].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(l.slice(1))<14||"WinAnsiEncoding"===g?m=c(f,l).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,h[l])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r}else t.text=i(Object.assign({},n,{text:e})).text}])}(E),
/**
 * @license
 * jsPDF virtual FileSystem functionality
 *
 * Licensed under the MIT License.
 * http://opensource.org/licenses/mit-license
 */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null}}(E.API),
/**
 * @license
 * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
 * MIT License
 */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,c,u=e,h=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],l=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?u[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return!1;if("R"===e)return!0}return!1},w=function(t,e,o,s){var c,u,h,l,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(c=o[s-1])&&"AN"!==c||"EN"!==(u=e[s+1])&&"AN"!==u?f="N":m&&(u="AN"),f=u===c?u:"N";break;case"ES":f="EN"===(c=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(h=s+1,l=e.length;h<l&&"ET"===e[h];)h++;f=h<l&&"EN"===e[h]?"EN":"N";break;case"NSM":if(i&&!a){for(l=e.length,h=s+1;h<l&&"NSM"===e[h];)h++;if(h<l){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(c=e[h],p&&("R"===c||"AL"===c)){f="R";break}}}f=s<1||"B"===(c=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N"}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,c,u,d=-1,p=t.length,g=0,y=[],N=v?l:h,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(u=g,y[s]=w(t,L,y,s),a=240&(g=N[u][f[y[s]]]),g&=15,e[s]=c=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=c;d=-1}"B"===L[s]&&(e[s]=0),i.hiLevel|=c}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v}}(L,e,p)},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,c,u,h=e.length,l=0;l<h;){if(i[l]>=t){for(c=l+1;c<h&&i[c]>=t;)c++;for(u=l,s=c-1;u<s;u++,s--)o=e[u],e[u]=e[s],e[s]=o,n&&(o=n[u],n[u]=n[s],n[s]=o);l=c}l++}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&c)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1])}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t))}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=c;a?(v=1,t=x(t,e,r),v=0,c=!1,t=x(t,e,r),c=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,c=!1,t=x(t,e,r),c=n,t=N(t,e))}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,c=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0})}])}(E),E.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new ne(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new Le(this),this.registerTTF()}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new ie(this.contents),this.head=new se(this),this.name=new pe(this),this.cmap=new ue(this),this.toUnicode={},this.hhea=new he(this),this.maxp=new ge(this),this.hmtx=new me(this),this.post=new fe(this),this.os2=new le(this),this.loca=new Ne(this),this.glyf=new be(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var re,ne=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return(t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return(t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),ie=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return e.prototype.encode=function(e){var r,n,i,a,o,s,c,u,h,l,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),h=16*Math.floor(Math.log(f)/s),a=Math.floor(h/s),u=16*f-h,(n=new ne).writeInt(this.scalarType),n.writeShort(f),n.writeShort(h),n.writeShort(a),n.writeShort(u),i=16*f,c=n.pos+i,o=null,d=[],e)for(l=e[p],n.writeString(p),n.writeInt(t(l)),n.writeInt(c),n.writeInt(l.length),d=d.concat(l),"head"===p&&(o=c),c+=l.length;c%4;)d.push(0),c++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=ve.call(t);t.length%4;)t.push(0);for(n=new ne(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),ae={}.hasOwnProperty,oe=function(t,e){for(var r in e)ae.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t};re=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var se=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new ne).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),ce=function(){function t(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),h=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),l=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=l?e<l:e>l;s=0<=l?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===u[s]?a=r+c[s]:0!==(a=o[u[s]/2+(r-d)-(l-s)]||0)&&(a+=c[s]),this.codeMap[r]=65535&a}t.pos=h}return t.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,I,F,C,j,O,B,M,E,q,D,R,T,U,z,H,W,V,G,Y;switch(I=new ne,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},F=0,B=a.length;F<B;F++)null==v[W=t[n=a[F]]]&&(v[W]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return I.writeUInt16(1),I.writeUInt16(0),I.writeUInt32(12),I.writeUInt16(0),I.writeUInt16(262),I.writeUInt16(0),I.write(g),{charMap:i,subtable:I.data,maxGlyphID:p+1};case"unicode":for(P=[],h=[],b=0,v={},r={},m=c=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===c||(m&&h.push(m),P.push(n),c=o),m=n;for(m&&h.push(m),h.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),l=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],u=h[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=u?O<=u:O>=u;n=_<=u?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0)}for(I.writeUInt16(3),I.writeUInt16(1),I.writeUInt32(12),I.writeUInt16(4),I.writeUInt16(16+8*x+2*f.length),I.writeUInt16(0),I.writeUInt16(S),I.writeUInt16(A),I.writeUInt16(l),I.writeUInt16(L),z=0,q=h.length;z<q;z++)n=h[z],I.writeUInt16(n);for(I.writeUInt16(0),H=0,D=P.length;H<D;H++)n=P[H],I.writeUInt16(n);for(V=0,R=s.length;V<R;V++)o=s[V],I.writeUInt16(o);for(G=0,T=N.length;G<T;G++)y=N[G],I.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],I.writeUInt16(p);return{charMap:r,subtable:I.data,maxGlyphID:b+1}}},t}(),ue=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new ce(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=ce.encode(t,e),(n=new ne).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(),he=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),le=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(),fe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(),de=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},pe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,c,u,h,l;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=u=0,h=r.length;u<h;i=++u)n=r[i],t.pos=n.offset,c=t.readString(n.length),a=new de(c,n),null==s[l=n.nameID]&&(s[l]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),ge=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),me=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),ve=[].slice,be=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,c,u,h;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new ne(e.read(n))).readShort(),c=o.readShort(),h=o.readShort(),s=o.readShort(),u=o.readShort(),this.cache[t]=-1===a?new we(o,c,h,s,u):new ye(o,a,c,h,s,u),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(),ye=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),we=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(){var t,e,r;for(e=new ne(ve.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),Ne=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return oe(e,re),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s)}for(var c=new Array(4*r.length),u=0;u<r.length;++u)c[4*u+3]=255&r[u],c[4*u+2]=(65280&r[u])>>8,c[4*u+1]=(16711680&r[u])>>16,c[4*u]=(4278190080&r[u])>>24;return c},e}(),Le=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,c,u,h,l,f,d,p,g,m;for(n in r=ue.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in l=r.maxGlyphID,a)d in f||(f[d]=l++);return u=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),h=Object.keys(u).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=h.length;t<e;t++)o=h[t],r.push(u[o]);return r}(),i=this.font.glyf.encode(a,p,f),c=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:c,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();E.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return"["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return""+r},e}();/* harmony default export */ __webpack_exports__["a"] = (E);
//# sourceMappingURL=jspdf.es.min.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 184 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Deflate */
/* unused harmony export AsyncDeflate */
/* unused harmony export deflate */
/* unused harmony export deflateSync */
/* unused harmony export Inflate */
/* unused harmony export AsyncInflate */
/* unused harmony export inflate */
/* unused harmony export inflateSync */
/* unused harmony export Gzip */
/* unused harmony export AsyncGzip */
/* unused harmony export gzip */
/* unused harmony export gzipSync */
/* unused harmony export Gunzip */
/* unused harmony export AsyncGunzip */
/* unused harmony export gunzip */
/* unused harmony export gunzipSync */
/* unused harmony export Zlib */
/* unused harmony export AsyncZlib */
/* unused harmony export zlib */
/* harmony export (immutable) */ __webpack_exports__["b"] = zlibSync;
/* unused harmony export Unzlib */
/* unused harmony export AsyncUnzlib */
/* unused harmony export unzlib */
/* harmony export (immutable) */ __webpack_exports__["a"] = unzlibSync;
/* unused harmony export compress */
/* unused harmony export AsyncCompress */
/* unused harmony export compressSync */
/* unused harmony export Compress */
/* unused harmony export Decompress */
/* unused harmony export AsyncDecompress */
/* unused harmony export decompress */
/* unused harmony export decompressSync */
/* unused harmony export strToU8 */
/* unused harmony export strFromU8 */
/* unused harmony export zip */
/* unused harmony export zipSync */
/* unused harmony export unzip */
/* unused harmony export unzipSync */
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Much of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// Many optimizations have been made, so the bundle size is ultimately smaller but performance is similar.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var ch2 = {};
var wk = (function (c, id, msg, transfer, cb) {
    var u = ch2[id] || (ch2[id] = URL.createObjectURL(new Blob([c], { type: 'text/javascript' })));
    var w = new Worker(u);
    w.onerror = function (e) { return cb(e.error, null); };
    w.onmessage = function (e) { return cb(null, e.data); };
    w.postMessage(msg, transfer);
    return w;
});

// aliases for shorter compressed code (most minifers don't do this)
var u8 = Uint8Array, u16 = Uint16Array, u32 = Uint32Array;
// fixed length extra bits
var fleb = new u8([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, /* unused */ 0, 0, /* impossible */ 0]);
// fixed distance extra bits
// see fleb note
var fdeb = new u8([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, /* unused */ 0, 0]);
// code length index map
var clim = new u8([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]);
// get base, reverse index map from extra bits
var freb = function (eb, start) {
    var b = new u16(31);
    for (var i = 0; i < 31; ++i) {
        b[i] = start += 1 << eb[i - 1];
    }
    // numbers here are at max 18 bits
    var r = new u32(b[30]);
    for (var i = 1; i < 30; ++i) {
        for (var j = b[i]; j < b[i + 1]; ++j) {
            r[j] = ((j - b[i]) << 5) | i;
        }
    }
    return [b, r];
};
var _a = freb(fleb, 2), fl = _a[0], revfl = _a[1];
// we can ignore the fact that the other numbers are wrong; they never happen anyway
fl[28] = 258, revfl[258] = 28;
var _b = freb(fdeb, 0), fd = _b[0], revfd = _b[1];
// map of value to reverse (assuming 16 bits)
var rev = new u16(32768);
for (var i = 0; i < 32768; ++i) {
    // reverse table algorithm from SO
    var x = ((i & 0xAAAA) >>> 1) | ((i & 0x5555) << 1);
    x = ((x & 0xCCCC) >>> 2) | ((x & 0x3333) << 2);
    x = ((x & 0xF0F0) >>> 4) | ((x & 0x0F0F) << 4);
    rev[i] = (((x & 0xFF00) >>> 8) | ((x & 0x00FF) << 8)) >>> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var hMap = (function (cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new u16(mb);
    // length of cd must be 288 (total # of codes)
    for (; i < s; ++i)
        ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new u16(mb);
    for (i = 0; i < mb; ++i) {
        le[i] = (le[i - 1] + l[i - 1]) << 1;
    }
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for (i = 0; i < s; ++i) {
            // ignore 0 lengths
            if (cd[i]) {
                // num encoding both symbol and bits read
                var sv = (i << 4) | cd[i];
                // free bits
                var r_1 = mb - cd[i];
                // start value
                var v = le[cd[i] - 1]++ << r_1;
                // m is end value
                for (var m = v | ((1 << r_1) - 1); v <= m; ++v) {
                    // every 16 bit value starting with the code yields the same result
                    co[rev[v] >>> rvb] = sv;
                }
            }
        }
    }
    else {
        co = new u16(s);
        for (i = 0; i < s; ++i)
            co[i] = rev[le[cd[i] - 1]++] >>> (15 - cd[i]);
    }
    return co;
});
// fixed length tree
var flt = new u8(288);
for (var i = 0; i < 144; ++i)
    flt[i] = 8;
for (var i = 144; i < 256; ++i)
    flt[i] = 9;
for (var i = 256; i < 280; ++i)
    flt[i] = 7;
for (var i = 280; i < 288; ++i)
    flt[i] = 8;
// fixed distance tree
var fdt = new u8(32);
for (var i = 0; i < 32; ++i)
    fdt[i] = 5;
// fixed length map
var flm = /*#__PURE__*/ hMap(flt, 9, 0), flrm = /*#__PURE__*/ hMap(flt, 9, 1);
// fixed distance map
var fdm = /*#__PURE__*/ hMap(fdt, 5, 0), fdrm = /*#__PURE__*/ hMap(fdt, 5, 1);
// find max of array
var max = function (a) {
    var m = a[0];
    for (var i = 1; i < a.length; ++i) {
        if (a[i] > m)
            m = a[i];
    }
    return m;
};
// read d, starting at bit p and mask with m
var bits = function (d, p, m) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8)) >>> (p & 7)) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var bits16 = function (d, p) {
    var o = (p / 8) >> 0;
    return ((d[o] | (d[o + 1] << 8) | (d[o + 2] << 16)) >>> (p & 7));
};
// get end of byte
var shft = function (p) { return ((p / 8) >> 0) + (p & 7 && 1); };
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var slc = function (v, s, e) {
    if (s == null || s < 0)
        s = 0;
    if (e == null || e > v.length)
        e = v.length;
    // can't use .constructor in case user-supplied
    var n = new (v instanceof u16 ? u16 : v instanceof u32 ? u32 : u8)(e - s);
    n.set(v.subarray(s, e));
    return n;
};
// expands raw DEFLATE data
var inflt = function (dat, buf, st) {
    // source length
    var sl = dat.length;
    // have to estimate size
    var noBuf = !buf || st;
    // no state
    var noSt = !st || st.i;
    if (!st)
        st = {};
    // Assumes roughly 33% compression ratio average
    if (!buf)
        buf = new u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function (l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            st.f = final = bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = shft(pos) + 4, l = dat[s - 4] | (dat[s - 3] << 8), t = s + l;
                if (t > sl) {
                    if (noSt)
                        throw 'unexpected EOF';
                    break;
                }
                // ensure size
                if (noBuf)
                    cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8;
                continue;
            }
            else if (type == 1)
                lm = flrm, dm = fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = bits(dat, pos, 31) + 257, hcLen = bits(dat, pos + 10, 15) + 4;
                var tl = hLit + bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new u8(tl);
                // code length tree
                var clt = new u8(19);
                for (var i = 0; i < hcLen; ++i) {
                    // use index map to get real code
                    clt[clim[i]] = bits(dat, pos + i * 3, 7);
                }
                pos += hcLen * 3;
                // code lengths bits
                var clb = max(clt), clbmsk = (1 << clb) - 1;
                if (!noSt && pos + tl * (clb + 7) > tbts)
                    break;
                // code lengths map
                var clm = hMap(clt, clb, 1);
                for (var i = 0; i < tl;) {
                    var r = clm[bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >>> 4;
                    // code length to copy
                    if (s < 16) {
                        ldt[i++] = s;
                    }
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16)
                            n = 3 + bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17)
                            n = 3 + bits(dat, pos, 7), pos += 3;
                        else if (s == 18)
                            n = 11 + bits(dat, pos, 127), pos += 7;
                        while (n--)
                            ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = max(lt);
                // max dist bits
                dbt = max(dt);
                lm = hMap(lt, lbt, 1);
                dm = hMap(dt, dbt, 1);
            }
            else
                throw 'invalid block type';
            if (pos > tbts)
                throw 'unexpected EOF';
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17;
        if (noBuf)
            cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var mxa = lbt + dbt + 18;
        while (noSt || pos + mxa < tbts) {
            // bits read, code
            var c = lm[bits16(dat, pos) & lms], sym = c >>> 4;
            pos += c & 15;
            if (pos > tbts)
                throw 'unexpected EOF';
            if (!c)
                throw 'invalid length/literal';
            if (sym < 256)
                buf[bt++] = sym;
            else if (sym == 256) {
                lm = null;
                break;
            }
            else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = fleb[i];
                    add = bits(dat, pos, (1 << b) - 1) + fl[i];
                    pos += b;
                }
                // dist
                var d = dm[bits16(dat, pos) & dms], dsym = d >>> 4;
                if (!d)
                    throw 'invalid distance';
                pos += d & 15;
                var dt = fd[dsym];
                if (dsym > 3) {
                    var b = fdeb[dsym];
                    dt += bits16(dat, pos) & ((1 << b) - 1), pos += b;
                }
                if (pos > tbts)
                    throw 'unexpected EOF';
                if (noBuf)
                    cbuf(bt + 131072);
                var end = bt + add;
                for (; bt < end; bt += 4) {
                    buf[bt] = buf[bt - dt];
                    buf[bt + 1] = buf[bt + 1 - dt];
                    buf[bt + 2] = buf[bt + 2 - dt];
                    buf[bt + 3] = buf[bt + 3 - dt];
                }
                bt = end;
            }
        }
        st.l = lm, st.p = pos, st.b = bt;
        if (lm)
            final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    } while (!final);
    return bt == buf.length ? buf : slc(buf, 0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var wbits = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var wbits16 = function (d, p, v) {
    v <<= p & 7;
    var o = (p / 8) >> 0;
    d[o] |= v;
    d[o + 1] |= v >>> 8;
    d[o + 2] |= v >>> 16;
};
// creates code lengths from a frequency table
var hTree = function (d, mb) {
    // Need extra info to make a tree
    var t = [];
    for (var i = 0; i < d.length; ++i) {
        if (d[i])
            t.push({ s: i, f: d[i] });
    }
    var s = t.length;
    var t2 = t.slice();
    if (!s)
        return [new u8(0), 0];
    if (s == 1) {
        var v = new u8(t[0].s + 1);
        v[t[0].s] = 1;
        return [v, 1];
    }
    t.sort(function (a, b) { return a.f - b.f; });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({ s: -1, f: 25001 });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = { s: -1, f: l.f + r.f, l: l, r: r };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while (i1 != s - 1) {
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = { s: -1, f: l.f + r.f, l: l, r: r };
    }
    var maxSym = t2[0].s;
    for (var i = 1; i < s; ++i) {
        if (t2[i].s > maxSym)
            maxSym = t2[i].s;
    }
    // code lengths
    var tr = new u16(maxSym + 1);
    // max bits in tree
    var mbt = ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function (a, b) { return tr[b.s] - tr[a.s] || a.f - b.f; });
        for (; i < s; ++i) {
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << (mbt - tr[i2_1]));
                tr[i2_1] = mb;
            }
            else
                break;
        }
        dt >>>= lft;
        while (dt > 0) {
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb)
                dt -= 1 << (mb - tr[i2_2]++ - 1);
            else
                ++i;
        }
        for (; i >= 0 && dt; --i) {
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return [new u8(tr), mbt];
};
// get the max length and assign length codes
var ln = function (n, l, d) {
    return n.s == -1
        ? Math.max(ln(n.l, l, d + 1), ln(n.r, l, d + 1))
        : (l[n.s] = d);
};
// length codes generation
var lc = function (c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while (s && !c[--s])
        ;
    var cl = new u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function (v) { cl[cli++] = v; };
    for (var i = 1; i <= s; ++i) {
        if (c[i] == cln && i != s)
            ++cls;
        else {
            if (!cln && cls > 2) {
                for (; cls > 138; cls -= 138)
                    w(32754);
                if (cls > 2) {
                    w(cls > 10 ? ((cls - 11) << 5) | 28690 : ((cls - 3) << 5) | 12305);
                    cls = 0;
                }
            }
            else if (cls > 3) {
                w(cln), --cls;
                for (; cls > 6; cls -= 6)
                    w(8304);
                if (cls > 2)
                    w(((cls - 3) << 5) | 8208), cls = 0;
            }
            while (cls--)
                w(cln);
            cls = 1;
            cln = c[i];
        }
    }
    return [cl.subarray(0, cli), s];
};
// calculate the length of output from tree, code lengths
var clen = function (cf, cl) {
    var l = 0;
    for (var i = 0; i < cl.length; ++i)
        l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var wfblk = function (out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >>> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for (var i = 0; i < s; ++i)
        out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var wblk = function (dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    wbits(out, p++, final);
    ++lf[256];
    var _a = hTree(lf, 15), dlt = _a[0], mlb = _a[1];
    var _b = hTree(df, 15), ddt = _b[0], mdb = _b[1];
    var _c = lc(dlt), lclt = _c[0], nlc = _c[1];
    var _d = lc(ddt), lcdt = _d[0], ndc = _d[1];
    var lcfreq = new u16(19);
    for (var i = 0; i < lclt.length; ++i)
        lcfreq[lclt[i] & 31]++;
    for (var i = 0; i < lcdt.length; ++i)
        lcfreq[lcdt[i] & 31]++;
    var _e = hTree(lcfreq, 7), lct = _e[0], mlcb = _e[1];
    var nlcc = 19;
    for (; nlcc > 4 && !lct[clim[nlcc - 1]]; --nlcc)
        ;
    var flen = (bl + 5) << 3;
    var ftlen = clen(lf, flt) + clen(df, fdt) + eb;
    var dtlen = clen(lf, dlt) + clen(df, ddt) + eb + 14 + 3 * nlcc + clen(lcfreq, lct) + (2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18]);
    if (flen <= ftlen && flen <= dtlen)
        return wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = hMap(dlt, mlb, 0), ll = dlt, dm = hMap(ddt, mdb, 0), dl = ddt;
        var llm = hMap(lct, mlcb, 0);
        wbits(out, p, nlc - 257);
        wbits(out, p + 5, ndc - 1);
        wbits(out, p + 10, nlcc - 4);
        p += 14;
        for (var i = 0; i < nlcc; ++i)
            wbits(out, p + 3 * i, lct[clim[i]]);
        p += 3 * nlcc;
        var lcts = [lclt, lcdt];
        for (var it = 0; it < 2; ++it) {
            var clct = lcts[it];
            for (var i = 0; i < clct.length; ++i) {
                var len = clct[i] & 31;
                wbits(out, p, llm[len]), p += lct[len];
                if (len > 15)
                    wbits(out, p, (clct[i] >>> 5) & 127), p += clct[i] >>> 12;
            }
        }
    }
    else {
        lm = flm, ll = flt, dm = fdm, dl = fdt;
    }
    for (var i = 0; i < li; ++i) {
        if (syms[i] > 255) {
            var len = (syms[i] >>> 18) & 31;
            wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7)
                wbits(out, p, (syms[i] >>> 23) & 31), p += fleb[len];
            var dst = syms[i] & 31;
            wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3)
                wbits16(out, p, (syms[i] >>> 5) & 8191), p += fdeb[dst];
        }
        else {
            wbits16(out, p, lm[syms[i]]), p += ll[syms[i]];
        }
    }
    wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var deo = /*#__PURE__*/ new u32([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]);
// empty
var et = /*#__PURE__*/ new u8(0);
// compresses data into a raw DEFLATE buffer
var dflt = function (dat, lvl, plvl, pre, post, lst) {
    var s = dat.length;
    var o = new u8(pre + s + 5 * (1 + Math.floor(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var pos = 0;
    if (!lvl || s < 8) {
        for (var i = 0; i <= s; i += 65535) {
            // end
            var e = i + 65535;
            if (e < s) {
                // write full block
                pos = wfblk(w, pos, dat.subarray(i, e));
            }
            else {
                // write final block
                w[i] = lst;
                pos = wfblk(w, pos, dat.subarray(i, s));
            }
        }
    }
    else {
        var opt = deo[lvl - 1];
        var n = opt >>> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = new u16(32768), head = new u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function (i) { return (dat[i] ^ (dat[i + 1] << bs1_1) ^ (dat[i + 2] << bs2_1)) & msk_1; };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new u32(25000);
        // length/literal freq   distance freq
        var lf = new u16(288), df = new u16(32);
        //  l/lcnt  exbits  index  l/lind  waitdx  bitpos
        var lc_1 = 0, eb = 0, i = 0, li = 0, wi = 0, bs = 0;
        for (; i < s; ++i) {
            // hash value
            var hv = hsh(i);
            // index mod 32768
            var imod = i & 32767;
            // previous index with this value
            var pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && rem > 423) {
                    pos = wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for (var j = 0; j < 286; ++j)
                        lf[j] = 0;
                    for (var j = 0; j < 30; ++j)
                        df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = (imod - pimod) & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while (dif <= maxd && --ch_1 && imod != pimod) {
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for (; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl)
                                ;
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn)
                                    break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for (var j = 0; j < mmd; ++j) {
                                    var ti = (i - dif + j + 32768) & 32767;
                                    var pti = prev[ti];
                                    var cd = (ti - pti + 32768) & 32767;
                                    if (cd > md)
                                        md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += (imod - pimod + 32768) & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one Uint32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | (revfl[l] << 18) | revfd[d];
                    var lin = revfl[l] & 31, din = revfd[d] & 31;
                    eb += fleb[lin] + fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                }
                else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        pos = wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        // this is the easiest way to avoid needing to maintain state
        if (!lst)
            pos = wfblk(w, pos, et);
    }
    return slc(o, 0, pre + shft(pos) + post);
};
// CRC32 table
var crct = /*#__PURE__*/ (function () {
    var t = new u32(256);
    for (var i = 0; i < 256; ++i) {
        var c = i, k = 9;
        while (--k)
            c = ((c & 1) && 0xEDB88320) ^ (c >>> 1);
        t[i] = c;
    }
    return t;
})();
// CRC32
var crc = function () {
    var c = 0xFFFFFFFF;
    return {
        p: function (d) {
            // closures have awful performance
            var cr = c;
            for (var i = 0; i < d.length; ++i)
                cr = crct[(cr & 255) ^ d[i]] ^ (cr >>> 8);
            c = cr;
        },
        d: function () { return c ^ 0xFFFFFFFF; }
    };
};
// Alder32
var adler = function () {
    var a = 1, b = 0;
    return {
        p: function (d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length;
            for (var i = 0; i != l;) {
                var e = Math.min(i + 5552, l);
                for (; i < e; ++i)
                    n += d[i], m += n;
                n %= 65521, m %= 65521;
            }
            a = n, b = m;
        },
        d: function () { return ((a >>> 8) << 16 | (b & 255) << 8 | (b >>> 8)) + ((a & 255) << 23) * 2; }
    };
};
;
// deflate with opts
var dopt = function (dat, opt, pre, post, st) {
    return dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : (12 + opt.mem), pre, post, !st);
};
// Walmart object spread
var mrg = function (a, b) {
    var o = {};
    for (var k in a)
        o[k] = a[k];
    for (var k in b)
        o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var wcln = function (fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/ /g, '').split(',');
    for (var i = 0; i < dt.length; ++i) {
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                }
                else {
                    fnStr += st_1;
                    for (var t in v.prototype)
                        fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            }
            else
                fnStr += st_1;
        }
        else
            td[k] = v;
    }
    return [fnStr, td];
};
var ch = [];
// clone bufs
var cbfs = function (v) {
    var tl = [];
    for (var k in v) {
        if (v[k] instanceof u8 || v[k] instanceof u16 || v[k] instanceof u32)
            tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    }
    return tl;
};
// use a worker to execute code
var wrkr = function (fns, init, id, cb) {
    var _a;
    if (!ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for (var i = 0; i < m; ++i)
            _a = wcln(fns[i], fnStr, td_1), fnStr = _a[0], td_1 = _a[1];
        ch[id] = wcln(fns[m], fnStr, td_1);
    }
    var td = mrg({}, ch[id][1]);
    return wk(ch[id][0] + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, cbfs(td), cb);
};
// base async inflate fn
var bInflt = function () { return [u8, u16, u32, fleb, fdeb, clim, fl, fd, flrm, fdrm, rev, hMap, max, bits, bits16, shft, slc, inflt, inflateSync, pbf, gu8]; };
var bDflt = function () { return [u8, u16, u32, fleb, fdeb, clim, revfl, revfd, flm, flt, fdm, fdt, rev, deo, et, hMap, wbits, wbits16, hTree, ln, lc, clen, wfblk, wblk, shft, slc, dflt, dopt, deflateSync, pbf]; };
// gzip extra
var gze = function () { return [gzh, gzhl, wbytes, crc, crct]; };
// gunzip extra
var guze = function () { return [gzs, gzl]; };
// zlib extra
var zle = function () { return [zlh, wbytes, adler]; };
// unzlib extra
var zule = function () { return [zlv]; };
// post buf
var pbf = function (msg) { return postMessage(msg, [msg.buffer]); };
// get u8
var gu8 = function (o) { return o && o.size && new u8(o.size); };
// async helper
var cbify = function (dat, opts, fns, init, id, cb) {
    var w = wrkr(fns, init, id, function (err, dat) {
        w.terminate();
        cb(err, dat);
    });
    if (!opts.consume)
        dat = new u8(dat);
    w.postMessage([dat, opts], [dat.buffer]);
    return function () { w.terminate(); };
};
// auto stream
var astrm = function (strm) {
    strm.ondata = function (dat, final) { return postMessage([dat, final], [dat.buffer]); };
    return function (ev) { return strm.push(ev.data[0], ev.data[1]); };
};
// async stream attach
var astrmify = function (fns, strm, opts, init, id) {
    var t;
    var w = wrkr(fns, init, id, function (err, dat) {
        if (err)
            w.terminate(), strm.ondata.call(strm, err);
        else {
            if (dat[1])
                w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.push = function (d, f) {
        if (t)
            throw 'stream finished';
        if (!strm.ondata)
            throw 'no stream handler';
        w.postMessage([d, t = f], [d.buffer]);
    };
    strm.terminate = function () { w.terminate(); };
};
// read 2 bytes
var b2 = function (d, b) { return d[b] | (d[b + 1] << 8); };
// read 4 bytes
var b4 = function (d, b) { return (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16)) + (d[b + 3] << 23) * 2; };
// write bytes
var wbytes = function (d, b, v) {
    for (; v; ++b)
        d[b] = v, v >>>= 8;
};
// gzip header
var gzh = function (c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0)
        wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for (var i = 0; i <= fn.length; ++i)
            c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var gzs = function (d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8)
        throw 'invalid gzip data';
    var flg = d[3];
    var st = 10;
    if (flg & 4)
        st += d[10] | (d[11] << 8) + 2;
    for (var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++])
        ;
    return st + (flg & 2);
};
// gzip length
var gzl = function (d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16) + (2 * (d[l - 1] << 23));
};
// gzip header length
var gzhl = function (o) { return 10 + ((o.filename && (o.filename.length + 1)) || 0); };
// zlib header
var zlh = function (c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = (fl << 6) | (fl ? (32 - 2 * fl) : 1);
};
// zlib valid
var zlv = function (d) {
    if ((d[0] & 15) != 8 || (d[0] >>> 4) > 7 || ((d[0] << 8 | d[1]) % 31))
        throw 'invalid zlib data';
    if (d[1] & 32)
        throw 'invalid zlib data: preset dictionaries not supported';
};
function AsyncCmpStrm(opts, cb) {
    if (!cb && typeof opts == 'function')
        cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
// zlib footer: -4 to -0 is Adler32
/**
 * Streaming DEFLATE compression
 */
var Deflate = /*#__PURE__*/ (function () {
    function Deflate(opts, cb) {
        if (!cb && typeof opts == 'function')
            cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
    }
    Deflate.prototype.p = function (c, f) {
        this.ondata(dopt(c, this.o, 0, 0, !f), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Deflate.prototype.push = function (chunk, final) {
        if (this.d)
            throw 'stream finished';
        if (!this.ondata)
            throw 'no stream handler';
        this.d = final;
        this.p(chunk, final || false);
    };
    return Deflate;
}());

/**
 * Asynchronous streaming DEFLATE compression
 */
var AsyncDeflate = /*#__PURE__*/ (function () {
    function AsyncDeflate(opts, cb) {
        astrmify([
            bDflt,
            function () { return [astrm, Deflate]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Deflate(ev.data);
            onmessage = astrm(strm);
        }, 6);
    }
    return AsyncDeflate;
}());

function deflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
    ], function (ev) { return pbf(deflateSync(ev.data[0], ev.data[1])); }, 0, cb);
}
/**
 * Compresses data with DEFLATE without any wrapper
 * @param data The data to compress
 * @param opts The compression options
 * @returns The deflated version of the data
 */
function deflateSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    return dopt(data, opts, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */
var Inflate = /*#__PURE__*/ (function () {
    /**
     * Creates an inflation stream
     * @param cb The callback to call whenever data is inflated
     */
    function Inflate(cb) {
        this.s = {};
        this.p = new u8(0);
        this.ondata = cb;
    }
    Inflate.prototype.e = function (c) {
        if (this.d)
            throw 'stream finished';
        if (!this.ondata)
            throw 'no stream handler';
        var l = this.p.length;
        var n = new u8(l + c.length);
        n.set(this.p), n.set(c, l), this.p = n;
    };
    Inflate.prototype.c = function (final) {
        this.d = this.s.i = final || false;
        var bts = this.s.b;
        var dt = inflt(this.p, this.o, this.s);
        this.ondata(slc(dt, bts, this.s.b), this.d);
        this.o = slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = slc(this.p, (this.s.p / 8) >> 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */
    Inflate.prototype.push = function (chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}());

/**
 * Asynchronous streaming DEFLATE decompression
 */
var AsyncInflate = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous inflation stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncInflate(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            function () { return [astrm, Inflate]; }
        ], this, 0, function () {
            var strm = new Inflate();
            onmessage = astrm(strm);
        }, 7);
    }
    return AsyncInflate;
}());

function inflate(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt
    ], function (ev) { return pbf(inflateSync(ev.data[0], gu8(ev.data[1]))); }, 1, cb);
}
/**
 * Expands DEFLATE data with no wrapper
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function inflateSync(data, out) {
    return inflt(data, out);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */
var Gzip = /*#__PURE__*/ (function () {
    function Gzip(opts, cb) {
        this.c = crc();
        this.l = 0;
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gzip.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function (c, f) {
        this.c.p(c);
        this.l += c.length;
        var raw = dopt(c, this.o, this.v && gzhl(this.o), f && 8, !f);
        if (this.v)
            gzh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 8, this.c.d()), wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    return Gzip;
}());

/**
 * Asynchronous streaming GZIP compression
 */
var AsyncGzip = /*#__PURE__*/ (function () {
    function AsyncGzip(opts, cb) {
        astrmify([
            bDflt,
            gze,
            function () { return [astrm, Deflate, Gzip]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Gzip(ev.data);
            onmessage = astrm(strm);
        }, 8);
    }
    return AsyncGzip;
}());

function gzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
        gze,
        function () { return [gzipSync]; }
    ], function (ev) { return pbf(gzipSync(ev.data[0], ev.data[1])); }, 2, cb);
}
/**
 * Compresses data with GZIP
 * @param data The data to compress
 * @param opts The compression options
 * @returns The gzipped version of the data
 */
function gzipSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var c = crc(), l = data.length;
    c.p(data);
    var d = dopt(data, opts, gzhl(opts), 8), s = d.length;
    return gzh(d, opts), wbytes(d, s - 8, c.d()), wbytes(d, s - 4, l), d;
}
/**
 * Streaming GZIP decompression
 */
var Gunzip = /*#__PURE__*/ (function () {
    /**
     * Creates a GUNZIP stream
     * @param cb The callback to call whenever data is inflated
     */
    function Gunzip(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Gunzip.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            var s = gzs(this.p);
            if (s >= this.p.length && !final)
                return;
            this.p = this.p.subarray(s), this.v = 0;
        }
        if (final) {
            if (this.p.length < 8)
                throw 'invalid gzip stream';
            this.p = this.p.subarray(0, -8);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Gunzip;
}());

/**
 * Asynchronous streaming GZIP decompression
 */
var AsyncGunzip = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous GUNZIP stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncGunzip(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            guze,
            function () { return [astrm, Inflate, Gunzip]; }
        ], this, 0, function () {
            var strm = new Gunzip();
            onmessage = astrm(strm);
        }, 9);
    }
    return AsyncGunzip;
}());

function gunzip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt,
        guze,
        function () { return [gunzipSync]; }
    ], function (ev) { return pbf(gunzipSync(ev.data[0])); }, 3, cb);
}
/**
 * Expands GZIP data
 * @param data The data to decompress
 * @param out Where to write the data. GZIP already encodes the output size, so providing this doesn't save memory.
 * @returns The decompressed version of the data
 */
function gunzipSync(data, out) {
    return inflt(data.subarray(gzs(data), -8), out || new u8(gzl(data)));
}
/**
 * Streaming Zlib compression
 */
var Zlib = /*#__PURE__*/ (function () {
    function Zlib(opts, cb) {
        this.c = adler();
        this.v = 1;
        Deflate.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Zlib.prototype.push = function (chunk, final) {
        Deflate.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function (c, f) {
        this.c.p(c);
        var raw = dopt(c, this.o, this.v && 2, f && 4, !f);
        if (this.v)
            zlh(raw, this.o), this.v = 0;
        if (f)
            wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    return Zlib;
}());

/**
 * Asynchronous streaming Zlib compression
 */
var AsyncZlib = /*#__PURE__*/ (function () {
    function AsyncZlib(opts, cb) {
        astrmify([
            bDflt,
            zle,
            function () { return [astrm, Deflate, Zlib]; }
        ], this, AsyncCmpStrm.call(this, opts, cb), function (ev) {
            var strm = new Zlib(ev.data);
            onmessage = astrm(strm);
        }, 10);
    }
    return AsyncZlib;
}());

function zlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bDflt,
        zle,
        function () { return [zlibSync]; }
    ], function (ev) { return pbf(zlibSync(ev.data[0], ev.data[1])); }, 4, cb);
}
/**
 * Compress data with Zlib
 * @param data The data to compress
 * @param opts The compression options
 * @returns The zlib-compressed version of the data
 */
function zlibSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var a = adler();
    a.p(data);
    var d = dopt(data, opts, 2, 4);
    return zlh(d, opts), wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */
var Unzlib = /*#__PURE__*/ (function () {
    /**
     * Creates a Zlib decompression stream
     * @param cb The callback to call whenever data is inflated
     */
    function Unzlib(cb) {
        this.v = 1;
        Inflate.call(this, cb);
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Unzlib.prototype.push = function (chunk, final) {
        Inflate.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 2 && !final)
                return;
            this.p = this.p.subarray(2), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4)
                throw 'invalid zlib stream';
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        Inflate.prototype.c.call(this, final);
    };
    return Unzlib;
}());

/**
 * Asynchronous streaming Zlib decompression
 */
var AsyncUnzlib = /*#__PURE__*/ (function () {
    /**
     * Creates an asynchronous Zlib decompression stream
     * @param cb The callback to call whenever data is deflated
     */
    function AsyncUnzlib(cb) {
        this.ondata = cb;
        astrmify([
            bInflt,
            zule,
            function () { return [astrm, Inflate, Unzlib]; }
        ], this, 0, function () {
            var strm = new Unzlib();
            onmessage = astrm(strm);
        }, 11);
    }
    return AsyncUnzlib;
}());

function unzlib(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return cbify(data, opts, [
        bInflt,
        zule,
        function () { return [unzlibSync]; }
    ], function (ev) { return pbf(unzlibSync(ev.data[0], gu8(ev.data[1]))); }, 5, cb);
}
/**
 * Expands Zlib data
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function unzlibSync(data, out) {
    return inflt((zlv(data), data.subarray(2, -4)), out);
}
// Default algorithm for compression (used because having a known output size allows faster decompression)

// Default algorithm for compression (used because having a known output size allows faster decompression)

/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var Decompress = /*#__PURE__*/ (function () {
    /**
     * Creates a decompression stream
     * @param cb The callback to call whenever data is decompressed
     */
    function Decompress(cb) {
        this.G = Gunzip;
        this.I = Inflate;
        this.Z = Unzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    Decompress.prototype.push = function (chunk, final) {
        if (!this.ondata)
            throw 'no stream handler';
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            }
            else
                this.p = chunk;
            if (this.p.length > 2) {
                var _this_1 = this;
                var cb = function () { _this_1.ondata.apply(_this_1, arguments); };
                this.s = (this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8)
                    ? new this.G(cb)
                    : ((this.p[0] & 15) != 8 || (this.p[0] >> 4) > 7 || ((this.p[0] << 8 | this.p[1]) % 31))
                        ? new this.I(cb)
                        : new this.Z(cb);
                this.s.push(this.p, final);
                this.p = null;
            }
        }
        else
            this.s.push(chunk, final);
    };
    return Decompress;
}());

/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */
var AsyncDecompress = /*#__PURE__*/ (function () {
    /**
   * Creates an asynchronous decompression stream
   * @param cb The callback to call whenever data is decompressed
   */
    function AsyncDecompress(cb) {
        this.G = AsyncGunzip;
        this.I = AsyncInflate;
        this.Z = AsyncUnzlib;
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */
    AsyncDecompress.prototype.push = function (chunk, final) {
        Decompress.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}());

function decompress(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzip(data, opts, cb)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflate(data, opts, cb)
            : unzlib(data, opts, cb);
}
/**
 * Expands compressed GZIP, Zlib, or raw DEFLATE data, automatically detecting the format
 * @param data The data to decompress
 * @param out Where to write the data. Saves memory if you know the decompressed size and provide an output buffer of that length.
 * @returns The decompressed version of the data
 */
function decompressSync(data, out) {
    return (data[0] == 31 && data[1] == 139 && data[2] == 8)
        ? gunzipSync(data, out)
        : ((data[0] & 15) != 8 || (data[0] >> 4) > 7 || ((data[0] << 8 | data[1]) % 31))
            ? inflateSync(data, out)
            : unzlibSync(data, out);
}
// flatten a directory structure
var fltn = function (d, p, t, o) {
    for (var k in d) {
        var val = d[k], n = p + k;
        if (val instanceof u8)
            t[n] = [val, o];
        else if (Array.isArray(val))
            t[n] = [val[0], mrg(o, val[1])];
        else
            fltn(val, n + '/', t, o);
    }
};
/**
 * Converts a string into a Uint8Array for use with compression/decompression methods
 * @param str The string to encode
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless decoding a binary string.
 * @returns The string encoded in UTF-8/Latin-1 binary
 */
function strToU8(str, latin1) {
    var l = str.length;
    if (!latin1 && typeof TextEncoder != 'undefined')
        return new TextEncoder().encode(str);
    var ar = new u8(str.length + (str.length >>> 1));
    var ai = 0;
    var w = function (v) { ar[ai++] = v; };
    for (var i = 0; i < l; ++i) {
        if (ai + 5 > ar.length) {
            var n = new u8(ai + 8 + ((l - i) << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1)
            w(c);
        else if (c < 2048)
            w(192 | (c >>> 6)), w(128 | (c & 63));
        else if (c > 55295 && c < 57344)
            c = 65536 + (c & 1023 << 10) | (str.charCodeAt(++i) & 1023),
                w(240 | (c >>> 18)), w(128 | ((c >>> 12) & 63)), w(128 | ((c >>> 6) & 63)), w(128 | (c & 63));
        else
            w(224 | (c >>> 12)), w(128 | ((c >>> 6) & 63)), w(128 | (c & 63));
    }
    return slc(ar, 0, ai);
}
/**
 * Converts a Uint8Array to a string
 * @param dat The data to decode to string
 * @param latin1 Whether or not to interpret the data as Latin-1. This should
 *               not need to be true unless encoding to binary string.
 * @returns The original UTF-8/Latin-1 string
 */
function strFromU8(dat, latin1) {
    var r = '';
    if (!latin1 && typeof TextDecoder != 'undefined')
        return new TextDecoder().decode(dat);
    for (var i = 0; i < dat.length;) {
        var c = dat[i++];
        if (c < 128 || latin1)
            r += String.fromCharCode(c);
        else if (c < 224)
            r += String.fromCharCode((c & 31) << 6 | (dat[i++] & 63));
        else if (c < 240)
            r += String.fromCharCode((c & 15) << 12 | (dat[i++] & 63) << 6 | (dat[i++] & 63));
        else
            c = ((c & 15) << 18 | (dat[i++] & 63) << 12 | (dat[i++] & 63) << 6 | (dat[i++] & 63)) - 65536,
                r += String.fromCharCode(55296 | (c >> 10), 56320 | (c & 1023));
    }
    return r;
}
;
// skip local zip header
var slzh = function (d, b) { return b + 30 + b2(d, b + 26) + b2(d, b + 28); };
// read zip header
var zh = function (d, b, z) {
    var fnl = b2(d, b + 28), fn = strFromU8(d.subarray(b + 46, b + 46 + fnl), !(b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = z ? z64e(d, es) : [b4(d, b + 20), b4(d, b + 24), b4(d, b + 42)], sc = _a[0], su = _a[1], off = _a[2];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
};
// read zip64 extra field
var z64e = function (d, b) {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2))
        ;
    return [b4(d, b + 12), b4(d, b + 4), b4(d, b + 20)];
};
// write zip header
var wzh = function (d, b, c, cmp, su, fn, u, o, ce, t) {
    var fl = fn.length, l = cmp.length;
    wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null)
        d[b] = 20, b += 2;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = (t == 8 && (o.level == 1 ? 6 : o.level < 6 ? 4 : o.level == 9 ? 2 : 0)), d[b++] = u && 8;
    d[b] = t, b += 2;
    var dt = new Date(o.mtime || Date.now()), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119)
        throw 'date not in range 1980-2099';
    wbytes(d, b, ((y << 24) * 2) | ((dt.getMonth() + 1) << 21) | (dt.getDate() << 16) | (dt.getHours() << 11) | (dt.getMinutes() << 5) | (dt.getSeconds() >>> 1));
    b += 4;
    wbytes(d, b, c);
    wbytes(d, b + 4, l);
    wbytes(d, b + 8, su);
    wbytes(d, b + 12, fl), b += 16; // skip extra field, comment
    if (ce != null)
        wbytes(d, b += 10, ce), b += 4;
    d.set(fn, b);
    b += fl;
    if (ce == null)
        d.set(cmp, b);
};
// write zip footer (end of central directory)
var wzf = function (o, b, c, d, e) {
    wbytes(o, b, 0x6054B50); // skip disk
    wbytes(o, b + 8, c);
    wbytes(o, b + 10, c);
    wbytes(o, b + 12, d);
    wbytes(o, b + 16, e);
};
function zip(data, opts, cb) {
    if (!cb)
        cb = opts, opts = {};
    if (typeof cb != 'function')
        throw 'no callback';
    var r = {};
    fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var cbf = function () {
        var out = new u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for (var i = 0; i < slft; ++i) {
            var f = files[i];
            try {
                wzh(out, tot, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
                wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, tot, f.t), o += 46 + f.n.length, tot += 30 + f.n.length + f.d.length;
            }
            catch (e) {
                return cb(e, null);
            }
        }
        wzf(out, o, files.length, cdl, oe);
        cb(null, out);
    };
    if (!lft)
        cbf();
    var _loop_1 = function (i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = crc(), m = file.length;
        c.p(file);
        var n = strToU8(fn), s = n.length;
        var t = p.level == 0 ? 0 : 8;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cb(e, null);
            }
            else {
                var l = d.length;
                files[i] = {
                    t: t,
                    d: d,
                    m: m,
                    c: c.d(),
                    u: fn.length != l,
                    n: n,
                    p: p
                };
                o += 30 + s + l;
                tot += 76 + 2 * s + l;
                if (!--lft)
                    cbf();
            }
        };
        if (n.length > 65535)
            cbl('filename too long', null);
        if (!t)
            cbl(null, file);
        else if (m < 160000) {
            try {
                cbl(null, deflateSync(file, p));
            }
            catch (e) {
                cbl(e, null);
            }
        }
        else
            term.push(deflate(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for (var i = 0; i < slft; ++i) {
        _loop_1(i);
    }
    return tAll;
}
/**
 * Synchronously creates a ZIP file. Prefer using `zip` for better performance
 * with more than one file.
 * @param data The directory structure for the ZIP archive
 * @param opts The main options, merged with per-file options
 * @returns The generated ZIP archive
 */
function zipSync(data, opts) {
    if (opts === void 0) { opts = {}; }
    var r = {};
    var files = [];
    fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for (var fn in r) {
        var _a = r[fn], file = _a[0], p = _a[1];
        var t = p.level == 0 ? 0 : 8;
        var n = strToU8(fn), s = n.length;
        if (n.length > 65535)
            throw 'filename too long';
        var d = t ? deflateSync(file, p) : file, l = d.length;
        var c = crc();
        c.p(file);
        files.push({
            t: t,
            d: d,
            m: file.length,
            c: c.d(),
            u: fn.length != s,
            n: n,
            o: o,
            p: p
        });
        o += 30 + s + l;
        tot += 76 + 2 * s + l;
    }
    var out = new u8(tot + 22), oe = o, cdl = tot - o;
    for (var i = 0; i < files.length; ++i) {
        var f = files[i];
        wzh(out, f.o, f.c, f.d, f.m, f.n, f.u, f.p, null, f.t);
        wzh(out, o, f.c, f.d, f.m, f.n, f.u, f.p, f.o, f.t), o += 46 + f.n.length;
    }
    wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Asynchronously decompresses a ZIP archive
 * @param data The raw compressed ZIP file
 * @param cb The callback to call with the decompressed files
 * @returns A function that can be used to immediately terminate the unzipping
 */
function unzip(data, cb) {
    if (typeof cb != 'function')
        throw 'no callback';
    var term = [];
    var tAll = function () {
        for (var i = 0; i < term.length; ++i)
            term[i]();
    };
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558) {
            cb('invalid zip file', null);
            return;
        }
    }
    ;
    var lft = b2(data, e + 8);
    if (!lft)
        cb(null, {});
    var c = lft;
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50)
            throw 'invalid zip file';
        c = lft = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    var _loop_2 = function (i) {
        var _a = zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        var cbl = function (e, d) {
            if (e) {
                tAll();
                cb(e, null);
            }
            else {
                files[fn] = d;
                if (!--lft)
                    cb(null, files);
            }
        };
        if (!c_1)
            cbl(null, slc(data, b, b + sc));
        else if (c_1 == 8) {
            var infl = data.subarray(b, b + sc);
            if (sc < 320000) {
                try {
                    cbl(null, inflateSync(infl, new u8(su)));
                }
                catch (e) {
                    cbl(e, null);
                }
            }
            else
                term.push(inflate(infl, { size: su }, cbl));
        }
        else
            cbl('unknown compression type ' + c_1, null);
    };
    for (var i = 0; i < c; ++i) {
        _loop_2(i);
    }
    return tAll;
}
/**
 * Synchronously decompresses a ZIP archive. Prefer using `unzip` for better
 * performance with more than one file.
 * @param data The raw compressed ZIP file
 * @returns The decompressed files
 */
function unzipSync(data) {
    var files = {};
    var e = data.length - 22;
    for (; b4(data, e) != 0x6054B50; --e) {
        if (!e || data.length - e > 65558)
            throw 'invalid zip file';
    }
    ;
    var c = b2(data, e + 8);
    if (!c)
        return {};
    var o = b4(data, e + 16);
    var z = o == 4294967295;
    if (z) {
        e = b4(data, e - 12);
        if (b4(data, e) != 0x6064B50)
            throw 'invalid zip file';
        c = b4(data, e + 32);
        o = b4(data, e + 48);
    }
    for (var i = 0; i < c; ++i) {
        var _a = zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = slzh(data, off);
        o = no;
        if (!c_2)
            files[fn] = slc(data, b, b + sc);
        else if (c_2 == 8)
            files[fn] = inflateSync(data.subarray(b, b + sc), new u8(su));
        else
            throw 'unknown compression type ' + c_2;
    }
    return files;
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js